window.hsonslidecart = window.hsonslidecart || {};
window.hsonslidecart = window.hsonslidecart || {};
window.hstrapFocusHandlers = {};
window.hstrapFocusHandlers = {};
window.hs_content = '';
window.hs_class_money = '';
window.HSUPSELLS = {};
window.HSHOST = '//node.slidecartapp.heysenior.com';
/*window.revyBundleDataLayer = window.revyBundleDataLayer || [];
window.revyBundleDataLayer.push({
  onReady: function () {
    if (window.RevyBundle) {
      window.RevyBundle.api.getTotal(response => {
        var newCart = window.HSSLIDECART.CART
        newCart.total_price = response.bundleTotal.final
        newCart.total_discount = response.bundleTotal.discount;up
        if (response.bundleTotal.per_variant) {
          for (var i = 0; i < response.bundleTotal.per_variant.length; i++) {
            var discountedItem = response.bundleTotal.per_variant[i]
            var quantity = window.HSSLIDECART.CART.items[i].quantity

            newCart.items[i].line_price = discountedItem.item_price.final * quantity
            newCart.items[i].original_line_price = discountedItem.item_price.original * quantity
          }
        }
        window.HS_SLIDE_CART_SET_CART(newCart)
      });
      window.RevyBundle.api.checkoutRedirectReplacer = function (discount_code) {
        if(HsApp1.checkoutPage !== ''){
          document.querySelector('.hs-content-checkout-button').insertAdjacentHTML('afterbegin', '<button class="hs-checkout-purchase hs-checkout-cloned" style="display:none;"></button>')
          HsApp1.hideCartPopup();
          
          var ev = new Event("click", { "bubbles": true, "cancelable": false });
          document.querySelector('.hs-checkout-purchase.hs-checkout-cloned').dispatchEvent(ev);
          return false;
        };
        if (discount_code) {
          console.log("Código de descuento de paquete generado, el código es: ", discount_code)
            // Aquí tiene el código de descuento del paquete disponible y debe redirigir 
        } 
      }
    };
  } 
}); */
function LOG(text) {
  console.log(text);
};
window.HS_SLIDE_CART_OPEN = function () {
  HsApp1.openCart();
};
window.HS_SLIDE_CART_CLOSE = function () {
  HsApp1.closeCart();
};
window.HS_SLIDE_CART_UPDATE = function (callback) {
  try {
    if (!!callback) {
      callback();
    };
    Hs_CartDrawer.update_set_cart = 0;
    HsApp1.getMyCart(0);
  } catch (error) {
    console.log(error)
  };
};
window.HS_SLIDE_CART_SET_CART = function (cart) {
  if (typeof cart !== 'undefined') {
    if (Object.keys(cart).length > 0) {
      Hs_CartDrawer.update_set_cart = 1;
      HsApp1.getMyCart(0, '', cart);
      Hs_CartDrawer.update_set_cart = 0;
    };
  };
};
window.HS_SLIDE_CART_APPLY_DISCOUNT = function (cuponCodes, input = false, events = '') {
  if (cuponCodes === '') {
    HsApp1.errorDiscount(events);
    return false;
  };

  if (!!cuponCodes) {
    var discount = cuponCodes;
    if (window.localStorage) {
      if (localStorage.getItem(Hs_CartDrawer.discount_storage)) {
        if (!!discount) {
          discount = discount.split(',');
          mydiscount = localStorage.getItem(Hs_CartDrawer.discount_storage).split(',');
          discount = mydiscount.concat(discount);
          discount = HsApp1.removeDuplicates(discount);
          discount = discount.join(',');
        }
      };
    };
    localStorage.setItem(
      Hs_CartDrawer.discount_storage, discount
    );
  }

  /*if (window.location.host.indexOf('.shopifypreview.com') > -1) {
    HsApp1.errorDiscount('preview');
    return false;
  };*/

  async function getCart() {
    var cart = Hs_CartDrawer.routeLocale(`cart.js`);
    return fetch(`${cart}`,
      {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.status == 200 && response.json())
      .then((responseData) => {
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          responseData = window.BOLD.common.cartDoctor.fix(responseData);
        };
        return responseData;
      })
      .catch((error) => { console.log(error) });
  };

  async function thisCheckout() {
    var mydiscount = '', routeDiscount = '/discount/', mydiscountCount = [];
    if (!!localStorage.getItem(Hs_CartDrawer.discount_storage)) {
      mydiscountCount = localStorage.getItem(Hs_CartDrawer.discount_storage).split(',');
      mydiscount = localStorage.getItem(Hs_CartDrawer.discount_storage);
      applyDiscountCode(mydiscount);
      //routeDiscount = routeDiscount+mydiscount;
      /*if(mydiscountCount.length > 1)
      {
        routeDiscount = '/cart?discount='+mydiscount;
        applyDiscountCode(mydiscount);
      }else{
        applyDiscountCode(mydiscount);
      }*/
    }

    /*fetch(routeDiscount, {
      headers: {
        'Content-Type': "application/json, text/javascript",
      },
      method: 'GET',
      //body: {discount:data.checkout.discount_code,v:(new Date).getTime()}
    }).then(function (response) {
      var thisResponse = response;
      if (response.status != 404) {
        thisResponse = thisResponse.json();
      } else {
        thisResponse = thisResponse.text();
      };
      return thisResponse;
    }).then(function (response) {
    }).catch(err => {
      if (err) {
        if (err.statusText == 'error') {
          window.location.href = shopifyRoot + 'checkout?discount=' + discount;
        }
      }
    }).then(function () {
      updateCouponCode();
    });*/
  };

  function applyDiscountCode(e) {
    if (!e)
      return;
    const cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
    //e = encodeURIComponent(e);
    const parts = e
      .split(",")
      .map(p => p.trim())
      .filter(Boolean);

    // Volver a unir correctamente
    const discountValue = parts.join(",") || '';

    return new Promise(o => {
      fetch(cart, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: discountValue
        })
      }).finally(() => {
        HsApp1.updateCouponCode();
      });
    });
  }

  function updateCouponCode() {
    //window.HS_SLIDE_CART_APPLY_DISCOUNT('hs_clear_discount');
    //HsApp1.createCpokie('hscodediscount','data.checkout.discount_code', 365);
    var discount_input = !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code') : '',
      hs_apply_discount = !!document.querySelector('button.hs-apply-discount') ? document.querySelector('button.hs-apply-discount') : '',
      sectiondscto = !!document.querySelector('.hs-add-discount') ? document.querySelector('.hs-add-discount') : '';

    if (!!sectiondscto) {
      sectiondscto.classList.remove('hs-disabled');
      !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout').classList.remove('hs-load-discount') : '';
    }
    if (!!hs_apply_discount) {
      hs_apply_discount.classList.remove('hs-loading-btn');
    }
    if (!!discount_input) {
      discount_input.disabled = false;
      discount_input.value = '';
    }
    window.HS_SLIDE_CART_UPDATE();
  }

  function shopifyToken() {
    var token = '';
    var shopifyFeatures = !!document.getElementById("shopify-features") ? document.getElementById("shopify-features").innerHTML : '';
    if (!!shopifyFeatures) {
      shopifyFeatures = JSON.parse(shopifyFeatures);
      if (typeof shopifyFeatures.accessToken !== 'undefined') {
        token = btoa(shopifyFeatures.accessToken);
      };
    };
    return token;
  };

  function loadComponents(view) {
    var discount_input = !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code') : '',
      hs_apply_discount = !!document.querySelector('button.hs-apply-discount') ? document.querySelector('button.hs-apply-discount') : '',
      sectiondscto = !!document.querySelector('.hs-add-discount') ? document.querySelector('.hs-add-discount') : '';
    if (!!sectiondscto) {
      if (!!view) {
        sectiondscto.classList.add('hs-disabled');
        !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout').classList.add('hs-load-discount') : '';
      } else {
        sectiondscto.classList.remove('hs-disabled');
        !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout').classList.remove('hs-load-discount') : '';
      };
    };
    if (!!hs_apply_discount) {
      !!view ? hs_apply_discount.classList.add('hs-loading-btn') : hs_apply_discount.classList.remove('hs-loading-btn');
    };
    if (!!discount_input) {
      if (view == true) {
        discount_input.setAttribute('disabled', true)
      } else {
        if (typeof discount_input === 'object') {
          discount_input.removeAttribute('disabled')
          var errorContent = !!document.querySelector('.hs-error-code-discount') ? document.querySelector('.hs-error-code-discount') : '';
          if (!!errorContent) {
            if (errorContent.innerHTML !== '') {
              const end = discount_input.value.length;
              discount_input.focus();
              discount_input.setSelectionRange(0, end);
            };
          };
        };
      };
    };
  };

  /*let token = shopifyToken();
  if (token !== '') {
    cuponCode !== 'hs_clear_discount' ? loadComponents(true) : '';
    getCart().then(response => !!response && thisCheckout(response, token));
  };*/

  loadComponents(true)
  thisCheckout();
}
window.HS_SLIDE_CART_DISCARD_DISCOUNT = function (cuponCodes = '') {

  if (!!cuponCodes) {
    var discount = cuponCodes;
    if (window.localStorage) {
      if (localStorage.getItem(Hs_CartDrawer.discount_storage)) {
        if (!!discount) {
          discount = discount.split(',');
          mydiscount = localStorage.getItem(Hs_CartDrawer.discount_storage).split(',');
          mydiscount = mydiscount.filter(item => !discount.includes(item));
          discount = HsApp1.removeDuplicates(mydiscount);
          discount = discount.join(',');
          if (!discount) {
            discount = '~!~!HSCART_REMOVE_DISCOUNT!~!~';
          }
        }
      };
    };
    localStorage.setItem(
      Hs_CartDrawer.discount_storage, discount
    );
    HsApp1.applyDiscountCode(discount, '');
  } else {
    HsApp1.applyDiscountCode('~!~!HSCART_REMOVE_DISCOUNT!~!~', '');
  }

  //var total_price_global = !!document.querySelector('.hs-total-price-global') ? document.querySelector('.hs-total-price-global').value : '';
  /*var total_price_global = HsApp1.rewardsExcludeProd(window.HSSLIDECART.CART);
  HsApp1.deleteCookie('hscodediscount');
  HsApp1.checkoutPage = '';
  !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code').value = '' : '';
  !!document.querySelector('.hs-discount-price-global') ? document.querySelector('.hs-discount-price-global').value = 0 : '';
  !!document.querySelector('.hs-sub-total-cart') ? document.querySelector('.hs-sub-total-cart').classList.remove('hs-dscto-script') : '';
  if (typeof window.HS_SLIDE_CART_APPLY_DISCOUNT !== 'undefined') {
    window.HS_SLIDE_CART_APPLY_DISCOUNT('');
  };*/

  /*var thisRewards = 0;
  if (!!slideData.settings.gift_wrap.enabled_gift_wrap) {*/
  /* CUSTOM GIFT WRAP CHECK */
  /*var hs_gift_wrap_custom = !!document.querySelector('.hs-gift-wrap-custom') ? document.querySelector('.hs-gift-wrap-custom') : '';
  if (!!hs_gift_wrap_custom) {
    var hs_gift_wrap_check = !!hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') : '';
    if (!!hs_gift_wrap_check) {
      var amount = 0;
      if (!!hs_gift_wrap_check.checked) {
        amount = parseFloat(slideData.settings.gift_wrap.offer_price * 100).toFixed(2);
      }
      thisRewards = 1;
      HsApp1.giftWrapUpdates(amount);
    }
  };*/
  /* SPECIFIC GIFT WRAP CHECK */
  /*var hs_gift_wrap_specific = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
  if (!!hs_gift_wrap_specific) {
    var hs_gift_wrap_check = !!hs_gift_wrap_specific.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_specific.querySelector('.hs-gift-wrap-check') : '';
    if (!!hs_gift_wrap_check) {
      var amount = 0;
      if (!!hs_gift_wrap_check.checked) {
        amount = HsApp1.readCookie('hs-giftWrap-variantPrice');
      }
      thisRewards = 1;
      HsApp1.giftWrapUpdates(amount);
    }
  }
}*/
  /* *** */
  //HsApp1.checkoutPage = '';//CLEAR VARIABLE DEL CHECKOUT DSCTO
  /*HsApp1.revyDiscountCheckout();
  if (!thisRewards) {
    HsApp1.rewardsBar(total_price_global);
  };*/
};

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

hsonslidecart.Discount = (function () {
  function notifyDiscount(discountnotReq) {
    var notify = '';
    if (!!discountnotReq) {
      notify = `<div class="hs--content--warning">
                              <div class="hs---warning---icon"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 22" style=" ">
                              <path d="M15.286 2.386l7.91 13.857C25.01 19.423 23.65 22 20.16 22H3.84C.35 22-1.01 19.427.805 16.243l7.91-13.857c1.815-3.178 4.754-3.185 6.57 0zm-1.737.992c-1.05-1.838-2.05-1.837-3.1 0L2.54 17.235C1.468 19.122 1.93 20 3.84 20h16.32c1.91 0 2.374-.88 1.298-2.765l-7.91-13.857zM12 6.5c.552 0 1 .448 1 1V12c0 .552-.448 1-1 1s-1-.448-1-1V7.5c0-.552.448-1 1-1zm-1.5 10c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5z">
                              </path>
                              </svg>
                              </div><p class="notice__text">${discountnotReq}</p>
                              <span style="cursor:pointer;" class="hs-close-discount-slide-cart">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13">
                                  <path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round">
                                </path>
                                </svg>
                              </span>
                              </div>`
    };
    return notify;
  };
  function tagDiscount(discount) {
    var tag = '';
    var discountCode = '';
    var amount = '';
    var remove_class = '';
    var cancellable = 1;

    if (discount) {
      /*if (!discount.type && discount.application_type) {
        discount.type = discount.application_type;
      } else {
        discount.type = '';
      };*/

      discountCode = discount?.title || '';
      amount = discount?.amount ? hsonslidecart.Currency.formatMoney(discount.amount * 100, slideData.settings.devices.money_format) : '';
      cancellable = discount?.type?.toLowerCase() !== "discount_code" ? 0 : cancellable;
      remove_class = discount?.type?.toLowerCase() !== "discount_code" ? '' : ' hs-clear-coupon-all';
    };
    if (!!discountCode) {
      tag = `
                <div class="hs-dscto-tag${remove_class}" style="background-color: rgba(0, 0, 0, 0.05);">
                      <div class="hs-reduction-code">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" class="hs-icon-dscto"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path></svg>
                      </div>
                      <div class="hs-code-text">${discountCode}</div>
                      ${cancellable ? `<div class="hs-code-remove" data-discount-code="${discountCode}">
                        <svg tabindex="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="7px" height="7px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
                        <div class="hs--loading"><div class="hs-spinner"></div></div>
                      </div>` : ``}
                  ${amount ? `<span class="hs-hov-tiptext">${amount}</span>` : ''}
                </div>`
    };
    return tag;
  };
  return {
    notifyDiscount, tagDiscount
  }
})();
hsonslidecart.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    format = decodeHtml(format);
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      centsAmount = !!Hs_CartDrawer.hiddenDecNum ? centsAmount.indexOf('.00') > -1 || centsAmount.indexOf(',00') > -1 ? '' : centsAmount : centsAmount;

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2),
          console.error("Theme Error: incorrect format for money, falling back to default format {{ amount }}. Please follow https://help.shopify.com/en/manual/markets/pricing/currency-formatting and contact your theme developer.");
        break
    }

    //var hs_money = formatString.replace(placeholderRegex, value);

    var replacements = {
      amount: value,
      amount_no_decimals: value,
      amount_with_comma_separator: value,
      amount_no_decimals_with_comma_separator: value,
      amount_with_apostrophe_separator: value,
      amount_no_decimals_with_space_separator: value,
      amount_with_space_separator: value,
      amount_with_period_and_space_separator: value,
      currency_code: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''
    };

    var hs_money = formatString.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      return replacements[key] !== undefined ? replacements[key] : '';
    });
    if (hs_money.indexOf('money') == -1) {
      var thisClass = '';

      var cb_widget_currency = !!document.querySelector('#cb-widget-currency') ? !!document.querySelector('#cb-widget-currency') : '';
      if (!!cb_widget_currency) {
        var cart_currency = HsApp1.readCookie('cart_currency');
        var currency_shopify = window.Shopify.currency.active;
        if (cart_currency === '' || cart_currency === currency_shopify) {
          thisClass = thisClass + ' conversion-bear-money';
        };
      };

      /* BUCKS Currency Converter PRO++ */
      let bucks = (((window || {}).bucksCC || {}).metaConfig || {}).active || false;
      if (bucks) {
        var buckscc_currency_wrapper = !!document.querySelector('.buckscc-currency-wrapper') ? document.querySelector('.buckscc-currency-wrapper') : '';
        if (!!buckscc_currency_wrapper) {
          thisClass = thisClass + ' money';
        };
      };

      if (window.hs_class_money !== '') {
        var money_regexp = /money(?=\s)/g;
        thisClass = thisClass.replace(money_regexp, '');
        thisClass = thisClass + ' ' + window.hs_class_money;
      };

      hs_money = '<span class="' + thisClass + '">' + hs_money + '</span>';
    }
    return hs_money;
  }

  return {
    formatMoney: formatMoney
  }
})();

if (typeof HsCurrency === "undefined") {
  var HsCurrency = {}
}
window.homepagecheck = function () {
  var check = false;
  if (document.location.pathname === "/") {
    check = true;
  }
  return check;
}
HsCurrency.moneyFormats = {
  AED: {
    money_format: "Dhs. {{amount}}",
    money_with_currency_format: "Dhs. {{amount}} AED"
  },
  AFN: {
    money_format: "{{amount}} ؋",
    money_with_currency_format: "{{amount}} ؋"
  },
  ALL: {
    money_format: "Lek {{amount}}",
    money_with_currency_format: "Lek {{amount}} ALL"
  }
  ,
  AMD: {
    money_format: "{{amount}} AMD",
    money_with_currency_format: "{{amount}} AMD"
  }
  ,
  AUD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} AUD"
  }
  ,
  AWG: {
    money_format: "Afl{{amount}}",
    money_with_currency_format: "Afl{{amount}} AWG"
  }
  ,
  AZN: {
    money_format: "m.{{amount}}",
    money_with_currency_format: "m.{{amount}} AZN"
  }
  ,
  BAM: {
    money_format: "KM {{amount_with_comma_separator}}",
    money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
  }
  ,
  BBD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} Bds"
  }
  ,
  BDT: {
    money_format: "Tk {{amount}}",
    money_with_currency_format: "Tk {{amount}} BDT"
  }
  ,
  BGN: {
    money_format: "{{amount}} лв",
    money_with_currency_format: "{{amount}} лв BGN"
  }
  ,
  BIF: {
    money_format: "FBu. {{amount}}",
    money_with_currency_format: "FBu. {{amount}}"
  }
  ,
  CDF: {
    money_format: "FC{{amount}}",
    money_with_currency_format: "FC{{amount}}"
  }
  ,
  CVE: {
    money_format: "{{amount}}$",
    money_with_currency_format: "{{amount}}$"
  }
  ,
  DJF: {
    money_format: "{{amount}} Fdj",
    money_with_currency_format: "{{amount}} Fdj"
  }
  ,
  FKP: {
    money_format: "£{{amount}}",
    money_with_currency_format: "£{{amount}}"
  }
  ,
  GNF: {
    money_format: "FG {{amount}}",
    money_with_currency_format: "FG {{amount}}"
  }
  ,
  KMF: {
    money_format: "{{amount}} CF",
    money_with_currency_format: "{{amount}} CF"
  }
  ,
  LAK: {
    money_format: "₭{{amount}}",
    money_with_currency_format: "₭{{amount}}"
  }
  ,
  MWK: {
    money_format: "Mk{{amount}}",
    money_with_currency_format: "Mk{{amount}}"
  }
  ,
  SBD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}}"
  }
  ,
  SHP: {
    money_format: "£{{amount}}",
    money_with_currency_format: "£{{amount}}"
  }
  ,
  SLL: {
    money_format: "Le {{amount}}",
    money_with_currency_format: "Le {{amount}}"
  }
  ,
  TJS: {
    money_format: "TJS {{amount}}",
    money_with_currency_format: "TJS {{amount}}"
  }
  ,
  TOP: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}}"
  }
  ,
  UZS: {
    money_format: "{{amount}} som",
    money_with_currency_format: "{{amount}} som"
  }
  ,
  YER: {
    money_format: "{{amount}} YER",
    money_with_currency_format: "{{amount}} YER"
  }
  ,
  USD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} USD"
  }
  ,
  EUR: {
    money_format: "&euro;{{amount_with_comma_separator}}",
    money_format_reverse: "{{amount_with_comma_separator}}&euro;",
    money_with_currency_format: "&euro;{{amount_with_comma_separator}} EUR"
  }
  ,
  GBP: {
    money_format: "&pound;{{amount}}",
    money_with_currency_format: "&pound;{{amount}} GBP"
  }
  ,
  CAD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} CAD"
  }
  ,
  DZD: {
    money_format: "DA {{amount}}",
    money_with_currency_format: "DA {{amount}} DZD"
  }
  ,
  AOA: {
    money_format: "Kz{{amount}}",
    money_with_currency_format: "Kz{{amount}} AOA"
  }
  ,
  ARS: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} ARS"
  }
  ,
  BSD: {
    money_format: "BS${{amount}}",
    money_with_currency_format: "BS${{amount}} BSD"
  }
  ,
  BHD: {
    money_format: "{{amount}}0 BD",
    money_with_currency_format: "{{amount}}0 BHD"
  }
  ,
  BYR: {
    money_format: "Br {{amount}}",
    money_with_currency_format: "Br {{amount}} BYR"
  }
  ,
  BZD: {
    money_format: "BZ${{amount}}",
    money_with_currency_format: "BZ${{amount}} BZD"
  }
  ,
  BTN: {
    money_format: "Nu {{amount}}",
    money_with_currency_format: "Nu {{amount}} BTN"
  }
  ,
  BRL: {
    money_format: "R$ {{amount_with_comma_separator}}",
    money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
  }
  ,
  BOB: {
    money_format: "Bs{{amount_with_comma_separator}}",
    money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
  }
  ,
  BWP: {
    money_format: "P{{amount}}",
    money_with_currency_format: "P{{amount}} BWP"
  }
  ,
  BND: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} BND"
  }
  ,
  MMK: {
    money_format: "K{{amount}}",
    money_with_currency_format: "K{{amount}} MMK"
  }
  ,
  KHR: {
    money_format: "KHR{{amount}}",
    money_with_currency_format: "KHR{{amount}}"
  }
  ,
  KYD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} KYD"
  }
  ,
  XAF: {
    money_format: "FCFA{{amount}}",
    money_with_currency_format: "FCFA{{amount}} XAF"
  }
  ,
  CLP: {
    money_format: "${{amount_no_decimals}}",
    money_with_currency_format: "${{amount_no_decimals}} CLP"
  }
  ,
  CNY: {
    money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY"
  }
  ,
  COP: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} COP"
  }
  ,
  CRC: {
    money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
  }
  ,
  HRK: {
    money_format: "{{amount_with_comma_separator}} kn",
    money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
  }
  ,
  CZK: {
    money_format: "{{amount_with_comma_separator}} K&#269;",
    money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
  }
  ,
  DKK: {
    money_format: "{{amount_with_comma_separator}} kr",
    money_with_currency_format: "kr.{{amount_with_comma_separator}}"
  }
  ,
  DOP: {
    money_format: "RD$ {{amount}}",
    money_with_currency_format: "RD$ {{amount}}"
  }
  ,
  XCD: {
    money_format: "${{amount}}",
    money_with_currency_format: "EC${{amount}}"
  }
  ,
  EGP: {
    money_format: "LE {{amount}}",
    money_with_currency_format: "LE {{amount}} EGP"
  }
  ,
  ETB: {
    money_format: "Br{{amount}}",
    money_with_currency_format: "Br{{amount}} ETB"
  }
  ,
  XPF: {
    money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
    money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
  }
  ,
  FJD: {
    money_format: "${{amount}}",
    money_with_currency_format: "FJ${{amount}}"
  }
  ,
  GMD: {
    money_format: "D {{amount}}",
    money_with_currency_format: "D {{amount}} GMD"
  }
  ,
  GHS: {
    money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}"
  }
  ,
  GTQ: {
    money_format: "Q{{amount}}",
    money_with_currency_format: "{{amount}} GTQ"
  }
  ,
  GYD: {
    money_format: "G${{amount}}",
    money_with_currency_format: "${{amount}} GYD"
  }
  ,
  GEL: {
    money_format: "{{amount}} GEL",
    money_with_currency_format: "{{amount}} GEL"
  }
  ,
  HNL: {
    money_format: "L {{amount}}",
    money_with_currency_format: "L {{amount}} HNL"
  }
  ,
  HKD: {
    money_format: "${{amount}}",
    money_with_currency_format: "HK${{amount}}"
  }
  ,
  HUF: {
    money_format: "{{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
  }
  ,
  ISK: {
    money_format: "{{amount_no_decimals}} kr",
    money_with_currency_format: "{{amount_no_decimals}} kr ISK"
  }
  ,
  INR: {
    money_format: "Rs. {{amount}}",
    money_with_currency_format: "Rs. {{amount}}"
  }
  ,
  IDR: {
    money_format: "Rp {{amount_with_comma_separator}}",
    money_with_currency_format: "Rp {{amount_with_comma_separator}}"
  }
  ,
  ILS: {
    money_format: "{{amount}} NIS",
    money_with_currency_format: "{{amount}} NIS"
  }
  ,
  JMD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} JMD"
  }
  ,
  JPY: {
    money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
  }
  ,
  JEP: {
    money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP"
  }
  ,
  JOD: {
    money_format: "{{amount}}0 JD",
    money_with_currency_format: "{{amount}}0 JOD"
  }
  ,
  KZT: {
    money_format: "{{amount}} KZT",
    money_with_currency_format: "{{amount}} KZT"
  }
  ,
  KES: {
    money_format: "KSh{{amount}}",
    money_with_currency_format: "KSh{{amount}}"
  }
  ,
  KWD: {
    money_format: "{{amount}}0 KD",
    money_with_currency_format: "{{amount}}0 KWD"
  }
  ,
  KGS: {
    money_format: "лв{{amount}}",
    money_with_currency_format: "лв{{amount}}"
  }
  ,
  LVL: {
    money_format: "Ls {{amount}}",
    money_with_currency_format: "Ls {{amount}} LVL"
  }
  ,
  LBP: {
    money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP"
  }
  ,
  LTL: {
    money_format: "{{amount}} Lt",
    money_with_currency_format: "{{amount}} Lt"
  }
  ,
  MGA: {
    money_format: "Ar {{amount}}",
    money_with_currency_format: "Ar {{amount}} MGA"
  }
  ,
  MKD: {
    money_format: "ден {{amount}}",
    money_with_currency_format: "ден {{amount}} MKD"
  }
  ,
  MOP: {
    money_format: "MOP${{amount}}",
    money_with_currency_format: "MOP${{amount}}"
  }
  ,
  MRP: {
    money_format: "MRP{{amount}}",
    money_with_currency_format: "MRP{{amount}}"
  },
  MVR: {
    money_format: "Rf{{amount}}",
    money_with_currency_format: "Rf{{amount}} MRf"
  }
  ,
  MXN: {
    money_format: "$ {{amount}}",
    money_with_currency_format: "$ {{amount}} MXN"
  }
  ,
  MYR: {
    money_format: "RM{{amount}} MYR",
    money_with_currency_format: "RM{{amount}} MYR"
  }
  ,
  MUR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} MUR"
  }
  ,
  MDL: {
    money_format: "{{amount}} MDL",
    money_with_currency_format: "{{amount}} MDL"
  }
  ,
  MAD: {
    money_format: "{{amount}} dh",
    money_with_currency_format: "Dh {{amount}} MAD"
  }
  ,
  MNT: {
    money_format: "{{amount_no_decimals}} &#8366",
    money_with_currency_format: "{{amount_no_decimals}} MNT"
  }
  ,
  MZN: {
    money_format: "{{amount}} Mt",
    money_with_currency_format: "Mt {{amount}} MZN"
  }
  ,
  NAD: {
    money_format: "N${{amount}}",
    money_with_currency_format: "N${{amount}} NAD"
  }
  ,
  NPR: {
    money_format: "Rs{{amount}}",
    money_with_currency_format: "Rs{{amount}} NPR"
  }
  ,
  ANG: {
    money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;"
  }
  ,
  NZD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} NZD"
  }
  ,
  NIO: {
    money_format: "C${{amount}}",
    money_with_currency_format: "C${{amount}} NIO"
  }
  ,
  NGN: {
    money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN"
  }
  ,
  NOK: {
    money_format: "kr {{amount_with_comma_separator}}",
    money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
  }
  ,
  OMR: {
    money_format: "{{amount_with_comma_separator}} OMR",
    money_with_currency_format: "{{amount_with_comma_separator}} OMR"
  }
  ,
  PKR: {
    money_format: "Rs.{{amount}}",
    money_with_currency_format: "Rs.{{amount}} PKR"
  }
  ,
  PGK: {
    money_format: "K {{amount}}",
    money_with_currency_format: "K {{amount}} PGK"
  }
  ,
  PYG: {
    money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  }
  ,
  PEN: {
    money_format: "S/. {{amount}}",
    money_with_currency_format: "S/. {{amount}} PEN"
  }
  ,
  PHP: {
    money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP"
  }
  ,
  PLN: {
    money_format: "{{amount_with_comma_separator}} zl",
    money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
  }
  ,
  QAR: {
    money_format: "QAR {{amount_with_comma_separator}}",
    money_with_currency_format: "QAR {{amount_with_comma_separator}}"
  }
  ,
  RON: {
    money_format: "{{amount_with_comma_separator}} lei",
    money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
  }
  ,
  RUB: {
    money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  }
  ,
  RWF: {
    money_format: "{{amount_no_decimals}} RF",
    money_with_currency_format: "{{amount_no_decimals}} RWF"
  }
  ,
  WST: {
    money_format: "WS$ {{amount}}",
    money_with_currency_format: "WS$ {{amount}} WST"
  }
  ,
  SAR: {
    money_format: "{{amount}} SR",
    money_with_currency_format: "{{amount}} SAR"
  }
  ,
  STD: {
    money_format: "Db {{amount}}",
    money_with_currency_format: "Db {{amount}} STD"
  }
  ,
  RSD: {
    money_format: "{{amount}} RSD",
    money_with_currency_format: "{{amount}} RSD"
  }
  ,
  SCR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} SCR"
  }
  ,
  SGD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} SGD"
  }
  ,
  SYP: {
    money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP"
  }
  ,
  ZAR: {
    money_format: "R {{amount}}",
    money_with_currency_format: "R {{amount}} ZAR"
  }
  ,
  KRW: {
    money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
  }
  ,
  LKR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} LKR"
  }
  ,
  SEK: {
    money_format: "{{amount_no_decimals}} kr",
    money_with_currency_format: "{{amount_no_decimals}} kr SEK"
  }
  ,
  CHF: {
    money_format: "CHF {{amount}}",
    money_with_currency_format: "SFr. {{amount}} CHF"
  }
  ,
  TWD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} TWD"
  }
  ,
  THB: {
    money_format: "{{amount}} &#xe3f;",
    money_with_currency_format: "{{amount}} &#xe3f; THB"
  }
  ,
  TZS: {
    money_format: "{{amount}} TZS",
    money_with_currency_format: "{{amount}} TZS"
  }
  ,
  TTD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} TTD"
  }
  ,
  TND: {
    money_format: "{{amount}}",
    money_with_currency_format: "{{amount}} DT"
  }
  ,
  TRY: {
    money_format: "{{amount}}TL",
    money_with_currency_format: "{{amount}}TL"
  }
  ,
  UGX: {
    money_format: "Ush {{amount_no_decimals}}",
    money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
  }
  ,
  UAH: {
    money_format: "₴{{amount}}",
    money_with_currency_format: "₴{{amount}} UAH"
  }
  ,
  UYU: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} UYU"
  }
  ,
  VUV: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}}VT"
  }
  ,
  VEF: {
    money_format: "Bs. {{amount_with_comma_separator}}",
    money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
  }
  ,
  VND: {
    money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
    money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
  }
  ,
  XBT: {
    money_format: "{{amount_no_decimals}} BTC",
    money_with_currency_format: "{{amount_no_decimals}} BTC"
  }
  ,
  XOF: {
    money_format: "CFA{{amount}}",
    money_with_currency_format: "CFA{{amount}} XOF"
  }
  ,
  ZMW: {
    money_format: "K{{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};

/* ============================ SLIDE CART =====================================*/
var HsDelay = (function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

var Hs_CartDrawer = {
  free_shipping_svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="m14.27 18.75h-4.54a.75.75 0 0 1 0-1.5h4.54a.75.75 0 0 1 0 1.5z"/><path d="m20.18 18.75h-2.45a.75.75 0 0 1 0-1.5h2.45a.24.24 0 0 0 .24-.19l.66-3.31h-6.08a.75.75 0 0 1 -.56-.25.77.77 0 0 1 -.19-.58l.88-7.92a.27.27 0 0 0 -.06-.2.31.31 0 0 0 -.19-.08h-11.88a.75.75 0 0 1 0-1.5h11.88a1.74 1.74 0 0 1 1.3.58 1.78 1.78 0 0 1 .45 1.36l-.79 7.06h6.16a.76.76 0 0 1 .58.27.8.8 0 0 1 .16.63l-.84 4.2a1.76 1.76 0 0 1 -1.72 1.43z"/><path d="m6.27 18.75h-4.27a.75.75 0 0 1 0-1.5h4.27a.75.75 0 0 1 0 1.5z"/><path d="m22 13.75h-7a.75.75 0 0 1 0-1.5h6l-1.48-4.33a.25.25 0 0 0 -.24-.17h-3.61a.75.75 0 0 1 0-1.5h3.61a1.78 1.78 0 0 1 1.66 1.18l1.77 5.33a.75.75 0 0 1 -.1.68.77.77 0 0 1 -.61.31z"/><path d="m8 21.75a2.75 2.75 0 1 1 2.75-2.75 2.75 2.75 0 0 1 -2.75 2.75zm0-4a1.25 1.25 0 1 0 1.25 1.25 1.25 1.25 0 0 0 -1.25-1.25z"/><path d="m16 21.75a2.75 2.75 0 1 1 2.75-2.75 2.75 2.75 0 0 1 -2.75 2.75zm0-4a1.25 1.25 0 1 0 1.25 1.25 1.25 1.25 0 0 0 -1.25-1.25z"/><path d="m6 8.25h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5z"/><path d="m7 11.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5z"/><path d="m8 15.25h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5z"/></g></svg>`,
  discount_svg: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
    <g>
        <g>
          <path d="M507.606,4.394c-5.857-5.858-15.356-5.858-21.214,0l-43.69,43.69c-2.686-1.28-5.52-2.311-8.479-3.05L298.452,11.491    c-15.246-3.811-31.622,0.724-42.735,11.837L13.16,265.486c-17.545,17.546-17.545,46.096,0,63.643l169.713,169.712    c17.546,17.546,46.096,17.547,63.643,0l242.158-242.558c11.113-11.113,15.649-27.489,11.836-42.736l-33.542-135.77    c-0.74-2.958-1.77-5.793-3.05-8.479l43.69-43.69C513.464,19.75,513.464,10.252,507.606,4.394z M471.403,220.825    c1.271,5.082-0.241,10.54-3.945,14.245L225.3,477.627c-5.849,5.849-15.366,5.849-21.215,0L34.373,307.914    c-5.849-5.849-5.849-15.366,0-21.215L276.931,44.542c2.837-2.837,6.703-4.388,10.641-4.388c1.204,0,2.415,0.145,3.604,0.442    l127.53,31.483l-36.125,36.125c-16.725-7.966-37.384-5.044-51.21,8.782c-17.547,17.547-17.547,46.096,0,63.643    c8.772,8.773,20.297,13.16,31.821,13.16c11.523,0,23.048-4.386,31.82-13.16c13.829-13.828,16.75-34.486,8.782-51.211    l36.125-36.125L471.403,220.825z M373.799,159.416c-5.848,5.848-15.365,5.849-21.214,0c-5.848-5.848-5.848-15.366,0-21.214    c2.925-2.925,6.765-4.386,10.607-4.386c3.84,0,7.682,1.462,10.605,4.385l0.001,0.001l0.001,0.001    C379.648,144.051,379.647,153.568,373.799,159.416z"/>
        </g>
    </g>
    <g>
        <g>
          <path d="M246.514,180.63c-17.546-17.546-46.096-17.546-63.643,0c-17.545,17.546-17.545,46.096,0,63.643    c17.546,17.546,46.097,17.546,63.643,0C264.061,226.726,264.061,198.177,246.514,180.63z M225.301,223.058    c-5.849,5.849-15.366,5.849-21.214,0c-5.848-5.849-5.85-15.366-0.001-21.214c5.849-5.848,15.365-5.849,21.215,0    C231.149,207.692,231.149,217.209,225.301,223.058z"/>
        </g>
    </g>
    <g>
        <g>
          <path d="M267.728,329.128c-17.587-17.587-46.052-17.589-63.642,0c-17.547,17.547-17.547,46.096,0,63.643    c17.588,17.587,46.053,17.59,63.642,0C285.275,375.224,285.275,346.675,267.728,329.128z M246.514,371.557    c-5.861,5.862-15.352,5.863-21.214,0c-5.848-5.848-5.848-15.366,0-21.214c5.862-5.862,15.352-5.863,21.214,0    C252.362,356.191,252.362,365.707,246.514,371.557z"/>
        </g>
    </g>
    <g>
        <g>
          <path d="M335.673,274.437c-0.915-8.234-8.333-14.168-16.566-13.253l-190.926,21.214c-8.234,0.915-14.168,8.331-13.253,16.566    c0.853,7.671,7.347,13.346,14.891,13.346c0.553,0,1.113-0.031,1.675-0.093l190.927-21.214    C330.655,290.087,336.589,282.671,335.673,274.437z"/>
        </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>`,
  product_svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="m97 44.94h-9.758l.066-.066c1.337-1.354 2.055-3.147 2.02-5.05-.036-1.903-.819-3.669-2.206-4.973-2.555-2.402-6.387-2.53-9.079-.431l-1.637-11.275c-.403-2.776-2.822-4.87-5.627-4.87h-9.6v-4.323c0-5.291-4.305-9.596-9.596-9.596h-16.5c-5.292 0-9.596 4.305-9.596 9.596v4.323h-10.655c-2.805 0-5.224 2.094-5.627 4.87l-8.145 56.118c-.238 1.634.246 3.288 1.327 4.537s2.648 1.966 4.3 1.966h34.523v7.877c0 1.104.896 2 2 2h50.028c1.104 0 2-.896 2-2v-31.942h1.762c1.104 0 2-.896 2-2v-12.76c0-1.104-.896-2-2-2zm-2 12.76h-18.917v-8.76h18.917zm-30.768 0v-8.76h7.851v8.76zm7.851 4v29.942h-7.851v-29.942zm-30.634-4v-8.76h18.783v8.76zm13.397-13.111c-1.164-1.164-1.164-3.06 0-4.224s3.059-1.164 4.224 0l4.575 4.575h-8.448l-.352-.352zm29.536-6.823c.595.56.931 1.316.946 2.133.015.815-.292 1.584-.866 2.165l-2.842 2.877h-8.527l7.11-7.109c1.154-1.153 2.989-1.182 4.178-.065zm-54.894-23.813c0-3.086 2.51-5.596 5.596-5.596h16.5c3.085 0 5.596 2.51 5.596 5.596v4.323h-27.692zm-22.801 67.813c-.67 0-1.086-.365-1.275-.583s-.49-.682-.394-1.346l8.145-56.116c.12-.823.837-1.444 1.669-1.444h10.656v8.458c0 1.104.896 2 2 2s2-.896 2-2v-8.458h27.691v8.458c0 1.104.896 2 2 2s2-.896 2-2v-8.458h9.6c.832 0 1.549.621 1.668 1.444l2.055 14.155-6.133 6.132-6.471-6.471c-2.725-2.725-7.157-2.725-9.88 0-1.32 1.319-2.046 3.074-2.046 4.939 0 .856.16 1.686.453 2.464h-10.976c-1.104 0-2 .896-2 2v12.76c0 1.104.896 2 2 2h1.761v20.065h-34.523zm38.523-20.065h15.022v29.942h-15.022zm46.028 29.942h-15.155v-29.942h15.155z"/><path d="m18.081 33.948c-1.092-.088-2.071.715-2.169 1.814l-.759 8.53c-.098 1.101.715 2.072 1.815 2.17.06.005.12.008.18.008 1.024 0 1.897-.783 1.99-1.822l.759-8.53c.098-1.101-.715-2.072-1.815-2.17z"/><path d="m16.565 50.985c-1.095-.093-2.071.715-2.169 1.814l-.095 1.069c-.098 1.101.714 2.072 1.815 2.17.06.005.12.008.18.008 1.024 0 1.897-.783 1.99-1.822l.095-1.069c.098-1.101-.714-2.072-1.815-2.17z"/></svg>`,
  hide_discount_list_footer: 0,
  add_url_item_cart: 1,
  iniAddShipping: false,
  coupon_bar_position: 0,
  coupon_bar_desktop_positionOffset: 0,
  coupon_bar_mobile_positionOffset: 0,
  announcement_autoplay_time: 0,
  prices_reverse_order: 0,
  discount_order_x_item: 1,
  show_base_price_discount: 1,
  showSaveItem: 0,
  checkout_button_show_subtotal_text: 0,
  positionDiscountCoupon: 0,
  hiddenVarianTitleCart: 0,
  hidenDiscount: 0,
  upgrade_text: 'Upgrade',
  downgrade_text: 'Downgrade',
  upgrade_charge: 0,
  swiper_tiered: null,
  swiper_static: null,
  swiper_dynamic: null,
  swiper_automatic: null,
  sticky_cart_countdown: 0,
  upsell_popUp_design: 0,
  minimum_order_option: 0,
  cart_note_additional: 0,
  auto_add_shipping_protection: 0,
  customize_body_sale_price: 0,
  customize_popUp_sale_price: 0,
  customize_upsell_sale_price: 0,
  rewards_specific_mode: 0,
  rewards_all_mode: 0,
  footer_fixed: 1,
  subscribe_option_upsell: 1,
  subscribe: 0,
  shipping: 0,
  total_save: 0,
  tfi_lock_method: 0,
  cart_empty_upsell_qty: 1,
  cart_empty_upsell_autoplay_time: 0,
  apu_qty_per_view: 1,
  apu_autoplay_time: 0,
  mpu_qty_per_view: 1,
  mpu_autoplay_time: 0,
  spu_qty_per_view: 1,
  spu_autoplay_time: 0,
  tiered_qty_per_view: 1,
  tiered_autoplay_time: 0,
  unit_price_separator: '/',
  display_unit_price: 0,
  footerStatic: 1,
  animationSlideMobile: 0,
  afterSymbol: 1,
  withOutSub: 'One Time',
  withSubAndDscto: 'Subscribe &amp; Save',
  withSubOnly: '',
  cartBar_typePrice: 0,
  rtl: '',
  slidePositon: 1,
  hiddenDecNum: 0,
  rewardShowGoal: 0,
  languageFreeGnral: ``,
  languageFree: `Free`,
  designQty: 0,
  typePrice: 0,
  elementAdd: 'form[data-zp-link-type="checkout"] button[data-zp-link-type="checkout"],[action$="/cart/add"] [type="submit"], [action$="/cart/add.js"] [type="submit"], [action$="/cart/add"] [name="add"]:not([data-pf-type="ProductATC2"]):not([data-pf-type="ProductATC"]):not([on\\:click="quick-add-component/handleClick"]), [action$="/cart/add.js"] [name="add"], [data-action="add-to-cart"], [action$="/cart/add"] .btn-addtocart, [action$="/cart/add.js"] .btn-addtocart,[action$="/cart/add.js"] .addtocart-js,[action$="/cart/add"] .addtocart-js,[action$="/cart/add"] .tt-btn-addtocart,[action$="/cart/add"] .addtocart-item-js,[action$="/cart/add.js"] .tt-btn-addtocart,[action$="/cart/add.js"] .addtocart-item-js, .addCart:not(.new-form-atc),button.add-to-cart-btn,.add-to-cart.btn,button.add_to_cart_btn_cls.fly_addtocart,button.quick-add-btn[data-id],form[action$="/cart/add"] [type="button"][data-add-button], a[href*="/cart/add?id="],.prodMain__buyRow .button.buyButton,.stickyBuy .button.buyButton,[action$="/cart/add"] button[data-node-type="commerce-add-to-cart-button"].w-commerce-commerceaddtocartbutton, [action$="/cart/add"] gp-product-button button[type="button"]:not(.gp-button-sold-out),[action$="/cart/add"] .pb-button-shadow .push-btn, .productgrid--item .productitem .productitem--action.atc--button button.productitem--action-atc, product-recommendations .swiper-wrapper .js-product-card .js-grid-cart[data-id]:not([data-id=""]), .product-card.js-product-card span.btn.js-grid-cart[data-id]:not([data-id=""]), product-quick-add.product--quick-add[data-form="false"] button.product--quick-add--button, form[action$="/cart/add"] button.js-go-cart-add-to-cart',
  arrQuickBuyButton: [],
  update_set_cart: 0,
  show_weight: 0,
  discount_storage: 'hs-slcart-discount',
  initAccessibleSwiper: function (swiperInstance = null, containerSelector = null) {
    if (!swiperInstance || !containerSelector) return;

    let keyboardSlideChange = false;

    // === Navegación por teclado (flechas izquierda/derecha) ===
    containerSelector.addEventListener('keydown', (e) => {
      const activeElement = document.activeElement;

      // Evitar interferir con controles o botones del Swiper
      const isInNavigationButton =
        activeElement.classList.contains('hs-swiper-button-prev') ||
        activeElement.classList.contains('hs-swiper-button-next');

      if (isInNavigationButton) return;

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        keyboardSlideChange = true;
        swiperInstance.slideNext();
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        keyboardSlideChange = true;
        swiperInstance.slidePrev();
      }
    });

    // === Control de foco y tabindex por slide ===
    function updateSlideFocus() {
      const slidesPerView = swiperInstance.params.slidesPerView || 1;
      const activeIndex = swiperInstance.activeIndex;
      //const totalSlides = swiperInstance.slides.length;

      swiperInstance.slides.forEach((slide, i) => {
        const isVisible = i >= activeIndex && i < activeIndex + slidesPerView;

        //slide.setAttribute('role', 'group');
        //slide.setAttribute('aria-label', `Producto ${i + 1} de ${totalSlides}`);
        slide.setAttribute('aria-roledescription', 'Slide');
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

        const focusables = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        focusables.forEach((el) => {
          el.tabIndex = isVisible ? 0 : -1;
        });
      });
    }

    // Inicializar
    updateSlideFocus();

    // === Manejo del cambio de slide ===
    swiperInstance.on('slideChangeTransitionEnd', () => {
      updateSlideFocus();

      // Solo si el cambio vino del teclado
      if (!keyboardSlideChange) return;

      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      const firstFocusable = activeSlide.querySelector('a, button, input, select, textarea, [tabindex]');
      if (firstFocusable) firstFocusable.focus();

      keyboardSlideChange = false;
    });
  },
  getDataPosition: function (key = '', type = 'main_cart') {
    let positionOrder = slideData?.position?.cart_body_order;
    switch (type) {
      case 'empty_cart':
        positionOrder = slideData?.position?.empty_cart_body_order;
        break;

      default:
        break;
    }
    if (!key || !positionOrder) return {};
    let dataSet = {};
    positionOrder = JSON.parse(positionOrder);
    positionOrder = positionOrder.find(position => position.key === key);
    if (positionOrder && Object.keys(positionOrder).length > 0) {
      const key = positionOrder?.key || '';
      if (key) {
        dataSet.key = `data-key=${key}`;
        dataSet.order = positionOrder.order;
      }
    }
    return dataSet;
  },
  Nn: function (e) {
    var t = {};
    return Hs_CartDrawer.In(e, (function (e) {
      t[e.title] = {
        title: e.title,
        type: e.type
      }
    }
    )),
      Object.values(t)
  },
  _: function (e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++)
      r[n] = e[n];
    return r
  },
  b: function (e, t) {
    if (e) {
      if ("string" === typeof e)
        return _(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name),
        "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _(e, t) : void 0
    }
  },
  In: function (e, t) {
    var n, r = Hs_CartDrawer.w(e.cart_level_discount_applications);
    try {
      for (r.s(); !(n = r.n()).done;) {
        t(n.value)
      }
    } catch (u) {
      r.e(u)
    } finally {
      r.f()
    }
    var o, a = Hs_CartDrawer.w(e.items);
    try {
      for (a.s(); !(o = a.n()).done;) {
        var i, s = Hs_CartDrawer.w(o.value.line_level_discount_allocations);
        try {
          for (s.s(); !(i = s.n()).done;) {
            t(i.value.discount_application)
          }
        } catch (u) {
          s.e(u)
        } finally {
          s.f()
        }
      }
    } catch (u) {
      a.e(u)
    } finally {
      a.f()
    }
  },
  w: function (e, t) {
    var n = "undefined" !== typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

    if (!n) {
      if (Array.isArray(e) || (n = Hs_CartDrawer.b(e)) || t && e && "number" === typeof e.length) {
        n && (e = n);

        var r = 0
          , o = function () { };
        return {
          s: o,
          n: function () {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            }
          },
          e: function (e) {
            throw e
          },
          f: o
        }
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }
    var a, i = !0, s = !1;
    return {
      s: function () {
        n = n.call(e)
      },
      n: function () {
        var e = n.next();
        return i = e.done,
          e
      },
      e: function (e) {
        s = !0,
          a = e
      },
      f: function () {
        try {
          i || null == n.return || n.return()
        } finally {
          if (s)
            throw a
        }
      }
    }
  },
  setActiveElement: function (element = '') {
    if (element) window.hsActiveElement = element;
  },
  focusOnItemsCart: function () {
    try {
      Hs_CartDrawer.removeTrapFocus();
      const containerToTrapFocusOn = document.querySelector('.hs-popup-cart-sp-load.hs-active') || '';
      if (!containerToTrapFocusOn) {
        // const focusable = [...document.body.querySelectorAll(
        //   '[tabindex]:not([tabindex="-1"]), button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
        // )].find(el => el.offsetParent !== null);
        // focusable?.focus();
        return false
      };
      const focusElement = document.querySelector('.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-sticky-cart') || document.querySelector('.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-close');
      if (containerToTrapFocusOn) {
        Hs_CartDrawer.trapFocus(containerToTrapFocusOn, focusElement);
      };
    } catch (error) {
      console.log(error)
    };
  },
  focusOnCartDrawer: function () {
    try {
      Hs_CartDrawer.removeTrapFocus();
      const containerToTrapFocusOn = document.querySelector('.hs-popup-cart-sp-load.hs-active') || '';
      if (!containerToTrapFocusOn) {
        return false
      };
      const focusElement = document.querySelector('.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-close');
      if (containerToTrapFocusOn) {
        Hs_CartDrawer.trapFocus(containerToTrapFocusOn, focusElement);
      };
    } catch (error) {
      console.log(error)
    };
  },
  // removeTrapFocus: function (elementToFocus = null) {
  //   try {
  //     document.removeEventListener('focusin', window.hstrapFocusHandlers.focusin);
  //     document.removeEventListener('focusout', window.hstrapFocusHandlers.focusout);
  //     document.removeEventListener('keydown', window.hstrapFocusHandlers.keydown);

  //     if (elementToFocus) elementToFocus.focus();
  //   } catch (error) {

  //   }
  // },
  // trapFocus: function (container, elementToFocus = container) {
  //   try {
  //     setTimeout(function () {
  //       const elements = Hs_CartDrawer.getFocusableElements(container);
  //       if (!elements.length) return;

  //       const first = elements[0];
  //       const last = elements[elements.length - 1];

  //       Hs_CartDrawer.removeTrapFocus();

  //       window.hstrapFocusHandlers.keydown = function (event) {
  //         if (event.key !== 'Tab') return;

  //         // TAB hacia adelante
  //         if (!event.shiftKey && document.activeElement === last) {
  //           event.preventDefault();
  //           first.focus();
  //         }

  //         // SHIFT + TAB hacia atrás
  //         if (event.shiftKey && document.activeElement === first) {
  //           event.preventDefault();
  //           last.focus();
  //         }
  //       };

  //       window.hstrapFocusHandlers.focusin = function (event) {
  //         if (!container.contains(event.target)) {
  //           event.stopPropagation();
  //           first.focus();
  //         }
  //       };

  //       document.addEventListener('keydown', window.hstrapFocusHandlers.keydown);
  //       document.addEventListener('focusin', window.hstrapFocusHandlers.focusin);

  //       elementToFocus.focus();
  //     }, 500);
  //   } catch (error) {

  //   };
  // },
  // getFocusableElements: function (container) {
  //   return Array.from(
  //     container.querySelectorAll(
  //       ".hs-close, [role='button'], a[href], button:enabled, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
  //     )
  //   );
  // },
  removeTrapFocus: function (elementToFocus = null) {
    try {
      if (window.hstrapFocusHandlers.keydown && window.hstrapFocusHandlers.container) {
        window.hstrapFocusHandlers.container.removeEventListener(
          'keydown',
          window.hstrapFocusHandlers.keydown
        );
      }

      if (elementToFocus) elementToFocus.focus();

      window.hstrapFocusHandlers.keydown = null;
      window.hstrapFocusHandlers.container = null;
      window.hstrapFocusHandlers.previousActiveElement = null;
    } catch (error) { }
  },

  trapFocus: function (container, elementToFocus = null) {
    try {
      const focusContainer =
        container instanceof HTMLElement
          ? container
          : document.getElementById(container);

      if (!focusContainer) return;

      const elements = Hs_CartDrawer.getFocusableElements(focusContainer)
        .filter(el => el.offsetParent !== null);

      if (!elements.length) return;

      const first = elements[0];
      const last = elements[elements.length - 1];

      // Guardar foco previo
      window.hstrapFocusHandlers.previousActiveElement = document.activeElement;
      window.hstrapFocusHandlers.container = focusContainer;

      // Enfocar elemento inicial
      (elementToFocus || first).focus();

      // Handler REAL de focus trap (como el último código)
      window.hstrapFocusHandlers.keydown = function (event) {
        if (event.key !== 'Tab' && event.keyCode !== 9) return;

        const active = document.activeElement;

        // SHIFT + TAB desde el primero → último
        if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
          return;
        }

        // TAB desde el último → primero
        if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      };

      // 👈 CLAVE: listener SOLO en el contenedor
      focusContainer.addEventListener(
        'keydown',
        window.hstrapFocusHandlers.keydown
      );

    } catch (error) { }
  },

  getFocusableElements: function (container) {
    return Array.from(
      container.querySelectorAll(
        ".hs-close, [role='button'], a[href], button:enabled, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, [tabindex]:not([tabindex='-1'])"
      )
    );
  },

  randomArray: function (array = []) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  },
  parseHTML: function (html) {
    var t = document.createElement('template');
    t.innerHTML = html;
    return t.content;
  },
  setObjDataProd: function (product = null, variant_select = null) {
    let obj = {};
    if (product != null && variant_select != null) {
      let requires_selling_plan = product.requires_selling_plan || '';
      let selling_plan_groups = product.selling_plan_groups || [];
      let variant_selected = variant_select || [];
      obj = {
        requires_selling_plan: requires_selling_plan,
        selling_plan_groups: selling_plan_groups,
        variant_selected: variant_selected,
      };
    };
    return obj;
  },
  propertiesSubscription: function (formData) {
    if (formData) {
      if (window.recurpay) {
        formData.append("properties[Plan]", '');
        formData.append("properties[_PlanId]", '');
        /* formData.append("properties[_is_cart_influenced]", '');
        formData.append("attributes[_is_cart_influenced]", ''); */
      };
    };
    return formData;
  },
  compareProductData: function (product = null, variant_id_select = null) {
    const equals = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);
    var thisEquals = true;

    if (product != null && variant_id_select != null) {
      let product_storage = [];
      let variant_select = '';
      variant_select = product.variants.find(variant => variant.id == variant_id_select) || ''
      let obj1 = Hs_CartDrawer.setObjDataProd(product, variant_select) || {};

      if (window.localStorage) {
        product_storage = JSON.parse(localStorage.getItem("_hsproducts")) || [];
      };
      if (product_storage.length > 0) {
        product_storage = product_storage.find(prod_storage => prod_storage.id == product.id) || '';
        variant_select = product_storage.variants ? product_storage.variants.find(variant => variant.id == variant_id_select) : '';
      };
      let obj2 = Hs_CartDrawer.setObjDataProd(product_storage, variant_select) || {};
      !equals(obj1, obj2) && (thisEquals = false);
    };
    return thisEquals;
  },
  getStorageProducts: function (product = null, item_id = null) {
    let times = Date.now() - 3600000,
      products_now = [],
      product_storage = [],
      equalStorage = true;
    /* if(product != null && item_id != null){
      equalStorage = Hs_CartDrawer.compareProductData(product,item_id);
    }; */

    if (window.localStorage) {
      product_storage = JSON.parse(localStorage.getItem("_hsproducts")) || [];
    };
    if (product_storage.length > 0) {
      product_storage.forEach(function (product) {
        //equalStorage && products_now.push(product);
        //product.timestamp >= times && products_now.push(product)
        products_now.push(product)
      })
    };
    return products_now
  },
  hasSwitchToSubscription: function (product = null, variant = null) {
    let plan = false;
    if (Hs_CartDrawer.upgrade_charge && product != null && variant != null && product.selling_plan_groups && product.selling_plan_groups.length > 0 && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
      plan = true;
    };
    return plan;
  },
  createThisElement: function (tag, options) {
    return Object.assign(document.createElement(tag), options);
  },
  createSelectRechargeCartElement: function (arrs = [], variant, item) {
    var requires_selling_plan = variant.requires_selling_plan || false,
      plan_selected = 0,
      selectElement = '';
    try {
      if (item.selling_plan_allocation) {
        if (item.selling_plan_allocation.selling_plan) {
          if (item.selling_plan_allocation.selling_plan.id) {
            plan_selected = item.selling_plan_allocation.selling_plan.id;
          };
        };
      };


      /*  */
      variant_plan_allocations = variant.selling_plan_allocations || variant.selling_plan_variant

      if (variant && variant_plan_allocations) {
        let select = document.createElement('select');

        if (!requires_selling_plan) {
          let option = document.createElement("option");
          option.setAttribute("value", 'onetime');
          let option1Texto = document.createTextNode('One-time Only');
          option.appendChild(option1Texto);
          select.appendChild(option);
        };

        let nuevoObjeto = {};
        variant_plan_allocations.forEach(function (plan_variant) {
          var plan_group = arrs.find(selling_plan_groups => selling_plan_groups.id === plan_variant.selling_plan_group_id)
          let amount = plan_variant.selling_plan.price_adjustments[0].value, plan_subs = '';
          switch (plan_variant.selling_plan.price_adjustments[0].value_type) {
            case 'percentage':
              amount = amount + '%';
              break;
            case 'fixed_amount':
              amount = hsonslidecart.Currency.formatMoney(amount, slideData.settings.devices.money_format);
              var documentFragment = Hs_CartDrawer.parseHTML(amount);
              if (typeof documentFragment.children === 'object' && documentFragment.children.length > 0) {
                documentFragment = documentFragment.children[0];
                if (documentFragment.textContent) {
                  amount = documentFragment.textContent;
                };
              };
              break;

            default:
              break;
          }


          if (!nuevoObjeto.hasOwnProperty(Hs_CartDrawer.curlyReplaceRc(amount))) {
            nuevoObjeto[Hs_CartDrawer.curlyReplaceRc(amount)] = {
              plans: []
            }
            nuevoObjeto[Hs_CartDrawer.curlyReplaceRc(amount)].app_id = plan_group.app_id
          }
          nuevoObjeto[Hs_CartDrawer.curlyReplaceRc(amount)].plans.push(
            plan_variant.selling_plan
          )
        });
        let claves = Object.keys(nuevoObjeto);
        if (claves.length > 0) {
          for (let i = 0; i < claves.length; i++) {
            let clave = claves[i];
            if (nuevoObjeto[clave] && nuevoObjeto[clave].plans && nuevoObjeto[clave].plans.length > 0) {
              let optgroup = document.createElement("optgroup");
              optgroup.setAttribute('label', claves[i]);
              nuevoObjeto[clave].app_id && optgroup.setAttribute('data-id', nuevoObjeto[clave].app_id);
              var option = '';
              nuevoObjeto[clave].plans.forEach(function (plan) {
                option = document.createElement("option");
                option.setAttribute("value", plan.id);
                if (plan.id == plan_selected) {
                  option.setAttribute("selected", true);
                };
                let option1Texto = document.createTextNode(plan.name);
                option.appendChild(option1Texto);
                optgroup.appendChild(option);
                select.appendChild(optgroup);
              });
            };
          }
        };

        selectElement = Object.assign(select, {
          className: "hs-subscription-change-plan",
          ariaLabel: "Subscription plan select",
          onchange: function (e) {
            e.preventDefault();
            var selling_plan = '', props = variant.properties;
            if (this.value != plan_selected) {
              var this_data = new FormData();
              if (this.value !== 'onetime') {
                selling_plan = this.value;
                //this_data.append("properties[__hsSubscriptionUpgrade]", true);
              } else {
                //this_data.append("properties[__hsSubscriptionUpgrade]", false);
                var parent = this.parentNode || '';
                if (parent && parent.classList.contains('hs-subscription-upgrade-section')) {
                  parent.innerHTML = `<button class="hs-subscription-upgrade-button" disabled><span class="hs-upgrade-charge">${Hs_CartDrawer.downgrade_text}</span></button>`
                };
              }

              this_data.append("quantity", variant.qty);
              this_data.append("key", variant.key);
              this_data.append("id", variant.key);
              this_data.append("selling_plan", selling_plan);

              this_data = Hs_CartDrawer.propertiesSubscription(this_data);
              //this_data = JSON.stringify(this_data);
              HsApp1.onloadCart('', this_data, 0);
            };
          }
        });
        selectElement.setAttribute('key', item.key)
        selectElement.setAttribute('selling_plan', plan_selected)
        selectElement.setAttribute('quantity', item.quantity || 1)

      };
    } catch (error) {

    }

    return selectElement;
  },
  elementCartSubscription: function (item = null, product = null, variant_selected = null) {
    let subs_section_element = '';
    if (item != null && product != null && variant_selected != null) {
      var plans_assing = [];
      if (item.selling_plan_allocation && item.selling_plan_allocation != null) {
        if (variant_selected.selling_plan_allocations && variant_selected.selling_plan_allocations.length > 0) {

          if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
            product.selling_plan_groups.forEach(function (plan_product) {
              variant_selected.selling_plan_allocations.forEach(function (plan_variant) {
                if (plan_variant.selling_plan_group_id == plan_product.id) {

                  var selling_plan = plan_product.selling_plans.find(selling_plan => selling_plan.id === plan_variant.selling_plan_id)
                  plan_variant.selling_plan = selling_plan;

                  if (plans_assing.filter(x => x.id === plan_product.id).length == 0) {
                    plans_assing.push(plan_product);
                  };
                };
              });
            });
          };
        };
        subs_section_element = Hs_CartDrawer.createSelectRechargeCartElement(plans_assing, variant_selected, item);
      } else {
        if (variant_selected.selling_plan_allocations && variant_selected.selling_plan_allocations.length > 0) {

          const span = Hs_CartDrawer.createThisElement('span', {
            textContent: Hs_CartDrawer.upgrade_text,
            className: "hs-upgrade-charge",
          });/* CREATE SPAN BUTTON SUBSCRIPTION */

          subs_section_element = Hs_CartDrawer.createThisElement('button', {
            className: "hs-subscription-upgrade-button"
          });//CREATE BUTTON SUBSCRIPTION
          subs_section_element.appendChild(span);
          subs_section_element.setAttribute('key', item.key);
          subs_section_element.setAttribute('quantity', item.quantity);
          subs_section_element.setAttribute('selling_plan', variant_selected.selling_plan_allocations[0].selling_plan_id);
        };
      };
    };
    return subs_section_element;
  },
  templateCartAdditional: function (cart, htmlStr) {
    if (Hs_CartDrawer.upgrade_charge || +slideData.settings.additional_settings.show_compare_price) {
      // Create a new DOMParser object
      var parser = new DOMParser();
      // Parse an HTML string
      var doc = parser.parseFromString(htmlStr, "text/html");
      var productStorage = Hs_CartDrawer.getStorageProducts() || [];
      if (productStorage.length > 0) {
        var compare_at_price = '', item_compare_price = 0, sum_compare_at_price = 0;
        cart.items.forEach(function (item) {//CART ITEMS
          var hs_product = doc.querySelectorAll(`.hs-product-${item.id}[data-item-qty="${item.quantity}"][data-item-key="${item.key}"]`) || [];
          if (hs_product.length > 0) {
            hs_product.forEach(function (val, i) { //elementos DOOM

              var subs_section_element = '';
              var subs_section = '';

              productStorage.forEach(function (product) { //products STORAGE
                let variant_selected = product.variants.find(variant => variant.id === item.variant_id) || 0;
                if (variant_selected) {
                  if (Hs_CartDrawer.upgrade_charge) {
                    if (Hs_CartDrawer.hasSwitchToSubscription(product, variant_selected)) {
                      if (!val.querySelector('.hs-subscription-upgrade-section')) {
                        subs_section = Hs_CartDrawer.createThisElement('div', {
                          className: "hs-subscription-upgrade-section"
                        });/* CREATE SECTION(DIV) SUBSCRIPTION */
                      };
                      if (subs_section) {
                        subs_section_element = Hs_CartDrawer.elementCartSubscription(item, product, variant_selected);
                      };
                      if (subs_section && subs_section_element) {
                        val.appendChild(subs_section);//ADD SECTION TO DIV PRODUCT
                        subs_section.appendChild(subs_section_element);
                      };
                    };
                  };

                  if (+slideData.settings.additional_settings.show_compare_price) {
                    item_compare_price = variant_selected.compare_at_price > variant_selected.price ? variant_selected.compare_at_price ? !Hs_CartDrawer.typePrice ? variant_selected.compare_at_price : variant_selected.compare_at_price * item.quantity : 0 : 0;

                    sum_compare_at_price = variant_selected.compare_at_price * item.quantity;


                    if (typeof item.selling_plan_allocation !== 'undefined') {
                      if (typeof item.selling_plan_allocation.compare_at_price !== 'undefined' && typeof item.selling_plan_allocation.price !== 'undefined') {
                        if (item.selling_plan_allocation.compare_at_price > item.selling_plan_allocation.price) {
                          item_compare_price = item.selling_plan_allocation.compare_at_price;
                          sum_compare_at_price = item.selling_plan_allocation.compare_at_price * item.quantity;
                        };
                      };
                    };


                    if (item_compare_price > 0) {

                      compare_at_price = hsonslidecart.Currency.formatMoney(item_compare_price, slideData.settings.devices.money_format);
                      var hs_price_total = !!val.querySelector('.hs-price-total:not(.hs-discount-price-line-through)') ? val.querySelector('.hs-price-total:not(.hs-discount-price-line-through)') : '';
                      var hs_compare_at_price = !!val.querySelector('.hs-compare-at-price') ? val.querySelector('.hs-compare-at-price') : '';
                      if (!!hs_compare_at_price) {
                        if (hs_compare_at_price.innerHTML === '') {
                          hs_compare_at_price.insertAdjacentHTML('beforebegin', `<input type="hidden" value="${sum_compare_at_price}" class="">`);
                          //hs_compare_at_price.innerHTML = variant.compare_at_price;
                          hs_compare_at_price.innerHTML = compare_at_price;

                          if (!!hs_price_total) {
                            if (!!Hs_CartDrawer.customize_body_sale_price) {
                              hs_price_total.classList.add('hs-active-sale-price');
                            };
                          };
                        } else {
                          hs_compare_at_price.classList.remove('hs-hidden-compare');
                        };
                      }
                    };
                  };
                };
              });

            })
          }
        });


      };
    };

    if (typeof doc.body.innerHTML !== 'undefined' || doc.body.innerHTML != null) {
      htmlStr = doc.body.innerHTML;
    }
    return htmlStr;
  },
  uploadSwiper: function () {
    try {
      if (Hs_CartDrawer.swiper_tiered != null) {
        Hs_CartDrawer.swiper_tiered.update();
      };
      if (Hs_CartDrawer.swiper_static != null) {
        Hs_CartDrawer.swiper_static.update();
      };
      if (Hs_CartDrawer.swiper_dynamic != null) {
        Hs_CartDrawer.swiper_dynamic.update();
      };
      if (Hs_CartDrawer.swiper_automatic != null) {
        Hs_CartDrawer.swiper_automatic.update();
      };
    } catch (error) {

    }

  },
  unEscape: function (htmlStr) {
    htmlStr = htmlStr.replace(/&lt;/g, "<");
    htmlStr = htmlStr.replace(/&gt;/g, ">");
    htmlStr = htmlStr.replace(/&quot;/g, "\"");
    htmlStr = htmlStr.replace(/&#39;/g, "\'");
    htmlStr = htmlStr.replace(/&amp;/g, "&");
    return htmlStr;
  },
  escape: function (htmlStr) {
    return htmlStr.replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  },
  checkoutChamps: function (thisCatch = '') {
    let cart = Hs_CartDrawer.routeLocale(`cart`);
    fetch(`${cart}`, {
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      var parser = new DOMParser();
      var stringParse = parser.parseFromString(response, 'text/html') || '';
      if (stringParse) {
        var all_scripts = stringParse.querySelectorAll('script'), count = 0;
        all_scripts.forEach(function (element) {
          count++;
          var textHTML = element.innerHTML
          if (textHTML.indexOf('window.RedirectCart') > - 1 && textHTML.indexOf('productIdsWithQuantities') > - 1) {
            document.querySelector('body').insertAdjacentHTML('beforeend', '<button class="hs-custom-btn" style="display: none;"></button>');
            var x = textHTML.replace('document.addEventListener("DOMContentLoaded"', 'document.querySelector(".hs-custom-btn").addEventListener("click"');
            x = x.replace('<script>', '')
            x = x.replace('</script>', '')
            var script = document.createElement('script');
            script.id = 'hs-chk-champ';
            script.innerHTML = x;
            document.head.appendChild(script)
          };
          if (count == all_scripts.length) {
            var x = document.querySelector('.hs-custom-btn') || '';
            if (x) {
              //var ev = new Event("click", { "bubbles": true, "cancelable": false });
              //x.dispatchEvent(ev);
              x.click();
            };

            var customer_session = !!document.querySelector('.hs-customer-session') ? document.querySelector('.hs-customer-session') : '';
            if (!!customer_session) {
              var checkout = !!customer_session.querySelector("input[name='checkout']") ? customer_session.querySelector("input[name='checkout']") : '';
              if (!!checkout) {
                /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
                checkout.dispatchEvent(ev); */
                checkout.click();
              };
            };
          }
        });
      };
    }).catch(err => {
      console.log(err)
      if (thisCatch) {
        window.location.href = thisCatch;
      }
    })
  },
  curlyReplaceRc: function (replace = '') {
    if (replace === '0%') {
      replace = '';
    };
    var text = Hs_CartDrawer.withSubAndDscto, text_replace = '';
    var updateLanguage = slideData.updateLanguage;
    if (typeof updateLanguage !== 'undefined') {
      if (Hs_CartDrawer.withSubAndDscto.indexOf('{{') > -1 && Hs_CartDrawer.withSubAndDscto.indexOf('}}') > -1) {
        if (Hs_CartDrawer.withSubAndDscto.indexOf('{{percentage}}') > -1) {
          text_replace = '{{percentage}}';
        };
        if (Hs_CartDrawer.withSubAndDscto.indexOf('{{ percentage }}') > -1) {
          text_replace = '{{ percentage }}';
        };
        if (text_replace === '') {
          text_replace = '{{}}';
          replace = '';
        };
        text = Hs_CartDrawer.withSubAndDscto.replace(text_replace, replace);
      }
    } else {
      text = Hs_CartDrawer.withSubAndDscto + ' ' + replace;
    };
    return text;
  },
  revy_discounts: function (parameter = 0) {
    /* if (window.RevyBundle) {
      window.RevyBundle.api.getTotal(response => {
        var hs_footer_layout = !!document.querySelector('.hs-footer-layout') ? document.querySelector('.hs-footer-layout') : '';
        var hs_sub_total_cart = !!document.querySelector('.hs-sub-total-cart') ? document.querySelector('.hs-sub-total-cart') : '';
        var hs_subtotal_compare_at_price = !!document.querySelector('.hs_subtotal_compare_at_price') ? document.querySelector('.hs_subtotal_compare_at_price') : '';
        if (response.bundleTotal.discount > 0) {
          if(!!hs_footer_layout){
            hs_footer_layout.classList.add('hs-revy-discount');
          };
 
          if(!!hs_sub_total_cart){
            hs_sub_total_cart.classList.add('hs-payment-discount');
          };
 
          var hs_subtotal_amount = !!document.querySelector('.hs_subtotal_amount') ? document.querySelector('.hs_subtotal_amount') : '';
          if (!!hs_subtotal_amount) {
            hs_subtotal_amount.innerHTML = hsonslidecart.Currency.formatMoney(response.bundleTotal.original,slideData.settings.devices.money_format);
          };
 
          var hs_subtotal_amount_discount = !!document.querySelector('.hs_subtotal_amount_discount') ? document.querySelector('.hs_subtotal_amount_discount') : '';
          if(!!hs_subtotal_amount_discount){
            var new_price = hsonslidecart.Currency.formatMoney(response.bundleTotal.final, slideData.settings.devices.money_format);
            hs_subtotal_amount_discount.setAttribute('data-hs-original-price', response.bundleTotal.original);
            hs_subtotal_amount_discount.innerHTML = new_price
          };
 
          
          if(!!hs_subtotal_compare_at_price){
            hs_subtotal_compare_at_price.style.display = 'none';
          };
          var json = response.bundleTotal;
          if (json.per_variant) {
            if (json.per_variant.length > 0) {
              json.per_variant.forEach(function (variant) {
                if(variant.discount > 0){
                  var hs_product = !!document.querySelector(`.hs-product-${variant.variant_id}[data-item-qty="${variant.quantity}"][data-item-key="${variant.key}"]`) ? document.querySelector(`.hs-product-${variant.variant_id}[data-item-qty="${variant.quantity}"][data-item-key="${variant.key}"]`) : '';
                  var hs_price_total = !!hs_product.querySelector(`.hs-price-total`) ? hs_product.querySelector(`.hs-price-total`) : '';
                  var hs_compare_at_price = !!hs_product.querySelector(`.hs-compare-at-price`) ? hs_product.querySelector(`.hs-compare-at-price`) : '';
                  if (!!hs_compare_at_price) {
                    hs_compare_at_price.innerHTML = hsonslidecart.Currency.formatMoney(variant.original, slideData.settings.devices.money_format);
                  };
                  if (!!hs_price_total) {
                    hs_price_total.innerHTML = hsonslidecart.Currency.formatMoney(variant.final, slideData.settings.devices.money_format);
                  };
                };
              });
            };
          };
        }else{
          if(!!hs_footer_layout){
            if(!!hs_footer_layout.classList.contains('hs-revy-discount')){
              if (!!hs_sub_total_cart) {
                hs_sub_total_cart.classList.remove('hs-payment-discount');
                hs_footer_layout.classList.remove('hs-revy-discount');
              };
            };
          };
 
          if(!!hs_subtotal_compare_at_price){
            hs_subtotal_compare_at_price.style.display = 'block';
          };
        };
        HsApp1.currencyConverter();
      })
    }; */
  },
  mwgrouped: function () {
    var mwgrouped = '';
    if (typeof window.mwGroupedProducts !== 'undefined') {
      mwgrouped = '&module=mw_gp'
    };
    return mwgrouped;
  },
  starReviews: function (container = '.hs-sticky-cart') {
    /* const observer0 = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
          //document.querySelector('.jdgm-prev-badge').dataset.numberOfReviews
        if (!!mutation.target.classList.contains('.jdgm-badge-placeholder')) {
          if (!document.querySelector(`${container}`).classList.contains('hs-star-review')) {
            var starReview = 0;
            typeof mutation.target.querySelector('.jdgm-prev-badge').dataset.numberOfReviews !== 'undefined' ? starReview = +mutation.target.querySelector('.jdgm-prev-badge').dataset.numberOfReviews : ''
            if (starReview > 0) {
              document.querySelector(`${container}`).classList.add('hs-star-review');
              typeof document.querySelector(`${container}`).dataset.slide !== 'undefined' && eval(document.querySelector(`${container}`).dataset.slide);
            }
          };
        }
      })
    });
    const jdgmElement = document.querySelectorAll('.jdgm-badge-placeholder').length > 0 ?document.querySelectorAll('.jdgm-badge-placeholder') : [];
    if (jdgmElement.length > 0) {
      const observerOptions = {
        attributes: true,
        childList: false,
      };
      jdgmElement.forEach(function (jdgm_item) {
        observer0.observe(jdgm_item, observerOptions);
      }) 
    };*/

    /* if (!Hs_CartDrawer.integrationData(10)) {
      return false;
    };
    var starApp = slideData.integrations.find(({ integrations_app_id }) => integrations_app_id == 10);
    if ((typeof starApp === 'undefined') || (!starApp.options) || (starApp.option_selected == 0)) {
      return false;
    };
    switch (starApp.option_selected) {
      case 1:
        var data = '', container_gnral = container;
        container = !!document.querySelector(`${container}`) ? document.querySelector(`${container}`) : '';
        if (!!container) {
          container = container.querySelectorAll(`.jdgm-badge-placeholder`).length > 0 ? container.querySelectorAll(`.jdgm-badge-placeholder`) : [];
          if (container.length > 0) {
            data = [...container].map(function (element) {
              var hash = {};
              var $element = element;
              hash['productHandle'] = $element.dataset.handle;
              hash['badgePlaceholder'] = `${container_gnral} .jdgm-badge-placeholder[data-handle="${$element.dataset.handle}"]`;
              return hash;
            });
          };
        };
 
        setTimeout(function () {
          if (typeof jdgm !== 'undefined') {
            if (typeof jdgm.batchRenderBadges !== 'undefined') {
              function thisSwiper() {
                eval('HsApp1.' + document.querySelector(`${container_gnral}`).dataset.slide);
              };
              var a = jdgm.batchRenderBadges(data).then((e, i, j) => {
                thisSwiper();
              }).catch((err) => {
                thisSwiper();
              });
            };
          };
        }, 100);
        break;
    }; */
  },
  activeCF: function (status, time, thisIndex) {
    if (typeof status === 'undefined') {
      status = 0;
    };
    if (!status) {
      return false;
    };
    try {
      if (typeof window.hs_confetti !== 'undefined') {
        var a = !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout') : '';/* , thisCanvas = '';
              thisCanvas = !!a.querySelector('canvas') ? a.querySelector('canvas') : '';
              if (!!thisCanvas) {
                thisCanvas.remove();
              }; */

        var canvasElements = document.querySelectorAll(`canvas[class^='hs-rewards-canvas']`).length > 0 ? document.querySelectorAll(`canvas[class^='hs-rewards-canvas']`) : [];
        var sizeSlide = `${HsApp1.sizeSlide()}px`;
        myCanvas = document.createElement('canvas');
        myCanvas.className = `hs-rewards-canvas-${thisIndex}`;
        myCanvas.style.position = "absolute"
        myCanvas.style.width = `${sizeSlide}`;
        myCanvas.style.height = '100%';
        myCanvas.style.inset = '0px';
        myCanvas.style.top = '0px';
        myCanvas.style.zIndex = '888888888888889';
        myCanvas.style.pointerEvents = 'none';
        a.appendChild(myCanvas);
        var myConfetti = hs_confetti.create(myCanvas, {
          resize: true,
          useWorker: true
        });
        var isAnimating = false;
        const end = Date.now() + (typeof time !== 'undefined' ? time : 300);

        if (isAnimating) return;
        function animate(end) {
          myConfetti({
            particleCount: 3,
            scalar: 1.9,
            zIndex: 888888888888889,
            spread: 100,
            gravity: 3.5,
            ticks: 300,
            startVelocity: 70,
            colors: ['#ff5722', '#00bcd4', '#673ab7'],
            shapes: ['circle', 'square', 'circle'],
            origin: { x: 0, y: 0 }
          });
          myConfetti({
            particleCount: 3,
            scalar: 1.9,
            zIndex: 888888888888889,
            spread: 100,
            gravity: 3.5,
            ticks: 300,
            startVelocity: 70,
            colors: ['#ffeb3b', '#4caf50', '#e91e63'],
            shapes: ['circle', 'square', 'circle'],
            origin: { x: 0.8, y: 0 }

          });
          if (Date.now() < end) {
            isAnimating = true;
            requestAnimationFrame(() => animate(end));
          } else {
            if (canvasElements.length > 0) {
              setTimeout(function () {
                canvasElements = document.querySelectorAll(`canvas[class^='hs-rewards-canvas']`).length > 0 ? document.querySelectorAll(`canvas[class^='hs-rewards-canvas']`) : [];
                if (canvasElements.length > 0) {
                  canvasElements.forEach(function (element) {
                    element.remove();
                  });
                };
              }, (typeof time !== 'undefined' ? time : 300) * 15);
            };
            isAnimating = false;
          }
        }
        animate(end);
      };
    } catch (error) {
      console.log(error)
    }
  },
  stringToInt: function (stringNum) {
    if (typeof stringNum !== 'string') {
      stringNum = "0";
    };
    if (stringNum !== '') {
      stringNum = parseInt(parseFloat(stringNum * 100).toFixed(2));
    };
    return stringNum;
  },
  dsctoObj: function (dscto, title) {
    if (typeof dscto === 'object' && typeof title === 'string') {
      if (dscto.length > 0) {
        var new_dscto = [];
        new_dscto.push({ "title": title, "amount": Hs_CartDrawer.stringToInt(dscto[0].amount) });
        dscto = new_dscto;
      };
    } else {
      dscto = [];
    }
    return dscto;
  },
  updateSlideCart: function () {
    HsApp1.getMyCart(0);
  },
  getSlideCart: function () {
    HsApp1.getMyCart(1);
  },
  closeCart: function () {
    HsApp1.closeCart();
  },
  closeCartAndHiddenSticky: function () {
    var sticky = !!document.querySelector('.hs-sticky-cart-cart-drawer') ? document.querySelector('.hs-sticky-cart-cart-drawer') : '';
    if (!!sticky) {
      sticky.style.display = 'none';
    }
    HsApp1.closeCart();
  },
  getQuickBuyButton: function (id) {
    HsApp4.quickBuy(id);
  },
  getRewardsBar: function (cart) {
    if (!!slideData.settings.rewards.enabled_rewards) {
      HsApp1.rewardsBar(cart);
    }
  },
  deleteCookieGW: function () {
    HsApp1.deleteCookie('hs-giftWrap-check-specific');
    HsApp1.deleteCookie('hs-giftWrap-variantId');
    HsApp1.deleteCookie('hs-giftWrap-variantCompareAtPrice');
    HsApp1.deleteCookie('hs-giftWrap-key');
  },
  removeGWSpecific: function () {
    var divSpecific = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
    if (!!divSpecific) {
      var chk = !!divSpecific.querySelector('.hs-gift-wrap-check') ? divSpecific.querySelector('.hs-gift-wrap-check') : '';
      if (!!chk) {
        chk.checked = false;
      }
    }
    Hs_CartDrawer.deleteCookieGW();
  },
  validateGiftWrap: function (json) {
    function deleteShipping(key) {
      var json = {};
      var cart = Hs_CartDrawer.routeLocale(`cart/change.js`);
      var mwgrouped = Hs_CartDrawer.mwgrouped();
      return fetch(`${cart}${mwgrouped}`,
        {
          body: JSON.stringify({ id: key, quantity: 0 }),
          method: 'POST',
          headers: {
            'Accept': "application/json, text/javascript",
            'Content-Type': "application/json, text/javascript",
            'X-Requested-With': 'XMLHttpRequest'
          },
        })
        .then((response) => response.json())
        .then((responseData) => {
          json = responseData;
          HsApp1.updateInfoCart(responseData);//CAMBIO
          HsApp1.priceCart(responseData);
          HsApp1.addCompareAtPrice(responseData, '');
          HsApp1.addRechargeButton(responseData, '');
          HsApp1.clearALL();
          Hs_CartDrawer.deleteCookieGW();
          Hs_CartDrawer.removeGWSpecific();
          Hs_CartDrawer.revy_discounts();
          /* var toggle = !!document.querySelector('.hs-shipping-slider') ? document.querySelector('.hs-shipping-slider') : '';
          if (!!toggle) {
            if (toggle.classList.contains('hs-active')) {
              toggle.classList.remove('hs-active')
            };
          }; */
          return responseData;
        })
        .catch(error => console.warn(error))
        .then((e) => {
          HsApp1.addCompareAtPrice(json);
          HsApp1.addRechargeButton(json);
          Hs_CartDrawer.revy_discounts();
        });
    };
    switch (slideData.settings.gift_wrap.product_type) {
      case "specificProduct":
        var prodInCart = false, count = 0, key = '', id = '';
        if (typeof json !== 'undefined') {
          json.items.forEach(function (item) {
            count++;
            var props = item.properties_all || item.properties;
            if (props != null) {
              if (!!props._giftWrap) {
                prodInCart = true;
                key = item.key;
                id = item.id.toString();
              };
            };
          });
          if (count = json.items.length) {
            var thisDelete = false;
            if (!!prodInCart) {
              if (slideData.settings.gift_wrap.featured_product_shopify_id_variants.indexOf(id) < 0) {
                thisDelete = true;
              };
              if (!slideData.settings.gift_wrap.enabled_gift_wrap) {
                thisDelete = true;
              }
              if (!HsApp1.readCookie('hs-giftWrap-check-specific')) {
                thisDelete = true;
              };
              if (!!thisDelete) {
                deleteShipping(key);
              }
            } else {
              if (!!HsApp1.readCookie('hs-giftWrap-check-specific')) {
                Hs_CartDrawer.deleteCookieGW();
              };
            }
          };
        };
        break;
    };
  },
  removeShippingGral: function () {
    var elementShipping = !!document.querySelector('.hs-shipping-protection-gnrl') ? document.querySelector('.hs-shipping-protection-gnrl') : '';
    if (!!elementShipping) {
      var chk = !!elementShipping.querySelector('#hs-shipping-chk-id') ? elementShipping.querySelector('#hs-shipping-chk-id') : '';
      var switch_slide = !!elementShipping.querySelector('.hs-shipping-slider') ? elementShipping.querySelector('.hs-shipping-slider') : '';
      if (!!chk) {
        chk.checked = false;
      };
      if (!!switch_slide) {
        switch_slide.classList.remove('hs-active');
      }
    };
  },
  validateShippingGral: function (json) {
    /* SHIPPING PROTECTION */
    //VALIDATE CHANGE SHIPPING PROTECTION PRODUCT
    function hsActive(callback) {
      var hs_shipping_protection_gnrl = !!document.querySelector('.hs-shipping-protection-gnrl') ? document.querySelector('.hs-shipping-protection-gnrl') : '';
      if (!!hs_shipping_protection_gnrl) {
        var elementsActive = '.hs-shipping-chk,.hs-shipping-slider';
        var elements = document.querySelectorAll(elementsActive).length > 0 ? document.querySelectorAll(elementsActive) : [];
        if (elements.length > 0) {
          elements.forEach(function (element) {
            callback === 'remove' ? element.classList.remove('hs-active') : element.classList.add('hs-active')
          })
        };
      };
    };
    function deleteShipping(key) {
      var json = {};
      var cart = Hs_CartDrawer.routeLocale(`cart/change.js`);
      var mwgrouped = Hs_CartDrawer.mwgrouped();
      return fetch(`${cart}${mwgrouped}`,
        {
          body: JSON.stringify({ id: key, quantity: 0 }),
          method: 'POST',
          headers: {
            'Accept': "application/json, text/javascript",
            'Content-Type': "application/json, text/javascript",
            'X-Requested-With': 'XMLHttpRequest'
          },
        })
        .then((response) => response.json())
        .then((responseData) => {
          json = responseData;
          HsApp1.priceCart(responseData);
          HsApp1.addCompareAtPrice(responseData, '');
          HsApp1.addRechargeButton(responseData, '');
          HsApp1.clearALL();

          Hs_CartDrawer.revy_discounts();
          if (!!HsApp1.readCookie('hs-shipping-protection')) {
            HsApp1.deleteCookie('hs-shipping-protection');
          };
          HsApp1.deleteCookie('hs-shipping-protection-auto-add');
          var toggle = !!document.querySelector('.hs-shipping-slider') ? document.querySelector('.hs-shipping-slider') : '';
          if (!!toggle) {
            if (toggle.classList.contains('hs-active')) {
              toggle.classList.remove('hs-active')
            };
          };
          return responseData;
        })
        .catch(error => console.warn(error))
        .then((e) => {
          HsApp1.addCompareAtPrice(json);
          HsApp1.addRechargeButton(json);
          Hs_CartDrawer.revy_discounts();
        });
    };

    var prodInCart = false, count = 0, key = '', id = '';
    if (typeof json !== 'undefined') {
      json.items.forEach(function (item) {
        count++;
        if (item.properties != null) {
          if (!!item.properties._shippingProtection) {
            prodInCart = true;
            key = item.key;
            id = item.id.toString();
          };
        };
      });
      if (count = json.items.length) {
        var thisDelete = false;
        if (!!prodInCart) {
          if (id !== slideData.settings.shipping_protection.sp_featured_product_shopify_id_variant) {
            thisDelete = true;
          };
          if (!slideData.settings.shipping_protection.enabled_shipping_protection) {
            thisDelete = true;
          }
          if (!HsApp1.readCookie('hs-shipping-protection')) {
            thisDelete = true;
          };
          if (!!thisDelete) {
            deleteShipping(key);
          } else {
            if (!HsApp1.readCookie('hs-shipping-protection')) {
              HsApp1.createCpokie('hs-shipping-protection', key, 360);
              hsActive('add')
            };
          }
        } else {
          if (!!HsApp1.readCookie('hs-shipping-protection')) {
            HsApp1.deleteCookie('hs-shipping-protection');
            hsActive('remove')
          };
          if (!slideData.settings.shipping_protection.enabled_shipping_protection) {
            HsApp1.deleteCookie('hs-shipping-protection-auto-add');
          };
        }
      };
      if (json.item_count == 0) {
        HsApp1.deleteCookie('hs-shipping-protection');
        HsApp1.deleteCookie('hs-shipping-protection-auto-add');
      };
    };
  },
  integrationData: function (app_id) {
    var thisIntegration = [], ini = true;
    if (!!slideData.integrations) {
      if (slideData.integrations.length > 0) {
        slideData.integrations.forEach(function (integration) {
          if (integration.integrations_app_id == app_id) {
            thisIntegration.push(integration)
          };
        })
      };
    };
    if (thisIntegration.length > 0) {
      thisIntegration = thisIntegration[0];
      if (!thisIntegration.automatic && !thisIntegration.enabled_app) {
        ini = false;
      };
    } else {
      // if (app_id != 11) {
      //   ini = false;
      // };
      const defaultTrueIntegrations = [11, 37, 38, 39, 40, 41, 42, 43, 44]; // actualiza esta lista 
      if (!defaultTrueIntegrations.includes(app_id)) {
        ini = false;
      }
    };
    return ini;
  },
  integrationKlarna: function () {
    var klarnaIntegration = Hs_CartDrawer.integrationData(13);
    if (!!klarnaIntegration) {
      var key = '';
      /* function klarnaLoad() {
        if (typeof window.Klarna !== 'undefined') {
          var klarna_placement = !!document.querySelector('.hs-footer-layout klarna-placement') ? document.querySelector('.hs-footer-layout klarna-placement') : '';
          if (!!klarna_placement) {
            klarna_placement.dataset.amount = !!total_price ? total_price / 100 : 0;
          };
        };
      }; */


      const load_script = (url, key, callback) => {
        var script = document.createElement("script");
        script.setAttribute('defer', 'defer');
        script.setAttribute('id', 'klarna-osm-script-tag');
        script.setAttribute('data-client-id', key);
        // If the browser is Internet Explorer.
        if (script.readyState) {
          script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
              script.onreadystatechange = null;
              callback();
            }
          };
          // For any other browser.
        } else {
          script.onload = function () {
            callback();
          };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
      };


      if (typeof window.klarna_OSMP !== 'undefined') {
        if (typeof window.klarna_OSMP.isOSMLoaded !== 'undefined') {
          if (!!window.klarna_OSMP.isOSMLoaded) {
            if (typeof window.klarna_OSMP.store !== 'undefined') {
              if (typeof window.klarna_OSMP.store.client_id !== 'undefined') {
                if (window.klarna_OSMP.store.client_id !== '') {
                  key = window.klarna_OSMP.store.client_id
                };
              };
            };
          };
        };
      };


      if (key === '' && typeof window.Klarna === 'undefined') {
        var integration = slideData.integrations.filter((integration) => {
          if (integration.integrations_app_id == 13) {
            return integration;
          };
        }) || [];
        if (integration.length > 0) {
          key = integration[0].integrations_app_key || '';

        };
      };

      if (!!key) {
        load_script(`//js.klarna.com/web-sdk/v1/klarna.js`, key, function (e) {
        });
      };
    };
  },
  integrationAfterpay: function (total_price) {
    var afterpayIntegration = Hs_CartDrawer.integrationData(8);
    if (!!afterpayIntegration) {
      function afterpayLoad() {
        if (typeof window.Afterpay !== 'undefined') {
          var afterpay_placement = !!document.querySelector('.hs-footer-layout afterpay-placement') ? document.querySelector('.hs-footer-layout afterpay-placement') : '';
          if (!!afterpay_placement) {
            afterpay_placement.dataset.amount = !!total_price ? total_price / 100 : 0;
            //afterpay_placement.remove()
          };
        };
      };
      if (typeof window.Afterpay === 'undefined' || !window.Afterpay.size) {
        _HsLoadScript(`//js.afterpay.com/afterpay-1.x.js`, function (e) {
          afterpayLoad();
        })
      }
      else {
        afterpayLoad();
      }
    };
  },
  integrationScalapay: function () {
    var scalapayIntegration = false//Hs_CartDrawer.integrationData(10);
    if (!!scalapayIntegration) {
      _HsLoadScriptModule(`//cdn.scalapay.com/widget/v3/js/scalapay-widget.esm.js`, false, 'module', function (e) {
        _HsLoadScriptModule(`//cdn.scalapay.com/widget/v3/js/scalapay-widget.js`, true, '', function (e) {
        })
      });
    };
  },
  amountGw(amount = 0, operator = 0) {
    if (!!HsApp1.readCookie('hs-giftWrap-variantPrice')) {
      if (typeof amount === 'number') {
        if (amount > 0) {
          amount += ((+slideData.settings.gift_wrap.offer_compare_price - +slideData.settings.gift_wrap.offer_price) * 100);
        };
      };
    };
    return amount
  },
  validateCheckGift: function () {
    if (!!slideData?.settings?.gift_wrap?.enabled_gift_wrap) {
      switch (slideData.settings.gift_wrap.product_type) {
        case "specificProduct":
          if (!!HsApp1.readCookie('hs-giftWrap-check')) {
            HsApp1.deleteCookie('hs-giftWrap-check');
            HsApp1.deleteCookie('hs-giftWrap-variantPrice');
          };
          break;
        case "customProduct":
          if (!!HsApp1.readCookie('hs-giftWrap-check-specific')) {
            if (slideData.settings.gift_wrap.featured_product_shopify_id_variants.indexOf(HsApp1.readCookie('hs-giftWrap-variantId')) > -1) {
              var variantId = HsApp1.readCookie('hs-giftWrap-key');
              var arr_variants = JSON.stringify({ id: variantId, quantity: 0 });
              HsApp1.onloadCart('', arr_variants, 0);
              Hs_CartDrawer.removeGWSpecific();
            }
          }
          break;
      }
    }
    else {
      if (!!HsApp1.readCookie('hs-giftWrap-check-specific')) {
        var variantId = HsApp1.readCookie('hs-giftWrap-key')
        var arr_variants = JSON.stringify({ id: variantId, quantity: 0 });
        HsApp1.onloadCart('', arr_variants, 0);
        Hs_CartDrawer.removeGWSpecific();
      };
      if (!!HsApp1.readCookie('hs-giftWrap-check')) {
        HsApp1.deleteCookie('hs-giftWrap-check');
        HsApp1.deleteCookie('hs-giftWrap-variantPrice');
      }
    }
  },
  routeLocale: function (route_api) {
    let identificator = '&hsfastcart=true';
    var new_route_api = '/' + route_api, separator = '?', currency_update = '';
    if (!!window.Shopify) {
      if (!!window.Shopify.routes) {
        if (!!window.Shopify.routes.root) {
          if (window.Shopify.routes.root !== '/') {
            new_route_api = window.Shopify.routes.root + route_api;
            if (window.Shopify.currency) {
              if (window.Shopify.currency.active && window.Shopify.country) {
                currency_update = `&currency=${window.Shopify.currency.active}&country=${window.Shopify.country}`;
              };
            };
          };
        };
      };
    };
    var size_parameters = 0;
    const url = new URL(window.location.origin + new_route_api);
    const params = url.searchParams;
    size_parameters = params.size || size_parameters;
    size_parameters > 0 ? separator = '&' : '';
    if ((route_api === 'cart/add.js' || route_api === 'cart/change.js' || route_api === 'cart/update.js') && window.Shopify.optionScriptInitialized) {
      return `${new_route_api}`;
    };
    return `${new_route_api}${separator}v=${(new Date).getTime()}${identificator}${currency_update}`;
  },
};
Hs_CartDrawer.elementAddATC = Hs_CartDrawer.elementAdd + ', [action$="/cart/add"].pf-product-form button[data-product-id]';
var customCssAndJs = {
  loadCustomCss: function () {
    try {
      if (typeof slideData.settings.devices.customCss !== 'undefined') {
        if (slideData.settings.devices.customCss !== '') {
          const labelStyle = document.getElementById('hs-customCss') || '';
          if (labelStyle) {
            labelStyle.innerHTML = slideData.settings.devices.customCss;
          } else {
            document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css" id="hs-customCss">' + slideData.settings.devices.customCss + '</style>');
          }
        };
      };
    } catch (error) {
      console.log(error)
    }
  },
  loadCustomJs: function () {
    if (typeof slideData.settings.devices.customJs !== 'undefined') {
      if (slideData.settings.devices.customJs !== '') {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'hs-customJs';
        script.textContent = `try{\n ${slideData.settings.devices.customJs}\n}catch (err){\n console.log(err.message);\n}`;
        document.head.appendChild(script);
      };
    };
  },
  init: function () {
    customCssAndJs.loadCustomCss();
    //customCssAndJs.loadCustomJs();
  }
};

var pageflyANDgempages = {
  withOutOpenCart: 0,
  addToCart: function () {
    if (slideData.dashboard && parseInt(slideData.dashboard.dashboard_general_app) < 1) {
      return false;
    };
    var resultValidateDevice = HsApp1.validateDevice();
    switch (parseInt(resultValidateDevice)) {
      case 0:
        return false;
        break;
      case 2:
        return false;
        break;
    };
    var where = this;
    var button_cart = 'button[data-checkout="cart"]';
    var elementForm = '[action$="/cart/add"], [action$="/cart/add.js"]', elementAdd = Hs_CartDrawer.elementAdd;
    var a = document.querySelectorAll(elementAdd).length > 0 ? document.querySelectorAll(elementAdd) : [];
    var buttonsCart = document.querySelectorAll(button_cart).length > 0 ? document.querySelectorAll(button_cart) : [];

    if (buttonsCart.length > 0) {
      buttonsCart.forEach(function (button) {
        button.dataset.checkout = '';
      });
    };

    /* https://genderrevealcelebrations.com */
    var shop_the_look_add = document.querySelectorAll(".shop-the-look--add") || [];
    if (shop_the_look_add.length > 0) {
      function getProductIds(products) {
        return [...products].map(t => parseInt(t.getAttribute("data-product-id"))).filter(t => !isNaN(t))
      }
      shop_the_look_add.forEach(function (add_button) {
        if (!add_button.classList.contains('hs-event-static')) {
          add_button.classList.add('hs-event-static');
          add_button.addEventListener('click', function (e) {
            var parent = add_button.parentElement || '';
            var product_ids = [];
            if (parent) {
              var products = parent.querySelectorAll(".shop-the-look--product") || [];
              if (products.length > 0) {
                product_ids = getProductIds(products) || [];
                if (product_ids.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  var params = JSON.stringify({
                    items: product_ids.map(t => ({
                      id: t,
                      quantity: 1
                    }))
                  })
                  HsApp3.postMyCart(params, add_button)
                };
              };
            };
          }, true)
        };
      })
    };

    /* veyelashfactory.myshopify.com */
    const home_card_information_add_to_cart = document.querySelectorAll('.card-wrapper .card-information .card-information__button add-to-cart.button') || [];
    if (home_card_information_add_to_cart.length > 0) {
      home_card_information_add_to_cart.forEach(function (add_button) {
        const variantId = add_button.dataset.variantId || '';
        if (variantId) {
          if (!add_button.classList.contains('hs-event-static')) {
            add_button.classList.add('hs-event-static');
            add_button.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var params = JSON.stringify({
                quantity: 1,
                id: variantId
              })
              HsApp3.postMyCart(params, add_button)
            }, true);
          };
        };
      });
    };



    if (a.length > 0) {
      if (typeof window.imageUploader !== 'undefined') {
        var contentUpload = !!document.querySelector('#ImageUploaderContainer') ? document.querySelector('#ImageUploaderContainer') : '';
        if (!!contentUpload) {
          var botonUpload = !!contentUpload.querySelector('.upload-button') ? contentUpload.querySelector('.upload-button') : '';
          if (!!botonUpload) {
            return false;
          };
        };
      };

      var unbind = true;
      a.forEach(function (thisButton) {
        if (!!thisButton.getAttribute('id')) {
          if (thisButton.getAttribute('id') === 'mwAddToCart') {
            unbind = false;
          };
        };
      });

      try {
        if (!!unbind) {
          if (typeof ($) !== 'undefined') {
            if (typeof ($) === 'function') {
              if (!document.querySelector === $) {
                $(elementAdd) ? $(elementAdd).unbind() : '';
              };
            };

          };

          if (typeof ($$) !== 'undefined') {
            if (typeof ($$) === 'function') {
              $(elementAdd) ? $(elementAdd).unbind() : '';
            };
          };
          if (typeof (jQuery) !== 'undefined') {
            jQuery(elementAdd) ? jQuery(elementAdd).unbind() : '';
          };
        };
      } catch (error) {

      }


      a.forEach(function (b) {
        var this_capture = false;

        if (!!b.parentNode) {
          if (!!b.parentNode.classList.contains('sticky-cart-buttons')) {
            return false;
          };
        };

        if (b.classList.contains('gp-button-atc')) {
          if (b.closest('[action$="/cart/add"]')) {
            var form = b.closest('[action$="/cart/add"]');
            if (!form.querySelector('kaching-bundles-block')) {
              this_capture = true;
            };
          };
        };

        if (b.classList.contains('gp-button-atc')) {
          if (b.closest('gp-sticky')) {
            //var gp_sticky = b.closest('gp-sticky]');
            return false;
          }
        };

        if (b.classList.contains('uploadkit-cloned-atc-button')) {
          return false;
        };

        if (b.classList.contains('gpo-clone-atc-button')) {
          return false;
        };

        if (b.classList.contains('gpo-clone-stickyAtc-button')) {
          return false;
        };

        if (b.type === 'submit' && b.name === 'add') {
          if (typeof b.id !== 'undefined') {
            if (b.id === 'prime-bundles') {
              if (typeof b.parentNode !== 'undefined') {
                const parent = b.parentNode || ''
                if (typeof parent.id !== 'undefined') {
                  if (parent.id === 'prime-bundles') {
                    return false;
                  };
                };
              };
            };
          };
        };

        if (b.id === 'product-pack-submit') {//https://hiscase.com/
          if (b.closest('product-pack')) {
            return false;
          };
        };

        let capture_button = true;

        let block_product = b.closest('.product-info__block-item') || '';
        if (block_product) {
          let info_product = block_product.closest('safe-sticky.product-info') || '';
          if (info_product) {
            let textfieldapp = info_product.querySelector('#textfieldapp') || '';
            let easyflowOptions = info_product.querySelectorAll('.ef__product-option-root form .ef__product-option') || [];
            if (textfieldapp) {
              capture_button = false;
            };

            if (easyflowOptions.length > 0) {
              capture_button = true;
            }
          }
        };

        if (capture_button) {
          if (!b.classList.contains('hs-event-static')) {
            /* if(b.classList.contains('addCart') && b.getAttribute('id') === 'new-form-atc')
            {
              b.outerHTML = b.outerHTML;
            } */
            if (!!b.getAttribute('data-skip-cart')) {
              b.removeAttribute('data-skip-cart');
            };

            b.classList.add('hs-event-static');

            if (b.type === 'submit' && b.name === 'add' && typeof b.dataset.addToCart !== 'undefined') {
              this_capture = true;
            };

            if (b.type === 'button' && b.classList.contains('productitem--action-trigger') && b.classList.contains('productitem--action-atc') && typeof b.dataset.quickBuy !== 'undefined' && typeof b.dataset.variantId !== 'undefined') {
              this_capture = true;
            };

            if (b.type === 'submit' && (typeof b.dataset.cartAction !== 'undefined' && b.dataset.cartAction === 'cart')) {
              this_capture = true;
            };

            if (b.type === 'button' && b.classList.contains('product--quick-add--button') && (b.closest('product-quick-add'))) {
              this_capture = true;
            };

            if (b.type === 'submit' && b.name === 'add' && (b.getAttribute('ymq-add-to-cart-tags'))) {
              this_capture = true;
            };

            if (b.nodeName === 'INPUT') {
              if (b.type === 'submit' && b.name === 'button' && (b.classList.contains('AddtoCart') && b.classList.contains('js-ajax-submit'))) {
                if (typeof b.id !== 'undefined') {
                  if (b.id === 'addToCart') {
                    this_capture = true;
                  };
                };
              };
            };

            if (typeof b.id !== 'undefined') {
              if (b.id === 'add-to-cart-btn') {
                if (b.getAttribute("onclick")) {
                  // Verificar si el atributo onclick es exactamente "addToCart()"
                  var cleanOnClick = b.getAttribute("onclick").replace(/\s+/g, '') || '';
                  if (cleanOnClick === "addToCart()") {
                    this_capture = true;
                  };
                };
              };
            };
            if (typeof b.tagName !== 'undefined') {
              if (b.tagName === 'TRYON-BUTTON') {
                this_capture = true;
              }
            }

            b.addEventListener('click', function (e) {
              var link_type = !!b.getAttribute('data-zp-link-type') ? b.getAttribute('data-zp-link-type') : '';
              if (!!link_type) {
                if (link_type === 'external' || link_type === 'checkout') {
                  pageflyANDgempages.withOutOpenCart = 1;
                  return false;
                };
              };
              if (!!b.classList.contains('button-bundle')) {
                if (b.getAttribute('data-bundle-addtocart') != null) {
                  return false;
                };
              };
              if (window.mrUpsellConfig) {
                if (typeof window.mrUpsellConfig.is_enabled !== 'undefined') {
                  if (!!window.mrUpsellConfig.is_enabled) {
                    if (b.getAttribute('mr-click')) {
                      if (!!b.getAttribute('mr-click')) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      };
                    };
                  };
                };
              };
              e.preventDefault();

              if (document.querySelectorAll('#ptw-wrapin .ptw-app-wrapper').length == 0) {
                e.stopPropagation();
              };
              HsApp3.addForm(where, this)
            }, true);
          }
        };

      });
      /*$(elementAdd).click(function(e){
        e.preventDefault();
        e.stopPropagation();
        Hs_CartDrawer.addForm($(this),data,$);
      });*/
    };

    var footbar = !!document.querySelector('.footbar-product') ? document.querySelector('.footbar-product') : '';
    if (!!footbar) {
      var button_footbar = !!footbar.querySelector('button[name="add"]') ? footbar.querySelector('button[name="add"]') : '';
      if (!!button_footbar) {
        if (!button_footbar.classList.contains('hs-event-static')) {
          button_footbar.classList.add('hs-event-static');
          button_footbar.addEventListener('click', function (e) {
            if (a.length > 0) {
              a.forEach(function (b) {
                if (b.getAttribute('data-js-button-add-to-cart-clone-id') === button_footbar.getAttribute('data-js-button-add-to-cart-clone')) {
                  /*var evt = document.createEvent("HTMLEvents");
                  evt.initEvent("click", false, true);
                  b.dispatchEvent(evt);*/
                  var ev = new Event("click", { "bubbles": true, "cancelable": false });
                  b.dispatchEvent(ev);
                }
              });
            }
          });
        }
      };
    };

    var c = document.querySelectorAll(elementForm).length > 0 ? document.querySelectorAll(elementForm) : [];
    if (c.length > 0) {
      if (typeof window.imageUploader !== 'undefined') {
        var contentUpload = !!document.querySelector('#ImageUploaderContainer') ? document.querySelector('#ImageUploaderContainer') : '';
        if (!!contentUpload) {
          var botonUpload = !!contentUpload.querySelector('.upload-button') ? contentUpload.querySelector('.upload-button') : '';
          if (!!botonUpload) {
            return false;
          };
        };
      };

      try {
        if (typeof ($) !== 'undefined') {
          if (typeof ($) === 'function') {
            if (!document.querySelector === $) {
              $(elementForm) ? $(elementForm).unbind('submit') : '';
            };
          };
        };

        if (typeof ($$) !== 'undefined') {
          if (typeof ($$) === 'function') {
            $(elementForm) ? $(elementForm).unbind('submit') : '';
          };
        };

        if (typeof (jQuery) !== 'undefined') {
          jQuery(elementForm) ? jQuery(elementForm).unbind('submit') : '';
        };
        if (typeof (dg$) !== 'undefined') { //FB TRACK PIXEL FORM
          dg$(elementForm) ? dg$(elementForm).submit(function (e) {
            e.preventDefault();
          }) : '';
        };
      } catch (error) {

      }

      c.forEach(function (d) {
        if (!!d.classList.contains('sticky-cart-form')) {
          return false;
        };

        let capture = true;
        //let captureSubmit = false;

        let block_product = d.closest('.product-info__block-item') || '';
        if (block_product) {
          let info_product = block_product.closest('safe-sticky.product-info') || '';
          if (info_product) {
            let textfieldapp = info_product.querySelector('#textfieldapp') || '';
            let easyflowOptions = info_product.querySelectorAll('.ef__product-option-root form .ef__product-option') || [];
            if (textfieldapp) {
              capture = false;
            };

            if (easyflowOptions.length > 0) {
              capture = true;
            };
          }
        };

        if (capture) {
          if (!d.classList.contains('hs-event-static')) {
            d.classList.add('hs-event-static');
            d.addEventListener('submit', function (e) {
              var link_type = !!d.getAttribute('data-zp-link-type') ? d.getAttribute('data-zp-link-type') : '';
              if (!!link_type) {
                if (link_type === 'external' || link_type === 'checkout') {
                  pageflyANDgempages.withOutOpenCart = 1;
                  return false;
                };
              };

              let customily = d.querySelector('#customily-options .customily-main-app .customily-options-wrapper #cl_optionsapp') || '';
              if (customily) {
                return false;
              };

              /* if(!!window.TPOConfigs){
                var form = this.closest('form') || '';
                var tpo_option = !!form ? form.querySelector('.tpo_option-set-wrapper') || '' : '';
                if(!!tpo_option){
                  return false;
                };
              }; */
              if (window.mrUpsellConfig) {
                if (typeof window.mrUpsellConfig.is_enabled !== 'undefined') {
                  if (!!window.mrUpsellConfig.is_enabled) {
                    if (d.querySelector('button[type="submit"][name="add"][mr-click="true"]')) {
                      e.preventDefault();
                      return false;
                    };
                  };
                };
              };
              e.preventDefault();
              HsApp3.addForm(where, this)
              return false;
            }, false);
          }
        };

      });
    };

    var gemColumn = document.querySelectorAll('.gf_column').length > 0 ? document.querySelectorAll('.gf_column') : [];
    if (gemColumn.length > 0) {
      gemColumn.forEach(function (val) {
        var elementGemPages = val.querySelectorAll(elementAdd).length > 0 ? val.querySelectorAll(elementAdd) : [];
        if (elementGemPages.length > 0) {
          elementGemPages.forEach(function (val) {
            if (!val.classList.contains('hs-event-static')) {
              val.classList.add('hs-event-static');
              val.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                HsApp3.addForm(where, this);
              }, false);
            }
          });
        }
      });
    }

    pageflyANDgempages.quickVIewButton();
  },
  quickVIewButton: function () {
    var parentsButton = document.querySelectorAll('[data-section-type="product-recommendations"],product-quick-add.product--quick-add[data-form="true"]') || [];
    if (parentsButton.length > 0) {
      parentsButton.forEach(parent => {
        let buttonsQuick = parent.querySelectorAll('div.quick-product__btn, button.product--quick-add--button') || [];
        if (buttonsQuick.length > 0) {
          buttonsQuick.forEach(button => {
            if (!button.classList.contains('hs-event')) {
              button.classList.add('hs-event');
              button.addEventListener('click', (e) => {
                setTimeout(function () {
                  pageflyANDgempages.addToCart();
                }, 800);
              });
            };
          });
        };
      });
    };
  },
  addCartPageFly: function () {
    window.addEventListener("load", function (e) {
      try {
        window.__pagefly_helper_store__ &&
          window.__pagefly_helper_store__.subscribe(function (res) {
            var paramsFunction = [
              {
                "name": 'addToCart',
                "attr": {
                  "id": __pagefly_helper_store__.lastATCResult.variant_id,
                  "quantity": 1
                }
              }];
            HsApp1.getMyCart(1, paramsFunction);
          });
      } catch (e) {
        console.warn(e);
      }
    })
  },
  init: function () {
    pageflyANDgempages.addCartPageFly();
  }
}
/* ============== SLIDE CART Pop Up ============== */
var HsApp1 = {
  openSlideCart: `.hs-open-cart-drawer,header a[href$="/cart"].site-header__cart,header .pt-cart .pt-dropdown-toggle,header a[href="/cart"],header a[href$="/cart"],header a[href^="/cart"],header .header--mobile--cart a.header--cart-link,header .header--cart a.header--cart-link,header a[href="#cart"],a[href="#cart"],a[data-cart-toggle],.hs-sticky-cart-cart-drawer,.navigation a[href="/cart"],a[href="/cart"],.tt-desctop-parent-cart,.cart-summary,.header-icon-with-text,.tt-cart,.header-inner #cart,[data-cart-pc],.lin-basket,.cart_container a.icon-bag mini_cart.cart_drawer_toggle,.minicart__button,header .ti-shopping-cart,.my-cart-link-container button.js-slideout-open,.sticky_header header svg#cart-icon-bubble,a[href*=cart].header__icon-wrapper,a[data-node-type="commerce-cart-open-link"],header-root .header--container a.header--cart-count, header-root .header--container .cart-link a,header #headerBorderWrap #headerContainer button#CartButton,header .single-icon.cart a, header-root a.header--cart-link,button[type="button"] svg.father.feather-shopping-cart,.header-wrapper button.header-link.slide-menu-cart,.header__icons .header__icon--cart,header .header_cart#main__cart_item,.site-header_items .group_items .contentsticky_cart .site-header__cart,.stickymenu-item a[data-target="#mobile-blockcart"],header .site-nav__link.cart-link,header a.snl.sni_icon.cart-link,header cart-drawer details.cart-drawer-container,header ul.header-nav_header li.cart-item,header div.header--mobile--cart,.pagefly-container [data-pf-type="Body"] [data-href="/cart"],body header .shopping-cart button.header__cartButton,a[href$="/cart"] [data-picky-cart-button-area],header .container a#cartToggle,header .container a.cartToggle,header .slideout__trigger--open button.slideout__trigger-ajax-cart,body header .wrapper-top-cart a#ToggleDown.icon-cart-arrow,header .container a.header__icon--cart,.halo-sticky-toolbar-mobile li.list-item a[data-cart-sidebar],mobile-dock.mobile-dock .dock__item[data-action='cart'],nav .container a.cart-icon[role="button"],header div.icon_cart a[href$="/cart"],header .header__icons span.buble_icon.buble_icon.header__icon__cart.header__icon,header .header-content a[href="#drawer-cart"][role="button"],.mini-cart-icon a.ltn__utilize-toggle,
    header .container .site-header__link.site-header__cart.cardraw,header#header .header--menu a[href$="#minicart"].minicart--toggle, .site-wrap .header-section #cart button.cart-icon, header-root.header--root .header--cart a.header--cart-toggle,header .site-header__link.site-header__cart .js-toggle-cart.header-cart-text,ul.cart-links__wrapper li.my-cart-link-container button.js-mini-cart-trigger,header span.site-header__cart.cardraw .js-toggle-cart,header .go-cart__trigger,header.header #cart-icon-bubble,header.header button[name="cart-open"]#cart-open, a[href$="#"].por.header__cart-trigger-mobile[data-target="#bt-sidebar-cart"], a[href$="#"].bt-sidebar-btn.cart-sidebar-trigger[data-target="#bt-sidebar-cart"],header [data-new-layout-header] button.new-layout-header__actions-cart, header .cart_canvas .header-cart, .shopify-section #headerBorderWrap #headerContainer button.js-enabled#CartButton, main-header .header-container a.area--cart.icon-button, header #cart-icon-bubble drawer-opener button.button--icon, .header__sidebar .header__icons .header__icons-item  a[href="#cartDrawer"], header .header__icons .header__icons-item  a[href="#cartDrawer"], #header header a.hdicon.header-cart, header#header nav-header ul.header-nav-item-menu li.nav-cart-button drawer-button, header header-element nav a.header--cart[data-drawer-view="cart-drawer"], .header-sticky-wrapper #HeaderWrapper header#SiteHeader a[aria-controls="CartDrawer"], header a[data-drawer-toggle="drawer-cart"],header header-actions cart-drawer-component button.button.header-actions__action,header #sticky-header.main-menu-area .container .header-right ul li.cart-icon,header height-calc header-component nav ul li button.js-element[drawer-to-open="cart-drawer"], header .header-container .header-content .header-cart a[href].cart-icon, main-header.site-header a[data-js-sidebar-handle].mobile-cart-button, body header .container-fluid .row-header span.site-header__link.site-header__cart, #shopify-section-header s-header.site-header ul li ul li button[js-open-cart], side-drawer-opener .header__icon.header__icon--cart.cart-icon--drawer, .toolbar-cart.header_cart a.cart.dropdown-link ${typeof window.Shopify !== 'undefined' ? typeof window.Shopify.routes !== 'undefined' ? typeof window.Shopify.routes.root !== 'undefined' ? `,a[href="${window.Shopify.routes.root}cart"],a[href="${window.Shopify.routes.root}cart "]` : '' : '' : ''}`,//CAMBIO
  iconRemoveSlideCart: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="12px" height="12px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>',
  iconCloseSlideCart: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="12px" height="12px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>',
  svgAddNote: '<svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M257,0C116.39,0,0,114.39,0,255s116.39,257,257,257s255-116.39,255-257S397.61,0,257,0z M392,285H287v107    c0,16.54-13.47,30-30,30c-16.54,0-30-13.46-30-30V285H120c-16.54,0-30-13.46-30-30c0-16.54,13.46-30,30-30h107V120    c0-16.54,13.46-30,30-30c16.53,0,30,13.46,30,30v105h105c16.53,0,30,13.46,30,30S408.53,285,392,285z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  svgCloseNote: '<svg xmlns="http://www.w3.org/2000/svg" height="15px" width="15px" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M257,0C116.39,0,0,114.39,0,255s116.39,257,257,257s255-116.39,255-257S397.61,0,257,0z M383.22,338.79    c11.7,11.7,11.7,30.73,0,42.44c-11.61,11.6-30.64,11.79-42.44,0L257,297.42l-85.79,83.82c-11.7,11.7-30.73,11.7-42.44,0    c-11.7-11.7-11.7-30.73,0-42.44l83.8-83.8l-83.8-83.8c-11.7-11.71-11.7-30.74,0-42.44c11.71-11.7,30.74-11.7,42.44,0L257,212.58    l83.78-83.82c11.68-11.68,30.71-11.72,42.44,0c11.7,11.7,11.7,30.73,0,42.44l-83.8,83.8L383.22,338.79z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  cart_currency_cookie: '',
  cartPrice: 0,
  cartComparePrice: 0,
  priceGiftWrap: 0,
  comparePriceGiftWrap: 0,
  cartPriceDiscount: 0,
  arr_rewards: [],
  popUpProduct: [],
  arr_variants: [],
  arr_variants_popup: [],
  rewardsIndex: null,
  checkoutPage: '',
  updateQuantityFocus: function (snapshot) {
    try {
      //if (!snapshot) return;

      const cartDrawerWrapper = document.querySelector('.hs-popup-cart-sp-load.hs-active') || '';
      if (!cartDrawerWrapper) return false;

      const lineItem =
        document.querySelector(`.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-cart-plus-minus[data-line="${snapshot?.line}"]`) || '';
      if (lineItem && lineItem.querySelector(`[data-name="${snapshot?.name}"]`)) {
        cartDrawerWrapper
          ? Hs_CartDrawer.trapFocus(cartDrawerWrapper, lineItem.querySelector(`[data-name="${snapshot?.name}"]`))
          : lineItem.querySelector(`[data-name="${snapshot?.name}"]`).focus();
      } else if (window?.HSSLIDECART?.CART?.item_count === 0 && cartDrawerWrapper) {
        Hs_CartDrawer.trapFocus(cartDrawerWrapper, cartDrawerWrapper.querySelector('.hs-site-cart-popup-layout'));
      } else if (cartDrawerWrapper.querySelector('.hs-item-cart-content') && cartDrawerWrapper) {
        Hs_CartDrawer.trapFocus(cartDrawerWrapper, cartDrawerWrapper.querySelector('.hs-item-cart-content'));
      }
    } catch (error) {

    }
  },
  extraFunction: function () {
    function notUndefined(variable = undefined) {
      return typeof variable !== 'undefined' && typeof variable === 'function';
    }
    try {
      if (notUndefined(window.pdsHandler)) {
        window.pdsHandler();
      };
    } catch (error) {
      console.log(error)
    };
  },
  rewardsExcludeProd: function (cart) {
    //slideData.settings.rewards.rewards_bar_no_dscto => 1 precio sin descuento , 0 precio con descuento
    let price_rewards = cart.total_price, rewards_with_dscto = 1;

    if (typeof slideData.settings.rewards.rewards_bar_no_dscto !== 'undefined') {
      if (!!slideData.settings.rewards.rewards_bar_no_dscto) {//SIN DESCUENTO
        price_rewards = cart.original_total_price;
        rewards_with_dscto = 0;
      }
    };

    try {
      if (typeof cart === 'object') {
        if (cart.items) {
          let sumaTotalHidden = 0, sumaTotalItems = 0, dsctoTotalProd = 0;
          let items = cart.items.filter(x => x.product_type.indexOf('rewards_product_hidden') < 0) || [];
          let items_hidden = cart.items.filter(x => x.product_type.indexOf('rewards_product_hidden') > -1) || [];

          let sumTotal = (array) => array.reduce((total, item) => {
            let price = !rewards_with_dscto ? item.original_line_price : item.line_price;
            return total + price;
          }, 0);

          if (items_hidden.length > 0) {
            sumaTotalHidden = sumTotal(items_hidden);
          };

          if (items.length > 0) {
            sumaTotalItems = sumTotal(items);
          };

          if (!!rewards_with_dscto) {
            let dsctoCheckout = HsApp1.checkoutPage || '';
            if (dsctoCheckout) {
              let dsctoItems = dsctoCheckout.line_items || [];
              if (dsctoItems.length > 0) {
                let variants_ids = items_hidden.map(item => { return item.variant_id; }) || [];
                let items_dscto = dsctoItems.filter(item => !variants_ids.includes(item.variant_id)) || [];
                if (items_dscto.length > 0) {
                  var count_dscto_allocations = 0;
                  items_dscto.forEach(function (item_dscto) {
                    let dscto_allocations = item_dscto.discount_allocations || [];
                    if (dscto_allocations.length > 0) {
                      dscto_allocations.forEach(function (dscto, index) {
                        count_dscto_allocations++;
                        var dsctoProd = parseInt(parseFloat(dscto.amount * 100).toFixed(2));
                        /*if (!Hs_CartDrawer.typePrice) {
                          dsctoProd = dsctoProd / item_dscto.quantity;
                        };*/
                        dsctoTotalProd = dsctoTotalProd + dsctoProd;
                      });
                    };
                  });

                };
              };
            };
          };

          if (dsctoTotalProd > 0) {
            sumaTotalItems = cart.original_total_price - dsctoTotalProd;
          };
          price_rewards = sumaTotalItems;
        };
      };
    } catch (error) {
      console.log(error);
    };
    return price_rewards;
  },
  rechargeCartElement: function () {
    let rechargeCartButton = document.querySelectorAll('.hs-subscription-upgrade-button') || [];
    if (rechargeCartButton.length > 0) {
      rechargeCartButton.forEach(function (button_recharge) {
        if (!button_recharge.classList.contains('hs-event-static')) {
          button_recharge.classList.add('hs-event-static');
          button_recharge.addEventListener('click', function (e) {
            e.preventDefault();
            var this_data = new FormData();
            let qty = button_recharge.getAttribute('quantity') || '';
            let key = button_recharge.getAttribute('key') || '';
            let selling_plan = button_recharge.getAttribute('selling_plan') || '';
            if (qty && key && selling_plan) {
              /* let tbyb = window.pltbyb || {};
              tbyb = tbyb.dataSellingPlan || {};
              if(Object.keys(tbyb).length > 0){
                let tbyb_amount = tbyb.amount || '';
                let tbyb_app_name = tbyb.app_name || '';
                let tbyb_selling_plan_id = tbyb.selling_plan_id || '';
                let tbyb_type = tbyb.type || '';
                if(tbyb_selling_plan_id){
                  if(tbyb_selling_plan_id == +(selling_plan)){
                    if(tbyb_amount){
                      this_data.append("properties[_mml_amount]", tbyb_amount);
                    };
                    if(tbyb_app_name){
                      this_data.append("properties[_mml_TBYB]", tbyb_app_name);
                    };
                    if(tbyb_type){
                      this_data.append("properties[_mml_type]", tbyb_type);
                    };
                  };
                };
              }; 
              window.pltbyb.dataSellingPlan*/
              //this_data.append("properties[__hsSubscriptionUpgrade]", true);

              this_data.append("quantity", qty);
              this_data.append("key", key);
              this_data.append("id", key);
              this_data.append("selling_plan", selling_plan);

              this.disabled = true

              var span_button = button_recharge.querySelector('.hs-upgrade-charge') || '';
              if (span_button) {
                span_button.innerHTML = `${Hs_CartDrawer.upgrade_text}...`;
              };

              //this_data = JSON.stringify(this_data);
              HsApp1.onloadCart('', this_data, 0);
            };
          });
        };
      });
    };

    let rechargeCartSelect = document.querySelectorAll('.hs-subscription-change-plan') || [];
    if (rechargeCartSelect.length > 0) {
      rechargeCartSelect.forEach(function (select_recharge) {
        if (!select_recharge.classList.contains('hs-event-static')) {
          select_recharge.classList.add('hs-event-static');
          select_recharge.addEventListener('change', function (e) {
            e.preventDefault();
            let qty = select_recharge.getAttribute('quantity') || '';
            let key = select_recharge.getAttribute('key') || '';
            let selling_plan_selected = select_recharge.getAttribute('selling_plan') || '';
            let selling_plan = select_recharge.value || '';
            if (selling_plan_selected && key && selling_plan) {
              if (selling_plan !== selling_plan_selected) {
                var this_data = new FormData();

                if (selling_plan === 'onetime') {
                  //this_data.append("properties[__hsSubscriptionUpgrade]", false);
                  selling_plan = '';
                  var parent = select_recharge.parentNode || '';
                  if (parent && parent.classList.contains('hs-subscription-upgrade-section')) {
                    parent.innerHTML = `<button class="hs-subscription-upgrade-button" disabled><span class="hs-upgrade-charge">${Hs_CartDrawer.downgrade_text}</span></button>`
                  };
                } else {
                  //this_data.append("properties[__hsSubscriptionUpgrade]", true);
                };

                this_data.append("quantity", qty);
                this_data.append("key", key);
                this_data.append("id", key);
                this_data.append("selling_plan", selling_plan);

                this_data = Hs_CartDrawer.propertiesSubscription(this_data);
                //this_data = JSON.stringify(this_data);
                HsApp1.onloadCart('', this_data, 0);
              };
            };
          });
        };
      });
    };
  },
  revyDiscountCheckout: function (discount_code) {
    /* REVYBUNDLE */
    if (window.RevyBundle) {
      if (window.RevyBundle.api) {
        if (typeof window.RevyBundle.api.checkoutRedirectReplacer !== 'undefined') {
          if (discount_code) {
            window.RevyBundle.api.checkoutRedirectReplacer = function (discount_code) {
              try {
                var button_load = document.querySelector('.hs-content-checkout-button') || '';
                if (!button_load) {
                  button_load = document.createElement('button')
                };
                HsApp1.buttonCheckout(button_load);
                return false;
              } catch (error) {
                console.log(error)
              }
            };
          } else {
            window.RevyBundle.api.checkoutRedirectReplacer = null;
          }
        };
      };
    };
  },
  progressCircleDesing: function () {
    if (!Hs_CartDrawer.tfi_lock_method) {
      return false;
    };
    var count_qualified = 0, count_hide = 0, text_unlock = '';
    slideData.settings.tiered_free_items_tiers.forEach(function (tier) {
      var tier_hide_in_cart = 0;
      try {
        if (typeof slideData.settings.tiered_free_items.tif_auto_add !== 'undefined') {
          if (!!slideData.settings.tiered_free_items.tif_auto_add) {
            tier_hide_in_cart = typeof tier.tfi_tier_hide_in_cart !== 'undefined' ? tier.tfi_tier_hide_in_cart : 0;
          };
        };
      } catch (error) {
        console.log(error)
      }
      if (!tier_hide_in_cart) {
        !!tier.qualified && count_qualified++;
        text_unlock === '' ? typeof tier.text_unlock !== 'undefined' ? text_unlock = tier.text_unlock : '' : '';
      } else {
        count_hide++;
      }
    });
    if (!!document.querySelector('.hs-locked-progress')) {
      if (!document.querySelector('.hs-locked-progress circle')) {
        var val_max = slideData.settings.tiered_free_items_tiers.length - count_hide;
        var options = { max: val_max, value: count_qualified, textFormat: 'horizontal' };
        var exampleEl = document.querySelector('.hs-content-circle');
        new CircleProgress(exampleEl.querySelector('.hs-content-progress'), options);
      } else {
        document.querySelector('.hs-locked-progress .hs-content-progress').circleProgress.value = count_qualified;
      };
    }
    document.querySelector('.hs-tiered-text p').innerHTML = text_unlock;
    HsApp1.currencyConverter();
  },
  checkoutContent: function (response) {
    if (response.line_items.length > 0) {
      var elementsProperties = ['_giftWrap', '_shippingProtection'], ini = 0, json = {};
      json.items = response.line_items, json.discount_code = response.discount_code, json.value_type = response.applied_discounts[0].value_type, json.amount = response.applied_discounts[0].amount;
      if (elementsProperties.length > 0) {
        elementsProperties.forEach(function (element) {
          ini++
          json = HsApp1.thisProperties(json, element);
        })
      };
      if (ini == elementsProperties.length) {
        var itemsElement = document.querySelectorAll('.hs-item-cart-content').length > 0 ? document.querySelectorAll('.hs-item-cart-content') : [];
        if ((itemsElement.length > 0 && json.items.length > 0) && (itemsElement.length == json.items.length)) {
          var item = json.items;
          itemsElement.forEach(function (element, indexElement) {
            var indexItem = item[indexElement];
            var variant_id = indexItem.variant_id,
              quantity = indexItem.quantity,
              price = (Hs_CartDrawer.typePrice ? indexItem.line_price : indexItem.price) * 100,
              compare_at_price = indexItem.compare_at_price ? indexItem.compare_at_price * 100 : 0;

            compare_at_price = Hs_CartDrawer.typePrice ? compare_at_price * quantity : compare_at_price;

            var hs_cart_content_price = element.querySelector('.hs-cart-content-price') || '';
            var hs_save_product = hs_cart_content_price ? hs_cart_content_price.querySelector('.hs-save-product') : '';
            var hs_discount_item = hs_cart_content_price ? hs_cart_content_price.querySelector('.hs-discount-item') : '';

            if (!!element.classList.contains(`hs-product-${variant_id}`)) {

              var dscto_allocations = indexItem.discount_allocations;
              var dsctos_automatic = dscto_allocations.filter(x => x.application_type === 'automatic');

              if (indexItem.discount_allocations.length > 0) {

                var priceProd = parseInt(parseFloat(indexItem.price * 100).toFixed(2));
                var dsctosProdText = '', dsctoTotalProd = 0;
                var count_dscto_allocations = 0;

                if (!!Hs_CartDrawer.typePrice) {
                  priceProd = priceProd * quantity;
                };


                for (let t = 0; t < dscto_allocations.length; t++) {
                  count_dscto_allocations++;
                  var discount_class = dscto_allocations[t].discount_class.toLowerCase();
                  if (!Hs_CartDrawer.discount_order_x_item ? discount_class === 'product' : (discount_class === 'product' || discount_class === 'order')) {
                    //if (dscto.discount_class.toLowerCase() === 'product') {
                    var dsctoProd = parseInt(parseFloat(dscto_allocations[t].amount * 100).toFixed(2));
                    var dscto_descp = dscto_allocations[t].description;

                    if (!Hs_CartDrawer.typePrice) {
                      dsctoProd = dsctoProd / quantity;
                    };
                    dsctoTotalProd = dsctoTotalProd + dsctoProd;
                    let discount_amount = " (-" + hsonslidecart.Currency.formatMoney(dsctoProd, slideData.settings.devices.money_format) + ")";
                    if (!Hs_CartDrawer.show_base_price_discount || Hs_CartDrawer.showSaveItem) {
                      discount_amount = '';
                    };

                    var dsctoTag = dsctoProd > 0 ? dscto_descp + discount_amount : dscto_descp;
                    dsctoTag = !!Hs_CartDrawer.hidenDiscount ? dscto_descp : dsctoTag;
                    dsctosProdText = dsctosProdText.concat(`
                          <div class="hs-discount-promo">
                            <div class='hs-reduction-code'>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" class="hs-reduction-code-item"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path></svg>
                              <span class="hs-code-text">${dsctoTag}</span>
                            </div>
                          </div>
                          `);
                  };

                  if (count_dscto_allocations == dscto_allocations.length) {

                    if (indexItem.properties?._mml_TBYB && indexItem.properties._mml_amount !== undefined && indexItem.properties._mml_type !== undefined) {
                      var mmlAmount = indexItem.properties._mml_amount;
                      const mmlTBYB = indexItem.properties._mml_TBYB;
                      const mmlType = indexItem.properties._mml_type;
                      if (mmlTBYB === 'Marshmalloo') {
                        if (!isNaN(mmlAmount)) {
                          switch (mmlType) {
                            case 'fixed-amount':
                              mmlAmount = mmlAmount * 100;
                              let amount_fix = mmlAmount * indexItem.quantity < parseInt(parseFloat(indexItem.line_price * 100).toFixed(2)) ? mmlAmount * indexItem.quantity : parseInt(parseFloat(indexItem.line_price * 100).toFixed(2));
                              if (Hs_CartDrawer.typePrice) {
                                priceProd = amount_fix;
                              } else {
                                priceProd = amount_fix / indexItem.quantity;
                              };
                              dsctoTotalProd = 0;
                              break;
                            case 'percentage':
                              let amount = (mmlAmount * parseInt(parseFloat(indexItem.line_price * 100).toFixed(2))) / 100;

                              if (Hs_CartDrawer.typePrice) {
                                priceProd = amount;
                              } else {
                                priceProd = amount / indexItem.quantity;
                              };
                              dsctoTotalProd = 0;
                              break;
                          };
                        };
                      };
                    };


                    var totalDscto = priceProd - dsctoTotalProd;
                    let totalDsctoHtml = '';
                    let saveProduct = '';

                    if (totalDscto <= 0) {
                      totalDsctoHtml = Hs_CartDrawer.languageFree !== '' ? Hs_CartDrawer.languageFree : hsonslidecart.Currency.formatMoney(totalDscto, slideData.settings.devices.money_format);
                    } else {
                      totalDsctoHtml = hsonslidecart.Currency.formatMoney(totalDscto, slideData.settings.devices.money_format);
                    };

                    if (!!slideData.settings.additional_settings.show_compare_price) {
                      if (compare_at_price > price) {
                        if (Hs_CartDrawer.showSaveItem) {
                          saveProduct = `(Save ${hsonslidecart.Currency.formatMoney(compare_at_price - price, slideData.settings.devices.money_format)})`;
                          try {
                            saveProduct = slideData.settings.language_settings.discount_savings_language_settings.replace('{{money}}', hsonslidecart.Currency.formatMoney(compare_at_price - price, slideData.settings.devices.money_format))
                          } catch (error) {
                          }
                          saveProduct = `<span class = 'hs-save-item-text'>${saveProduct}</span>`;
                        };
                      };
                    };

                    if (!!hs_cart_content_price) {
                      var hs_price_total = hs_cart_content_price.querySelector('.hs-price-total') || '';
                      var hs_discount_price_total = hs_cart_content_price.querySelector('.hs-discount-price-total') || '';

                      var hs_save_item_text = hs_cart_content_price.querySelector('.hs-save-item-text') || '';

                      if (!!hs_discount_price_total) {
                        hs_discount_price_total.remove();
                      };


                      if (!!element.classList.contains('hs-cls-discount')) {
                        element.classList.remove('hs-cls-discount');
                        var cart_content_price = element.querySelector('.hs-cart-content-price');
                        if (!!cart_content_price) {
                          let active_sale = '';
                          var hs_compare_price = cart_content_price.querySelector('input.hs_compare_price') || '';
                          var hs_compare_at_price = cart_content_price.querySelector('.hs-compare-at-price') || '';
                          var hs_price_total = cart_content_price.querySelector('.hs-price-total') || '';
                          if (!!slideData.settings.additional_settings.show_compare_price) {
                            if (compare_at_price > price) {
                              active_sale = 'hs-active-sale-price';
                              if (hs_compare_price) {
                                hs_compare_price.value = compare_at_price;
                              };
                              if (hs_compare_at_price) {
                                hs_compare_at_price.innerHTML = hsonslidecart.Currency.formatMoney(compare_at_price, slideData.settings.devices.money_format);
                              };
                            } else {
                              hs_compare_at_price.classList.add('hs-hidden-compare');
                            }
                          };

                          if (!!hs_price_total) {
                            if (price == 0) {
                              price = Hs_CartDrawer.languageFree !== '' ? Hs_CartDrawer.languageFree : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
                            } else {
                              price = hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
                            };
                          };
                          active_sale ? hs_price_total.classList.add(active_sale) : '';
                          hs_price_total.innerHTML = price;
                          if (!!hs_price_total.classList.contains('hs-discount-price-line-through')) {
                            hs_price_total.classList.remove('hs-discount-price-line-through')
                          };
                        };
                      };

                      if (!!hs_price_total) {
                        if (dsctosProdText !== '') {
                          if (dsctoTotalProd > 0) {
                            element.classList.add('hs-cls-discount')
                            hs_price_total.classList.add('hs-discount-price-line-through');
                            hs_price_total.classList.remove('hs-active-sale-price');
                            if (!Hs_CartDrawer.show_base_price_discount) {
                              let compare_price = 0;
                              let variant_select = '';
                              if (window.localStorage) {
                                let product_storage = JSON.parse(localStorage.getItem("_hsproducts")) || [];
                                if (product_storage.length > 0) {
                                  product_storage = product_storage.find(prod_storage => prod_storage.id == indexItem.product_id) || '';
                                  variant_select = product_storage.variants ? product_storage.variants.find(variant => variant.id == indexItem.variant_id) : '';
                                };
                              };
                              if (variant_select) {
                                compare_price = (variant_select.compare_at_price || 0) * indexItem.quantity;
                                if (typeof indexItem.selling_plan_id !== 'undefined') {
                                  compare_price = Math.max(compare_at_price, compare_price);
                                };
                                if (compare_price > 0) {
                                  priceProd = compare_price > priceProd ? compare_price : priceProd;
                                };
                              };
                            };
                          };
                          if (priceProd > totalDscto) {
                            if (Hs_CartDrawer.showSaveItem) {
                              saveProduct = `(Save ${hsonslidecart.Currency.formatMoney(priceProd - totalDscto, slideData.settings.devices.money_format)})`;
                              try {
                                saveProduct = slideData.settings.language_settings.discount_savings_language_settings.replace('{{money}}', hsonslidecart.Currency.formatMoney(priceProd - totalDscto, slideData.settings.devices.money_format))
                              } catch (error) {
                              }
                              saveProduct = `<span class = 'hs-save-item-text'>${saveProduct}</span>`;
                            };
                          };
                          hs_price_total.innerHTML = hsonslidecart.Currency.formatMoney(priceProd, slideData.settings.devices.money_format);

                          /* if (!!hs_save_item_text) {
                            hs_save_item_text.remove();
                          };
 
                          if (!!hs_save_product) {
                            hs_save_product.remove();
                          }; */
                          var hs_cart_item_prices_row = hs_cart_content_price.querySelector('.hs-cart-item-prices-row') || '';
                          if (hs_cart_item_prices_row) {
                            hs_cart_item_prices_row.insertAdjacentHTML('beforeend', `
                                <span class="hs-discount-price-total hs-variant-${variant_id}-discount-price-total ${!!Hs_CartDrawer.customize_popUp_sale_price ? ' hs-active-sale-price' : ''} hs-desktop">
                                ${totalDsctoHtml}
                                </span>
                                `);
                          };

                          /* hs_cart_content_price.insertAdjacentHTML('beforeend', `
                            <div class="hs-save-product">
                            ${saveProduct}
                            </div>
                            ${dsctosProdText}
                            `); */
                        } /* else {
                            if (Hs_CartDrawer.showSaveItem) {
                              if (hs_save_product) {
                                if (saveProduct) {
                                  hs_save_product.innerHTML = saveProduct;
                                }
                              };
                            };
                          } */
                      };
                    };
                    hs_save_product && (hs_save_product.innerHTML = saveProduct);
                    if (+response.total_discount_amount > 0) {
                      hs_discount_item && (hs_discount_item.innerHTML = dsctosProdText);
                    };
                  };
                };

              } else {
                /* COMMENT NOT MOVE */
                if (!!element.classList.contains('hs-cls-discount')) {
                  element.classList.remove('hs-cls-discount');

                  var cart_content_price = element.querySelector('.hs-cart-content-price')
                  if (!!cart_content_price) {
                    var hs_price_total = cart_content_price.querySelector('.hs-price-total') || '',
                      hs_compare_at_price = cart_content_price.querySelector('.hs-compare-at-price') || '',
                      hs_discount_promo = cart_content_price.querySelector('.hs-discount-promo') || '',
                      hs_save_item_text = cart_content_price.querySelector('.hs-save-item-text') || '';
                    if (!!hs_price_total) {
                      hs_price_total.innerHTML = hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
                      if (!!hs_price_total.classList.contains('hs-discount-price-line-through')) {
                        hs_price_total.classList.remove('hs-discount-price-line-through')
                      };
                    };
                    if (hs_compare_at_price && slideData.settings.additional_settings.show_compare_price) {
                      if (compare_at_price > price) {
                        if (!!Hs_CartDrawer.customize_body_sale_price) {
                          hs_price_total.classList.add('hs-active-sale-price');
                        };
                        hs_compare_at_price.classList.remove('hs-hidden-compare');
                        hs_compare_at_price.innerHTML = hsonslidecart.Currency.formatMoney(compare_at_price, slideData.settings.devices.money_format);
                      } else {
                        hs_price_total.classList.remove('hs-active-sale-price');
                        hs_compare_at_price.classList.add('hs-hidden-compare');
                        hs_compare_at_price.innerHTML = '';
                      }
                    };

                    hs_discount_item && (hs_discount_item.innerHTML = '');
                    hs_save_product && (hs_save_product.innerHTML = '');
                  };
                };
              };
            };

          });
        };
      };
    };
  },
  sizeSlide: function () {
    var size = 440;
    if (typeof slideData.customize !== 'undefined') {
      if (typeof slideData.customize.customize_slidecart_size !== 'undefined') {
        size = slideData.customize.customize_slidecart_size;
      };
      if (size == 450) {
        size = 440;
      };
    };
    return size;
  },
  currencyConverter: function () {
    try {
      var cb_widget_currency = !!document.querySelector('#cb-widget-currency') ? !!document.querySelector('#cb-widget-currency') : '';
      if (!!cb_widget_currency) {
        if (typeof window.conversionBearAutoCurrencyConverter !== 'undefined') {
          if (typeof window.conversionBearAutoCurrencyConverter.convertPricesOnPage !== 'undefined') {
            window.conversionBearAutoCurrencyConverter.convertPricesOnPage();
          };
        };
      };

      var doubly_float = !!document.querySelector('.doubly-float') ? document.querySelector('.doubly-float') : '';
      var doubly_wrapper = !!document.querySelector('.doubly-wrapper') ? document.querySelector('.doubly-wrapper') : '';
      if (!doubly_float && !!doubly_wrapper) {
        doubly_float = doubly_wrapper;
      };
      if (!!doubly_float) {
        var currentCurrency = typeof window.DoublyGlobalCurrency !== 'undefined' ? typeof window.DoublyGlobalCurrency.currentCurrency !== 'undefined' ? window.DoublyGlobalCurrency.currentCurrency : '' : '';
        if (!!currentCurrency) {
          const currency_switcher = doubly_float.querySelector('.currency-switcher') || doubly_float.querySelector('.currency-switcher-btn.selected') || '';
          if (currency_switcher) {
            if (currency_switcher.tagName.toLowerCase() === 'select') {
              currency_switcher.value = '';
              currency_switcher.value = currentCurrency;
              var ev = new Event("change", { "bubbles": true, "cancelable": false });
              currency_switcher.dispatchEvent(ev);
            } else if (currency_switcher.tagName.toLowerCase() === 'button') {
              currency_switcher.click();
            };
          };
        };
      };

      var pick_currency = !!document.querySelector('.pick_currency') ? document.querySelector('.pick_currency') : '';
      if (!!pick_currency) {
        var select_change = !!pick_currency.querySelector('#currencies') ? pick_currency.querySelector('#currencies') : '';
        var select = !!pick_currency.querySelector('.nice-select') ? pick_currency.querySelector('.nice-select') : '';
        if (!!select) {
          var list = !!select.querySelector('ul.list') ? select.querySelector('ul.list') : '';
          if (!!list) {
            var selected = !!list.querySelector('li.selected') ? list.querySelector('li.selected') : '';
            if (!!selected) {
              var value = !!selected.dataset.value ? selected.dataset.value : '';
              if (window.shopify_supported_currencies !== 'undefined') {
                var cart_currency = 0;
                if (HsApp1.readCookie('cart_currency') !== '' && HsApp1.readCookie('acscurrency') !== '') {
                  if (HsApp1.readCookie('cart_currency') !== HsApp1.readCookie('acscurrency')) {
                    cart_currency = 1;
                  };
                };
                if (window.shopify_supported_currencies.length <= 4 || !!cart_currency) {
                  if (typeof window.mlvedaload === 'function') {
                    mlvedaload()
                  };
                };

              };

            }
          }
        };
        //pick_currency.classList.remove('open');
      };

      var select_currencies = !!document.querySelector('select.currencies') ? document.querySelector('select.currencies') : '';
      if (!!select_currencies) {
        var top_bar = !!select_currencies.querySelector('.top_bar [data-currency-converter]') ? select_currencies.querySelector('.top_bar [data-currency-converter]') : '';
        if (!!top_bar) {
          var ev = new Event("click", { "bubbles": true, "cancelable": false });
          top_bar.dispatchEvent(ev);
        }
      };

      /* BUCKS Currency Converter PRO++ */
      if (typeof window.bucksCC !== 'undefined') {
        var buckscc_currency_wrapper = document.querySelector('.buckscc-currency-wrapper') || '';
        if (buckscc_currency_wrapper) {
          ((window || {}).bucksCC || {}).reConvert && bucksCC.reConvert();
        };
      };

      if (!!document.querySelector('select.currency-picker')) {
        var currency_active = document.querySelector('select.currency-picker')?.value || '';
        if (currency_active) {
          if (!!Shopify) {
            if (!!Shopify.currency) {
              if (!!Shopify.currency.active) {
                currency_active = Shopify.currency.active;
              };
            };
          };
          if (document.querySelector('select.currency-picker').value !== currency_active) {
            var ev = new Event("change", { "bubbles": true, "cancelable": false });
            document.querySelector('select.currency-picker').dispatchEvent(ev);
          };
        }
      };

      /* Nova: Multi Currency Converter */
      if (typeof window?.baCurr !== 'undefined') {
        if (typeof window?.baCurr?.config !== 'undefined') {
          if (window?.baCurr?.config?.enabled !== 'undefined') {
            if (typeof window?.baCurr?.config?.multi_curr !== 'undefined') {
              if (window?.baCurr?.config?.multi_curr.length <= 1) {
                var id_selected = '', currMovers = '';
                var bacurr_cur_block = !!document.querySelector('.bacurr-cur-block') ? document.querySelector('.bacurr-cur-block') : '';
                if (!!bacurr_cur_block) {
                  var ba_chosen = !!bacurr_cur_block.querySelector('.ba-chosen') ? bacurr_cur_block.querySelector('.ba-chosen') : '';
                  if (!!ba_chosen) {
                    id_selected = ba_chosen.innerHTML;
                  };
                  var bacurr_dropdown_choices = !!bacurr_cur_block.querySelector('.bacurr-dropdown-choices') ? bacurr_cur_block.querySelector('.bacurr-dropdown-choices') : '';
                  if (!!bacurr_dropdown_choices && !!id_selected) {
                    currMovers = !!bacurr_dropdown_choices.querySelector(`.currMovers#${id_selected}`) ? bacurr_dropdown_choices.querySelector(`.currMovers#${id_selected}`) : '';
                  };
                  if (!!currMovers) {
                    var evt = new CustomEvent("click", ['foo', 'bar']);
                    currMovers.dispatchEvent(evt);
                  };
                };
              };
            };
          };
        };
      };
    } catch (error) {
      console.log(error)
    }
  },
  moneyDscto: function (text, currency) {
    if (!!text && !!currency) {
      var i = text.indexOf(currency);
      var x = text.indexOf(')');
      var y = currency.length;
      var price = text.slice(i + y, x);
      price = Math.round(+price * 100);
      return price;
    }
  },
  getCartOrder: function (giftWrapType) {
    var cart = Hs_CartDrawer.routeLocale(`cart.js`), checkoutPage = 0;
    fetch(`${cart}`,
      {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then((json) => {
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          json = window.BOLD.common.cartDoctor.fix(json);
        }
        if (json) {
          if (giftWrapType === 'custom') {
            json.giftWrapType = 'custom';
          }
          else {
            json.giftWrapType = 'specific';
          };

          var data_dscto = {}, arr_dsctos = [], prod_dscto = 0, totalPriceCheckout = [], discountTitleCheckout = !!HsApp1.readCookie('hscodediscount') ? HsApp1.readCookie('hscodediscount').toUpperCase() : '', currency = '';
          if (HsApp1.checkoutPage !== '') {
            data_dscto = HsApp1.checkoutPage;
            //CODE DSCTO FOR ALL PRODUCTS
            /* PERCENTAGE */
            var applied_dscto = '';
            if (typeof data_dscto.applied_discounts === 'object') {
              if (data_dscto.applied_discounts.length > 0) {
                applied_dscto = data_dscto.applied_discounts[0];
                if (!!applied_dscto.discount_class && !!applied_dscto.value_type) {
                  if (applied_dscto.discount_class === "ORDER") {
                    if (!!applied_dscto.amount && !!applied_dscto.value && !!applied_dscto.value_type) {
                      totalPriceCheckout = [{
                        amount: applied_dscto.value_type === "percentage" ? +applied_dscto.value : +applied_dscto.amount,
                        description: applied_dscto.description !== null ? applied_dscto.description : "",
                        title: applied_dscto.title !== null ? applied_dscto.title : "",
                        value: +applied_dscto.value,
                        valueType: applied_dscto.value_type.toUpperCase()
                      }];
                    };
                  };
                };
              };
            };
            /* FIXED AMOUNT */
            //END CODE DSCTO FOR ALL PRODUCTS
            /* return false */

            //CODE DSCTO FOR SPECIFIC PRODUCTS
            if (totalPriceCheckout.length < 1) {
              if (!!data_dscto.currency) {
                currency = data_dscto.currency;//STORE CURRENCY
              };
              //CREATE ARRAY WITH PRICE DSCTO PRODUCTS
              if (data_dscto.line_items.length > 0) {
                data_dscto.line_items.forEach(function (item) {
                  var variantId = item.variant_id, amount = 0, title = '';
                  if (item.discount_allocations.length > 0) {
                    dsctoPrice = parseFloat(item.discount_allocations[0].amount).toFixed(2) * 1;
                    if (dsctoPrice > 0) {
                      amount = parseInt(dsctoPrice * 100), title = discountTitleCheckout;
                    };
                  };
                  arr_dsctos.push({ variantId: variantId, amount: (amount / window.Shopify.currency.rate).toFixed(2), title: title })
                });
              };
            };
          };

          var identify = 3, discountTarget = '';
          if (json.items.length > 0) {
            if (json.cart_level_discount_applications.length > 0)//DISCOUNT AUTOMATIC ALL PRODUCTOS
            {
              identify = 0;
              discountTarget = json.cart_level_discount_applications[0];
            };
            if (totalPriceCheckout.length > 0) {
              identify = 1;
            };
            if (arr_dsctos.length > 0) {
              identify = 2;
            };
          };
          switch (identify) {
            case 0:
              var discountTitle = discountTarget.title,
                discountValue_type = discountTarget.value_type.toUpperCase().replace('"', ''),
                discountValue = parseFloat(discountTarget.value).toFixed(2);
              json.hs_discount = [{ amount: discountValue, description: discountTitle, title: discountTitle, value: discountValue, valueType: discountValue_type }]
              break;
            case 1:/*  */
              json.hs_discount_checkout = totalPriceCheckout;
              break;
            case 2:
              var items = json.items;
              if (items.length > 0) {
                items.forEach(function (x, index) {
                  if (x.id == arr_dsctos[index].variantId) {
                    var amount = Math.round(arr_dsctos[index].amount / x.quantity);
                    x.discounts = [{ amount: amount, title: arr_dsctos[index].title }]
                  };
                });
              };
              break;
            case 3:
              var items = json.items;
              if (items.length > 0) {
                items.forEach(function (x, index) {
                  if (x.discounts.length > 0) {
                    x.discounts[0].amount = +((x.discounts[0].amount / 100) / window.Shopify.currency.rate).toFixed(2) * 1000;
                  }
                });
              };
              break;
          };
          if (json.giftWrapType === 'specific') {
            var variantId = parseInt(HsApp1.readCookie('hs-giftWrap-variantId'));
            json.items.push({ discounts: [], quantity: 1, variant_id: variantId })
          };
        };
        if (json.note === null) {
          json.note = '';//hacemos lo que se requiera en caso de que la variable contenga null   
        };
        json.country = typeof window.Shopify !== 'undefined' ? typeof window.Shopify.country !== 'undefined' ? window.Shopify.country : "" : "";

        if (HsApp1.checkoutPage !== '') {
          var dataChk = HsApp1.checkoutPage;
          if (!!dataChk.line_items && dataChk.line_items.length > 0) {
            if (dataChk.line_items.length > json.items.length) {
              checkoutPage = 1;
              var line_items = dataChk.line_items, items = [], count = 0;
              line_items.forEach(function (line_item) {
                count++;
                var dataItem = {
                  "product_id": line_item.product_id,
                  "variant_id": line_item.variant_id,
                  "price": Hs_CartDrawer.stringToInt(line_item.price),
                  "properties": line_item.properties,
                  "quantity": line_item.quantity,
                  "discounts": Hs_CartDrawer.dsctoObj(line_item.discount_allocations, dataChk.discount_code)
                }
                items.push(dataItem)
              });
              if (line_items.length == count) {
                json.items = items;
                /* return false; */
                HsApp1.createDraftOrder(json);
              };
            };
          };
        };
        if (!checkoutPage) {
          /* return false; */
          HsApp1.createDraftOrder(json);
        };
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.eventEmitter !== 'undefined'
          && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', json);
        }
      })
      .catch(err => {
        console.log(err)
      }).then(function () {
      });
  },
  createDraftOrder: async function (datacart) {
    await fetch(`${window.HSHOST}/gift`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Accept': "application/json, text/javascript",
        'Content-type': 'application/json',
        /* 'X-Requested-With': 'XMLHttpRequest',*/
        'Auth': slideData.token.auth
      },
      body: JSON.stringify({ shop: Shopify.shop, datacart: eval(datacart) })
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }

        throw new Error('Something went wrong.');
      })
      .then(function (json) {

        if (json) {
          if (json.invoice) {
            var to_url = json.invoice;
            if (typeof window.Weglot !== 'undefined') {
              const language = Weglot.getCurrentLang() || '';
              if (language) {
                to_url = to_url + '?locale=' + language;
              }
            }

            window.location = to_url;
          }
        }
      }).catch(function (error) {                        // catch
        console.log('Request failed', error);
        window.location = '/checkout';
      }).then(function () {
      });
  },
  loadDevice: function () {
    const ua = navigator.userAgent;
    var device;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      device = "tablet";
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      device = "mobile";
    }
    else {
      device = "desktop";
    };
    return device;
  },
  convertPrice: function (o) {
    if (o) {
      o = o.replace(/[^a-zA-Z0-9]/g, '');
      o = o.replace(/[^0-9]/g, '');
    }
    return o;
  },
  validateDevice: function () {
    var enabled_desktop = slideData.settings.devices.enabled_desktop;
    var enabled_mobile = slideData.settings.devices.enabled_mobile;
    var device = HsApp1.loadDevice();
    var result;
    if (device == "desktop") {
      switch (parseInt(enabled_desktop)) {
        case 0:
          result = 0;
          break;
        case 1:
          result = 1
          break;
      };
    }
    else if (device == "mobile" || "tablet") {
      switch (parseInt(enabled_mobile)) {
        case 0:
          result = 2;
          break;
        case 1:
          result = 3;
          break;
      };
    };
    return result;
  },
  validateEmptyUpsell: function (cartEmptyArr, condition) {
    var arr = [];
    if (cartEmptyArr.length > 0) {
      cartEmptyArr.forEach(function (element) {
        if (arr.length < slideData.settings.cart_empty.cart_empty_upsell_max_item) {
          var itemsAvailable = 0;
          element.variants.forEach(function (variant) {
            if (!!variant.available) {
              itemsAvailable++
            }
          });
          itemsAvailable > 0 ? element.available = true : element.available = false;
          if (!!element.available) {
            if (arr.length < slideData.settings.cart_empty.cart_empty_upsell_max_item) {
              arr.push(element);
            }
          }
        }
      });
    };
    if (condition === 'collection' && arr.length > 0) {
      var arr_collection = arr;
      arr_collection.forEach(function (element) {
        element.variants.forEach(function (variant) {
          var options = [];
          if (!variant.options) {
            /* variant.options = options.split(',') */
            if (variant.option1 != null) {
              options.push(variant.option1)
            }
            if (variant.option2 != null) {
              options.push(variant.option2)
            }
            if (variant.option3 != null) {
              options.push(variant.option3)
            }
            if (!!options) {
              variant.options = options;
            }
          }
        });
      });
      arr = arr_collection;
    }
    return arr;
  },
  cartEmptyUpsellView: function (cartEmptyArr, condition) {
    cartEmptyArr = HsApp1.validateEmptyUpsell(cartEmptyArr, condition);

    var noPopUp = typeof slideData.settings.cart_empty.cart_empty_upsell_add_to_cart_mode !== 'undefined' ? slideData.settings.cart_empty.cart_empty_upsell_add_to_cart_mode : 0;
    if (!!cartEmptyArr) {
      var status_text_slide_cart = '', url_upsell_empty = '', show_only_product_variant_in_stock = 1, hs_cross_sell = !!document.querySelector('.hs-cross-sell') ? document.querySelector('.hs-cross-sell') : '';
      status_text_slide_cart = HsApp1.upsellProductsJson(parseInt(slideData.settings.additional_settings.show_quantity_box_upsells), parseInt(slideData.settings.cart_empty.cart_empty_upsell_mode), 'swiper-container-dynamic', cartEmptyArr, 'empty', show_only_product_variant_in_stock, noPopUp);
      let hs_content_cart_empty = document.querySelector('.hs-body-layout .hs-content-cart-empty') || '';
      if (hs_content_cart_empty) {
        if (status_text_slide_cart) {
          hs_content_cart_empty.classList.remove('hs-hidden-div');
        } else {
          hs_content_cart_empty.classList.add('hs-hidden-div');
        }
      };

      if (!!hs_cross_sell) {
        hs_cross_sell.style.display = 'none';
        if (status_text_slide_cart) {
          hs_cross_sell.style.display = 'block';
          if (parseInt(slideData.settings.cart_empty.cart_empty_upsell_mode)) {
            var hs_products_dynamic_stacked = !!hs_cross_sell.querySelector('.hs-products-dynamic-stacked') ? hs_cross_sell.querySelector('.hs-products-dynamic-stacked') : '';
            if (!!hs_products_dynamic_stacked) {
              hs_products_dynamic_stacked.innerHTML = status_text_slide_cart;
            };
          } else {
            var hs_mode_dynamic = !!hs_cross_sell.querySelector('.hs-mode-dynamic') ? hs_cross_sell.querySelector('.hs-mode-dynamic') : '';
            if (!!hs_mode_dynamic) {
              hs_mode_dynamic.innerHTML = status_text_slide_cart;
            };
          };

          HsApp1.upsellNoPopUp();
          HsApp1.upsellVariants('empty');
          HsApp1.swiperDynamicHSCart('cart_empty', cartEmptyArr.length);
          HsApp1.upsellAddToCartFreeShipping(condition, 'empty');
          HsApp1.currencyConverter();
        };
      };
    }
  },
  cartEmptyUpsell: async function () {
    if (!!slideData.settings.cart_empty.cart_empty_enabled_upsell && !!slideData.settings.cart_empty.enabled_cart_empty) {
      var listProdEmpty = false;
      const cart_empty_upsell_type = typeof slideData.settings.cart_empty.cart_empty_upsell_type !== 'undefined' ? slideData.settings.cart_empty.cart_empty_upsell_type : 0;
      switch (cart_empty_upsell_type) {
        case 0:
          if (typeof slideData.settings.cart_empty.cart_empty_upsell_list_products !== 'undefined') {
            if (slideData.settings.cart_empty.cart_empty_upsell_list_products !== '') {
              var arrProds = slideData.settings.cart_empty.cart_empty_upsell_list_products.split(',');
              arrProds = HsApp1.unique(arrProds);
              if (arrProds.length > 0) {
                try {
                  await window.getShopifyDataByHandles({
                    handles: arrProds,
                    type: 'product'
                  }).then(prodsProcess => {
                    prodsProcess = HsApp1.hiddenProd(prodsProcess);
                    if (prodsProcess.length > 0) {
                      listProdEmpty = true;
                      HsApp1.cartEmptyUpsellView(prodsProcess, 'product');
                    };
                  });
                } catch (error) {
                  listProdEmpty = true;
                  console.log(error)
                }
              };
            };
          };
          break;
        case 1:
          if (typeof slideData.settings.cart_empty.cart_empty_upsell_list_collections !== 'undefined' && slideData.settings.cart_empty.cart_empty_upsell_list_collections !== '') {
            let arrCollections = HsApp1.unique(slideData.settings.cart_empty.cart_empty_upsell_list_collections.split(','));
            try {
              await window.getShopifyDataByHandles({
                handles: arrCollections,
                type: 'collection'
              }).then(arr_prodUpsell => {
                // eliminar duplicados
                arr_prodUpsell = HsApp1.unique(arr_prodUpsell);
                if (arr_prodUpsell.length > 0) {
                  listProdEmpty = true;
                  HsApp1.cartEmptyUpsellView(arr_prodUpsell, 'collection');
                }
              });
            } catch (error) {
              listProdEmpty = true;
              console.log(error)
            }
          };
          break;
      }

      if (!listProdEmpty) {
        var arr_prod = [], arr_prodUpsell = [], item = 0;
        var collections = Hs_CartDrawer.routeLocale(`collections/all/products.json?limit=250`);
        fetch(`${collections}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then((response) => {
            return response.ok ? response.json() : Promise.reject(response);
          })
          .then((json) => {
            if (!!json.products) {
              let arr_collection = HsApp1.hiddenProd(json.products);
              arr_collection.map((arr_coll) => {
                arr_coll.upsell_specific = "collection";
              });

              arr_prod.push(arr_collection);
            };
            arr_prod.forEach(function (vals) {
              vals.forEach(function (val) {
                item++;
                arr_prodUpsell.push(val)
              })
            });
          })
          .catch(err => {
            item++;
            console.log(err);
          })
          .then(function () {
            if (item == arr_prodUpsell.length) {
              HsApp1.cartEmptyUpsellView(arr_prodUpsell, 'collection');
            }
          });
      };
    }
  },
  cartEmpty: function (countCart, condition) {
    const positionKeyUpsell = Hs_CartDrawer.getDataPosition('hs-upsell', 'empty_cart')?.key || '';
    var cartEmpty = '', cross_sell = '', rewards = '', multi_view_class = '';
    if (countCart < 1) {
      if (!!slideData.settings.cart_empty.enabled_cart_empty) {
        if (!!slideData.settings.cart_empty.cart_empty_enabled_upsell) {
          if (parseInt(slideData.settings.cart_empty.cart_empty_upsell_mode)) {
            cross_sell = `
                      ${slideData.settings.cart_empty.cart_empty_upsell_heading !== '' ? `<div class='hs-content-cart-empty hs-hidden-div' ${positionKeyUpsell}>
                        <div class="hs-frequently-bought">
                          <span>${slideData.settings.cart_empty.cart_empty_upsell_heading}</span>
                        </div>
                      </div>` : ''}
                      <div class='hs-content-upsell-empty-scroll' ${positionKeyUpsell}>
                        <div class="hs-container-dynamic-stacked hs-cross-sell" style="display:none;">
                          <div class='hs-scroll'>
                            <div class="hs-products-dynamic-stacked">
                            </div>
                          </div>
                        </div>
                      </div>`;
          } else {
            multi_view_class = Hs_CartDrawer.cart_empty_upsell_qty > 1 ? 'hs-upsell_multi_view' : '';
            cross_sell = `
                        ${slideData.settings.cart_empty.cart_empty_upsell_heading !== '' ? ` <div class='hs-content-cart-empty hs-hidden-div' ${positionKeyUpsell}>
                          <div class="hs-frequently-bought">
                            <span>${slideData.settings.cart_empty.cart_empty_upsell_heading}</span>
                          </div>
                        </div>` : ''}
                        <div class='hs-content-upsell-empty' ${positionKeyUpsell}>
                          <div class="hs-container-swp ${multi_view_class} hs-cross-sell" style="display:none;">
                            <div class="hs-swipper-containter-cart hs-mode-dynamic" aria-roledescription="Carousel" aria-label="${slideData.settings.cart_empty.cart_empty_upsell_heading}">
                            </div>
                          </div>
                      </div>`;
          }
        };
        if (!!slideData.settings.rewards.enabled_rewards && !!slideData.settings.rewards.rewards_enabled_in_cartEmpty) {
          const positionKeyEmptyRewards = Hs_CartDrawer.getDataPosition('hs-rewards', 'empty_cart')?.key || '';
          rewards = `
                    <div class="hs-content-discounts-calculate-checkout" ${positionKeyEmptyRewards}>
                    </div>`;
        }
        var view_content_empty = 1;
        if (slideData.settings.cart_empty.cart_empty_title === '' && slideData.settings.cart_empty.cart_empty_subtitle === '' && slideData.settings.cart_empty.cart_empty_button_text === '') {
          view_content_empty = 0;
        };
        const positionKeyEmptyCart = Hs_CartDrawer.getDataPosition('hs-emptyCart', 'empty_cart')?.key || '';

        const emptyBodyOrder = JSON.parse(slideData?.position?.empty_cart_body_order || '[]');

        // genera SOLO los custom, ya ordenados
        const customEmptyHtml = emptyBodyOrder
          .filter(item => item.type === 'hs-custom')
          .sort((a, b) => a.order - b.order)
          .map(item => `<div class="hs-custom-section" data-key="${item.key}" style="order:${item.order}">${item.html || ''}</div>`)
          .join('');

        const iconBadged = `<svg width="60px" id="Capa_1" data-name="Capa 1" viewBox="0 0 1042 1186.53"><defs><style>.cls-1{fill:#f2f2f2;}.cls-2{fill:#bababa;}.cls-3{fill:#fefefe;}.cls-4{fill:#ebebeb;}.cls-5{fill:#6d6d6d;}</style></defs><title>heysenior_cart</title><path class="cls-1" d="M79.11,1148.9V182.64c1.81-3.35-1.14-9,4.94-10.31C93,164.7,103.48,163,115,163q485,.23,970,.12c1.09,0,2.18.06,3.26,0,10.8-.69,20.19,2.16,27.29,10.76,4.74,1.78,4.22,6.35,5.32,10.07v3.91c-1.3,2.69-.62,5.56-.62,8.33q-.06,473.87,0,947.71c0,26.92-16.76,45.54-43.81,48.69a2.22,2.22,0,0,0-1.11.6H124.68c-15.62-1.63-28.3-8.38-37.4-21.41C82.47,1164.89,80.47,1157,79.11,1148.9Z" transform="translate(-79 -6.74)"></path><path class="cls-2" d="M1117.1,177.52c-9.15-11-21.36-12-34.67-11.94q-486.5.3-973,0c-9.49,0-17.52,2.66-24.14,9.17-3.36,3.3-2-.23-2.36-1.3-1.84-5.35,2.45-8.17,5.32-10.76,21.09-19,41.85-38.27,62.89-57.28,16.38-14.8,32.66-29.73,49-44.6C218.71,44,237.2,27,255.92,10.23c1.66-1.49,3.77-2.09,5.5-3.39H937.28c14.92,11.22,27.83,24.7,41.71,37.1,22.29,19.9,44.32,40.1,66.39,60.25,17.43,15.91,35,31.64,52.15,47.91,5.18,4.92,11.38,8.8,15.64,14.62C1115.45,169.85,1119.28,172.66,1117.1,177.52Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M1117.1,177.52c-1.48-6.75-6.24-11.24-11-15.59-12.42-11.32-25-22.43-37.49-33.72q-35.47-32.12-70.84-64.36c-11.16-10.17-22.2-20.48-33.35-30.66-8.11-7.41-16.32-14.72-24.5-22-1.33-1.19-2.48-2.42-2.62-4.3q89.37,0,178.73-.1c4,0,5,.89,5,5q-.24,86.12-.11,172.23c-1.81-.23-2.72-1.08-1.78-2.92C1120.29,178.74,1118.54,178.24,1117.1,177.52Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M261.42,6.84c-6.45,8.84-15.61,14.89-23.36,22.4-11,10.67-22.82,20.55-34.21,30.84q-34.65,31.35-69.23,62.77c-15.06,13.68-30.13,27.35-45,41.2A23,23,0,0,0,83,173.5c-4,1.92-.43,7-3.84,9.14q0-85.47-.11-170.93c0-4.08.94-5,5-5Q172.7,7,261.42,6.84Z" transform="translate(-79 -6.74)"></path><path class="cls-4" d="M1119.58,1146.28q0-474.85.07-949.72c0-2.9-1.17-6.1,1.24-8.71V1146.3C1120.45,1146.89,1120,1146.92,1119.58,1146.28Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M1119.58,1146.28l1.31,0c0,14.54-.09,29.08.09,43.62,0,2.8-.54,3.38-3.34,3.34-14.11-.18-28.22-.08-42.32-.08,7.89-3.33,16.47-5,23.48-10.44C1110.84,1173.47,1118.33,1161.67,1119.58,1146.28Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M79.11,1148.9c3.73,7.26,5.29,15.52,10.1,22.28,7.76,10.92,18.87,16.73,31.37,20.39,1.42.41,3.06.23,4.1,1.61-14.1,0-28.21-.1-42.32.08-2.8,0-3.38-.54-3.34-3.34C79.21,1176.25,79.11,1162.57,79.11,1148.9Z" transform="translate(-79 -6.74)"></path><path class="cls-5" d="M830.88,471.23c0,26.65,1.23,53.37-5.41,79.59C806.13,627.26,760.56,682,688,712.47c-90.54,38-193.23,14.58-259.69-58.12-31.83-34.83-50.93-76.08-57.65-123C367,506.25,369,481.09,368.44,456c-.22-10.19-.08-20.39,0-30.59.09-16.3,10.67-27.79,25.52-27.83,14.61,0,25.92,11.59,26.08,27.54.29,28-.47,56,.43,84,1.27,39.75,15.78,74.8,41.19,105.19s57.59,50.44,96.17,59.67q58.14,13.92,113.27-9.75a176.89,176.89,0,0,0,77.79-64.1c20.93-30.74,30.94-65.16,30.85-102.44-.06-24.31-.12-48.61,0-72.91.1-16,11.22-27.35,26.17-27.17,13.37.17,24.62,10.77,24.89,24.21C831.13,438.24,830.88,454.74,830.88,471.23Z" transform="translate(-79 -6.74)"></path></svg>`;

        cartEmpty = `
                    ${rewards}
              ${!!view_content_empty ?
            `<div class="hs-empty-cart" ${positionKeyEmptyCart}>
                    ${slideData.settings.cart_empty.cart_empty_title !== '' ?
              `${iconBadged}<p class="hs-empty-cart-title">
                    ${slideData.settings.cart_empty.cart_empty_title}
                    </p>` : ``}
                    ${slideData.settings.cart_empty.cart_empty_subtitle !== '' ?
              `<p class="hs-empty-cart-subtitle">
                    ${slideData.settings.cart_empty.cart_empty_subtitle}
                    </p>` : ``
            }
                      ${slideData.settings.cart_empty.cart_empty_button_text !== '' ?
              `<p class="hs-empty-cart-button">
                      <a href="/${slideData.settings.cart_empty.cart_empty_button_url}">${slideData.settings.cart_empty.cart_empty_button_text}</a>
                      </p>`: ``}
              </div>` : ''}
                    ${cross_sell}
                    ${customEmptyHtml}
                  `;
        if (!condition) {
          cartEmpty = `<!-- HS BODY LAYOUT --><div class='hs-body-layout'>${cartEmpty}</div>`
        };
      }
    }

    return cartEmpty;
  },
  ipinfo: function () {
    if (!slideData.settings.rewards.enabled_rewards) {
      HsApp1.getMyCart(0), HsApp3.addCart();
      return false;
    };
    fetch('/browsing_context_suggestions.json', {
      method: 'GET'
    }).then((response) => {
      return response.ok ? response.json() : Promise.reject(response);
    })
      .then((json) => {
        if (window.shiprocket) {
          window.HSSLIDECART.localCountryCode = json.detected_values.country.handle
        };
        if (typeof slideData.settings.rewards_specific_countries_tiers != undefined) {
          var countries = slideData.settings.rewards_specific_countries_tiers;
          countries.forEach(function (val) {
            if (json.detected_values.country.handle === val.rewards_specific_country /* || val.rewards_specific_country === '1' */) {
              HsApp1.arr_rewards.push(val);
            };
          });
        };
        const cart = Hs_CartDrawer.routeLocale('cart/update.js');
        fetch(cart, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              _hs_rewards_country: slideData.settings.rewards.rewards_mode == 3 ? json.detected_values.country.handle : ''
            }
          })
        });

      }).catch(err => {
        console.log(err)
      }).then(function () {
        HsApp1.getMyCart(0), HsApp3.addCart()
      });
  },
  setGeoCountryfunction: function () {
    if (slideData?.settings?.rewards?.enabled_rewards) return
    if (!window.shiprocket) return;
    if (window.HSSLIDECART.localCountryCode) return;

    fetch('/browsing_context_suggestions.json', {
      method: 'GET'
    })
      .then((response) => {
        return response.ok ? response.json() : null;
      })
      .then((json) => {
        const country = json?.detected_values?.country?.handle || '';
        window.HSSLIDECART.localCountryCode = country;

      })
      .catch((err) => {
        console.log(err);
      });

  },
  createCpokie: function (key, value, exdays) {
    expires = new Date();
    expires.setTime(expires.getTime() + (exdays * 24 * 60 * 60 * 1000)); cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    return document.cookie = cookie;
  },
  readCookie: function (key) {
    keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    if (keyValue) {
      return keyValue[2];
    } else {
      return '';
    }
  },
  setCookie: function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString(); document.cookie = cname + '=' + cvalue + '; ' + expires + ';path=/';
  },
  deleteCookie: function (cname) {
    expires = new Date(); expires.setTime(expires.getTime() + (-1 * 24 * 60 * 60 * 1000));
    cookie = cname + '=;expires=' + expires.toUTCString() + ';path=/';
    return document.cookie = cookie;
  },
  cookieGiftWrap: function (arr_cookies) {
    if (arr_cookies.length > 0) {
      arr_cookies.forEach(function (val) {
        HsApp1.createCpokie(val.name, val.value, 360);
      });
    }
  },
  closePopUpProd: function () {
    var hs_product_option = !!document.querySelector('.hs-product-option') ? document.querySelector('.hs-product-option') : '';
    if (!!hs_product_option) {
      var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
      var hs_popUp_product = !!hs_product_option.querySelector('.hs-popUp-product') ? hs_product_option.querySelector('.hs-popUp-product') : '';
      if (!!hs_popUp_product || !!hs_popUp_overlay) {
        hs_popUp_product.classList.remove('hs-popUp-active');
        hs_popUp_overlay.classList.remove('hs-popUp-active');
      }
      setTimeout(function () { hs_product_option.innerHTML = ''; }, 300);
      HsApp1.popUpProduct = [];//CLEAR VARIABLES GLOBAL
      HsApp1.arr_variants_popup = [];//CLEAR VARIABLES GLOBAL
    };
  },
  quantityBoxPopUp: function (upsell) {
    var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
    if (!!hs_popUp_product) {
      var hs_qty_upsell = !!hs_popUp_product.querySelector('.hs-qty-upsell') ? hs_popUp_product.querySelector('.hs-qty-upsell') : '';
      if (!!hs_qty_upsell) {
        var hs_qty_upsell_input = !!hs_qty_upsell.querySelector('input[type="text"]') ? hs_qty_upsell.querySelector('input[type="text"]') : '';
        if (!!hs_qty_upsell_input) {
          if (!!hs_qty_upsell_input) {
            HsApp1.setInputFilter(hs_qty_upsell_input, function (value) {
              return /^-?\d*$/.test(value);//VALIDATE INPUT ONLY NUMBER
            });
          }
        };
        var hs_qtybutton_upsell = hs_qty_upsell.querySelectorAll('.hs-qtybutton-upsell').length > 0 ? hs_qty_upsell.querySelectorAll('.hs-qtybutton-upsell') : [];
        if (hs_qtybutton_upsell.length > 0) {

          function quantityBoxPopUpChange($button) {
            var newVal = 0,
              data = !!$button.closest('.hs-item-cart-qty-upsell')
                ? $button.closest('.hs-item-cart-qty-upsell').querySelector('input').dataset.prod
                : '',
              oldValue = !!$button.closest('.hs-item-cart-qty-upsell')
                ? $button.closest('.hs-item-cart-qty-upsell').querySelector('input').value
                : '';

            if (!!oldValue) {
              if ($button.classList.contains('hs-inc-upsell')) {
                newVal = parseFloat(oldValue) + 1;
              } else {
                if (oldValue > 1) {
                  newVal = parseFloat(oldValue) - 1;
                } else {
                  newVal = 1;
                }
              }
            }

            if (typeof data !== 'undefined' && data === 'free_gift') {
              newVal = 1;
            }

            const input = $button.closest('.hs-item-cart-qty-upsell')?.querySelector('input');
            if (input) input.value = newVal;
          }

          hs_qtybutton_upsell.forEach(function (qtybutton) {
            if (!qtybutton.classList.contains('hs-event-static')) {
              qtybutton.classList.add('hs-event-static')
              qtybutton.addEventListener('click', function (event) {
                event.preventDefault();
                quantityBoxPopUpChange(this)
              });
              qtybutton.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  quantityBoxPopUpChange(this);
                }
              });
            }
          });
        }
      }
    }
  },
  captureVariantsPopUp: function (variantTitle) {
    var arr = [];
    if (HsApp1.arr_variants_popup.length > 0) {
      HsApp1.arr_variants_popup.forEach(function (variant) {
        if (variantTitle === variant.title) {
          arr.push(variant);
        } else {
          if (variant.options.length > 0) {
            if (variant.options.length > 1) {
              if (variantTitle.indexOf('/') > -1) {
                var title_split = variantTitle.split('/'), count = 0;
                if (title_split.length > 0 && variant.options.length > 0) {
                  title_split.forEach(function (title) {
                    variant.options.forEach(function (opt) {
                      if (title.trim() === opt) {
                        count++;
                      };
                    });
                  });
                  if (count == title_split.length) {
                    arr.push(variant);
                  };
                };
              };
            } else {
              var this_variant = variant.options.find(element => element === variantTitle);
              if (typeof this_variant !== 'undefined') {
                arr.push(variant);
              };
            };
          };
        };
      });
      if (arr.length > 0) {
        arr = arr[0];
      }
    }
    return arr;
  },
  callBackVariantPopUp: function (variant, identify, condition, upsell, dataProd, button_parent = '') {
    if (typeof variant.id === 'undefined') {
      var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
      if (!!hs_popUp_product) {
        hs_popUp_product.removeAttribute('data-variant');
        var hs_product_popup_header = !!hs_popUp_product.querySelector('.hs-product-popup-header') ? hs_popUp_product.querySelector('.hs-product-popup-header') : '';
        if (!!hs_product_popup_header) {
          var hs_content_price_swiper = !!hs_popUp_product.querySelector('.hs-content-price-swiper') ? hs_popUp_product.querySelector('.hs-content-price-swiper') : '';
          if (!!hs_content_price_swiper) {
            var hs_options_prices = !!hs_content_price_swiper.querySelector('.hs-options-prices') ? hs_content_price_swiper.querySelector('.hs-options-prices') : '';
            if (!!hs_options_prices) {
              var hs_compare_price_sw = !!hs_options_prices.querySelector('.hs-compare-price-sw') ? hs_options_prices.querySelector('.hs-compare-price-sw') : '';
              if (!!hs_compare_price_sw) {
                hs_compare_price_sw.innerHTML = '';
              };
              var hs_price_sw = !!hs_options_prices.querySelector('.hs-price-sw') ? hs_options_prices.querySelector('.hs-price-sw') : '';
              if (!!hs_price_sw) {
                hs_price_sw.classList.remove('hs-compare-price-active')
                hs_price_sw.innerHTML = '';
              }
            }
          }
          var hs_product_popup_text = !!hs_product_popup_header.querySelector('.hs-product-popup-text') ? hs_product_popup_header.querySelector('.hs-product-popup-text') : '';
          if (!!hs_product_popup_text) {
            var hs_product_popup_title = !!hs_product_popup_text.querySelector('.hs-product-popup-title') ? hs_product_popup_text.querySelector('.hs-product-popup-title') : '';
            if (!!hs_product_popup_title) {
              var hs_product_popup_variant = !!hs_product_popup_title.querySelector('.hs-product-popup-variant') ? hs_product_popup_title.querySelector('.hs-product-popup-variant') : '';
              if (!!hs_product_popup_variant) {
                hs_product_popup_variant.innerHTML = '';
              }
            }
          }
        }
        var hs_subscription_content = !!hs_popUp_product.querySelector('.hs-subscription-content') ? hs_popUp_product.querySelector('.hs-subscription-content') : '';
        if (!!hs_subscription_content) {
          hs_subscription_content.style.display = 'none';
        };
        var hs_popup_button_full = !!hs_popUp_product.querySelector('.hs-popup-button-full') ? hs_popUp_product.querySelector('.hs-popup-button-full') : '';
        if (!!hs_popup_button_full) {
          var hs_button_full = !!hs_popup_button_full.querySelector('.hs-checkout-bar-add-to-cart') ? hs_popup_button_full.querySelector('.hs-checkout-bar-add-to-cart') : '';
          if (!!hs_button_full) {
            hs_button_full.innerHTML = slideData.settings.language_settings.unavailable_language_settings;
            hs_button_full.setAttribute('disabled', 'disabled');
          }
          return false;
        }
      }
    };
    if (typeof variant !== 'undefined') {
      var url = window.location.href,
        featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif',
        variantid = variant.id,
        available = variant.available,
        price = variant.price,
        compareatprice = variant.compare_at_price || 0,
        variant_id_select = '',
        compare_price_active = '';
      var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
      if (!!hs_popUp_product) {
        hs_popUp_product.dataset.variant = variant.id
        variant_id_select = hs_popUp_product.querySelector('.hs-select-variants-bar').value = variantid;

        var hs_content_price_swiper = !!hs_popUp_product.querySelector('.hs-content-price-swiper') ? hs_popUp_product.querySelector('.hs-content-price-swiper') : '';
        if (!!hs_content_price_swiper) {
          var hs_options_prices = !!hs_content_price_swiper.querySelector('.hs-options-prices') ? hs_content_price_swiper.querySelector('.hs-options-prices') : '';
          if (!!hs_options_prices) {
            var hs_compare_price_sw = !!hs_options_prices.querySelector('.hs-compare-price-sw') ? hs_options_prices.querySelector('.hs-compare-price-sw') : '';
            if (!!hs_compare_price_sw) {
              hs_compare_price_sw.innerHTML = '';
            };
            var hs_price_sw = !!hs_options_prices.querySelector('.hs-price-sw') ? hs_options_prices.querySelector('.hs-price-sw') : '';
            if (!!hs_price_sw) {
              hs_price_sw.innerHTML = '';
            }
          }
        };
        /* SUBCRIPTION FUNCTION */
        var hs_subscription_content = !!hs_popUp_product.querySelector('.hs-subscription-content') ? hs_popUp_product.querySelector('.hs-subscription-content') : '';
        if (!!hs_subscription_content) {
          hs_subscription_content.style.display = '';
          /*  */
          if (typeof variant.selling_plan_allocations !== 'undefined') {
            var hs_selling_plan = !!hs_popUp_product.querySelector('select[name="hs-selling_plan"]') ? hs_popUp_product.querySelector('select[name="hs-selling_plan"]') : '';
            var hs_subscription_input = !!hs_popUp_product.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? hs_popUp_product.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
            //var hs_only_input = !!hs_popUp_product.querySelector('input[data-hs-type="hs-chks-once"]') ? hs_popUp_product.querySelector('input[data-hs-type="hs-chks-once"]') : '';
            var opts_selling_plan = '';
            var label_subscription = /* Hs_CartDrawer.withSubOnly; */Hs_CartDrawer.curlyReplaceRc();
            if (!!hs_selling_plan) {
              if (variant.selling_plan_allocations.length > 0) {

                //COMMENT CAMBIO DE LAS OPCIONES DEL SELECT PLAN
                variant.selling_plan_allocations.forEach((selling_plan_allocations) => {
                  selling_plan_allocations.selling_plans.forEach((selling_plan) => {
                    var price_adjustments = '';
                    if (selling_plan.price_adjustments) {
                      if (selling_plan.price_adjustments.length > 0) {
                        var value = selling_plan.price_adjustments[0].value;
                        var value_type = selling_plan.price_adjustments[0].value_type;
                        if (value && value_type) {
                          if (value > 0 && value_type === 'percentage') {
                            price_adjustments = `data-value-percentage="${value}"`
                          }
                        };
                      };
                    };
                    var selected = '';
                    if (+selling_plan_allocations.selling_plan_id == +hs_selling_plan.value) {
                      selected = 'selected';
                    };
                    opts_selling_plan = opts_selling_plan + `<option ${selected} value="${selling_plan.id}" ${price_adjustments}>${selling_plan.name}</option>`
                  });
                });
                hs_selling_plan.innerHTML = opts_selling_plan;
                //COMMENT CAMBIO TEXT LABEL SUBSCRIPTION SI TIENE PORCENTAJE

                var selling_plan_selected_percentage = hs_selling_plan[hs_selling_plan.selectedIndex].dataset.valuePercentage;
                if (selling_plan_selected_percentage) {
                  label_subscription = Hs_CartDrawer.curlyReplaceRc(selling_plan_selected_percentage + '%');
                };
                if (!!hs_subscription_input) {
                  if (!!hs_subscription_input.checked) {
                    var selling_plan_selected_value = hs_selling_plan.value;
                    if (selling_plan_selected_value) {
                      var plan = variant.selling_plan_allocations.find((selling_plan) => {
                        return +selling_plan.selling_plan_id == +selling_plan_selected_value
                      });
                      if (plan) {
                        if (plan.price) {
                          price = plan.price
                        };
                        if (plan.compare_at_price) {
                          if (!compareatprice || compareatprice >= plan.price) {
                            if (plan.compare_at_price > plan.price) {
                              compareatprice = plan.compare_at_price || 0;
                            };
                          };
                        };
                      };
                    };
                  };
                };
              } else {
                hs_selling_plan.innerHTML = '';
              };
              /*COMMENT  SI NO TIENE OPCIONES SE OCULTA O CASO CONTRARIO SE MUESTRA*/
              if (opts_selling_plan === '') {
                hs_subscription_content.style.display = 'none';
              } else {
                hs_subscription_content.style.display = '';
              };

              if (!!hs_subscription_input) {
                var hs_subscription = !!hs_subscription_input.closest('.hs-subscription-sub-option') ? hs_subscription_input.closest('.hs-subscription-sub-option') : '';
                if (!!hs_subscription) {
                  var hs_subcription_label = !!hs_subscription.querySelector('.hs-sub-label') ? hs_subscription.querySelector('.hs-sub-label') : '';
                  if (!!hs_subcription_label) {
                    hs_subcription_label.innerHTML = label_subscription;
                  };
                };
              };
            }
          };
          /*  */
          var inputs = hs_subscription_content.querySelectorAll('input').length > 0 ? hs_subscription_content.querySelectorAll('input') : [];
          if (inputs.length > 0) {
            inputs.forEach(function (thisInput) {
              if (!thisInput.classList.contains('hs-event-static')) {
                thisInput.classList.add('hs-event-static')
                thisInput.addEventListener('click', function (e) {
                  var where = this;
                  var hs_frequency_option = !!hs_subscription_content.querySelector('.hs-frequency-option') ? hs_subscription_content.querySelector('.hs-frequency-option') : '';
                  if (!!hs_frequency_option) {
                    if (this.dataset.hsType === 'hs-chks-subscribe') {
                      hs_frequency_option.classList.remove('hs-hidden');
                    } else {
                      hs_frequency_option.classList.add('hs-hidden');
                    }
                  };
                  inputs.forEach(function (thisInput) {
                    if (where.dataset.hsType !== thisInput.dataset.hsType) {
                      thisInput.checked = false;
                      where.checked = true;
                    };
                  });

                  var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
                  var hs_popup_select_options = !!hs_popUp_product.querySelector('.hs-popup-select-options') ? hs_popUp_product.querySelector('.hs-popup-select-options') : '';
                  var hs_select_option_popup = hs_popup_select_options.querySelectorAll('.hs-select-option-popup').length > 0 ? hs_popup_select_options.querySelectorAll('.hs-select-option-popup') : [];
                  hs_select_option_popup.forEach(function (vals) {
                    var evt = document.createEvent("HTMLEvents");
                    evt.initEvent("change", false, true);
                    vals.dispatchEvent(evt);
                  });
                });
              };
            });
          };
        };

        var hs_product_popup_header = !!hs_popUp_product.querySelector('.hs-product-popup-header') ? hs_popUp_product.querySelector('.hs-product-popup-header') : '';
        if (!!hs_product_popup_header) {
          if (!!hs_product_popup_header.classList.contains('hs-link')) {
            var header_popup_links = hs_product_popup_header.querySelectorAll('a').length > 0 ? hs_product_popup_header.querySelectorAll('a') : [];
            if (header_popup_links.length > 0) {
              var hs_select_variants_bar = !!hs_popUp_product.querySelector('.hs-select-variants-bar') ? hs_popUp_product.querySelector('.hs-select-variants-bar') : '';
              if (!!hs_select_variants_bar) {
                header_popup_links.forEach(function (thisUrl) {
                  var url = hs_select_variants_bar.options[hs_select_variants_bar.selectedIndex].dataset.handle;
                  thisUrl.setAttribute('href', url)
                });
              };
            };
          };

          var hs_product_popup_image = !!hs_product_popup_header.querySelector('.hs-product-popup-image img') ? hs_product_popup_header.querySelector('.hs-product-popup-image img') : '';
          if (!!hs_product_popup_image) {
            if (variant.featured_image != null) {
              /* featured_image = HsApp2.imageResize(variant.featured_image.src,'thumb'); */
              featured_image = HsApp1.resizeSrc(variant.featured_image.src, slideData.settings.additional_settings.image_quality);
              hs_product_popup_image.setAttribute('src', featured_image)
            } else {
              if (condition === 'collection') {
                if (HsApp1.popUpProduct.images.length > 0) {
                  var src_img = typeof HsApp1.popUpProduct.images[0].src !== 'undefined' ? HsApp1.popUpProduct.images[0].src : HsApp1.popUpProduct.images[0];
                  featured_image = HsApp1.resizeSrc(src_img, slideData.settings.additional_settings.image_quality);
                  hs_product_popup_image.setAttribute('src', featured_image)
                }
                else {
                  hs_product_popup_image.setAttribute('src', featured_image)
                }
              }
            };
            let attr_img = variant.title;
            var hs_select_variants_bar = !!hs_popUp_product.querySelector('.hs-select-variants-bar') ? hs_popUp_product.querySelector('.hs-select-variants-bar') : '';
            if (hs_select_variants_bar) {
              let img_attr = hs_select_variants_bar[hs_select_variants_bar.selectedIndex].dataset.attr || '';
              if (img_attr) {
                attr_img = img_attr;
              };
            };
            hs_product_popup_image.setAttribute('alt', attr_img);
          };

          var hs_product_popup_text = !!hs_product_popup_header.querySelector('.hs-product-popup-text') ? hs_product_popup_header.querySelector('.hs-product-popup-text') : '';
          if (!!hs_product_popup_text) {
            var hs_product_popup_title = !!hs_product_popup_text.querySelector('.hs-product-popup-title') ? hs_product_popup_text.querySelector('.hs-product-popup-title') : '';
            if (!!hs_product_popup_title) {
              var hs_product_popup_variant = !!hs_product_popup_title.querySelector('.hs-product-popup-variant') ? hs_product_popup_title.querySelector('.hs-product-popup-variant') : '';
              if (!!hs_product_popup_variant) {
                if (variant.title === 'Default Title') {
                  hs_product_popup_variant.innerHTML = '';
                }
                else {
                  hs_product_popup_variant.innerHTML = variant.title;
                }
              }
            }
          }
        };

        var hs_content_price_swiper = !!hs_popUp_product.querySelector('.hs-content-price-swiper') ? hs_popUp_product.querySelector('.hs-content-price-swiper') : '';
        if (!!hs_content_price_swiper) {
          var hs_options_prices = !!hs_content_price_swiper.querySelector('.hs-options-prices') ? hs_content_price_swiper.querySelector('.hs-options-prices') : '';
          if (!!hs_options_prices) {
            if (!!slideData.settings.additional_settings.show_compare_price) {
              var hs_compare_price_sw = !!hs_options_prices.querySelector('.hs-compare-price-sw') ? hs_options_prices.querySelector('.hs-compare-price-sw') : '';
              if (!!hs_compare_price_sw) {
                if (typeof compareatprice !== 'undefined') {
                  if (+compareatprice > +price) {
                    //compare_price_active = 'hs-compare-price-active';
                    hs_compare_price_sw.innerHTML = +compareatprice > 0 ? hsonslidecart.Currency.formatMoney(compareatprice, slideData.settings.devices.money_format) : '';
                  };
                }
              };
            }
            var hs_price_sw = !!hs_options_prices.querySelector('.hs-price-sw') ? hs_options_prices.querySelector('.hs-price-sw') : '';
            if (!!hs_price_sw) {
              if (typeof price !== 'undefined') {
                if (typeof compareatprice !== 'undefined') {
                  if (compareatprice > price) {
                    hs_price_sw.classList.add('hs-compare-price-active')
                  }
                } else {
                  hs_price_sw.classList.remove('hs-compare-price-active')
                }
                hs_price_sw.innerHTML = price == 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
              };
            }
          };
        };

        /* BUTTON ADD TO CART */
        var hs_popup_button_full = !!hs_popUp_product.querySelector('.hs-popup-button-full') ? hs_popUp_product.querySelector('.hs-popup-button-full') : '';
        if (!!hs_popup_button_full) {
          var hs_button_full = !!hs_popup_button_full.querySelector('.hs-checkout-bar-add-to-cart') ? hs_popup_button_full.querySelector('.hs-checkout-bar-add-to-cart') : '';
          if (!!hs_button_full) {
            if (available) {
              url = HsApp2.removeParam('variant', url);
              url = HsApp2.URL_add_parameter(url, 'variant', variantid);
              window.history.pushState({}, "keywords", url);
              hs_button_full.removeAttribute('disabled');
              hs_button_full.innerHTML = '<span class="hs-add--to--cart">' + slideData.settings.language_settings.add_to_cart_language_settings + '</span><span class="hs--loading">' + HsApp4.loadSvg() + '</span>';
            }
            else {
              hs_button_full.setAttribute('disabled', 'disabled');
              hs_button_full.innerHTML = slideData.settings.language_settings.sold_out_language_settings;
              url = HsApp2.removeParam('variant', url);
              url = HsApp2.URL_add_parameter(url, 'variant', variantid);
              window.history.pushState({}, "keywords", url);
            };
            if (!hs_button_full.classList.contains('hs-event-static')) {
              hs_button_full.classList.add('hs-event-static');
              hs_button_full.addEventListener('click', function (e) {
                e.preventDefault();

                var parent = !!this.closest('.hs-popUp-product') ? this.closest('.hs-popUp-product') : ''

                subscription_option = !!parent ? parent.querySelector('.hs-subscription-option') : '',

                  subscription_option_input = !!subscription_option ? subscription_option.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '',

                  selling_group_id = !!subscription_option_input ? subscription_option_input.value : '',

                  selling_plan = !!subscription_option_input ? !!subscription_option_input.checked ? true : false : false,

                  frequency_option = !!selling_plan ? !!parent ? parent.querySelector('.hs-frequency-option') : '' : '',

                  selling_plan_id = !!frequency_option ? !!frequency_option.querySelector('[name="hs-selling_plan"]') ? frequency_option.querySelector('[name="hs-selling_plan"]').options.length > 0 ? frequency_option.querySelector('[name="hs-selling_plan"]').options[frequency_option.querySelector('[name="hs-selling_plan"]').options.selectedIndex].value : '' : '' : '';

                //IDENTIFY 0 ADD TO CART
                var where = this, params = {};
                if (!identify) {
                  var show_qty = '';
                  if (upsell === 'tiered') {
                    show_qty = typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_show_quantity_box : 0;
                  }
                  else {
                    show_qty = slideData.settings.additional_settings.show_quantity_box_upsells
                  };

                  var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
                  if (!!hs_popUp_product) {
                    var quantity = 1, variantId = !!hs_popUp_product.querySelector('.hs-select-variants-bar') ? hs_popUp_product.querySelector('.hs-select-variants-bar').value : '';
                    dataprod = !!where.dataset.prod ? where.dataset.prod : '';
                    if (!!variantId) {
                      if (!!show_qty) {
                        var hs_qty_upsell_input = !!hs_popUp_product.querySelector('.hs-qty-upsell input[type="text"]') ? hs_popUp_product.querySelector('.hs-qty-upsell input[type="text"]') : '';
                        if (!!hs_qty_upsell_input) {
                          quantity = hs_qty_upsell_input.value;
                        }
                      };
                      params = { 'id': variantId, 'quantity': quantity }
                      if (!!dataProd || dataProd !== '') {
                        params = Object.assign(params, { 'properties': { '_tiered': dataProd } });
                      }
                      if (selling_plan_id !== '') {
                        params = Object.assign(params, { 'selling_plan_group_id': selling_group_id, 'selling_plan': selling_plan_id });
                      };
                      where.classList.add('hs-loading-btn');
                      params = JSON.stringify(params);
                      HsApp1.productCartUpsell(params, where, '', button_parent);
                    }
                  }
                };

                //IDENTIFY 1 CHECK WITH GIFTWRAP
                if (!!identify) {
                  where.classList.add('hs-loading-btn');//ADD CLASS BUTTON LOADING
                  var hs_drawer_checkout = !!document.querySelector('.hs-drawer-checkout') ? document.querySelector('.hs-drawer-checkout') : '';
                  if (!!hs_drawer_checkout) {
                    var hs_options_variants = !!hs_drawer_checkout.querySelector('.hs-options-variants') ? hs_drawer_checkout.querySelector('.hs-options-variants') : '';
                    if (!!hs_options_variants) {
                      var hs_swipper_select_option_add_to_cart = !!hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') ? hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') : '';
                      if (!!hs_swipper_select_option_add_to_cart) {
                        var variant_id = !!document.querySelector('.hs-select-variants-bar') ? document.querySelector('.hs-select-variants-bar') : '';
                        if (!!variant_id) {
                          var variant_price = variant_id.options[variant_id.selectedIndex].dataset.price, variant_compare_price = parseInt(variant_id.options[variant_id.selectedIndex].dataset.compareatprice) > parseInt(variant_price) ? variant_id.options[variant_id.selectedIndex].dataset.compareatprice : 0;
                          HsApp1.comparePriceGiftWrap = variant_id.options[variant_id.selectedIndex].dataset.compareatprice;
                          HsApp1.priceGiftWrap = variant_id.options[variant_id.selectedIndex].dataset.price;
                          hs_swipper_select_option_add_to_cart.value = variant_id.value;////
                          var evt = document.createEvent("HTMLEvents");
                          evt.initEvent("change", false, true);
                          hs_swipper_select_option_add_to_cart.dispatchEvent(evt);
                        }
                      }
                    };
                    var hs_gift_wrap = !!hs_drawer_checkout.querySelector('.hs-gift-wrap') ? hs_drawer_checkout.querySelector('.hs-gift-wrap') : '';
                    if (!!hs_gift_wrap) {
                      var giftWrapContent = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
                      if (!!giftWrapContent) {
                        var hs_gift_wrap_check = !!hs_gift_wrap.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap.querySelector('.hs-gift-wrap-check') : '';
                        if (!!hs_gift_wrap_check) {
                          hs_gift_wrap_check.setAttribute('checked', 'checked');
                        }
                      }
                    };
                    var hs_product_option = !!document.querySelector('.hs-product-option') ? document.querySelector('.hs-product-option') : '';
                    if (!!hs_product_option) {
                      var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
                      var hs_popUp_product = !!hs_product_option.querySelector('.hs-popUp-product') ? hs_product_option.querySelector('.hs-popUp-product') : '';
                      if (!!hs_popUp_product || !!hs_popUp_overlay) {
                        setTimeout(function () {
                          hs_popUp_product.classList.remove('hs-popUp-active');
                          hs_popUp_overlay.classList.remove('hs-popUp-active');
                          HsApp1.changeButton(where);//DELETE LOADING OF BUTTON ADD
                          var arr_cookies = [
                            {
                              name: 'hs-giftWrap-check-specific',
                              value: 1
                            },
                            {
                              name: 'hs-giftWrap-variantId',
                              value: variant_id.value
                            },
                            /*{
                              name: 'hs-giftWrap-variantPrice',
                              value: variant_price
                            },*/
                            {
                              name: 'hs-giftWrap-variantCompareAtPrice',
                              value: variant_compare_price
                            }
                          ];
                          HsApp1.cookieGiftWrap(arr_cookies);
                          //var params = JSON.stringify({id:variant_id.value,quantity:1,properties: {'giftWrap': true}});
                          var params = new FormData();
                          params.append('id', variant_id.value);
                          params.append('quantity', 1);
                          params.append('properties[_giftWrap]', true);
                          if (selling_plan_id !== '') {
                            params.append('selling_plan_group_id', selling_group_id);
                            params.append('selling_plan', selling_plan_id);
                          };
                          HsApp3.postMyCart(params);
                          Hs_CartDrawer.focusOnItemsCart();

                          HsApp1.popUpProduct = [];//CLEAR VARIABLES GLOBAL
                          HsApp1.arr_variants_popup = [];//CLEAR VARIABLES GLOBAL
                        }, 400);
                      }
                    }
                  }
                };
              });
            }
          }
        };
      };
    };
    HsApp1.currencyConverter();
  },
  changeVariantsPopUp: function (identify, condition, upsell, dataProd, button_parent = '') {
    function addSellingPlanVariant(variant = {}) {
      if (variant) {
        //COMMENT COLOCO A LOS PLANES DE LA VARIANTE SUS RESPECTIVOS NOMBRES QUE ESTAN EN EL PRODUCTO
        if (Object.keys(HsApp1.popUpProduct).length > 0) {
          var product_plans = '', variant_plan_allocations = '';
          if (HsApp1.popUpProduct.selling_plan_groups) {
            product_plans = HsApp1.popUpProduct.selling_plan_groups;
          };
          if (variant.selling_plan_allocations) {
            variant_plan_allocations = variant.selling_plan_allocations;
          };
          if (product_plans && variant_plan_allocations) {
            product_plans.map((prod_plan) => {
              variant_plan_allocations.map((var_plan_allocation) => {
                if (prod_plan.id === var_plan_allocation.selling_plan_group_id) {
                  var this_selling_plan = prod_plan.selling_plans.filter((selling_plan) => {
                    return selling_plan.id == var_plan_allocation.selling_plan_id
                  });
                  var_plan_allocation.name = prod_plan.name;
                  var_plan_allocation.selling_plans = this_selling_plan || [];
                };
              });
            });
          };
        };
      };
      return variant;
    };

    if (HsApp1.arr_variants_popup.length == 1) {
      let variant = addSellingPlanVariant(HsApp1.arr_variants_popup[0]);
      HsApp1.callBackVariantPopUp(variant, identify, condition, upsell, dataProd, button_parent)
    }
    var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
    if (!!hs_popUp_product) {
      var hs_popup_select_options = !!hs_popUp_product.querySelector('.hs-popup-select-options') ? hs_popUp_product.querySelector('.hs-popup-select-options') : '';
      if (!!hs_popup_select_options) {
        var hs_select_option_popup = hs_popup_select_options.querySelectorAll('.hs-select-option-popup').length > 0 ? hs_popup_select_options.querySelectorAll('.hs-select-option-popup') : [];
        if (hs_select_option_popup.length > 0) {
          hs_select_option_popup.forEach(function (valOptPopUp) {
            if (!valOptPopUp.classList.contains('hs-event-static')) {
              valOptPopUp.classList.add('hs-event-static');
              valOptPopUp.addEventListener('change', function (e) {
                e.preventDefault();
                var id = valOptPopUp.querySelector('option:checked').dataset.id,
                  value = Hs_CartDrawer.unEscape(valOptPopUp.value),
                  variant_option = '',
                  titleVariant = '',
                  arr = [],
                  variant = [];
                var select_box_load = hs_popup_select_options.querySelectorAll('.hs-select-box-load').length > 0 ? hs_popup_select_options.querySelectorAll('.hs-select-box-load') : [];
                if (select_box_load.length > 0) {
                  select_box_load.forEach(function (valSelect) {
                    var val_select = Hs_CartDrawer.unEscape(valSelect.querySelector('select').value);
                    titleVariant = titleVariant.concat(val_select + ' / ');
                    arr.push(val_select);
                  });
                };

                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                }
                variant = HsApp1.captureVariantsPopUp(titleVariant);
                variant = addSellingPlanVariant(variant);
                HsApp1.callBackVariantPopUp(variant, identify, condition, upsell, dataProd, button_parent);//MODIFI hs-popUp-product 
              });
            }
          });
          hs_select_option_popup.forEach(function (vals) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            vals.dispatchEvent(evt);
          });
        }
      };
      var hs_popup_select_subscribe_options = !!hs_popUp_product.querySelector('select[name="hs-selling_plan"]') ? hs_popUp_product.querySelector('select[name="hs-selling_plan"]') : '';
      if (!!hs_popup_select_subscribe_options) {
        if (!hs_popup_select_subscribe_options.classList.contains('hs-event-static')) {
          hs_popup_select_subscribe_options.classList.add('hs-event-static');
          hs_popup_select_subscribe_options.addEventListener('change', function (e) {
            e.preventDefault();
            var hs_select_variants_bar = hs_popUp_product.querySelector('.hs-select-variants-bar') || '';
            if (hs_select_variants_bar) {
              var variant_selected = hs_select_variants_bar.value;
              if (variant_selected) {
                if (Object.keys(HsApp1.popUpProduct).length > 0) {
                  var variant = HsApp1.popUpProduct.variants.find((variant) => {
                    return +variant.id == +variant_selected
                  });
                  if (variant) {
                    var compare_price_popup = hs_popUp_product.querySelector('.hs-compare-price-sw') || '';
                    var price_popup = hs_popUp_product.querySelector('.hs-price-sw') || '';
                    if (!!compare_price_popup) {
                      compare_price_popup.innerHTML = '';
                    };
                    if (!!price_popup) {
                      price_popup.innerHTML = '';
                    }
                    if (variant.selling_plan_allocations.length > 0) {
                      var label_subscription = /* Hs_CartDrawer.withSubOnly; */Hs_CartDrawer.curlyReplaceRc();
                      var hs_subscription_input = !!hs_popUp_product.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? hs_popUp_product.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
                      var price = variant.price;
                      var compareatprice = variant.compare_at_price || 0;


                      //COMMENT CAMBIO DE LAS OPCIONES DEL SELECT PLAN
                      /*  variant.selling_plan_allocations.forEach((selling_plan_allocations) => {
                        if (+selling_plan_allocations.selling_plan_id == +hs_popup_select_subscribe_options.value) {
                          selling_plan_allocations.selling_plans.forEach((selling_plan) => {
                            var price_adjustments = '';
                            if (selling_plan.price_adjustments) {
                              if (selling_plan.price_adjustments.length > 0) {
                                var value = selling_plan.price_adjustments[0].value;
                                var value_type = selling_plan.price_adjustments[0].value_type;
                                if (value && value_type) {
                                  if (value > 0 && value_type === 'percentage') {
                                    price_adjustments = value;
                                  }
                                };
                              };
                            };
                            if (price_adjustments) {
                              label_subscription = Hs_CartDrawer.withSubAndDscto + ' ' + price_adjustments + '%';
                            };
                          });
                        };
                      }); */

                      var selling_plan_allocation_selected = variant.selling_plan_allocations.find((selling_plan_allocation) => {
                        return +selling_plan_allocation.selling_plan_id == +hs_popup_select_subscribe_options.value;
                      });
                      if (selling_plan_allocation_selected) {
                        var selling_plan_selected = selling_plan_allocation_selected.selling_plans.find((selling_plan) => {
                          return +selling_plan.id == +hs_popup_select_subscribe_options.value;
                        });
                        if (selling_plan_selected) {
                          var price_adjustments = '';
                          if (selling_plan_selected.price_adjustments) {
                            if (selling_plan_selected.price_adjustments.length > 0) {
                              var value = selling_plan_selected.price_adjustments[0].value;
                              var value_type = selling_plan_selected.price_adjustments[0].value_type;
                              if (value && value_type) {
                                if (value > 0 && value_type === 'percentage') {
                                  price_adjustments = value;
                                };
                              };
                            };
                          };
                          if (price_adjustments) {
                            label_subscription = Hs_CartDrawer.curlyReplaceRc(price_adjustments + '%');
                          };
                        };

                        /*  */
                        //COMMENT CAMBIO TEXT LABEL SUBSCRIPTION SI TIENE PORCENTAJE
                        if (!!hs_subscription_input) {
                          var hs_subscription = !!hs_subscription_input.closest('.hs-subscription-sub-option') ? hs_subscription_input.closest('.hs-subscription-sub-option') : '';
                          if (!!hs_subscription) {
                            var hs_subcription_label = !!hs_subscription.querySelector('.hs-sub-label') ? hs_subscription.querySelector('.hs-sub-label') : '';
                            if (!!hs_subcription_label) {
                              hs_subcription_label.innerHTML = label_subscription;
                            };
                          };
                          if (!!hs_subscription_input.checked) {
                            if (selling_plan_allocation_selected.price) {
                              price = selling_plan_allocation_selected.price;
                            };
                            if (selling_plan_allocation_selected.compare_at_price) {
                              if (!compareatprice || compareatprice >= selling_plan_allocation_selected.price) {
                                if (selling_plan_allocation_selected.compare_at_price > selling_plan_allocation_selected.price) {
                                  compareatprice = selling_plan_allocation_selected.compare_at_price || 0;
                                };
                              };
                            };
                          };
                        };
                        /*  */
                      };
                    };

                    if (!!slideData.settings.additional_settings.show_compare_price) {
                      if (!!compare_price_popup) {
                        if (typeof compareatprice !== 'undefined') {
                          if (+compareatprice > +price) {
                            //compare_price_active = 'hs-compare-price-active';
                            compare_price_popup.innerHTML = +compareatprice > 0 ? hsonslidecart.Currency.formatMoney(compareatprice, slideData.settings.devices.money_format) : '';
                          };
                        }
                      };
                    }
                    if (price_popup) {
                      if (typeof price !== 'undefined') {
                        if (typeof compareatprice !== 'undefined') {
                          if (compareatprice > price) {
                            price_popup.classList.add('hs-compare-price-active')
                          }
                        } else {
                          price_popup.classList.remove('hs-compare-price-active')
                        }
                        price_popup.innerHTML = price == 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
                      };
                    };

                  };
                };
              };
            };
            /*             var option_selected = this.options[this.selectedIndex];
                        if (typeof option_selected !== 'undefined') {
                          var option_attr = option_selected.dataset.valuePercentage;
                          if (typeof option_attr !== 'undefined') {
                            var hs_subscription_input = !!hs_popUp_product.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? hs_popUp_product.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
                            if (!!hs_subscription_input) {
                              var hs_subscription = !!hs_subscription_input.closest('.hs-subscription-sub-option') ? hs_subscription_input.closest('.hs-subscription-sub-option') : '';
                              if (!!hs_subscription) {
                                var hs_subcription_label = !!hs_subscription.querySelector('.hs-sub-label') ? hs_subscription.querySelector('.hs-sub-label') : '';
                                if (!!hs_subcription_label) {
                                  hs_subcription_label.innerHTML = Hs_CartDrawer.withSubAndDscto + ' ' + option_attr + '%';
                                };
                              };
                            };
                          };
                        }; */
          });
          /* var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          hs_popup_select_subscribe_options.dispatchEvent(evt); */
        };
      };
    };
  },
  changeVariantPopup: function () {
    var variantTitle = '', productId = '';
    var hs_drawer_checkout = !!document.querySelector('.hs-drawer-checkout') ? document.querySelector('.hs-drawer-checkout') : '';
    if (!!hs_drawer_checkout) {
      var hs_options_variants = !!hs_drawer_checkout.querySelector('.hs-options-variants') ? hs_drawer_checkout.querySelector('.hs-options-variants') : '';
      if (!!hs_options_variants) {
        var hs_swipper_select_option_add_to_cart = !!hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') ? hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') : '';
        if (!!hs_swipper_select_option_add_to_cart) {
          variantTitle = hs_swipper_select_option_add_to_cart.options[hs_swipper_select_option_add_to_cart.selectedIndex].getAttribute('title');
          productId = hs_swipper_select_option_add_to_cart.dataset.id;
          if (!!variantTitle) {
            variantTitle = variantTitle.split('/');
            variantTitle.forEach(function (val, index) {
              var titleVariant = Hs_CartDrawer.escape(val.trim());
              var hs_product_option = !!document.querySelector('.hs-product-option') ? document.querySelector('.hs-product-option') : '';
              if (!!hs_product_option) {
                var hs_select_option_popup = !!hs_product_option.querySelector(`.hs-option-${productId}-${index}`) ? hs_product_option.querySelector(`.hs-option-${productId}-${index}`) : '';
                if (!!hs_select_option_popup) {
                  hs_select_option_popup.value = titleVariant;
                  var evt = document.createEvent("HTMLEvents");
                  evt.initEvent("change", false, true);
                  hs_select_option_popup.dispatchEvent(evt);
                }
              }
            });
          }
        }
      }
    }
  },
  createPopUpProduct: function (check, show_quantity_box, identify, condition, upsell, dataProd, dataType, result_item = '', button_parent = '') {
    var popUpProduct = [],
      hs_footer_layout = '',
      hs_product_option = '',
      selectCombobox = '',
      selectParent = '',
      selectVariant = '',
      quantity_box = '',
      add_to_cart = '',
      footer = '',
      parent_class = '',
      status_text_slide_cart = '',
      featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif',
      featured_image_variant = '',
      count_options = 1,
      count_variants = 0,
      filterText1 = '',
      filterText2 = '',
      filterText3 = '',
      options = [],
      variants = [],
      filteredArr1 = [],
      filteredArr2 = [],
      filteredArr3 = [],
      opt1 = [],
      opt2 = [],
      opt3 = [],
      option1 = '',
      option2 = '',
      option3 = '',
      title_variant = '',
      show_only_product_variant_in_stock = 1,
      compare_at_price_sw = '',
      new_url = `/products/`,
      utm = !!slideData.settings.additional_settings.add_utm ? '&utm_source=slide-cart-drawer-upsell' : '',
      upsell_design = !!Hs_CartDrawer.upsell_popUp_design ? ' hs-upsell-design-1' : '';
    //if (HsApp1.readCookie('cart_currency') !== '') {
    if (!!window.Shopify) {
      if (!!window.Shopify.routes) {
        if (!!window.Shopify.routes.root) {
          if (window.Shopify.routes.root !== '/') {
            new_url = window.Shopify.routes.root.concat(`products/`);
          }
        }
      }
    }
    //};
    hs_footer_layout = !!document.querySelector('.hs-footer-layout') ? document.querySelector('.hs-footer-layout') : '';
    if (!!hs_footer_layout) {
      hs_product_option = !!document.querySelector('.hs-product-option') ? document.querySelector('.hs-product-option') : '';
      if (!!hs_product_option) {
        if (!HsApp1.popUpProduct.length) {
          popUpProduct.push(HsApp1.popUpProduct)
        };

        popUpProduct.forEach(function (item) {
          let attr_img = Hs_CartDrawer.escape(`${item.title.replace(/<.*?>/g, '')}`);
          if (item.variants.length > 0 && item.variants[0].title !== "Default Title") {
            attr_img = attr_img + ' - ' + item.variants[0].title.replace(/<.*?>/g, '');
          };
          var selling_group_id = '';
          var selling_plan_options = ``;
          var active_sale_price = '';
          var count_options = 0;
          new_url = new_url + item.handle;
          if (typeof item.selling_plan_groups !== 'undefined') {
            if (item.selling_plan_groups.length > 0) {

              item.selling_plan_groups.forEach((selling_plan_group) => {
                if (typeof selling_plan_group.app_id !== 'undefined') {
                  //294517 => rechargesubscription x variant
                  //null recurpay subscription x product
                  if (selling_plan_group.app_id === '294517' || selling_plan_group.app_id === 'appstle' || selling_plan_group.app_id == null) {
                    if (typeof selling_plan_group.selling_plans !== 'undefined') {
                      if (selling_plan_group.selling_plans.length > 0) {
                        selling_group_id = selling_plan_group.id;
                        selling_plan_group.selling_plans.forEach(function (selling_opt) {
                          var price_adjustments = '';
                          if (typeof selling_opt.price_adjustments !== 'undefined') {
                            if (selling_opt.price_adjustments.length > 0) {
                              var value = selling_opt.price_adjustments[0].value;
                              var value_type = selling_opt.price_adjustments[0].value_type;
                              if (typeof value !== 'undefined' && typeof value_type !== 'undefined') {
                                if (value > 0 && value_type === 'percentage') {
                                  price_adjustments = `data-value-percentage="${value}"`
                                }
                              };
                            };
                          };
                          count_options++
                          selling_plan_options = selling_plan_options + `<option value="${selling_opt.id}" ${price_adjustments}>${selling_opt.name}</option>`
                        });
                      };
                    };
                  };
                };
              });
            };
          };

          var checked = 0;
          if (typeof item.requires_selling_plan !== 'undefined') {
            if (!!item.requires_selling_plan) {
              checked = 1
            };
          };
          var contentSellingPlan = `${Hs_CartDrawer.subscribe_option_upsell ? selling_plan_options !== '' ? `<div class="hs-subscription-content">
                    <div class="hs-subscription-option${!!checked ? ' hs-subscription-only' : ''}">
                    ${!checked ? `
                      <label class="hs-subscription-sub-option">
                        <div class="hs-content-subscription-sub-option">
                          <input type="radio" data-hs-type="hs-chks-once" value="once" ${!!Hs_CartDrawer.subscribe ? '' : 'checked'}>
                          <span class="hs-custom-radio"></span>
                          <span class="hs-sub-label">${Hs_CartDrawer.withOutSub}</span>
                        </div>
                      </label>` : ''}
                      <label class="hs-subscription-sub-option">
                        <div class="hs-content-subscription-sub-option">
                          <input type="radio" data-hs-type="hs-chks-subscribe" value="${selling_group_id}" ${!!checked ? 'checked' : !!Hs_CartDrawer.subscribe ? 'checked' : ''}>
                          <span class="hs-custom-radio"></span>
                          <span class="hs-sub-label">${Hs_CartDrawer.curlyReplaceRc()}</span>
                        </div>
                      </label>
                    </div>
                    <div class="hs-frequency-option ${!!checked ? '' : 'hs-hidden'}">
                      <select name="hs-selling_plan" data-count-options='${count_options}'>
                      ${selling_plan_options}
                      </select>
                    </div>
                  </div>` : '' : ''}`;
          var count_options = 1, variantsAvailable = [], iniArray = '';
          count_variants = variants.length;
          if (typeof item.error === "undefined") {
            featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
            if (item.featured_image !== null) {
              featured_image = HsApp1.resizeSrc(item.featured_image, slideData.settings.additional_settings.image_quality);
            }
            if (condition === 'collection') {
              if (item.images !== null && item.images.length > 0) {

                featured_image = HsApp1.resizeSrc(item.images[0].src, slideData.settings.additional_settings.image_quality);
              }
            }
            selectParent = '';
            selectVariant = '';
            featured_image_variant = '';
            opt1 = [],
              opt2 = [],
              opt3 = [],
              count_options = 1;
            count_variants = item.variants.length;
            item.variants.forEach(function (n) {
              let attr_img = Hs_CartDrawer.escape(`${item.title.replace(/<.*?>/g, '')}`);
              if (n.title !== "Default Title") {
                attr_img = attr_img + ' - ' + n.title.replace(/<.*?>/g, '');
              };
              option1 = '',
                option2 = '',
                option3 = '',
                count_options = n.options.length;
              n.options.forEach(function (w, u) {
                if (u == 0) {
                  option1 = w;
                }
                if (u == 1) {
                  option2 = w;
                }
                if (u == 2) {
                  option3 = w;
                }
              });
              if (option1.length > 0) {
                opt1.push(option1);
              }
              if (option2.length > 0) {
                opt2.push(option2);
              }
              if (option3.length > 0) {
                opt3.push(option3);
              }
              featured_image_variant = '';
              if (n.featured_image !== null) {
                featured_image_variant = HsApp1.resizeSrc(n.featured_image.src, slideData.settings.additional_settings.image_quality);
              }


              var url_parameter = new_url + '?variant=' + n.id + utm
              if (parseInt(show_only_product_variant_in_stock)) {
                if (!!n.available) {
                  variantsAvailable.push(n);
                  //selectParent = selectParent.concat('<option value="' + n.id + '" title="' + n.title + '" data-id="' + item.id + '" data-name="' + n.name + '"  data-price="' + n.price + '" data-sku="' + n.sku + '" data-available="' + n.available + '" data-handle="/products/' + item.handle + '" data-barcode="' + n.barcode + '" data-featuredimage="' + featured_image_variant + '" data-inventorymanagement="' + n.inventory_management + '" data-compareatprice="' + n.compare_at_price + '" data-variantid="' + n.id + '">' + n.title + '</option>');
                  selectParent = selectParent.concat(`<option value='${n.id}' data-id='${item.id}' data-attr='${attr_img}' data-name='${n.name}'  data-price='${n.price}' data-sku='${n.sku}' data-available='${n.available}' data-handle='${url_parameter}' data-barcode='${n.barcode}' data-featuredimage='${featured_image_variant}' data-inventorymanagement='${n.inventory_management}' data-compareatprice='${n.compare_at_price}' data-variantid='${n.id}'>${n.title}</option>`);
                }
              } else {
                selectParent = selectParent.concat(`<option value='${n.id}' data-id='${item.id}' data-attr='${attr_img}' data-name='${n.name}' data-price='${n.price}' data-sku='${n.sku}' data-available='${n.available}' data-handle='${url_parameter}' data-barcode='${n.barcode}' data-featuredimage='${featured_image_variant}' data-inventorymanagement='${n.inventory_management}' data-compareatprice='${n.compare_at_price}' data-variantid='${n.id}'>${n.title}</option>`);
                //selectParent = selectParent.concat('<option value="' + n.id + '" title="' + n.title + '" data-id="' + item.id + '"  data-name="' + n.name + '" data-price="' + n.price + '" data-sku="' + n.sku + '" data-available="' + n.available + '" data-handle="/products/' + item.handle + '" data-barcode="' + n.barcode + '" data-featuredimage="' + featured_image_variant + '" data-inventorymanagement="' + n.inventory_management + '" data-compareatprice="' + n.compare_at_price + '" data-variantid="' + n.id + '">' + n.title + '</option>');
              }
            });
            filterText1 = '';
            filterText2 = '';
            filterText3 = '';
            selectParent = '<select name="hiddenProductVariants" class="hs-select-variants-bar" style="display:none;">' + selectParent + '</select>';
            filteredArr1 = opt1.filter(function (item, index) {
              if (opt1.indexOf(item) == index)
                return item;
            });
            filteredArr2 = opt2.filter(function (item, index) {
              if (opt2.indexOf(item) == index)
                return item;
            });
            filteredArr3 = opt3.filter(function (item, index) {
              if (opt3.indexOf(item) == index)
                return item;
            });
            if (item.variants.length > 0 || variantsAvailable.length > 0) {
              if (filteredArr1.length > 0) {
                hidden_variant = '';
                filteredArr1.forEach(function (v, i) {

                  if (count_variants == 1) {
                    if (v == 'Default Title') {
                      hidden_variant = ' hs-hidden-select---variants';
                    }
                  }
                  var a = '';
                  if (result_item !== '') {
                    result_item.variant_options.forEach(function (opt) {
                      if (v === opt) {
                        a = 'selected';
                      }
                    });
                  };
                  filterText1 = filterText1.concat('<option ' + a + ' value="' + Hs_CartDrawer.escape(v) + '" data-id="' + item.id + '">' + v + '</option>');
                })
                filterText1 = `<div class="hs-select-box-load ${hidden_variant} hs-load-select-box-bar-${count_options} ${upsell_design}">
                                      <span id="hs-option-${item.options[0].name.replace(' ', '-')}">${item.options[0].name}${!!Hs_CartDrawer.upsell_popUp_design ? ':' : ''}</span>
                                      <select aria-labelledby="hs-option-${item.options[0].name.replace(' ', '-')}" class="hs-option-${item.id}-0 hs-select-option-popup" name="itemProdcuctVariant">${filterText1}</select>
                                      </div>`;
              };

              if (filteredArr2.length > 0) {
                filteredArr2.forEach(function (v, i) {
                  var a = '';
                  if (result_item !== '') {
                    result_item.variant_options.forEach(function (opt) {
                      if (v === opt) {
                        a = 'selected';
                      }
                    });
                  };
                  filterText2 = filterText2.concat('<option ' + a + ' value="' + Hs_CartDrawer.escape(v) + '" data-id="' + item.id + '">' + v + '</option>');
                });

                filterText2 = `<div class="hs-select-box-load hs-load-select-box-bar-${count_options} ${upsell_design}">
                                      <span id="hs-option-${item.options[1].name.replace(' ', '-')}">${item.options[1].name}${!!Hs_CartDrawer.upsell_popUp_design ? ':' : ''}</span>
                                      <select aria-labelledby="hs-option-${item.options[1].name.replace(' ', '-')}" class="hs-option-${item.id}-1 hs-select-option-popup" name="itemProdcuctVariant">${filterText2}</select>
                                      </div>`;
              };

              if (filteredArr3.length > 0) {
                filteredArr3.forEach(function (v, i) {
                  var a = '';
                  if (result_item !== '') {
                    result_item.variant_options.forEach(function (opt) {
                      if (v === opt) {
                        a = 'selected';
                      }
                    });
                  };
                  filterText3 = filterText3.concat('<option ' + a + ' value="' + Hs_CartDrawer.escape(v) + '" data-id="' + item.id + '">' + v + '</option>');
                });
                filterText3 = `<div class="hs-select-box-load hs-load-select-box-bar-${count_options} ${upsell_design}">
                                      <span id="hs-option-${item.options[2].name.replace(' ', '-')}">${item.options[2].name}${!!Hs_CartDrawer.upsell_popUp_design ? ':' : ''}</span>
                                      <select aria-labelledby="hs-option-${item.options[2].name.replace(' ', '-')}" class="hs-option-${item.id}-2 hs-select-option-popup" name="itemProdcuctVariant">${filterText3}</select>
                                      </div>`;
              };
            };

            parent_class = '';
            if (item.variants.length == 1 || variantsAvailable.length == 1) {
              title_variant = item.variants[0].public_title || variantsAvailable[0].public_title;
              parent_class = ' hs-hidden-element';
            };
            selectCombobox = `<select class="hs-swipper-option-parent-${item.id} hs-swipper-select-option-add-to-cart${parent_class}" data-id=${item.id}">${selectParent}</select>`;
            var price_sw = item.variants[0].price;
            if (!!slideData.settings.additional_settings.show_compare_price) {
              compare_at_price_sw = item.variants[0].compare_at_price;
              if (+compare_at_price_sw > +price_sw) {
                active_sale_price = !!Hs_CartDrawer.customize_popUp_sale_price ? ' hs-active-sale-price' : '';
                compare_at_price_sw = `${hsonslidecart.Currency.formatMoney(compare_at_price_sw, slideData.settings.devices.money_format)}`;
              } else {
                compare_at_price_sw = '';
              }
            };

            quantity_box = `
                          <div class="hs-qty-upsell">
                          <div class="hs-item-cart-content-quantity-upsell">
                          <div class="hs-item-cart-qty-upsell">
                  <div class="hs-cart-plus-minus-upsell">
                          <div class=" hs-dec-upsell hs-qtybutton-upsell " role="button" tabindex="0" aria-label="minus">
                          <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg>
                          </div>
                          <input type="text" maxlength="4" value="1" ${dataType !== '' ? `data-prod='${dataType}'` : ``}>
                          <div class="hs-inc-upsell hs-qtybutton-upsell" role="button" tabindex="0" aria-label="plus">
                          <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                          </div>
                          </div>
                          </div>
                          </div>
                          </div>`;

            if (upsell === 'tiered') {
              if (typeof slideData.settings.tiered_free_items !== 'undefined') {
                if (!slideData.settings.tiered_free_items.tfi_show_quantity_box && !identify) {
                  quantity_box = '';
                }
              } else {
                quantity_box = '';
              }
            }
            else if (upsell === 'gift_wrap') {
              quantity_box = '';
            } else {
              if (!slideData.settings.additional_settings.show_quantity_box_upsells && !identify) {
                quantity_box = '';
              };
            };

            if (typeof dataType !== 'undefined') {
              if (dataType === 'free_gift') {
                quantity_box = '';
              }
            };
            var url_prod = '', with_href = '';
            if (upsell === 'empty') {
              url_prod = !!parseInt(slideData.settings.cart_empty.cart_empty_upsell_product_url) ? 'href="' + new_url + '"' : "";
              with_href = !!parseInt(slideData.settings.cart_empty.cart_empty_upsell_product_url) ? ' hs-link' : "";
            };
            if (upsell === 'automatic') {
              url_prod = !!parseInt(slideData.settings.product_recommendations_settings.upsell_product_url_automatic) ? 'href="' + new_url + '"' : "";
              with_href = !!parseInt(slideData.settings.product_recommendations_settings.upsell_product_url_automatic) ? ' hs-link' : "";
            };
            if (upsell === 'manually') {
              url_prod = !!parseInt(slideData.settings.manually_products_upsells.upsell_product_url_manually) ? 'href="' + new_url + '"' : "";
              with_href = !!parseInt(slideData.settings.manually_products_upsells.upsell_product_url_manually) ? ' hs-link' : "";
            };
            if (upsell === 'static') {
              url_prod = !!parseInt(slideData.settings.static_products_upsells.upsell_product_url_static) ? 'href="' + new_url + '"' : "";
              with_href = !!parseInt(slideData.settings.static_products_upsells.upsell_product_url_static) ? ' hs-link' : "";
            };
            if (upsell === 'tiered') {
              if (item.type !== 'free_gift') {
                url_prod = typeof slideData.settings.tiered_free_items !== 'undefined' ? !!parseInt(slideData.settings.tiered_free_items.tfi_product_url_automatic) ? 'href="' + new_url + '"' : "" : 'href="' + new_url + '"';
                with_href = typeof slideData.settings.tiered_free_items !== 'undefined' ? !!parseInt(slideData.settings.tiered_free_items.tfi_product_url_automatic) ? ' hs-link' : "" : ' hs-link';
              };
            };

            price_sw = `<div class="hs-price-sw ${active_sale_price}">${price_sw <= 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price_sw, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(price_sw, slideData.settings.devices.money_format)}</div>`;

            add_to_cart = `
                  <div class="hs-popup-button-full">
                    <button
                    title = "${slideData.settings.language_settings.add_to_cart_language_settings}" class="hs-checkout-bar-add-to-cart btn" ${dataType !== '' ? `data-prod='${dataType}'` : ''}
                    aria-label="Add product to cart">
                      <span class="hs-add--to--cart">${slideData.settings.language_settings.add_to_cart_language_settings}</span>
                      <span class="hs--loading">${HsApp4.loadSvg()}</span>
                    </button>
                  </div>`

            const footer_popUp = (quantity_box, add_to_cart) => {
              var footer = quantity_box + add_to_cart;
              if (quantity_box && add_to_cart) {
                footer = `
                        <div class="hs-product-popup-footer">
                          ${quantity_box + add_to_cart}
                        </div>`
              };
              return footer
            };
            footer = footer_popUp(quantity_box, add_to_cart);

            status_text_slide_cart = status_text_slide_cart.concat(`
                      <div class="hs-product-popup-header-close">
                      <span style="cursor:pointer;"class="hs-product-popup-close" role="button" tabindex="0" aria-label="Close product modal">${HsApp1.iconCloseSlideCart}</span></div>
                      <header class="hs-product-popup-header${with_href}">
                        <div class="hs-product-popup-image">
                          <a ${url_prod}>
                            <img alt='${attr_img}' src="${featured_image}"/>
                          </a>
                        </div>
                        <div class="hs-product-popup-text">
                          <div class="hs-product-popup-title">
                            <h2>
                              <a ${url_prod} class="hs-product-link-image">
                                ${item.title}
                              </a>
                            </h2>
                            <p class="hs-product-popup-variant">
                              ${title_variant}
                            </p>
                          </div>
                          <div class="hs-content-price-swiper">
                            <div class="hs-options-prices">
                              <div class="hs-compare-price-sw">${compare_at_price_sw}</div>
                              ${price_sw}
                            </div>
                          </div>
                        </div>
                      </header>
                      ${contentSellingPlan}
                      <div class="hs-popup-select-options">
                      ${filterText1}${filterText2}${filterText3}
                      </div>
                      ${selectParent}
                      ${footer}
                      `);
          }
        });
        hs_product_option.innerHTML = `<div class="hs-popUp-overlay" aria-hidden="true"></div>
                  <div class="hs-popUp-product" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="hs-product-popup-title" aria-describedby="hs-product-popup-desc">
                    ${status_text_slide_cart}
                  </div>`;

        var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
        if (!!hs_popUp_overlay) {
          setTimeout(function () {
            hs_popUp_overlay.classList.add('hs-popUp-active');
          }, 100);
        }

        var hs_popUp_product = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
        if (!!hs_popUp_product) {
          setTimeout(function () {
            hs_popUp_product.classList.add('hs-popUp-active');
            try {
              Hs_CartDrawer.removeTrapFocus();
              const containerToTrapFocusOn = hs_popUp_product || '';
              if (!containerToTrapFocusOn) {
                return false
              };
              const focusElement = hs_popUp_product;
              if (containerToTrapFocusOn) {
                Hs_CartDrawer.trapFocus(containerToTrapFocusOn, focusElement);
              };
            } catch (error) {
              console.log(error)
            };
          }, 100);
          var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
          if (!!hs_popUp_overlay) {
            function closePopUp() {

              if (button_parent) {
                try {
                  Hs_CartDrawer.removeTrapFocus();
                  const containerToTrapFocusOn = document.querySelector('.hs-popup-cart-sp-load.hs-active') || '';
                  if (!containerToTrapFocusOn) {
                    return false
                  };
                  const focusElement = button_parent;
                  if (containerToTrapFocusOn) {
                    Hs_CartDrawer.trapFocus(containerToTrapFocusOn, focusElement);
                  };
                } catch (error) {
                  console.log(error)
                };
              };

              hs_popUp_overlay.classList.remove('hs-popUp-active');
              hs_popUp_product.classList.remove('hs-popUp-active');
              HsApp1.popUpProduct = [];
              setTimeout(function () {
                hs_product_option.innerHTML = '';
              }, 200);
              if (identify == 1) {
                check.checked = false;
              };

            };
            window.hsClosePopUp = closePopUp;
            if (!hs_popUp_overlay.classList.contains('hs-event-static')) {
              hs_popUp_overlay.classList.add('hs-event-static');
              hs_popUp_overlay.addEventListener('click', function (e) {
                e.preventDefault();
                closePopUp();
              });
            };

            let hs_product_popup_close = document.querySelector('span.hs-product-popup-close') || '';
            if (hs_product_popup_close) {
              if (!hs_product_popup_close.classList.contains('hs-event-static')) {
                hs_product_popup_close.classList.add('hs-event-static');
                hs_product_popup_close.addEventListener('click', function (e) {
                  e.preventDefault();
                  closePopUp();
                });

                hs_product_popup_close.addEventListener('keydown', function (e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    closePopUp();
                  };
                });
              };
            };
          };
        };

        if (upsell !== 'tiered') {
          if (!identify && !!slideData.settings.additional_settings.show_quantity_box_upsells) {
            HsApp1.quantityBoxPopUp(upsell);
          }
        }
        else {
          if (typeof slideData.settings.tiered_free_items !== 'undefined') {
            if (!!slideData.settings.tiered_free_items.tfi_show_quantity_box && !identify) {
              HsApp1.quantityBoxPopUp(upsell);
            };
          };
        };

        function activeSubscribe() {
          if (!!Hs_CartDrawer.subscribe && !!Hs_CartDrawer.subscribe_option_upsell) {
            var popUpActive = !!document.querySelector('.hs-popUp-product') ? document.querySelector('.hs-popUp-product') : '';
            if (!!popUpActive) {
              var hs_chks_subscribe = !!popUpActive.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? popUpActive.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
              if (!!hs_chks_subscribe) {
                var ev = new Event("click", { "bubbles": true, "cancelable": false });
                hs_chks_subscribe.dispatchEvent(ev);
              };
            };
          };
        };

        HsApp1.changeVariantsPopUp(identify, condition, upsell, dataProd, button_parent);//CAPTURE CHANGE IN 'SELECTS' FROM hs-popUp-product.
        HsApp1.changeVariantPopup(identify, condition);//CHANGE SELECT FROM hs-popUp-product WHERE HE STAYED.
        activeSubscribe();
        HsApp1.currencyConverter();
      }
    }
  },
  updateMinimumOrder: function () {
    var hidden_min_price = '',
      status_price_checkout = '',
      total_price = HsApp1.cartPrice,
      min_money = parseFloat(slideData.settings.minimum_order.minimum_order),
      min_money = min_money * 100,
      item_count = window.HSSLIDECART.CART.item_count || 0;
    if (!!slideData.settings.minimum_order.enabled_minimum_order) {
      var hs_checkout_purchase = !!document.querySelector('.hs-checkout-purchase') ? document.querySelector('.hs-checkout-purchase') : '';
      var hs_min_money_cart = !!document.querySelector('.hs-min-money-cart') ? document.querySelector('.hs-min-money-cart') : '';
      var data_minimum_order = HsApp1.caseMinimumOrder(total_price, item_count);
      hidden_min_price = data_minimum_order.hidden_min_price.trim();
      status_price_checkout = data_minimum_order.status_price_checkout;
      hidden_text_cart = data_minimum_order.hidden_text_cart.trim();

      if (!!hs_checkout_purchase) {
        hidden_min_price === '' ? hs_checkout_purchase.classList.remove('hs-hidden-min-price') : hs_checkout_purchase.classList.add(hidden_min_price);
      }
      if (!!hs_min_money_cart) {
        hidden_text_cart === '' ? hs_min_money_cart.classList.remove('hs-hidden-min-price') : hs_min_money_cart.classList.add(hidden_text_cart);
        hs_min_money_cart.innerHTML = status_price_checkout;
      };
    };
  },
  giftWrapCheckSpecific: async function (product, arr_variants, iniJSON) {//CAMBIO
    var giftWrap = '', checkGift = '';
    giftWrap = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
    if (!!giftWrap) {
      checkGift = !!giftWrap.querySelector('.hs-gift-wrap-check') ? giftWrap.querySelector('.hs-gift-wrap-check') : '';
      if (!!checkGift) {
        if (HsApp1.readCookie('hs-giftWrap-check-specific') !== '') {
          checkGift.checked = true;
        }
        else {
          checkGift.checked = false;
        };
        function checkGiftClick(checkGift) {
          if (!!checkGift.checked) {
            var condition = arr_variants.length == 1 ? 0 : 1;
            switch (condition) {
              case 0:
                var hs_options_variants = !!document.querySelector('.hs-options-variants') ? document.querySelector('.hs-options-variants') : '';
                if (!!hs_options_variants) {
                  var hs_swipper_select_option_add_to_cart = !!hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') ? hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') : '';
                  if (!!hs_swipper_select_option_add_to_cart) {
                    var variant = hs_swipper_select_option_add_to_cart.options[hs_swipper_select_option_add_to_cart.selectedIndex].dataset;
                    var arr_cookies = [
                      {
                        name: 'hs-giftWrap-check-specific',
                        value: 1
                      },
                      {
                        name: 'hs-giftWrap-variantId',
                        value: variant.variantid
                      },
                      /*{
                        name: 'hs-giftWrap-variantPrice',
                        value: variant.price
                      },*/
                      {
                        name: 'hs-giftWrap-variantCompareAtPrice',
                        value: variant.compareatprice !== 'null' ? variant.compareatprice > variant.price ? variant.compareatprice : 0 : 0
                      }
                    ];

                    HsApp1.cookieGiftWrap(arr_cookies);
                    //var params = JSON.stringify({id:variant.variantid,quantity:1,properties: {'giftWrap': true}});
                    var params = new FormData();
                    params.append('id', variant.variantid)
                    params.append('quantity', 1)
                    params.append('properties[_giftWrap]', true);
                    giftWrap.classList.add('hs-loading-giftwrap');
                    HsApp3.postMyCart(params, giftWrap, show_loading = 0);
                  }
                };
                break;
              case 1:
                var hs_footer_layout = !!document.querySelector('.hs-footer-layout') ? document.querySelector('.hs-footer-layout') : '';
                if (!!hs_footer_layout) {
                  var hs_product_option = !!hs_footer_layout.querySelector('.hs-product-option') ? hs_footer_layout.querySelector('.hs-product-option') : '';
                  if (!!hs_product_option) {
                    hs_product_option.style.display = 'block';
                    var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
                    var hs_popUp_product = !!hs_product_option.querySelector('.hs-popUp-product') ? hs_product_option.querySelector('.hs-popUp-product') : '';
                    if (!!hs_popUp_product && !!hs_popUp_overlay) {
                      setTimeout(function () {
                        if (!!hs_popUp_product) {
                          HsApp1.popUpProduct = product;
                          HsApp1.arr_variants_popup = arr_variants;
                          hs_popUp_overlay.classList.add('hs-popUp-active');
                          hs_popUp_product.classList.add('hs-popUp-active');
                        }
                      }, 300);
                    }
                    else {
                      HsApp1.popUpProduct = product;
                      HsApp1.arr_variants_popup = arr_variants;
                      HsApp1.createPopUpProduct(checkGift, 0, 1, '', 'gift_wrap');
                    }
                  }
                }
                break;
            }
          }
          else {
            var hs_options_variants = !!document.querySelector('.hs-options-variants') ? document.querySelector('.hs-options-variants') : '';
            if (!!hs_options_variants) {
              var hs_swipper_select_option_add_to_cart = !!hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') ? hs_options_variants.querySelector('.hs-swipper-select-option-add-to-cart') : '';
              if (!!hs_swipper_select_option_add_to_cart) {
                var variant = HsApp1.readCookie('hs-giftWrap-key');
                var params = JSON.stringify({ id: variant, quantity: 0 });
                giftWrap.classList.add('hs-loading-giftwrap');
                HsApp1.onloadCart(giftWrap, params, undefined);

              }
            }
            Hs_CartDrawer.removeGWSpecific();
          }
        };
        if (!checkGift.classList.contains('hs-event-static')) {
          checkGift.classList.add('hs-event-static');
          checkGift.addEventListener('change', (e) => {
            e.preventDefault();
            checkGiftClick(checkGift);
          });
        };
        var img_check_gift = document.querySelector('.hs-gift-wrap-content-specificProduct-img img') || '';
        if (img_check_gift) {
          if (!img_check_gift.classList.contains('hs-event-static')) {
            img_check_gift.classList.add('hs-event-static');
            img_check_gift.addEventListener('click', (e) => {
              e.preventDefault();
              var hs_gift_wrap_check = !!document.querySelector('.hs-gift-wrap-check') ? document.querySelector('.hs-gift-wrap-check') : '';
              if (hs_gift_wrap_check) {
                hs_gift_wrap_check.checked ? hs_gift_wrap_check.checked = false : hs_gift_wrap_check.checked = true;
                var evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                hs_gift_wrap_check.dispatchEvent(evt);
              };
            });
          };
        }
        await HsApp1.giftWrapAutoAdd(product, iniJSON);//CAMBIO
      }
    }
  },
  giftWrapAutoAdd: async function (product = {}, iniJSON = {}) {//CAMBIO
    if (typeof slideData.settings.gift_wrap !== 'undefined' && typeof slideData.settings.gift_wrap.gift_wrap_auto_add) {
      if (!slideData.settings.gift_wrap.gift_wrap_auto_add) return false;
      if (typeof product === 'object' && Object.keys(product).length > 0 && typeof iniJSON === 'object' && Object.keys(iniJSON).length > 0) {
        const cart = iniJSON;
        let propGiftWrap = false;
        if (Array.isArray(cart.items) && cart.items.length > 0) {
          propGiftWrap = cart.items.some(item =>
            item.properties &&
            typeof item.properties === 'object' &&
            Object.entries(item.properties).some(
              ([key, value]) => key === '_giftWrap' && value === 'true'
            )
          );
          if (!propGiftWrap) {
            if (product?.variants?.length > 0) {
              let variant = product?.variants[0] || [];
              if (typeof variant === 'object' && Object.keys(variant).length > 0) {
                let price = variant.price;
                if ((typeof price !== 'undefined' && price == 0) || (typeof window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] !== 'undefined' && window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] == 1)) {
                  var giftWrap = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
                  giftWrap.classList.add('hs-loading-giftwrap');
                  Hs_CartDrawer.iniAddShipping = true;
                  var cartRoute = Hs_CartDrawer.routeLocale('cart/add.js');
                  var params = new FormData();
                  params.append("id", variant.id);
                  params.append('properties[_giftWrap]', true)
                  params.append("quantity", 1);
                  await fetch(`${cartRoute}`,
                    {
                      body: params,
                      method: 'POST',
                      headers: {
                        'Accept': "application/json, text/javascript",
                        'X-Requested-With': 'XMLHttpRequest'
                      },
                    })
                    .then((response) => response.status == 200 && response.json())
                    .then((response) => {
                      var arr_cookies = [
                        {
                          name: 'hs-giftWrap-check-specific',
                          value: 1
                        },
                        {
                          name: 'hs-giftWrap-variantId',
                          value: variant.id
                        },
                        {
                          name: 'hs-giftWrap-variantCompareAtPrice',
                          value: variant.compare_at_price !== 'null' ? variant.compare_at_price > variant.price ? variant.compare_at_price : 0 : 0
                        },
                        {
                          name: 'hs-giftWrap-key',
                          value: response.key
                        }
                      ];
                      HsApp1.cookieGiftWrap(arr_cookies);
                      var hs_gift_wrap_check = !!document.querySelector('.hs-gift-wrap-check') ? document.querySelector('.hs-gift-wrap-check') : '';
                      if (hs_gift_wrap_check) {
                        hs_gift_wrap_check.checked = true;
                      };
                      try {
                        Hs_modal_notification(response.message, response.description, slideData)
                      } catch (error) {
                        alert(`Error ${response.status}: ${response.description}`)
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                      Hs_CartDrawer.iniAddShipping = false;
                      giftWrap.classList.remove('hs-loading-giftwrap');
                    }).then(function (e) {
                      giftWrap.classList.remove('hs-loading-giftwrap');
                      Hs_CartDrawer.iniAddShipping = false;
                      var paramsFunction = [
                        {
                          "name": 'addToCart',
                          "attr": {
                            "id": parseInt(variant.id),
                            "quantity": 1
                          }
                        }];
                      HsApp1.getMyCart(0, paramsFunction);
                    });
                };
              };
            };
          };
        };
      };
    };
  },
  giftWrapSpecificProduct: async function (iniJSON) {//CAMBIO
    var count = 0, hs_product = [], arrVariantsGiftWrap = [], show_only_product_variant_in_stock = 1;
    var product = Hs_CartDrawer.routeLocale(`products/${slideData.settings.gift_wrap.featured_product_shopify_handle}.js`);
    try {
      const response = await fetch(`${product}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw response;

      product = await response.json();
      if (product) {
        hs_product = product;
        var selectParent = '', featured_image_variant = '', parent_class = '', variants_ids = slideData.settings.gift_wrap.featured_product_shopify_id_variants.split(","), featured_image = '';
        product.variants.forEach(function (variants) {
          variants_ids.forEach(function (variant_id) {
            if (parseInt(show_only_product_variant_in_stock)) {
              if (!!variants.available) {
                if (variant_id == variants.id) {
                  arrVariantsGiftWrap.push(variants)
                }
              }
            }
          });
        });
        product.variants = arrVariantsGiftWrap;
        if (arrVariantsGiftWrap.length < 1) {
          var hs_drawer_checkout = !!document.querySelector('.hs-drawer-checkout') ? document.querySelector('.hs-drawer-checkout') : '';
          if (!!hs_drawer_checkout) {
            var hs_options_variants = !!hs_drawer_checkout.querySelector('.hs-options-variants') ? hs_drawer_checkout.querySelector('.hs-options-variants') : '';
            var hs_gift_wrap = !!hs_drawer_checkout.querySelector('.hs-gift-wrap') ? hs_drawer_checkout.querySelector('.hs-gift-wrap') : '';
            if (!!hs_options_variants) {
              hs_drawer_checkout.removeChild(hs_options_variants);
            }
            if (!!hs_gift_wrap) {
              hs_drawer_checkout.removeChild(hs_gift_wrap);
            }
            return false;
          }
        };

        if (typeof slideData.settings.gift_wrap.featured_product_show_image !== 'undefined') {
          switch (slideData.settings.gift_wrap.featured_product_show_image) {
            case 1:
              featured_image = `<img src="//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif" alt="">`;
              if (typeof product.images !== 'undefined') {
                if (product.images.length > 0) {
                  featured_image = `<img src="${product.images[0]}" alt="${product.title.replace('"', "'")}">`;
                };
              };
              break;
            case 2:
              featured_image = slideData.settings.gift_wrap.icon;
              break;
            default:
              break;
          }
        };

        if (arrVariantsGiftWrap.length == 1) {
          var hs_drawer_checkout = !!document.querySelector('.hs-drawer-checkout') ? document.querySelector('.hs-drawer-checkout') : '';
          if (!!hs_drawer_checkout) {
            selectParent = selectParent.concat(`
                            <option value='${arrVariantsGiftWrap[0].id}' title='${arrVariantsGiftWrap[0].title}' data-id='${arrVariantsGiftWrap[0].id}' data-name='${arrVariantsGiftWrap[0].name}' data-price='${arrVariantsGiftWrap[0].price}' data-sku='${arrVariantsGiftWrap[0].sku}' data-available='${arrVariantsGiftWrap[0].available}' data-handle='/products/${arrVariantsGiftWrap[0].handle}' data-barcode='${arrVariantsGiftWrap[0].barcode}' data-inventorymanagement='${arrVariantsGiftWrap[0].inventory_management}' data-compareatprice='${arrVariantsGiftWrap[0].compare_at_price}' data-variantid='${arrVariantsGiftWrap[0].id}'>${arrVariantsGiftWrap[0].title}</option>`
            );
            hs_drawer_checkout.insertAdjacentHTML('afterbegin', `<div class='hs-options-variants'><select class="hs-swipper-option-parent-${arrVariantsGiftWrap[0].id} hs-swipper-select-option-add-to-cart hs-hidden-element" data-id="${arrVariantsGiftWrap[0].id}">${selectParent}</select></div>`);
            var hs_gift_wrap_content_specificProduct = !!hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct') ? hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct') : '';
            if (!!hs_gift_wrap_content_specificProduct) {
              var productTitle = '';
              const regex = /{{([^}]*)/g;
              productTitle = regex.exec(slideData.settings.gift_wrap.featured_product_title);
              if (!productTitle) {
                productTitle = slideData.settings.gift_wrap.featured_product_title
              }
              else {
                productTitle = slideData.settings.gift_wrap.featured_product_title.replace(productTitle[1], arrVariantsGiftWrap[0].name).replace(/{{|}}/g, '')
              }
              hs_gift_wrap_content_specificProduct.innerHTML = `<label for="hs_input_check_gift"><span>${productTitle}</span></label>`;
              var hs_gift_wrap_content_specificProduct_img = !!hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-img') ? hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-img') : '';
              if (!!hs_gift_wrap_content_specificProduct_img) {
                hs_gift_wrap_content_specificProduct_img.innerHTML = featured_image;
              };
              var hs_gift_wrap_content_specificProduct_price = !!hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-price') ? hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-price') : '';
              if (!!hs_gift_wrap_content_specificProduct_price) {
                var comparePrice = '';
                if (!!slideData.settings.additional_settings.show_compare_price) {
                  if (arrVariantsGiftWrap[0].compare_at_price === "null") {
                    arrVariantsGiftWrap[0].compare_at_price = 0
                  }
                  comparePrice = `${arrVariantsGiftWrap[0].compare_at_price > arrVariantsGiftWrap[0].price ?
                    `<div class="hs-compare-price-sw">
                                  ${hsonslidecart.Currency.formatMoney(arrVariantsGiftWrap[0].compare_at_price, slideData.settings.devices.money_format)}
                                  </div>` : ``}`
                }
                if (comparePrice) {
                  hs_gift_wrap_content_specificProduct_price.classList.add('hs-has-compare');
                } else {
                  hs_gift_wrap_content_specificProduct_price.classList.remove('hs-has-compare');
                };
                hs_gift_wrap_content_specificProduct_price.innerHTML = `
                            ${comparePrice}
                            <div class="hs-price-sw">
                            ${arrVariantsGiftWrap[0].price <= 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? '<span>' + Hs_CartDrawer.languageFreeGnral + '</span>' : hsonslidecart.Currency.formatMoney(arrVariantsGiftWrap[0].price, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(arrVariantsGiftWrap[0].price, slideData.settings.devices.money_format)}
                            </div>`;
              }
            }
          }
        };
        if (arrVariantsGiftWrap.length > 1) {
          arrVariantsGiftWrap.forEach(function (n) {
            count++;
            if (n.available) {
              if (n.featured_image !== null) {
                featured_image_variant = HsApp1.resizeSrc(n.featured_image.src, slideData.settings.additional_settings.image_quality);
              }
              selectParent = selectParent.concat(`
                            <option value='${n.id}' data-id='${product.id}' data-name='${n.name}' data-price='${n.price}' data-sku='${n.sku}' data-available='${n.available}' data-handle='/products/${product.handle}' data-barcode='${n.barcode}' data-featuredimage='${featured_image_variant}' data-inventorymanagement='${n.inventory_management}' data-compareatprice='${n.compare_at_price}' data-variantid='${n.id}'>${n.title}</option>`
              );
            }
          });
          if (count == arrVariantsGiftWrap.length) {
            if (arrVariantsGiftWrap.length == 1) {
              parent_class = ' hs-hidden-element' || '';
            }
            var hs_drawer_checkout = !!document.querySelector('.hs-drawer-checkout') ? document.querySelector('.hs-drawer-checkout') : '';
            if (!!hs_drawer_checkout) {
              hs_drawer_checkout.insertAdjacentHTML('afterbegin', `<div class='hs-options-variants'><select class="hs-swipper-option-parent-${product.id} hs-swipper-select-option-add-to-cart${parent_class}" data-id="${product.id}">${selectParent}</select></div>`);
              var hs_gift_wrap = !!hs_drawer_checkout.querySelector('.hs-gift-wrap') ? hs_drawer_checkout.querySelector('.hs-gift-wrap') : '';
              if (!!hs_gift_wrap) {
                var hs_swipper_select_option = !!hs_drawer_checkout.querySelector('.hs-swipper-select-option-add-to-cart') ? hs_drawer_checkout.querySelector('.hs-swipper-select-option-add-to-cart') : '';
                if (!!hs_swipper_select_option) {
                  if (!hs_swipper_select_option.classList.contains('hs-event-static')) {
                    hs_swipper_select_option.classList.add('hs-event-static');
                    hs_swipper_select_option.addEventListener('change', (event) => {
                      event.preventDefault();
                      var optGift = hs_swipper_select_option.options[hs_swipper_select_option.selectedIndex];
                      var productTitle = '';
                      const regex = /{{([^}]*)/g;
                      productTitle = regex.exec(slideData.settings.gift_wrap.featured_product_title);
                      if (!productTitle) {
                        productTitle = slideData.settings.gift_wrap.featured_product_title
                      }
                      else {
                        productTitle = slideData.settings.gift_wrap.featured_product_title.replace(productTitle[1], optGift.dataset.name).replace(/{{|}}/g, '')
                      }
                      var hs_gift_wrap_content_specificProduct = !!hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct') ? hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct') : '';
                      if (!!hs_gift_wrap_content_specificProduct) {
                        hs_gift_wrap_content_specificProduct.innerHTML = `<label for="hs_input_check_gift" style="display: inline-block;"><span>${productTitle}</span></label>`;
                      }
                      var hs_gift_wrap_content_specificProduct_img = !!hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-img') ? hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-img') : '';
                      if (!!hs_gift_wrap_content_specificProduct_img) {
                        hs_gift_wrap_content_specificProduct_img.innerHTML = featured_image;
                      };
                      var hs_gift_wrap_content_specificProduct_price = !!hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-price') ? hs_drawer_checkout.querySelector('.hs-gift-wrap-content-specificProduct-price') : '';
                      if (!!hs_gift_wrap_content_specificProduct_price) {
                        var comparePrice = '';
                        if (!!slideData.settings.additional_settings.show_compare_price) {
                          if (optGift.dataset.compareatprice === "null") {
                            optGift.dataset.compareatprice = 0
                          }
                          comparePrice = `${optGift.dataset.compareatprice > optGift.dataset.price ?
                            `<div class="hs-compare-price-sw">
                                          ${hsonslidecart.Currency.formatMoney(optGift.dataset.compareatprice, slideData.settings.devices.money_format)}
                                        </div>` : ``}`
                        }
                        if (comparePrice) {
                          hs_gift_wrap_content_specificProduct_price.classList.add('hs-has-compare');
                        } else {
                          hs_gift_wrap_content_specificProduct_price.classList.remove('hs-has-compare');
                        };
                        hs_gift_wrap_content_specificProduct_price.innerHTML = `
                                      ${comparePrice}
                                      <div class="hs-price-sw">
                                        ${hsonslidecart.Currency.formatMoney(optGift.dataset.price, slideData.settings.devices.money_format)}
                                      </div>`;
                      };

                      if (hs_gift_wrap_content_specificProduct_img) {
                        let this_img = hs_gift_wrap_content_specificProduct_img.querySelector('img') || '';
                        if (this_img) {
                          if (!this_img.classList.contains('hs-event-static')) {
                            this_img.classList.add('hs-event-static');
                            this_img.addEventListener('click', (e) => {
                              e.preventDefault();
                              var hs_gift_wrap_check = !!document.querySelector('.hs-gift-wrap-check') ? document.querySelector('.hs-gift-wrap-check') : '';
                              if (hs_gift_wrap_check) {
                                hs_gift_wrap_check.checked ? hs_gift_wrap_check.checked = false : hs_gift_wrap_check.checked = true;
                                var evt = document.createEvent("HTMLEvents");
                                evt.initEvent("change", false, true);
                                hs_gift_wrap_check.dispatchEvent(evt);
                              };
                            });
                          };
                        };
                      }

                    });
                  }
                  if (!!HsApp1.readCookie('hs-giftWrap-variantId')) {
                    var hs_cookie_variantId = HsApp1.readCookie('hs-giftWrap-variantId');
                    if (!!hs_swipper_select_option.querySelector(`option[value="${hs_cookie_variantId}"]`)) {
                      var giftWrap = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
                      if (!!giftWrap) {
                        var hs_gift_wrap_check = !!document.querySelector('.hs-gift-wrap-check') ? document.querySelector('.hs-gift-wrap-check') : '';
                        if (!!hs_gift_wrap_check) {
                          hs_gift_wrap_check.setAttribute('checked', 'checked');
                        }
                        hs_swipper_select_option.value = hs_cookie_variantId;
                      }
                    }
                  }
                  var evt = document.createEvent("HTMLEvents");
                  evt.initEvent("change", false, true);
                  hs_swipper_select_option.dispatchEvent(evt);

                }
              }
            };
          };
        }
        var giftWrap = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
        if (!!giftWrap) {
          giftWrap.style.display = 'flex';
        }
      };
      await HsApp1.giftWrapCheckSpecific(hs_product, arrVariantsGiftWrap, iniJSON);//CAMBIO

    } catch (err) {
      count++;
      console.error(err);
    }
  },
  giftWrapCustomProduct: function () {
    HsApp1.giftWrapCustomCheck();
    var hs_gift_wrap_custom = !!document.querySelector('.hs-gift-wrap-custom') ? document.querySelector('.hs-gift-wrap-custom') : '';
    if (!!hs_gift_wrap_custom) {
      hs_gift_wrap_custom.style.display = 'flex';
      var hs_gift_wrap_check = !!hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') : '';
      if (!!hs_gift_wrap_check) {
        var hs_gift_wrap_offer = !!hs_gift_wrap_custom.querySelector('.hs-input-gift-lbl') ? hs_gift_wrap_custom.querySelector('.hs-input-gift-lbl') : '';
        if (!!hs_gift_wrap_offer) {
          if (!hs_gift_wrap_offer.classList.contains('hs-event-static')) {
            hs_gift_wrap_offer.classList.add('hs-event-static');
            hs_gift_wrap_offer.addEventListener('change', function (e) {
              if (!!hs_gift_wrap_check.checked) {
                hs_gift_wrap_check.checked = false;
              } else {
                hs_gift_wrap_check.checked = true;
              };
              /* var evt = document.createEvent("HTMLEvents");
              evt.initEvent("click", false, true); */
              hs_gift_wrap_check.click();
            });
          }
        };
      };
    };
  },
  giftWrapUpdates: function (identify) {
    var amount = identify > 1 ? identify : 0;
    var hs_sub_total_cart = !!document.querySelector('.hs-sub-total-cart ') ? document.querySelector('.hs-sub-total-cart ') : '';
    if (!!hs_sub_total_cart) {
      if (!!hs_sub_total_cart.classList.contains('hs-payment-discount')) {
        var hs_subtotal_amount_discount = !!hs_sub_total_cart.querySelector('.hs_subtotal_amount_discount') ? hs_sub_total_cart.querySelector('.hs_subtotal_amount_discount') : '';
        var hs_discount_price_global = !!document.querySelector('.hs-discount-price-global') ? document.querySelector('.hs-discount-price-global').value : 0;
        var hs_total_price_global = !!document.querySelector('.hs-total-price-global') ? document.querySelector('.hs-total-price-global').value : 0;
        //var total_price = parseInt(hs_total_price_global);
        var total_price = HsApp1.rewardsExcludeProd(window.HSSLIDECART.CART);

        if (!!hs_subtotal_amount_discount) {
          hs_subtotal_amount_discount.innerHTML = hsonslidecart.Currency.formatMoney(parseInt(hs_discount_price_global) + parseInt(amount), slideData.settings.devices.money_format);
          if (!!slideData.settings.rewards.enabled_rewards) {
            /* if (typeof slideData.settings.rewards.rewards_bar_no_dscto !== 'undefined') {
              if (!slideData.settings.rewards.rewards_bar_no_dscto) {
                total_price = parseInt(hs_discount_price_global) + parseInt(amount);
              }
            }; */
            /* if (typeof slideData.settings.rewards.rewards_bar_no_dscto !== 'undefined') {
              if (!slideData.settings.rewards.rewards_bar_no_dscto) {
                total_price = total_price + parseInt(amount);
              }
            }; */
            HsApp1.rewardsBar(total_price + parseInt(amount));
          };
        };

        var hs_content_subtotal_checkout = !!document.querySelector('.hs-content-subtotal-checkout') ? document.querySelector('.hs-content-subtotal-checkout') : '';
        if (!!hs_content_subtotal_checkout) {
          hs_content_subtotal_checkout.innerHTML = hsonslidecart.Currency.formatMoney(parseInt(hs_discount_price_global) + parseInt(amount), slideData.settings.devices.money_format)
        };

        if (!!slideData.settings.additional_settings.show_compare_price) {
          var hs_subtotal_amount = !!hs_sub_total_cart.querySelector('.hs_subtotal_amount') ? hs_sub_total_cart.querySelector('.hs_subtotal_amount') : '';
          if (!!hs_subtotal_amount) {
            var sum_compare_at_price = 0;
            if (amount > 0) {
              sum_compare_at_price = parseInt(HsApp1.priceGiftWrap);
            }
            var hs_total_price_global = !!document.querySelector('.hs-total-price-global') ? document.querySelector('.hs-total-price-global').value : 0;
            var compare_price = parseInt(hs_total_price_global) + sum_compare_at_price;

            window.HSSLIDECART.SUB_TOTAL = compare_price;

            hs_subtotal_amount.innerHTML = hsonslidecart.Currency.formatMoney(compare_price, slideData.settings.devices.money_format);
          }
        };
      }
      else if (!!hs_sub_total_cart.classList.contains('hs-run-discount-automatic')) {
        var hs_subtotal_discount_automatic = !!hs_sub_total_cart.querySelector('.hs_subtotal_discount_automatic') ? hs_sub_total_cart.querySelector('.hs_subtotal_discount_automatic') : '';

        if (!!hs_subtotal_discount_automatic) {
          total_price = parseInt(HsApp1.cartComparePrice);
          var hs_total_price_global = !!document.querySelector('.hs-total-price-global') ? document.querySelector('.hs-total-price-global').value : '';
          if (!!hs_total_price_global) {
            var this_amount = parseInt(hs_total_price_global) + amount;

            window.HSSLIDECART.DISCOUNT_TOTAL_PRICE = this_amount;

            hs_subtotal_discount_automatic.innerHTML = hsonslidecart.Currency.formatMoney(this_amount, slideData.settings.devices.money_format);
          };

          var sum_compare_at_price = 0;
          if (amount > 0) {
            sum_compare_at_price = parseInt(HsApp1.priceGiftWrap);
          };
          var hs_discount_price_global = !!document.querySelector('.hs-discount-price-global') ? document.querySelector('.hs-discount-price-global').value : 0;
          var compare_price = parseInt(hs_discount_price_global) + sum_compare_at_price;

          window.HSSLIDECART.SUB_TOTAL = compare_price;

          var new_amount = hsonslidecart.Currency.formatMoney(compare_price, slideData.settings.devices.money_format);

          var hs_subtotal_amount = !!hs_sub_total_cart.querySelector('.hs_subtotal_amount') ? hs_sub_total_cart.querySelector('.hs_subtotal_amount') : '';
          if (!!hs_subtotal_amount) {
            hs_subtotal_amount.innerHTML = new_amount;
          };

          var hs_content_subtotal_checkout = !!document.querySelector('.hs-content-subtotal-checkout') ? document.querySelector('.hs-content-subtotal-checkout') : '';
          if (!!hs_content_subtotal_checkout) {
            hs_content_subtotal_checkout.innerHTML = new_amount;
          };
          hs_total_price_global = HsApp1.rewardsExcludeProd(window.HSSLIDECART.CART);
          if (!!slideData.settings.rewards.enabled_rewards) {
            /* if (typeof slideData.settings.rewards.rewards_bar_no_dscto !== 'undefined') {
              if (!slideData.settings.rewards.rewards_bar_no_dscto) {
                hs_total_price_global = compare_price;
              }
            }; */
            HsApp1.rewardsBar(hs_total_price_global + sum_compare_at_price);
          };
        };
      } else {
        var hs_subtotal_amount = !!document.querySelector('.hs_subtotal_amount') ? document.querySelector('.hs_subtotal_amount') : '';
        var total_price = parseInt(HsApp1.cartPrice);
        var cartComparePrice = parseInt(HsApp1.cartComparePrice);
        var comparePriceGiftWrap = parseInt(HsApp1.comparePriceGiftWrap);
        total_price += parseInt(amount);

        window.HSSLIDECART.SUB_TOTAL = total_price;

        let new_amount = hsonslidecart.Currency.formatMoney(total_price, slideData.settings.devices.money_format);
        if (!!hs_subtotal_amount) {
          hs_subtotal_amount.innerHTML = new_amount;
        };
        var hs_content_subtotal_checkout = !!document.querySelector('.hs-content-subtotal-checkout') ? document.querySelector('.hs-content-subtotal-checkout') : '';
        if (!!hs_content_subtotal_checkout) {
          hs_content_subtotal_checkout.innerHTML = new_amount
        };

        if (!!slideData.settings.additional_settings.show_compare_price) {
          var hs_subtotal_compare_at_price = !!document.querySelector('.hs_subtotal_compare_at_price') ? document.querySelector('.hs_subtotal_compare_at_price') : '';
          if (!!hs_subtotal_compare_at_price) {
            var sum_compare_at_price = 0;
            if (amount > 0) {
              sum_compare_at_price = comparePriceGiftWrap;
            };
            var compare_price = cartComparePrice + sum_compare_at_price;
            if (compare_price == 0 || (compare_price <= parseInt(HsApp1.cartPrice))) {
              window.HSSLIDECART.COMPARE_AT_PRICE = 0;
              hs_subtotal_compare_at_price.innerHTML = '';
            }
            else {
              if (total_price < compare_price) {
                window.HSSLIDECART.COMPARE_AT_PRICE = !!compare_price ? compare_price : 0;
                hs_subtotal_compare_at_price.innerHTML = hsonslidecart.Currency.formatMoney(compare_price, slideData.settings.devices.money_format);
              }
            }
          };
        };

        if (!!slideData.settings.rewards.enabled_rewards) {
          let total_price = HsApp1.rewardsExcludeProd(window.HSSLIDECART.CART);
          HsApp1.rewardsBar(total_price + parseInt(amount));
        };
      }
    };
    HsApp1.currencyConverter();
    HsApp1.updateDynamicPrice();
  },
  giftWrapCustomCheck: function () {
    var hs_gift_wrap_custom = !!document.querySelector('.hs-gift-wrap-custom') ? document.querySelector('.hs-gift-wrap-custom') : '';
    if (!!hs_gift_wrap_custom) {
      HsApp1.comparePriceGiftWrap = parseFloat(slideData.settings.gift_wrap.offer_compare_price * 100).toFixed(2);//val price giftwrap custom
      HsApp1.priceGiftWrap = parseFloat(slideData.settings.gift_wrap.offer_price * 100).toFixed(2); //val compare price giftwrap custom
      if (!!HsApp1.readCookie('hs-giftWrap-variantPrice')) {
        var cookierPrice = HsApp1.readCookie('hs-giftWrap-variantPrice');
        var priceGiftWrap = parseFloat(slideData.settings.gift_wrap.offer_price * 100).toFixed(2);
        if (cookierPrice != priceGiftWrap) {
          HsApp1.deleteCookie('hs-giftWrap-check');
          HsApp1.deleteCookie('hs-giftWrap-variantPrice');
          HsApp1.giftWrapUpdates(0);
        }
      }
      var hs_gift_wrap_check = !!hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') : '';
      if (!!hs_gift_wrap_check) {
        if (!!HsApp1.readCookie('hs-giftWrap-check')) {
          hs_gift_wrap_check.checked = true;
        }
        if (!hs_gift_wrap_check.classList.contains('hs-event-static')) {
          hs_gift_wrap_check.classList.add('hs-event-static');
          hs_gift_wrap_check.addEventListener('click', function (e) {
            if (!!hs_gift_wrap_check.checked) {
              HsApp1.createCpokie('hs-giftWrap-check', 1, 360);
              HsApp1.createCpokie('hs-giftWrap-variantPrice', parseFloat(slideData.settings.gift_wrap.offer_price * 100).toFixed(2), 360);
              HsApp1.updateMinimumOrder();
              var amount = parseFloat(slideData.settings.gift_wrap.offer_price * 100).toFixed(2);
              HsApp1.giftWrapUpdates(parseInt(amount));
            }
            else {
              HsApp1.deleteCookie('hs-giftWrap-check');
              HsApp1.deleteCookie('hs-giftWrap-variantPrice');
              HsApp1.updateMinimumOrder();
              HsApp1.giftWrapUpdates(0);
            };
          });
        }
      }
    };
  },
  resizeSrc: function (t, r) {
    try {
      if ("original" == r) return t;
      var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return e[1] + "_" + r + "." + e[2]
    } catch (r) {
      return t
    }
  },
  textContentProp: function (propertie) {
    const propertieOrg = propertie || '';
    try {
      if (typeof propertie !== 'undefined' || !!propertie) {
        propertie = propertie.split("_");
        for (let i = 0; i < propertie.length; i++) {
          propertie[i] = propertie[i][0].toUpperCase() + propertie[i].substr(1);
        };
        propertie = propertie.join(" ");
      };
      return propertie;
    } catch (error) {
      return propertieOrg;
    };
  },
  elementRemoveItem: function () {
    var remove_item = HsApp1.iconRemoveSlideCart;
    if (typeof slideData.customize !== 'undefined') {
      if (typeof slideData.customize.customize_body_prod_remove_enabled !== 'undefined' && typeof slideData.customize.customize_body_prod_remove_text && typeof slideData.customize.icon !== 'undefined') {
        if (!!slideData.customize.customize_body_prod_remove_enabled) {
          remove_item = slideData.customize.customize_body_prod_remove_text;
        } else {
          remove_item = slideData.customize.icon;
        }
      };
    };
    return remove_item;
  },
  templateCart: function (cart) {
    var template = `{{#each items}}
  {{#if this.hs_sl_content.custom_bundle}}
    {{{this.hs_sl_content.custom_bundle}}}
  {{else}}
    <div class="hs-item-cart-content hs-product-{{this.id}}{{this.hs_sl_content.discount_class}}" data-item-key="{{this.key}}" data-item-qty="{{this.quantity}}">
      <div class="hs-item-content-variants">
          <div class="hs-item-cart-image">
          {{#if this.hs_sl_content.url}}
            <a class="hs-item-cart-image-content" href="{{this.hs_sl_content.url}}">{{{this.hs_sl_content.image}}}</a>
          {{else}}
            <span class="hs-item-cart-image-content">{{{this.hs_sl_content.image}}}</span>
          {{/if}}
          </div>
          <div class="hs-item-cart-description">
            <div class="hs-item-top">
                <div class="hs-item-top-left">
                  <div class="hs-content-product-and-variant-title">
                      {{#if this.hs_sl_content.url}}
                        <a href="{{this.hs_sl_content.url}}" class="hs-product-title">{{this.product_title}}</a>
                      {{else}}
                        <div class="hs-product-title">{{this.product_title}}</div>
                      {{/if}}
                      <div class="jdgm-badge-placeholder" data-handle="{{this.handle}}"></div>
                      <div class="hs-variant-title">{{this.variant_title}}</div>
                      <div class="hs-content-selling-plan">{{{this.hs_sl_content.selling_plan}}}</div>
                      <div class="hs-propertie-content">{{{this.hs_sl_content.text_variant_propertie}}}</div>
                  </div>
                </div>
                <div class="hs-item-close">
                  {{{this.hs_sl_content.remove_item}}}
                </div>
            </div>
            <div class="hs-content-quantity-price">
                <div class="hs-item-cart-content-quantity">
                  {{{this.hs_sl_content.quantity_box}}}
                </div>
                <div class="hs-cart-content-price">
                  {{{this.hs_sl_content.price}}}
                </div>
            </div>
            <div class="hs-cart-content-weight">
                {{{this.hs_sl_content.item_grams}}}
            </div>
          </div>
      </div>
    </div>
  {{/if}}
  {{/each}}`;

    if (typeof slideData.settings.devices.template_item_cart !== 'undefined') {
      template = slideData.settings.devices.template_item_cart;
    };
    if (template.indexOf('{{this.variant_title}}') > -1) {
      template = template.replace('{{this.variant_title}}', '{{{this.variant_title}}}')
    };
    var templateFunction = _HsHandlebars.compile(template);
    var htmlStr = templateFunction({ items: cart.items });

    try {
      htmlStr = Hs_CartDrawer.templateCartAdditional(cart, htmlStr);
    } catch (error) {
      htmlStr = htmlStr
    }
    return htmlStr;
  },
  jsonCart: function (result) {
    result = JSON.parse(JSON.stringify(result));
    function propImage(prop) {
      var thispropertie = { class: '', propertie: prop };
      if (typeof prop === 'string') {
        const origin = ['image-uploader', 'upldr.app'];
        origin.forEach(function (org) {
          if (prop.indexOf(org) > -1) {
            thispropertie.class = ' hs-prop-img';
            thispropertie.propertie =
              `<dd style="margin: 0 0 0 10px;">
                        <a href="${prop}" style="border: none;" target="_blank">
                          <img src="${prop}" style="max-width: 50px;">
                        </a>
                      </dd>`
          };
        });
      };
      return thispropertie;
    };
    function getRemoveAriaLabel(item) {
      if (!item) return "Remove product from cart";

      // Título base del producto
      let label = `Remove ${item.product_title || item.title || 'product'}`;

      // Construir texto de variantes / opciones
      let optionsText = '';

      if (Array.isArray(item.options_with_values) && item.options_with_values.length > 0) {
        const validOptions = item.options_with_values
          .map(opt => {
            if (!opt || !opt.name || !opt.value) return '';

            // Limpieza de texto: eliminar ":" duplicados o espacios
            const name = opt.name.trim().replace(/:+$/, '');
            const value = opt.value.trim().replace(/^:+/, '');

            // Excluir "Default Title"
            if (
              value.toLowerCase() === 'default title' ||
              name.toLowerCase() === 'title'
            ) return '';

            return `${name}: ${value}`;
          })
          .filter(Boolean);

        if (validOptions.length > 0) {
          optionsText = validOptions.join(', ');
        }
      } else if (
        item.variant_title &&
        item.variant_title.toLowerCase() !== 'default title'
      ) {
        // Si no existen options_with_values, usar variant_title
        optionsText = item.variant_title.trim().replace(/^:+|:+$/g, '');
      }

      //Agregar variantes si existen
      if (optionsText) label += `, ${optionsText}`;

      // Si el producto es un regalo o promoción, añadir contexto
      if (item.product_type && item.product_type.includes('free_gift')) {
        label = label.replace(/^Remove/, 'Remove gift');
      } else if (item.properties && item.properties._tiered) {
        label += ` (${item.properties._tiered})`;
      }

      // Cerrar el texto
      label += ' from cart';

      return Hs_CartDrawer.escape(`${label.replace(/<.*?>/g, '')}`);
    };

    var money_format = slideData.settings.devices.money_format || '',

      custom_content_bundle = false,
      arr_product_id = [],
      arr_content_items = [],
      json_cart = [],
      arr_product_handle = [],
      htmlCart = '',
      cls_discount = '',
      item_id = '',
      item_handle = '',
      item_url = '',
      item_key = '',
      item_quantity = '',
      item_image = '',
      item_product_title = '',
      item_variant_title = '',
      item_grams = '',
      orinal_price_discount = '',
      mg_price = '',
      text_discounts = '',
      text_variant_propertie = '',
      selling_plan = '',
      final_line_price = '',
      item_discounted_price = '',
      item_compare_price = '',
      item_line_price = '',
      status_text_slide_cart = '',
      all_discount_price = '',
      line = 0,
      text_total_variant = '',
      text_total_variant_discount_price = '',
      footer = '',
      thisPropertie = {},
      item_bundle = 0,
      input_hidden_compare_price = '',
      text_unit_price = '';

    var hidden_quantity_box_cart_free = typeof slideData.settings.additional_settings.hidden_quantity_box_cart_free !== 'undefined' ? slideData.settings.additional_settings.hidden_quantity_box_cart_free : 1;
    /* Route Package  */
    /* result.items = result.items.filter((item) => {
      return item.vendor.indexOf('Route') == -1;
    }) || result.items; */

    const filteredItems = result.items.filter(item => item?.vendor?.indexOf('Route') == -1);

    // Si no hay elementos con 'Route' como vendor, devolver los items originales
    result.items = filteredItems.length > 0 ? filteredItems : result.items;

    let productStorage = [];
    let show_compare_price = slideData.settings.additional_settings.show_compare_price;

    try {
      var new_result = window.Hs_modify_result(result, slideData); /* ADD COMPARE PRICE FROM LOCAL STORAGE, VARIANT TITLE */
      result = !new_result ? result : new_result;
    } catch (error) {
      console.log(error)
    };

    const parentGroupIdsGpo = result?.items
      .filter(item => item?.properties?._gpo_product_group)
      .map(item => item?.properties?._gpo_product_group);

    function isChildOfExistingParentGpo(item, parentGroupIds) {
      const childGroup = item.properties?._gpo_parent_product_group;

      return childGroup && parentGroupIds.includes(childGroup);
    }

    result.items.forEach(function (item, index) {
      item.handle = item.handle === null ? '' : item.handle;
      item.title = item.title === null ? '' : item.title;
      item.variant_title = item.variant_title === null ? '' : item.variant_title;
      item.product_title = item.product_title === null ? '' : item.product_title;
      item.product_title = item.product_title !== null ? item.product_title.replace(/<.*?>/g, '') : item.product_title;

      var getHighestPrice = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;

      /* item.variant_title = item.variant_title !== null ? item.variant_title.replace(/<.*?>/g, '') : item.variant_title; */

      let exist_discount = 0, show_base_price_discount = Hs_CartDrawer.show_base_price_discount, text_discounts = '', sumLineDiscount = 0, discount_price_amount = 0, active_sale_price = '', active_sale_final_price = '';

      let priceOriginal = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
      let maxLinePrice = function () {
        var is_dscto = item.original_line_price > item.final_line_price;
        if (Hs_CartDrawer.discount_order_x_item) {
          var total_discount = 0, discounts;
          if (null != (discounts = item.discounts) || discounts.length) {
            for (let t = 0; t < item.discounts.length; t++)
              if (item.discounts[t].amount > 0) {
                total_discount += item.discounts[t].amount;//CAMBIO
              };
          };
          is_dscto = total_discount > 0;
        };
        return is_dscto;
      }();//HAY UN DESCUENTO

      try {
        getHighestPrice = function (show_base_price_discount, show_compare_price, item) {
          let priceOriginal = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
          if (!show_compare_price) {
            return priceOriginal;
          };
          var t, n = function () {
            var e, t;
            return item.compare_at_price && null !== (e = item.selling_plan_allocation) && void 0 !== e && e.compare_at_price ? Math.max(item.compare_at_price, item.selling_plan_allocation.compare_at_price) : item.compare_at_price ? item.compare_at_price : null !== (t = item.selling_plan_allocation) && void 0 !== t && t.compare_at_price ? item.selling_plan_allocation.compare_at_price : null
          }(),
            r = n ? (Hs_CartDrawer.typePrice ? n * item.quantity : n) : null;
          let o = priceOriginal > (Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price);
          if (Hs_CartDrawer.discount_order_x_item && !o) {
            o = item.total_discount > 0;
          };

          var filter_price = function () {
            var price = priceOriginal;
            if (show_base_price_discount && o) {
              price = priceOriginal;
            } else {
              if (r) {
                price = Math.max(r, priceOriginal);
              }
            }
            return price;
          }();
          return Math.max(filter_price, (Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price))
        };
      } catch (error) {
        console.log(error)
      };


      let highestPrice = getHighestPrice(show_base_price_discount, show_compare_price, item);
      var total_discount = 0, discounts;
      if (null != (discounts = item.discounts) || discounts.length) {
        for (let t = 0; t < item.discounts.length; t++)
          if (item.discounts[t].amount > 0) {
            total_discount += item.discounts[t].amount;//CAMBIO
          };
      };

      let final_line_price = function () {
        if (item.properties?._mml_TBYB && item.properties._mml_amount !== undefined && item.properties._mml_type !== undefined) {
          var mmlAmount = item.properties._mml_amount;
          const mmlTBYB = item.properties._mml_TBYB;
          const mmlType = item.properties._mml_type;
          if (mmlTBYB === 'Marshmalloo') {
            if (!isNaN(mmlAmount)) {
              switch (mmlType) {
                case 'fixed-amount':
                  mmlAmount = mmlAmount * 100;
                  let amount_fix = mmlAmount * item.quantity < item.final_line_price ? mmlAmount * item.quantity : item.final_line_price;
                  if (Hs_CartDrawer.typePrice) {
                    item.final_line_price = amount_fix;
                  } else {
                    item.final_price = amount_fix / item.quantity;
                  };

                  if (Hs_CartDrawer.discount_order_x_item) {
                    amount_fix = mmlAmount * item.quantity < item.original_line_price ? mmlAmount * item.quantity : item.original_line_price
                    if (Hs_CartDrawer.typePrice) {
                      item.original_line_price = amount_fix;
                    } else {
                      item.original_price = amount_fix / item.quantity;
                    };
                  };
                  item.discounted_price = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
                  total_discount = 0;
                  break;
                case 'percentage':
                  let amount = (mmlAmount * item.final_line_price) / 100;

                  if (Hs_CartDrawer.typePrice) {
                    item.final_line_price = amount;
                  } else {
                    item.final_price = amount / item.quantity;
                  };

                  if (Hs_CartDrawer.discount_order_x_item) {
                    amount = (mmlAmount * item.original_line_price) / 100;
                    if (Hs_CartDrawer.typePrice) {
                      item.original_line_price = amount;
                    } else {
                      item.original_price = amount / item.quantity;
                    };
                  };
                  item.discounted_price = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
                  total_discount = 0;
                  break;
              };
            };
          };
        };

        let price = Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price;
        if (Hs_CartDrawer.discount_order_x_item) {
          let priceOriginal = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
          price = Hs_CartDrawer.typePrice ? priceOriginal > total_discount ? priceOriginal - total_discount : item.discounted_price : item.discounted_price
        };
        return price;
      }();

      let cls_discount = '',
        docapp = '',
        line = item.hs_line || '',
        item_id = item.id,
        item_product_id = item.product_id,
        //final_line_price = Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price,
        item_key = item.key,
        item_quantity = item.quantity,
        item_product_title = item.product_title,
        item_variant_title = item.variant_title || '',
        item_url = item.url,
        item_handle = item.handle,
        item_image = HsApp1.resizeSrc(item.image, slideData.settings.additional_settings.image_quality) || 'https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif',
        bkp_item_image = '',
        item_grams = item.grams > 0 ? `(${(Hs_CartDrawer.typePrice ? item.grams * item_quantity : item.grams) / 1000} kg)` : '',
        product_type = item.product_type || '',
        item_unit_price_measurement = typeof item.unit_price_measurement !== 'undefined' ? item.unit_price_measurement : {},
        item_unit_price = typeof item.unit_price !== 'undefined' ? item.unit_price : 0,

        item_discounted_price = maxLinePrice ? final_line_price : '',
        save_item = highestPrice - final_line_price,

        input_hidden_compare_price = 0,
        item_compare_price = '',
        line_price_discount = '',
        text_total_variant_discount_price = '',
        text_save_item = '',
        text_variant_propertie = '',
        selling_plan = '',
        attr_img = Hs_CartDrawer.escape(`${item.product_title.replace(/<.*?>/g, '')}`),
        hidden_compare = ' hs-hidden-compare',
        item_tryon = 0,
        text_unit_price = '',
        gpo_child = false;



      /* TRYON */
      if (!!item.selling_plan_allocation) {
        if (!!item.selling_plan_allocation.selling_plan) {
          if (!!item.selling_plan_allocation.selling_plan.description) {
            if (item.selling_plan_allocation.selling_plan.description === 'tryon') {
              if (item.selling_plan_allocation.selling_plan.options.length > 0) {
                var arr_tryon_value = [];
                arr_tryon_value = JSON.parse(item.selling_plan_allocation.selling_plan.options[0].value);
                final_line_price = final_line_price * arr_tryon_value.checkoutChargeAmount;
                final_line_price = final_line_price / 100;
                item_tryon = 1;
              }
            }
          }
        }
      }



      /* SHOW COMPARE PRICE */
      if (!!slideData.settings.additional_settings.show_compare_price) {
        if (highestPrice > final_line_price) {
          active_sale_final_price = !!Hs_CartDrawer.customize_body_sale_price ? ' hs-active-sale-price' : '';
          input_hidden_compare_price = highestPrice;
          hidden_compare = '';
          item_compare_price = hsonslidecart.Currency.formatMoney(highestPrice, money_format);
        };
      };

      if (Hs_CartDrawer.languageFree !== '' && final_line_price == 0) {
        final_line_price = Hs_CartDrawer.languageFree;
        if (!!item_tryon) {
          final_line_price = hsonslidecart.Currency.formatMoney(final_line_price, money_format);
        }
      } else {
        final_line_price = hsonslidecart.Currency.formatMoney(final_line_price, money_format);
      };

      /* DISCOUNT PRICE MAX LINE */
      if (item_discounted_price !== '') {
        exist_discount = 1;
        let item_discounted_price_org = item_discounted_price;
        item_discounted_price = hsonslidecart.Currency.formatMoney(item_discounted_price, money_format);
        if (item_discounted_price_org == 0) {
          if (Hs_CartDrawer.languageFree !== '') {
            item_discounted_price = Hs_CartDrawer.languageFree;
          }
        };

        let maxComparePriceFinalOrg = priceOriginal;
        final_line_price = hsonslidecart.Currency.formatMoney(priceOriginal, money_format);
        if (maxComparePriceFinalOrg == 0) {
          if (Hs_CartDrawer.languageFree !== '') {
            final_line_price = Hs_CartDrawer.languageFree;
          };
        };


      };

      /* BOLD CHANGE PRICE AND DISCOUNT */
      if (typeof item.Bold !== 'undefined') {
        if (item.discounts.length > 0) {
          //exist_discount = 1;
          var price = item.price,
            discount_amount = item.total_discount;
          if (!Hs_CartDrawer.typePrice) {
            discount_amount = discount_amount / item.quantity;
          } else {
            price = price * item.quantity;
          };
          discount_amount = discount_amount + price;
          final_line_price = hsonslidecart.Currency.formatMoney(discount_amount, money_format);
          save_item = highestPrice - discount_amount;
          if (discount_amount == 0) {
            if (Hs_CartDrawer.languageFreeGnral !== '') {
              final_line_price = Hs_CartDrawer.languageFreeGnral;
            };
          };

          /* item_discounted_price = hsonslidecart.Currency.formatMoney(item_compare_price, money_format);
          if (item.discounted_price == 0) {
            if (Hs_CartDrawer.languageFreeGnral !== '') {
              item_discounted_price = Hs_CartDrawer.languageFreeGnral;
            };
          }; */
        };
      };

      /*EXIST DISCOUNT*/
      if (exist_discount) {
        if (!show_base_price_discount) {
          if (item_compare_price) {
            final_line_price = item_compare_price;
          };
        };
        active_sale_final_price = '';
        cls_discount = ' hs-cls-discount';
        line_price_discount = ' hs-discount-price-line-through';
        active_sale_price = !!Hs_CartDrawer.customize_body_sale_price ? ' hs-active-sale-price' : '';
        text_total_variant_discount_price = '<span class="hs-discount-price-total hs-variant-' + item_id + '-discount-price-total hs-desktop' + active_sale_price + '">' + item_discounted_price + '</span>';
      };

      if (Hs_CartDrawer.showSaveItem && save_item > 0) {
        text_save_item = `(Save ${hsonslidecart.Currency.formatMoney(save_item, money_format)})`;
        try {
          text_save_item = slideData.settings.language_settings.discount_savings_language_settings.replace('{{money}}', hsonslidecart.Currency.formatMoney(save_item, money_format))
        } catch (error) {
        }
        text_save_item = `<span class = 'hs-save-item-text'>${text_save_item}</span>`
      };

      text_save_item = `<div class = 'hs-save-product'>${text_save_item}</div>`;

      if (typeof slideData.settings.additional_settings.show_labels_discount === 'undefined' || (typeof slideData.settings.additional_settings.show_labels_discount !== 'undefined' && !!slideData.settings.additional_settings.show_labels_discount)) {
        text_discounts = function () {
          var text_dscto = '';
          let dscto = Hs_CartDrawer.discount_order_x_item ? 'discounts' : 'line_level_discount_allocations';

          item[dscto].map((function (line_discount) {
            var cancellable = 0;
            var discount_application = Hs_CartDrawer.discount_order_x_item ? line_discount : line_discount.discount_application;
            var all_discount_price = line_discount.amount || 0;
            if (all_discount_price > 0) {
              sumLineDiscount = sumLineDiscount + (!Hs_CartDrawer.typePrice ? all_discount_price / item.quantity : all_discount_price);
              if (all_discount_price > 0) {
                all_discount_price = `${discount_application.title + ' (-' + hsonslidecart.Currency.formatMoney(!Hs_CartDrawer.typePrice ? all_discount_price / item.quantity : all_discount_price, slideData.settings.devices.money_format) + ')'}`;
              } else {
                all_discount_price = discount_application.title;
              }
              if (!!Hs_CartDrawer.hidenDiscount || !!Hs_CartDrawer.showSaveItem || !show_base_price_discount) {
                all_discount_price = discount_application.title;
              };

              Hs_CartDrawer.Nn(result).forEach(j => {
                if (j.title === discount_application.title && j.type === 'discount_code') {
                  cancellable = 1;
                }
              });

              //cancellable = line_discount.type.toLowerCase() !== "discount_code" ? 0 : cancellable;

              text_dscto = text_dscto.concat(`
              <div class ="hs-discount-promo">
                <div class="hs-reduction-code">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" class="hs-reduction-code-item"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path></svg>
                </div>
                <span class="hs-code-text">${all_discount_price}</span>
                ${cancellable ? `<div class="hs-code-remove" data-discount-code="${discount_application.title}">
                  <svg tabindex="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="7px" height="7px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
                  <div class="hs--loading"><div class="hs-spinner"></div></div>
                </div>` : ``}
              </div>`);
            };
          }));
          text_dscto = `<div class ="hs-discount-item">${text_dscto}</div>`;
          return text_dscto;
        }();
      }
      /* SHOW NAME SELLING PLAN */
      if (!!item.selling_plan_allocation) {
        if (!!item.selling_plan_allocation.selling_plan) {
          if (!!item.selling_plan_allocation.selling_plan.name) {
            if (typeof window.pltbyb !== 'undefined') {
              if (item.selling_plan_allocation.selling_plan.name.includes('Due today')) {
                item.selling_plan_allocation.selling_plan.name = item.selling_plan_allocation.selling_plan.name.replace(/Due today/g, '<span style="font-weight: bold;">Due today</span>');
              };
            };
            selling_plan = '<span class="hs-selling-plan">' + item.selling_plan_allocation.selling_plan.name + '</span>'
          }
        }
      };

      var class_free_item = product_type.indexOf('free_gift') > -1 ? ' hs-cart-free-item' : '';

      input_hidden_compare_price = `<input type="hidden" value="${input_hidden_compare_price}" class="hs_compare_price">`;
      text_total_variant = `${input_hidden_compare_price}<span class="hs-compare-at-price ${hidden_compare} "> ${item_compare_price} </span>
        <span class="hs-price-total hs-variant-${item_id}-price-total ${line_price_discount} ${class_free_item} ${active_sale_final_price} hs-desktop">${final_line_price} </span>`;

      /* SHOW PROPERTIES */
      if (!!slideData.settings.additional_settings.show_product_property) {
        if (!!item.properties) {
          var itemProperties = true;
          if (Object.keys(item.properties).length > 0) {
            if (!!item.properties_all) {
              if (Object.keys(item.properties_all).length > 0) {
                itemProperties = false;
              };
            };
            if (!!itemProperties) {
              if (typeof item.properties['_Design Image URL'] !== 'undefined') {
                bkp_item_image = item_image;
                item_image = item.properties['_Design Image URL'];
              };
              if (typeof item.properties['_customily-thumb'] !== 'undefined') {
                if (item.properties['_customily-thumb'] !== '') {
                  bkp_item_image = item_image;
                  item_image = item.properties['_customily-thumb'];
                };
              };
              Object.keys(item.properties).forEach(function (c, o) {
                var prop = Object.keys(item.properties)[o],
                  value_prop = item.properties[prop];
                var _pplr_preview = '', uploader = '';
                if (value_prop !== '' && prop.charAt(0) !== '_') {
                  if (value_prop.toString().indexOf("/uploads/") > -1) {
                    if (window.pplr_commpn_ready || (window.pplr_commpn_ready)) {
                      if (typeof item.properties['_pplr_preview'] !== 'undefined') {
                        _pplr_preview = `<div class="hs-content-propertie"><span class="hs-propertie">${HsApp1.textContentProp(c)}: </span>
                                    <a class="${typeof window.pplr_cart !== 'undefined' ? 'pplr_slide' : ''}" href="${item.properties[c]}" >${typeof window.pplr_manual_theme_selector !== 'undefined' && window.pplr_manual_theme_selector.length >= 10 ? window.pplr_manual_theme_selector[10] : typeof window.pplr_cart !== 'undefined' ? window.pplr_c_t_v_i : item.properties[c].replace(/^.*[\\/]/, '') || window.pplr_c_t_v_i}</a>
                                  </div>`;
                      };
                    };
                  };

                  if (c.indexOf('uploader') > -1) {
                    uploader = '<div class="hs-content-image-properties"><img src="' + item.properties[c] + '" class="hs-uploader-image-properties" /></div>'
                  };

                  if (_pplr_preview !== '') {
                    text_variant_propertie = text_variant_propertie.concat(_pplr_preview)
                  };
                  if (uploader !== '') {
                    text_variant_propertie = text_variant_propertie.concat(uploader)
                  };
                  if (_pplr_preview === '' && uploader === '') {
                    thisPropertie = propImage(item.properties[c]);
                    text_variant_propertie = text_variant_propertie.concat('<div class="hs-content-propertie' + thisPropertie.class + '"><span class="hs-propertie">' + HsApp1.textContentProp(c) + ': </span>' + thisPropertie.propertie + '</div>');
                  };
                };
              });
              text_variant_propertie = text_variant_propertie;
            };
          };
        };

        if (!!item.properties_all) {
          if (Object.keys(item.properties_all).length > 0) {
            Object.keys(item.properties_all).forEach(function (c, o) {
              var attr = 0;
              if (o !== '') {
                if (c === "_ro_discount_percentage") {
                  attr = 1;
                }
                if (c === "_ro_unformatted_price") {
                  attr = 1;
                }
                if (attr == 0) {
                  if (c.charAt(0) !== '_') {
                    thisPropertie = propImage(item.properties_all[c]);
                    text_variant_propertie = text_variant_propertie.concat('<div class="hs-content-propertie' + thisPropertie.class + '"><span class="hs-propertie">' + HsApp1.textContentProp(c) + ': </span>' + thisPropertie.propertie + '</div>');
                  };
                }
              }
            });
          }
        };
      };

      //PROPERTIES GPO
      const isChildGpo = isChildOfExistingParentGpo(item, parentGroupIdsGpo) ?? false;
      if (isChildGpo) {
        gpo_child = true;
      };

      /* SHOW UTM URL */
      if (!!slideData.settings.additional_settings.add_utm) {
        item_url = item_url.concat('&utm_source=slide-cart-drawer-upsell')
      };

      /* SHOW UNITE PRICE */
      if (!!Hs_CartDrawer.display_unit_price) {
        if (Object.keys(item_unit_price_measurement).length > 0) {
          var unit_price = '', reference_value = '', reference_unit = '';
          unit_price = hsonslidecart.Currency.formatMoney(item_unit_price, money_format);
          if (!!item_unit_price_measurement) {
            if (typeof item_unit_price_measurement.reference_value !== 'undefined') {
              if (item_unit_price_measurement.reference_value != 1) {
                reference_value = item_unit_price_measurement.reference_value;
              };
            };
            if (typeof item_unit_price_measurement.reference_unit !== 'undefined') {
              reference_unit = item_unit_price_measurement.reference_unit;
            };
          };
          unit_price = `${unit_price}<span>&nbsp;${Hs_CartDrawer.unit_price_separator}&nbsp;</span>${reference_value}${reference_unit}`;
          text_unit_price = `<div class="hs-unit-price">${unit_price}</div>`
        };
      };

      /* SHOW  WEIGHT*/
      if (Hs_CartDrawer.show_weight) {
        item_grams = item_grams ? `<span class="hs-weight">${item_grams}</span>` : '';
      } else {
        item_grams = '';
      };

      var content_price = `<div class="hs-cart-item-prices-row">${text_total_variant}${text_total_variant_discount_price}</div>${text_unit_price}${text_save_item}${text_discounts}`;

      var quantity_box = !!slideData.settings.additional_settings.show_quantity_box_cart && !gpo_child ?
        `<div class="hs-item-cart-qty hs-item-${item_id}">
          <div class="hs-cart-plus-minus" data-quantity="${item_quantity}" data-id="${item_id}" data-key="${item_key}" ${line ? 'data-line="' + line + '"' : ''} ${product_type !== '' ? `${product_type.indexOf('free_gift') > -1 ? 'data-free="free_gift"' : ''}` : ``}>
          </div>
        </div>` : ``;

      var content_remove = !gpo_child ? `
          <span style="cursor:pointer;" class="hs-remove-item" role="button" tabindex="0" aria-label="${getRemoveAriaLabel(item)}" data-id="${item_id}" data-key="${item_key}" ${line ? 'data-line="' + line + '"' : ''}>${HsApp1.elementRemoveItem()}
          </span>
        ` : '';

      if (item.variant_title) {
        attr_img = attr_img + ' - ' + Hs_CartDrawer.escape(`${item.variant_title.replace(/<.*?>/g, '')}`);
      };

      item_url = product_type.indexOf('free_gift') > -1 || !Hs_CartDrawer.add_url_item_cart ? '' : item_url;



      bkp_item_image = bkp_item_image !== '' ? `data-hs-backup-src="${bkp_item_image}"` : ''
      item_image = `<img class="hs-cart-image" loading="lazy" src="${item_image}" ${bkp_item_image} alt="${attr_img}">`;

      if (item.handle.includes('docapp-free-gift') || (item.product_title.toLocaleLowerCase().split(' ').includes('free') && hidden_quantity_box_cart_free)) {
        docapp = ' hs-docapp-active';
      };

      cls_discount = cls_discount + docapp;

      var bundle_builder = !!document.getElementById("bundle-builder-cart-integration-box") ? document.getElementById("bundle-builder-cart-integration-box").innerHTML : '';
      var custom_bundle = '';
      const t = item.properties || {};
      if (!!bundle_builder && !!(t.__bundle_security_checksum || t.__bundle_content || t._configured_bundle_id || t._bundle_data || item.product_type === "Custom Bundle")) {
        if (item_bundle == 0) {
          bundle_builder = JSON.parse(bundle_builder);
          if (typeof bundle_builder.heading !== 'undefined' && typeof bundle_builder.heading_plural !== 'undefined' && typeof bundle_builder.view_text !== 'undefined') {
            custom_content_bundle = true;
            bundle_builder.heading = bundle_builder.heading.replace('{', '{{').replace('}', '}}');
            bundle_builder.heading_plural = bundle_builder.heading_plural.replace('{', '{{').replace('}', '}}');
            htmlCart = htmlCart.concat(`<bundle-builder-cart-box data-heading="${bundle_builder.heading}" data-heading-plural="${bundle_builder.heading_plural}" data-view-text="${bundle_builder.view_text}" data-type="page" data-index="0"></bundle-builder-cart-box>`);
            custom_bundle = `<bundle-builder-cart-box data-heading="${bundle_builder.heading}" data-heading-plural="${bundle_builder.heading_plural}" data-view-text="${bundle_builder.view_text}" data-type="page" data-index="0"></bundle-builder-cart-box>`;
          };
        };
        item_bundle++;
      } else {
        htmlCart = htmlCart.concat(
          `<div class="hs-item-cart-content hs-product-${item_id}${cls_discount}" data-item-key="${item.key}" data-item-qty="${item.quantity}">
                      <div class="hs-item-content-variants">
                        <div class="hs-item-cart-image">
                          ${item_url !== '' ?
            `<a class="hs-item-cart-image-content" tabindex="-1" aria-hidden="true" href="${item_url}">${item_image}</a>` :
            `<span class="hs-item-cart-image-content">${item_image}</span>`
          }      	
                        </div>
                        <div class="hs-item-cart-description">
                          <div class="hs-item-top">
                            <div class="hs-item-top-left">
                              <div class="hs-content-product-and-variant-title">\
                              ${item_url !== '' ?
            `<a href="${item_url}" class="hs-product-title"> ${item_product_title}</a>` :
            `<span class="hs-product-title">${item_product_title}</span>`
          }
                              <div class='jdgm-badge-placeholder' data-handle='${item.handle}'></div>
                                <span class="hs-variant-title">${item_variant_title}</span>
                                ${selling_plan}
                                ${text_variant_propertie}
                              </div>\
                            </div>
                            <div class="hs-item-close">
                              <span style="cursor:pointer;" class="hs-remove-item" data-id="${item_id}" data-key="${item_key}" ${line ? 'data-line="' + line + '"' : ''}>${HsApp1.elementRemoveItem()}</span>
                            </div>
                          </div>
                          <div class="hs-content-quantity-price">\
                            ${quantity_box}
                            <div class="hs-cart-content-price">\
                              <div class="hs-cart-item-prices-row">
                                ${text_total_variant}
                                ${text_total_variant_discount_price}
                              </div>
                              ${text_unit_price}
                              ${text_discounts}
                            </div>\
                          </div>\
                          <div class="hs-cart-content-weight">\
                            ${item_grams}
                          </div>\
                        </div>\
                      </div>\
                    </div>`)
      };

      if (custom_content_bundle) {
        const t = item.properties || {};
        if (!!(t.__bundle_security_checksum || t.__bundle_content || t._configured_bundle_id || t._bundle_data || item.product_type === "Custom Bundle")) {
          cls_discount = cls_discount + ' hs-hidden-div';
        };
      };

      arr_product_id.push(item_product_id);
      arr_product_handle.push(item_handle);

      item.hs_sl_content = {
        price: content_price,
        url: item_url,
        image: item_image,
        discount_class: cls_discount,
        selling_plan: selling_plan,
        text_variant_propertie: text_variant_propertie,
        line: line,
        remove_item: content_remove,
        quantity_box: quantity_box,
        text_total_variant: text_total_variant,
        text_total_variant_discount_price: text_total_variant_discount_price,
        text_unit_price: text_unit_price,
        text_discounts: text_discounts,
        item_grams: item_grams,
        custom_bundle: custom_bundle
      };
      //arr_content_items.push(item);
    });

    json_cart.push({ htmlCart: HsApp1.templateCart(result), arr_product_id: arr_product_id, arr_product_handle: arr_product_handle });
    return json_cart;
  },
  startTimer: function (duration, display) {
    function countDownSticky(styleDisplay = '') {
      if (document.querySelector('.hs-sticky-cart-countdown')) {
        document.querySelector('.hs-sticky-cart-countdown').style.display = styleDisplay;//STICKY CART COUNTDOWN
      };
    };
    var timer = duration,
      minutes,
      seconds,
      obj = 1;

    var refreshInterval = setInterval(function () {
      var element = !!document.querySelector('.hs_countdown_cart_plus') ? document.querySelector('.hs_countdown_cart_plus') : 0;
      if (parseInt(HsApp1.cartPrice) < 1 || !element) {//if price cart total is < 1 or the element no exist not continue with interval
        clearInterval(refreshInterval);
        refreshInterval = null;
        return false;
      }
      timer = timer - 1;
      if (timer > -1) {
        /* if (document.querySelector('.hs-sticky-cart-countdown')) {
          document.querySelector('.hs-sticky-cart-countdown').style.display = '';//STICKY CART COUNTDOWN
        }; */
        countDownSticky('');
        display = !!document.querySelector('.hs_countdown_cart_plus') ? document.querySelectorAll('.hs_countdown_cart_plus') : 0;
        hs_countdown_cart = !!document.querySelector('.hs-countdown-cart') ? document.querySelector('.hs-countdown-cart') : 0;
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        if (display.length > 0) {
          display.forEach(function (r) {
            r.innerHTML = minutes + ":" + seconds;
          });
        }

        /* COUNTDOWN STICKY */
        var sticky_countdown = document.querySelector('.hs-sticky-cart-countdown-countdown-timer') || 0;
        sticky_countdown.innerHTML = minutes + ":" + seconds;
      }
      else if (timer = -1) {
        timer = duration;
        if (typeof slideData.settings.countdown.countdown_reset !== 'undefined') {
          if (parseInt(slideData.settings.countdown.countdown_reset)) {
            clearInterval(refreshInterval);
            refreshInterval = null;
            HsApp1.iniTimer('');
            return false;
          };
        };
        if (!!hs_countdown_cart) {
          hs_countdown_cart.innerHTML = '<p style="text-align: center;">' + slideData.settings.countdown.countdown_text_expire + '</p>';
        };
        /* if (document.querySelector('.hs-sticky-cart-countdown')) {
          document.querySelector('.hs-sticky-cart-countdown').style.display = 'none';//STICKY CART COUNTDOWN
        }; */
        countDownSticky('none');
        if (parseInt(slideData.settings.countdown.countdown_expire_clear_cart)) {
          HsApp1.fetchClearAll();
        };
      }
    }, 1000);
  },
  iniTimer: function (countCart) {
    var minutes = parseInt(slideData.settings.countdown.countdown_minutes_reservation), fiveMinutes = 60 * minutes;
    display = !!document.querySelector('.hs_countdown_cart_plus') ? document.querySelectorAll('.hs_countdown_cart_plus') : 0;
    //if (!!display) {
    HsApp1.startTimer(fiveMinutes, display, countCart);
    //};
  },
  savingElement: function (cart) {
    let savingElement = '';
    if (typeof cart !== 'undefined') {
      if (typeof cart.item !== 'undefined') {
        savingElement = cart;
      };
    };
    return savingElement;
  },
  sumComparePrice: function (cart = {}) {
    let items = cart.items || [];
    let sumComparePrice = (items) => items.reduce((total, item) => {
      if (typeof item.compare_at_price === 'undefined') {
        item.compare_at_price = 0;
      };
      let compare_at_price = item.compare_at_price || item.price;
      compare_at_price = compare_at_price * item.quantity;
      return total + compare_at_price;
    }, 0);
    return sumComparePrice(items);
  },
  sumSubTotal: function (cart = {}) {
    try {
      let items = cart.items || [];
      let sumSubTotal = (items) => items.reduce((total, item) => {
        let price = (window.Hs_get_highest_price(Hs_CartDrawer.show_base_price_discount, slideData.settings.additional_settings.show_compare_price, item) || 0);
        //price = price * item.quantity;
        return total + price;
      }, 0);
      return sumSubTotal(items);

    } catch (error) {
      console.log(error)
    }
  },
  addCompareAtPrice: function (cart, row) {
    let show_base_price_discount = Hs_CartDrawer.show_base_price_discount;
    var bundle_builder = !!document.getElementById("bundle-builder-cart-integration-box") ? document.getElementById("bundle-builder-cart-integration-box") : '';
    if (!!bundle_builder) {
      if (typeof window.eight !== 'undefined') {
        if (typeof window.eight.bundleBuilder !== 'undefined') {
          if (typeof window.eight.bundleBuilder.storefront !== 'undefined') {
            if (typeof window.eight.bundleBuilder.storefront.cartEngine !== 'undefined') {
              if (typeof window.eight.bundleBuilder.storefront.cartEngine.updateCart !== 'undefined') {
                if (typeof window.eight.bundleBuilder.storefront.cartEngine.updateCart === 'function') {
                  window.eight.bundleBuilder.storefront.cartEngine.updateCart(cart);
                  //return false
                };
              };
            };
          };
        };
      };
    };

    var hs_site_cart_popup_layout = !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout') : '';
    if (!!hs_site_cart_popup_layout) {
      /* var hs_subtotal_compare_at_price = !!document.querySelector('.hs_subtotal_compare_at_price') ? document.querySelector('.hs_subtotal_compare_at_price') : '';
      if (!!hs_subtotal_compare_at_price) {
        hs_subtotal_compare_at_price.innerHTML = '';
      } */
      var hs_sub_total_cart = !!hs_site_cart_popup_layout.querySelector('.hs-sub-total-cart') ? hs_site_cart_popup_layout.querySelector('.hs-sub-total-cart') : '';
      if (!!hs_sub_total_cart) {
        hs_sub_total_cart.classList.remove('hs-run-discount-automatic');
        if (!!hs_sub_total_cart.classList.contains('hs-payment-discount')) {
          hs_sub_total_cart.classList.remove('hs-payment-discount');
        };
        if (cart.total_discount) {
          try {
            var new_result = window.Hs_modify_result(cart, slideData); /* ADD COMPARE PRICE FROM LOCAL STORAGE, VARIANT TITLE */
            cart = !new_result ? cart : new_result;
          } catch (error) {
            console.log(error)
          };

          let sumComparePrice = HsApp1.sumSubTotal(cart) || cart.original_total_price;
          if (cart.original_total_price > cart.total_price) {
            var original_total_price = cart.original_total_price;
            if (sumComparePrice > cart.original_total_price) {
              original_total_price = sumComparePrice;
            };
            HsApp1.cartComparePrice = original_total_price;
            original_total_price = !!HsApp1.readCookie('hs-giftWrap-variantPrice') ? original_total_price + parseInt(HsApp1.readCookie('hs-giftWrap-variantPrice')) : original_total_price;

            window.HSSLIDECART.DISCOUNT_TOTAL_PRICE = original_total_price;

            original_total_price = hsonslidecart.Currency.formatMoney(original_total_price, slideData.settings.devices.money_format);
            hs_sub_total_cart.classList.add('hs-run-discount-automatic');

            var hs_subtotal_discount_automatic = !!hs_site_cart_popup_layout.querySelector('.hs_subtotal_discount_automatic') ? hs_site_cart_popup_layout.querySelector('.hs_subtotal_discount_automatic') : '';
            if (!!hs_subtotal_discount_automatic) {
              hs_subtotal_discount_automatic.innerHTML = original_total_price;
            }
          };
        }
      }
    };


    if (!parseInt(slideData.settings.additional_settings.show_compare_price)) {
      return false;
    }

    var hs_sub_total_cart = !!document.querySelector('.hs-sub-total-cart') ? document.querySelector('.hs-sub-total-cart') : '';
    if (!!hs_sub_total_cart) {
      if (!!hs_sub_total_cart.classList.contains('hs-run-discount-automatic')) {
        //return false;
      };
    };

    var counter = 0, compare_at_price = '', item_compare_price = 0, arr_variants = [], emptyStorage = true, productStorage = [];

    if (window.localStorage) {
      if (localStorage.getItem("_hsproducts")) {
        emptyStorage = false;
        productStorage = Hs_CartDrawer.getStorageProducts();
      }
    };

    let cart_mml = JSON.parse(JSON.stringify(cart));
    let newTotalPrice = 0, count_mmlTBYB = 0, count_Tryon = 0;
    cart_mml.items.forEach(item => {
      var total_discount = 0, discounts;
      if (null != (discounts = item.discounts) || discounts.length) {
        for (let t = 0; t < item.discounts.length; t++)
          if (item.discounts[t].amount > 0) {
            total_discount += item.discounts[t].amount;//CAMBIO
          };
      };

      let final_price = function () {
        if (item.properties?._mml_TBYB && item.properties._mml_amount !== undefined && item.properties._mml_type !== undefined) {
          var mmlAmount = item.properties._mml_amount;
          const mmlTBYB = item.properties._mml_TBYB;
          const mmlType = item.properties._mml_type;
          if (mmlTBYB === 'Marshmalloo') {
            if (!isNaN(mmlAmount)) {
              count_mmlTBYB++;
              switch (mmlType) {
                case 'fixed-amount':
                  mmlAmount = mmlAmount * 100;
                  let amount_fix = mmlAmount * item.quantity < item.final_line_price ? mmlAmount * item.quantity : item.final_line_price;
                  item.final_line_price = amount_fix;

                  if (Hs_CartDrawer.discount_order_x_item) {
                    amount_fix = mmlAmount * item.quantity < item.original_line_price ? mmlAmount * item.quantity : item.original_line_price
                    item.original_line_price = amount_fix;
                  };
                  item.discounted_price = item.original_line_price;
                  break;
                case 'percentage':
                  let amount = (mmlAmount * item.final_line_price) / 100;
                  item.final_line_price = amount;

                  if (Hs_CartDrawer.discount_order_x_item) {
                    amount = (mmlAmount * item.original_line_price) / 100;
                    item.original_line_price = amount;
                  };
                  item.discounted_price = item.original_line_price;
                  break;
              };
            };
          };
        };

        /* TRYON */
        if (!!item.selling_plan_allocation) {
          if (!!item.selling_plan_allocation.selling_plan) {
            if (!!item.selling_plan_allocation.selling_plan.description) {
              if (item.selling_plan_allocation.selling_plan.description === 'tryon') {
                if (item.selling_plan_allocation.selling_plan.options.length > 0) {
                  var arr_tryon_value = [], myAumount = 0;
                  arr_tryon_value = JSON.parse(item.selling_plan_allocation.selling_plan.options[0].value);
                  myAumount = arr_tryon_value.checkoutChargeAmount;
                  count_Tryon++;
                  switch (arr_tryon_value.checkoutChargeType) {
                    case 'fixed-amount':
                      myAumount = myAumount * 100;
                      let amount_fix = myAumount * item.quantity < item.final_line_price ? myAumount * item.quantity : item.final_line_price;
                      item.final_line_price = amount_fix;

                      if (Hs_CartDrawer.discount_order_x_item) {
                        amount_fix = myAumount * item.quantity < item.original_line_price ? myAumount * item.quantity : item.original_line_price
                        item.original_line_price = amount_fix;
                      };
                      item.discounted_price = item.original_line_price;
                      total_discount = 0;
                      break;
                    case 'percentage':
                      let amount = (myAumount * item.final_line_price) / 100;
                      item.final_line_price = amount;

                      if (Hs_CartDrawer.discount_order_x_item) {
                        amount = (myAumount * item.original_line_price) / 100;
                        item.original_line_price = amount;
                      };
                      item.discounted_price = item.original_line_price;
                      total_discount = 0;
                      break;
                  };
                }
              }
            }
          }
        }

        let price = item.final_line_price;
        if (Hs_CartDrawer.discount_order_x_item) {
          let priceOriginal = item.original_line_price;
          price = priceOriginal > total_discount ? priceOriginal - total_discount : item.discounted_price;
        };
        return price;
      }();

      newTotalPrice += final_price;
    });
    if (count_mmlTBYB > 0 || count_Tryon > 0) {
      cart.total_price = newTotalPrice != cart.total_price ? newTotalPrice : cart.total_price;
    };

    cart.items.forEach(function (item) {
      if (item.handle === null) {
        return false
      }
      let maxComparePriceFinal = Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
      let final_line_price = Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price;
      let maxLinePrice = item.original_line_price > item.final_line_price;//HAY UN DESCUENTO

      //if (!existComparePrice) {
      var product = Hs_CartDrawer.routeLocale(`products/${item.handle}.js`);
      fetch(`${product}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      }).then((product) => {
        if (product) {
          var changedProduct = false, newProduct = false;
          counter++;

          //if (Hs_CartDrawer.upgrade_charge) {
          product.timestamp = Date.now();
          var returnNewObj = JSON.parse(JSON.stringify(product))
          let product_in_array = productStorage.find(prod => prod.id === product.id) || 0;
          if (!product_in_array) {
            newProduct = true;
            productStorage.push(returnNewObj);
          } else {
            let equalStorage = Hs_CartDrawer.compareProductData(product, item.variant_id);
            if (!equalStorage) {
              changedProduct = true;
              const newArr = productStorage.filter(prod_storage => {
                return prod_storage.id !== product.id;
              }) || [];
              newArr.push(returnNewObj);
              productStorage = newArr;
            }
          }
          //};

          product.variants.forEach(function (post, index) {
            let compare_price_propertie = false;
            if (post.id == item.variant_id) {

              if (item.properties?._mml_TBYB && item.properties._mml_amount !== undefined && item.properties._mml_type !== undefined) {
                var mmlAmount = item.properties._mml_amount;
                const mmlTBYB = item.properties._mml_TBYB;
                const mmlType = item.properties._mml_type;
                if (mmlTBYB === 'Marshmalloo') {
                  if (!isNaN(mmlAmount)) {
                    switch (mmlType) {
                      case 'fixed-amount':
                        mmlAmount = mmlAmount * 100;
                        if (mmlAmount < post.price) {
                          compare_price_propertie = true;
                          post.compare_at_price = post.price;
                        };
                        break;
                      case 'percentage':
                        let amount = (mmlAmount * post.price) / 100;
                        if (amount < post.price) {
                          compare_price_propertie = true;
                          post.compare_at_price = post.price;
                        };
                        break;
                    };
                  };
                };
              };

              post.qty = item.quantity;
              post.key = item.key;

              if (post.compare_at_price != null) {
                item_compare_price = post.compare_at_price;
                if (!compare_price_propertie) {
                  if (item_compare_price <= item.price) {
                    item_compare_price = 0;
                  };
                };
              } else {
                item_compare_price = 0;
              };


              if (item_compare_price > 0) {
                post.item_compare_price = item_compare_price;
                sum_compare_at_price = post.compare_at_price * item.quantity;
                post.sum_compare_at_price = sum_compare_at_price;
              };

              if (typeof item.selling_plan_allocation !== 'undefined') {
                if (typeof item.selling_plan_allocation.compare_at_price !== 'undefined' && typeof item.selling_plan_allocation.price !== 'undefined') {
                  /* if (item.selling_plan_allocation.compare_at_price > item.selling_plan_allocation.price) {
                    
                    post.item_compare_price = item.selling_plan_allocation.compare_at_price;
                    sum_compare_at_price = item.selling_plan_allocation.compare_at_price * item.quantity;
                    post.sum_compare_at_price = sum_compare_at_price;
                  }; */
                  let max = Math.max(item_compare_price, item.selling_plan_allocation.compare_at_price);
                  post.item_compare_price = max;
                  sum_compare_at_price = max * item.quantity;
                  post.sum_compare_at_price = sum_compare_at_price;
                };
              };


              //if (Hs_CartDrawer.upgrade_charge) {
              if (Hs_CartDrawer.hasSwitchToSubscription(product, post)) {
                if (product.selling_plan_groups) {
                  post.selling_plans_product = product.selling_plan_groups;
                };

                if (item.selling_plan_allocation) {
                  post.selling_plan_selected = item.selling_plan_allocation;
                };
                if (post.selling_plan_allocations) {
                  post.selling_plan_variant = post.selling_plan_allocations;
                  delete post.selling_plan_allocations;
                };
                post.properties = item.properties;
              };

              post.changedProduct = changedProduct;
              post.newProduct = newProduct;
              post.item = item;
              post.maxComparePriceFinal = maxComparePriceFinal;
              post.final_line_price = final_line_price;
              post.maxLinePrice = maxLinePrice;
              post.item_selling_plan_allocation = item.selling_plan_allocation;
              arr_variants.push(post);

              item.compare_at_price = post.item_compare_price || 0;
            }
          });

          if (cart.items.length == counter) {
            //if (Hs_CartDrawer.upgrade_charge) {
            if (productStorage.length > 0) {
              localStorage.setItem(
                "_hsproducts", JSON.stringify(productStorage)
              )
            };
            //};

            var sum_compare_at_price = 0, compare_at_price_sum = 0;
            arr_variants.forEach(function (variant) {
              if (variant.changedProduct || !!emptyStorage || !!variant.newProduct) {
                let show_base_price_discount = Hs_CartDrawer.show_base_price_discount;
                let maxComparePrice = null;
                let maxComparePriceTotal = null;

                if (variant.compare_at_price && (is = variant.item_selling_plan_allocation) !== null && void 0 !== is && !!is.compare_at_price) {
                  maxComparePrice = Math.max(variant.compare_at_price, variant.item_selling_plan_allocation.compare_at_price)
                } else {
                  if (variant.compare_at_price) {
                    maxComparePrice = variant.compare_at_price;
                  };

                  if ((is = variant.item_selling_plan_allocation) !== null && void 0 !== is && !!is.compare_at_price) {
                    maxComparePrice = variant.item_selling_plan_allocation.compare_at_price;
                  };
                };

                if (maxComparePrice) {
                  maxComparePriceTotal = Hs_CartDrawer.typePrice ? maxComparePrice * variant.qty : maxComparePrice;
                };

                if (show_base_price_discount && variant.maxLinePrice) {
                  variant.maxComparePriceFinal = variant.maxComparePriceFinal
                } else {
                  if (maxComparePriceTotal) {
                    variant.maxComparePriceFinal = Math.max(maxComparePriceTotal, variant.maxComparePriceFinal);
                  } else {
                    variant.maxComparePriceFinal = variant.maxComparePriceFinal;
                  }
                };

                variant.maxComparePriceFinal = Math.max(variant.maxComparePriceFinal, variant.final_line_price)

                var hs_product = document.querySelectorAll(`.hs-product-${variant.id}[data-item-qty="${variant.qty}"][data-item-key="${variant.key}"]`).length > 0 ? document.querySelectorAll(`.hs-product-${variant.id}[data-item-qty="${variant.qty}"][data-item-key="${variant.key}"]`) : [];
                if (hs_product.length > 0) {
                  hs_product.forEach(function (val, i) {
                    var subs_section_element = '';
                    var subs_section = '';

                    /* SELLING PLAN */
                    //if(variant.discounts.length == 0){
                    if (Hs_CartDrawer.upgrade_charge) {
                      let hs_subscription_upgrade_section = val.querySelector('.hs-subscription-upgrade-section') || '';
                      hs_subscription_upgrade_section && hs_subscription_upgrade_section.remove();
                      if (!val.querySelector('.hs-subscription-upgrade-section')) {
                        subs_section = Hs_CartDrawer.createThisElement('div', {
                          className: "hs-subscription-upgrade-section"
                        });/* CREATE SECTION(DIV) SUBSCRIPTION */
                      };
                      if (subs_section) {
                        //var plans = [];
                        var plans_assing = [];
                        if (variant.selling_plan_selected && variant.selling_plan_selected != null) {
                          if (variant.selling_plan_variant && variant.selling_plan_variant.length > 0) {
                            if (variant.selling_plans_product && variant.selling_plans_product.length > 0) {
                              variant.selling_plans_product.forEach(function (plan_product) {

                                variant.selling_plan_variant.forEach(function (plan_variant) {

                                  if (plan_variant.selling_plan_group_id == plan_product.id) {

                                    var selling_plan = plan_product.selling_plans.find(selling_plan => selling_plan.id === plan_variant.selling_plan_id)
                                    plan_variant.selling_plan = selling_plan;

                                    if (plans_assing.filter(x => x.id === plan_product.id).length == 0) {
                                      plans_assing.push(plan_product);
                                    };
                                  };
                                });
                              });
                            };
                          };
                          subs_section_element = Hs_CartDrawer.createSelectRechargeCartElement(plans_assing, variant, variant.item)
                        } else {
                          if (variant.selling_plan_variant && variant.selling_plan_variant.length > 0) {
                            const span = Hs_CartDrawer.createThisElement('span', {
                              textContent: Hs_CartDrawer.upgrade_text,
                              className: "hs-upgrade-charge",
                            });/* CREATE SPAN BUTTON SUBSCRIPTION */

                            subs_section_element = Hs_CartDrawer.createThisElement('button', {
                              className: "hs-subscription-upgrade-button",
                              onclick: function (e) {
                                e.preventDefault();
                                var this_data = new FormData();
                                this.disabled = true

                                var span_button = this.querySelector('.hs-upgrade-charge') || '';
                                if (span_button) {
                                  span_button.innerHTML = `${Hs_CartDrawer.upgrade_text}...`;
                                };
                                this_data.append("quantity", variant.qty);
                                this_data.append("key", variant.key);
                                this_data.append("id", variant.key);
                                this_data.append("selling_plan", variant.selling_plan_variant[0].selling_plan_id);

                                HsApp1.onloadCart('', this_data, 0);
                              }
                            });/* CREATE BUTTON SUBSCRIPTION */
                            subs_section_element.appendChild(span);
                          };
                        };
                      };

                      if (subs_section && subs_section_element) {
                        val.appendChild(subs_section);//ADD SECTION TO DIV PRODUCT
                        subs_section.appendChild(subs_section_element);
                      };
                    };
                    //};
                    /* END SELLING PLAN */

                    item_compare_price = variant.item_compare_price ? !Hs_CartDrawer.typePrice ? variant.item_compare_price : variant.item_compare_price * variant.qty : 0;
                    var hs_compare_at_price = !!val.querySelector('.hs-compare-at-price') ? val.querySelector('.hs-compare-at-price') : '';
                    var hs_compare_price_final = !!val.querySelector('.hs_compare_price_final') ? val.querySelector('.hs_compare_price_final') : '';
                    if (item_compare_price > 0) {
                      sum_compare_at_price += item_compare_price;
                      compare_at_price = hsonslidecart.Currency.formatMoney(item_compare_price, slideData.settings.devices.money_format);
                      var hs_price_total = !!val.querySelector('.hs-price-total:not(.hs-discount-price-line-through)') ? val.querySelector('.hs-price-total:not(.hs-discount-price-line-through)') : '';

                      let hs_price_total_dscto = !!val.querySelector(`.hs-price-total.hs-variant-${variant.id}-price-total.hs-discount-price-line-through`) ? val.querySelector(`.hs-price-total.hs-variant-${variant.id}-price-total.hs-discount-price-line-through`) : '';

                      if (!!hs_compare_at_price) {

                        hs_compare_at_price.classList.remove('hs-hidden-compare');
                        if (hs_compare_price_final) {
                          hs_compare_price_final.value = variant.sum_compare_at_price;
                        } else {
                          hs_compare_at_price.insertAdjacentHTML('beforebegin', `<input type="hidden" value="${variant.sum_compare_at_price}" class="">`);
                        }
                        hs_compare_at_price.innerHTML = compare_at_price;

                        if (!Hs_CartDrawer.show_base_price_discount) {
                          if (hs_price_total_dscto) {
                            hs_price_total_dscto.innerHTML = compare_at_price;
                          };
                        };

                        if (!!hs_price_total) {
                          if (!!Hs_CartDrawer.customize_body_sale_price) {
                            hs_price_total.classList.add('hs-active-sale-price');
                          };
                        };
                      };
                    } else {
                      if (!!hs_compare_at_price) {
                        hs_compare_at_price.classList.add('hs-hidden-compare');
                      };
                    };

                    if (!!Hs_CartDrawer.showSaveItem) {
                      let save_item = variant.maxComparePriceFinal - variant.final_line_price;
                      if (save_item > 0) {
                        let hs_save_product = !!val.querySelector('.hs-save-product') ? val.querySelector('.hs-save-product') : '';
                        if (hs_save_product) {

                          var text_save_item = `(Save ${hsonslidecart.Currency.formatMoney(save_item, slideData.settings.devices.money_format)})`;
                          try {
                            text_save_item = slideData.settings.language_settings.discount_savings_language_settings.replace('{{money}}', hsonslidecart.Currency.formatMoney(save_item, slideData.settings.devices.money_format))
                          } catch (error) {
                          }
                          hs_save_product.innerHTML = `<span class = 'hs-save-item-text'>${text_save_item}</span>`
                        };
                      };
                    };
                  });
                }
              };
              compare_at_price_sum += variant.sum_compare_at_price || (variant.price * variant.qty);
            });

            let sumComparePrice = HsApp1.sumSubTotal(cart) || cart.original_total_price;
            if (cart.total_discount > 0) {
              compare_at_price_sum = sumComparePrice;
              var hs_total_price_global = !!document.querySelector('.hs-total-price-global') ? document.querySelector('.hs-total-price-global') : '';
              if (!!hs_total_price_global) {
                hs_total_price_global.value = sumComparePrice;//CAMBIO
              };
            };

            HsApp1.cartComparePrice = compare_at_price_sum;
            /*  VALIDATE CHECK CUSTOM GIFT WRAP COMPARE PRICE */

            var hs_gift_wrap_custom = !!document.querySelector('.hs-gift-wrap-custom') ? document.querySelector('.hs-gift-wrap-custom') : '';
            if (!!hs_gift_wrap_custom) {
              var hs_gift_wrap_check = !!hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') : '';
              if (!!hs_gift_wrap_check) {
                if (!!hs_gift_wrap_check.checked) {
                  HsApp1.comparePriceGiftWrap = parseInt(slideData.settings.gift_wrap.offer_compare_price) * 100 //val price giftwrap custom
                  compare_at_price_sum = compare_at_price_sum + HsApp1.comparePriceGiftWrap;
                }
              }
            };
            /* *************************** */
            try {
              let saving_price = window.Hs_saving_price(cart.total_price, compare_at_price_sum);
              if (saving_price > 0) {
                saving_price = hsonslidecart.Currency.formatMoney(saving_price, slideData.settings.devices.money_format);
              } else {
                saving_price = '';
              };
            } catch (error) {
              console.log(error);
            }

            //CAMBIO
            let k = 0;

            let total_discount = cart.total_discount || 0;

            let total_discount_price = total_discount;

            let compare_org = compare_at_price_sum;

            if (compare_at_price_sum > cart.total_price) {
              k = 1;
              total_discount = compare_at_price_sum - cart.total_price;//CAMBIO
              //window.HSSLIDECART.DISCOUNT_TOTAL_PRICE = compare_at_price_sum;
              window.HSSLIDECART.COMPARE_AT_PRICE = compare_org;
              compare_at_price_sum = hsonslidecart.Currency.formatMoney(compare_at_price_sum, slideData.settings.devices.money_format);
            } else {
              compare_at_price_sum = '';
              window.HSSLIDECART.COMPARE_AT_PRICE = 0;
              //window.HSSLIDECART.DISCOUNT_TOTAL_PRICE = 0;
            };

            //CAMBIO
            let hs_content_discount = document.querySelector('.hs-content-discount') || '';
            if (hs_content_discount) {
              let hs_discount = hs_content_discount.querySelector('.hs_discount') || '';
              let hs_discount_input = hs_content_discount.querySelector('input.hs-discount-global') || '';

              if (hs_discount_input) {
                hs_discount_input.value = total_discount;
              };
              //CAMBIO

              if (total_discount > 0) {
                total_discount = `- ${hsonslidecart.Currency.formatMoney(total_discount, slideData.settings.devices.money_format)}`;
                hs_content_discount.classList.remove('hs-hidden-div');
              } else {
                hs_content_discount.classList.add('hs-hidden-div')
              };
              //CAMBIO
              if (hs_discount) {
                hs_discount.innerHTML = total_discount;
              };
            };

            if (!k) {
              //CAMBIO
              if (total_discount_price > 0) {
                total_discount_price = `- ${hsonslidecart.Currency.formatMoney(total_discount_price, slideData.settings.devices.money_format)}`;
                hs_content_discount ? hs_content_discount.classList.remove('hs-hidden-div') : '';
              } else {
                hs_content_discount ? hs_content_discount.classList.add('hs-hidden-div') : '';
              };

              if (!!total_discount_price) {
                if (hs_discount) {
                  hs_discount.innerHTML = total_discount_price;
                }
              }
            }

            var hs_subtotal_compare_at_price = !!document.querySelector('.hs_subtotal_compare_at_price') ? document.querySelector('.hs_subtotal_compare_at_price') : '';
            if (!!hs_subtotal_compare_at_price) {
              //hs_subtotal_compare_at_price.innerHTML = '';
              var hs_sub_total_cart = !!document.querySelector('.hs-sub-total-cart ') ? document.querySelector('.hs-sub-total-cart ') : '';
              if (!!hs_sub_total_cart) {
                if (hs_sub_total_cart.classList.contains('hs-run-discount-automatic')) {
                  window.HSSLIDECART.DISCOUNT_TOTAL_PRICE = compare_org;
                  hs_subtotal_compare_at_price = !!document.querySelector('.hs_subtotal_discount_automatic') ? document.querySelector('.hs_subtotal_discount_automatic') : hs_subtotal_compare_at_price;
                } else {
                  window.HSSLIDECART.DISCOUNT_TOTAL_PRICE = 0;
                }
              };
              hs_subtotal_compare_at_price.innerHTML = compare_at_price_sum;
            };

            var hs_original_price = !!document.querySelector('.hs_original_price') ? document.querySelector('.hs_original_price') : '';
            var hs_content_original_price = !!document.querySelector('.hs-content-original-price') ? document.querySelector('.hs-content-original-price') : '';
            if (hs_original_price) {
              hs_original_price.innerHTML = compare_at_price_sum;
            };
            if (hs_content_original_price) {
              compare_at_price_sum === '' ? hs_content_original_price.classList.add('hs-hidden-div') : hs_content_original_price.classList.remove('hs-hidden-div');
            };

            var hs_total_save = document.querySelector('.hs_total_save') || '';
            if (hs_total_save) {
              hs_total_save.innerHTML = saving_price;
            };

            HsApp1.currencyConverter();
            HsApp1.updateDynamicPrice();
          }
          //} //
        }
      })
        .catch(err => {
          console.error(err);
          counter++
        })
        .then(e => {

        });
      //};
    });

    HsApp1.updateDynamicPrice();
  },
  addRechargeButton: async function (cart = null) {
    if (+slideData.settings.additional_settings.show_compare_price && Hs_CartDrawer.upgrade_charge) {
      return false;
    };

    async function getProduct(handle = null) {
      var dataProd = null;
      if (handle != null) {
        var product = Hs_CartDrawer.routeLocale(`products/${handle}.js`);
        dataProd = fetch(`${product}`,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => response.status == 200 ? response.json() : Promise.reject(response))
          .then((response) => {
            return response;
          })
          .catch((error) => { console.log(error) });
      };
      return dataProd;
    };

    if (!(+slideData.settings.additional_settings.show_compare_price) && Hs_CartDrawer.upgrade_charge) {
      var counter = 0, arr_variants = [], emptyStorage = true, productStorage = [];


      if (window.localStorage) {
        if (localStorage.getItem("_hsproducts")) {
          emptyStorage = false;
          productStorage = Hs_CartDrawer.getStorageProducts();
        }
      };

      if (cart != null) {
        cart.items.forEach(async function (item) {
          var product = await getProduct(item.handle).then(response => response) || null;
          counter++;
          if (product !== null && product.handle) {
            product.timestamp = Date.now();
            var changedProduct = false, newProduct = false;
            var returnNewObj = JSON.parse(JSON.stringify(product))
            let product_in_array = productStorage.find(prod => prod.id === product.id) || 0;
            if (!product_in_array) {
              newProduct = true;
              productStorage.push(returnNewObj);
            } else {
              let equalStorage = Hs_CartDrawer.compareProductData(product, item.variant_id);
              if (!equalStorage) {
                changedProduct = true;
                const newArr = productStorage.filter(prod_storage => {
                  return prod_storage.id !== product.id;
                }) || [];
                newArr.push(returnNewObj);
                productStorage = newArr;
              }
            };

            var variant = product.variants.find(variant => variant.id === item.variant_id) || 0;
            if (variant) {
              if (Hs_CartDrawer.hasSwitchToSubscription(product, variant)) {
                if (product.selling_plan_groups) {
                  variant.selling_plans_product = product.selling_plan_groups;
                };

                if (item.selling_plan_allocation) {
                  variant.selling_plan_selected = item.selling_plan_allocation;
                };
                if (variant.selling_plan_allocations) {
                  variant.selling_plan_variant = variant.selling_plan_allocations;
                  delete variant.selling_plan_allocations;
                };
                variant.properties = item.properties;
              };

              variant.qty = item.quantity;
              variant.key = item.key;

              variant.changedProduct = changedProduct;
              variant.newProduct = newProduct;
              variant.item = item;
              arr_variants.push(variant);
            };
            if (cart.items.length == counter) {
              if (productStorage.length > 0) {
                localStorage.setItem(
                  "_hsproducts", JSON.stringify(productStorage)
                )
              };

              arr_variants.forEach(function (variant) {
                if (variant.changedProduct || !!emptyStorage || !!variant.newProduct) {
                  var hs_product = document.querySelectorAll(`.hs-product-${variant.id}[data-item-qty="${variant.qty}"][data-item-key="${variant.key}"]`).length > 0 ? document.querySelectorAll(`.hs-product-${variant.id}[data-item-qty="${variant.qty}"][data-item-key="${variant.key}"]`) : [];
                  if (hs_product.length > 0) {
                    hs_product.forEach(function (val, i) {
                      var subs_section_element = '';
                      var subs_section = '';
                      let hs_subscription_upgrade_section = val.querySelector('.hs-subscription-upgrade-section') || '';
                      hs_subscription_upgrade_section && hs_subscription_upgrade_section.remove();
                      if (!val.querySelector('.hs-subscription-upgrade-section')) {
                        subs_section = Hs_CartDrawer.createThisElement('div', {
                          className: "hs-subscription-upgrade-section"
                        });/* CREATE SECTION(DIV) SUBSCRIPTION */
                      };
                      if (subs_section) {
                        var plans_assing = [];
                        if (variant.selling_plan_selected && variant.selling_plan_selected != null) {
                          if (variant.selling_plan_variant && variant.selling_plan_variant.length > 0) {
                            if (variant.selling_plans_product && variant.selling_plans_product.length > 0) {
                              variant.selling_plans_product.forEach(function (plan_product) {

                                variant.selling_plan_variant.forEach(function (plan_variant) {

                                  if (plan_variant.selling_plan_group_id == plan_product.id) {

                                    var selling_plan = plan_product.selling_plans.find(selling_plan => selling_plan.id === plan_variant.selling_plan_id)
                                    plan_variant.selling_plan = selling_plan;
                                    if (plans_assing.filter(x => x.id === plan_product.id).length == 0) {
                                      plans_assing.push(plan_product);
                                    };
                                  };

                                });
                              });
                            };
                          };
                          subs_section_element = Hs_CartDrawer.createSelectRechargeCartElement(plans_assing, variant, variant.item);//CREATE SELECT OPTION SUBSCRIPTION */
                        } else {
                          if (variant.selling_plan_variant && variant.selling_plan_variant.length > 0) {
                            const span = Hs_CartDrawer.createThisElement('span', {
                              textContent: Hs_CartDrawer.upgrade_text,
                              className: "hs-upgrade-charge",
                            });/* CREATE SPAN BUTTON SUBSCRIPTION */

                            subs_section_element = Hs_CartDrawer.createThisElement('button', {
                              className: "hs-subscription-upgrade-button",
                              onclick: function (e) {
                                e.preventDefault();

                                /* var props = Object.assign({}, variant.properties, {
                                  __hsSubscriptionUpgrade: "true"
                                }); */

                                this.disabled = true

                                var span_button = this.querySelector('.hs-upgrade-charge') || '';
                                if (span_button) {
                                  span_button.innerHTML = `${Hs_CartDrawer.upgrade_text}...`;
                                };

                                /* var this_data = {
                                  key: variant.key,
                                  id: variant.key,
                                  quantity: variant.qty,
                                  selling_plan: variant.selling_plan_variant[0].selling_plan_id,
                                  //properties: props
                                } */
                                var this_data = new FormData();
                                //this_data.append("properties[__hsSubscriptionUpgrade]", true);
                                this_data.append("quantity", variant.qty);
                                this_data.append("key", variant.key);
                                this_data.append("id", variant.key);
                                this_data.append("selling_plan", variant.selling_plan_variant[0].selling_plan_id);

                                //this_data = JSON.stringify(this_data);
                                HsApp1.onloadCart('', this_data, 0);
                              }
                            });/* CREATE BUTTON SUBSCRIPTION */
                            subs_section_element.appendChild(span);

                          };
                        };
                      };

                      if (subs_section && subs_section_element) {
                        val.appendChild(subs_section);//ADD SECTION TO DIV PRODUCT
                        subs_section.appendChild(subs_section_element);
                      };
                    });
                  };
                };
              });
            };

          };

        });
      };

    };
  },
  errorDiscount: function (events, message = '') {
    var hs_sub_total_cart = document.querySelectorAll('.hs-sub-total-cart').length > 0 ? document.querySelectorAll('.hs-sub-total-cart') : [],
      hs_error_code_discount = !!document.querySelector('.hs-error-code-discount') ? document.querySelector('.hs-error-code-discount') : '',
      tagContent = !!document.querySelector('.hs-tag-code-discount') ? document.querySelector('.hs-tag-code-discount') : '',
      hs_subtotal_amount_discount = !!document.querySelector('.hs_subtotal_amount_discount') ? document.querySelector('.hs_subtotal_amount_discount') : '',
      hs_discount_price_global = !!document.querySelector('.hs-discount-price-global') ? document.querySelector('.hs-discount-price-global') : '',
      success_discount = !!document.querySelector('.hs-success-code-discount') ? document.querySelector('.hs-success-code-discount') : '';
    if (hs_sub_total_cart.length > 0) {
      hs_sub_total_cart.forEach(function (val) {
        val.classList.remove('hs-payment-discount');
      });
    };
    if (typeof events !== 'undefined') {
      if (!!hs_error_code_discount) {
        var errorText = slideData.settings.language_settings.valid_coupon_text;
        if (events === 'preview') {
          errorText = 'Discount not found in shop preview.'
        };
        if (message) {
          if (events === 'product_not_available') {
            errorText = message
          };
        };

        if (events !== 'discount_clear') {
          hs_error_code_discount.innerHTML = '<span>' + errorText + '</span>'
        };
        if (events !== 'error') {
          hs_error_code_discount.innerHTML = '<span>' + errorText + '</span>'
        };

      };
    };

    if (!!success_discount) {
      success_discount.innerHTML = '';
    };

    if (!!tagContent) {
      tagContent.innerHTML = '';
    };

    if (!!hs_subtotal_amount_discount) {
      hs_subtotal_amount_discount.innerHTML = ''
    };

    if (!!hs_subtotal_amount_discount) {
      hs_discount_price_global.value = 0
    };

    if (typeof window.HS_SLIDE_CART_UPDATE !== 'undefined') {
      if (!!HsApp1.readCookie('hscodediscount')) {
        window.HS_SLIDE_CART_UPDATE();
      };
    };

    if (!!hs_error_code_discount) {
      setTimeout(function () {
        hs_error_code_discount.innerHTML = '';
      }, 2000);
    };
  },
  closeCouponCheckout: function () {
    var hs_close_discount_slide_carts = document.querySelectorAll('.hs-close-discount-slide-cart:not(.hs-dscto-tag-button)').length > 0 ? document.querySelectorAll('.hs-close-discount-slide-cart:not(.hs-dscto-tag-button)') : [];
    if (hs_close_discount_slide_carts.length > 0) {
      hs_close_discount_slide_carts.forEach(function (hs_close_discount_slide_cart) {
        if (!hs_close_discount_slide_cart.classList.contains('hs-event-static')) {
          hs_close_discount_slide_cart.classList.add('hs-event-static');
          hs_close_discount_slide_cart.addEventListener('click', function (e) {
            e.preventDefault();
            var cookie_code_shopify = HsApp1.readCookie('discount_code');
            if (!!cookie_code_shopify) {
              HsApp1.deleteCookie('discount_code');
            };
            !!window.OCUApi ? HsApp1.deleteCookie('ocu-share-discount') : '';//OCUApi
            if (!!slideData.settings.additional_check.enabled_additional_checkout_buttons) {
              var add_buttons = !!document.querySelector('#hs-additional-buttons') ? document.querySelector('#hs-additional-buttons') : '';
              if (!!add_buttons) {
                var thisHeight = add_buttons.offsetHeight;
                thisHeight = thisHeight > 0 ? thisHeight + 'px' : 'auto';
                add_buttons.innerHTML = '';
                add_buttons.innerHTML = `<div style="height:${thisHeight};" class="hs-show-loading"><div class="hs-spinner"></div></div>`;
              };
            };

            var tagContent = !!document.querySelector('.hs-tag-code-discount') ? document.querySelector('.hs-tag-code-discount') : '';
            if (tagContent) {
              tagContent.innerHTML = ``;
            };
            var a = !!document.querySelector('.hs-success-code-discount') ? document.querySelector('.hs-success-code-discount') : '';
            if (!!a) {
              a.innerHTML = ``;
            };

            if (typeof window.HS_SLIDE_CART_DISCARD_DISCOUNT !== 'undefined') {
              window.HS_SLIDE_CART_DISCARD_DISCOUNT();
            };
            if (typeof window.HS_SLIDE_CART_UPDATE !== 'undefined') {
              window.HS_SLIDE_CART_UPDATE();
            };

            window.HS_SLIDE_CART_APPLY_DISCOUNT('hs_clear_discount');

          });
        }
      });
    };
    /*  */
    var hs_dscto_tag_close_buttons = document.querySelectorAll('.hs-tag-code-discount .hs-dscto-tag-button') || [];
    if (hs_dscto_tag_close_buttons.length > 0) {
      hs_dscto_tag_close_buttons.forEach(function (hs_dscto_tag_close_button) {
        if (!hs_dscto_tag_close_button.classList.contains('hs-event-static')) {
          hs_dscto_tag_close_button.classList.add('hs-event-static');
          hs_dscto_tag_close_button.addEventListener('click', function (e) {
            e.preventDefault();
            if (HsApp1.checkoutPage) {
              var data_checkout = HsApp1.checkoutPage;
              var discount_codes = data_checkout.discount_codes;
              var code_selected = this.dataset.name;

              discount_codes = discount_codes.filter(function (item) {
                return item !== code_selected
              })
              if (discount_codes) {
                if (discount_codes.length >= 1) {
                  window.HS_SLIDE_CART_APPLY_DISCOUNT(discount_codes[0], input = false, "delete");
                } else {
                  var hs_close_discount = document.querySelector('.hs-add-discount .hs-close-discount-slide-cart') || '';
                  if (hs_close_discount) {
                    var ev = new Event("click", { "bubbles": true, "cancelable": false });
                    hs_close_discount.dispatchEvent(ev);
                  };
                };
              };
            };

          });
        }
      });
    };
    /*  */
  },
  updateCouponCode: function (v) {
    //window.HS_SLIDE_CART_APPLY_DISCOUNT('hs_clear_discount');
    //HsApp1.createCpokie('hscodediscount','data.checkout.discount_code', 365);
    var discount_input = !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code') : '',
      hs_apply_discount = !!document.querySelector('button.hs-apply-discount') ? document.querySelector('button.hs-apply-discount') : '',
      sectiondscto = !!document.querySelector('.hs-add-discount') ? document.querySelector('.hs-add-discount') : '';

    if (!!sectiondscto) {
      sectiondscto.classList.remove('hs-disabled');
      !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout').classList.remove('hs-load-discount') : '';
    }
    if (!!hs_apply_discount) {
      hs_apply_discount.classList.remove('hs-loading-btn');
    }
    if (!!discount_input) {
      discount_input.disabled = false;
      discount_input.value = '';
    }
    if (!!v) {
      v.classList.remove('hs-loading-btn');
    }
    window.HS_SLIDE_CART_UPDATE();

  },
  applyDiscountCode: function (e, v) {
    if (!e)
      return;
    const cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
    //e = encodeURIComponent(e);
    const parts = e
      .split(",")
      .map(p => p.trim())
      .filter(Boolean);

    // Volver a unir correctamente
    const discountValue = parts.join(",") || '';

    return new Promise(o => {
      fetch(cart, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: discountValue
        })
      }).finally(() => {
        HsApp1.updateCouponCode(v);
      });
    });
  },
  startDiscount: function (discount = '') {
    var discount_code = HsApp1.readCookie('hscodediscount'),
      total_price_global = !!document.querySelector('.hs-total-price-global') ? parseFloat(document.querySelector('.hs-total-price-global').value) : '',
      hs_apply_discount = !!document.querySelector('button.hs-apply-discount') ? document.querySelector('button.hs-apply-discount') : '',
      hs_remove_discount = document.querySelectorAll('.hs-code-remove').length > 0 ? document.querySelectorAll('.hs-code-remove') : 0,

      cookie_code_shopify = HsApp1.readCookie('discount_code');
    if (cookie_code_shopify === 'CLEAR_DISCOUNT') {
      cookie_code_shopify = '';
    };

    if (hs_remove_discount.length > 0) {
      hs_remove_discount.forEach(function (v) {
        if (!v.classList.contains('hs-event-static')) {
          v.classList.add('hs-event-static');
          v.addEventListener('click', function (e) {
            e.preventDefault();
            var coupon_code = v.getAttribute("data-discount-code"), myArray = [];
            if (!!localStorage.getItem(Hs_CartDrawer.discount_storage)) {
              v.classList.add('hs-loading-btn');
              myArray = localStorage.getItem(Hs_CartDrawer.discount_storage).split(',');
              if (myArray.length > 0) {
                myArray = myArray.filter(item => item !== coupon_code);
                myArray = myArray.join(',');
                if (!!myArray) {
                  HsApp1.applyDiscountCode(myArray, v);
                } else {
                  HsApp1.applyDiscountCode('~!~!HSCART_REMOVE_DISCOUNT!~!~', v);
                }
              }
            }
          });
        }
      });
    }


    if (hs_apply_discount) {
      if (!hs_apply_discount.classList.contains('hs-event-static')) {
        hs_apply_discount.classList.add('hs-event-static');
        hs_apply_discount.addEventListener('click', function (e) {
          e.preventDefault();
          //total_price_global = !!document.querySelector('.hs-total-price-global') ? parseFloat(document.querySelector('.hs-total-price-global').value) : ''
          var discount_input = !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code') : '', mydiscount = '';
          if (!!discount_input) {
            var discount = encodeURIComponent(discount_input.value);
            if (window.localStorage) {
              if (localStorage.getItem(Hs_CartDrawer.discount_storage)) {
                if (!!discount) {
                  discount = discount.split(',');
                  mydiscount = localStorage.getItem(Hs_CartDrawer.discount_storage).split(',');
                  discount = mydiscount.concat(discount);
                  discount = HsApp1.removeDuplicates(discount);
                  discount = discount.join(',');
                }
              };
            };
            localStorage.setItem(
              Hs_CartDrawer.discount_storage, discount
            );
            if (typeof window.HS_SLIDE_CART_APPLY_DISCOUNT !== 'undefined') {
              window.HS_SLIDE_CART_APPLY_DISCOUNT(discount, input = true);
            }
          }
        });
      }
      var hs_discount_code = !!document.querySelector('.hs-discount-code') ? document.querySelector('.hs-discount-code') : '';
      if (!!hs_discount_code) {
        if (!hs_discount_code.classList.contains('hs-event-static')) {
          hs_discount_code.classList.add('hs-event-static');
          hs_discount_code.addEventListener('keydown', function (e) {
            if (e.keyCode == 13) {
              var sectiondscto = !!document.querySelector('.hs-add-discount') ? document.querySelector('.hs-add-discount') : '';
              if (!!sectiondscto) {
                if (!sectiondscto.classList.contains('hs-disabled')) {
                  /* var ev = new Event("click", { "bubbles": true, "cancelable": false }); */
                  hs_apply_discount.click();
                  //hs_apply_discount.focus()
                }
              };
            };
          });
        };
      };
    };
  },
  removeDuplicates: function (array) {
    for (let i = 0; i < array.length; i++) {
      if (array.indexOf(array[i]) !== i) {
        array.splice(i, 1);
        i--;
      }
    }
    return array;
  },
  storageCart: function () {
    var cart = window.HSSLIDECART.CART;
    var all_discount = [];
    if (cart?.items?.length > 0) {//CAMBIO
      cart.items.forEach(function callback(value, index, array) {
        var discount = value.discounts, arr_discount = [];
        if (discount.length > 0) {
          discount.forEach(function callback(x, y, z) {
            arr_discount.push(x.title);
          });
          all_discount.push(arr_discount.join(','));
        }
      });
      if (all_discount.length > 0) {
        var p = [];
        all_discount = all_discount.join(',');
        all_discount = all_discount.split(',');
        all_discount = HsApp1.removeDuplicates(all_discount);
        localStorage.setItem(Hs_CartDrawer.discount_storage, all_discount);
        //HsApp1.setCookie('discount_code',all_discount,360);
      } else {
        localStorage.removeItem(Hs_CartDrawer.discount_storage);
      }
      HsApp1.deleteCookie('discount_code');
    }
    return all_discount;
  },
  countDownCart: function (clss) {
    var text_countdown_cart = slideData.settings.countdown.countdown_text,
      countdown_cart = '';
    if (parseInt(slideData.settings.countdown.enabled_countdown)) {
      const positionKeyCountDown = Hs_CartDrawer.getDataPosition('hs-countdown')?.key || '';

      /* text_countdown_cart = text_countdown_cart.replace("{{time_remaining}}", "<span class='hs_countdown_cart_plus'>" + slideData.settings.countdown.countdown_minutes_reservation + ":00</span>");
 
      text_countdown_cart = text_countdown_cart.replace("{{ time_remaining }}", "<span class='hs_countdown_cart_plus'>" + slideData.settings.countdown.countdown_minutes_reservation + ":00</span>"); */

      if (!!text_countdown_cart) {
        var dynamic_total_save_calculation = HsApp1.dynamic_total_save_calculation();
        var percentage_total_save_calculation = HsApp1.percentage_total_save_calculation();
        if (/\{\{\s*time_remaining\s*\}\}/i.test(slideData.settings.countdown.countdown_text)) {
          text_countdown_cart = text_countdown_cart.replace(
            /\{\{\s*time_remaining\s*\}\}/gi,
            `<span class="hs_countdown_cart_plus">${slideData.settings.countdown.countdown_minutes_reservation}:00</span>`
          );
        }
        if (/\{time_remaining\}/i.test(slideData.settings.countdown.countdown_text)) {
          text_countdown_cart = text_countdown_cart.replace(/\{time_remaining\}/gi, `<span class="hs_countdown_cart_plus">${slideData.settings.countdown.countdown_minutes_reservation}:00</span>`);
        }

        if (/\{dynamic_calculation\}/i.test(slideData.settings.countdown.countdown_text)) {
          text_countdown_cart = text_countdown_cart.replace(/\{dynamic_calculation\}/gi, `<span class="hs-dynamic-calculation-total-save-price">${dynamic_total_save_calculation}</span>`);
        }
        if (/\{total_save_price\}/i.test(slideData.settings.countdown.countdown_text)) {
          text_countdown_cart = text_countdown_cart.replace(/\{total_save_price\}/gi, `<span class="hs-dynamic-calculation-total-save-price">${dynamic_total_save_calculation}</span>`);
        }
        if (/\{total_save_percentage\}/i.test(slideData.settings.countdown.countdown_text)) {
          text_countdown_cart = text_countdown_cart.replace(/\{total_save_percentage\}/gi, `<span class="hs-dynamic-calculation-total-save-percentage">${percentage_total_save_calculation}</span>`);
        }
      };
      countdown_cart = '<div tabindex="0" class="hs-countdown-cart' + clss + '" ' + positionKeyCountDown + '><p>' + text_countdown_cart + '</p></div>';
    };
    return countdown_cart;
  },
  announcementSlider: function () {
    var announcement_autoplay = Hs_CartDrawer.announcement_autoplay_time > 0 ? {
      autoplay: {
        delay: Hs_CartDrawer.announcement_autoplay_time,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    } : {};

    var parameters = {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      a11y: {//
        enabled: true,
        slideLabelMessage: '{{index}} of {{slidesLength}}'
      },
      pagination: {
        el: ".hs-swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".hs-swiper-button-next",
        prevEl: ".hs-swiper-button-prev",
      },
    };

    parameters = { ...parameters, ...announcement_autoplay };

    var swiper = new HS_Swiper(".hs-mySwiper", parameters);

    const announcementSwiper = document.querySelector('.hs-site-cart-popup-layout .hs-mySwiper') || '';
    Hs_CartDrawer.initAccessibleSwiper(swiper, announcementSwiper);

  },
  dynamic_total_save_calculation: function () {
    var dynamic_calculation = window.HSSLIDECART.COMPARE_AT_PRICE;
    if (typeof window.HSSLIDECART.DISCOUNT_TOTAL_PRICE !== "undefined") {
      dynamic_calculation = window.HSSLIDECART.COMPARE_AT_PRICE > window.HSSLIDECART.DISCOUNT_TOTAL_PRICE ? window.HSSLIDECART.COMPARE_AT_PRICE : window.HSSLIDECART.DISCOUNT_TOTAL_PRICE;
    }
    dynamic_calculation = dynamic_calculation - window.HSSLIDECART.SUB_TOTAL;
    dynamic_calculation = hsonslidecart.Currency.formatMoney(dynamic_calculation, slideData.settings.devices.money_format);
    return dynamic_calculation;
  },
  percentage_total_save_calculation: function () {
    const compareAtPrice = window.HSSLIDECART.COMPARE_AT_PRICE;
    const discountTotalPrice = window.HSSLIDECART.DISCOUNT_TOTAL_PRICE;
    const subTotal = window.HSSLIDECART.SUB_TOTAL;

    if (typeof compareAtPrice !== 'number' || isNaN(compareAtPrice) || compareAtPrice <= 0) {
      return null;
    }

    if (typeof subTotal !== 'number' || isNaN(subTotal) || subTotal <= 0) {
      return null;
    }

    const dynamicCalculation = (typeof discountTotalPrice === 'number' && discountTotalPrice > compareAtPrice)
      ? discountTotalPrice
      : compareAtPrice;

    if (dynamicCalculation === 0) {
      return null;
    }

    const total_save = dynamicCalculation - subTotal;
    const porcentaje = (total_save / dynamicCalculation) * 100;

    return Math.round(porcentaje) + '%';

  },
  announcementContent: function () {
    var top_enable_countdown_cart = '',
      announcement = '';
    if (!!parseInt(slideData.settings.announcement.enabled_announcement))//announcement
    {
      if (!!parseInt(slideData.settings.countdown.enabled_countdown)) {
        top_enable_countdown_cart = ' hs-top-4';
      };

      var dynamic_total_save_calculation = HsApp1.dynamic_total_save_calculation();
      var percentage_total_save_calculation = HsApp1.percentage_total_save_calculation();
      var announcement_tiers = slideData.settings.announcement_tiers;

      if (typeof announcement_tiers != undefined) {
        var text_announcement = '';
        announcement_tiers.forEach(function (tier) {
          /* if (!!tier.announcement_text) {
            text_announcement = tier.announcement_text.toLowerCase();
          }
          if (text_announcement.indexOf("{dynamic_calculation}") > -1) {
            text_announcement = text_announcement.replace("{dynamic_calculation}", `<span class="hs-dynamic-calculation-total-save-price">${dynamic_total_save_calculation}</span>`);
          }
          if (text_announcement.indexOf("{total_save_price}") > -1) {
            text_announcement = text_announcement.replace("{total_save_price}", `<span class="hs-dynamic-calculation-total-save-price">${dynamic_total_save_calculation}</span>`);
          }
          if (text_announcement.indexOf("{total_save_percentage}") > -1) {
            text_announcement = text_announcement.replace("{total_save_percentage}", `<span class="hs-dynamic-calculation-total-save-percentage">${percentage_total_save_calculation}</span>`);
          } */
          if (!!tier.announcement_text) {
            text_announcement = tier.announcement_text;
            if (/\{dynamic_calculation\}/i.test(tier.announcement_text)) {
              text_announcement = text_announcement.replace(/\{dynamic_calculation\}/gi, `<span class="hs-dynamic-calculation-total-save-price">${dynamic_total_save_calculation}</span>`);
            }
            if (/\{total_save_price\}/i.test(tier.announcement_text)) {
              text_announcement = text_announcement.replace(/\{total_save_price\}/gi, `<span class="hs-dynamic-calculation-total-save-price">${dynamic_total_save_calculation}</span>`);
            }
            if (/\{total_save_percentage\}/i.test(tier.announcement_text)) {
              text_announcement = text_announcement.replace(/\{total_save_percentage\}/gi, `<span class="hs-dynamic-calculation-total-save-percentage">${percentage_total_save_calculation}</span>`);
            }
            if (/\{time_remaining\}/i.test(tier.announcement_text)) {
              text_announcement = text_announcement.replace(/\{time_remaining\}/gi, `<span class="hs_countdown_cart_plus">${slideData.settings.countdown.countdown_minutes_reservation}:00</span>`);
            }
          };

          announcement = announcement.concat(`<div class="hs-swiper-slide"><p>
                ${text_announcement}</p></div>`);
        });
      };
      var nav_buttons = '';
      if (announcement_tiers.length > 1) {
        nav_buttons = `<!-- If we need navigation buttons -->
                  <div class="hs-swiper-button-next"></div>
                  <div class="hs-swiper-button-prev"></div>
                  `
      };
      announcement = `<!-- Slider main container -->
                <div tabindex="0" class="hs-announcement${top_enable_countdown_cart} hs-mySwiper">
                <!-- Additional required wrapper -->
                <div class="hs-swiper-wrapper">
                <!-- Slides -->
                ${announcement}
                </div>
                ${nav_buttons}
                </div>`;
      !!document.querySelector('.hs-announcement-module') ? document.querySelector('.hs-announcement-module').innerHTML = `${announcement}` : '';//announcement
      if (announcement_tiers.length > 1) {
        HsApp1.announcementSlider();
      }
    };
  },
  rewardsPrintProducts: function (result_rewards) {
    if (result_rewards.from_free_shipping.length > 0) {
      var arrProducts = [], arrProductsHandle = [], prefixIndex = HsApp1.readCookie('hs_sl_prefix_rewards') == undefined ? 0 : parseInt(HsApp1.readCookie('hs_sl_prefix_rewards'));
      result_rewards.from_free_shipping.forEach(function callback(currentValue, index, array) {
        if (currentValue.arr_product.length > 0) {
          currentValue.arr_product.forEach(function callback(c, i, a) {
            arrProducts.push(c);
            arrProductsHandle.push(c.handle);
          });
        }
      });

      arrProductsHandle = HsApp1.removeDuplicates(arrProductsHandle);

      if (arrProductsHandle.length > 0) {
        var productArr = [], arrLatest = [], arrValidate = [], counter = 0, prefix_index = 0;
        arrProductsHandle.forEach(function (handle) {
          var product = Hs_CartDrawer.routeLocale(`products/${handle}.js`);
          fetch(`${product}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            return response.ok ? response.json() : Promise.reject(response);
          }).then((product) => {
            if (product) {
              counter++;
              productArr.push(product);
              if (arrProductsHandle.length == counter) {
                if (productArr.length > 0) {
                  prefix_index = HsApp1.readCookie('hs_sl_prefix_rewards') == undefined ? 0 : parseInt(HsApp1.readCookie('hs_sl_prefix_rewards'));

                  if (!!prefix_index) {
                    arrLatest = HsApp1.latestRewards(prefix_index);
                    prefix_index = arrLatest.data.length == 0 ? 0 : prefix_index;
                  }

                  window.HSSLIDECART.setSettings.rewardsProducts = { products: productArr, validateProducts: arrProducts, result_rewards: result_rewards };
                  HsApp1.viewRewardsProducts(prefix_index);
                }
              }
            }
          }).catch(err => {
            console.error(err);
            counter++
          })
            .then(e => {
            });
        });
      }
    } else {
      HsApp1.viewRewardsProducts(prefixIndex);
    }
  },
  validateRewardsProducts: function (result) {
    var arr = [];
    if (result.products.length > 0) {
      result.products.forEach(function (currentValue) {
        result.validateProducts.forEach(function (x) {
          if (currentValue.handle === x.handle) {
            var arrVariants = [];
            currentValue.variants.forEach(function (z) {
              x.variants.forEach(function (y) {
                if (z.id == y.id) {
                  z.qty = x.quantity;
                  if (!!z.available) {
                    arrVariants.push(z);
                  }
                }
              });
              currentValue.variants = arrVariants;
            });
          }
        });
      });
      arr = result.products;
    }
    return arr;
  },
  loadRewardsProducts: function () {
    var hs_rewards_products = document.querySelectorAll('.hs-sl-rw-product,.hs-tab-rewards-description').length > 0 ? document.querySelectorAll('.hs-sl-rw-product,.hs-tab-rewards-description') : [];
    if (hs_rewards_products.length > 0) {
      hs_rewards_products.forEach(function (addToCart) {
        if (!addToCart.classList.contains('hs-event-static')) {
          addToCart.classList.add('hs-event-static');
          addToCart.addEventListener('click', function (event) {
            event.preventDefault();
            var index = parseInt(addToCart.getAttribute('data-index'));
            HsApp1.setCookie('hs_sl_prefix_rewards', index, 360);
            HsApp1.viewRewardsProducts(index, 1, 1);
          });

          addToCart.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              var index = parseInt(addToCart.getAttribute('data-index'));
              HsApp1.setCookie('hs_sl_prefix_rewards', index, 360);
              HsApp1.viewRewardsProducts(index, 1, 1);
            }
          });
        }
      });
    }
  },
  validateRewardsCartProduct: function (arrProducts) {
    let cartItems = HSSLIDECART.CART, myarr = [], countProducts = 0;
    if (cartItems != undefined) {
      if (cartItems.items.length > 0) {
        if (arrProducts.length > 0) {
          arrProducts.forEach(function (result, index, array) {
            var l = 0;
            cartItems.items.forEach(function (item, i, arr) {
              if (result.id == item.product_id) {
                if (item.properties && item.properties.hasOwnProperty("_hs-index")) {
                  l = 1;
                }
              }
            });
            if (result.variants.length > 0) {
              result.added = 1;
              if (!l) {
                result.added = 0;
              } else {
                countProducts = countProducts + 1;
              }
              myarr.push(result);
            }
          });
        }
      } else {
        myarr = arrProducts;
      }
    }
    myarr = { myarr: myarr, countProducts: countProducts };
    return myarr;
  },
  addRewardsItems: function (params) {

    var add = Hs_CartDrawer.routeLocale('cart/add.js?hs-rewards');

    fetch(`${add}`, {
      body: params,
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }).then(function (response) {
      /* return response.ok ? response.json() : Promise.reject(response) ; */
      return response.json();
    }).then(function (json) {
      if (!!json.status) {
        window.HS_SLIDE_CART_UPDATE();
        error = true;
        alert(`Error ${json.status}: ${json.description}`);
        return false;
      }
    }).catch(error => {
      console.log(error);
    }).then(function () {
    }).finally(() => {
      window.HS_SLIDE_CART_UPDATE();
    });
  },
  removeRewardsItems: function (params) {

    var update = Hs_CartDrawer.routeLocale('cart/update.js?hs-rewards');

    fetch(`${update}`, {
      body: params,
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      dataType: 'json'
    }).then(function (response) {
      /* return response.ok ? response.json() : Promise.reject(response) ; */
      return response.json();
    }).then(function (json) {
      if (!!json.status) {
        window.HS_SLIDE_CART_UPDATE();
        error = true;
        alert(`Error ${json.status}: ${json.description}`);
        return false;
      }
    }).catch(error => {
      console.log(error);
    }).then(function () {
    }).finally(() => {
      window.HS_SLIDE_CART_UPDATE();
    });
  },
  autoAddRewardsProducts: function (arrProducts, congrats, thisIndex) {
    var rewardsData = window.HSSLIDECART.setSettings.rewardsProducts,
      cart = window.HSSLIDECART.CART,
      arrCart = [],
      valArr = [],
      limit_product_qty = [],
      letQuantity = 1,
      fromBar = rewardsData.result_rewards.from_free_shipping,
      countBar = fromBar.length - 1,
      position = thisIndex,
      reward_id = 0,
      discount_type = 0,
      discount_value = 0,
      formData = ``,
      congrats = congrats == null ? `` : congrats;
    elementHeaderRewardsText = !!document.querySelectorAll('.hs-text-free-shipping') ? document.querySelector('.hs-text-free-shipping') : 0,
      elementLimitRewardsText = !!document.querySelectorAll('.hs-text-rewards-products-load') ? document.querySelector('.hs-text-rewards-products-load') : 0,
      limit_products_rewards = `<div class="hs-sl-rewards-text-congrats hs-sl-rewards-none">${congrats}</div>`;

    if (countBar == rewardsData.result_rewards.thisIndex) {
      if (elementHeaderRewardsText) {
        elementHeaderRewardsText.innerHTML = congrats;
      }
    } else {
      if (elementLimitRewardsText) {
        elementLimitRewardsText.innerHTML = limit_products_rewards;
      }
    }

    if (!!rewardsData.result_rewards) {
      if (rewardsData.result_rewards.from_free_shipping.length > 0) {
        limit_product_qty = rewardsData.result_rewards.from_free_shipping[thisIndex].arr_product;
        discount_type = rewardsData.result_rewards.from_free_shipping[thisIndex].discount_type;
        discount_value = rewardsData.result_rewards.from_free_shipping[thisIndex].discount_value;
      }
    }

    if (fromBar.length > 0) {
      fromBar.forEach(function (result, index, array) {
        if (index == position) {
          reward_id = result.reward_id;
        }
      });
    }

    function isItemAlreadyInCart(cart, variantIdToCheck, hsIndexToCheck, rewardIdToCheck) {
      return cart.items.some(item => {
        const hasProps = item.properties && item.properties["_hs-index"] != null && item.properties["_hs-reward-id"] != null;
        return (
          item.variant_id == variantIdToCheck &&
          hasProps &&
          item.properties["_hs-index"] == hsIndexToCheck &&
          item.properties["_hs-reward-id"] == rewardIdToCheck
        );
      });
    }

    if (arrProducts.length > 0) {
      arrProducts.forEach(function (result, index, array) {
        if (!!limit_product_qty) {
          if (limit_product_qty.length > 0) {
            letQuantity = 1;
            limit_product_qty.forEach(function (x, y, z) {
              if (x.handle == result.handle) {
                letQuantity = x.quantity;
              }
            });
          }
        }

        if (result.variants.length > 0) {
          result.variants.forEach(function (r, i, a) {
            const variantId = r.id;
            if (!isItemAlreadyInCart(cart, variantId, position, reward_id)) {
              formData += '{ "id": ' + r.id + ', "quantity": ' + r.qty + ', "properties": { "_hs-index": ' + position + ', "_hs-reward-id": ' + reward_id + ', "_hs-reward-discount-type": ' + discount_type + ', "_hs-reward-discount-value": ' + discount_value + ', "_hs-reward-qty": ' + letQuantity + ' } },';
            }
          });
        }
      });

      const autoRw = 0;//parseInt(localStorage.getItem('hs_sl_auto_load_items_rewards_' + position));
      if (!autoRw) {
        if (!!formData) {
          formData = formData.slice(0, -1);
          formData = '{"items":[' + formData + ']}';

          //localStorage.setItem('hs_sl_auto_load_items_rewards_' + position, 1);

          formData = JSON.parse(formData);
          formData = JSON.stringify(formData);
          HsApp1.addRewardsItems(formData);
        }
      }
    }
  },
  removeRewardsProducts: function (thisIndex) {
    var rewardsData = window.HSSLIDECART.setSettings.rewardsProducts,
      formData = '',
      cart = HSSLIDECART.CART,
      position = thisIndex;
    if (!!cart) {
      if (cart.items.length > 0) {
        cart.items.forEach(function (result, index, array) {
          if (Object.keys(result.properties).length > 0) {
            for (const mykey in result.properties) {
              if (result.properties.hasOwnProperty(mykey)) {
                if (mykey === '_hs-index') {
                  var i = parseInt(result.properties[mykey]);
                  if (position < i) {
                    formData += '"' + result.key + '": 0,';
                  }
                }
              }
            }
          }
        });
        if (!!formData) {
          formData = formData.slice(0, -1);
          formData = '{"updates":{' + formData + '}}';
          formData = JSON.parse(formData);
          formData = JSON.stringify(formData);
          HsApp1.removeRewardsItems(formData);
        }
      }
    }
  },
  latestRewards: function (thisIndex) {
    var result = window.HSSLIDECART.setSettings.rewardsProducts,
      cart = window.HSSLIDECART.CART,
      total_price = HsApp1.rewardsExcludeProd(cart),
      item_count = HsApp1.removeRewardCount(cart),
      rewards_basis = slideData.settings.rewards.rewards_basis,
      title = '',
      free_shipping_price_away = '',
      mode_add = 0,
      limit_items = 0,
      reward_id = 0,
      discount_type = 0,
      rewards_type = 0,
      products_limit = 0,
      products_limit_enabled = 0,
      discount_value = 0,
      products = HsApp1.validateRewardsProducts(result),
      arr = [],
      arrAllProducts = [],
      arrProducts = [],
      arrValidate = [],
      allProducts = [];

    if (result.result_rewards.from_free_shipping.length > 0) {
      result.result_rewards.from_free_shipping.forEach(function (c, index, array) {
        if (index == thisIndex) {
          mode_add = c.mode_add;
          reward_id = c.reward_id;
          discount_type = c.discount_type;
          rewards_type = c.rewards_type;
          products_limit_enabled = parseInt(c.products_limit_enabled);
          products_limit = parseInt(c.products_limit);
          discount_value = parseFloat(c.discount_value);
          congrats = c.congrats;

          free_shipping_price_away = !!rewards_basis ? item_count : total_price;

          free_shipping_price_away = !!rewards_basis ? c.count - free_shipping_price_away : c.price - free_shipping_price_away;
          free_shipping_price_away = !!rewards_basis ? free_shipping_price_away : hsonslidecart.Currency.formatMoney(free_shipping_price_away, slideData.settings.devices.money_format);
          free_shipping_price_away = `<strong>${free_shipping_price_away}</strong>`;

          if (!rewards_basis) {
            text_free_shipping_price_away = c.title.replace("{{price}}", free_shipping_price_away);
            text_free_shipping_price_away = text_free_shipping_price_away.replace("{{ price }}", free_shipping_price_away);

            text_free_shipping_price_away = text_free_shipping_price_away.replace("{AMOUNT}", free_shipping_price_away);
            text_free_shipping_price_away = text_free_shipping_price_away.replace("{ AMOUNT }", free_shipping_price_away);
          } else {
            text_free_shipping_price_away = c.title.replace("{COUNT}", free_shipping_price_away);
            text_free_shipping_price_away = text_free_shipping_price_away.replace("{ COUNT }", free_shipping_price_away);
          }

          title = `<div class="hs-sl-rewards-text-congrats">${text_free_shipping_price_away}</div>`;

          if (c.arr_product.length > 0) {
            c.arr_product.forEach(function (x, index, array) {
              products.forEach(function (l, i, a) {
                if (x.handle === l.handle) {
                  arrProducts.push(l);
                }
              });
            });
          }
        }
      });
    }

    allProducts = arrProducts;
    arrValidate = HsApp1.validateRewardsCartProduct(arrProducts);
    arrProducts = arrValidate.myarr;

    //PRODUCT LIMIT
    if (!mode_add) {
      if (!!products_limit_enabled) {
        if (!!arrValidate.countProducts) {
          if (arrValidate.countProducts >= products_limit) {
            limit_items = 1;
          }
        }
      }
    }

    if (arrProducts.length > 0) {
      arrAllProducts = [];
      arrProducts.forEach(function (c, index, array) {
        c.limit_items = limit_items;
        arrAllProducts.push(c);
      });
    }

    arr = {
      data: arrAllProducts,
      countProducts: arrValidate.countProducts,
      b: allProducts,
      mode_add: mode_add,
      rewards_type: rewards_type,
      reward_id: reward_id,
      discount_type: discount_type,
      products_limit: products_limit,
      products_limit_enabled: products_limit_enabled,
      discount_value: discount_value,
      title: title,
      congrats: congrats
    };

    return arr;
  },
  descriptionRewardsGift: function (fromBar, loadIndex, thisIndex) {
    var elementTab = ``, active = ``, count = 0;
    if (fromBar.length > 0) {
      fromBar.forEach(function (c, index, array) {
        //if(index <= loadIndex)
        //{
        if (c.rewards_type == 2) {
          count = count + 1;
          active = thisIndex == index ? ` hs-sl-rewards-btn-active` : ``;
          elementTab = elementTab.concat(`<button title="${c.description}" type="button" name="hs_tab_rewards_description" data-index="${index}" class="hs-tab-rewards-description${active}">${c.icon}${c.description}</button>`);
        }
        //}
      });
    }

    elementTab = `<div class="hs-tab-content-header">${elementTab}</div>`;
    if (count == 1) {
      elementTab = ``;
    }
    return elementTab;
  },
  resetRewards: function () {
    for (var i = 0; i < 6; i++) {
      localStorage.removeItem("hs_sl_this_index_rewards_" + i);
    }
  },
  autoRewardsOff: function () {
    for (var i = 0; i < 6; i++) {
      localStorage.setItem("hs_sl_auto_load_items_rewards_" + i, 0);
    }
  },
  goalRewardsUnlock: function (l) {
    for (var i = 0; i <= l; i++) {
      localStorage.setItem('hs_sl_this_index_rewards_' + i, i);
    }
  },
  viewRewardsProducts: function (thisIndex = 0, auto = 0, static = 0) {
    if (Object.keys(window.HSSLIDECART.setSettings.rewardsProducts).length > 0) {
      var result = window.HSSLIDECART.setSettings.rewardsProducts,
        rewards_content_popup_title = slideData.settings.rewards.rewards_content_popup_title,
        rewards_content_popup_description = slideData.settings.rewards.rewards_content_popup_description,
        rewards_auto_open_picker_popup = slideData.settings.rewards.rewards_auto_open_picker_popup,
        rewards_popup_continue_language_settings = slideData.settings.language_settings.rewards_popup_continue_language_settings,
        rewards_popup_pick_language_settings = slideData.settings.language_settings.rewards_popup_pick_language_settings,
        rewards_popup_remove_language_settings = slideData.settings.language_settings.rewards_popup_remove_language_settings,//NO SE USA
        fromBar = result.result_rewards.from_free_shipping,
        countBar = !!fromBar.length ? fromBar.length - 1 : 0,
        modalProducts = document.querySelectorAll('.hs-content-modal-rewards-products').length > 0 ? document.querySelector('.hs-content-modal-rewards-products') : 0,
        elementProduct = 0,
        elementContentRewardsProducts = 0,
        elementRewardsProducts = 0,
        elementHeaderRewardsText = 0,
        elementLimitRewardsText = 0,
        hs_sl_popup_static = localStorage.getItem('hs_sl_popup_static'),
        hs_sl_this_index_rewards = localStorage.getItem('hs_sl_this_index_rewards_' + result.result_rewards.thisIndex) == undefined ? 0 : parseInt(localStorage.getItem('hs_sl_this_index_rewards_' + result.result_rewards.thisIndex)),
        mode_add = 0,
        reward_id = 0,
        title = '',
        congrats = '',
        elementLimitProducts = '',
        classLimitProducts = '',
        classHidePopup = '',
        prefix_index = 0,
        rewards_type = 0,
        discount_type = 0,
        discount_value = 0,
        products_limit = 0,
        products_limit_enabled = 0,
        unlock = 0,
        limit_products_rewards = ``,
        rewardsSettings = {},
        arrRewardDescription = [],
        allProducts = [],
        arrLatest = [],
        arrProducts = [];

      thisIndex = !thisIndex ? result.result_rewards.thisIndex : thisIndex;
      arrLatest = HsApp1.latestRewards(thisIndex);
      rewards_type = arrLatest.rewards_type;
      mode_add = arrLatest.mode_add;
      congrats = arrLatest.congrats;
      arrProducts = arrLatest.data;

      HsApp1.removeRewardsProducts(result.result_rewards.thisIndex);

      fromBar
        .map((item, index) => {
          if (item.mode_add === 1 && Array.isArray(item.arr_product) && item.arr_product.length > 0) {
            if (index < thisIndex) {
              const localStorageKey = 'hs_sl_this_index_rewards_' + index;
              const localStorageValue = localStorage.getItem(localStorageKey);
              if (!localStorageValue) {
                let arrLatest_ = HsApp1.latestRewards(index);
                let mode_add_ = arrLatest_.mode_add;
                let congrats_ = arrLatest_.congrats;
                let arrProducts_ = arrLatest_.data;
                if (!!mode_add_) {
                  HsApp1.autoAddRewardsProducts(arrProducts_, congrats_, index);
                  HsApp1.loadRewardsProducts();
                  HsApp1.goalRewardsUnlock(index);
                }
              };
            };
          }
          return null;
        });


      //AUTO ADD PRODUCT
      if (result.result_rewards.thisIndex == thisIndex) {
        if (!!mode_add) {
          // if (typeof window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] !== 'undefined' && window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] == 1) {
          HsApp1.autoAddRewardsProducts(arrProducts, congrats, thisIndex);
          HsApp1.loadRewardsProducts();
          // }
        }
      }

      if (!static) {
        if (hs_sl_this_index_rewards == result.result_rewards.thisIndex || rewards_type != 2) {
          HsApp1.loadRewardsProducts();
          return false;
        }
      }

      //localStorage Index Rewards
      HsApp1.goalRewardsUnlock(result.result_rewards.thisIndex);
      //localStorage.setItem('hs_sl_this_index_rewards_'+result.result_rewards.thisIndex, result.result_rewards.thisIndex);

      if (!!modalProducts) {
        modalProducts.remove();
        modalProducts = 0;
      }

      /*if (result.result_rewards.thisIndex < thisIndex) {
        thisIndex = result.result_rewards.thisIndex;
      } else {
        thisIndex = !thisIndex ? result.result_rewards.thisIndex : thisIndex;
      }*/

      arrRewardDescription = HsApp1.descriptionRewardsGift(fromBar, result.result_rewards.thisIndex, thisIndex);

      allProducts = arrLatest.b;

      title = arrLatest.title;
      reward_id = arrLatest.reward_id;
      discount_type = arrLatest.discount_type;
      products_limit = arrLatest.products_limit;
      products_limit_enabled = arrLatest.products_limit_enabled;
      discount_value = arrLatest.discount_value;
      classHidePopup = !static && !!mode_add ? ` hs-sl-hide-popup` : !static && !rewards_auto_open_picker_popup && !hs_sl_popup_static ? ` hs-sl-hide-popup` : ``;

      //REMOVE PRODUCTS

      /*if (fromBar.length > 0) {
        fromBar.forEach(function (result, index, array) {
          if (index < thisIndex) {
            if (!!result.mode_add) {
              HsApp1.viewRewardsProducts(index, 1);
            }
          }
        });
      }*/

      if (rewards_type < 2) {
        HsApp1.loadRewardsProducts();
        return false;
      }

      if (!modalProducts) {
        document.querySelector('body').insertAdjacentHTML('beforeend', `
          <div class="hs-content-modal-rewards-products${classHidePopup}" data-index="${thisIndex}">
            <div class="hs-content-rewards-products" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="hs-modal-rewards-products-title" aria-describedby="hs-modal-rewards-products-description">
              <div class="hs-modal-rewards-content-close">
                <a href="javascript:void();" aria-label="Close rewards modal" class="hs-modal-rewards-close" data-index="${thisIndex}">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="14px" height="14px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
                </a>
              </div>
              <div class="hs-title-rewards-goals">${rewards_content_popup_title}</div>
              <div class="hs-description-rewards-goals">${rewards_content_popup_description}</div>
              ${arrRewardDescription}
              <div class="hs-text-rewards-products-load"></div>
              <div class="hs-rewards-products-load"></div>
            </div>
          </div>`);
      }

      //elementHeaderRewardsText = document.querySelectorAll('.hs-text-free-shipping').length > 0 ? document.querySelector('.hs-text-free-shipping') : 0;
      elementContentRewardsProducts = document.querySelectorAll('.hs-content-rewards-products').length > 0 ? document.querySelector('.hs-content-rewards-products') : 0;
      elementRewardsProducts = document.querySelectorAll('.hs-rewards-products-load').length > 0 ? document.querySelector('.hs-rewards-products-load') : 0;
      elementLimitRewardsText = document.querySelectorAll('.hs-text-rewards-products-load').length > 0 ? document.querySelector('.hs-text-rewards-products-load') : 0;

      if (!!elementRewardsProducts) {
        elementRewardsProducts.innerHTML = ``;

        elementLimitRewardsText.innerHTML = ``;

        unlock = result.result_rewards.thisIndex < thisIndex ? 0 : 1;

        rewardsSettings = { mode_add: mode_add, reward_id: reward_id, discount_type: discount_type, discount_value: discount_value, products_limit: products_limit, countProducts: arrLatest.countProducts, position: thisIndex, unlock: unlock };

        elementLimitProducts = `<div class="hs-sl-rewards-text-products-limit">${rewardsSettings.countProducts}/${rewardsSettings.products_limit} ${slideData.settings.language_settings.rewards_selected_language_settings} ${slideData.settings.language_settings.rewards_items_language_settings}</div>`;

        if (arrLatest.countProducts > products_limit || products_limit >= allProducts.length || !rewardsSettings.products_limit) {
          elementLimitProducts = ``;
          classLimitProducts = ` hs-sl-rewards-none`;
        }

        limit_products_rewards = !!products_limit_enabled ? `<div class="hs-sl-rewards-text-congrats${classLimitProducts}">${congrats}</div>${elementLimitProducts}` : `<div class="hs-sl-rewards-text-congrats hs-sl-rewards-none">${congrats}</div>`;

        limit_products_rewards = result.result_rewards.thisIndex < thisIndex ? title : limit_products_rewards;

        if (countBar == result.result_rewards.thisIndex) {
          //elementHeaderRewardsText.innerHTML = !!congrats ? congrats : ``;
          elementLimitRewardsText.innerHTML = !!elementLimitProducts ? limit_products_rewards : limit_products_rewards;
        } else {
          elementLimitRewardsText.innerHTML = !!congrats ? limit_products_rewards : ``;
        }

        if (arrProducts.length > 0) {
          slide = 1,
            count = typeof slideData.customize !== 'undefined' ? slideData.customize.customize_slidecart_size == 500 || slideData.customize.customize_slidecart_size == 450 ? arrProducts.length > 3 ? 3 : arrProducts.length : arrProducts.length > 2 ? 2 : arrProducts.length : arrProducts.length > 3 ? 3 : arrProducts.length;

          if (window.innerWidth <= 10000 && arrProducts.length > 2) {
            count = arrProducts.length - 1;
          }

          if (window.innerWidth <= 320 && arrProducts.length > 1) {
            count = arrProducts.length - 1;
          }

          if (arrProducts.length > count) {
            slide = 0;
            elementRewardsProducts.classList.add('hs-sl-carousel-rewards');
          } else {
            elementRewardsProducts.classList.remove('hs-sl-carousel-rewards');
          }
          elementProduct = HsApp1.upsellProductsJson(0, slide, 'hs-rewards-swiper-container-recommend', arrProducts, 'none', 1, 1, '', rewardsSettings);

          elementRewardsProducts.innerHTML = elementProduct;

          if (arrProducts.length > count) {
            HsApp1.swiperRewardsHSCart(arrProducts.length);
          }

          Hs_CartDrawer.rewards_product_count = arrProducts.length;
          HsApp1.upsellAddToCartFreeShipping(0, 'rewards');
        }
      };

      if (elementContentRewardsProducts) {
        elementContentRewardsProducts.focus();
        try {
          Hs_CartDrawer.trapFocus(elementContentRewardsProducts, elementContentRewardsProducts);
        } catch (error) {
          console.log(error)
        };
      };

      localStorage.setItem('hs_sl_popup_static', 1);
      HsApp1.loadRewardsProducts();
      HsApp1.upsellNoPopUp();
      HsApp1.closeModalRewards();
      HsApp1.upsellVariants();
      HsApp1.currencyConverter();
    }
  },
  closeModalRewards: function () {
    var close_modal_rewards = document.querySelectorAll('.hs-content-modal-rewards-products,.hs-modal-rewards-close').length > 0 ? document.querySelectorAll('.hs-content-modal-rewards-products,.hs-modal-rewards-close') : [];
    if (close_modal_rewards.length > 0) {
      close_modal_rewards.forEach(function (addToCart) {
        if (!addToCart.classList.contains('hs-event-static')) {
          addToCart.classList.add('hs-event-static');
          addToCart.addEventListener('click', function (event) {
            event.preventDefault();
            event.srcElement.closest('.hs-content-modal-rewards-products').style.display = 'none';
            event.srcElement.closest('.hs-content-modal-rewards-products').classList.add('hs-modal-rewards-closed');

            /* try {
              Hs_CartDrawer.removeTrapFocus();
              const containerToTrapFocusOn = document.querySelector('.hs-popup-cart-sp-load.hs-active') || '';
              if (!containerToTrapFocusOn) {
                const focusable = [...document.body.querySelectorAll(
                  '[tabindex]:not([tabindex="-1"]), button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
                )].find(el => el.offsetParent !== null);
                focusable?.focus();
                return false
              };
              const focusElement = document.querySelector('.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout') || document.querySelector('.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-close');
              if (containerToTrapFocusOn) {
                Hs_CartDrawer.trapFocus(containerToTrapFocusOn, focusElement);
              };
            } catch (error) {
              console.log(error)
            }; */
            //Hs_CartDrawer.focusOnItemsCart();
            const rw_index = Number(addToCart?.dataset?.index) || 0;
            if (rw_index || rw_index > 0) {
              const elementRw = document.querySelectorAll('.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-cart__tierCircle.hs-sl-rw-product').length > 0 ? document.querySelector(`.hs-popup-cart-sp-load.hs-active .hs-site-cart-popup-layout .hs-cart__tierCircle.hs-sl-rw-product[data-index="${rw_index}"]`) : 0;
              if (elementRw) {
                elementRw.focus();
              }
            };
          });
        }
      });
    }

    var clse_modal_stop = document.querySelectorAll('.hs-content-rewards-products').length > 0 ? document.querySelectorAll('.hs-content-rewards-products') : [];
    if (clse_modal_stop.length > 0) {
      clse_modal_stop.forEach(function (addToCart) {
        if (!addToCart.classList.contains('hs-event-static')) {
          addToCart.classList.add('hs-event-static');
          addToCart.addEventListener('click', function (event) {
            event.stopPropagation();
          });
        }
      });
    }

  },
  calcTotalRw: (e, t) => {
    let r = 0
      , n = e.length
      , o = null
      , a = 0;
    for (let i of e) {
      if (t < HsApp1.Pf(i.price)) {
        o = i;
        break
      }
      a += 1
    }
    if (o === null)
      return 100;
    if (t !== 0) {
      let i = 100 / n
        , s = a * i
        , l = a > 0 ? HsApp1.Pf(e[a - 1].price) : 0
        , c = HsApp1.Pf(o.price) - l
        , u = t - l;
      r = s + u / c * i
    }
    return r
  },
  calcCountRw: (e, t) => {
    let r = 0
      , n = e.length
      , o = null
      , a = 0;
    for (let i of e) {
      if (t < parseInt(i.count)) {
        o = i;
        break
      }
      a += 1
    }
    if (o === null)
      return 100;
    if (t !== 0) {
      let i = 100 / n
        , s = a * i
        , l = a > 0 ? parseInt(e[a - 1].count) : 0
        , c = parseInt(o.count) - l
        , u = t - l;
      r = s + u / c * i
    }
    return r
  },
  Pf: function (e) {
    return typeof e == "number" ? e : parseFloat(e)
  },
  rewardsContent: function (total_price) {
    function amountConvert(type, amount) {
      switch (type) {
        case 0:
          if (!Hs_CartDrawer.rewards_specific_mode) {
            amount = amount * 100;
          } else {
            amount = parseInt(amount);
          };
          break;
        case 1:
          if (!Hs_CartDrawer.rewards_all_mode) {
            amount = amount * 100;
          } else {
            amount = parseInt(amount);
          };
          break;
      };
      return amount;
    };
    //window.HSSLIDECART.cart.total_price
    var arr = [],
      price = '',
      count_tier = 0,
      title_tier = '',
      cart = window.HSSLIDECART.CART,
      item_count = HsApp1.removeRewardCount(cart),
      rewards_basis = slideData.settings.rewards.rewards_basis,
      from_free_shipping = [],
      total_discount_price = !!document.querySelector('.hs-discount-price-global') ? document.querySelector('.hs-discount-price-global') : '',
      total_from_free_shipping = 0,
      text_free_shipping = '',
      text_free_shipping_price_away = [],
      free_shipping_price_away = '',
      free_shipping = [],
      text_congrats = '',
      confetti = {};

    if (!!parseInt(slideData.settings.rewards.enabled_rewards)) {
      var rewards_default = '';
      var currency = 1;
      if (typeof slideData.settings.rewards.rewards_converted_amount !== 'undefined') {
        if (!!slideData.settings.rewards.rewards_converted_amount) {
          if (!!window.Shopify) {
            if (!!window.Shopify.currency) {
              if (!!window.Shopify.currency.rate) {
                currency = parseFloat(Shopify.currency.rate);
              };
            };
          };
        };
      };
      if (slideData.settings.rewards_specific_countries_tiers.length > 0) {
        if (HsApp1.arr_rewards.length > 0) {
          rewards_default = HsApp1.arr_rewards.slice();
        } else {
          rewards_default = slideData.settings.rewards_specific_countries_tiers.filter(reward => reward.rewards_specific_country === "1") || [];
        };

        if (typeof rewards_default != undefined) {
          rewards_default.forEach(function (val, i) {
            price = parseFloat(val.rewards_amount_specific_countries) * currency;
            count_tier = typeof val.rewards_item_count_specific_countries !== 'undefined' ? val.rewards_item_count_specific_countries : 0;
            title_tier = !rewards_basis ? val.rewards_title_specific_countries : val.rewards_item_count_title_specific_countries;
            from_free_shipping.push({
              'count': count_tier,
              'price': amountConvert(0, price)/* price * 100 */,
              'title': title_tier,
              'reward_id': val.reward_id,
              'congrats': val.rewards_congratulations_specific_countries,
              'rewards_type': val.rewards_type_specific_countries,
              'discount_type': val.rewards_discount_type_specific_countries,
              'discount_value': val.rewards_discount_value_specific_countries,
              'mode_add': val.rewards_mode_add_specific_countries,
              'products_limit_enabled': val.rewards_products_limit_enabled_specific_countries,
              'products_limit': val.rewards_products_limit_specific_countries,
              'icon': val.rewards_type_icon_specific_countries,
              'mode': Hs_CartDrawer.rewards_specific_mode,
              'description': val.rewards_description_specific_countries,
              'arr_product': val.rewards_products_specific_countries,
              'targetType': val.rewards_type_specific_countries,
              'confetti': { 'show': typeof val.rewards_confetti_specific_countries !== 'undefined' ? val.rewards_confetti_specific_countries : false, 'time': typeof val.rewards_confetti_time_specific_countries !== 'undefined' ? val.rewards_confetti_time_specific_countries : 300 }
            });
          });
        };
      };

      if (slideData.settings.rewards_all_countries_tiers.length > 0 && HsApp1.arr_rewards.length <= 0) {
        rewards_default = slideData.settings.rewards_all_countries_tiers;
        if (typeof rewards_default != undefined) {
          rewards_default.forEach(function (val, i) {
            price = parseFloat(val.rewards_amount) * currency;
            count_tier = 0;
            from_free_shipping.push({
              'count': count_tier,
              'price': amountConvert(1, price)/* price * 100 */,
              'title': val.rewards_title,
              'reward_id': val.reward_id,
              'congrats': val.rewards_congratulations,
              'rewards_type': val.rewards_type_specific_countries,
              'discount_type': val.rewards_discount_type_specific_countries,
              'discount_value': val.rewards_discount_value_specific_countries,
              'mode_add': val.rewards_mode_add_specific_countries,
              'products_limit_enabled': val.rewards_products_limit_enabled_specific_countries,
              'products_limit': val.rewards_products_limit_specific_countries,
              'icon': val.rewards_type_icon_specific_countries,
              'mode': Hs_CartDrawer.rewards_all_mode,
              'description': val.rewards_description,
              'arr_product': val.rewards_products_specific_countries,
              'targetType': val.rewards_type,
              'confetti': { 'show': typeof val.rewards_confetti !== 'undefined' ? val.rewards_confetti : false, 'time': typeof val.rewards_confetti_time !== 'undefined' ? val.rewards_confetti_time : 300 }
            });
          });
        };
      };

      if (from_free_shipping.length <= 0) {
        return false;
      };

      if (typeof from_free_shipping.find(arr => arr.price == 0) === 'undefined') {
        from_free_shipping.push({
          'count': 0,
          'price': 0,
          'title': '',
          'reward_id': 0,
          'congrats': '',
          'rewards_type': 0,
          'products_limit_enabled': 0,
          'products_limit': 0,
          'icon': '',
          'discount_type': 0,
          'discount_value': 0,
          'mode_add': 0,
          'mode': 0,
          'description': '',
          'arr_product': [],
          'targetType': 0,
          'confetti': { 'show': false, 'time': 0 }
        }
        );
      };

      from_free_shipping = from_free_shipping.sort(
        function (a, b) {
          var a_amount = !!rewards_basis ? a.count : a.price, b_amount = !!rewards_basis ? b.count : b.price;
          return a_amount > b_amount ? 1 : b_amount > a_amount ? -1 : 0
        }
      );//order array less to higher

      var index = 0;
      var vals = [];
      var arr_rewards = [];
      var min = !!rewards_basis ? from_free_shipping[0].count : from_free_shipping[0].price;
      for (let i = index; i < from_free_shipping.length; i++) {
        var from_free_shipping_amount = !!rewards_basis ? from_free_shipping[i].count : from_free_shipping[i].price;
        if (from_free_shipping_amount > min && from_free_shipping_amount <= (!!rewards_basis ? item_count : total_price)) {
          vals = from_free_shipping[i];
          index = i;
        }
        if (from_free_shipping_amount == 0) {
          vals = from_free_shipping[i];
          index = i;
        };
        if (slideData.settings.rewards.rewards_mode == 3) {
          if (!!from_free_shipping[i].reward_id && !!from_free_shipping[i].price) {
            arr_rewards.push(from_free_shipping[i]);
          }
        } else {
          if (!!from_free_shipping[i].price) {
            arr_rewards.push(from_free_shipping[i]);
          }
        }
      };
      if (vals.length == 0) {
        vals = from_free_shipping[1]
      };

      if (index == 0 && from_free_shipping.length == 1) {
        free_shipping = from_free_shipping[index]
      } else if (index == 0 || index < from_free_shipping.length - 1) {
        free_shipping = from_free_shipping[index + 1]
      } else {
        free_shipping = from_free_shipping[index]
      };

      var size = from_free_shipping.length;
      var validate = 0;
      var from_free_shipping_size = from_free_shipping[size - 1];
      var from_free_shipping_size_amount = !!rewards_basis ? from_free_shipping_size.count : from_free_shipping_size.price;
      var percentageTotalRw = !!rewards_basis ? HsApp1.calcCountRw(arr_rewards, item_count) : HsApp1.calcTotalRw(arr_rewards, total_price);

      //if (from_free_shipping_size_amount != 0) {

      //total_from_free_shipping = !!rewards_basis ? item_count / from_free_shipping_size_amount : total_price / from_free_shipping_size_amount;
      total_from_free_shipping = percentageTotalRw;

      free_shipping_price_away = !!rewards_basis ? item_count : total_price;
      text_congrats = from_free_shipping[index].congrats !== '' ? '<div class="hs-text-rewards-goal">' + from_free_shipping[index].congrats + '</div>' : '';
      confetti = from_free_shipping[index].confetti;

      free_shipping_price_away = !!rewards_basis ? free_shipping.count - free_shipping_price_away : free_shipping.price - free_shipping_price_away;
      free_shipping_price_away = !!rewards_basis ? free_shipping_price_away : hsonslidecart.Currency.formatMoney(free_shipping_price_away, slideData.settings.devices.money_format);
      free_shipping_price_away = `<strong>${free_shipping_price_away}</strong>`;

      if (!rewards_basis) {
        text_free_shipping_price_away = free_shipping.title.replace("{{price}}", free_shipping_price_away);
        text_free_shipping_price_away = text_free_shipping_price_away.replace("{{ price }}", free_shipping_price_away);

        text_free_shipping_price_away = text_free_shipping_price_away.replace("{AMOUNT}", free_shipping_price_away);
        text_free_shipping_price_away = text_free_shipping_price_away.replace("{ AMOUNT }", free_shipping_price_away);
      } else {
        text_free_shipping_price_away = free_shipping.title.replace("{COUNT}", free_shipping_price_away);
        text_free_shipping_price_away = text_free_shipping_price_away.replace("{ COUNT }", free_shipping_price_away);
      }


      text_free_shipping = '<div class="hs-text-free-shipping">' + text_free_shipping_price_away + '</div>';
      validate = 1;
      //};

      if (total_from_free_shipping >= 100) {
        total_from_free_shipping = 100;
        text_free_shipping = '<div class="hs-text-free-shipping">' + free_shipping.congrats + '</div>';
        text_congrats = '';
      }
    };
    arr = { 'thisIndex': index, 'text_congrats': text_congrats, 'total_from_free_shipping': total_from_free_shipping, 'free_shipping_price_away': free_shipping_price_away, 'text_free_shipping': text_free_shipping, 'from_free_shipping': from_free_shipping, 'confetti_settings': confetti };

    if (!validate) {
      arr = {};
    };
    return arr;
  },
  sumRewards: function (cart) {
    let total = 0;

    cart.items.forEach(item => {
      if (item.properties && item.properties['_hs-index'] !== undefined) {
        const qtyReward = parseInt(item.properties['_hs-reward-qty']) || 1;
        const discountType = parseInt(item.properties['_hs-reward-discount-type']);
        let discountValue = parseFloat(item.properties['_hs-reward-discount-value']) || 0;
        const price = item.price || 0;

        let discountAmount = 0;

        const hasNoDiscounts =
          !Array.isArray(item.discounts) ||
          item.discounts.length === 0 ||
          item.discounts.every(d => parseFloat(d.amount) <= 0);
        if (!!hasNoDiscounts) {
          discountValue = 100;
        }
        if ((discountType === 0 && discountValue === 100) || hasNoDiscounts) {
          discountAmount = (price * (discountValue / 100)) * qtyReward;
        }
        if (discountType === 1 && !hasNoDiscounts) {
          discountAmount = discountValue * qtyReward;
          discountAmount = discountAmount * 100;
        }

        if (isNaN(discountAmount) || discountAmount < 0) discountAmount = 0;

        total += discountAmount;
      }
    });

    return total;
  },
  removeRewardCount: function (cart) {
    let rewardQty = 0;

    cart.items.forEach(item => {
      if (
        item.properties &&
        parseFloat(item.properties['_hs-reward-discount-value']) === 100
      ) {
        rewardQty += item.quantity || 1;
      }
    });

    return cart.item_count - rewardQty;
  },
  rewardsBar: function (total_price) {
    if (!!slideData.settings.rewards.enabled_rewards) {
      slideData.settings.rewards.rewards_mode = !slideData.settings.rewards.rewards_show_prices_percentages ? 2 : slideData.settings.rewards.rewards_mode;
      var range0 = typeof slideData.settings.rewards.rewards_range !== 'undefined' ? parseInt(slideData.settings.rewards.rewards_range, 10) : 5,
        rewards_basis = slideData.settings.rewards.rewards_basis,
        cart = window.HSSLIDECART.CART,
        item_count = HsApp1.removeRewardCount(cart),
        totalRewards = !!slideData.settings.rewards.rewards_bar_no_dscto ? HsApp1.sumRewards(cart) : 0,
        total_price = total_price - totalRewards,
        range = slideData.settings.rewards.rewards_mode == 0 ? range0 : 5,
        rewards_background_primary_color_hex = slideData.settings.rewards.rewards_background_primary_color_hex,
        rewards_background_secondary_color_hex = slideData.settings.rewards.rewards_background_secondary_color_hex,
        max_num = 0,
        rewards_content_style = '',
        rewards_content_goals = '',
        text_multiple_from_free_shipping = '',
        count_multiple_from_free_shipping = 0,
        multiple_from_free_shipping = 0,
        rewards_show_percentages = '',
        free_shipping = '',
        text_free_shipping = '',
        text_free_shipping_price_away = '',
        free_shipping_price_away = '',
        total_from_free_shipping = 0,
        result_rewards = HsApp1.rewardsContent(total_price),
        mode_element_placeholder = result_rewards?.from_free_shipping?.length == 1 && result_rewards?.from_free_shipping[0]?.price == 0 && result_rewards?.from_free_shipping[0]?.reward_id ? '<div></div>' : '',
        mode_element_class = parseInt(slideData.settings.rewards.rewards_mode) == 0 || parseInt(slideData.settings.rewards.rewards_mode) == 1 ? ` hs-pd-element` : ``;

      if (Object.keys(result_rewards).length > 0) {
        if (slideData.settings.rewards.rewards_mode == 3) {
          HsApp1.rewardsPrintProducts(result_rewards);
        }
        var rewardsBar = '';
        for (let i = 1; i <= range - 1; i++) {
          if (i < range - 1) {
            var a = result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].price / (range == 5 ? 4 : range);
            var b = a * i;
            var c = b * 100
            var d = c / result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].price
            if (range == 3) {
              d = 50;
            }
            if (!!slideData.settings.rewards.rewards_mode) {
              d = (100 / 4) * i;
            }

            if (Hs_CartDrawer.rtl === '') {
              rewardsBar = rewardsBar.concat(`
                    .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(${i + 1}) {
                      left: ${d}%;
                      transform: translateX(-50%);
                    }
                    .hs-progess-content .hs-progress-indicator:nth-of-type(${i + 1}) {
                      left: ${d}%;
                      transform: translateX(-50%);
                    }
                  `)
            } else {
              rewardsBar = rewardsBar.concat(`
                    .hs-popup-cart-sp-load .hs-site-cart-popup-layout.hs-layout-rtl .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(${i + 1}) {
                      right: ${d}% !important;
                      transform: translateX(-50%);
                    }
                    .hs-popup-cart-sp-load .hs-site-cart-popup-layout.hs-layout-rtl .hs-progess-content .hs-progress-indicator:nth-of-type(${i + 1}) {
                      right: ${d}% !important;
                      transform: translateX(-50%);
                    }
                  `)

            }
          }
          else {
            if (Hs_CartDrawer.rtl === '') {
              rewardsBar = rewardsBar.concat(`
                      .hs-progess-content .hs-progress-indicator:nth-of-type(${i + 1}) {
                      right: 0px;
                      }
                      .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(${i + 1}) {
                      right: 0px;
                      }
                      .hs-progess-content .hs-progress-indicator:nth-of-type(${i + 1}):before {
                      margin-right: 0;
                      }
                    `)
            } else {
              rewardsBar = rewardsBar.concat(`
                      .hs-popup-cart-sp-load .hs-site-cart-popup-layout.hs-layout-rtl .hs-progess-content .hs-progress-indicator:nth-of-type(${i + 1}) {
                        left: 0px !important;
                      }
                      .hs-popup-cart-sp-load .hs-site-cart-popup-layout.hs-layout-rtl .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(${i + 1}) {
                        left: 0px !important;
                      }
                      .hs-popup-cart-sp-load .hs-site-cart-popup-layout.hs-layout-rtl .hs-progess-content .hs-progress-indicator:nth-of-type(${i + 1}):before {
                        margin-left: 0 !important;
                      }
                    `)
            }
          }
          rewardsBar = rewardsBar.concat(`
                  .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(${i + 1}) span {
                      text-align:center;
                    }
                  `);
        };

        if (!document.querySelector('[data-hsrewards]')) {
          document.querySelector('head').insertAdjacentHTML('beforeend', '<style data-hsrewards="rewards_style" type="text/css">' + rewardsBar + '</style>');
        };

        if (result_rewards != false) {
          if (result_rewards.from_free_shipping.length > 0) {

            var p = 0, l = 0, p = 0, n = 0;
            if (result_rewards.from_free_shipping.length < range) {
              l = 1, p = range;
              n = parseFloat(result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].price) / (range - 1);
              max_num = result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].price / range;
            }
            else {
              p = result_rewards.from_free_shipping.length;
              max_num = result_rewards.from_free_shipping[p - 1].price / range;
            }
            if (p < range) {
              p = range - 1;
            }
            var myp = p - 1, rw_off = `<div class="hs-element-reward-off" style="background-color: ${rewards_background_secondary_color_hex}"></div>`;
            var amount_rewards_cal = 100 / myp;
            if (slideData.settings.rewards.rewards_mode == 3) {
              p = result_rewards.from_free_shipping.length;
            }
            var unlock_step_price = 0, unlock_step_count = 0;

            if (slideData.settings.rewards.rewards_mode == 0 && result_rewards.from_free_shipping.length == 1) {
              if (result_rewards.from_free_shipping[0].price == 0) {
                mode_element_class = '';
                text_multiple_from_free_shipping = '';
              };
            } else {

              for (let i = 0; i < p; i++) {
                if (slideData.settings.rewards.rewards_mode == 3) {
                  let rw_price = result_rewards.from_free_shipping[i].price;
                  let rw_count = result_rewards.from_free_shipping[i].count;
                  let rw_type = result_rewards.from_free_shipping[i].rewards_type;
                  //let targetType = Hs_CartDrawer.free_shipping_svg;
                  let targetType = result_rewards.from_free_shipping[i].icon;
                  let description = result_rewards.from_free_shipping[i].description;

                  let rewards_price = hsonslidecart.Currency.formatMoney(rw_price, slideData.settings.devices.money_format);
                  rewards_price = new DOMParser().parseFromString(rewards_price, 'text/html').body.textContent;

                  let cl_product = rw_type == 2 ? ` hs-sl-rw-product` : ``,
                    cl_total_rw_active = total_price >= rw_price ? ` hs-sl-rw-active` : ``,
                    cl_count_rw_active = item_count >= rw_count ? ` hs-sl-rw-active` : ``;

                  let cl_total_rw_active_attributes = cl_product ? cl_total_rw_active ? ` role="button" tabindex="0" aria-label="Unlocked: ${description}. You can click to view or add the product. Value ${rewards_price}"` : ` role="button" tabindex="0" aria-label="${description} is blocked. It will be unlocked after spending ${rewards_price}."` : ``,

                    cl_count_rw_active_attributes = cl_product ? cl_count_rw_active ? ` role="button" tabindex="0" aria-label="Unlocked: ${description}. You can click to view or add the product. Quantity: ${rw_count} products"` : ` role="button" tabindex="0" aria-label="${description} is blocked. It unlocks when you add ${rw_count} products."` : ``;

                  let mode_element_style = i == 0 && result_rewards?.from_free_shipping?.length > 0 && result_rewards?.from_free_shipping[i]?.price == 0 && result_rewards?.from_free_shipping[i]?.reward_id ? "margin-left: -1px; transform: translateX(0px);align-items:initial;" : "margin-left: -20px; transform: translateX(20px);";
                  let mode_tier_circle_style = i == 0 && result_rewards?.from_free_shipping?.length > 0 && result_rewards?.from_free_shipping[i]?.price == 0 && result_rewards?.from_free_shipping[i]?.reward_id ? "margin-left: 0px;" : "";

                  /*switch (result_rewards.from_free_shipping[i].targetType) {
                    case 0:
                      targetType = Hs_CartDrawer.free_shipping_svg;
                      break;
                    case 1:
                      targetType = Hs_CartDrawer.discount_svg;
                      break;
                    case 2:
                      targetType = Hs_CartDrawer.product_svg;
                      break;
                    default:
                      targetType = Hs_CartDrawer.free_shipping_svg;
                  }*/

                  //let circle_percentage = (total_price - rw_price) / (rw_price) * 100;
                  rw_off = i == p - 1 ? `` : ``;
                  if (i > 0) {
                    unlock_step_price = total_price >= rw_price ? unlock_step_price + amount_rewards_cal : unlock_step_price;
                    unlock_step_count = item_count >= rw_count ? unlock_step_count + amount_rewards_cal : unlock_step_count;
                  }


                  let rewards_sort_price_1 = !slideData.settings.rewards.rewards_show_goals_prices ? `<div class="hs-description-rewards hs-sl-rw-hdd">${description}</div>` : `<div class="hs-description-rewards">${rewards_price}</div>`;
                  let rewards_sort_price_2 = !slideData.settings.rewards.rewards_show_goals_prices ? `` : `<div class="hs-description-rewards">${description}</div>`;
                  let rewards_sort_price_3 = !slideData.settings.rewards.rewards_show_goals_prices ? `<div class="hs-description-rewards hs-sl-rw-hdd">${description}</div>` : `<div class="hs-description-rewards">${rw_count}</div>`;

                  if (!rewards_basis) {
                    cl_product = total_price >= rw_price ? cl_product : cl_product;
                    rewards_content_goals = typeof rw_price !== 'undefined' && result_rewards.from_free_shipping[i].reward_id /* typeof rw_price !== 'undefined' && targetType */ ? rewards_content_goals.concat(`<div class="hs-cart-rewards-tier${cl_total_rw_active}" style="${mode_element_style}">
                        ${rewards_sort_price_2}
                        <div class="hs-cart__tierCircle${cl_product}" ${cl_total_rw_active_attributes} data-index="${i}" style="background-color: ${total_price >= rw_price ? rewards_background_primary_color_hex : rewards_background_secondary_color_hex};fill: ${total_price >= rw_price ? rewards_background_secondary_color_hex : rewards_background_primary_color_hex};border: 2px solid ${rewards_background_primary_color_hex};${mode_tier_circle_style}">
                          <div class="hs-cart-rewards-tier-icon">
                            ${targetType}
                          </div>
                        </div>
                        ${rw_off}
                        ${rewards_sort_price_1}
                      </div>`) : `<div></div>`;
                  } else {
                    cl_product = item_count >= rw_count ? cl_product : cl_product;
                    rewards_content_goals = typeof rw_count !== 'undefined' && result_rewards.from_free_shipping[i].reward_id /* typeof rw_count !== 'undefined' && targetType */ ? rewards_content_goals.concat(`<div class="hs-cart-rewards-tier${cl_count_rw_active}" style="${mode_element_style}">
                        ${rewards_sort_price_2}
                        <div class="hs-cart__tierCircle${cl_product}" ${cl_count_rw_active_attributes} data-index="${i}" style="background-color: ${item_count >= rw_count ? rewards_background_primary_color_hex : rewards_background_secondary_color_hex};fill: ${item_count >= rw_count ? rewards_background_secondary_color_hex : rewards_background_primary_color_hex};border: 2px solid ${rewards_background_primary_color_hex};${mode_tier_circle_style}">
                          <div class="hs-cart-rewards-tier-icon">
                            ${targetType}
                          </div>
                        </div>
                        ${rw_off}
                        ${rewards_sort_price_3}
                      </div>`) : `<div></div>`;
                  }

                }

                if (slideData.settings.rewards.rewards_mode == 0) {
                  if (i < range - 1) {
                    count_multiple_from_free_shipping = max_num * i;
                    if (range == 3) {
                      if (i == 1) {
                        count_multiple_from_free_shipping = result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].price / 2
                      }
                    }
                    if (range == 5) {
                      count_multiple_from_free_shipping = (result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].price / 4) * i
                    }
                    count_multiple_from_free_shipping = !!result_rewards.from_free_shipping[result_rewards.from_free_shipping.length - 1].mode ? count_multiple_from_free_shipping : hsonslidecart.Currency.formatMoney(count_multiple_from_free_shipping, slideData.settings.devices.money_format);
                    text_multiple_from_free_shipping = text_multiple_from_free_shipping.concat('<span class="hs-progress-indicator hs-progress-price">' + count_multiple_from_free_shipping + '</span>');
                  }
                  if (i == range - 1) {
                    count_multiple_from_free_shipping = !!l ? n * i : result_rewards.from_free_shipping[p - 1].price;
                    /* count_multiple_from_free_shipping = !!result_rewards.from_free_shipping[p - 1].mode ? count_multiple_from_free_shipping : hsonslidecart.Currency.formatMoney(count_multiple_from_free_shipping, slideData.settings.devices.money_format); */
                    count_multiple_from_free_shipping = hsonslidecart.Currency.formatMoney(count_multiple_from_free_shipping, slideData.settings.devices.money_format);
                    text_multiple_from_free_shipping = text_multiple_from_free_shipping.concat('<span class="hs-progress-indicator hs-progress-price">' + count_multiple_from_free_shipping + '</span>');
                  }
                }
              };
            }


            if (!rewards_basis) {
              result_rewards.total_from_free_shipping = unlock_step_price > result_rewards.total_from_free_shipping ? unlock_step_price : result_rewards.total_from_free_shipping;
            } else {
              result_rewards.total_from_free_shipping = unlock_step_count > result_rewards.total_from_free_shipping ? unlock_step_count : result_rewards.total_from_free_shipping;
            }

            if (slideData.settings.rewards.rewards_mode == 3) {
              rewards_content_style = `<div class="hs-content-my-rewards-goals">${mode_element_placeholder}${rewards_content_goals}</div>`;
            }
            if (slideData.settings.rewards.rewards_mode == 0) {
              rewards_content_style = text_multiple_from_free_shipping;
            }
            if (slideData.settings.rewards.rewards_mode == 1) {
              rewards_content_style = `<span class="hs-progress-indicator">0%</span><span class="hs-progress-indicator">25%</span><span class="hs-progress-indicator">50%</span><span class="hs-progress-indicator">75%</span><span class="hs-progress-indicator">100%</span>`;
            }
            if (!Hs_CartDrawer.rewardShowGoal) {
              result_rewards.text_congrats = ``;
            };

            const progressbar_valuenow = parseInt(result_rewards?.total_from_free_shipping) || 0;
            let class_goal_price_enable = !slideData.settings.rewards.rewards_show_goals_prices ? ` hs-sl-goal-prices` : ``;
            let class_rewards_classic = parseInt(slideData.settings.rewards.rewards_mode) == 3 ? ` hs-sl-rewards-classic` : ``;
            free_shipping = `
                    <div class="hs-rewards-content${mode_element_class}">
                      <div class="hs-progess-content">
                        <div class="hs-content-text-rewards" id="hs-shipping-progress-bar-lbl">
                          ${result_rewards.text_congrats}
                          ${result_rewards.text_free_shipping}
                        </div>
                        <div class="hs-rewards-progress-bar-content${class_goal_price_enable}${class_rewards_classic}">
                          <div class="hs-shipping-progress-bar">
                            <div id="hs_shipping_bar" style="width:${result_rewards.total_from_free_shipping}%;" aria-labelledby="hs-shipping-progress-bar-lbl" tabindex="0" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progressbar_valuenow}"></div>
                          </div>
                          ${rewards_content_style}
                        </div>
                      </div>
                    </div>`;
            var thisRewards = '';
            if (free_shipping != '') {
              !!document.querySelector('.hs-content-discounts-calculate-checkout') ? document.querySelector('.hs-content-discounts-calculate-checkout').classList.add('hs-enable-content-rewards') : '';
              var hs_rewards_content = !!document.querySelector('.hs-rewards-content') ? document.querySelector('.hs-rewards-content') : '';
              if (!hs_rewards_content) {
                !!document.querySelector('.hs-content-discounts-calculate-checkout') ? document.querySelector('.hs-content-discounts-calculate-checkout').innerHTML = free_shipping : '';
              }
              else {
                thisRewards = `${result_rewards.text_congrats}${result_rewards.text_free_shipping}`
                !!document.querySelector('.hs-text-rewards-goal') ? document.querySelector('.hs-text-rewards-goal').remove() : '';
                !!document.querySelector('.hs-text-free-shipping') ? document.querySelector('.hs-text-free-shipping').remove() : '';
                !!document.querySelector('.hs-content-text-rewards') ? document.querySelector('.hs-content-text-rewards').innerHTML = thisRewards : '';
                !!document.querySelector('.hs-content-my-rewards-goals') ? document.querySelector('.hs-content-my-rewards-goals').innerHTML = mode_element_placeholder + rewards_content_goals : '';
                !!document.querySelector('#hs_shipping_bar') ? document.querySelector('#hs_shipping_bar').style.setProperty('width', `${result_rewards.total_from_free_shipping}%`) : '';
                !!document.querySelector('#hs_shipping_bar') ? document.querySelector('#hs_shipping_bar').setAttribute('aria-valuenow', `${parseInt(result_rewards?.total_from_free_shipping) || 0}`) : '';

                if (typeof window.Hs_updateLiveRegion === 'function') {
                  setTimeout(() => {
                    const container = document.createElement("div");
                    container.innerHTML = thisRewards;

                    const rewards = container.querySelector(".hs-text-rewards-goal")?.textContent.trim();
                    const shipping = container.querySelector(".hs-text-free-shipping")?.textContent.trim();

                    const textRewards = [rewards, shipping].filter(Boolean).join(" ");
                    window.Hs_updateLiveRegion(textRewards)
                  }, 7000);
                };

              };
              if (typeof result_rewards.thisIndex !== 'undefined') {
                var equals = false;
                equals = result_rewards.thisIndex == HsApp1.rewardsIndex;
                if (HsApp1.rewardsIndex != null) {
                  if (result_rewards.thisIndex > HsApp1.rewardsIndex) {
                    if (!!result_rewards.confetti_settings.show) {
                      Hs_CartDrawer.activeCF(result_rewards.confetti_settings.show, result_rewards.confetti_settings.time, result_rewards.thisIndex);
                    };
                  };
                }
                if (!equals) {
                  HsApp1.rewardsIndex = result_rewards.thisIndex;
                };
              };

              function equalizeRewardsTextHeight() {
                const tiers = document.querySelectorAll('.hs-cart-rewards-tier');
                const rewardsText = [];

                // Recoger solo el primer .hs-description-rewards de cada tier
                tiers.forEach(tier => {
                  const firstReward = tier.querySelector('.hs-description-rewards:not(.hs-sl-rw-hdd)');
                  if (firstReward) {
                    rewardsText.push(firstReward);
                  }
                });

                if (rewardsText.length > 0) {
                  let maxHeight = 0;

                  // Reset heights
                  rewardsText.forEach(el => {
                    el.style.height = 'auto';
                  });

                  // Calcular altura máxima
                  rewardsText.forEach(el => {
                    const h = el.offsetHeight;
                    if (h > maxHeight) maxHeight = h;
                  });

                  // Asignar altura máxima
                  rewardsText.forEach(el => {
                    el.style.height = maxHeight + 'px';
                  });
                }
              };

              function distanceToElementCenter() {
                const content = document.querySelector('.hs-cart-rewards-tier');
                if (!content) {
                  //console.warn("not content");
                  return null;
                }

                const children = Array.from(content.children);
                const obj = children.find(child => child.classList.contains('hs-cart__tierCircle'));

                if (!obj) {
                  //console.warn(`Not "hs-cart__tierCircle"`);
                  return null;
                }

                const indexObj = children.indexOf(obj);

                // Obtener estilos del contenedor (para calcular el gap)
                const myStyle = window.getComputedStyle(content);
                const gap = parseFloat(myStyle.rowGap || myStyle.gap || 0);

                // Sumar alturas de los hijos anteriores + gaps anteriores
                let distance = 0;

                for (let i = 0; i < indexObj; i++) {
                  distance += children[i].offsetHeight;
                  distance += gap; // agregar el gap después de cada hijo anterior
                }

                // Finalmente, sumar la mitad del alto del objetivo
                distance += obj.offsetHeight / 2;

                const rewards_progress_bar = document.querySelector('.hs-shipping-progress-bar');
                if (!!rewards_progress_bar) {
                  rewards_progress_bar.style.setProperty('top', `${distance}px`);
                }
              };

              try {
                const debouncedEqualize = Hs_debounce(equalizeRewardsTextHeight);
                const debouncedDistance = Hs_debounce(distanceToElementCenter);

                equalizeRewardsTextHeight();
                distanceToElementCenter();

                window.removeEventListener('resize', debouncedEqualize);
                window.removeEventListener('resize', debouncedDistance);

                window.addEventListener('resize', debouncedEqualize);
                window.addEventListener('resize', debouncedDistance);

              } catch (error) {
                console.log('Error:', error);
              }
            }
          };
        }
      }
    };
  },
  changeButton: function (where) {
    setTimeout(function () {
      where.classList.remove('hs-loading-btn');
    }, 200);
  },
  unique: function (names) {
    const unique = (value, index, self) => {
      return self.indexOf(value) === index
    }
    names = names.filter(unique);
    return names;
  },
  swiperAutomaticProductsHSCart: function (count_items = 0) {
    if (parseInt(slideData.settings.product_recommendations_settings.mode_upsell_automatic)) {
      return false;
    }

    var upsell_space = 20;
    var upsell_slide_per_view = count_items > Hs_CartDrawer.apu_qty_per_view ? Hs_CartDrawer.apu_qty_per_view : count_items;
    var upsell_autoplay = Hs_CartDrawer.apu_autoplay_time > 0 ? {
      autoplay: {
        delay: Hs_CartDrawer.apu_autoplay_time,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    } : {};

    switch (Hs_CartDrawer.apu_qty_per_view) {//CAMBIO
      case 2:
        upsell_space = 35;
        break;
      case 3:
        upsell_space = 30;
        break;
    };

    var content_swiper = !!document.querySelector('.swiper-container-automatic') ? document.querySelector('.swiper-container-automatic') : '';
    if (!!content_swiper) {
      var content_parent = !!content_swiper.closest('.hs-container-swp') ? content_swiper.closest('.hs-container-swp') : ''
      if (!!content_parent) {
        if (upsell_slide_per_view == 1) {
          if (!!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.remove('hs-upsell_multi_view')
          };
        } else {
          if (!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.add('hs-upsell_multi_view')
          };
        };
      };
    };

    var parameters = {
      autoHeight: true,
      spaceBetween: 30,
      loop: true,
      a11y: {//
        enabled: true,
        slideLabelMessage: '{{index}} of {{slidesLength}}'
      },
      pagination: {
        el: ".hs-swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".hs-swiper-button-next",
        prevEl: ".hs-swiper-button-prev",
      },
      breakpoints: {
        400: {
          shortSwipes: true,
          slidesPerView: upsell_slide_per_view,
          spaceBetween: upsell_space,
        },
        0: {
          slidesPerView: upsell_slide_per_view == 3 ? 2 : upsell_slide_per_view,
          spaceBetween: upsell_space,
        }
      }
    };

    parameters = { ...parameters, ...upsell_autoplay };

    Hs_CartDrawer.swiper_automatic = new HS_Swiper(".swiper-container-automatic", parameters);

    Hs_CartDrawer.initAccessibleSwiper(Hs_CartDrawer.swiper_automatic, content_swiper);

  },
  swiperDynamicHSCart: function (identify, count_items = 0) {
    var upsell_space = 20;
    var upsell_slide_per_view = 1;
    var upsell_autoplay = {};
    switch (identify) {
      case 'cart_empty':
        if (parseInt(slideData.settings.cart_empty.cart_empty_upsell_mode)) {
          return false;
        };
        switch (Hs_CartDrawer.cart_empty_upsell_qty) {//CAMBIO
          case 2:
            upsell_space = 35;
            break;
          case 3:
            upsell_space = 30;
            break;
        };
        upsell_slide_per_view = count_items > Hs_CartDrawer.cart_empty_upsell_qty ? Hs_CartDrawer.cart_empty_upsell_qty : count_items;
        upsell_autoplay = Hs_CartDrawer.cart_empty_upsell_autoplay_time > 0 ? {
          autoplay: {
            delay: Hs_CartDrawer.cart_empty_upsell_autoplay_time,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        } : {};
        break;
      case 'upsell':
        if (parseInt(slideData.settings.manually_products_upsells.mode_upsell_manually)) {
          return false;
        }
        switch (Hs_CartDrawer.mpu_qty_per_view) {//CAMBIO
          case 2:
            upsell_space = 35;
            break;
          case 3:
            upsell_space = 30;
            break;
        };
        upsell_slide_per_view = count_items > Hs_CartDrawer.mpu_qty_per_view ? Hs_CartDrawer.mpu_qty_per_view : count_items;
        upsell_autoplay = Hs_CartDrawer.mpu_autoplay_time > 0 ? {
          autoplay: {
            delay: Hs_CartDrawer.mpu_autoplay_time,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        } : {};
        break;
    };

    var content_swiper = !!document.querySelector('.swiper-container-dynamic') ? document.querySelector('.swiper-container-dynamic') : '';
    if (!!content_swiper) {
      var content_parent = !!content_swiper.closest('.hs-container-swp') ? content_swiper.closest('.hs-container-swp') : ''
      if (!!content_parent) {
        if (upsell_slide_per_view == 1) {
          if (!!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.remove('hs-upsell_multi_view')
          };
        }
        else {
          if (!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.add('hs-upsell_multi_view')
          };
        };
      };
    };

    var parameters = {
      autoHeight: true,
      loop: true,
      a11y: {//
        enabled: true,
        slideLabelMessage: '{{index}} of {{slidesLength}}'
      },
      pagination: {
        el: ".hs-swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.hs-swiper-button-next',
        prevEl: '.hs-swiper-button-prev',
      },
      breakpoints: {
        400: {
          shortSwipes: true,
          slidesPerView: upsell_slide_per_view,
          spaceBetween: upsell_space,
        },
        0: {
          slidesPerView: upsell_slide_per_view == 3 ? 2 : upsell_slide_per_view,
          spaceBetween: upsell_space,
        }
      }
    };
    parameters = { ...parameters, ...upsell_autoplay };

    Hs_CartDrawer.swiper_dynamic = new HS_Swiper('.swiper-container-dynamic', parameters);
    //Hs_CartDrawer.paginationHover(data,$);
    Hs_CartDrawer.initAccessibleSwiper(Hs_CartDrawer.swiper_dynamic, content_swiper);

  },
  swiperStaticHSCart: function (count_items = 0) {
    if (typeof slideData.settings.static_products_upsells !== 'undefined') {
      if (parseInt(slideData.settings.static_products_upsells.mode_upsell_static)) {
        return false;
      }
    }
    var upsell_space = 20;
    var upsell_slide_per_view = count_items > Hs_CartDrawer.spu_qty_per_view ? Hs_CartDrawer.spu_qty_per_view : count_items;
    var upsell_autoplay = Hs_CartDrawer.spu_autoplay_time > 0 ? {
      autoplay: {
        delay: Hs_CartDrawer.spu_autoplay_time,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    } : {};

    switch (Hs_CartDrawer.spu_qty_per_view) {//CAMBIO
      case 2:
        upsell_space = 35;
        break;
      case 3:
        upsell_space = 30;
        break;
    };

    /* if (slideData.customize.customize_slidecart_size == 365) {
      upsell_space = upsell_space - 5;
    }; */

    var content_swiper = !!document.querySelector('.swiper-container-recommend') ? document.querySelector('.swiper-container-recommend') : '';
    if (!!content_swiper) {
      var content_parent = !!content_swiper.closest('.hs-container-swp') ? content_swiper.closest('.hs-container-swp') : ''
      if (!!content_parent) {
        if (upsell_slide_per_view == 1) {
          if (!!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.remove('hs-upsell_multi_view')
          };
        } else {
          if (!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.add('hs-upsell_multi_view')
          };
        };
      };
    };

    var parameters = {
      autoHeight: true,
      spaceBetween: 30,
      slidesPerView: 2,
      loop: true,
      a11y: {//
        enabled: true,
        slideLabelMessage: '{{index}} of {{slidesLength}}'
      },
      pagination: {
        el: ".hs-swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.hs-swiper-button-next',
        prevEl: '.hs-swiper-button-prev',
      },
      breakpoints: {
        400: {
          shortSwipes: true,
          slidesPerView: upsell_slide_per_view,
          spaceBetween: upsell_space,
        },
        0: {
          slidesPerView: upsell_slide_per_view == 3 ? 2 : upsell_slide_per_view,
          spaceBetween: upsell_space,
        }
      }
    };

    parameters = { ...parameters, ...upsell_autoplay };

    Hs_CartDrawer.swiper_static = new HS_Swiper('.swiper-container-recommend', parameters);
    //Hs_CartDrawer.paginationHover(data,$);
    Hs_CartDrawer.initAccessibleSwiper(Hs_CartDrawer.swiper_static, content_swiper);
  },
  swiperRewardsHSCart: function (count_items = 0) {
    var upsell_space = slideData.customize.customize_slidecart_size == 500 ? 12 : 12;
    var upsell_slide_per_view = slideData.customize.customize_slidecart_size == 500 || slideData.customize.customize_slidecart_size == 450 ? 3 : 3;
    var upsell_autoplay = {};

    var content_swiper = !!document.querySelector('.hs-rewards-swiper-container-recommend') ? document.querySelector('.hs-rewards-swiper-container-recommend') : '';
    if (!!content_swiper) {
      var content_parent = !!content_swiper.closest('.hs-rewards-swiper-container-recommend') ? content_swiper.closest('.hs-rewards-swiper-container-recommend') : ''
      if (!!content_parent) {
        if (upsell_slide_per_view == 1) {
          if (!!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.remove('hs-upsell_multi_view')
          };
        }
        else {
          if (!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.add('hs-upsell_multi_view')
          };
        };
      };
    };
    var parameters = {
      autoHeight: true,
      loop: false,
      spaceBetween: upsell_space,
      slidesPerView: 2,
      pagination: {
        el: ".hs-swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.hs-swiper-button-next',
        prevEl: '.hs-swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: upsell_space,
        },
        320: {
          shortSwipes: true,
          slidesPerView: 2,
          spaceBetween: upsell_space,
        },
        1024: {
          shortSwipes: true,
          slidesPerView: 2,
          spaceBetween: upsell_space,
        }
      }
    };
    parameters = { ...parameters, ...upsell_autoplay };

    Hs_CartDrawer.swiper_rewards = new HS_Swiper('.hs-rewards-swiper-container-recommend', parameters);
    //Hs_CartDrawer.paginationHover(data,$);
  },
  productCartUpsell: function (params, where, upsell = '', button_parent = '') {
    var error = false;
    var cart_add = 'cart/add.js';
    let add_json_result = {};
    if (upsell === 'tiered') {
      if (window.EasyGiftScriptLoaded) {
        cart_add = cart_add + '?_easygift_internal=true'
      };
    };
    var add = Hs_CartDrawer.routeLocale(cart_add);
    fetch(`${add}`, {
      body: params,
      method: 'POST',
      headers: {
        'Accept': "application/json, text/javascript",
        'Content-Type': "application/json, text/javascript",
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(function (response) {
      /* return response.ok ? response.json() : Promise.reject(response) ; */
      return response.json();
    }).then(function (json) {
      if (!!json.status) {
        error = true;
        try {
          Hs_modal_notification(json?.message, json?.description, slideData, json?.status)
        } catch (error) {
          alert(`Error ${json.status}: ${json.description}`);
        }

        HsApp1.changeButton(where);//DELETE LOADING OF BUTTON ADD
      } else {
        add_json_result = json;
      }
    }).catch(error => {
      console.error(error)

    }).then(function () {
      var paramsFunction = [];
      if (!error) {
        params = JSON.parse(params);
        paramsFunction = [
          {
            "name": 'addToCartUpsell',
            "attr": {
              "id": parseInt(params.id)
            }
          }];
        try {
          if (where && button_parent === '') {
            button_parent = where;
          };
          if (button_parent) {
            //button_parent?.focus();
            var parent_button = button_parent.closest('.hs-swiper-slide') || '';
            if (parent_button) {
              var parent_upsell = parent_button.closest('[data-slide]') || '';
              if (parent_upsell) {
                var parent_upsell_data_slide = parent_upsell.dataset.slide || '';
                var parent_upsell_data_item = parent_upsell.dataset.item || '';
                if (parent_upsell_data_slide && parent_upsell_data_item) {
                  parent_button.remove()//remove UPSELL
                  var upsell_childs = parent_upsell.querySelectorAll('.hs-swiper-slide') || [];
                  if (upsell_childs.length > 0) {
                    eval('HsApp1.' + parent_upsell_data_slide);
                  } else {
                    parent_upsell.style.display = 'none';
                  };
                };
              };
            };
          };
          if (typeof window.Hs_updateLiveRegion === 'function') {
            if (Object.keys(params).length > 0 && Object.keys(add_json_result).length > 0) {
              const qty = parseInt(params?.quantity) || '';
              if (qty) {
                const title = Hs_CartDrawer.escape(`${add_json_result.title.replace(/<.*?>/g, '')}`)
                const liveRegionMessage = `${title} (quantity: ${params.quantity}) has been added to your cart`;
                window.Hs_updateLiveRegion(liveRegionMessage);
              }
            };
          };
        } catch (error) {
          console.log(error)
        }
      };
      HsApp1.getMyCart(1, paramsFunction);
      HsApp3.getMyCart(1);
      HsApp1.hideCartPopup();
      HsApp1.changeQuantityCart();
      HsApp1.changeButton(where);//DELETE LOADING OF BUTTON ADD
      HsApp1.closePopUpProd();//CLOSE POPUP PROD
      HsApp1.clearALL();
      Hs_CartDrawer.focusOnItemsCart();
    });
    HsApp3.klaviyoTrackAddToCart('');
  },
  upsellAddToCartFreeShipping: function (condition, upsell, result_item) {
    var hs_upsell_add_to_cart = document.querySelectorAll('.hs-upsell-add-to-cart').length > 0 ? document.querySelectorAll('.hs-upsell-add-to-cart') : [];
    if (hs_upsell_add_to_cart.length > 0) {
      hs_upsell_add_to_cart.forEach(function (addToCart) {
        if (!addToCart.classList.contains('hs-event-static')) {
          addToCart.classList.add('hs-event-static');
          if (typeof addToCart.dataset.upsellType !== 'undefined') {
            addToCart.addEventListener('click', function (event) {
              event.preventDefault();
              var where = this;
              condition = this.dataset.upsellCollection === 'true' ? 'collection' : '';
              if (typeof addToCart.dataset.upsellType !== 'undefined') {
                var dataProd = window.HSUPSELLS[addToCart.dataset.upsellType][addToCart.dataset.upsellIndex]//GET DATA FOR PRODUCT STORED IN BUTTON
                HsApp1.popUpProduct = dataProd;//SEND DATA FOR PRODUCT TO VARIABLE GLOBAL
                HsApp1.arr_variants_popup = dataProd.variants;//SEND DATA FOR PRODUCT-VARIANT TO VARIABLE GLOBAL
                var conditional = 0;
                if (upsell === 'tiered') {
                  conditional = slideData.settings.tiered_free_items.tfi_show_quantity_box;
                } else {
                  conditional = slideData.settings.additional_settings.show_quantity_box_upsells;
                };
                if (conditional > 0 || dataProd.variants.length > 1 || typeof where.dataset.upsellSubs !== 'undefined') {
                  HsApp1.createPopUpProduct(0, 0, 0, condition, upsell, !!dataProd.tieredName ? dataProd.tieredName : '', !!dataProd.type ? dataProd.type : '', result_item, where);
                };
                if (conditional == 0 && dataProd.variants.length <= 1 && typeof where.dataset.upsellSubs === 'undefined') {
                  var params = '',
                    properties = {},
                    variantid = !!this.closest('.hs-content-title-price-swiper') ? this.closest('.hs-content-title-price-swiper').querySelector('.hs-swipper-select-option-add-to-cart') : '',
                    variantValue = !!variantid ? variantid.value : '',
                    elementQty = !!where.closest('.hs-content-title-price-swiper') ? where.closest('.hs-content-title-price-swiper').querySelector('.hs-item-cart-content-quantity-upsell') : '',
                    quantity = 1;
                  where.classList.add('hs-loading-btn');

                  if (!!elementQty) {
                    quantity = !!elementQty.querySelector('input') ? elementQty.querySelector('input').value : '';
                  }
                  params = { 'id': variantValue, 'quantity': quantity };
                  if (!!dataProd.properties) {
                    properties = dataProd.properties
                  };

                  if (!!dataProd.tieredName) {
                    properties = Object.assign(properties, { 'properties': { '_tiered': dataProd.tieredName } });
                    params = Object.assign(params, properties);
                  };
                  params = JSON.stringify(params);
                  HsApp1.productCartUpsell(params, where, upsell);
                };
              }
            });
          } else {
            addToCart.addEventListener('click', function (event) {
              event.preventDefault();
              var where = this,
                parent = !!this.closest('.hs-content-title-price-swiper') ? this.closest('.hs-content-title-price-swiper') : '',
                params = '',
                variantid = !!parent ? parent.querySelector('.hs-swipper-select-option-add-to-cart') : '',
                variantValue = !!variantid ? variantid.value : '',
                elementQty = !!where.closest('.hs-content-title-price-swiper') ? where.closest('.hs-content-title-price-swiper').querySelector('.hs-item-cart-content-quantity-upsell') : '',
                quantity = 1,
                position = parseInt(where.getAttribute('data-hs-rw-position')),
                reward_id = parseInt(where.getAttribute('data-hs-rw-id')),
                reward_qty = parseInt(where.getAttribute('data-hs-rw-qty')),
                reward_discount_type = parseInt(where.getAttribute('data-hs-rw-discount-type')),
                reward_discount_value = parseInt(where.getAttribute('data-hs-rw-discount-value')),
                subscription_option = !!parent ? parent.querySelector('.hs-subscription-option') : '',

                subscription_option_input = !!subscription_option ? subscription_option.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '',

                selling_group_id = !!subscription_option_input ? subscription_option_input.value : '',

                selling_plan = !!subscription_option_input ? !!subscription_option_input.checked ? true : false : false,

                frequency_option = !!selling_plan ? !!parent ? parent.querySelector('.hs-frequency-option') : '' : '',

                selling_plan_id = !!frequency_option ? !!frequency_option.querySelector('[name="hs-selling_plan"]') ? frequency_option.querySelector('[name="hs-selling_plan"]').options.length > 0 ? frequency_option.querySelector('[name="hs-selling_plan"]').options[frequency_option.querySelector('[name="hs-selling_plan"]').options.selectedIndex].value : '' : '' : '',

                elementButtonLoad = document.querySelectorAll('.hs-content-modal-rewards-products').length > 0 ? document.querySelector('.hs-content-modal-rewards-products').querySelectorAll('button') : [];
              if (elementButtonLoad.length > 0) {
                elementButtonLoad.forEach(function (b) {
                  b.setAttribute('disabled', 'disabled');
                });
              }

              where.classList.add('hs-loading-btn');

              if (!!elementQty) {
                quantity = !!elementQty.querySelector('input') ? elementQty.querySelector('input').value : '';
              }

              if (!!position) {
                HsApp1.resetRewards();
                localStorage.setItem('hs_sl_popup_static', 1);
              }

              //params = `{'id':${variantValue},'quantity':${quantity} ${!!dataProd.tieredName ? `,'properties': {'tiered': ${dataProd.tieredName}}` : ``}} `
              //params = JSON.stringify(params);
              params = { 'id': variantValue, 'quantity': quantity };
              if (selling_plan_id !== '') {
                params = Object.assign(params, { 'selling_plan_group_id': selling_group_id, 'selling_plan': selling_plan_id });
              };
              if (typeof where.dataset.tieredName !== 'undefined') {
                params = Object.assign(params, { 'properties': { '_tiered': where.dataset.tieredName } });
                if (!!reward_id) {
                  params = Object.assign(params, { 'properties': { '_tiered': where.dataset.tieredName, "_hs-index": position, "_hs-reward-id": reward_id, "_hs-reward-discount-type": reward_discount_type, "_hs-reward-discount-value": reward_discount_value, "_hs-reward-qty": reward_qty } });
                }
              } else {
                if (!!reward_id) {
                  params = Object.assign(params, { 'properties': { "_hs-index": position, "_hs-reward-id": reward_id, "_hs-reward-discount-type": reward_discount_type, "_hs-reward-discount-value": reward_discount_value, "_hs-reward-qty": reward_qty } });
                }
              }

              params = JSON.stringify(params);

              HsApp1.productCartUpsell(params, where);
            });
          };
        }
      });
    };

    var hs_upsell_remove_to_cart = document.querySelectorAll('.hs-upsell-remove-to-cart').length > 0 ? document.querySelectorAll('.hs-upsell-remove-to-cart') : [];
    if (hs_upsell_remove_to_cart.length > 0) {
      hs_upsell_remove_to_cart.forEach(function (addToCart) {
        if (!addToCart.classList.contains('hs-event-static')) {
          addToCart.classList.add('hs-event-static');
          addToCart.addEventListener('click', function (event) {
            event.preventDefault();
            var where = this,
              variant_id = where.closest('.hs-combobox-and-btn').querySelector('.hs-swipper-select-option-add-to-cart').value,
              position = parseInt(where.getAttribute('data-hs-rw-position')),
              elementButtonLoad = document.querySelectorAll('.hs-content-modal-rewards-products').length > 0 ? document.querySelector('.hs-content-modal-rewards-products').querySelectorAll('button') : [];
            addToCart.setAttribute('disabled', 'disabled');
            if (elementButtonLoad.length > 0) {
              elementButtonLoad.forEach(function (b) {
                b.setAttribute('disabled', 'disabled');
              });
            }
            HsApp1.resetRewards();
            localStorage.setItem('hs_sl_popup_static', 1);
            where.classList.add('hs-loading-btn');
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates: {
                  [variant_id]: 0
                }
              })
            })
              .then(response => response.json())
              .then(data => {
                window.HSSLIDECART.CART = data;
              });
          });
        }
      });
    };
  },
  upsellVariants: function (upsell) {
    //var body_layout = document.querySelector('.hs-body-layout') || '';
    //if (body_layout) {
    var hs_swipper_select_option_add_to_cart = document.querySelectorAll('.hs-swipper-select-option-add-to-cart').length > 0 ? document.querySelectorAll('.hs-swipper-select-option-add-to-cart') : [];
    if (hs_swipper_select_option_add_to_cart.length > 0) {
      hs_swipper_select_option_add_to_cart.forEach(function (opt) {
        if (!opt.classList.contains('hs-event-static')) {
          opt.classList.add('hs-event-static');
          opt.addEventListener('change', (event) => {
            event.preventDefault();
            // var dataProd = opt.dataset.upsellType ? Object.keys(window.HSUPSELLS).length > 0 ? window.HSUPSELLS[opt.dataset.upsellType][opt.dataset.upsellIndex] : {} : {};
            var dataProd = opt.dataset.upsellType ? window.HSUPSELLS?.[opt.dataset.upsellType]?.[opt.dataset.upsellIndex] ?? {} : {};
            var rewards = parseInt(opt.getAttribute('data-rewards'));
            var option = opt.options.length > 0 ? opt.options[opt.selectedIndex] : '';
            var variantid = opt.options.length > 0 ? option.dataset.variantid : '';
            var price = opt.options.length > 0 ? option.dataset.price ? +option.dataset.price : 0 : 0;
            var price_discount = opt.options.length > 0 ? option.dataset.pricediscount ? +option.dataset.pricediscount : 0 : 0;
            var compareatprice = opt.options.length > 0 ? option.dataset.compareatprice ? +option.dataset.compareatprice > +option.dataset.price ? +option.dataset.compareatprice : 0 : 0 : 0;
            var rewards_popup_pick_language_settings = slideData.settings.language_settings.rewards_popup_pick_language_settings;
            var rewards_popup_remove_language_settings = slideData.settings.language_settings.rewards_popup_remove_language_settings;
            var title_btn = slideData.settings.language_settings.add_in_upsell_language_settings;
            var disabled_btn = 0;
            var added_btn = 0;
            var limititems_btn = 0;
            var position = 0;

            var plan_price = opt.options.length > 0 ? typeof option.dataset.planPrice !== 'undefined' ? option.dataset.planPrice : '' : '';
            var plan_compareatprice = opt.options.length > 0 ? typeof option.dataset.planCompareatprice !== 'undefined' ? option.dataset.planCompareatprice : '' : '';

            var image = opt.options.length > 0 ? option.dataset.featuredimage : '';
            var attr_img = opt.options.length > 0 ? option.dataset.attr : '';

            var available = opt.options.length > 0 ? option.dataset.available : '';
            var handle = opt.options.length > 0 ? option.dataset.handle : '';
            var hs_upsell_add_to_cart = '', hs_add_to_cart = '';
            var hs_content_product_slide_cart = !!opt.closest('.hs-content-product-slide-cart') ? opt.closest('.hs-content-product-slide-cart') : '';
            var hs_selling_plan = hs_content_product_slide_cart ? hs_content_product_slide_cart.querySelector('select[name="hs-selling_plan"]') : '';
            var hs_subscription_input = hs_content_product_slide_cart ? hs_content_product_slide_cart.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
            var popup = hs_content_product_slide_cart ? hs_content_product_slide_cart.querySelector('.hs-popup') : '';

            if (!!hs_content_product_slide_cart) {
              /*  */
              /* SUBCRIPTION FUNCTION */
              var hs_subscription_content = !!hs_content_product_slide_cart.querySelector('.hs-subscription-content') ? hs_content_product_slide_cart.querySelector('.hs-subscription-content') : '';
              if (!!hs_subscription_content) {
                hs_subscription_content.style.display = '';
                if (Object.keys(dataProd).length > 0) {
                  if (dataProd.variants && variantid) {
                    var opts_selling_plan = '';
                    var label_subscription = /* Hs_CartDrawer.withSubOnly; */Hs_CartDrawer.curlyReplaceRc();
                    var variant = dataProd.variants.find((variant) => {
                      return +variant.id == +variantid
                    });
                    //COMMENT COLOCO A LOS PLANES DE LA VARIANTE SUS RESPECTIVOS NOMBRES QUE ESTAN EN EL PRODUCTO
                    var product_plans = '', variant_plan_allocations = '';
                    if (dataProd.selling_plan_groups) {
                      product_plans = dataProd.selling_plan_groups;
                    };
                    if (variant.selling_plan_allocations) {
                      variant_plan_allocations = variant.selling_plan_allocations;
                    };
                    if (product_plans && variant_plan_allocations) {
                      product_plans.map((prod_plan) => {
                        variant_plan_allocations.map((var_plan_allocation) => {
                          if (prod_plan.id === var_plan_allocation.selling_plan_group_id) {
                            var this_selling_plan = prod_plan.selling_plans.filter((selling_plan) => {
                              return selling_plan.id == var_plan_allocation.selling_plan_id
                            });
                            var_plan_allocation.name = prod_plan.name;
                            var_plan_allocation.selling_plans = this_selling_plan;
                          };
                        });
                      });
                    };

                    if (variant.selling_plan_allocations.length > 0) {
                      //COMMENT  CAMBIO DE LAS OPCIONES DEL SELECT PLAN
                      variant.selling_plan_allocations.forEach((selling_plan_allocations) => {
                        selling_plan_allocations.selling_plans.forEach((selling_plan) => {
                          var price_adjustments = '';
                          if (selling_plan.price_adjustments) {
                            if (selling_plan.price_adjustments.length > 0) {
                              var value = selling_plan.price_adjustments[0].value;
                              var value_type = selling_plan.price_adjustments[0].value_type;
                              if (value && value_type) {
                                if (value > 0 && value_type === 'percentage') {
                                  price_adjustments = `data-value-percentage="${value}"`
                                }
                              };
                            };
                          };
                          var selected = '';
                          if (+selling_plan_allocations.selling_plan_id == +hs_selling_plan.value) {
                            selected = 'selected';
                          };
                          opts_selling_plan = opts_selling_plan + `<option ${selected} value="${selling_plan.id}" ${price_adjustments}>${selling_plan.name}</option>`
                        });
                      });
                      hs_selling_plan.innerHTML = opts_selling_plan;
                      //COMMENT CAMBIO TEXT LABEL SUBSCRIPTION SI TIENE PORCENTAJE

                      var selling_plan_selected_percentage = hs_selling_plan[hs_selling_plan.selectedIndex].dataset.valuePercentage;
                      if (selling_plan_selected_percentage) {
                        label_subscription = Hs_CartDrawer.curlyReplaceRc(selling_plan_selected_percentage + '%');
                      };
                      /*COMMENT  SI NO TIENE OPCIONES SE OCULTA O CASO CONTRARIO SE MUESTRA*/
                      if (!!hs_subscription_input || (!!popup && !!Hs_CartDrawer.subscribe)) {
                        if (!!hs_subscription_input.checked) {
                          var selling_plan_selected_value = hs_selling_plan.value;
                          if (selling_plan_selected_value) {
                            var plan = variant.selling_plan_allocations.find((selling_plan) => {
                              return +selling_plan.selling_plan_id == +selling_plan_selected_value
                            });
                            if (plan) {
                              if (plan.price) {
                                price = plan.price;
                              };
                              if (plan.compare_at_price) {
                                if (!compareatprice || compareatprice >= plan.price) {
                                  if (plan.compare_at_price > plan.price) {
                                    compareatprice = plan.compare_at_price || 0;
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    } else {
                      hs_selling_plan.innerHTML = '';
                    };
                    if (opts_selling_plan === '') {
                      hs_subscription_content.style.display = 'none';
                    } else {
                      hs_subscription_content.style.display = '';
                    };
                    if (!!hs_subscription_input) {
                      var hs_subscription = !!hs_subscription_input.closest('.hs-subscription-sub-option') ? hs_subscription_input.closest('.hs-subscription-sub-option') : '';
                      if (!!hs_subscription) {
                        var hs_subcription_label = !!hs_subscription.querySelector('.hs-sub-label') ? hs_subscription.querySelector('.hs-sub-label') : '';
                        if (!!hs_subcription_label) {
                          hs_subcription_label.innerHTML = label_subscription;
                        };
                      };
                    };
                  };
                };
              };
              /*  */
              if (Hs_CartDrawer.subscribe_option_upsell) {
                if (!!popup && !!Hs_CartDrawer.subscribe) {
                  if (plan_price !== '') {
                    price = plan_price;
                  };
                  if (plan_compareatprice !== '') {
                    compareatprice = plan_compareatprice;
                  };
                };
              };

              var hs_upsell_add = !!hs_content_product_slide_cart.querySelector('.hs-upsell-add') ? hs_content_product_slide_cart.querySelector('.hs-upsell-add') : '';
              if (!!hs_upsell_add) {
                hs_upsell_add_to_cart = !!hs_upsell_add.querySelector('.hs-upsell-add-to-cart,.hs-upsell-remove-to-cart') ? hs_upsell_add.querySelector('.hs-upsell-add-to-cart,.hs-upsell-remove-to-cart') : '';
                if (!!hs_upsell_add_to_cart) {
                  limititems_btn = typeof hs_upsell_add_to_cart.getAttribute('data-hs-rw-limititems') !== 'undefined' ? parseInt(hs_upsell_add_to_cart.getAttribute('data-hs-rw-limititems')) : 0;
                  added_btn = typeof hs_upsell_add_to_cart.getAttribute('data-hs-rw-added') !== 'undefined' ? parseInt(hs_upsell_add_to_cart.getAttribute('data-hs-rw-added')) : 0;
                  position = typeof hs_upsell_add_to_cart.getAttribute('data-hs-rw-position') !== 'undefined' ? parseInt(hs_upsell_add_to_cart.getAttribute('data-hs-rw-position')) : 0;

                  disabled_btn = !!limititems_btn ? 1 : 0;
                  disabled_btn = !!added_btn ? 0 : disabled_btn;
                  title_btn = !!added_btn ? rewards_popup_remove_language_settings : !!position ? rewards_popup_pick_language_settings : title_btn;

                  if (!!hs_upsell_add_to_cart) {
                    hs_add_to_cart = !!hs_upsell_add_to_cart.querySelector('.hs-add--to--cart') ? hs_upsell_add_to_cart.querySelector('.hs-add--to--cart') : '';
                    typeof hs_upsell_add_to_cart.dataset.tieredLock === 'undefined' ? hs_upsell_add_to_cart.removeAttribute('disabled') : '';
                  }
                  if (!!added_btn) {
                    opt.setAttribute('disabled', 'disabled');
                  }
                  if (!!disabled_btn) {
                    hs_upsell_add_to_cart.setAttribute('disabled', 'disabled');
                  }
                }
              };

              var hs_product_content_image_swipper = !!hs_content_product_slide_cart.querySelector('.hs-product-content-image-swipper') ? hs_content_product_slide_cart.querySelector('.hs-product-content-image-swipper') : '';
              if (!!hs_product_content_image_swipper) {
                var img_swipper = !!hs_product_content_image_swipper.querySelector('img') ? hs_product_content_image_swipper.querySelector('img') : '';
                if (!!img_swipper) {
                  if (!!image) {
                    img_swipper.setAttribute('src', image)
                  };
                  let img_attr = '';
                  if (attr_img) {
                    img_attr = attr_img;
                  } else {
                    if (!!option) {
                      img_attr = option.text;
                    };
                  }
                  if (!!img_attr) {
                    img_swipper.setAttribute('alt', img_attr);
                  };
                };
              };


              var hs_content_title_price_swiper = !!opt.closest('.hs-content-title-price-swiper') ? opt.closest('.hs-content-title-price-swiper') : '';
              if (available === 'true') {
                if (!!hs_content_product_slide_cart) {
                  if (opt.closest('.hs-automatic-recommend')) {
                    if (!!parseInt(slideData.settings.product_recommendations_settings.upsell_product_url_automatic) && typeof upsell === 'undefined' || (upsell === 'empty' && !!slideData.settings.cart_empty.cart_empty_upsell_product_url)) {
                      var upsell_url = hs_content_product_slide_cart.querySelectorAll('a').length > 0 ? hs_content_product_slide_cart.querySelectorAll('a') : [];
                      if (upsell_url.length > 0) {
                        upsell_url.forEach(function (thisUrl) {
                          thisUrl.setAttribute('href', handle);
                        });
                      }
                    };
                  };

                  if (opt.closest('.hs-cross-sell')) {
                    if (!!parseInt(slideData.settings.manually_products_upsells.upsell_product_url_manually) && typeof upsell === 'undefined' || (upsell === 'empty' && !!slideData.settings.cart_empty.cart_empty_upsell_product_url)) {
                      var upsell_url = hs_content_product_slide_cart.querySelectorAll('a').length > 0 ? hs_content_product_slide_cart.querySelectorAll('a') : [];
                      if (upsell_url.length > 0) {
                        upsell_url.forEach(function (thisUrl) {
                          thisUrl.setAttribute('href', handle);
                        });
                      }
                    };
                  };

                  if (opt.closest('.hs-tiered_free_items')) {
                    var setHref = true;
                    if (typeof slideData.settings.tiered_free_items !== 'undefined') {
                      if (!parseInt(slideData.settings.tiered_free_items.tfi_product_url_automatic)) {
                        setHref = false;
                      };
                    };
                    if (!!setHref) {
                      var upsell_url = hs_content_product_slide_cart.querySelectorAll('a').length > 0 ? hs_content_product_slide_cart.querySelectorAll('a') : [];
                      if (upsell_url.length > 0) {
                        upsell_url.forEach(function (thisUrl) {
                          thisUrl.setAttribute('href', handle);
                        });
                      }
                    };
                  };
                };
                /* var input_subscribe = !!hs_content_product_slide_cart.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? hs_content_product_slide_cart.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
                var popup = !!hs_content_product_slide_cart.querySelector('.hs-popup') ? hs_content_product_slide_cart.querySelector('.hs-popup') : '';
                if (!!input_subscribe.checked || (!!popup && !!Hs_CartDrawer.subscribe)) {
                  if (plan_price !== '') {
                    price = plan_price;
                  };
                  if (plan_compareatprice !== '') {
                    compareatprice = plan_compareatprice;
                  };
                }; */

                if (!!hs_content_title_price_swiper) {
                  let hidden_span = '';
                  if (!!slideData.settings.additional_settings.show_compare_price) {
                    var elementComparePrice = '', hs_compare_price_sw = !!hs_content_title_price_swiper.querySelector('.hs-compare-price-sw') ? hs_content_title_price_swiper.querySelector('.hs-compare-price-sw') : '';
                    if (!!hs_compare_price_sw) {
                      if (+compareatprice > 0) {
                        hidden_span = `<span class="hs-internal-visually-hidden">Original price</span>`;
                      };
                      elementComparePrice = +compareatprice > 0 ? hidden_span + hsonslidecart.Currency.formatMoney(compareatprice, slideData.settings.devices.money_format) : '';
                      if (!!rewards) {
                        hidden_span = '';
                        elementComparePrice = +price > 0 ? hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) : '';
                      }
                      hs_compare_price_sw.innerHTML = elementComparePrice;
                    }
                  }


                  var elementPrice = '', hs_price_sw = !!hs_content_title_price_swiper.querySelector('.hs-price-sw') ? hs_content_title_price_swiper.querySelector('.hs-price-sw') : '';
                  if (!!hs_price_sw) {
                    elementPrice = price > 0 ? hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) : Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
                    if (!!rewards) {
                      elementPrice = price_discount > 0 ? hsonslidecart.Currency.formatMoney(price_discount, slideData.settings.devices.money_format) : Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price_discount, slideData.settings.devices.money_format);
                    }
                    hs_price_sw.innerHTML = `<span class="hs-internal-visually-hidden">${hidden_span !== '' ? 'Sale Price' : 'Price'}</span>` + elementPrice;
                  };
                };

                if (!!hs_upsell_add) {
                  var hs_upsell_add_to_cart = !!hs_upsell_add.querySelector('.hs-upsell-add-to-cart') ? hs_upsell_add.querySelector('.hs-upsell-add-to-cart') : '';
                  if (!!hs_upsell_add_to_cart) {
                    if (!!hs_add_to_cart) {
                      hs_add_to_cart.innerHTML = title_btn;
                    }
                  }
                }
                //var hs_content_title_price_swiper = !!opt.closest('.hs-content-title-price-swiper') ? opt.closest('.hs-content-title-price-swiper') : '';
              } else {
                if (!!hs_upsell_add_to_cart) {
                  hs_upsell_add_to_cart.disabled = true;
                  if (!!hs_add_to_cart) {
                    hs_add_to_cart.innerHTML = slideData.settings.language_settings.sold_out_language_settings;
                  }
                }
              };
            };
            HsApp1.currencyConverter();
          });
          opt.addEventListener('touchstart', (event) => {
            event.stopPropagation();
          }, { passive: true });
          opt.addEventListener('mousedown', (event) => {
            event.stopPropagation();
          });

          opt.addEventListener('ONPointerDown', (event) => {
            event.stopPropagation();
          });
        }
      });
      var count = 0;
      hs_swipper_select_option_add_to_cart.forEach(function (opt) {
        count++
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        opt.dispatchEvent(evt);
        if (count == hs_swipper_select_option_add_to_cart.length) {
          HsApp1.currencyConverter();
        }
      });

      var hs_selling_plan = document.querySelectorAll('select[name="hs-selling_plan"]').length > 0 ? document.querySelectorAll('select[name="hs-selling_plan"]') : [];
      if (hs_selling_plan.length > 0) {
        hs_selling_plan.forEach(function (select_plan) {
          if (!select_plan.classList.contains('hs-event-static')) {
            select_plan.classList.add('hs-event-static');
            select_plan.addEventListener('change', (event) => {

              var content_product_slide_cart = select_plan.closest('.hs-content-product-slide-cart ') || '';
              if (!!content_product_slide_cart) {
                var hs_select_variants_bar = content_product_slide_cart.querySelector('.hs-swipper-select-option-add-to-cart') || '';
                if (hs_select_variants_bar) {
                  var variant_selected = hs_select_variants_bar.value;
                  if (variant_selected) {
                    var dataProd = Object.keys(window.HSUPSELLS).length > 0 ? window.HSUPSELLS[hs_select_variants_bar.dataset.upsellType][hs_select_variants_bar.dataset.upsellIndex] : {};//COMMENT GET DATA FOR PRODUCT STORED IN BUTTON
                    if (dataProd) {
                      var variant = dataProd.variants.find((variant) => {
                        return +variant.id == +variant_selected
                      });
                      if (variant) {
                        var price = variant.price;
                        var compareatprice = variant.compare_at_price || 0;
                        if (variant.selling_plan_allocations.length > 0) {
                          var label_subscription = /* Hs_CartDrawer.withSubOnly; */ Hs_CartDrawer.curlyReplaceRc();
                          var hs_subscription_input = !!content_product_slide_cart.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? content_product_slide_cart.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
                          //COMMENT CAMBIO DE LAS OPCIONES DEL SELECT PLAN
                          variant.selling_plan_allocations.forEach((selling_plan_allocations) => {
                            if (+selling_plan_allocations.selling_plan_id == +select_plan.value) {
                              selling_plan_allocations.selling_plans.forEach((selling_plan) => {
                                var price_adjustments = '';
                                if (selling_plan.price_adjustments) {
                                  if (selling_plan.price_adjustments.length > 0) {
                                    var value = selling_plan.price_adjustments[0].value;
                                    var value_type = selling_plan.price_adjustments[0].value_type;
                                    if (value && value_type) {
                                      if (value > 0 && value_type === 'percentage') {
                                        price_adjustments = value;
                                      }
                                    };
                                  };
                                };
                                if (price_adjustments) {
                                  label_subscription = Hs_CartDrawer.curlyReplaceRc(price_adjustments + '%');
                                };
                              });
                            };
                          });

                          //COMMENT CAMBIO TEXT LABEL SUBSCRIPTION SI TIENE PORCENTAJE
                          if (!!hs_subscription_input) {
                            var hs_subscription = !!hs_subscription_input.closest('.hs-subscription-sub-option') ? hs_subscription_input.closest('.hs-subscription-sub-option') : '';
                            if (!!hs_subscription) {
                              var hs_subcription_label = !!hs_subscription.querySelector('.hs-sub-label') ? hs_subscription.querySelector('.hs-sub-label') : '';
                              if (!!hs_subcription_label) {
                                hs_subcription_label.innerHTML = label_subscription;
                              };
                            };
                            if (!!hs_subscription_input.checked) {
                              var selling_plan_selected_value = select_plan.value;
                              if (selling_plan_selected_value) {
                                var plan = variant.selling_plan_allocations.find((selling_plan) => {
                                  return +selling_plan.selling_plan_id == +selling_plan_selected_value
                                });
                                if (plan) {
                                  if (plan.price) {
                                    price = plan.price;

                                  };
                                  if (plan.compare_at_price) {
                                    if (!compareatprice || compareatprice >= plan.price) {
                                      if (plan.compare_at_price > plan.price) {
                                        compareatprice = plan.compare_at_price || 0;
                                      };
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                        var price_no_popup = content_product_slide_cart.querySelector('.hs-price-sw') || '';
                        if (price_no_popup) {
                          price_no_popup.innerHTML = price > 0 ? hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) : Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
                        };
                        if (!!slideData.settings.additional_settings.show_compare_price) {
                          var compare_price_no_popup = content_product_slide_cart.querySelector('.hs-compare-price-sw') || '';
                          if (compare_price_no_popup) {
                            if (+compareatprice > +price) {
                              compare_price_no_popup.innerHTML = +compareatprice > 0 ? hsonslidecart.Currency.formatMoney(compareatprice, slideData.settings.devices.money_format) : '';
                            };
                          };
                        }
                      };
                    };
                  };
                };
              };

              /* var text_subscription = Hs_CartDrawer.withSubAndDscto;
              var option_selected = select_plan.options[select_plan.selectedIndex];
              if (typeof option_selected !== 'undefined') {
                var option_attr = option_selected.dataset.valuePercentage;
                if (typeof option_attr !== 'undefined') {
                  text_subscription = Hs_CartDrawer.withSubAndDscto + ' ' + option_attr + '%';
                };
                var hs_subscription_content = !!select_plan.closest('.hs-subscription-content') ? select_plan.closest('.hs-subscription-content') : '';
                if (!!hs_subscription_content) {
                  var hs_subscription_input = !!hs_subscription_content.querySelector('input[data-hs-type="hs-chks-subscribe"]') ? hs_subscription_content.querySelector('input[data-hs-type="hs-chks-subscribe"]') : '';
                  if (!!hs_subscription_input) {
                    var hs_subscription = !!hs_subscription_input.closest('.hs-subscription-sub-option') ? hs_subscription_input.closest('.hs-subscription-sub-option') : '';
                    if (!!hs_subscription) {
                      var hs_subcription_label = !!hs_subscription.querySelector('.hs-sub-label') ? hs_subscription.querySelector('.hs-sub-label') : '';
                      if (!!hs_subcription_label) {
                        hs_subcription_label.innerHTML = text_subscription;
                      };
                    };
                  };
                };
              }; */
            });
          };
        });
        hs_selling_plan.forEach(function (select_plan) {
          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          select_plan.dispatchEvent(evt);
        });
      };
      var hs_item_cart_content_quantity_upsell = document.querySelectorAll('.hs-item-cart-content-quantity-upsell').length > 0 ? document.querySelectorAll('.hs-item-cart-content-quantity-upsell') : [];
      if (hs_item_cart_content_quantity_upsell.length > 0) {
        hs_item_cart_content_quantity_upsell.forEach(function (upsell) {
          var hs_cart_input_upsell = !!upsell.querySelector('input[type="text"]') ? upsell.querySelector('input[type="text"]') : '';
          if (!!hs_cart_input_upsell) {
            HsApp1.setInputFilter(hs_cart_input_upsell, function (value) {
              return /^-?\d*$/.test(value);
            });
            /* if(!hs_cart_input_upsell.classList.contains('hs-event-static')){
              hs_cart_input_upsell.classList.add('hs-event-static')
              hs_cart_input_upsell.addEventListener('focusout', function (e) {
                this.value = this.value.replace(/[^0-9\.]/g, '');
                if (!this.value || this.value == 0) {
                  this.value = 1;
                }
                var where = this, value = this.value;
 
                if (value === '') {
                  value = 1;
                }
              });
            }; */
          }
        });
      };
      var hs_qtybutton_upsell = document.querySelectorAll('.hs-qtybutton-upsell').length > 0 ? document.querySelectorAll('.hs-qtybutton-upsell') : [];
      if (hs_qtybutton_upsell.length > 0) {

        function qtyButtonUpsell($button) {
          var newVal = 0,
            oldValue = !!$button.closest('.hs-item-cart-qty-upsell')
              ? $button.closest('.hs-item-cart-qty-upsell').querySelector('input').value
              : '';

          if (!!oldValue) {
            if ($button.classList.contains('hs-inc-upsell')) {
              newVal = parseFloat(oldValue) + 1;
            } else {
              if (oldValue > 1) {
                newVal = parseFloat(oldValue) - 1;
              } else {
                newVal = 1;
              }
            }
          }

          const input = $button.closest('.hs-item-cart-qty-upsell')?.querySelector('input');
          if (input) input.value = newVal;
        }


        hs_qtybutton_upsell.forEach(function (qtybutton) {
          if (!qtybutton.classList.contains('hs-event-static')) {
            qtybutton.classList.add('hs-event-static')
            qtybutton.addEventListener('click', function (event) {
              event.preventDefault();
              qtyButtonUpsell(this);
            });

            qtybutton.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                qtyButtonUpsell(this);
              }
            });

          }

        });
      };
    };
    //};
  },
  discountRewardsPrice: function (price_sw, arrRewards) {
    var price = 0, discount_value = 0;
    if (Object.keys(arrRewards).length === 0 && arrRewards.constructor === Object) {
      price = price_sw;
    } else {
      if (!arrRewards.discount_type) {
        price = (price_sw * arrRewards.discount_value) / 100;
        price = price_sw - price;
      } else {
        discount_value = arrRewards.discount_value * 100;
        price = price_sw >= discount_value ? price_sw - discount_value : 0;
      }
    }
    return price;
  },
  upsellProductsJson: function (show_quantity_box, mode, upsell_class, products, upsell, showProd, addToCartMode, result_item = '', arrRewards = {}) {
    /*COMMENT SHOW_QUANTITY_BOX= SHOW QTY IN UPSELL,MODE=SLIDE(0)/STACKED(1),UPSELL_CLASS= ADD CLASS IF MODE IS SLIDE, PRODUCTS= LIST OF PRODS ,UPSELL=NAME UPSELL(ASSIGN VAR. GLOBAL window.HSUPSELLS['upsell_' + upsell], SHOWPROD= SHOW IF AVAILABLE STOCK), ADDTOCARTMODE= POPUP OR NOT,RESULT_ITEM= FIND VARIANTS THAT MATCH THE LAST ADDED TO THE CART  */
    var selectCombobox = '',
      rewards_popup_pick_language_settings = '',
      rewards_popup_remove_language_settings = '',
      title_btn = '',
      aria_label_btn = '',
      selectParent = '',
      active_product = '',
      disabled_btn = '',
      add_and_remove_btn = ``,
      limit_items_btn = 0,
      added_btn = 0,
      selectVariantText = '',
      quantity_box = '',
      parent_class = '',
      validateTextVariant = 0,
      my_price = 0,
      my_price_with_discount = 0,
      my_compare_at_price = 0,
      status_text_slide_cart = '',
      featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif',
      featured_image_variant = '',
      myclass_rewards_add = '',
      myclass_rewards_products_two = '',
      contentUpsell = '',
      rewards_quantity = 0,
      validateRewards = 0,
      discount_type = 0,
      discount_value = 0,
      position = 0,
      reward_id = 0,
      unlock = 0,
      element_rewards_quantity = '',
      show_only_product_variant_in_stock = showProd,
      utm = !!slideData.settings.additional_settings.add_utm ? '&utm_source=slide-cart-drawer-upsell' : '';
    if (typeof products == 'undefined' || products.length < 1) {
      return false;
    };
    //if (Object.keys(arrRewards).length === 0 && arrRewards.constructor === Object) {
    window.HSUPSELLS['upsell_' + upsell] = products;
    //}
    //if (HsApp1.readCookie('cart_currency') !== '') {

    //};

    if (Object.keys(arrRewards).length > 0 && arrRewards.constructor === Object) {
      validateRewards = 1;
      discount_type = arrRewards.discount_type;
      discount_value = arrRewards.discount_value;
      position = arrRewards.position;
      reward_id = arrRewards.reward_id;
      unlock = arrRewards.unlock;
      myclass_rewards_add = ` hs-rewards-re-add`;
      if (products.length == 2) {
        myclass_rewards_products_two = ` hs-rewards-products-two`;
      }
    }

    products.forEach(function (item, index) {
      var pricesInt = true;
      var new_url = '/products/';
      var iniArray = 0;
      var variantsAvailable = [], price_sw = 0, price_sw_discount = 0, compare_at_price_sw = '', hidden_span = '';
      if (typeof item.error === "undefined") {
        if (!!window.Shopify) {
          if (!!window.Shopify.routes) {
            if (!!window.Shopify.routes.root) {
              if (window.Shopify.routes.root !== '/') {
                new_url = window.Shopify.routes.root.concat(`products/`);
              };
            };
          };
        };

        let attr_img = Hs_CartDrawer.escape(`${item.title.replace(/<.*?>/g, '')}`);
        if (item.variants.length > 0 && item.variants[0].title !== "Default Title") {
          attr_img = attr_img + ' - ' + item.variants[0].title.replace(/<.*?>/g, '');
        };
        new_url = new_url + item.handle;
        if (item.featured_image !== null) {
          featured_image = HsApp1.resizeSrc(item.featured_image, slideData.settings.additional_settings.image_quality)
          //featured_image_variant = featured_image;
        }
        if (!item.featured_image) {
          if (!!item.images) {
            if (item.images.length > 0) {
              var img = item.images[0].src;
              featured_image = HsApp1.resizeSrc(img.replace('https:', ''), slideData.settings.additional_settings.image_quality)
            }
            else {
              featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
            }
          }
        };
        if (!item.price) {
          pricesInt = false;
        };
        selectParent = '', selectVariantText = '';
        var exist = 0;
        item.variants.forEach(function (n, i) {
          let attr_img = Hs_CartDrawer.escape(`${item.title.replace(/<.*?>/g, '')}`);
          if (n.title !== "Default Title") {
            attr_img = attr_img + ' - ' + n.title.replace(/<.*?>/g, '');
          };
          var price = '', compare_price = '';
          if (n.price) {
            if (typeof n.price === 'string') {
              n.price = n.price * 100;
            };
          }
          if (n.compare_at_price) {
            if (typeof n.compare_at_price === 'string') {
              n.compare_at_price = n.compare_at_price * 100;
            };
          }
          featured_image_variant = '';
          if (n.featured_image !== null) {
            featured_image_variant = HsApp1.resizeSrc(n.featured_image.src, slideData.settings.additional_settings.image_quality);
          };
          if (result_item !== '') {
            if (n.title === result_item.variant_title) {
              exist = 1;
              iniArray = i;
            };

            if (exist == 0) {
              if (result_item.variant_options.length > 0) {
                result_item.variant_options.forEach(function (opt) {
                  if (exist == 0) {
                    if (opt === n.option1) {
                      exist = 1;
                      iniArray = i;
                    };
                  };
                  if (exist == 0) {
                    if (opt === n.option2) {
                      exist = 1;
                      iniArray = i;
                    };
                  }
                  if (exist == 0) {
                    if (opt === n.option3) {
                      exist = 1;
                      iniArray = i;
                    };
                  }
                });

              };
            };
          };
          if (iniArray === '') {
            iniArray = 0;
          };

          var selected = exist == 1 && n.id == item.variants[iniArray].id ? 'selected' : '';
          var selling_plan = ''
          if (typeof n.selling_plan_allocations !== 'undefined') {
            if (n.selling_plan_allocations.length > 0) {
              selling_plan = n.selling_plan_allocations[0];
              price = `data-plan-price='${selling_plan.price}'`;
              if (typeof n.requires_selling_plan !== 'undefined') {
                if (!n.requires_selling_plan) {
                  compare_price = price == selling_plan.compare_at_price ? compare_price : `data-plan-compareatprice='${selling_plan.compare_at_price}'`;
                };
              };
            };
          };

          var url_parameter = new_url + '?variant=' + n.id + utm, variant_selling_plan_group_id = [];
          if (n.selling_plan_allocations) {
            variant_selling_plan_group_id = n.selling_plan_allocations.map((element) => {
              return element.selling_plan_group_id;
            });
            variant_selling_plan_group_id = variant_selling_plan_group_id.toString()
          };

          my_price = n.price;
          my_compare_at_price = n.compare_at_price;
          my_price_with_discount = HsApp1.discountRewardsPrice(n.price, arrRewards);
          if (Object.keys(arrRewards).length > 0 && arrRewards.constructor === Object) {
            rewards = 1;
            rewards_quantity = !!n.qty ? n.qty : 1;
            my_price_with_discount = !!my_price_with_discount ? my_price_with_discount * rewards_quantity : 0;
            my_compare_at_price = !!my_compare_at_price ? my_compare_at_price * rewards_quantity : 0;
            my_price = !!my_price ? my_price * rewards_quantity : 0;
            element_rewards_quantity = `<div class="hs-sl-offer-quantity-label" title="Quantity">×${rewards_quantity}<div class="hs-item-cart-content-quantity-upsell" style="display:none;"><input type="hidden" value="${rewards_quantity}" aria-label="quantity"></div></div>`;
          }

          var variant_selected = ``;
          if (Object.keys(arrRewards).length > 0 && arrRewards.constructor === Object) {

            if (HSSLIDECART.CART.items.length > 0) {
              HSSLIDECART.CART.items.forEach(function (c) {
                if (n.id == c.id) {
                  if (Object.keys(c.properties).length > 0) {
                    for (const mykey in c.properties) {
                      if (c.properties.hasOwnProperty(mykey)) {
                        if (mykey === '_hs-index') {
                          var i = parseInt(c.properties[mykey]);
                          if (position == i) {
                            variant_selected = ` selected="selected"`;
                          }
                        }
                      }
                    }
                  }
                }
              });
            }
          }

          if (parseInt(show_only_product_variant_in_stock)) {
            if (n.available) {
              variantsAvailable.push(n);
              if (n.title !== 'Default Title') {
                selectVariantText = selectVariantText.concat(n.title);
              }
              selectParent = selectParent.concat(`<option ${selected} value="${n.id}" data-attr="${attr_img}" data-id="${item.id}" ${price} ${compare_price} data-price="${my_price}" data-pricediscount="${my_price_with_discount}" data-sku="${n.sku}" data-available="${n.available}" data-handle="${url_parameter}" data-barcode="${n.barcode || ''}" data-featuredimage="${featured_image_variant}" data-inventorymanagement="${n.inventory_management}" data-compareatprice="${my_compare_at_price}" data-variantid="${n.id}" data-selling-plan-group-id="${variant_selling_plan_group_id}"${variant_selected}>${n.title}</option>`)
            }
          } else {
            selectParent = selectParent.concat('<option ' + selected + ' value="' + n.id + '" data-attr="' + attr_img + '" ' + '" data-id="' + item.id + '" ' + price + compare_price + ' data-price="' + my_price + '" data-pricediscount="' + my_price_with_discount + '" data-sku="' + n.sku + '" data-available="' + n.available + '" data-handle="' + url_parameter + '" data-barcode="' + n.barcode || '' + '" data-featuredimage="' + featured_image_variant + '" data-inventorymanagement="' + n.inventory_management + '" data-compareatprice="' + my_compare_at_price + '" data-variantid="' + n.id + '" data-selling-plan-group-id=" ' + variant_selling_plan_group_id + '"' + variant_selected + '>' + n.title + '</option>');
            if (n.title !== 'Default Title') {
              selectVariantText = selectVariantText.concat(n.title);
            }
          }
        });

        if (item.variants.length > 0) {
          price_sw = item.variants[iniArray].price;
          compare_at_price_sw = item.variants[iniArray].compare_at_price;
          if (Hs_CartDrawer.subscribe_option_upsell) {
            if (typeof item.variants[iniArray].selling_plan_allocations !== 'undefined') {
              if (item.variants[iniArray].selling_plan_allocations.length > 0) {
                price_sw = item.variants[iniArray].selling_plan_allocations[0].price;
                if (item.variants[iniArray].selling_plan_allocations[0].compare_at_price > price_sw) {
                  compare_at_price_sw = item.variants[iniArray].selling_plan_allocations[0].compare_at_price;
                };
              };
            };
          };
        } else {
          price_sw = item.price;
          compare_at_price_sw = item.compare_at_price;
        };

        price_sw_discount = HsApp1.discountRewardsPrice(price_sw, arrRewards);


        if (!!slideData.settings.additional_settings.show_compare_price) {

          compare_at_price_sw = compare_at_price_sw ? compare_at_price_sw : 0;
          if (compare_at_price_sw > price_sw) {
            hidden_span = '<span class="hs-internal-visually-hidden">Original Price</span>';
            compare_at_price_sw = '<div class="hs-compare-price-sw">' + hidden_span + hsonslidecart.Currency.formatMoney(compare_at_price_sw, slideData.settings.devices.money_format) + '</div>';
          } else {
            compare_at_price_sw = '<div class="hs-compare-price-sw"></div>';
          }
        } else {
          compare_at_price_sw = '<div class="hs-compare-price-sw"></div>'
        };

        price_sw = `<div class="hs-price-sw" tabindex="0"><span class="hs-internal-visually-hidden">${hidden_span !== '' ? 'Sale Price' : 'Price'}</span>
        ${price_sw == 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price_sw, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(price_sw, slideData.settings.devices.money_format)}</div>`;

        if (!!validateRewards) {
          compare_at_price_sw = '<div class="hs-compare-price-sw">' + price_sw + '</div>';
          price_sw = `<div class="hs-price-sw">${price_sw_discount == 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? `<span>${Hs_CartDrawer.languageFreeGnral}</span>` : hsonslidecart.Currency.formatMoney(price_sw_discount, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(price_sw_discount, slideData.settings.devices.money_format)}</div>`;
        }

        parent_class = '', validateTextVariant = 0;
        /* if (item.variants.length == 1 || (variantsAvailable.length == 1 || variantsAvailable.length == 0)) {
          parent_class = ' hs-hidden-element';
          validateTextVariant = 1;
        } */

        //CAMBIO
        if (item.variants.length == 1 || (variantsAvailable.length == 1)) {
          if (variantsAvailable.length == 1) {
            if (variantsAvailable[0]?.title === "Default Title") {
              parent_class = ' hs-hidden-element';
              validateTextVariant = 1;
            };
          };
        };
        if (variantsAvailable.length == 0) {
          parent_class = ' hs-hidden-element';
          validateTextVariant = 1;
        };

        selectCombobox = `<div class="hs-sl-product-variants-options"><select aria-label="select ${Hs_CartDrawer.escape(`${item.title.replace(/<.*?>/g, '')}`)} variant" name="itemProductVariants" data-upsell-type="upsell_${upsell}" data-rewards="${validateRewards}" data-upsell-index='${index}' class="${!mode ? 'hs-swiper-no-swiping' : ''} hs-swipper-option-parent-${item.id} hs-swipper-select-option-add-to-cart${parent_class}" data-id="${item.id}">${selectParent}</select></div>`;

        if (!!show_quantity_box) {
          quantity_box = `
                    <div class="hs-qty-upsell">
                      <div class="${!mode ? 'hs-swiper-no-swiping ' : ' '}hs-item-cart-content-quantity-upsell">
                        <div class="hs-item-cart-qty-upsell">
                          <div class=" hs-dec-upsell hs-qtybutton-upsell " role="button" tabindex="0" aria-label="minus">
                              <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg>
                          </div>
                          <input type="text" maxlength="4" name="updates[]" class="" value="1" min="0" data-id="43644933996836" data-line="1" data-key="43644933996836:2d5f1ed029f2c01b0d880fadbf59e382" aria-label="quantity" pattern="[0-9]*">
                          <div class="hs-inc-upsell hs-qtybutton-upsell" role="button" tabindex="0" aria-label="plus">
                              <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                            </div>
                        </div>
                      </div>
                    </div>`;
        };

        var url_prod = '', with_href = '';
        if (upsell === 'automatic') {
          url_prod = !!parseInt(slideData.settings.product_recommendations_settings.upsell_product_url_automatic) ? 'href="' + new_url + '"' : "";
          with_href = !!parseInt(slideData.settings.product_recommendations_settings.upsell_product_url_automatic) ? ' hs-link' : "";
        };
        if (upsell === 'manually') {
          url_prod = !!parseInt(slideData.settings.manually_products_upsells.upsell_product_url_manually) ? 'href="' + new_url + '"' : "";
          with_href = !!parseInt(slideData.settings.manually_products_upsells.upsell_product_url_manually) ? ' hs-link' : "";
        };
        if (upsell === 'empty') {
          url_prod = !!parseInt(slideData.settings.cart_empty.cart_empty_upsell_product_url) ? 'href="' + new_url + '"' : "";
          with_href = !!parseInt(slideData.settings.cart_empty.cart_empty_upsell_product_url) ? ' hs-link' : "";
        };
        if (upsell === 'static') {
          url_prod = !!parseInt(slideData.settings.static_products_upsells.upsell_product_url_static) ? 'href="' + new_url + '"' : "";
          with_href = !!parseInt(slideData.settings.static_products_upsells.upsell_product_url_static) ? ' hs-link' : "";
        };
        if (upsell === 'tiered') {
          url_prod = typeof slideData.settings.tiered_free_items !== 'undefined' ? !!parseInt(slideData.settings.tiered_free_items.tfi_product_url_automatic) ? 'href="' + new_url + '"' : '' : 'href="' + new_url + '"';
          with_href = typeof slideData.settings.tiered_free_items !== 'undefined' ? !!parseInt(slideData.settings.tiered_free_items.tfi_product_url_automatic) ? ' hs-link' : "" : ' hs-link';
        };
        if (upsell === 'none') {
          url_prod = "";
          with_href = "";
        };

        if (variantsAvailable.length > 0) {
          item.variants = variantsAvailable;
        };

        var image = `<img loading="lazy" src="${featured_image}" alt='${attr_img}'/>`,
          content_img = url_prod !== '' ? `<a ${url_prod} class="hs-product-link-image">${image}</a>` : `<span class="hs-product-link-image">${image}</span>`;

        var contentTitle = `<div class="hs-title-swiper"><${url_prod !== '' ? `a ${url_prod}` : `span`}  class="hs-product-link-image">
                    ${item.title}
                    </${url_prod !== '' ? 'a' : 'span'}></div><div class='jdgm-badge-placeholder' data-handle='${item.handle}'></div>`;

        var selling_group_id = '';
        var selling_plan_options = ``;
        var count_options = 0;
        if (typeof item.selling_plan_groups !== 'undefined') {
          if (item.selling_plan_groups.length > 0) {
            item.selling_plan_groups.forEach((selling_plan_group) => {
              if (typeof selling_plan_group.app_id !== 'undefined') {
                //294517 => rechargesubscription x variant
                //null recurpay subscription x product
                if (selling_plan_group.app_id === '294517' || selling_plan_group.app_id === 'appstle' || selling_plan_group.app_id == null) {
                  if (typeof selling_plan_group.selling_plans !== 'undefined') {
                    if (selling_plan_group.selling_plans.length > 0) {
                      selling_group_id = selling_plan_group.id;
                      selling_plan_group.selling_plans.forEach(function (selling_opt) {
                        var price_adjustments = '';
                        if (typeof selling_opt.price_adjustments !== 'undefined') {
                          if (selling_opt.price_adjustments.length > 0) {
                            var value = selling_opt.price_adjustments[0].value;
                            var value_type = selling_opt.price_adjustments[0].value_type;
                            if (typeof value !== 'undefined' && typeof value_type !== 'undefined') {
                              if (value > 0 && value_type === 'percentage') {
                                price_adjustments = `data-value-percentage="${value}"`
                              }
                            };
                          };
                        };
                        count_options++;
                        selling_plan_options = selling_plan_options + `<option value="${selling_opt.id}" ${price_adjustments}>${selling_opt.name}</option>`
                      });
                    };
                  };
                };
              };
            });
          };
        };
        //noPopUp = window.location.search.indexOf('nopopup')> -1 ? 1 : 0;
        var checked = 0;
        if (typeof item.requires_selling_plan !== 'undefined') {
          if (!!item.requires_selling_plan) {
            checked = 1
          };
        };

        var position_button = 0;
        if (!!checked && !show_quantity_box && parent_class !== '') {
          position_button = 1;
        };

        var tiered_name = upsell === 'tiered' ? typeof item.tieredName !== 'undefined' ? `data-tiered-name="${item.tieredName}"` : '' : '';
        var tiered_lock = upsell === 'tiered' ? !!Hs_CartDrawer.tfi_lock_method ? typeof item.qualified !== 'undefined' ? !item.qualified ? `data-tiered-lock="true"` : '' : '' : '' : '';

        var data_only_variant = '';
        if (!addToCartMode) {
          if (selling_group_id !== '' && Hs_CartDrawer.subscribe_option_upsell) {
            data_only_variant = `data-upsell-subs=${selling_group_id}`
          };
        };

        add_and_remove_btn = `hs-upsell-add-to-cart`;
        rewards_popup_pick_language_settings = slideData.settings.language_settings.rewards_popup_pick_language_settings;
        rewards_popup_remove_language_settings = slideData.settings.language_settings.rewards_popup_remove_language_settings;
        title_btn = slideData.settings.language_settings.add_in_upsell_language_settings;
        aria_label_btn = ` aria-label="Add the product, ${attr_img}`;

        if (typeof item.added !== 'undefined') {
          if (typeof item.limit_items !== 'undefined') {
            disabled_btn = !!item.limit_items ? ` disabled="disabled"` : ``;
            disabled_btn = !!item.added ? `` : disabled_btn;

            added_btn = item.added;
            limit_items_btn = item.limit_items;

            active_product = !!item.added ? ` hs-active-rewards-product` : ``;
            title_btn = !!item.added ? rewards_popup_remove_language_settings : rewards_popup_pick_language_settings;

            aria_label_btn = !!item.added ? ` aria-label="Remove the product, ${attr_img}` : aria_label_btn;

            add_and_remove_btn = !!item.added ? `hs-upsell-remove-to-cart` : add_and_remove_btn;
          }
        }

        let upsell_collection = item.upsell_specific || '';
        upsell_collection = upsell_collection === 'collection' ? 'data-upsell-collection="true"' : 'data-upsell-collection="false"';
        var contentButton = `${!item.tags.includes('HS_HIDDEN_ADDTOCART_BUTTON') ?
          `<div class="hs-upsell-add ${!mode ? ' hs-swiper-no-swiping' : ''}">
                    <button ${tiered_lock !== '' ? 'disabled' : ''} ${aria_label_btn}" type="button" data-hs-rw-added="${added_btn}" data-hs-rw-limititems="${limit_items_btn}" data-hs-rw-position="${position}" data-hs-rw-qty="${rewards_quantity}" data-hs-rw-id="${reward_id}" data-hs-rw-discount-type="${discount_type}" data-hs-rw-discount-value="${discount_value}" class="${add_and_remove_btn} btn" ${!addToCartMode ? 'data-upsell-type="upsell_' + upsell + '" data-upsell-index=' + index : ''}  ${tiered_lock} ${tiered_name} ${data_only_variant} ${upsell_collection}${disabled_btn}>
                      <span class="hs-add--to--cart">
                        ${title_btn}
                      </span>
                      <span class="hs--loading">
                        ${HsApp4.loadSvg()}
                      </span>
                    </button>
                  </div>` : ''}`;
        if (!!validateRewards) {
          contentButton = !!unlock ? contentButton : '';
        }

        var contentSellingPlan = `${Hs_CartDrawer.subscribe_option_upsell ? selling_plan_options !== '' ? `<div class="hs-subscription-content">
                    <div class="hs-subscription-option${!!checked ? ' hs-subscription-only' : ''}">
                    ${!checked ? `
                      <label class="hs-subscription-sub-option ${!mode ? ' hs-swiper-no-swiping' : ''}">
                        <div class="hs-content-subscription-sub-option">
                          <input type="radio" data-hs-type="hs-chks-once" value="once" ${!!Hs_CartDrawer.subscribe ? '' : 'checked'}>
                          <span class="hs-custom-radio"></span>
                          <span class="hs-sub-label">${Hs_CartDrawer.withOutSub}</span>
                        </div>
                      </label>` : ''}
                      <label class="hs-subscription-sub-option ${!mode ? ' hs-swiper-no-swiping' : ''}">
                        <div class="hs-content-subscription-sub-option">
                          <input type="radio" data-hs-type="hs-chks-subscribe" value="${selling_group_id}" ${!!checked ? 'checked' : !!Hs_CartDrawer.subscribe ? 'checked' : ''}>
                          <span class="hs-custom-radio"></span>
                          <span class="hs-sub-label">${Hs_CartDrawer.curlyReplaceRc()}</span>
                        </div>
                      </label>
                    </div>
                    <div class="hs-frequency-option ${!!checked ? '' : !!Hs_CartDrawer.subscribe ? '' : 'hs-hidden'}">
                      <select name="hs-selling_plan" ${!mode ? 'class="hs-swiper-no-swiping"' : ''}
                      data-count-options='${count_options}'>
                      ${selling_plan_options}
                      </select>
                      ${!!position_button ? contentButton : ''}
                    </div>
                  </div>` : '' : ''}`;

        var contentPrices = `<div class="hs-content-price-swiper${!!Hs_CartDrawer.customize_upsell_sale_price ? ' hs-active-sale-price' : ''}">
                    ${Hs_CartDrawer.prices_reverse_order ? price_sw + compare_at_price_sw : compare_at_price_sw + price_sw}
                  </div>`

        var textVariant = !!validateTextVariant ? `<div class="hs-rewards-content-products-variants-text"><div class="hs-sl-rewards-variant-text">${selectVariantText}</div></div>` : '';
        if (Object.keys(arrRewards).length === 0 && arrRewards.constructor === Object) {
          textVariant = '';
        }
        var elementCombobx = `<div class="hs-options-swiper ${parent_class}">${selectCombobox}</div>`;
        var elementQuantityButton = !!quantity_box ? `${elementCombobx}<div class="hs-content-two-box">${quantity_box}${!position_button ? contentButton : ''}</div>` : !position_button ? contentButton : '';
        var elementButtonCombobox = !!quantity_box ? elementQuantityButton : `<div class="hs-content-two-box hs-combobox-and-btn">${elementCombobx}${!position_button ? contentButton : ''}</div>`;
        if (addToCartMode > 0) {
          contentUpsell = `
                    <div class="hs-nopopup${selling_plan_options === '' ? ' hs-not-subscription' : ''}${!show_quantity_box ? ' hs-not-qty' : ''}${!!position_button ? ' hs_button_subscription' : ''}${parent_class}">
                      ${contentTitle}
                      ${contentPrices}
                      ${contentSellingPlan}
                      ${textVariant}
                      ${element_rewards_quantity}
                      ${elementButtonCombobox}
                    </div>
                    `;
        } else {
          contentUpsell = `
                    <div class="hs-popup">
                      ${contentTitle}
                      <div class="hs-content-all-upsell">
                        ${contentPrices}
                        <div class="hs-variants-swipper ${parent_class}">
                          <div class="${parent_class}">
                            ${selectCombobox}
                          </div>
                          ${quantity_box}
                        </div>
                        ${contentButton}
                      </div>
                    </div>`;
        };
        var progressOld = typeof item.tieredName !== 'undefined' ? !!document.querySelector(`.hs-${item.id + '-' + item.tieredName.replace(/ /g, "").replace(/\((\d+)\)/g, "").replace('$', '')}`) ? document.querySelector(`.hs-${item.id + '-' + item.tieredName.replace(/ /g, "").replace(/\((\d+)\)/g, "").replace('$', '')}`).dataset.value : 0 : '';
        var hideTier = 0;
        if (typeof slideData.settings.tiered_free_items !== 'undefined') {
          if (typeof slideData.settings.tiered_free_items.tif_auto_add !== 'undefined') {
            if (!!slideData.settings.tiered_free_items.tif_auto_add) {
              hideTier = typeof item.tieredHide !== 'undefined' ? item.tieredHide : 0;
            };
          };
        };

        status_text_slide_cart = status_text_slide_cart.concat(!hideTier ? `
                    <div class="hs-swiper-slide${myclass_rewards_products_two}${active_product}">
                      <div class="hs-content-product-slide-cart${Hs_CartDrawer.tfi_lock_method == 0 ? typeof item.qualified !== 'undefined' ? !item.qualified ? ' hs-locked-offer-content' : '' : '' : ''}">
                        <div class="hs-product-content-image-swipper ${addToCartMode > 0 ? 'hs-content-nopopup' : ''}">
                          ${content_img}
                        </div>
                        <div class="hs-content-title-price-swiper${with_href}${myclass_rewards_add}">
                          ${contentUpsell}
                        </div>
                      </div>
                      ${Hs_CartDrawer.tfi_lock_method == 0 ? typeof item.qualified !== 'undefined' ? !item.qualified ?
            `<div class="hs-locked-offer">
                          <p>${item.value_amount}</p>
                          <div data-value=${item.progress} class="hs-locked-offer-progress-bar hs-${item.id + '-' + item.tieredName.replace(/ /g, "").replace(/\((\d+)\)/g, "").replace('$', '')}">
                            <div class="hs-locked-offer-progress-made" style="width:${progressOld}%;"></div>
                          </div>
                        </div>` : '' : '' : ''}
                    </div>` : '')
      }
    });
    if (status_text_slide_cart) {
      if (!mode) {
        status_text_slide_cart = '<div class="hs-swiper-container ' + upsell_class + '">\
                  <div class="hs-swiper-wrapper">'+ status_text_slide_cart + '</div>\
                  <div class="hs-swiper-pagination"></div>\
                  <div class="hs-swiper-button-next"></div>\
                  <div class="hs-swiper-button-prev"></div>\
                  </div>';
      }
    };
    return status_text_slide_cart;
  },
  upsellNoPopUp: function () {
    var hs_nopopup = document.querySelectorAll('.hs-site-cart-popup-layout .hs-nopopup').length > 0 ? document.querySelectorAll('.hs-site-cart-popup-layout .hs-nopopup') : [];
    if (hs_nopopup.length > 0) {
      hs_nopopup.forEach(function (noPopUp) {
        var hs_subscription_content = !!noPopUp.querySelector('.hs-subscription-content') ? noPopUp.querySelector('.hs-subscription-content') : '';
        if (!!hs_subscription_content) {
          var inputs = hs_subscription_content.querySelectorAll('input').length > 0 ? hs_subscription_content.querySelectorAll('input') : [];
          if (inputs.length > 0) {
            inputs.forEach(function (thisInput) {
              if (!thisInput.classList.contains('hs-event-static')) {
                thisInput.classList.add('hs-event-static')
                thisInput.addEventListener('click', function (e) {
                  var where = this;
                  var hs_frequency_option = !!hs_subscription_content.querySelector('.hs-frequency-option') ? hs_subscription_content.querySelector('.hs-frequency-option') : '';
                  var hs_swiper_wrapper = !!where.closest('.hs-swiper-wrapper') ? where.closest('.hs-swiper-wrapper') : '';
                  if (!!hs_swiper_wrapper) {
                    hs_swiper_wrapper.style.height = '';
                  };
                  if (!!hs_frequency_option) {
                    if (this.dataset.hsType === 'hs-chks-subscribe') {
                      /* var this_select = hs_frequency_option.querySelector('select[name="hs-selling_plan"]') || '';
                      if (this_select) {
                        var this_options = this_select.options || '';
                        if (this_options) {
                          if (this_options.length > 1) {
                            hs_frequency_option.classList.remove('hs-hidden');
                          }
                        };
                      } */
                      hs_frequency_option.classList.remove('hs-hidden');
                    } else {
                      hs_frequency_option.classList.add('hs-hidden');
                    }
                  };
                  inputs.forEach(function (thisInput) {
                    if (where.dataset.hsType !== thisInput.dataset.hsType) {
                      thisInput.checked = false;
                    };
                  });
                  var options_select = !!noPopUp.querySelector('.hs-swipper-select-option-add-to-cart') ? noPopUp.querySelector('.hs-swipper-select-option-add-to-cart') : '';
                  if (!!options_select) {
                    var evt = document.createEvent("HTMLEvents");
                    evt.initEvent("change", false, true);
                    options_select.dispatchEvent(evt);
                  };
                });
              };
            });
          };
        };
      });
    };
  },
  validateUpsell: function (arrUpsell, handleProd, condition, typeProduct, latestProduct) {

    if (arrUpsell.length > 0) {
      var arrEnd = [];
      if (typeProduct === 'automatic') {
        typeProduct = slideData.settings.product_recommendations_settings.maximum_items_suggest;
        if (slideData.settings.product_recommendations_settings.based_last_product !== 'undefined') {
          if (!!slideData.settings.product_recommendations_settings.based_last_product) {
            var variantLatestProduct = latestProduct.variant_title;
            if (typeof variantLatestProduct !== 'undefined') {
              if (arrUpsell.length > 0) {
                arrUpsell.forEach(function (prod) {
                  if (typeof prod.variants !== 'undefined') {
                    if (prod.variants.length > 0) {
                      var itemCheck = 0;
                      prod.variants.forEach(function (variant) {
                        if (itemCheck == 0) {
                          if (!!variant.available) {
                            if (variant.title === variantLatestProduct) {
                              itemCheck++;
                              arrEnd.push(prod);
                            };
                          };
                        };
                      });
                    };
                  };
                });
              };
              arrUpsell = arrEnd;
            };
          };
        };
      }
      if (typeProduct === 'manually') {
        typeProduct = slideData.settings.manually_products_upsells.maximum_items_suggest_manually;
      }
      if (typeProduct === 'static') {
        typeProduct = slideData.settings.static_products_upsells.maximum_items_suggest_static;
      }
      var arr = [];
      arrUpsell.forEach(function (element) {
        var itemsAvailable = 0;
        let collection = element.upsell_specific || '';
        element.variants.forEach(function (variant) {
          if (!!variant.available) {
            itemsAvailable++;
            if (collection === 'collection') {
              var options = [];
              if (!variant.options) {
                /* variant.options = options.split(',') */
                if (variant.option1 != null) {
                  options.push(variant.option1)
                }
                if (variant.option2 != null) {
                  options.push(variant.option2)
                }
                if (variant.option3 != null) {
                  options.push(variant.option3)
                }
                if (!!options) {
                  variant.options = options;
                }
              }
            };
          };
        });
        itemsAvailable > 0 ? element.available = true : element.available = false;
        if (!!element.available) {
          if (arr.length < typeProduct) {
            var itemHandle = 0;
            handleProd.forEach(function (handle) {
              if (element.handle === handle) {
                itemHandle++;
              }
            });
            if (itemHandle == 0) {
              arr.push(element);
            }
          }
        }
      });
    };
    return arr;
  },
  tieredSlider: function (count_items = 0) {
    var upsell_space = 25;
    var upsell_slide_per_view = count_items > Hs_CartDrawer.tiered_qty_per_view ? Hs_CartDrawer.tiered_qty_per_view : count_items;
    var upsell_autoplay = Hs_CartDrawer.tiered_autoplay_time > 0 ? {
      autoplay: {
        delay: Hs_CartDrawer.tiered_autoplay_time,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    } : {};

    switch (Hs_CartDrawer.tiered_qty_per_view) {//CAMBIO
      case 2:
        upsell_space = 35;
        break;
      case 3:
        upsell_space = 30;
        break;
    };

    var content_swiper = !!document.querySelector('.tiered-swiper-container-dynamic') ? document.querySelector('.tiered-swiper-container-dynamic') : '';
    if (!!content_swiper) {
      var content_parent = !!content_swiper.closest('.hs-container-swp') ? content_swiper.closest('.hs-container-swp') : ''
      if (!!content_parent) {
        if (upsell_slide_per_view == 1) {
          if (!!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.remove('hs-upsell_multi_view')
          };
        } else {
          if (!content_parent.classList.contains('hs-upsell_multi_view')) {
            content_parent.classList.add('hs-upsell_multi_view')
          };
        }
      };
    };

    var parameters = {
      autoHeight: true,
      spaceBetween: 30,
      a11y: {//
        enabled: true,
        slideLabelMessage: '{{index}} of {{slidesLength}}'
      },
      loop: true,
      pagination: {
        el: ".hs-swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".hs-swiper-button-next",
        prevEl: ".hs-swiper-button-prev",
      },
      breakpoints: {
        400: {
          shortSwipes: true,
          slidesPerView: upsell_slide_per_view,
          spaceBetween: upsell_space,
        },
        0: {
          slidesPerView: upsell_slide_per_view == 3 ? 2 : upsell_slide_per_view,
          spaceBetween: upsell_space,
        }
      }
    };
    parameters = { ...parameters, ...upsell_autoplay };

    Hs_CartDrawer.swiper_tiered = new HS_Swiper(".tiered-swiper-container-dynamic", parameters);

    Hs_CartDrawer.initAccessibleSwiper(Hs_CartDrawer.swiper_tiered, content_swiper);
  },
  fetchingProd: async function (tiereds, result, arrHandles) {
    try {
      var prodFetch = [], tiered = slideData.settings.tiered_free_items_tiers, qualified = 0, unqualified = 0, z = 0, y = 0, arr_prod = [], index = [];
      var result2 = [], items = [], qty = 0, price = 0;

      function getItem(line_item, item) {
        return line_item.variant_id == item.variant_id && JSON.stringify(line_item.properties) === JSON.stringify(item.properties);
      }
      result.items.forEach(function (item) {
        if (item.properties === null || !item.properties._tiered) {
          items.push(item);
          qty += item.quantity;
          if (item.discounts.length > 0) {
            price += item.line_price;
          } else {
            price += item.price * item.quantity;
          }
        }
      });

      if (tiereds.length > 0) {
        for (let c = 0; c < tiered.length; c++) {
          tiered[c].product_in_cart = false
        };

        var calculate = 0, itemProcess = 0, shopifyRate = 1;
        switch (slideData.settings.tiered_free_items.tfi_calculate_based_on) {
          case 'cart_total_price':
            calculate = price / 100;
            if (HsApp1.checkoutPage !== '') {
              calculate = +HsApp1.checkoutPage.total_price;
            };
            if (typeof Shopify !== 'undefined') {
              if (typeof Shopify.currency !== 'undefined') {
                if (typeof Shopify.currency.rate !== 'undefined') {
                  if (+Shopify.currency.rate > 1 || +Shopify.currency.rate < 1) {
                    shopifyRate = +Shopify.currency.rate;
                  };
                };
              };
            };
            break;
          case 'cart_item_count':
            calculate = qty;
            break;
          case 'cart_paid_items_count':
            calculate = 0;
            if (items.length > 0) {
              items.forEach(function (item) {
                if (item.final_price == 0) {
                  calculate++;
                }
              });
              calculate = qty - calculate;
            };
            break;
        };
        for (let i = 0; i < tiereds.length; i++) {
          var amount = parseFloat(slideData.settings.tiered_free_items_tiers[i].tfi_tier_amount_from * shopifyRate);
          if (calculate >= amount) {
            slideData.settings.tiered_free_items_tiers[i].qualified = true;
          }
          else {
            slideData.settings.tiered_free_items_tiers[i].qualified = false;
          }
        };

        for (let c = 0; c < tiered.length; c++) {
          result.items.forEach(function (item) {
            if (item.properties !== null && typeof item.properties._tiered != undefined && !!item.properties._tiered) {
              // if (tiered[c].tfi_tier_products.indexOf(item.variant_id) > -1) {
              //   tiered[c].product_in_cart = true
              // };
              let products = Hs_normalizeTierProducts(tiered[c].tfi_tier_products);
              const result = products.find(product => product.variants.includes(String(item.variant_id)));
              if (result) {
                tiered[c].product_in_cart = true
              };
            }
          });
        };

        for (let x = 0; x < tiered.length; x++) {
          //var tfi_tier_products = JSON.parse(tiered[x].tfi_tier_products);
          var tfi_tier_products = Hs_normalizeTierProducts(tiered[x].tfi_tier_products);

          if (tfi_tier_products.length > 0) {
            for (let a = 0; a < tfi_tier_products.length; a++) {
              result.items.forEach(function (item) {//aqui
                if (!!tfi_tier_products[a]) {
                  /* if (tfi_tier_products[a].indexOf(item.id) > -1 && tfi_tier_products[a].indexOf(item.handle) > -1) {
                    if (item.price == 0) {
                      tfi_tier_products.splice(a, 1);
                    };
                  }; */
                  if (tfi_tier_products[a].variants.includes(String(item.id)) && tfi_tier_products[a].handle.includes(item.handle)) {
                    if (item.price == 0) {
                      tfi_tier_products.splice(a, 1);
                    };
                  };
                };
              });
            };

            for (let a = 0; a < tfi_tier_products.length; a++) {
              var value = tiered[x].tfi_tier_amount_from * shopifyRate;
              //var variants = tfi_tier_products[a].substring(tfi_tier_products[a].indexOf(':') + 1, tfi_tier_products[a].indexOf(':').length);
              var variants = tfi_tier_products[a].variants;
              var properties = tfi_tier_products[a].properties;
              //var handleProd = tfi_tier_products[a].substring(0, tfi_tier_products[a].indexOf(':'));
              var handleProd = tfi_tier_products[a].handle;
              y = 0;
              if (!!tiered[x].tfi_tier_max_item) {
                if (!!tiered[x].product_in_cart) {
                  y = 1;
                }
              };
              if (!!tiered[x].tfi_tier_hide_when_in_cart) {
                let incluyeVeinte = arrHandles.includes(handleProd);
                if (!!incluyeVeinte) {
                  y = 1;
                }
              }
              if (!!tiered[x].qualified) {
                if (qualified == slideData.settings.tiered_free_items.tfi_unlocked_limit) {
                  z = 1;
                }
              };
              if (!tiered[x].qualified) {
                if (unqualified == slideData.settings.tiered_free_items.tfi_locked_limit) {
                  z = 1;
                }
              };
              if (z == 0 && y == 0) {
                var product = Hs_CartDrawer.routeLocale(`products/${handleProd}.js`);
                await fetch(`${product}`, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then((response) => {
                    return response.ok ? response.json() : Promise.reject(response);
                  })
                  .then((json) => {
                    if (!!json.id) {
                      var arrVariants = [];
                      //var arrVariants2 = [];
                      if (json.variants.length > 0) {
                        json.variants.forEach(function (variant) {
                          if (!!variant.available) {
                            /* if (variants.indexOf(variant.id) > -1) {
                              arrVariants.push(variant)
                            }; */
                            if (variants.includes(String(variant.id))) {
                              arrVariants.push(variant);
                            };
                          };
                        });
                      };
                      json.properties = properties;
                      json.variants = arrVariants;
                      json.tieredName = tiered[x].tfi_tier_name;
                      json.tieredHide = tiered[x].tfi_tier_hide_in_cart || 0;

                      if (!!tiered[x].qualified) {
                        json.qualified = true;
                        tiered[x].text_unlock = '';
                        qualified++;
                      } else {
                        json.qualified = false;
                        unqualified++;
                        var progress = 0, amount = 0;
                        switch (slideData.settings.tiered_free_items.tfi_calculate_based_on) {
                          case 'cart_total_price':
                            progress = price / value;
                            amount = value * 100;
                            if (typeof slideData.settings.tiered_free_items.tfi_unlock_text_show !== 'undefined') {
                              if (!!slideData.settings.tiered_free_items.tfi_unlock_text_show) {
                                value = parseFloat(value) * 100;
                                amount = value - price;
                              };
                            };
                            amount = hsonslidecart.Currency.formatMoney(parseFloat(amount), slideData.settings.devices.money_format);
                            amount = slideData.settings.tiered_free_items.tfi_unlock_text.indexOf('{{amount}}') > -1 ? slideData.settings.tiered_free_items.tfi_unlock_text.replace('{{amount}}', amount) : slideData.settings.tiered_free_items.tfi_unlock_text + ' ' + amount;
                            break;
                          case 'cart_item_count':
                            progress = (qty * 100) / value;
                            amount = parseInt(value, 10);
                            if (typeof slideData.settings.tiered_free_items.tfi_unlock_text_show !== 'undefined') {
                              if (!!slideData.settings.tiered_free_items.tfi_unlock_text_show) {
                                //value = parseInt(value,10);
                                amount = parseInt(value, 10) - qty;
                              };
                            }
                            amount = slideData.settings.tiered_free_items.tfi_unlock_text.indexOf('{{amount}}') > -1 ? slideData.settings.tiered_free_items.tfi_unlock_text.replace('{{amount}}', amount) : slideData.settings.tiered_free_items.tfi_unlock_text + ' ' + amount;
                            break;
                          case 'cart_paid_items_count':
                            var count = qty;
                            amount = parseInt(value, 10);
                            if (items.length > 0) {
                              items.forEach(function (item) {
                                if (item.final_price == 0) {
                                  count--;
                                }
                              });
                              progress = (count * 100) / value;
                              if (typeof slideData.settings.tiered_free_items.tfi_unlock_text_show !== 'undefined') {
                                if (!!slideData.settings.tiered_free_items.tfi_unlock_text_show) {
                                  //value = parseInt(value,10);
                                  amount = parseInt(value, 10) - count;
                                };
                              }
                            };
                            amount = slideData.settings.tiered_free_items.tfi_unlock_text.indexOf('{{amount}}') > -1 ? slideData.settings.tiered_free_items.tfi_unlock_text.replace('{{amount}}', amount) : slideData.settings.tiered_free_items.tfi_unlock_text + ' ' + amount;
                            break;
                        };
                        tiered[x].text_unlock = amount
                        json.progress = Math.floor(progress);
                        json.value_amount = amount;
                      }
                      arr_prod.push(json)
                    };
                  })
                  .catch(err => {
                    z = 0, y = 0;
                    console.log(err);
                  })
              }
            }
          };
          z = 0, y = 0;
        };
      };
      if (z == 0 && y == 0) {
        var viewTiered = 1;
        try {
          if (typeof slideData.settings.tiered_free_items.tif_auto_add !== 'undefined') {
            if (!!slideData.settings.tiered_free_items.tif_auto_add) {
              if (arr_prod.length > 0) {
                var prodQualifiedAutoAdd = { items: [] }, viewTiered = 0;
                arr_prod.forEach(function (prod) {
                  if (prod.qualified !== null) {
                    if (!!prod.qualified) {
                      prod.variants.forEach(function (variant) {
                        if (!!variant.available) {
                          var x = 1;
                          result.items.forEach(function (item) {
                            if (item.id == variant.id) {
                              if (item.properties !== null) {
                                if (!!item.properties._tiered) {
                                  x = 0
                                };
                              }
                            };
                          });
                          if (x == 1) {
                            variant.price == 0 || (typeof window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] !== 'undefined' && window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] == 1) ? prodQualifiedAutoAdd.items.push({ quantity: 1, id: variant.id, properties: Object.assign(prod.properties, { '_tiered': prod.tieredName }) }) : '';//CAMBIO
                          };
                        };
                      });
                    };
                  };
                });

                if (prodQualifiedAutoAdd.items.length > 0) {
                  function prodAdd(prod, response) {
                    var prods = JSON.parse(JSON.stringify(prod))
                    if (!!response) {
                      if (response.items.length > 0) {
                        response.items.forEach(function (item) {
                          prodQualifiedAutoAdd.items.forEach(function (prod, index) {
                            if (item.id == prod.id) {
                              if (item.properties != null) {
                                if (!!item.properties._tiered) {
                                  prods.items.splice(index, 1);
                                };
                              };
                            };
                          });
                        });
                      };
                    };
                    return prods;
                  };
                  async function getCart() {
                    var cart = Hs_CartDrawer.routeLocale(`cart.js`);
                    return await fetch(`${cart}`,
                      {
                        method: "GET",
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                        },
                      })
                      .then((response) => response.status == 200 && response.json())
                      .then((response) => {
                        if (typeof window.BOLD !== 'undefined'
                          && typeof window.BOLD.common !== 'undefined'
                          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                          // NOTE: "cart" should be the variable containing the cart json data
                          response = window.BOLD.common.cartDoctor.fix(response);
                        };
                        return response;
                      })
                      .catch((error) => { console.log(error) });
                  };
                  async function tieredAutoAdd(response) {
                    var prods = prodAdd(prodQualifiedAutoAdd, response);
                    if (prods.items.length > 0) {
                      var cart_add = 'cart/add.js';
                      if (window.EasyGiftScriptLoaded) {
                        cart_add = cart_add + '?_easygift_internal=true'
                      };
                      var add = Hs_CartDrawer.routeLocale(cart_add);
                      await fetch(`${add}`, {
                        body: JSON.stringify(prods),
                        method: 'POST',
                        headers: {
                          'Accept': "application/json, text/javascript",
                          'Content-Type': "application/json, text/javascript",
                          'X-Requested-With': 'XMLHttpRequest'
                        },
                      }).then(function (response) {
                        return response.json();
                      }).then(function (json) {
                      }).catch(function (err) {
                        console.log(err);
                      }).then(function (e) {
                        HsApp1.getMyCart(0, 0);
                        HsApp3.getMyCart(1);
                      })
                    };
                  };

                  let isIntervalCleared = false;
                  const intervalId = setInterval(() => {
                    if (!Hs_CartDrawer.iniAddShipping && !isIntervalCleared) {
                      isIntervalCleared = true;
                      getCart().then(response => {
                        if (!!response) {
                          tieredAutoAdd(response);
                        }
                        clearInterval(intervalId);
                      }).catch(error => {
                        console.error("Error", error);
                        clearInterval(intervalId);
                      });
                    };
                  }, 500);
                  //getCart().then(response => !!response && tieredAutoAdd(response));
                }
                else {
                  viewTiered = 1;
                }
              };
            };
          };
        } catch (error) {
          viewTiered = 1;
          console.log(error)
        }
        if (!!viewTiered) {
          /*------------------*/
          var status_text_slide_cart = '';
          var show_qty_box_tiered = typeof slideData.settings.tiered_free_items.tfi_show_quantity_box !== 'undefined' ? slideData.settings.tiered_free_items.tfi_show_quantity_box : 0,
            mode_tiered = typeof slideData.settings.tiered_free_items.tfi_mode_view !== 'undefined' ? slideData.settings.tiered_free_items.tfi_mode_view : 1,
            noPopUp = typeof slideData.settings.tiered_free_items.tfi_mode_add_to_cart !== 'undefined' ? slideData.settings.tiered_free_items.tfi_mode_add_to_cart : 0;
          status_text_slide_cart = HsApp1.upsellProductsJson(show_qty_box_tiered, mode_tiered, 'tiered-swiper-container-dynamic', arr_prod, 'tiered', 1, noPopUp, '');
          //status_text_slide_cart = HsApp1.tieredFreeItmJSON(arr_prod);
          var mode = typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_mode_view : 0
          if (parseInt(mode)) {
            var hs_products_free_items = !!document.querySelector('.hs-products-free-items.hs-tiered') ? document.querySelector('.hs-products-free-items.hs-tiered') : '';
            if (!!hs_products_free_items) {
              hs_products_free_items.innerHTML = status_text_slide_cart;
            };
          } else {
            var hs_mode_dynamic = !!document.querySelector('.hs-mode-dynamic.hs-tiered') ? document.querySelector('.hs-mode-dynamic.hs-tiered') : '';
            if (!!hs_mode_dynamic) {
              hs_mode_dynamic.innerHTML = status_text_slide_cart;
            };
          };
          if (!status_text_slide_cart) {
            var tiered_content = !!document.querySelector('.hs-tiered_free_items') ? document.querySelector('.hs-tiered_free_items') : '';
            if (!!tiered_content) {
              tiered_content.style.display = 'none';
            };
          }
          else {
            var tiered_content = !!document.querySelector('.hs-tiered_free_items') ? document.querySelector('.hs-tiered_free_items') : '';
            if (!!tiered_content) {
              tiered_content.dataset.item = arr_prod.length;
              tiered_content.dataset.slide = `tieredSlider(${arr_prod.length})`;
              tiered_content.style.display = 'block';
              Hs_CartDrawer.starReviews('.hs-tiered_free_items');
              HsApp1.upsellAddToCartFreeShipping(0, 'tiered');
              HsApp1.upsellVariants();
              HsApp1.tieredSlider(arr_prod.length);
              HsApp1.progressCircleDesing(arr_prod);

              setTimeout(function () {
                eval('HsApp1.' + `tieredSlider(${arr_prod.length})`)
              }, 1200);

              HsApp1.currencyConverter();
            };
          };

          setTimeout(function () {
            var parentTiered = !!document.querySelector('.hs-tiered_free_items') ? document.querySelector('.hs-tiered_free_items') : '';
            if (!!parentTiered) {
              var itemTiered = !!parentTiered.querySelector('.hs-tiered') ? parentTiered.querySelector('.hs-tiered') : '';
              if (!!itemTiered) {
                var slide = itemTiered.querySelectorAll('.hs-swiper-slide').length > 0 ? itemTiered.querySelectorAll('.hs-swiper-slide') : [];
                if (slide.length > 0) {
                  slide.forEach(function (b) {
                    arr_prod.forEach(function (c, e) {
                      var d = !!b.querySelector(`.hs-locked-offer-progress-bar.hs-${c.id + '-' + c.tieredName.replace(/ /g, "").replace(/\((\d+)\)/g, "").replace('$', '')}`) ? b.querySelector(`.hs-locked-offer-progress-bar.hs-${c.id + '-' + c.tieredName.replace(/ /g, "").replace(/\((\d+)\)/g, "").replace('$', '')}`) : '';
                      if (!!d) {
                        d.querySelector('.hs-locked-offer-progress-made').style.width = `${!!arr_prod[e].qualified ? '100' : arr_prod[e].progress}%`;
                      }
                    })

                  })
                };
              };
            };
            HsApp1.currencyConverter();
          }, 100);

        };
      };
    } catch (error) {
      console.log(error)
    }

  },
  tieredFreeItemsProd: function (result, arrHandles) {
    try {
      if (result.items.length > 0) {
        arrHandles = [];
        if (typeof slideData.settings.tiered_free_items !== 'undefined') {
          if (!!slideData.settings.tiered_free_items.enabled_tiered_free_items) {
            if (slideData.settings.tiered_free_items_tiers.length > 0) {
              /*  */

              var hidden_all_tiers = 0;
              if (typeof slideData.settings.tiered_free_items.tfi_only_product_tier !== 'undefined') {
                hidden_all_tiers = slideData.settings.tiered_free_items.tfi_only_product_tier;
              };
              if (hidden_all_tiers) {
                var class_tiered = 0;
                var tiered = result.items.filter(item => item.properties ? item.properties['_tiered'] : []) || [];
                if (tiered.length > 0) {
                  class_tiered = 1;
                };
                var hs_body_layout = document.querySelector('.hs-body-layout') || '';
                if (hs_body_layout) {
                  var container_hs_tiered_free_items = hs_body_layout.querySelector('.hs-tiered_free_items') || '';
                  if (container_hs_tiered_free_items) {
                    switch (class_tiered) {
                      case 0:
                        container_hs_tiered_free_items.classList.remove('hs-hidden-tiered_free_items');
                        break;
                      case 1:
                        container_hs_tiered_free_items.classList.add('hs-hidden-tiered_free_items');
                        break;
                    };
                  };
                };

              };
              /*  */
              var tiereds = []
              slideData.settings.tiered_free_items_tiers.forEach(function (items) {
                tiereds.push(Hs_normalizeTierProducts(items.tfi_tier_products))
              });
              var result2 = [], items = [], qty = 0, price = 0;
              result.items.forEach(function (item) {
                if (item.properties != null && !!item.properties._tiered) {
                  arrHandles.push(item.handle)
                };
                if (item.properties === null || !item.properties._tiered) {
                  items.push(item);
                  qty += item.quantity
                  if (item.discounts.length > 0) {
                    price += item.line_price;
                  } else {
                    price += item.price * item.quantity;
                  };
                };
              });
              var calculate = 0, itemProcess = 0, thisTiered = [], idunqualified = [], shopifyRate = 1;
              switch (slideData.settings.tiered_free_items.tfi_calculate_based_on) {
                case 'cart_total_price':
                  calculate = price / 100;

                  if (HsApp1.checkoutPage !== '') {
                    calculate = +HsApp1.checkoutPage.total_price;
                  };

                  if (typeof Shopify !== 'undefined') {
                    if (typeof Shopify.currency !== 'undefined') {
                      if (typeof Shopify.currency.rate !== 'undefined') {
                        if (+Shopify.currency.rate > 1 || +Shopify.currency.rate < 1) {
                          shopifyRate = +Shopify.currency.rate
                        };
                      };
                    };
                  };
                  break;
                case 'cart_item_count':
                  calculate = qty;
                  break;
                case 'cart_paid_items_count':
                  calculate = 0;
                  if (items.length > 0) {
                    items.forEach(function (item) {
                      if (item.final_price == 0) {
                        calculate++
                      }
                    });
                    calculate = qty - calculate
                  };
                  break;
              };
              for (let i = 0; i < tiereds.length; i++) {
                var amount = parseFloat(slideData.settings.tiered_free_items_tiers[i].tfi_tier_amount_from * shopifyRate);
                if (calculate >= amount) {
                  //thisTiered.push({qualified:true})
                  slideData.settings.tiered_free_items_tiers[i].qualified = true;
                }
                else {
                  //thisTiered.push({qualified:false})
                  thisTiered.push(i)
                  slideData.settings.tiered_free_items_tiers[i].qualified = false;
                }
              };

              if (thisTiered.length > 0) {
                result.items.forEach(function (item) {
                  slideData.settings.tiered_free_items_tiers.forEach(function (mytiered) {
                    if (!mytiered.qualified) {
                      if (item.properties !== null && typeof item.properties._tiered != undefined && !!item.properties._tiered) {
                        if (mytiered.tfi_tier_products.indexOf(item.variant_id) > -1) {
                          idunqualified.push(item.key)
                        }
                      };
                    }
                  })
                });
                //return false;
              };
              if (idunqualified.length > 0) {
                var elementsProperties = ['_giftWrap', '_shippingProtection'];
                var myJSON = {};
                var ini = 0;
                var textConcat = '';
                idunqualified.forEach(function (ids) {
                  textConcat = textConcat + `"${ids}":"0",`
                })
                textConcat = textConcat.substring(0, textConcat.length - 1);

                var formData = JSON.parse(`{"updates":{${textConcat}}}`);

                var cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
                var mwgrouped = Hs_CartDrawer.mwgrouped();
                HsApp1.disableCheckout(1);//CAMBIO
                let info = fetch(`${cart}${mwgrouped}`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
                }).then(function (response) {
                  return response.ok ? response.json() : Promise.reject(response);
                }).then(function (data) {
                  if (typeof window.BOLD !== 'undefined'
                    && typeof window.BOLD.common !== 'undefined'
                    && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                    // NOTE: "cart" should be the variable containing the cart json data
                    data = window.BOLD.common.cartDoctor.fix(data);
                  }
                  myJSON = JSON.parse(JSON.stringify(data));
                  /* var shipping = false;
                  if (data.items.length == 1) {
                    if (!!data.items[0].properties) {
                      if (!!data.items[0].properties._shippingProtection) {
                        var arr_variants = JSON.stringify({ id: data.items[0].key, quantity: 0 })
                        HsApp1.onloadCart('', arr_variants, 0, '', undefined)
                      };
                    };
                  }
                  if (!shipping) {
                    if (elementsProperties.length > 0) {
                      elementsProperties.forEach(function (element) {
                        ini++
                        data = HsApp1.thisProperties(data, element);
                      })
                    };
                    if (ini == elementsProperties.length) {
                      HsApp1.cartPrice = data.total_price;
                      HsApp1.updateCart(data, myJSON, 1);
                      HsApp1.priceCart(data);
                      HsApp3.countCart(data);
                      HsApp1.currencyConverter();
                      HsApp1.hideCartPopup();
                      HsApp1.plusMin();
                      HsApp1.clearALL();
                      HsApp1.removeItemCart();
                      HsApp1.changeQuantityCart();
                      HsApp1.clearALL();
                      HsApp1.startDiscount();
                      HsApp1.rechargeCartElement();
                    };
                  }; */
                  HsApp1.getMyCart(0, '', '', 0);
                }).catch((error) => {
                  console.error('Error:', error);
                  /* HsApp1.cartPrice = result.total_price;
                  HsApp1.updateCart(result, result, 0);
                  HsApp1.priceCart(result);
                  HsApp3.countCart(result);
                  HsApp1.currencyConverter();
                  HsApp1.hideCartPopup(); */
                  HsApp1.getMyCart(0, '', '', 1);
                }).then((e) => {
                  if (typeof window.BOLD !== 'undefined'
                    && typeof window.BOLD.common !== 'undefined'
                    && typeof window.BOLD.common.eventEmitter !== 'undefined'
                    && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
                    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', myJSON);
                  }
                });
              }
              else {
                HsApp1.fetchingProd(tiereds, result, arrHandles);
              };

            }
          }
        }
      };
    } catch (error) {
      console.log(error)
    }
  },
  dynamicUpsellView: function (arrUpsell, handleProd, condition, result_item) {
    arrUpsell = arr = HsApp4.removeDuplicates(arrUpsell, 'handle');
    arrUpsell = HsApp1.validateUpsell(arrUpsell, handleProd, condition, 'manually');
    var status_text_slide_cart = '', show_only_product_variant_in_stock = 1, hs_cross_sell = !!document.querySelector('.hs-cross-sell') ? document.querySelector('.hs-cross-sell') : '',
      noPopUp = typeof slideData.settings.manually_products_upsells.mode_add_to_cart_manually !== 'undefined' ? slideData.settings.manually_products_upsells.mode_add_to_cart_manually : 0;
    status_text_slide_cart = HsApp1.upsellProductsJson(parseInt(slideData.settings.additional_settings.show_quantity_box_upsells), parseInt(slideData.settings.manually_products_upsells.mode_upsell_manually), 'swiper-container-dynamic', arrUpsell, 'manually', show_only_product_variant_in_stock, noPopUp, result_item);
    if (!!hs_cross_sell) {
      hs_cross_sell.style.display = 'none';
      if (status_text_slide_cart) {
        if (parseInt(slideData.settings.manually_products_upsells.mode_upsell_manually)) {
          var hs_products_dynamic_stacked = !!hs_cross_sell.querySelector('.hs-products-dynamic-stacked') ? hs_cross_sell.querySelector('.hs-products-dynamic-stacked') : '';
          if (!!hs_products_dynamic_stacked) {
            hs_products_dynamic_stacked.innerHTML = status_text_slide_cart;
          };
        } else {
          var hs_mode_dynamic = !!hs_cross_sell.querySelector('.hs-mode-dynamic') ? hs_cross_sell.querySelector('.hs-mode-dynamic') : '';
          if (!!hs_mode_dynamic) {
            hs_mode_dynamic.innerHTML = status_text_slide_cart;
          };
        };
        hs_cross_sell.dataset.item = arrUpsell.length;
        hs_cross_sell.style.display = 'block';
        hs_cross_sell.dataset.slide = `swiperDynamicHSCart('upsell',${arrUpsell.length})`;
        Hs_CartDrawer.starReviews('.hs-cross-sell');
        HsApp1.swiperDynamicHSCart('upsell', arrUpsell.length);
        HsApp1.upsellNoPopUp();
        HsApp1.upsellVariants();
        HsApp1.upsellAddToCartFreeShipping(condition, 'manually', result_item);
        HsApp1.currencyConverter();
      };
    };
  },
  dynamicUpsell: async function (handleProd, result_item = []) {
    try {
      if (!parseInt(slideData.settings.manually_products_upsells.enabled_product_manually)) {
        return false;
      };

      var hs_cross_sell = !!document.querySelector('.hs-cross-sell') ? document.querySelector('.hs-cross-sell') : '';
      if (handleProd.length == 0) {
        if (!!hs_cross_sell) {
          hs_cross_sell.style.display = 'none';
        };
        //return false;
      } else {
        var arrProducts = [], arrHandles = [], arrRows = 0, arrCollection = [], arrRowsCol = 0;
        var result_handle = handleProd.length > 1 ? HsApp1.unique(handleProd) : handleProd;

        let dataUpsell = JSON.parse(JSON.stringify(slideData.upsell));

        dataUpsell = dataUpsell.filter(upsell => upsell.upsell_enabled == 1); // FILTER ENABLED UPSELL

        function includeHandle(result_handle = [], products_in_cart = []) {
          let result = 0;
          if (products_in_cart.length > 0 && result_handle.length > 0) {
            products_in_cart.forEach(function (prodDb) {
              var text_variant = prodDb.indexOf('?variant');
              if (text_variant > -1) {
                prodDb = prodDb.substring(text_variant, 0)
              };
              if (result_handle.includes(prodDb)) {
                result = 1;
              }
            })
          };
          return result;
        }; //CHECK IF THE CART HANDLES ARE IN THE CONFIGURATION

        dataUpsell.forEach(function (upsell, i) {
          upsell.available = false;
          upsell.upsell_products_in_cart = upsell.upsell_products_in_cart.split(',');
          var result = includeHandle(result_handle, upsell.upsell_products_in_cart) || 0;
          let upsell_plan = upsell.upsell_selling_plan_rule ?? 2;

          if (upsell_plan == 0 || upsell_plan == 1) {
            const resultados = upsell.upsell_products_in_cart
              .map(item_1 => result_item.find(item_2 => item_2.handle === item_1))
              .filter(item => item !== undefined);

            const resultadosConSellingPlan = resultados.filter(item =>
              item.selling_plan_allocation && Object.keys(item.selling_plan_allocation).length > 0
            );

            if (upsell_plan == 0 && resultadosConSellingPlan.length > 0) {
              result = 0;
            }
            if (upsell_plan == 1 && resultadosConSellingPlan.length == 0) {
              result = 0;
            }
          };

          if (result == 1) {
            upsell.available = true;

            if (upsell.upsell_specific === 'product') {
              let upsell_these_products = [];
              upsell.upsell_these_products = upsell.upsell_these_products.split(',');

              upsell.upsell_these_products.forEach(function (rows) {
                let text_variant = rows.indexOf('?variant');
                if (text_variant > -1) {
                  rows = rows.substring(0, text_variant); // corregido
                }
                rows = rows.trim();
                let inCart = result_handle.includes(rows); // simplificado
                if (!inCart) {
                  upsell_these_products.push(rows);
                }
              });

              if (upsell_these_products.length > 0) {
                arrRows += upsell_these_products.length; // suma real
                upsell.upsell_these_products = upsell_these_products;
              } else {
                upsell.available = false; // ocultar si no queda nada
              }

            } else if (upsell.upsell_specific === 'collection') {
              upsell.upsell_these_collections = upsell.upsell_these_collections.split(',');

              upsell.upsell_these_collections = upsell.upsell_these_collections.map(function (rows) {
                let text_variant = rows.indexOf('?variant');
                if (text_variant > -1) {
                  rows = rows.substring(0, text_variant);
                }
                return rows.trim();
              }).filter(Boolean);

              if (upsell.upsell_these_collections.length > 0) {
                arrRowsCol += upsell.upsell_these_collections.length;
              } else {
                upsell.available = false;
              }
            }
          };
        });

        dataUpsell = dataUpsell.filter(item => item.available == true);

        if (arrRowsCol > 0 || arrRows > 0) {
          let upsell_processed = 0;
          for (const upsell of dataUpsell) {
            let arrRowsColl = [], arrRows = [];
            if (upsell.upsell_specific === "collection") {
              let upsell_collections = upsell.upsell_these_collections;
              try {
                await window.getShopifyDataByHandles({
                  handles: upsell_collections,
                  type: 'collection'
                })
                  .then(products => {
                    upsell_processed++;
                    products.map((prod) => {
                      prod.upsell_specific = "collection";
                    });
                    arrRowsColl = products;
                    upsell.upsell_these_collections = arrRowsColl;

                  });
              } catch (error) {
                upsell_processed++;
                upsell.upsell_these_collections = [];
                console.log(error)
              }
            } else {
              let upsell_products = upsell.upsell_these_products;
              try {
                await window.getShopifyDataByHandles({
                  handles: upsell_products,
                  type: 'product'
                })
                  .then(products => {
                    upsell_processed++;
                    arrRows = products;
                    upsell.upsell_these_products = arrRows;
                  });
              } catch (error) {
                upsell_processed++;
                upsell.upsell_these_products = [];
                console.log(error)
              }
            };
            if (upsell_processed == dataUpsell.length) {
              let random_groups = slideData.settings.manually_products_upsells.random_groups_manually || 0;
              if (!!random_groups) {
                dataUpsell = Hs_CartDrawer.randomArray(dataUpsell);
              };

              let data = dataUpsell.reduce((totalUpsell, upsell) => {
                let upsells = upsell.upsell_specific === "collection" ? upsell.upsell_these_collections : upsell.upsell_these_products;

                let random_products = slideData.settings.manually_products_upsells.random_products_manually || 0;
                if (!!random_products) {
                  upsells = Hs_CartDrawer.randomArray(upsells);
                };


                return totalUpsell.concat(upsells);
              }, []);

              result_item = result_item[0] || '';
              HsApp1.dynamicUpsellView(data, handleProd, '', result_item);
            };
          };
        };

        if ((arrRowsCol < 1 && arrRows < 1) || slideData.upsell.length < 1) {
          var hs_container_dynamic_stacked = !!document.querySelector('.hs-container-dynamic-stacked.hs-cross-sell') ? document.querySelector('.hs-container-dynamic-stacked.hs-cross-sell') : '';
          if (!parseInt(slideData.settings.manually_products_upsells.mode_upsell_manually)) {
            hs_container_dynamic_stacked = !!document.querySelector('.hs-container-swp.hs-cross-sell') ? document.querySelector('.hs-container-swp.hs-cross-sell') : '';
          };
          if (!!hs_container_dynamic_stacked) {
            hs_cross_sell.style.display = 'none';
            if (!!slideData.settings.manually_products_upsells.cross_upsell_groups_manually) {
              let fetchParams = {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              };
              var arrCross = [], arrCrossUpsell = [];
              var collections = Hs_CartDrawer.routeLocale(`collections/all/products.json?limit=250`);
              fetch(`${collections}`, fetchParams).then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
              }).then((json) => {
                if (!!json.products) {
                  let arr_collection = HsApp1.hiddenProd(json.products);
                  arr_collection.map((arr_coll) => {
                    arr_coll.upsell_specific = "collection";
                  });
                  arrCross.push(arr_collection);
                };
                arrCross.forEach(function (vals) {
                  vals.forEach(function (val) {
                    arrCrossUpsell.push(val)
                  })
                });
                let random_products = slideData.settings.manually_products_upsells.random_products_manually || 0;
                if (!!random_products) {
                  arrCrossUpsell = Hs_CartDrawer.randomArray(arrCrossUpsell);
                };
                result_item = result_item[0] || '';
                HsApp1.dynamicUpsellView(arrCrossUpsell, handleProd, 'collection', result_item);
              })
                .catch(err => {
                  console.log(err);
                })
                .then(function () {
                  HsApp1.currencyConverter();
                });
            }
          }
        };
      };
    } catch (error) {
      console.log(error)
    };
  },
  hiddenProd: function (arrProducts) {//exclude products with tag // 'HS_HIDDEN_PRODUCT_UPSELL'
    var products = [], count = 0;
    if (arrProducts.length > 0) {
      arrProducts.forEach(product => {
        count++;
        if (!product.tags.includes('HS_HIDDEN_PRODUCT_UPSELL')) {
          products.push(product)
        }
      });
    }
    if (count == arrProducts.length) {
      return products;
    };
  },
  upsellAutomaticProducts: function (handles, result) {
    if (!parseInt(slideData.settings.product_recommendations_settings.enabled_product_recommendations)) {
      return false;
    };
    if (result.items.length == 0) {
      return false;
    };
    if (result.items[0].product_id === null) {
      return false;
    };
    var recommendations = Hs_CartDrawer.routeLocale(`recommendations/products.json?product_id=${result.items[0].product_id}&limit=250`);
    fetch(`${recommendations}`, {
      headers: {
        'Accept': "application/json, text/javascript",
        'Content-Type': "application/json, text/javascript",
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(response => {
      return response.ok ? response.json() : Promise.reject(response);
    }).then(({ products }) => {
      var hs_automatic_recommend = !!document.querySelector('.hs-automatic-recommend') ? document.querySelector('.hs-automatic-recommend') : '';
      if (products.length > 0) {
        let random_products = slideData.settings.product_recommendations_settings.random_products_automatic || 0;
        if (!!random_products) {
          products = Hs_CartDrawer.randomArray(products);
        };
        products = HsApp1.hiddenProd(products);
        var latestProduct = {};
        if (typeof result !== 'undefined') {
          if (typeof result.items !== 'undefined') {
            if (result.items.length > 0) {
              latestProduct = result.items[0]
            };
          };
        };
        products = HsApp1.validateUpsell(products, handles, 0, 'automatic', latestProduct);
        var status_text_slide_cart = '', show_only_product_variant_in_stock = 1, noPopUp = typeof slideData.settings.product_recommendations_settings.mode_add_to_cart_automatic !== 'undefined' ? slideData.settings.product_recommendations_settings.mode_add_to_cart_automatic : 0;
        status_text_slide_cart = HsApp1.upsellProductsJson(parseInt(slideData.settings.additional_settings.show_quantity_box_upsells), parseInt(slideData.settings.product_recommendations_settings.mode_upsell_automatic), 'swiper-container-automatic', products, 'automatic', show_only_product_variant_in_stock, noPopUp, result.items[0]);
        if (!!hs_automatic_recommend) {
          hs_automatic_recommend.style.display = 'none';
          if (status_text_slide_cart != '') {
            if (parseInt(slideData.settings.product_recommendations_settings.mode_upsell_automatic)) {
              var hs_products_dynamic_stacked = !!hs_automatic_recommend.querySelector('.hs-products-dynamic-stacked') ? hs_automatic_recommend.querySelector('.hs-products-dynamic-stacked') : '';
              if (!!hs_products_dynamic_stacked) {
                hs_products_dynamic_stacked.innerHTML = status_text_slide_cart;
              };
            } else {
              var hs_mode_dynamic = !!hs_automatic_recommend.querySelector('.hs-mode-dynamic') ? hs_automatic_recommend.querySelector('.hs-mode-dynamic') : '';
              if (!!hs_mode_dynamic) {
                hs_mode_dynamic.innerHTML = status_text_slide_cart;
              }
            };
            hs_automatic_recommend.dataset.item = products.length;
            hs_automatic_recommend.style.display = 'block';
            hs_automatic_recommend.dataset.slide = `swiperAutomaticProductsHSCart(${products.length})`;
            Hs_CartDrawer.starReviews('.hs-automatic-recommend');
            HsApp1.swiperAutomaticProductsHSCart(products.length);
            HsApp1.currencyConverter();
          }
        };
      } else {
        hs_automatic_recommend.style.display = 'none';
      };
    })
      .catch(err => {
        console.log(err)
      }).then(function () {
        HsApp1.upsellNoPopUp();
        HsApp1.upsellVariants();
        HsApp1.upsellAddToCartFreeShipping(0, 'automatic', result.items[0]);
      });
  },
  manuallyRecommendedProducts: function (result, dataUpsell) {
    if (result.length > 0) {
      result = HsApp1.unique(result);
    }
    var arr = [];
    if (dataUpsell) {
      dataUpsell.forEach(function (item) {
        var empty = 1;
        result.forEach(function (h) {
          if (item === h) {
            empty = 0
          }
        });
        if (empty) {
          arr.push(item);
        };
      });
    };
    return arr;
  },
  staticUpsell: async function (arrHandles, result_item) {
    if (typeof slideData.settings.static_products_upsells !== 'undefined') {
      if (!!slideData.settings.static_products_upsells.enabled_static_products_upsell) {

        const upsell_type = typeof slideData.settings.static_products_upsells.upsell_type_static !== 'undefined' ? slideData.settings.static_products_upsells.upsell_type_static : 0;
        const random_products = slideData.settings.static_products_upsells.random_products_static || 0;

        function genereUpsell(arrProds) {
          var hs_static_recommend = !!document.querySelector('.hs-recommend-products') ? document.querySelector('.hs-recommend-products') : '';
          if (!!hs_static_recommend) {
            hs_static_recommend.style.display = 'none';
          };
          if (arrProds.length > 0) {
            var products = HsApp1.hiddenProd(arrProds);
            products = HsApp1.validateUpsell(products, arrHandles, 0, 'static');
            if (typeof products !== 'undefined') {

              if (products.length > 0) {
                var status_text_slide_cart = '', show_only_product_variant_in_stock = 1, noPopUp = typeof slideData.settings.static_products_upsells !== 'undefined' ? typeof slideData.settings.static_products_upsells.mode_add_to_cart_static !== 'undefined' ? slideData.settings.static_products_upsells.mode_add_to_cart_static : 0 : 0;

                status_text_slide_cart = HsApp1.upsellProductsJson(parseInt(slideData.settings.additional_settings.show_quantity_box_upsells), typeof slideData.settings.static_products_upsells !== 'undefined' ? parseInt(slideData.settings.static_products_upsells.mode_upsell_static) : 0, 'swiper-container-recommend', products, 'static', show_only_product_variant_in_stock, noPopUp, result_item);
                if (!!hs_static_recommend) {
                  if (status_text_slide_cart !== '') {
                    if (typeof slideData.settings.static_products_upsells !== 'undefined') {
                      if (parseInt(slideData.settings.static_products_upsells.mode_upsell_static)) {
                        var hs_products_stacked = !!hs_static_recommend.querySelector('.hs-products-stacked ') ? hs_static_recommend.querySelector('.hs-products-stacked ') : '';
                        if (!!hs_products_stacked) {
                          hs_products_stacked.innerHTML = status_text_slide_cart;
                        };
                      } else {
                        var hs_mode_static = !!hs_static_recommend.querySelector('.hs-mode-dynamic') ? hs_static_recommend.querySelector('.hs-mode-dynamic') : '';
                        if (!!hs_mode_static) {
                          hs_mode_static.innerHTML = status_text_slide_cart;
                        }
                      };
                    }
                    hs_static_recommend.dataset.item = products.length;
                    hs_static_recommend.dataset.slide = `swiperStaticHSCart(${products.length})`;
                    hs_static_recommend.style.display = 'block';
                    HsApp1.swiperStaticHSCart(products.length);
                    Hs_CartDrawer.starReviews('.hs-recommend-products');
                    HsApp1.upsellNoPopUp();
                    HsApp1.upsellVariants();
                    HsApp1.upsellAddToCartFreeShipping('', 'static', result_item);
                    HsApp1.currencyConverter();
                    Hs_CartDrawer.focusOnItemsCart();
                  }
                }
              };
            };
          };
        };

        switch (upsell_type) {
          case 0:
            var handlesStatic = slideData.settings.static_products_upsells.list_products_static.split(',');
            if (handlesStatic.length > 0) {
              if (!!random_products) {
                handlesStatic = Hs_CartDrawer.randomArray(handlesStatic);
              };
              var manually_recommended_products = HsApp1.manuallyRecommendedProducts(arrHandles, handlesStatic);
              if (manually_recommended_products.length > 0) {
                var arr_products = [];
                try {
                  await window.getShopifyDataByHandles({
                    handles: manually_recommended_products,
                    type: 'product'
                  }).then(products => {
                    arr_products = products || [];
                    arr_products = arr_products.slice(0, slideData.settings.static_products_upsells.maximum_items_suggest_static);
                    genereUpsell(arr_products);
                  });
                } catch (error) {
                  arr_products = [];
                  console.log(error)
                }

              };

              if (manually_recommended_products.length == 0 || arr_products.length == 0) {
                var hs_static_recommend = !!document.querySelector('.hs-recommend-products') ? document.querySelector('.hs-recommend-products') : '';
                if (!!hs_static_recommend) {
                  hs_static_recommend.style.display = 'none';
                }
              }
            };
            break;
          case 1:
            if (typeof slideData.settings.static_products_upsells.list_collections_static !== 'undefined' && slideData.settings.static_products_upsells.list_collections_static !== '') {
              var collectionsStatic = slideData.settings.static_products_upsells.list_collections_static.split(',');
              var arr_prodUpsell = [];
              if (collectionsStatic.length > 0) {
                try {
                  await window.getShopifyDataByHandles({
                    handles: collectionsStatic,
                    type: 'collection'
                  }).then(products => {
                    arr_prodUpsell = products
                    if (random_products) {
                      arr_prodUpsell = Hs_CartDrawer.randomArray(products)
                    };
                    // eliminar duplicados
                    arr_prodUpsell = HsApp1.unique(arr_prodUpsell);
                    if (arr_prodUpsell.length > 0) {
                      genereUpsell(arr_prodUpsell);
                    };
                  });
                } catch (error) {
                  arr_prodUpsell = [];
                  console.log(error)
                }
              };
              if (collectionsStatic.length == 0 || arr_prodUpsell.length == 0) {
                var hs_static_recommend = !!document.querySelector('.hs-recommend-products') ? document.querySelector('.hs-recommend-products') : '';
                if (!!hs_static_recommend) {
                  hs_static_recommend.style.display = 'none';
                };
              }
            };
            break;
        };
      }
    }
  },
  caseMinimumOrder: function (total_price = 0, item_count = 0) {
    var min = 0;
    var arr_minimum = { hidden_min_price: '', status_price_checkout: '', hidden_text_cart: '' };
    var text_extract = slideData.settings.minimum_order.minimum_order_text.indexOf("{{ money }}") > -1 ? "{{ money }}" : ''
    text_extract = text_extract === '' ? slideData.settings.minimum_order.minimum_order_text.indexOf("{{ amount }}") > -1 ? "{{ amount }}" : "" : text_extract;
    if (!!slideData.settings.minimum_order.enabled_minimum_order) {
      if (!!HsApp1.readCookie('hs-giftWrap-variantPrice')) {
        total_price += +(HsApp1.readCookie('hs-giftWrap-variantPrice'));
        item_count += 1;
      };
      switch (Hs_CartDrawer.minimum_order_option) {
        case 0://AMOUNT
          min = parseFloat(slideData.settings.minimum_order.minimum_order) * 100;
          if (total_price < min) {
            arr_minimum.hidden_min_price = ' hs-hidden-min-price';
            min = hsonslidecart.Currency.formatMoney(min, slideData.settings.devices.money_format);
            arr_minimum.status_price_checkout = text_extract !== '' ? slideData.settings.minimum_order.minimum_order_text.replace(text_extract, min) : slideData.settings.minimum_order.minimum_order_text;
          } else {
            arr_minimum.hidden_text_cart = ' hs-hidden-min-price';
          }
          break;
        case 1://QTY
          min = parseInt(slideData.settings.minimum_order.minimum_order);
          if (item_count < min) {
            arr_minimum.hidden_min_price = ' hs-hidden-min-price';
            arr_minimum.status_price_checkout = text_extract !== '' ? slideData.settings.minimum_order.minimum_order_text.replace(text_extract, min) : slideData.settings.minimum_order.minimum_order_text;
          } else {
            arr_minimum.hidden_text_cart = ' hs-hidden-min-price';
          }
          break;
      };
    };
    return arr_minimum;
  },
  buildCart: function (cart) {
    return false;
    // _HsHandlebars.js cart layout
    var items = [], item = {}, data = {};
    var CompareTotal = 0;
    var TotalSaving = 0;
    var count = 0;
    var TotalDiscount = 0;
    // Add each item to our _HsHandlebars.js data

    if (cart.cart_level_discount_applications.length !== 0) {
      for (var cartDiscount in cart.cart_level_discount_applications) {
        var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount || cart.cart_level_discount_applications[cartDiscount].amount;
        TotalDiscount = TotalDiscount + cartAmount;
        cart.cart_level_discount_applications[cartDiscount].formattedAmount = hsonslidecart.Currency.formatMoney(cartAmount, slideData.settings.devices.money_format);
      }
    };

    cart.items.forEach(function (cartItem, index) {
      var prodImg;
      var unitPrice = null;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }


      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;
          TotalSaving = TotalSaving + amount;
          cartItem.line_level_discount_allocations[discount].formattedAmount = hsonslidecart.Currency.formatMoney((amount / cartItem.quantity), slideData.settings.devices.money_format);
        }
      }


      var varID = cartItem.variant_id; // needed to find right variant from ajax results
      var comparePrice = '';
      var sale = false;
      var product = Hs_CartDrawer.routeLocale(`products/${cartItem.handle}.js`);
      fetch(`${product}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      }).then((product) => {
        count++;
        let variants = product.variants || [];

        product.variants.forEach(function (variant) {
          if (variant.id == varID && variant.compare_at_price !== 0) {
            comparePrice = variant.compare_at_price;
            return false;
          };
        });
      }).catch(err => {
        count++;
        console.error(err);
      }).then(e => {
        var itemPrice = cartItem.original_line_price / cartItem.quantity; //price of item
        var priceUnitAmount = cartItem.final_line_price / cartItem.quantity; //price after discount per unit
        var TotalcomparePrice = '';

        if (comparePrice == null || comparePrice < 1) {
          CompareTotal = CompareTotal + (itemPrice * cartItem.quantity);
          comparePrice = '';
        } else {
          if (comparePrice > itemPrice) {
            sale = true;
            TotalcomparePrice = cartItem.quantity * comparePrice;
            CompareTotal = CompareTotal + TotalcomparePrice;
            TotalSaving = TotalSaving + (TotalcomparePrice - cartItem.original_line_price);
            comparePrice = hsonslidecart.Currency.formatMoney(
              comparePrice,
              slideData.settings.devices.money_format
            );
          }
          else {
            CompareTotal = CompareTotal + (itemPrice * cartItem.quantity);
          }
        }

        var discountUnitAmount = itemPrice - priceUnitAmount; //amount of discount per unit

        // Create item's data object and add to 'items' array
        item = {
          key: cartItem.key,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: hsonslidecart.Currency.formatMoney(cartItem.price, slideData.settings.devices.money_format),
          priceQty: hsonslidecart.Currency.formatMoney(cartItem.original_line_price, slideData.settings.devices.money_format),
          comparePrice: comparePrice,
          priceUnitAmount: hsonslidecart.Currency.formatMoney(priceUnitAmount, slideData.settings.devices.money_format),
          discountUnitAmount: hsonslidecart.Currency.formatMoney(discountUnitAmount, slideData.settings.devices.money_format),
          discountedPrice: hsonslidecart.Currency.formatMoney(
            cartItem.final_line_price,
            slideData.settings.devices.money_format
          ),
          discounts: cartItem.line_level_discount_allocations,
          discountsApplied:
            cartItem.line_level_discount_allocations.length === 0 ? false : true,
          vendor: cartItem.vendor,
          unitPrice: unitPrice,
          sale: sale,
          itemPrice: itemPrice,
          comparePrice: comparePrice,  //Compare at Price of Item
          TotalcomparePrice: hsonslidecart.Currency.formatMoney(  //Compare at Price of Item * Quantity
            TotalcomparePrice,
            slideData.settings.devices.money_format),
          linePrice: hsonslidecart.Currency.formatMoney(  //Sale Price of Item * quantity
            cartItem.final_line_price,
            slideData.settings.devices.money_format
          ),
          originalLinePrice: hsonslidecart.Currency.formatMoney(
            cartItem.original_line_price,
            slideData.settings.devices.money_format
          )
        };
        items.push(item);
        if (count == cart.items.length) {

          data = {
            items: items,
            note: cart.note,
            totalPrice: hsonslidecart.Currency.formatMoney(
              cart.total_price,
              slideData.settings.devices.money_format
            ),
            compareTotalSpan: hsonslidecart.Currency.formatMoney(
              !!HsApp1.readCookie('hs-giftWrap-variantPrice') ? CompareTotal + (slideData.settings.gift_wrap.offer_compare_price * 100 || 0) : CompareTotal,
              slideData.settings.devices.money_format
            ),
            TotalSavingSpan: (TotalSaving > 0 ? '<span>-</span>' : '') + hsonslidecart.Currency.formatMoney(
              !!HsApp1.readCookie('hs-giftWrap-variantPrice') ? TotalSaving + (slideData.settings.gift_wrap.offer_compare_price * 100 - (+HsApp1.readCookie('hs-giftWrap-variantPrice')) || 0) : TotalSaving,
              slideData.settings.devices.money_format
            ),
            TotalDiscountSpan: (TotalDiscount > 0 ? '<span>-</span>' : '') + hsonslidecart.Currency.formatMoney(
              TotalDiscount,
              slideData.settings.devices.money_format
            ),
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied:
              cart.cart_level_discount_applications.length === 0 ? false : true
          };
          var content_total_save = document.querySelector('.hs-content-total-save') || '';

          if (!!data.TotalSavingSpan) {
            if (!!content_total_save) {
              content_total_save.style.display = '';
            };
          } else {
            if (!!content_total_save) {
              content_total_save.style.display = 'none';
            };
          };

          var hs_content_additional = document.querySelector('.hs-content-additional') || '';
          if (!!hs_content_additional) {
            //var elements_footer_cart = `.hs-save,.hs-original-price`;
            hs_content_additional.querySelectorAll('.hs-skeleton').forEach(function (element) {
              element.classList.remove('hs-skeleton');
            });

            !!hs_content_additional.querySelector('.hs_original_price') ? hs_content_additional.querySelector('.hs_original_price').innerHTML = data.compareTotalSpan : '';
            !!hs_content_additional.querySelector('.hs-total-original-price-global') ? hs_content_additional.querySelector('.hs-total-original-price-global').value = CompareTotal : '';
            !!hs_content_additional.querySelector('.hs_total_save') ? hs_content_additional.querySelector('.hs_total_save').innerHTML = data.TotalSavingSpan : '';
            !!hs_content_additional.querySelector('.hs-total-save-global') ? hs_content_additional.querySelector('.hs-total-save-global').value = TotalSaving : '';
            !!hs_content_additional.querySelector('.hs_discount') ? hs_content_additional.querySelector('.hs_discount').innerHTML = data.TotalDiscountSpan : '';
            !!hs_content_additional.querySelector('.hs-discount-global') ? hs_content_additional.querySelector('.hs-discount-global').value = TotalDiscount : '';
          };
        };
      });
    });
  },
  boomerangMehrwegpfandApp: function () {
    setTimeout(function () {
      var hs_container_mg_top_up = document.querySelector('div.hs-container-mg-top-up') || '';
      var hs_layout_content = document.querySelector('div.hs-layout-content') || '';
      if (!!hs_layout_content) {
        var boomerang_element = hs_layout_content.querySelector('.widget_Q7c_y') || '';
        if (!boomerang_element) {
          if (!!hs_container_mg_top_up) {
            const x = Symbol.for('boomerang-bc91');
            if (typeof window[x] !== 'undefined') {
              let contentBoomeran = window[x];
              if (typeof contentBoomeran.g !== 'undefined' && typeof contentBoomeran.g === 'object') {
                if (contentBoomeran.g.length > 0) {
                  if (typeof contentBoomeran.g[0] !== 'undefined' && typeof contentBoomeran.g[0] === 'object') {
                    if (contentBoomeran.g[0].length > 1) {
                      if (typeof contentBoomeran.g[0][1] !== 'undefined' && typeof contentBoomeran.g[0][1] === 'function') {
                        contentBoomeran.g[0][1]([hs_container_mg_top_up, 'afterend'])
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    }, 1000);
  },
  headerTitle: function (count = '') {
    // slideData.settings.language_settings.update_language_header_title = 0;
    //slideData.customize = undefined;

    try {
      count = count !== '' ? String(count) : count;
      const language_settings = slideData.settings.language_settings ?? {};
      const customize = slideData.customize ?? {};
      //const update_language_header_title = language_settings.update_language_header_title;
      const shopping_cart_language_settings = language_settings.shopping_cart_language_settings;
      let header_title = `Your Cart • ${count}`;
      if (customize.customize_header_title_type !== undefined) {
        // 1 → usar título con qty
        header_title = (shopping_cart_language_settings ?? header_title).replace(/{qty}/g, count);
      } else {
        // undefined → fallback
        if (slideData.settings.additional_settings.show_products_count) {
          header_title = (shopping_cart_language_settings ?? "Your Cart") + ` • ${count}`;
        } else {
          header_title = (shopping_cart_language_settings ?? "Your Cart");
        }
      };

      // Props del header
      const textAlignment = Boolean(customize.customize_header_text_alignment ?? true)   // default: true
      const titleType = customize.customize_header_title_type ?? "custom";
      const textLevel = customize.customize_header_text_level ?? "h3";
      let propsHeader = `data-internal-props="HsTitleAlignment=${textAlignment}"`;

      // Función helper para envolver título
      const wrapTitle = (tag = "span") =>
        `<${tag} class="hs-header-title" id="hs-header-content" ${propsHeader}>${header_title}</${tag}>`;

      switch (titleType) {
        case "theme":
          header_title = wrapTitle(textLevel);
          break;
        case "custom":
          header_title = wrapTitle("span");
          break;
        case "logo":
          const customize_header_logo_url = customize.customize_header_logo_url ?? '';
          header_title = `<img class="hs-header-logo" id="hs-header-content" src="${customize_header_logo_url}" alt="Brand header logo" ${propsHeader}  onerror="this.setAttribute('style', 'visibility: hidden !important');" />`
          break;
        default:
          header_title = wrapTitle("span");
          break;
      };

      // Header title final
      return header_title;
    } catch (error) {
      console.log(error);
      return `<span aria-label="Your Cart • ${count}" class='hs-header-title' id="hs-header-content" style="font-size: 16px !important; text-transform: none !important;">Your Cart • ${count}</span>`;
    };
  },
  headerProductCount: function (count = 0) {
  try {
    count = parseInt(count) || 0;

    const language_settings = slideData.settings.language_settings ?? {};

    const productText =
      language_settings.product_language_settings ?? 'Product';

    const productsText =
      language_settings.products_language_settings ?? 'Products';

    return `${count} ${count === 1 ? productText : productsText}`;
  } catch (error) {
    console.log(error);

    return `${count} ${Number(count) === 1 ? 'Product' : 'Products'}`;
  };
  },
  getCartTotalSavings: function (cart = {}) {
    try {
      if (!cart || !Array.isArray(cart.items)) {
        return 0;
      }

      // Clone the cart because Hs_modify_result may enrich the items
      // with compare_at_price and other Slide Cart values.
      try {
        if (typeof window.Hs_modify_result === 'function') {
          const new_result = window.Hs_modify_result(
            JSON.parse(JSON.stringify(cart)),
            slideData
          );

          cart = new_result || cart;
        }
      } catch (error) {
        console.log('HS modify result savings error:', error);
      }

      // Calculate the total "original / compare-at" value shown
      // by the Cart Drawer.
      const compareTotal = cart.items.reduce(function (total, item) {
        const quantity = parseInt(item.quantity || 0, 10);

        const compareAtPrice =
          parseInt(item.compare_at_price || 0, 10);

        const originalLinePrice =
          parseInt(item.original_line_price || 0, 10);

        let originalPrice = originalLinePrice;

        // compare_at_price is normally a unit price,
        // so multiply it by quantity.
        if (compareAtPrice > 0 && quantity > 0) {
          const compareLinePrice = compareAtPrice * quantity;

          originalPrice = Math.max(
            originalLinePrice,
            compareLinePrice
          );
        }

        return total + originalPrice;
      }, 0);

      // IMPORTANT:
      // Use the actual cart total after discounts.
      //
      // In your JSON:
      // total_price = 3199 (£31.99)
      //
      // Do NOT use final_line_price here because Shopify can return
      // the pre-discount value there depending on the discount /
      // selling-plan configuration.
      let currentTotal = parseInt(cart.total_price || 0, 10);

      // Defensive fallback in case total_price is unavailable.
      if (!currentTotal && cart.items.length) {
        currentTotal = cart.items.reduce(function (total, item) {
          const quantity = parseInt(item.quantity || 0, 10);

          if (item.line_price != null) {
            return total + parseInt(item.line_price || 0, 10);
          }

          if (item.discounted_price != null) {
            return total +
              (parseInt(item.discounted_price || 0, 10) * quantity);
          }

          return total;
        }, 0);
      }

      return Math.max(0, compareTotal - currentTotal);

    } catch (error) {
      console.log('HS cart total savings error:', error);

      return 0;
    }
  },
  cart: function (result, iniJSON) {
    var dataCart = [],
      arr_product_id = [],
      arr_product_handle = [],
      one_page_checkout = 'checkout',
      icon_cart = '',
      manually_recommended_products = '',
      hidden_min_price = '',
      header = '',
      body = '',
      body_empty = '',
      footer = '',
      status_text_tiered_free_items = '',
      status_text_automatic_recomendations = '',
      status_text_slide_cart_dynamic = '',
      additional_buttons = '',
      amazing_badge = '',
      orinal_price_discount = '',
      total_price = parseFloat(result.total_price),
      text_shipping_taxes = '',
      gift_wrap_content = '',
      mg_price = '',
      minimum_order = '',
      min_money = parseFloat(slideData.settings.minimum_order.minimum_order),
      min_money = min_money * 100,
      discount_code = '',
      note = result.note,
      text_countdown_cart = '',
      countdown_cart = '',
      selectCombobox = '',
      parent_class = '',
      text_variant_propertie = '',
      terms = '',
      cart_note_additional = '',
      selectParent = '',
      text_discounts = '',
      status_text_slide_cart = '',
      all_discount_price = '',
      line = 0,
      text_total_variant = '',
      line_price_discount = '',
      text_total_variant_discount_price = '',
      btn_continue_shopping = '',
      personalize_footer_continue = '',
      status_text_cart = '',
      button_shopify = '',
      subtotal_text_checkout = '',
      status_text_checkout = '',
      status_price_checkout = '',
      status_icon_checkout_left = '',
      status_icon_checkout_right = '',
      status_icon_checkout_position = 0,
      status_text_discount = '',
      status_text_note = '',
      trust_payment = '',
      giraffly_trust_badge = '<div class="giraffly-trust-badge"></div>',
      giftWrapType = '',
      hidden_text_cart = '',
      shipping_protection = '',
      total_weight = result.total_weight || 0,
      klarnaIntegration = '',
      dataCart = HsApp1.jsonCart(result);
    const customize = slideData.customize ?? {};


    total_weight = Hs_CartDrawer.show_weight ? total_weight > 0 ? `<span class="hs-total-cart-weight">(Total Weight: ${Math.round(total_weight) / 1000} kg)</span>` : '' : '';

    if (note === null) {
      note = '';
    };

    if (!slideData.settings.cart_button.enabled_cart_button || !slideData.settings.checkout_button.enabled_checkout_button) {
      button_shopify = ' hs-button-100-w';
    }

    if (!!slideData.settings.minimum_order.enabled_minimum_order) {
      var item_count = iniJSON.item_count;
      var data_minimum_order = HsApp1.caseMinimumOrder(total_price, item_count);
      hidden_min_price = data_minimum_order.hidden_min_price;//HIDDEN BUTTON
      status_price_checkout = data_minimum_order.status_price_checkout;
      hidden_text_cart = data_minimum_order.hidden_text_cart;//HIDDEN MINIMUM ORDER
      minimum_order = '<div class="hs-min-money-cart' + hidden_text_cart + '">' + status_price_checkout + '</div>';
    };


    if (!!slideData.settings.checkout_button.enabled_checkout_button) {
      var recurpay_input = '';
      if (typeof window.recurpay !== 'undefined') {
        if (!!window.recurpay) {
          if (typeof window.recurpay.checkout !== 'undefined') {
            if (!!window.recurpay.checkout) {
              if (window.recurpay.checkout === 'recurpay') {
                if (!!window.recurpay.action) {
                  recurpay_input = `<input style="display:none !important;" type="button" id="recurpay-checkout" data-value= '${window.recurpay.action}' class="btn" value="Check Out">`
                };
              };
            };
          };
        }
      };

      if (slideData.settings.checkout_button.checkout_button_icon_enabled) {
        if (slideData.settings.checkout_button.checkout_button_icon_svg) {
          var status_icon_checkout = `<div class="hs-content-lock-checkout">
                    ${slideData.settings.checkout_button.checkout_button_icon_svg}
                  </div>`;
          if (!status_icon_checkout_position) {
            status_icon_checkout_left = status_icon_checkout;
          } else {
            status_icon_checkout_right = status_icon_checkout;
          };

        };
      };

      if (Hs_CartDrawer.checkout_button_show_subtotal_text) {
        subtotal_text_checkout = ` • <div class="hs-content-subtotal-checkout"></div>`;
      };

      var checkout_x = !slideData?.settings?.gift_wrap?.enabled_gift_wrap ? ` checkout-x-buy-now-btn` : ``;
      var disabled_checkout = '';
      var class_disabled_checkout = '';
      if (typeof minMaxify !== 'undefined') { //minMaxify
        if (typeof minMaxify.checkLimits !== 'undefined') {
          if (!minMaxify.checkLimits()) {
            disabled_checkout = 'disabled'
          };
        };
      };

      if (!!slideData.settings.terms_conditions.enabled_terms) {
        class_disabled_checkout = ' hs-is-disabled';
      };

      status_text_checkout = '<div class="hs-content-checkout-button' + button_shopify + '">' + minimum_order + '<button data-ocu-checkout="true" ' + disabled_checkout + ' name="' + one_page_checkout + '" type="submit" ' + ' class="hs-checkout-purchase' + checkout_x + button_shopify + hidden_min_price + class_disabled_checkout + ' btn"><span class="hs-add--to--cart">' + status_icon_checkout_left + '<div class="hs-checkout-text">' + slideData.settings.checkout_button.checkout_button_text + '</div>' + status_icon_checkout_right + subtotal_text_checkout + '</span><span class="hs--loading">' + HsApp4.loadSvg() + '</span></button></div>' + recurpay_input;
    };

    if (!!slideData.settings.cart_button.enabled_cart_button) {
      status_text_cart = '<div class="hs-content-go-cart-button' + button_shopify + '" ><button title= "' + slideData.settings.cart_button.cart_button_text + '" type="button" class="hs-cart-purchase' + button_shopify + '">' + slideData.settings.cart_button.cart_button_text + '</button></div>';

    }

    if (!!slideData.settings.cart_coupon.enabled_cart_coupon_button) {
      /* discount_code = HsApp1.readCookie('hscodediscount');
      discount_code = decodeURIComponent(discount_code); */
      const positionKeyDiscount = !Hs_CartDrawer.positionDiscountCoupon ? Hs_CartDrawer.getDataPosition('hs-discountCode')?.key || '' : '';

      status_text_discount = `
                  <div class="hs-add-discount" ${positionKeyDiscount}>
                    <div class="hs-success-code-discount"></div>
                      <label class="hs-discount-heading" for="hs-id-discount" style="display: none !important;">Discount:</label>
                      <div class="hs-content-discount-add">
                        <input type="text" class="hs-discount-code" id="hs-id-discount" autocorrect="off" autocapitalize="off" spellcheck="false" placeholder="${slideData.settings.cart_coupon.placeholder_cart_coupon_button}" aria-label="${slideData.settings.cart_coupon.placeholder_cart_coupon_button}" value="${discount_code}" name="hsdiscount" autocomplete="off">
                        <button type="button" class="hs-apply-discount btn">
                          <span class="hs-text--apply--discount">${slideData.settings.cart_coupon.name_cart_coupon_button}</span>
                          <span class="hs--loading">${HsApp4.loadSvg()}</span>
                        </button>
                      </div>
                    <div class="hs-error-code-discount"></div>
                    <div class="hs-tag-code-discount"></div>
                  </div>`;
    } else {
      discount_code = HsApp1.readCookie('hscodediscount');
      if (!!discount_code) {
        HsApp1.deleteCookie(`hscodediscount`);
        HsApp1.checkoutPage = '';
      };
    };

    if (!!slideData.settings.cart_note.enabled_cart_note) {
      const positionKeyNote = Hs_CartDrawer.getDataPosition('hs-note')?.key || '';
      status_text_note = `
                <div class="hs-note-border" ${positionKeyNote}>
                  <div class="hs-note-view" style="display:block">
                    <span class="hs-note-heading" role="button" tabindex="0">
                      ${HsApp1.svgAddNote}
                      <span class="hs-note-title">${slideData.settings.cart_note.cart_note_heading}</span>
                    </span>
                  </div>
                  <div class="hs-cart-note">
                    <textarea placeholder="${slideData.settings.cart_note.cart_note_heading_placeholder}" aria-label="${slideData.settings.cart_note.cart_note_heading_placeholder}"class="hs-cart-ins" name="note" autocomplete="off">${note}</textarea>
                  </div>
                </div>`;
      if (!!Hs_CartDrawer.cart_note_additional) {
        cart_note_additional =
          `<div class="hs-additional-cart-note-content">
                  <span class="hs-content-additional-cart-note hs-sl-content-checkbox">
                    <input type="checkbox" class="hs_front_check_additional_note" id="hs_input_check_additional_note">
                    <span class="hs-sl-terms-box"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" class="hs-sl-terms-icon"><polyline points="5 10.75 8.5 14.25 16 6"></polyline></svg></span>
                  </span>
                  <span>
                    <label for="hs_input_check_additional_note" style="display: inline-block;"> ${slideData.settings.cart_note.cart_note_additional_text}</label>
                  </span>
                </div>`;
      };
    };

    if (typeof slideData.settings.continue_shopping !== 'undefined') {
      if (!!slideData.settings.continue_shopping.enabled_continue_shopping) {
        if (slideData.settings.continue_shopping.continue_shopping_button_url !== '') {
          btn_continue_shopping = `<a class="hs-continue-shopping" href="${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_button_url : '/collections/all'}">${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text : 'Continue Shopping'}</a>`;
        }
        else {
          btn_continue_shopping = `<span class="hs-continue-shopping" style="cursor:pointer;">${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text : 'Continue Shopping'}</span>`;
        }
      };
    };


    if (typeof slideData.settings.tiered_free_items !== 'undefined') {
      if (!!parseInt(slideData.settings.tiered_free_items.enabled_tiered_free_items) && (!Hs_CartDrawer.hidden_tiered)) {
        const positionKeyTiered = Hs_CartDrawer.getDataPosition('hs-tiered')?.key || '';
        if (parseInt(slideData.settings.tiered_free_items.tfi_mode_view)) {
          status_text_tiered_free_items = `<div class="hs-container-stacked hs-tiered_free_items ${!!Hs_CartDrawer.tfi_lock_method ? ' hs-design-0' : ''}" ${positionKeyTiered} style="display:none;">
                        <div class="hs-frequently-bought"><span>${slideData.settings.tiered_free_items.tfi_section_heading}</span></div>
                        ${!!Hs_CartDrawer.tfi_lock_method ? `<div class="hs-locked-progress">
                                  <div class="hs-content-circle">
                                    <div class="hs-content-progress"></div>
                                  </div>
                                  <div class="hs-tiered-text"><p></p></div>
                                </div>` : ''}
                          <div class="hs-products-free-items hs-tiered">
                          </div>
                      </div>`;
        } else {
          var multi_view_class = Hs_CartDrawer.tiered_qty_per_view > 1 ? ' hs-upsell_multi_view' : '';
          status_text_tiered_free_items = `<div class="hs-container-swp ${multi_view_class} ${!!Hs_CartDrawer.tfi_lock_method ? ' hs-design-0' : ''} hs-tiered_free_items" ${positionKeyTiered} style="display:none;">
                      <div class="hs-frequently-bought"><span>${slideData.settings.tiered_free_items.tfi_section_heading}</span></div>
                      ${!!Hs_CartDrawer.tfi_lock_method ? `<div class="hs-locked-progress">
                                <div class="hs-content-circle">
                                  <div class="hs-content-progress"></div>
                                </div>
                                <div class="hs-tiered-text"><p></p></div>
                              </div>` : ''}
                      <div class="hs-swipper-containter-cart hs-mode-dynamic hs-tiered" aria-roledescription="Carousel" aria-label="${slideData.settings.tiered_free_items.tfi_section_heading}"></div>
                    </div>`;
        }
      }
    };

    if (parseInt(slideData.settings.product_recommendations_settings.enabled_product_recommendations)) {
      const positionKeyUpsellAutomatic = Hs_CartDrawer.getDataPosition('hs-upsellAutomatic')?.key || '';
      if (parseInt(slideData.settings.product_recommendations_settings.mode_upsell_automatic)) {
        status_text_automatic_recomendations = `<div class="hs-container-dynamic-stacked hs-automatic-recommend" ${positionKeyUpsellAutomatic} style="display:none;"><div class="hs-frequently-bought"><span>${slideData.settings.product_recommendations_settings.section_heading_products}</span></div><div class="hs-products-dynamic-stacked"></div></div>`;
      } else {
        var multi_view_class = Hs_CartDrawer.apu_qty_per_view > 1 ? ' hs-upsell_multi_view' : '';
        status_text_automatic_recomendations = `<div class="hs-container-swp ${multi_view_class} hs-automatic-recommend" ${positionKeyUpsellAutomatic} style="display:none;">
                  <div class="hs-frequently-bought">
                  <span>${slideData.settings.product_recommendations_settings.section_heading_products}</span>
                  </div>
                  <div class="hs-swipper-containter-cart hs-mode-dynamic" aria-roledescription="Carousel" aria-label="${slideData.settings.product_recommendations_settings.section_heading_products}"></div>\
                  </div>`;
      }
    };

    if (!!parseInt(slideData.settings.manually_products_upsells.enabled_product_manually)) {
      const positionKeyUpsellManually = Hs_CartDrawer.getDataPosition('hs-upsellManually')?.key || '';
      if (parseInt(slideData.settings.manually_products_upsells.mode_upsell_manually)) {
        status_text_slide_cart_dynamic = `<div class="hs-container-dynamic-stacked hs-cross-sell" ${positionKeyUpsellManually} style="display:none;"><div class="hs-frequently-bought"><span>${slideData.settings.manually_products_upsells.section_heading_products_manually}</span></div><div class="hs-products-dynamic-stacked"></div></div>`;
      } else {
        var multi_view_class = Hs_CartDrawer.mpu_qty_per_view > 1 ? ' hs-upsell_multi_view' : '';
        status_text_slide_cart_dynamic = `<div class="hs-container-swp ${multi_view_class} hs-cross-sell" ${positionKeyUpsellManually} style="display:none;">
                  <div class="hs-frequently-bought">\
                  <span>${slideData.settings.manually_products_upsells.section_heading_products_manually}</span>
                  </div>
                  <div class="hs-swipper-containter-cart hs-mode-dynamic" aria-roledescription="Carousel" aria-label="${slideData.settings.manually_products_upsells.section_heading_products_manually}"></div>
                  </div>`;
      }
    };


    if (!!slideData.settings.static_products_upsells) {
      if (!!parseInt(slideData.settings.static_products_upsells.enabled_static_products_upsell)) {
        if (typeof slideData.settings.static_products_upsells !== 'undefined') {
          const positionKeyUpsellStatic = Hs_CartDrawer.getDataPosition('hs-upsellStatic')?.key || '';

          if (parseInt(slideData.settings.static_products_upsells.mode_upsell_static)) {
            status_text_slide_cart = `<div class="hs-container-stacked hs-recommend-products" ${positionKeyUpsellStatic} style="display:none;"><div class="hs-frequently-bought"><span>${slideData.settings.static_products_upsells.section_heading_products_static}</span></div><div class="hs-products-stacked hs-manual-products"></div></div>`;
          } else {
            var multi_view_class = Hs_CartDrawer.spu_qty_per_view > 1 ? ' hs-upsell_multi_view' : '';
            status_text_slide_cart = `<div class="hs-container-swp ${multi_view_class} hs-recommend-products" ${positionKeyUpsellStatic} style="display:none;">
                        <div class="hs-frequently-bought">\
                        <span>${slideData.settings.static_products_upsells.section_heading_products_static}</span>
                        </div>
                        <div class="hs-swipper-containter-cart hs-mode-dynamic hs-manual-products" aria-roledescription="Carousel" aria-label="${slideData.settings.static_products_upsells.section_heading_products_static}"></div>
                        </div>`;
          }
        }
      };
    }

    if (!!slideData.settings.language_settings.shipping_taxes_discounts_language_settings) {
      text_shipping_taxes = '<div class="hs-shipping-taxes">' + slideData.settings.language_settings.shipping_taxes_discounts_language_settings + '</div>';
    };

    if (!!slideData?.settings?.gift_wrap?.enabled_gift_wrap) {
      var gift_wrap_main = '';
      if (slideData.settings.gift_wrap.product_type === "customProduct") {
        var comparePrice = '';
        if (!!slideData.settings.additional_settings.show_compare_price) {
          comparePrice = `${slideData.settings.gift_wrap.offer_compare_price * 100 > slideData.settings.gift_wrap.offer_price * 100 ?
            `<div class="hs-compare-price-sw">
                        ${hsonslidecart.Currency.formatMoney(slideData.settings.gift_wrap.offer_compare_price, slideData.settings.devices.money_format)}
                      </div>` : ``}`
        }

        giftWrapType = ' hs-gift-wrap-custom';
        gift_wrap_main = `
                  <div class='hs-gift-wrap-content-customProduct'>
                  <label for="hs_input_check_gift" class="hs-input-gift-lbl">
                    <div class='hs-gift-wrap-offer'>
                      <span class='hs-gift-wrap-icon'>
                        ${slideData.settings.gift_wrap.icon}
                      </span>
                      <span class='hs-gift-wrap-text'>
                        ${slideData.settings.gift_wrap.offer_name}
                      </span>
                    </div>
                  </label>
                    <div class='hs-gift-wrap-content-customProduct-price'>
                      ${comparePrice}
                      <div class="hs-price-sw">
                        ${parseInt(slideData.settings.gift_wrap.offer_price) <= 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? '<span>' + Hs_CartDrawer.languageFreeGnral + '</span>' : hsonslidecart.Currency.formatMoney(slideData.settings.gift_wrap.offer_price, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(slideData.settings.gift_wrap.offer_price, slideData.settings.devices.money_format)}
                      </div>
                    </div>
                  </div>`;
      } else {
        giftWrapType = ' hs-gift-wrap-specific'
        gift_wrap_main = `
                  <div class='hs-gift-wrap-content-specificProduct-img'></div>
                  <div class='hs-gift-wrap-content-specificProduct'>
                  </div>
                  <div class='hs-gift-wrap-content-specificProduct-price'>
                  </div>
                  `
      };
      //var _checked = !!HsApp1.readCookie('hs-giftWrap-check') ? 'checked' : '';
      gift_wrap_content = `
                <div class="hs-gift-wrap ${giftWrapType}" style="display:none;">
                  <div class="hs-gift-wrap-content-check hs-sl-content-checkbox">
                    <input type="checkbox" class="hs-gift-wrap-check" id="hs_input_check_gift">
                    <span class="hs-sl-terms-box"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" class="hs-sl-terms-icon"><polyline points="5 10.75 8.5 14.25 16 6"></polyline></svg></span>
                  </div>
                  ${gift_wrap_main}
                </div>`;
    }

    countdown_cart = HsApp1.countDownCart(' hs-sl-cart-page');

    const regex = /{{([^}]*)}}/g;
    var text_terms = '', text_url = '';
    var title_url = regex.exec(slideData.settings.terms_conditions.text_terms);

    if (!title_url) {
      text_terms = `<label for="hs_input_check" style="display: inline-block;"> ${slideData.settings.terms_conditions.text_terms}</label>`;
      /*  text_url = ''; */
    }
    else {
      if (slideData.settings.terms_conditions.url_terms.indexOf('https://') < 0) {
        text_url = 'https://' + slideData.settings.terms_conditions.url_terms;
      } else {
        text_url = slideData.settings.terms_conditions.url_terms;
      }
      text_terms = `<label for="hs_input_check" style="display: inline-block;">
                  ${slideData.settings.terms_conditions.text_terms.replace(title_url[1], text_url !== 'https://' ? `<a href="${text_url}" target="_blank">${title_url[1]}</a>` : `<span>${title_url[1]}</span>`).replace(/{{|}}/g, '')}
                  </label>`
    }

    terms = `<div class="hs-terms-content">
                        <span class="hs-content-terms hs-sl-content-checkbox">
                          <input type="checkbox" class="hs_front_check_agreed" id="hs_input_check">
                          <span class="hs-sl-terms-box"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" class="hs-sl-terms-icon"><polyline points="5 10.75 8.5 14.25 16 6"></polyline></svg></span>
                        </span>
                        <span>
                          ${text_terms}
                        </span>
                  </div>`;
    if (!slideData.settings.terms_conditions.enabled_terms) {
      terms = '';
    };

    if (!!slideData.settings.additional_check.enabled_additional_checkout_buttons) {
      if (Shopify.PaymentButton) {
        additional_buttons = '<div class="dynamic-checkout__content" id="dynamic-checkout-cart" data-shopify="dynamic-checkout-cart"></div>';
      }
    };
    if (!!slideData.settings.payment_badges.enabled_payment_badges) {
      if (slideData.settings.payment_badges.url_img_host) {
        var this_image = slideData.settings.payment_badges.url_img_shopify !== '' ? slideData.settings.payment_badges.url_img_shopify : slideData.settings.payment_badges.url_img_host;
        trust_payment = '<div class="hs-trust-payment"><img loading="lazy" alt=' + slideData.settings.checkout_button.checkout_button_text + ' src=' + this_image + '></div>';
        giraffly_trust_badge = '';
      }
    };

    /* if (!!slideData.settings.minimum_order.enabled_minimum_order && !hidden_text_cart) {
      additional_buttons = '';
    }; */

    if (typeof slideData.settings.devices.personalize !== 'undefined') {
      if (slideData.settings.devices.personalize !== '') {
        var json_personalize = JSON.parse(slideData.settings.devices.personalize);
        if (json_personalize.footer_continue_shoopping !== '') {
          personalize_footer_continue = json_personalize.footer_continue_shoopping;
        }
      };
    };

    /* SHIPPING PROTECTION */
    if (typeof slideData.settings.shipping_protection !== 'undefined') {
      var dataShipping = slideData.settings.shipping_protection;
      if (!!dataShipping.enabled_shipping_protection) {
        if (dataShipping.sp_featured_product_shopify_handle !== '') {
          shipping_protection = `
                    <div class='hs-shipping-protection-gnrl hs-loading-protection'>
                    <div class="hs-result-loading hs-show-loading" style="display:none"><div class="hs-spinner"></div></div>
                    </div>`
        };
      };
    };
    /* END SHIPPING PROTECTION */

    var shipping_rates_calculator_plus = '';
    if (!!window.codeblackbelt) {
      if (!!window.codeblackbelt["shipping-rates-calculator-plusLoaded"]) {
        shipping_rates_calculator_plus = `<div class='hs_form_shipping' style="position: relative; clear: both; text-align: left; padding: 10px 20px 10px 20px;max-width: 1140px;cursor: default;"><form class='hs_shipping_rates_calculator_plus' action="/cart" method="post" novalidate="" data-cbb-target-form="processed"></form></div>`
      }
    };

    /* AFTERPAY INTEGRATION */

    var afterpayIntegration = Hs_CartDrawer.integrationData(8);
    if (!!afterpayIntegration) {
      var locale = 'EN_US';
      var currencie = 'EUR';
      /* if (!!window.Shopify) {
        if (!!window.Shopify.locale && !!window.Shopify.country) {
          locale = window.Shopify.locale + '_' + window.Shopify.country
        };
        if (!!window.Shopify.currency) {
          if (typeof window.Afterpay !== 'undefined') {
            if (typeof window.Afterpay.currency !== 'undefined') {
              Object.keys(window.Afterpay.currency).forEach(function (currencies) {
                if (currencies === window.Shopify.currency.active) {
                  currencie = window.Shopify.currency.active;
                }
              })
            };
          };
        };
      }; */
      if (!!window.Shopify) {
        if (!!window.Shopify.locale && !!window.Shopify.country) {
          var locale_compatible = ['en_US', 'en_AU', 'en_CA', 'en_GB', 'en_NZ', 'fr_CA']
          var this_locale = (window.Shopify.locale + '_' + window.Shopify.country).toLocaleLowerCase();
          locale_compatible = locale_compatible.find(element => element.toLocaleLowerCase() === this_locale);
          if (typeof locale_compatible !== 'undefined') {
            locale = locale_compatible;
          };
        };
        if (!!window.Shopify.currency) {
          if (typeof window.Afterpay !== 'undefined') {
            if (typeof window.Afterpay.currency !== 'undefined') {
              Object.keys(window.Afterpay.currency).forEach(function (currencies) {
                if (currencies === window.Shopify.currency.active) {
                  currencie = window.Shopify.currency.active;
                }
              })
            };
          };
        };
      };
      afterpayIntegration = `<afterpay-placement
                data-locale="${locale}"
                data-currency="${currencie}"
                data-size=${'xs' || 'm'}
                data-amount=${!!result.total_price ? result.total_price / 100 : 0}>
                </afterpay-placement>`
    } else {
      afterpayIntegration = '';
    };


    /* SCALAPAY INTEGRATION */
    var scalapayIntegration = false//Hs_CartDrawer.integrationData(10);
    if (!!scalapayIntegration) {
      var locale = 'en';
      if (!!window.Shopify) {
        if (!!window.Shopify.locale) {
          var locale_compatible = ['en', 'it', 'pt', 'de', 'fr', 'es']
          locale_compatible = locale_compatible.find(element => element === window.Shopify.locale);
          if (typeof locale_compatible !== 'undefined') {
            locale = locale_compatible;
          };
        };
      };
      scalapayIntegration = `<scalapay-widget
            frequency-number='${window.HSSLIDECART.SCALAPAY_FREQUENCY_NUM || 30}'
            number-of-installments='${window.HSSLIDECART.SCALAPAY_NUM_INSTALMENT || 3}'
            hide='false'
            hide-price='${window.HSSLIDECART.SCALAPAY_HIDE_PRICE || false}'
            min='${window.HSSLIDECART.SCALAPAY_MIN || 100}'
            max='${window.HSSLIDECART.SCALAPAY_MAX || 1500}'
            amount-selectors='[".hs-sub-total-cart:not(.hs-payment-discount):not(.docapp-replaces) .hs_subtotal_amount span:first-of-type",".hs-sub-total-cart.hs-payment-discount .hs_subtotal_amount_discount span:first-of-type",".hs-sub-total-cart.hs-payment-discount.docapp-replaces .hs_subtotal_amount_discount span:first-of-type",".docapp-cart-item.docapp-est-total [data-est-total] span"]'
            currency-position=${window.HSSLIDECART.SCALAPAY_CURRENCY_POSITION || 'before'}
            currency-display=${window.HSSLIDECART.SCALAPAY_CURRENCY_DISPLAY || 'symbol'}
            logo-size=${window.HSSLIDECART.SCALAPAY_LOGO_SIZE = '100'}
            locale='${locale}'
          ></scalapay-widget>`
    } else {
      scalapayIntegration = '';
    }

    /* KLARNA INTEGRATION */
    let klarnaIntegrationActive = Hs_CartDrawer.integrationData(13);
    if (!!klarnaIntegrationActive) {
      if (typeof window.Klarna !== 'undefined') {
        var integration = slideData.integrations.filter((integration) => {
          if (integration.integrations_app_id == 13) {
            return integration;
          };
        }) || [];
        if (integration.length > 0) {
          var locale = "en-US";
          if (!!window.Shopify) {
            if (!!window.Shopify.locale && !!window.Shopify.country) {
              var locale_compatible = ['en-AT', 'de-AT', 'nl-BE', 'en-BE', 'fr-BE', 'en-CH', 'de-CH', 'it-CH', 'fr-CH', 'en-CZ', 'cs-CZ', 'de-DE', 'en-DE', 'da-DK', 'en-DK', 'es-ES', 'en-ES', 'fi-FI', 'sv-FI', 'en-FI', 'fr-FR', 'en-FR', 'en-GB', 'en-GR', 'el-GR', 'en-HU', 'en-IE', 'en-IT', 'hu-HU', 'it-IT', 'nl-NL', 'en-NL', 'no-NO', 'nb-NO', 'en-NO', 'en-PL', 'pl-PL', 'en-PT', 'pt-PT', 'sv-SE', 'en-SE', 'sk-SK', 'en-SK', 'en-CA', 'fr-CA', 'es-MX', 'en-MX', 'en-US', 'es-US', 'en-AU', 'en-NZ']
              var this_locale = (window.Shopify.locale + '_' + window.Shopify.country).toLocaleLowerCase();
              locale_compatible = locale_compatible.find(element => element.toLocaleLowerCase() === this_locale);
              if (typeof locale_compatible !== 'undefined') {
                locale = locale_compatible;
              };
            };
          };


          klarnaIntegration = `
          <klarna-placement
            data-key="top-strip-promotion-auto-size"
            data-locale=${locale}
          ></klarna-placement>
          `;
        };
      };
    };

    var header_layout = !!document.querySelector('.hs-header-layout') ? document.querySelector('.hs-header-layout') : '';

    const iconThickness = Boolean(customize.customize_header_icon_thickness ?? false); // default: false
    const propsHeaderButtonClose = `data-internal-props="HsIconStrokeWidth=${iconThickness}"`;
    const headerTitle = HsApp1.headerTitle(result.item_count);
    const headerProductCount = HsApp1.headerProductCount(result.item_count);

    header = `<!-- HS HEADER LAYOUT -->
                <div class='hs-header-layout'>
                  <div class="hs-close-popup-cart">
                    <div class="hs-header-close-empty">
                      <div>
                        <div class="hs-sl-icon-sl-cart">
                          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 512.003 512.003" height="512" viewBox="0 0 512.003 512.003" width="512"><g><circle cx="226" cy="436.002" r="45"></circle><circle cx="377" cy="436.002" r="45"></circle><path d="m15 61.002h62.553l72.418 253.513-5.68 11.36c-14.956 29.88 6.755 65.127 40.254 65.127h252.455c8.291 0 15-6.709 15-15s-6.709-15-15-15h-252.455c-11.139 0-18.419-11.729-13.418-21.709l4.146-8.291h261.727c6.694 0 12.583-4.438 14.429-10.884l60-210c1.289-4.526.381-9.39-2.446-13.154-2.842-3.75-7.28-5.962-11.982-5.962h-379.678l-14.033-49.117c-1.846-6.445-7.734-10.884-14.429-10.884h-73.861c-8.291 0-15 6.709-15 15s6.709 15.001 15 15.001z"></path></g></svg>
                        </div>
                        <div class="hs-sl-text-count-products">${headerProductCount}</div>
                      </div>
                      ${headerTitle}
                      <div class="hs-sl-btn-close-sl-cart">
                      <button ${propsHeaderButtonClose} class="hs-close" aria-label="Close cart">
                        ${HsApp1.iconCloseSlideCart}
                      </button>
                      </div>
                    </div>
                  </div>
                </div>`;

    var original_price = 0
    let content_original_price = /* Hs_CartDrawer.checkout_button_show_subtotal_text ?
        `<div class="hs-content-original-price hs-hidden-div">
              <div  class="hs-cart-original-price-padding">
                <div class="hs-original-price">
                  <div class="hs-text-original-price-content">
                    <span class="hs-text-original-price">${slideData.settings.language_settings.subtotal_language_settings || 'SubTotal'}</span>
                  </div>
                  <div class="hs-amount-original-price-content">
                    <div class="hs_original_price">
                    </div>
                    <input type="hidden" value="0" class="hs-total-original-price-global" data-value-dscto="0">
                  </div>
                </div>
              </div>
            </div>` :  */'';

    //TOTAL_SAVE
    let content_total_save = !!Hs_CartDrawer.total_save ?
      `<div class="hs-content-total-save">
                <div  class="hs-cart-save-padding">
                  <div class="hs-save">
                    <div class="hs-text-save-content">
                      <div class="hs-text-save">${slideData.settings.settings_footer.total_save_text}</div>
                    </div>
                    <div class="hs-amount-save-content">
                      <div class="hs_total_save">
                      </div>
                      <input type="hidden" value="0" class="hs-total-save-global" data-value-dscto="0">
                    </div>
                  </div>
                </div>
              </div>` : '';

    /* <div class="hs-discount hs-skeleton"> */
    var this_discount = 0;

    var tagDiscounts = '';
    Hs_CartDrawer.Nn(result).forEach(apply_discount => {
      var tag = hsonslidecart.Discount.tagDiscount(apply_discount);
      tagDiscounts = tagDiscounts + tag;
    });

    let content_shipping_label = '';
    // if (typeof slideData.customize !== 'undefined') {
    //   if (typeof slideData.customize.customize_footer_enabled_shipping_label !== 'undefined' && typeof slideData.customize.customize_footer_shipping_text_label !== 'undefined' && typeof slideData.customize.customize_footer_shipping_price_label !== 'undefined') {
    //     if (slideData.customize.customize_footer_enabled_shipping_label && slideData.customize.customize_footer_shipping_text_label !== '' && slideData.customize.customize_footer_shipping_price_label !== '') {

    //     };
    //   };
    // };

    if (customize?.customize_footer_enabled_shipping_label &&
      customize?.customize_footer_shipping_text_label &&
      customize?.customize_footer_shipping_price_label) {
      // Aquí va el código cuando todas las condiciones son verdaderas
      content_shipping_label =
        `<div class="hs-content-shipping-label"><span class="hs-shipping-text-label">${customize?.customize_footer_shipping_text_label}</span><span class="hs-shipping-cost-label"><span class="hs-shipping-price-label">${customize?.customize_footer_shipping_price_label}</span></span></div>`
    };

    let content_discount = Hs_CartDrawer.hide_discount_list_footer ? '' :
      `<div class="hs-content-discount hs-hidden-div">
                <div  class="hs-cart-discount-padding">
                  <div class="hs-discount">
                    <div class="hs-text-discount-content">
                      <span class="hs-text-discount">${slideData.settings.language_settings.total_discount_savings_language_settings || 'Discount'}</span>
                      <div class="hs-text-discount-tags">
                      ${tagDiscounts}
                      </div>
                    </div>
                    <div class="hs-amount-discount-content">
                      <div class="hs_discount">
                        -${hsonslidecart.Currency.formatMoney(result.total_discount, slideData.settings.devices.money_format)}
                      </div>
                      <input type="hidden" value="${result.total_discount}" class="hs-discount-global" data-value-dscto="0">
                    </div>
                  </div>
                </div>
              </div>`;

    let content_free_shipping = !!Hs_CartDrawer.shipping ?
      `<div class="hs-content-shipping">
                  <div  class="hs-cart-shipping-padding">
                    <div class="hs-shipping hs-skeleton">
                      <div class="hs-shipping-text-content">
                        <div class="hs-text-shipping">${slideData.settings.settings_footer.free_shipping_text1}</div>
                      </div>
                      <div class="hs-shipping-price-content">
                        <div class="hs-text-shipping">${slideData.settings.settings_footer.free_shipping_text2}</div>
                      </div>
                    </div>
                  </div>
                </div>` : '';

    var footer_layout = !!document.querySelector('.hs-footer-layout') ? document.querySelector('.hs-footer-layout') : '';
    var route_div_integration = Hs_CartDrawer.integrationData(11) ? `<div class="route-div"></div>` : ``;

    let hidden_subtotal = slideData.settings.checkout_button.enabled_checkout_button ? Hs_CartDrawer.checkout_button_show_subtotal_text ? 'hs-hidden-element' : '' : '';

    /* ${!Hs_CartDrawer.total_save ? `<span class="hs_subtotal_compare_at_price">${comparePriceTotal}</span>` : ''} */
    if (slideData.settings.language_settings.amazing_badge_language_settings) {
      amazing_badge = `<div class="hs-amazing-badge">
          <div class="hs-content-amazing-badge">
            ${slideData.settings.language_settings.amazing_badge_language_settings}
          </div>
        </div>`;
    };

    var total_cart_page = `<div class="hs-content-total-cart">
                      <div class="hs-sub-total-cart-padding">
                        <div class="hs-sub-total-cart ${typeof window.conversionBundlesBear !== 'undefined' ? 'cb-bundle-show-ajax_cart__cart_subtotal_container' : ''}">
                          <div class="hs-text-subtotal">
                            ${slideData.settings.language_settings.subtotal_language_settings}
                          </div>
                          <div class="hs-mount-sub-total">
                            <span class="hs_subtotal_discount_automatic"></span>
                            <span class="hs_subtotal_amount ${typeof window.conversionBundlesBear !== 'undefined' ? 'cb-bundle-show-ajax_cart__cart_subtotal' : ''}"></span>
                            <span class="hs_subtotal_amount_discount">
                            </span>
                          </div>
                          <input type="hidden" value="" class="hs-total-price-global" />\
                          <input type="hidden" value="0" class="hs-discount-price-global" />\
                        </div>
                      </div>
                    </div>`;

    var content_footer = ` 
                <div class="hs-drawer-checkout">
                  <div class="hs-drawer-content-checkout">
                    <div id="offset-cart-drawer-ui-offer"></div>
                    ${shipping_protection}
                    ${gift_wrap_content}
                    <div class="hs-additional-cart-note-check">${cart_note_additional}</div>
                    ${!Hs_CartDrawer.positionDiscountCoupon ? content_discount : ''}
                    ${content_original_price}
                    ${content_total_save}
                    ${content_free_shipping}
                    <div class="hs-content-total-cart-weight">${total_weight}</div>
                    ${!slideData?.settings?.gift_wrap?.enabled_gift_wrap ? `<form action="/cart" method="post" novalidate="">` : ``}
                      <div class="hs-finalize-purchase">
                        <div class='pds-donate-source'></div>
                        ${text_shipping_taxes}
                        ${afterpayIntegration}
                        ${scalapayIntegration}
                        ${Hs_CartDrawer.positionDiscountCoupon ? status_text_discount : ''}
                        ${content_shipping_label}
                        ${Hs_CartDrawer.positionDiscountCoupon ? content_discount : ''}
                        ${total_cart_page}
                        ${route_div_integration}
                        <div class="hs-terms-and-conditions">${terms}</div>
                        <div class="hs-content-buttons">${status_text_cart}${status_text_checkout}</div>
                        <div class="hs-content-additional-buttons"${!additional_buttons ? 'style="display:none;"' : ''}>
                          <div id="hs-additional-buttons" style="display:none;">
                          ${additional_buttons}
                          </div>
                        </div>
                        ${amazing_badge}
                        ${klarnaIntegration}
                        <div class="si-widget"></div>
                        ${trust_payment}
                        ${giraffly_trust_badge}
                        ${btn_continue_shopping}
                        ${personalize_footer_continue}
                      </div>
                    ${!slideData?.settings?.gift_wrap?.enabled_gift_wrap ? `</form>` : ``}
                  </div>
                </div>`;

    footer = `
                <!-- HS FOOTER LAYOUT -->
                <div class = "hs-footer-layout${result.item_count > 0 ? '' : ' empty'}">
                <div class="hs-content-sub-total-cart">
                  <div class="hs-subtotaldiscount-cart">
                    <span>Total</span>
                    <span class="hs_subtotaldiscount_amount"><span class="hs_subtotal_compare_at_price"></span></span>
                  </div>
                </div>
                  ${content_footer}
                  <div class='hs-product-option'></div>
                </div>`;


    var hs_popup = !!document.querySelector('.hs-popup-cart-sp-load .hs-site-cart-popup-layout') ? document.querySelector('.hs-popup-cart-sp-load .hs-site-cart-popup-layout') : '';
    var hs_empty = !!HsApp1.cartEmpty(result.item_count, 0) ? HsApp1.cartEmpty(result.item_count, 0) : `
                  <!-- HS BODY LAYOUT -->
                    <div class='hs-body-layout'>
                      <div class="hs-content-empty-cart">
                        ${slideData.settings.language_settings.cart_empty_text_language_settings}
                      </div>
                    </div>
                  `;

    const bodyOrder = JSON.parse(slideData?.position?.cart_body_order || '[]');

    const customHtml = bodyOrder
      .filter(item => item.type === 'hs-custom')
      .sort((a, b) => a.order - b.order)
      .map(item => `<div class="hs-custom-section ${item.key}"  data-key="${item.label}" style="order:${item.order}">${item.html || ''}</div>`)
      .join('');

    if (!!hs_popup) {
      var content_slide = '';
      if (result.item_count > 0) {
        const positionKeyAnnouncement = Hs_CartDrawer.getDataPosition('hs-announcement')?.key || '';
        const positionKeyRewards = Hs_CartDrawer.getDataPosition('hs-rewards')?.key || '';
        const positionKeyClearAll = Hs_CartDrawer.getDataPosition('hs-clearAll')?.key || '';
        const positionKeyProducts = Hs_CartDrawer.getDataPosition('hs-products')?.key || '';
        const totalSavings = HsApp1.getCartTotalSavings(HSSLIDECART.CART);
        const totalSavingsCurrency = totalSavings > 0
          ? hsonslidecart.Currency.formatMoney(
              totalSavings,
              slideData.settings.devices.money_format
            )
          : '';
        const totalYouSave = totalSavings > 0
          ? `<div class="hs-total-save">You Saved ${totalSavingsCurrency}!</div>`
          : '';
 
        hs_popup.classList.remove('hs-popup-cart-empty')
        var body_layout = !!document.querySelector('.hs-body-layout') ? document.querySelector('.hs-body-layout') : '';
        var content_body = `
                  <div class='hs-layout-content'>
                    ${countdown_cart}
                      <div class="hs-announcement-module" ${positionKeyAnnouncement}>
                      </div>
                      <div class="hs-content-discounts-calculate-checkout" ${positionKeyRewards}>
                      </div>
                      <div class="hs-content-count-products-clear-all" ${positionKeyClearAll}>
                    </div>
                    <div class="hs-sticky-cart" tabindex="0" ${positionKeyProducts}>
                      ${dataCart[0].htmlCart}
                      ${totalYouSave}
                    </div>
                    <div class="hs-container-mg-top-up" ${positionKeyProducts}></div>
                    ${Hs_CartDrawer.positionDiscountCoupon ? '' : status_text_discount}
                    ${status_text_note + status_text_tiered_free_items + status_text_automatic_recomendations + status_text_slide_cart_dynamic + status_text_slide_cart}
                    ${customHtml}
                    <div class="hs-dobly-content">
                      <div class="doubly-message"></div>
                    </div>
                    ${shipping_rates_calculator_plus}
                  </div>`;

        if (!!body_layout) {
          body_layout.innerHTML = content_body;
        } else {
          body = `
                    <!-- HS BODY LAYOUT -->
                    <div class='hs-body-layout'>
                      ${content_body}
                    </div>
                    `;
        };

        if (!!footer_layout) {
          footer_layout.classList.remove('empty');
          footer_layout.setAttribute('aria-hidden', 'false');
        };
        if (!header_layout && !body_layout && !footer_layout) {
          content_slide = header + body + footer;
          hs_popup.innerHTML = content_slide;
        } else {
          /* var content_static = !!document.querySelector('.hs-content-static') ? document.querySelector('.hs-content-static') : '';
          if (!!content_static) {
            if (!!content_static.classList.contains('hs-empty')) {
              content_static.classList.remove('hs-empty')
            };
          }; */
          if (!!slideData.settings.minimum_order.enabled_minimum_order) {
            HsApp1.updateMinimumOrder();
          };
        };
        //hs_popup.innerHTML = header+body;
        Hs_CartDrawer.starReviews('.hs-sticky-cart');
        Hs_CartDrawer.integrationScalapay();

        HsApp1.addCompareAtPrice(iniJSON);
        HsApp1.addRechargeButton(iniJSON);
        HsApp1.buildCart(iniJSON);
        HsApp1.boomerangMehrwegpfandApp();//Boomerang Mehrwegpfand App
        !HsApp1.readCookie('hscodediscount') ? HsApp1.tieredFreeItemsProd(iniJSON, dataCart[0].arr_product_handle) : '';
        HsApp1.upsellAutomaticProducts(dataCart[0].arr_product_handle, result);
        HsApp1.dynamicUpsell(dataCart[0].arr_product_handle, result.items);
        HsApp1.staticUpsell(dataCart[0].arr_product_handle, result.items[0]);
        Hs_CartDrawer.revy_discounts();

        /* if (!!slideData.settings.gift_wrap.enabled_gift_wrap) {
          if (slideData.settings.gift_wrap.product_type === "specificProduct") {
            HsApp1.giftWrapSpecificProduct();
          }
          else {
            HsApp1.giftWrapCustomProduct();
          }
        }; */

        //CAMBIO
        (async () => {
          if (!!slideData?.settings?.gift_wrap?.enabled_gift_wrap) {
            if (slideData.settings.gift_wrap.product_type === "specificProduct") {
              await HsApp1.giftWrapSpecificProduct(iniJSON);//CAMBIO
            }
            else {
              HsApp1.giftWrapCustomProduct();
            }
          };

          /* SHIPPING PROTECTION */
          if (shipping_protection !== '') {
            await HsApp1.iniShippingProtection(result, iniJSON);
          };
        })();


        /* END SHIPPING PROTECTION */
        if (!!slideData.settings.additional_check.enabled_additional_checkout_buttons) {
          if (Shopify.PaymentButton) {
            //Shopify.PaymentButton.init();
            var hs_additional_buttons = !!document.querySelector('#hs-additional-buttons') ? document.querySelector('#hs-additional-buttons') : '';
            if (!!hs_additional_buttons) {
              if (!!hs_additional_buttons.querySelector('.dynamic-checkout__content')) {
                setTimeout(function () {
                  var a = document.querySelectorAll('.shopify-cleanslate'), element = '';
                  a.forEach(function (b) {
                    var ul = !!b.querySelector('ul') ? b.querySelector('ul') : '';
                    if (!!ul) {
                      var lis = ul.querySelectorAll('li').length > 0 ? ul.querySelectorAll('li') : [];
                      if (lis.length > 0) {
                        if (lis.length <= 3) {
                          b.classList.add('hs-simple')
                        } else {
                          b.classList.add('hs-multiple')
                        }
                      }
                    }
                  });
                  document.querySelector('#hs-additional-buttons').style.display = 'block';
                }, 1000);
              };
            }
          }
        }

        if (!!slideData.settings.additional_check.enabled_additional_checkout_buttons) {
          if (Shopify.PaymentButton) {
            var dynamic_checkout_cart = !!document.querySelector('#hs--dynamic-checkout-buttons #dynamic-checkout-cart') ? document.querySelector('#hs--dynamic-checkout-buttons #dynamic-checkout-cart') : '';
            if (!!dynamic_checkout_cart) {
              if (typeof dynamic_checkout_cart.parentNode.id !== 'undefined' && dynamic_checkout_cart.parentNode.id !== 'hs-additional-buttons') {
                if (dynamic_checkout_cart.innerHTML !== '') {
                  var hs_additional_buttons = !!document.querySelector('.hs-content-additional-buttons #hs-additional-buttons') ? document.querySelector('.hs-content-additional-buttons #hs-additional-buttons') : '';
                  if (!!hs_additional_buttons) {
                    hs_additional_buttons = hs_additional_buttons.querySelector('#dynamic-checkout-cart') || '';
                    if (!!hs_additional_buttons) {
                      //hs_additional_buttons.innerHTML = '';
                      //hs_additional_buttons.appendChild(dynamic_checkout_cart);
                      if (!!slideData.settings.minimum_order.enabled_minimum_order && !hidden_text_cart) {
                        hs_additional_buttons.style.display = 'none';
                      };
                      hs_additional_buttons.innerHTML = dynamic_checkout_cart.innerHTML;
                      try {
                        try {
                          window.hscheckoutResizeObserver.disconnect()
                        } catch (t) { }
                        window.hscheckoutResizeObserver = new ResizeObserver((e => {
                          window.Hs_dynamic_checkout();
                        }
                        )),
                          window.hscheckoutResizeObserver.observe(n)
                      } catch (t) { }
                    };
                  };
                };
              };
            };
          };
        };

        if (Hs_CartDrawer.positionDiscountCoupon) {
          let hs_content_buttons = document.querySelector('.hs-footer-layout .hs-content-buttons') || '';
          let hs_content_discount = document.querySelector('.hs-footer-layout .hs-content-discount') || '';
          let element = hs_content_discount ? hs_content_discount : hs_content_buttons
          if (!!element) {
            let footer_discount = document.querySelector('.hs-footer-layout .hs-add-discount') || '';
            if (!footer_discount) {
              element.insertAdjacentHTML("beforebegin", status_text_discount);
            };
          };
        };
      } else {
        hs_popup.classList.add('hs-popup-cart-empty')
        content_slide = header + hs_empty + footer;
        /* if (!!Hs_CartDrawer.footer_fixed) {
          
        } else {
          content_slide = header + '<div class="hs-content-static hs-empty">' + hs_empty + footer + '</div>';
        }; */
        hs_popup.innerHTML = content_slide;
        HsApp1.cartEmptyUpsell();
        Hs_CartDrawer.removeShippingGral();
      };

      const observer = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
          if (typeof mutation.target !== 'undefined') {
            //if (mutation.target.classList.contains('dynamic-checkout__content')) {
            if (!!slideData.settings.additional_check.enabled_additional_checkout_buttons) {
              if (Shopify.PaymentButton) {
                window.Hs_dynamic_checkout();
                //Shopify.PaymentButton.init();
                var hs_additional_buttons = !!document.querySelector('#hs-additional-buttons') ? document.querySelector('#hs-additional-buttons') : '';
                if (!!hs_additional_buttons) {
                  setTimeout(function () {
                    var a = document.querySelectorAll('.shopify-cleanslate'), element = '';
                    a.forEach(function (b) {
                      var ul = !!b.querySelector('ul') ? b.querySelector('ul') : '';
                      if (!!ul) {
                        var lis = ul.querySelectorAll('li').length > 0 ? ul.querySelectorAll('li') : [];
                        if (lis.length > 0) {
                          if (lis.length <= 3) {
                            b.classList.add('hs-simple')
                          } else {
                            b.classList.add('hs-multiple')
                          }
                        }
                      }
                    });
                    document.querySelector('#hs-additional-buttons').style.display = 'block';
                  }, 500);
                }
              }
            };
            //};
          };
        })
      });
      const grid_items = document.querySelectorAll('#hs-additional-buttons');
      if (grid_items.length > 0) {
        const observerOptions = {
          attributes: false,
          childList: true,
          subtree: true,
          characterData: false,
          attributeOldValue: false,
          characterDataOldValue: false
        };
        grid_items.forEach(function (grid_item) {
          observer.observe(grid_item, observerOptions);
        })
      };
    };

    if (Hs_CartDrawer.update_set_cart == 0) {
      if (typeof window.HS_SLIDE_CART_UPDATED !== 'undefined') {
        try {
          window.HS_SLIDE_CART_UPDATED(result);
        } catch (err) {
          console.log(err)
        };
      };
    };

    try {
      document.querySelectorAll('.hs-cart-image').forEach(function (img) {
        if (typeof img.dataset.hsBackupSrc !== 'undefined') {
          if (img.dataset.hsBackupSrc !== '') {
            img.onerror = function () { img.src = img.dataset.hsBackupSrc; };
          };
        };
      });
    } catch (error) {
      console.log(error);
    };

    var bundle_builder = !!document.getElementById("bundle-builder-cart-integration-box") || '';
    if (!!bundle_builder) {
      try {
        const n = new CustomEvent("BB:UPDATE:MODAL");
        document.dispatchEvent(n)
      } catch (error) {
        console.log(error)
      }
    }
    try {
      if (Hs_CartDrawer.integrationData(14)) {
        if (typeof window._rsi !== 'undefined') {
          if (typeof window._rsi.cartPage !== 'undefined') {
            if (typeof window._rsi.cartPage.init !== 'undefined') {
              window._rsi.cartPage.init();
            };
          };
        };
      };
    } catch (error) {
      console.log(error)
    };
    HsApp1.extraFunction();
  },
  updateCart: function (result, iniJSON, row = 0, triggerElement = null) {
    window.HSSLIDECART.CART = iniJSON;

    var dataCart = [],
      header = '',
      body_empty = '',
      icon_cart = '',
      total_price = parseFloat(result.total_price),
      note = result.note,
      button_shopify = '',
      one_page_checkout = 'checkout',
      status_text_slide_cart = '',
      manually_recommended_products = '',
      hidden_min_price = '',
      additional_buttons = '',
      status_text_checkout = '',
      status_text_cart = '',
      min_money = parseFloat(slideData.settings.minimum_order.minimum_order),
      min_money = min_money * 100,
      status_text_discount = '',
      status_price_checkout = '',
      status_text_note = '',
      btn_continue_shopping = '';

    if (!slideData.settings.cart_button.enabled_cart_button || !slideData.settings.checkout_button.enabled_checkout_button) {
      button_shopify = ' hs-button-100-w';
    }


    if (!!slideData.settings.checkout_button.enabled_checkout_button) {
      if (typeof opcSettings !== 'undefined' && opcSettings.enabled) {
        one_page_checkout = 'checkout_one_page';
      };

      var checkout_x = !slideData?.settings?.gift_wrap?.enabled_gift_wrap ? ` checkout-x-buy-now-btn` : ``;
      status_text_checkout = `
              <button name="${one_page_checkout}" type="submit" data-ocu-checkout="true" class="hs-checkout-purchase${button_shopify}${checkout_x}${hidden_min_price} btn">
                ${slideData.settings.checkout_button.checkout_button_text}
                <span class="hs-add--to--cart">
                  ${slideData.settings.checkout_button.checkout_button_text}
                </span>
                <span class="hs--loading">
                  <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw margin-bottom">
                  </i>
                </span>
              </button>
              `
    };

    if (!!slideData.settings.cart_button.enabled_cart_button) {
      status_text_cart = '<button title="' + slideData.settings.cart_button.cart_button_text + '" type="button" class="hs-cart-purchase' + button_shopify + '">' + slideData.settings.cart_button.cart_button_text + '</button>';
      /*if(parseInt(data.redirect_minimum_order))
      {
        status_text_cart = '';
        status_text_checkout = '<div class="hs-content-checkout-button'+button_shopify+'"><button type="button" class="hs-cart-purchase'+button_shopify+'">'+data.text_cart+'</button></div>';
      }*/
    };

    if (!!slideData.settings.cart_coupon.enabled_cart_coupon_button) {
      if (slideData.settings.cart_coupon.placeholder_cart_coupon_button) {
        status_text_discount = '<div class="hs-add-discount"> <label class="hs-discount-heading">' + slideData.settings.cart_coupon.placeholder_cart_coupon_button + '</label> <input type="text" class="hs-discount-code" name="discount" autocomplete="off"></div>';
      }
      //status_text_discount = '<div class="hs-add-discount">'+status_text_discount+'<input type="text" class="hs-discount-code" name="discount" autocomplete="off"></div>';
    };

    if (note === null) {
      note = '';
    };

    if (!!slideData.settings.cart_note.enabled_cart_note) {
      status_text_note = '<div class="hs-cart-note"><label class="hs-note-heading">' + slideData.settings.cart_note.cart_note_heading + '</label><textarea class="hs-cart-ins" name="note" autocomplete="off">' + note + '</textarea></div>';
    };

    /* TEXT MINIMUM ORDER AND CHECKOUT BUTTON */
    var item_count = iniJSON.item_count;
    var hs_checkout_purchase = !!document.querySelector('.hs-checkout-purchase') ? document.querySelector('.hs-checkout-purchase') : '';

    var hs_min_money_cart = !!document.querySelector('.hs-min-money-cart') ? document.querySelector('.hs-min-money-cart') : '';

    var data_minimum_order = HsApp1.caseMinimumOrder(result.total_price, item_count);
    hidden_min_price = data_minimum_order.hidden_min_price.trim();
    status_price_checkout = data_minimum_order.status_price_checkout;
    hidden_text_cart = data_minimum_order.hidden_text_cart.trim();

    if (!!hs_checkout_purchase) {
      setTimeout(function () {
        if (typeof minMaxify !== 'undefined') { //minMaxify
          if (typeof minMaxify.checkLimits !== 'undefined') {
            if (!minMaxify.checkLimits()) {
              hs_checkout_purchase.setAttribute('disabled', '')
            } else {
              hs_checkout_purchase.removeAttribute('disabled')
            }
          };
        };
      }, 500);
      hidden_min_price === '' ? hs_checkout_purchase.classList.remove('hs-hidden-min-price') : hs_checkout_purchase.classList.add(hidden_min_price);
      //hidden_min_price !== '' && hs_checkout_purchase.classList.add(hidden_min_price);
    };

    if (!!hs_min_money_cart) {
      hidden_text_cart === '' ? hs_min_money_cart.classList.remove('hs-hidden-min-price') : hs_min_money_cart.classList.add(hidden_text_cart);
      hs_min_money_cart.innerHTML = status_price_checkout;
    };
    /**************************************************/
    dataCart = HsApp1.jsonCart(result);

    HsApp1.disableCheckout(0);//CAMBIO

    var hs_empty = !!HsApp1.cartEmpty(result.item_count, 1) ? HsApp1.cartEmpty(result.item_count, 1) : `<div class="hs-content-empty-cart">
              ${slideData.settings.language_settings.cart_empty_text_language_settings}
            </div>`;
    var hs_popup = !!document.querySelector('.hs-popup-cart-sp-load .hs-site-cart-popup-layout') ? document.querySelector('.hs-popup-cart-sp-load .hs-site-cart-popup-layout') : '';
    let hs_sticky_cart = document.querySelector('.hs-sticky-cart') || '';
    if (result.item_count > 0) {
      if (hs_sticky_cart) {
        const totalSavings = HsApp1.getCartTotalSavings(HSSLIDECART.CART);
        const totalSavingsCurrency = totalSavings > 0
          ? hsonslidecart.Currency.formatMoney(
              totalSavings,
              slideData.settings.devices.money_format
            )
          : '';
        const totalYouSave = totalSavings > 0
          ? `<div class="hs-total-save">You Saved ${totalSavingsCurrency}!</div>`
          : '';
        hs_sticky_cart.classList.remove('hs-adding-prod');
        hs_sticky_cart.innerHTML = dataCart[0].htmlCart+totalYouSave;
      };
      HsApp1.buildCart(iniJSON);
      !HsApp1.readCookie('hscodediscount') ? HsApp1.tieredFreeItemsProd(iniJSON, dataCart[0].arr_product_handle) : '';
      if (!row) {
        HsApp1.upsellAutomaticProducts(dataCart[0].arr_product_handle, result);
        HsApp1.dynamicUpsell(dataCart[0].arr_product_handle, result.items);
        HsApp1.staticUpsell(dataCart[0].arr_product_handle, result.items[0]);
      };
    } else {
      if (!!hs_popup) {
        hs_popup.classList.add('hs-popup-cart-empty');
        if (document.querySelector('.hs-sticky-cart-countdown')) {
          document.querySelector('.hs-sticky-cart-countdown').style.display = 'none';//STICKY CART COUNTDOWN
        };

        if (!!HsApp1.readCookie('hs-giftWrap-check') || !!HsApp1.readCookie('hs-giftWrap-variantId') || !!HsApp1.readCookie('hs-giftWrap-variantPrice') || !!HsApp1.readCookie('hs-giftWrap-variantCompareAtPrice') || !!HsApp1.readCookie('hscodediscount') || !!HsApp1.readCookie('hs-shipping-protection') || !!HsApp1.readCookie('hs-shipping-protection-auto-add')) {
          HsApp1.deleteCookie('hs-giftWrap-check');
          HsApp1.deleteCookie('hs-giftWrap-variantId');
          HsApp1.deleteCookie('hs-giftWrap-variantPrice');
          HsApp1.deleteCookie('hs-giftWrap-variantCompareAtPrice');
          HsApp1.deleteCookie('hs-shipping-protection');
          HsApp1.deleteCookie('hs-shipping-protection-auto-add');
          HsApp1.deleteCookie('hscodediscount');
        };
        HsApp1.checkoutPage = '';
        /* var content_static = !!document.querySelector('.hs-content-static') ? document.querySelector('.hs-content-static') : '';
        if (!!content_static) {
          if (!content_static.classList.contains('hs-empty')) {
            content_static.classList.add('hs-empty')
          };
        }; */
        var body_layout = !!document.querySelector('.hs-body-layout') ? document.querySelector('.hs-body-layout') : '';
        if (!!body_layout) {
          body_layout.innerHTML = hs_empty;
        };
        var footer_layout = !!document.querySelector('.hs-footer-layout') ? document.querySelector('.hs-footer-layout') : '';
        if (!!footer_layout) {
          footer_layout.classList.add('empty');
          footer_layout.setAttribute('aria-hidden', 'true');
        };

        if (Hs_CartDrawer.positionDiscountCoupon) {
          let hs_finalize_purchase = document.querySelector('.hs-finalize-purchase') || ''
          if (hs_finalize_purchase) {
            var discount_element = hs_finalize_purchase.querySelector('.hs-add-discount') || '';
            if (discount_element) {
              discount_element.remove();
            }
          };
        };

        let hs_sticky_cart_countdown = document.querySelector('.hs-sticky-cart-countdown') || '';
        if (hs_sticky_cart_countdown) {
          hs_sticky_cart_countdown.style.display = 'none';
        };

        var price_rewards = HsApp1.rewardsExcludeProd(result);
        HsApp1.rewardsBar(price_rewards);
        HsApp1.cartEmptyUpsell();
        Hs_CartDrawer.removeShippingGral();
      }
    };
    Hs_CartDrawer.starReviews('.hs-sticky-cart');
    HsApp1.addCompareAtPrice(iniJSON);
    HsApp1.addRechargeButton(iniJSON);
    Hs_CartDrawer.revy_discounts();

    try {
      document.querySelectorAll('.hs-cart-image').forEach(function (img) {
        if (typeof img.dataset.hsBackupSrc !== 'undefined') {
          if (img.dataset.hsBackupSrc !== '') {
            img.onerror = function () { img.src = img.dataset.hsBackupSrc; };
          };
        };
      });
    } catch (error) {
      console.log(error);
    };

    try {
      if (!!slideData.settings.additional_check.enabled_additional_checkout_buttons) {
        if (Shopify.PaymentButton) {
          var add_buttons = !!document.querySelector('#hs-additional-buttons') ? document.querySelector('#hs-additional-buttons') : '';
          if (!!add_buttons) {
            window.Hs_dynamic_checkout();
            var dynamic_checkout_content = !!add_buttons.querySelector('.dynamic-checkout__content') ? add_buttons.querySelector('.dynamic-checkout__content') : '';
            if (!status_price_checkout) {
              if (!!dynamic_checkout_content) {
                dynamic_checkout_content.style.display = 'block';
              };
            } else {
              if (!!dynamic_checkout_content) {
                dynamic_checkout_content.style.display = 'none';
              };
            };
          };
        };
      };
    } catch (error) {

    }

    if (Hs_CartDrawer.update_set_cart == 0) {
      if (typeof window.HS_SLIDE_CART_UPDATED !== 'undefined') {
        try {
          window.HS_SLIDE_CART_UPDATED(result);
        } catch (err) {
          console.log(err)
        };
      };
    };
    var bundle_builder = !!document.getElementById("bundle-builder-cart-integration-box") || '';
    if (!!bundle_builder) {
      try {
        const n = new CustomEvent("BB:UPDATE:MODAL");
        document.dispatchEvent(n)
      } catch (error) {
        console.log(error)
      }
    }

    HsApp1.extraFunction();
  },
  openCart: function (triggeredBy = '') {
    if (triggeredBy) Hs_CartDrawer.setActiveElement(triggeredBy);

    const _html = document.querySelector('html') || '';
    if (_html) {
      _html.classList.add('hs-open-drawer');
    };

    const _body = document.querySelector('body') || '';
    if (_body) {
      _body.classList.add('hs-open-cart');
    };

    const hs_load_popup_cart_show_products = document.querySelector('.hs-load-popup-cart-show-products') || '';
    if (hs_load_popup_cart_show_products) {
      hs_load_popup_cart_show_products.style.display = 'block'
    };

    const cartDrawer = document.querySelector('.hs-popup-cart-sp-load') || '';
    if (cartDrawer) {
      cartDrawer.classList.add('hs-active');
      //cartDrawer.style.setProperty('visibility', 'visible', 'important');
      cartDrawer.setAttribute('aria-hidden', "false")
    };

    var checkGift = !!document.querySelector('.hs-gift-wrap-check') ? document.querySelector('.hs-gift-wrap-check') : '';
    var hs_footer_layout = document.querySelector('.hs-footer-layout') || '';
    if (!!hs_footer_layout) {
      var hs_product_option = !!document.querySelector('.hs-product-option') ? document.querySelector('.hs-product-option') : '';
      if (!!hs_product_option) {
        var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
        var hs_popUp_product = !!hs_product_option.querySelector('.hs-popUp-product') ? hs_product_option.querySelector('.hs-popUp-product') : '';
        if ((!!hs_popUp_overlay && !!hs_popUp_product && !!checkGift.checked && !HsApp1.readCookie('hs-giftWrap-variantPrice') && !HsApp1.readCookie('hs-giftWrap-variantId') && !HsApp1.readCookie('hs-giftWrap-check-specific')) || (HsApp1.arr_variants_popup.length > 0)) {

          hs_product_option.style.display = 'block';
          setTimeout(function () {
            if (!!hs_popUp_product) {
              hs_popUp_overlay.classList.add('hs-popUp-active');
              hs_popUp_product.classList.add('hs-popUp-active');
            }
          }, 300);
        }
      }
    };
    HsApp1.viewChatShopify();
    HsApp1.viewSmileUiWidget();

    // if (typeof window.OCUApi !== 'undefined' && typeof window.Zipify !== 'undefined') {
    //   if (typeof window.Zipify.OCU !== 'undefined') {
    //     if (typeof window.OCUDisableEvents === 'undefined') {
    //       window.OCUDisableEvents = [];
    //     };
    //   };
    // };

    if (typeof window.HS_SLIDE_CART_OPENED !== 'undefined') {
      try {
        window.HS_SLIDE_CART_OPENED();
      } catch (err) {
        console.log(err)
      };
    };

    try {
      window.Hs_hidden_cart_store();
    } catch (error) {
      console.log(error);
    };

    if (typeof window.Hs_updateLiveRegion === 'function') {
      const liveRegionMessage = typeof window?.HSSLIDECART?.CART?.item_count !== 'undefined' ? `Opening the cart. There are ${window?.HSSLIDECART?.CART?.item_count} items in your cart.` : '';
      window.Hs_updateLiveRegion(liveRegionMessage);
    };

    document.querySelector('.hs-site-cart-popup-layout')?.addEventListener(
      'transitionend',
      () => {
        Hs_CartDrawer.focusOnCartDrawer();
      },
      { once: true }
    );
  },
  closeCart: function () {
    const cartDrawer = document.querySelector('.hs-popup-cart-sp-load') || '';

    if (cartDrawer) {
      cartDrawer.classList.remove('hs-active');
      cartDrawer.setAttribute('aria-hidden', "true");
      // setTimeout(function () {
      //   !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load').style.setProperty('visibility', 'hidden', 'important') : '';
      // }, 249);
    };

    const _html = document.querySelector('html') || '';
    if (_html) {
      _html.classList.remove('hs-open-drawer');
    };

    const _body = document.querySelector('body') || '';
    if (_body) {
      _body.classList.remove('hs-open-cart');
    };

    var hs_footer_layout = document.querySelector('.hs-footer-layout') || '';
    if (!!hs_footer_layout) {
      var hs_product_option = !!document.querySelector('.hs-product-option') ? document.querySelector('.hs-product-option') : '';
      if (!!hs_product_option) {
        var hs_popUp_overlay = !!hs_product_option.querySelector('.hs-popUp-overlay') ? hs_product_option.querySelector('.hs-popUp-overlay') : '';
        var hs_popUp_product = !!hs_product_option.querySelector('.hs-popUp-product') ? hs_product_option.querySelector('.hs-popUp-product') : '';
        if (!!hs_popUp_overlay && !!hs_popUp_product) {
          hs_product_option.style.display = 'none';
          var hs_popUp_product = !!hs_product_option.querySelector('.hs-popUp-product') ? hs_product_option.querySelector('.hs-popUp-product') : '';
          if (!!hs_popUp_product) {
            hs_popUp_overlay.classList.remove('hs-popUp-active');
            hs_popUp_product.classList.remove('hs-popUp-active');
          }
        }
      }
    }
    HsApp1.viewChatShopify();
    HsApp1.viewSmileUiWidget();
    // if (typeof window.OCUApi !== 'undefined' && typeof window.Zipify !== 'undefined') {
    //   if (typeof window.Zipify.OCU !== 'undefined') {
    //     if (typeof window.OCUDisableEvents !== 'undefined') {
    //       if (typeof window.OCUDisableEvents === 'object') {
    //         if (window.OCUDisableEvents.length == 0) {
    //           window.OCUDisableEvents = undefined;
    //         };
    //       };
    //     };
    //   };
    // };

    //Hs_CartDrawer.removeTrapFocus(window.hsActiveElement || '');
    if (typeof window.HS_SLIDE_CART_CLOSED !== 'undefined') {
      try {
        window.HS_SLIDE_CART_CLOSED();
      } catch (err) {
        console.log(err)
      };
    };

    Hs_CartDrawer.removeTrapFocus(window.hsActiveElement);
    if (typeof window.Hs_updateLiveRegion === 'function') {
      const liveRegionMessage = 'Closing the cart.';
      window.Hs_updateLiveRegion(liveRegionMessage);
    };
  },
  HideCart: function () {
    !!document.querySelector(`.hs-popup-cart-sp-load.hs-cart-drawer-${slideData.settings.devices.cart_type}.hs-desktop-content-cart`) ? document.querySelector(`.hs-popup-cart-sp-load.hs-cart-drawer-${slideData.settings.devices.cart_type}.hs-desktop-content-cart`).classList.remove('hs-active') : '';

    !!document.querySelector(`.hs-popup-cart-sp-load.hs-cart-drawer-${slideData.settings.devices.cart_type}.hs-desktop-content-cart`) ? document.querySelector(`.hs-popup-cart-sp-load.hs-cart-drawer-${slideData.settings.devices.cart_type}.hs-desktop-content-cart`).setAttribute('aria-hidden', "true") : '';
    // setTimeout(function () {
    //   !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load').style.setProperty('visibility', 'hidden', 'important') : '';
    // }, 249);
  },
  resizeCart: function () {
    if (window.innerWidth < 770) {
      !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load').classList.remove('hs-desktop-content-cart') : '';
      !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load').classList.add('hs-mobile-content-cart') : '';
    } else {
      !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load').classList.remove('hs-mobile-content-cart') : '';
      !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load').classList.add('hs-desktop-content-cart') : '';
    }
  },
  resizeSlideCart: function () {
    HsApp1.resizeCart();
    HsApp1.removePrefixRewards();
    window.addEventListener('resize', function (e) {
      HsDelay(function () {
        let index = HsApp1.readCookie('hs_sl_prefix_rewards') == undefined ? 0 : parseInt(HsApp1.readCookie('hs_sl_prefix_rewards'));
        HsApp1.resizeCart();
        HsApp1.viewRewardsProducts(index, 1);
      }, 200);
    });
  },
  removePrefixRewards: function () {
    HsApp1.setCookie('hs_sl_prefix_rewards', 0, 360);
  },
  redirectCart: function () {
    var d = new Date(), n = d.getTime(), cart = '/cart';
    if (!!window.Shopify) {
      if (!!window.Shopify.routes) {
        if (!!window.Shopify.routes.root) {
          if (window.Shopify.routes.root !== '/') {
            cart = window.Shopify.routes.root.concat('cart');
          };
        };
      };
    };
    window.location.href = `${cart}?` + n;
  },
  updateAdditionalNote: function (note = '') {
    var space = 'ㅤ', line_break = '';
    if (note === null) {
      note = '';
    };
    var arr_note = { note: note, update_note: false }
    var note_static = '';
    /* if (note !== '') { */
    var spacing = note.indexOf('ㅤ');
    if (spacing > -1) {//if the additional static note was already added
      arr_note.note = note.substr(0, spacing);
      note_static = '';
      arr_note.update_note = true;
    } else {
      if (!!window.hs_content) {
        var hs_front_check_additional_note = !!window.hs_content.querySelector('.hs_front_check_additional_note') ? window.hs_content.querySelector('.hs_front_check_additional_note') : '';
        if (hs_front_check_additional_note) {
          if (!!hs_front_check_additional_note.checked) {
            note_static = slideData.settings.cart_note.cart_note_additional_message;
            if (note_static !== '') {
              line_break = note === '' ? '' : '\n\n\n'
              line_break = space + line_break;
            };
          };
        };
      };
    }
    /* }; */
    arr_note.note = arr_note.note + line_break + note_static
    return arr_note;
  },
  fetchUpdateCart: function (level, discount, note, where, giftStatus) {
    note = HsApp1.updateAdditionalNote(note);
    note = note.note;
    var myJSON = {}, cart = Hs_CartDrawer.routeLocale('cart/update.js');
    var mwgrouped = Hs_CartDrawer.mwgrouped();
    fetch(cart + mwgrouped, {
      method: 'POST',
      body: JSON.stringify({ note: note }),
      headers: {
        'Accept': "application/json, text/javascript",
        'Content-Type': "application/json, text/javascript",
        'X-Requested-With': 'XMLHttpRequest'
      },
    })
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then((json) => {
        var d = new Date(), n = d.getTime(), jsontext = JSON.stringify(json), languageCheckout = '';
        let items = json.items || [];
        const languageWeglot = typeof window.Weglot !== 'undefined' ? (Weglot.getCurrentLang() || '') : '';

        if (items.length > 0) {
          const filteredItems = items.filter(item => {//App Bundle Builder
            return item.properties && typeof item.properties === 'object' && item.properties.hasOwnProperty('_bundle_id');
          }) || [];

          if (filteredItems.length > 0) {
            const e = document.createElement("form");
            e.setAttribute("action", '/apps/bundles/cart'), e.setAttribute("method", "POST");
            const r = document.createElement("input");
            r.setAttribute("type", "hidden"), r.setAttribute("name", "_cart"), r.setAttribute("value", jsontext), e.appendChild(r);
            const c = document.createElement("input");
            c.setAttribute("type", "hidden"), c.setAttribute("name", "_shop"), c.setAttribute("value", window.Shopify.shop), e.appendChild(c), document.body.appendChild(e), e.submit();
            return false;
          };
        };

        if (languageWeglot) {
          languageCheckout = '?locale=' + Weglot.getCurrentLang();
        };

        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          json = window.BOLD.common.cartDoctor.fix(json);

          if (JSON.stringify(json).indexOf('frequency_type_text') > -1) {
            var hs_checkout_bold = !!document.querySelector('#hs-checkout-bold') ? document.querySelector('#hs-checkout-bold') : '';
            if (!!hs_checkout_bold) {
              /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
              hs_checkout_bold.dispatchEvent(ev); */
              hs_checkout_bold.click();
            }
            setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 2000);
            return false;
          }
        };

        var recurpay_checkout = !!document.querySelector('.hs-footer-layout').querySelector('input[id="recurpay-checkout"]') ? document.querySelector('.hs-footer-layout').querySelector('input[id="recurpay-checkout"]') : '';
        if (!!recurpay_checkout) {
          if (typeof recurpay_checkout.dataset.value !== 'undefined') {
            var checkoutRecurpay = false;
            for (var i = 0; i < json.items.length; i++) {
              var item = json.items[i],
                property = item.properties;
              if (property) {
                if (property._PlanId) {
                  checkoutRecurpay = true;
                }
              }
            };
            if (checkoutRecurpay) {
              if (recurpay_checkout.dataset.value === 'default') {
                var customer_session = !!document.querySelector('.hs-customer-session') ? document.querySelector('.hs-customer-session') : '';
                if (!!customer_session) {
                  var checkout = !!customer_session.querySelector("input[name='checkout']") ? customer_session.querySelector("input[name='checkout']") : '';
                  if (!!checkout) {
                    /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
                    checkout.dispatchEvent(ev); */
                    checkout.click();
                    return false;
                  };
                };
              } else {
                /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
                recurpay_checkout.dispatchEvent(ev); */
                recurpay_checkout.click();
                setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 8000);
                return false;
              };
            };
          };

        };

        if (typeof window.conversionBundlesBear !== 'undefined') {
          var hs_checkout_bold = !!document.querySelector('#hs-checkout-bold') ? document.querySelector('#hs-checkout-bold') : '';
          if (!!hs_checkout_bold) {
            /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
            hs_checkout_bold.dispatchEvent(ev); */
            hs_checkout_bold.click();
          }
          setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 2000);
          return false;
        };
        discount = encodeURIComponent(discount);
        if (json) {
          if (typeof window.opcLoadCart !== 'undefined' && typeof opcSettings !== 'undefined' && opcSettings.enabled) {
            window.opcLoadCart();
            setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 2000);
            return false;
          }

          if (level == 0) {
            HsApp1.redirectCart();
            setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 2000);
          } else {
            if (jsontext.indexOf('shipping_interval_frequency') > -1) {
              function get_cookie(name) { return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2] }
              do {
                var token = get_cookie('cart');
              }
              while (token == undefined);
              var myshopify_domain = Shopify.shop;
              var customer_id = '';
              var customer_email = '';
              var customer_param = '';
              var hs_subscriptions_customer_id = !!document.querySelector('#hs_subscriptions_customer_id') ? document.querySelector('#hs_subscriptions_customer_id') : '';
              if (!!hs_subscriptions_customer_id) {
                customer_id = !!document.querySelector('#hs_subscriptions_customer_id') ? document.querySelector('#hs_subscriptions_customer_id').value : '';
                customer_email = !!document.querySelector('#hs_subscriptions_customer_email') ? document.querySelector('#hs_subscriptions_customer_id').value : '';
                customer_param = '&customer_id=' + customer_id + '&customer_email=' + customer_email;
              }

              try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch (err) { var ga_linker = '' }
              var checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + customer_param + "&discount=" + discount;
              window.location.href = checkout_url;
              setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 2000);
            } else {
              if (giftStatus > 0) {
                switch (giftStatus) {
                  case 1:
                    HsApp1.getCartOrder('custom');
                    break;
                  case 2:
                    HsApp1.getCartOrder('specific');
                    break;
                }
                setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 3000);
                return false;
              };
              if (discount !== '') {
                if (languageWeglot) {
                  languageCheckout = '&locale=' + Weglot.getCurrentLang();
                }
                discount = '?discount=' + discount + languageCheckout;
              } else {
                if (languageCheckout !== '') {
                  discount = discount + languageCheckout;
                }
                else {
                  if (discount !== '') {
                    discount = "?discount=" + discount
                  }

                }
              }
              var shopifyRoot = '/';
              if (!!window.Shopify) {
                if (!!window.Shopify.routes) {
                  if (!!window.Shopify.routes) {
                    if (!!window.Shopify.routes.root) {
                      if (window.Shopify.routes.root !== '/') {
                        shopifyRoot = window.Shopify.routes.root;
                      }
                    }
                  }
                }
              };
              if (HsApp1.checkoutPage !== '') {
                if (languageWeglot) {
                  languageCheckout = '?locale=' + Weglot.getCurrentLang();
                }
              } else {
                if (Hs_CartDrawer.integrationData(12)) {
                  let thisCatch = shopifyRoot + 'checkout' + discount + languageCheckout;
                  Hs_CartDrawer.checkoutChamps(thisCatch)
                  return false;
                };
              };

              let urlRedirect = shopifyRoot + 'checkout' + discount;
              let shopStore = '';
              if (HsApp1.checkoutPage !== '') {
                urlRedirect = HsApp1.checkoutPage.web_url + languageCheckout;
                if (window.Shopify) {
                  if (window.Shopify.shop) {
                    if (window.Shopify.shop) {
                      shopStore = window.Shopify.shop;
                    };
                  };
                };
                //592cf1.myshopify.com
                const shopExclude = ['dynastymattress.myshopify.com'];
                let store = shopExclude.find(element => element == shopStore);
                if (!store) {
                  let url = HsApp1.checkoutPage.web_url || '';
                  if (url) {
                    let shopId = '';
                    var shopifyFeatures = !!document.getElementById("shopify-features") ? document.getElementById("shopify-features").innerHTML : '';
                    if (!!shopifyFeatures) {
                      shopifyFeatures = JSON.parse(shopifyFeatures);
                      if (typeof shopifyFeatures.shopId !== 'undefined') {
                        shopId = shopifyFeatures.shopId;
                      };
                    };
                    if (shopId) {
                      if (url.indexOf(shopId + '/') > -1) {
                        url = url.replace(shopId + '/', '');
                      };
                      if (url.indexOf('checkouts/') > -1) {
                        url = url.replace('checkouts/', 'checkouts/co/');
                      };
                      if (languageCheckout === '') {
                        var locale = HsApp1.checkoutPage.customer_locale || '';
                        if (locale) {
                          languageCheckout = '?locale=' + locale;
                        };
                      };
                      urlRedirect = url + languageCheckout;
                    };
                  };
                };
              };
              window.location.href = urlRedirect;
            };
          };
        };
      }).catch(err => {
        console.log(err);
        var hs_customer_session_btn = document.querySelector('.hs-customer-session') || '';
        if (hs_customer_session_btn) {
          var checkout = hs_customer_session_btn.querySelector("input[name='checkout']") || '';
          if (checkout) {
            checkout.click();
            return false;
          };
        }
      }).then(function () {
        setTimeout(function () { where.classList.remove('hs-loading-btn'); }, 2500);
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.eventEmitter !== 'undefined'
          && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', myJSON);
        }
      });
  },

  buttonCheckout: async function (where, e = '') {
    var elementTerms = !!document.querySelector('.hs_front_check_agreed') ? document.querySelector('.hs_front_check_agreed') : '',
      elementDiscount = !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code') : '',
      elementNote = !!document.querySelector('textarea.hs-cart-ins') ? document.querySelector('textarea.hs-cart-ins') : '',
      discount = HsApp1.checkoutPage !== '' ? elementDiscount.value : '',
      note = elementNote.value,
      giftStatus = 0,
      checkoutStatus = 0;
    where.setAttribute('style', `min-height:${where.offsetHeight}px !important`);
    where.classList.add('hs-loading-btn');
    if (!elementDiscount) {
      discount = '';
    };
    if (!!elementTerms) {
      if (!elementTerms.checked) {
        setTimeout(function () {

          try {
            Hs_modal_notification('Terms', slideData.settings.terms_conditions.notify_terms, slideData);
          } catch (error) {
            alert(slideData.settings.terms_conditions.notify_terms);
          }
          where.classList.remove('hs-loading-btn');
        }, 200);
        return false;
      }
    };

    function removeLoadingCheckout(button) {
      setTimeout(function () {
        button.classList.remove('hs-loading-btn');
      }, 2000);
    };

    function thisCheckout() {
      var customer_session = !!document.querySelector('.hs-customer-session') ? document.querySelector('.hs-customer-session') : '';
      if (!!customer_session) {
        var checkout = !!customer_session.querySelector("input[name='checkout']") ? customer_session.querySelector("input[name='checkout']") : '';
        if (!!checkout) {
          if (!!checkout.classList.contains('kodrite_p24')) {
            /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
            checkout.dispatchEvent(ev); */
            checkout.click();
            return false;
          }
        };
      };

      if (typeof window.cartEndpoint !== 'undefined') {
        if (window.cartEndpoint.indexOf('.mycartpanda.com/shopify/cart') > -1) {
          window.location.href = '/cart';
          return false;
        }
      };

      /* RazorPay */
      var razorpayIntegration = Hs_CartDrawer.integrationData(9);
      if (!!razorpayIntegration) {
        if (typeof window.openRzpCheckout !== 'undefined' && typeof window.openRzpCheckout === 'function') {
          var razorpay_backdrop = !!document.querySelector('.razorpay-backdrop') && document.querySelector('.razorpay-backdrop');
          var razorpay_checkout_frame = !!document.querySelector('.razorpay-checkout-frame') && document.querySelector('.razorpay-checkout-frame')
          if (!!razorpay_backdrop && !!razorpay_checkout_frame) {
            setTimeout(function () {
              where.classList.remove('hs-loading-btn');
              var _button = document.createElement("button");
              _button.onclick = function () {
                window.openRzpCheckout(event);
                Hs_CartDrawer.closeCart();
                return false;
              };
              /* var ev = new Event("click", { "bubbles": true, "cancelable": false });
              _button.dispatchEvent(ev); */
              _button.click();
            }, 500);
            return false;
          };
        };
      };

      var identify = 0;
      var hs_gift_wrap_custom = !!document.querySelector('.hs-gift-wrap-custom') ? document.querySelector('.hs-gift-wrap-custom') : '';
      if (!!hs_gift_wrap_custom) {
        var hs_gift_wrap_check = !!hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') : '';
        if (!!hs_gift_wrap_check) {
          if (!!hs_gift_wrap_check.checked) {
            giftStatus = 1;
          };
        };
      };
      /* SHIPPING PROTECTION */
      function getvals() {
        var cart = Hs_CartDrawer.routeLocale(`cart.js`);
        return fetch(`${cart}`,
          {
            method: "GET",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          })
          .then((response) => response.json())
          .then((responseData) => {
            if (typeof window.BOLD !== 'undefined'
              && typeof window.BOLD.common !== 'undefined'
              && typeof window.BOLD.common.cartDoctor !== 'undefined') {
              // NOTE: "cart" should be the variable containing the cart json data
              responseData = window.BOLD.common.cartDoctor.fix(responseData);
            };
            return responseData;
          })
          .catch(error => console.warn(error));
      }

      function changevals(key) {
        var cart = Hs_CartDrawer.routeLocale(`cart/change.js`);
        var mwgrouped = Hs_CartDrawer.mwgrouped();
        return fetch(`${cart}${mwgrouped}`,
          {
            body: JSON.stringify({ id: key, quantity: 1 }),
            method: 'POST',
            headers: {
              'Accept': "application/json, text/javascript",
              'Content-Type': "application/json, text/javascript",
              'X-Requested-With': 'XMLHttpRequest'
            },
          })
          .then((response) => response.json())
          .then((responseData) => {
            return responseData;
          })
          .catch(error => console.warn(error));
      }

      function thisvalidate(json) {
        var count = 0, prodInCart = false, qty = 0, key = '';
        json.items.forEach(function (item) {
          count++;
          if (parseInt(item.id) == parseInt(slideData.settings.shipping_protection.sp_featured_product_shopify_id_variant)) {
            if (item.properties != null) {
              if (!!item.properties._shippingProtection) {
                prodInCart = true;
                qty = item.quantity;
                key = item.key
              };
            };
          };
        });
        if (count == json.items.length) {
          if (!!prodInCart && qty > 1) {
            changevals(key).then(() => HsApp1.fetchUpdateCart(1, discount, note, where, giftStatus));
          }
          else {
            HsApp1.fetchUpdateCart(1, discount, note, where, giftStatus)
          }
        };
      };

      if (typeof slideData.settings.shipping_protection !== 'undefined') {
        var dataShipping = slideData.settings.shipping_protection;
        if (!!dataShipping.enabled_shipping_protection) {
          if (!!HsApp1.readCookie('hs-shipping-protection')) {
            checkoutStatus = 1;
          };
        }
      };

      if (!!checkoutStatus) {
        getvals().then(response => thisvalidate(response));
      } else {
        HsApp1.fetchUpdateCart(1, discount, note, where, giftStatus)
      };
    };

    if (typeof window.HS_SLIDE_CART_CHECKOUT_CLICKED !== 'undefined') {
      try {
        window.HS_SLIDE_CART_CHECKOUT_CLICKED();
      } catch (err) {
        console.log(err)
      };
    };

    if (typeof window.HS_SLIDE_CART_CHECKOUT_STOP !== 'undefined') {
      try {
        window.HS_SLIDE_CART_CHECKOUT_STOP();
        removeLoadingCheckout(where);
        return false;
      } catch (err) {
        console.log(err)
      };
    };

    // Paso previo: Onward (ID 41)
    if (Hs_CartDrawer.integrationData(41) && typeof window.onwardApp?.fixInsuranceAndProceed === "function") {
      try {
        await window.onwardApp.fixInsuranceAndProceed();
        // No hace checkout aún, solo agrega el producto
      } catch (err) {
        console.warn("Onward fail", err);
      }
    };

    // Lista de integraciones en orden (37 → 40)
    const integrations = [
      {
        id: 15, // YAMPI
        check: () => {
          if (typeof window.yampiClick !== 'undefined' && typeof window.yampiClick === 'function') {
            return () => window.yampiClick();
          }
          return null;
        },
        run: (fn) => {
          fn();
          Hs_CartDrawer.closeCart();
          removeLoadingCheckout(where);
        }
      },
      {
        id: 37, // Lucent OTP
        check: () => {
          const otp = window?.simplyOtp;
          const otpSettings = window?.simplyOtp;
          if (!otp || !otpSettings) return null;
          if (!otpSettings?.new_popup_design) return null;
          if (typeof otp?.openPopup === "function") return otp?.openPopup;
          if (typeof otp?.sotpPopUpOpen === "function") return otp?.sotpPopUpOpen;
          return null;
        },
        run: (fn) => {
          fn();
          Hs_CartDrawer.closeCart();
          removeLoadingCheckout(where);
        }
      },
      {
        id: 38, // Gokwik
        check: () => {
          if (typeof window.gkShopDomain !== "undefined" && typeof window.initiateLogin === "function") {
            return () => window.initiateLogin();
          }
          if (typeof window.gokwikSdk !== "undefined" && typeof window.onCheckoutClick === "function") {
            return () => window.onCheckoutClick(where);
          }
          return null;
        },
        run: (fn) => {
          fn();
          Hs_CartDrawer.closeCart();
          removeLoadingCheckout(where);
        }
      },
      {
        id: 39, // Shopflo
        check: () => {
          if (window.Shopflo?.isFloCheckoutEnabled && typeof window.handleFloCheckoutBtn === "function") {
            return () => window.handleFloCheckoutBtn();
          }
          return null;
        },
        run: async (fn) => {
          try {
            await fn();
            removeLoadingCheckout(where);
            Hs_CartDrawer.closeCart();
          } catch (err) {
            thisCheckout();
          }
        }
      },
      {
        id: 40, // Shiprocket
        check: () => {
          const allowedCountries = window.shiprocket;
          const country = window.HSSLIDECART?.localCountryCode;

          // si NO existe config → Shiprocket siempre activo
          const isShiprocketActive =
            !Array.isArray(allowedCountries) ||
            (country &&
              allowedCountries
                .map(c => c.toUpperCase())
                .includes(country.toUpperCase()));

          // if (typeof window.shiprocketCheckoutEvents?.buyCart === "function") {
          //     return (e) => window.shiprocketCheckoutEvents.buyCart(e);
          // }
          // if (typeof window.HeadlessCheckout?.checkout === "function") {
          //     return (e) => window.HeadlessCheckout.checkout(e);
          // }

          if (isShiprocketActive) {

            const handler =
              window.shiprocketCheckoutEvents?.buyCart ||
              window.HeadlessCheckout?.checkout;

            if (typeof handler === "function") {
              return (e) => handler(e);
            }

            return null;
          }
        },
        run: (fn) => {
          try {
            if (e) {
              fn(e);
              Hs_CartDrawer.closeCart();
              removeLoadingCheckout(where);
            } else {
              thisCheckout();
            }
          } catch {
            thisCheckout();
          }
        }
      },
      {
        id: 42, // Zecpe (One Click Checkout CashFree Payments)
        check: () => (typeof window.handleOcc === "function" ? window.handleOcc : null),
        run: (fn) => {
          try {
            fn(where);
            removeLoadingCheckout(where);
          } catch {
            thisCheckout();
          }
        }
      },
      {
        id: 43, // Breeze
        check: () => {
          const breeze_script = document.getElementById("breeze-script-tag");
          if (breeze_script && typeof window.breeze?.startCheckout === "function") {
            return () => window.breeze.startCheckout();
          }
          return null;
        },
        run: (fn) => {
          try {
            fn();
            removeLoadingCheckout(where);
          } catch {
            thisCheckout();
          }
        }
      },
      {
        id: 44, // Stripe
        check: () => (typeof window.stripe_checkout === "function" ? window.stripe_checkout : null),
        run: (fn) => {
          try {
            fn(where);
            // Hs_CartDrawer.closeCart();
            removeLoadingCheckout(where);
          } catch {
            thisCheckout();
          }
        }
      }
    ];

    // Recorrer integraciones
    for (const integration of integrations) {
      if (Hs_CartDrawer.integrationData(integration.id)) {
        //console.log(`Checking integration ID ${integration.id}`);
        const fn = integration.check();
        if (typeof fn === "function") {
          try {
            integration.run(fn);
            return false; // Se detiene el flujo
          } catch (error) {
            thisCheckout();
          };
        };
      };
    };

    if (typeof window.$th_bundle_cart_active_bundles_value !== 'undefined') {//???
      if (typeof window.$th_bundle_cart_active_bundles_value === 'object') {
        try {
          if (window.$th_bundle_cart_active_bundles_value.length > 0) {
            var hs_customer_session_btn = document.querySelector('.hs-customer-session') || '';
            if (hs_customer_session_btn) {
              var checkout = hs_customer_session_btn.querySelector("input[name='checkout']") || '';
              if (checkout) {
                checkout.click();
                return false;
              };
            }
          };
          thisCheckout();
        } catch (error) {
          thisCheckout();
        };
        return false;
      };
    };

    // Si ninguna integración aplica entonces va al checkout normal
    thisCheckout();
  },
  hideCartPopup: function () {

    var hs_checkout_purchase = !!document.querySelector('.hs-checkout-purchase') ? document.querySelector('.hs-checkout-purchase') : '';
    if (!!hs_checkout_purchase) {
      if (!hs_checkout_purchase.classList.contains('hs-event-static')) {
        hs_checkout_purchase.classList.add('hs-event-static');
        hs_checkout_purchase.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var where = this;
          HsApp1.buttonCheckout(where, e);
        });
      }
    };

    var hs_bg_slide = !!document.querySelector('.hs-bg-slide-cart') ? document.querySelector('.hs-bg-slide-cart') : '';
    if (!!hs_bg_slide) {
      if (!hs_bg_slide.classList.contains('hs-event-static')) {
        hs_bg_slide.classList.add('hs-event-static');
        hs_bg_slide.addEventListener('click', function (e) {
          e.preventDefault();
          var hs_open_cart = !!document.querySelector('.hs-open-cart') ? document.querySelector('.hs-open-cart') : '';
          var hs_popup_cart_sp_load = !!document.querySelector('.hs-popup-cart-sp-load.hs-active') ? document.querySelector('.hs-popup-cart-sp-load.hs-active') : '';
          if (!!hs_open_cart || !!hs_popup_cart_sp_load) {
            HsApp1.closeCart();
          };

        });
      }
    };

    var hs_site_cart_popup_layout = !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout') : '';
    if (!!hs_site_cart_popup_layout) {
      var hs_close = !!hs_site_cart_popup_layout.querySelector('.hs-close') ? hs_site_cart_popup_layout.querySelector('.hs-close') : '';
      if (!!hs_close) {
        if (!hs_close.classList.contains('hs-event-static')) {
          hs_close.classList.add('hs-event-static');
          hs_close.addEventListener('click', function (e) {
            e.preventDefault();
            HsApp1.closeCart();
          });
        };
      };
    };

    var hs_continue_shopping = !!document.querySelector('.hs-continue-shopping') ? document.querySelector('.hs-continue-shopping') : '';
    if (!!hs_continue_shopping) {
      if (!hs_continue_shopping.classList.contains('hs-event-static')) {
        hs_continue_shopping.classList.add('hs-event-static');
        hs_continue_shopping.addEventListener('click', function (e) {
          e.preventDefault();
          var value = hs_continue_shopping.getAttribute('href');
          if (value) {
            window.location.href = value;
            return false;
          }
          HsApp1.closeCart();
        });
      }
    };


    function filterCheckboxes(checkboxes, parentExclusions = [], classExclusions = []) {
      return Array.from(checkboxes).filter(function (checkbox) {
        var hasExcludedParent = parentExclusions.some(function (selector) {
          return checkbox.closest(selector);
        });
        var hasExcludedClass = classExclusions.some(function (cls) {
          return checkbox.classList.contains(cls);
        });
        return !hasExcludedParent && !hasExcludedClass;
      });
    };

    var hs_front_check = !!document.querySelector('.hs_front_check_agreed') ? document.querySelector('.hs_front_check_agreed') : '';
    if (!!hs_front_check) {
      if (!hs_front_check.classList.contains('hs-event-static')) {
        hs_front_check.classList.add('hs-event-static');
        hs_front_check.addEventListener('click', function (e) {
          if (hs_checkout_purchase) {
            hs_checkout_purchase.classList.toggle('hs-is-disabled', !this.checked);
          };
          var hs_finalize = !!document.querySelector('.hs-finalize-purchase') ? document.querySelector('.hs-finalize-purchase') : '';
          /* var checks = !!hs_finalize.querySelector('[type="checkbox"]') ? hs_finalize.querySelector('[type="checkbox"]') : ''; */
          if (!hs_finalize) return;
          var checks = hs_finalize.querySelectorAll('[type="checkbox"]:not(#shippingProtectionCheckBox,#hs-shipping-chk-id,#hs_input_check_additional_note,.loop-return-coverage__checkbox,#ssp-toggle-input)') || [];

          var checks = filterCheckboxes(checks, ['route-protect-widget']);//FILTER
          checks.forEach(function (val) {
            if (!val.classList.contains('hs-gift-wrap-check')) {
              if (!!hs_front_check.checked) {
                if (!!val) {
                  val.checked = true;
                }
              }
              else {
                if (!!val) {
                  val.checked = false;
                }
              }
            }
          });
        });
      }
    };

    var hs_cart_purchase = !!document.querySelector('.hs-cart-purchase') ? document.querySelector('.hs-cart-purchase') : '';
    if (!!hs_cart_purchase) {
      if (!hs_cart_purchase.classList.contains('hs-event-static')) {
        hs_cart_purchase.classList.add('hs-event-static');
        hs_cart_purchase.addEventListener('click', function (e) {
          e.stopImmediatePropagation();
          e.preventDefault();
          var where = this, elementDiscount = !!document.querySelector('input.hs-discount-code') ? document.querySelector('input.hs-discount-code') : '',
            elementNote = !!document.querySelector('textarea.hs-cart-ins') ? document.querySelector('textarea.hs-cart-ins') : '',
            discount = null,
            note = elementNote.value,
            giftStatus = 0;
          var hs_gift_wrap_custom = !!document.querySelector('.hs-gift-wrap-custom') ? document.querySelector('.hs-gift-wrap-custom') : '';
          if (!!hs_gift_wrap_custom) {
            var hs_gift_wrap_check = !!hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_custom.querySelector('.hs-gift-wrap-check') : '';
            if (!!hs_gift_wrap_check) {
              if (!!hs_gift_wrap_check.checked) {
                giftStatus = 1;
              };
            };
          };

          var hs_gift_wrap_specific = !!document.querySelector('.hs-gift-wrap-specific') ? document.querySelector('.hs-gift-wrap-specific') : '';
          if (!!hs_gift_wrap_specific) {
            var hs_gift_wrap_check = !!hs_gift_wrap_specific.querySelector('.hs-gift-wrap-check') ? hs_gift_wrap_specific.querySelector('.hs-gift-wrap-check') : '';
            if (!!hs_gift_wrap_check) {
              if (!!hs_gift_wrap_check.checked) {
                giftStatus = 2
              };
            };
          };

          if (!elementNote) {
            HsApp1.redirectCart();
            return false;
          }
          if (note === '') {
            HsApp1.redirectCart();
            return false;
          }
          HsApp1.fetchUpdateCart(0, discount, note, where, giftStatus);
        });
      }
    };
  },
  openCartDrawerClick: function (element = '') {
    if (element) {
      if (!!element.classList.contains('hs-sticky-cart-cart-drawer')) {
        var stickycart_takes_user_to = slideData.sticky_cart.sticky_cart_redirect;
        var shopifyRoot = '/';
        if (!!window.Shopify) {
          if (!!window.Shopify.routes) {
            if (!!window.Shopify.routes) {
              if (!!window.Shopify.routes.root) {
                if (window.Shopify.routes.root !== '/') {
                  shopifyRoot = window.Shopify.routes.root;
                }
              }
            }
          }
        };

        if (stickycart_takes_user_to === 'cart') {
          window.location.href = shopifyRoot + "cart";
          return false;
        }
        if (stickycart_takes_user_to === 'checkout') {
          window.location.href = shopifyRoot + "checkout";
          return false;
        };
      };
    };
    HsApp1.openCart(element);
    HsApp1.hideCartPopup();
  },
  priceCart: function (result) {
    result = JSON.parse(JSON.stringify(result));
    /*  */
    let newTotalPrice = 0, count_mmlTBYB = 0, count_Tryon = 0;

    if (!result.items.length) {
      HsApp1.removePrefixRewards();
      HsApp1.autoRewardsOff();
      HsApp1.resetRewards();
    }
    result.items.forEach(item => {
      var total_discount = 0, discounts;
      if (null != (discounts = item.discounts) || discounts.length) {
        for (let t = 0; t < item.discounts.length; t++)
          if (item.discounts[t].amount > 0) {
            total_discount += item.discounts[t].amount;//CAMBIO
          };
      };

      let final_price = function () {
        if (item.properties?._mml_TBYB && item.properties._mml_amount !== undefined && item.properties._mml_type !== undefined) {
          var mmlAmount = item.properties._mml_amount;
          const mmlTBYB = item.properties._mml_TBYB;
          const mmlType = item.properties._mml_type;
          if (mmlTBYB === 'Marshmalloo') {
            if (!isNaN(mmlAmount)) {
              count_mmlTBYB++;
              switch (mmlType) {
                case 'fixed-amount':
                  mmlAmount = mmlAmount * 100;
                  let amount_fix = mmlAmount * item.quantity < item.final_line_price ? mmlAmount * item.quantity : item.final_line_price;
                  item.final_line_price = amount_fix;

                  if (Hs_CartDrawer.discount_order_x_item) {
                    amount_fix = mmlAmount * item.quantity < item.original_line_price ? mmlAmount * item.quantity : item.original_line_price
                    item.original_line_price = amount_fix;
                  };
                  item.discounted_price = item.original_line_price;
                  total_discount = 0;
                  break;
                case 'percentage':
                  let amount = (mmlAmount * item.final_line_price) / 100;
                  item.final_line_price = amount;

                  if (Hs_CartDrawer.discount_order_x_item) {
                    amount = (mmlAmount * item.original_line_price) / 100;
                    item.original_line_price = amount;
                  };
                  item.discounted_price = item.original_line_price;
                  total_discount = 0;
                  break;
              };
            };
          };
        };

        /* TRYON */
        if (!!item.selling_plan_allocation) {
          if (!!item.selling_plan_allocation.selling_plan) {
            if (!!item.selling_plan_allocation.selling_plan.description) {
              if (item.selling_plan_allocation.selling_plan.description === 'tryon') {
                if (item.selling_plan_allocation.selling_plan.options.length > 0) {
                  var arr_tryon_value = [], myAumount = 0;
                  arr_tryon_value = JSON.parse(item.selling_plan_allocation.selling_plan.options[0].value);
                  myAumount = arr_tryon_value.checkoutChargeAmount;
                  count_Tryon++;
                  switch (arr_tryon_value.checkoutChargeType) {
                    case 'fixed-amount':
                      myAumount = myAumount * 100;
                      let amount_fix = myAumount * item.quantity < item.final_line_price ? myAumount * item.quantity : item.final_line_price;
                      item.final_line_price = amount_fix;

                      if (Hs_CartDrawer.discount_order_x_item) {
                        amount_fix = myAumount * item.quantity < item.original_line_price ? myAumount * item.quantity : item.original_line_price
                        item.original_line_price = amount_fix;
                      };
                      item.discounted_price = item.original_line_price;
                      total_discount = 0;
                      break;
                    case 'percentage':
                      let amount = (myAumount * item.final_line_price) / 100;
                      item.final_line_price = amount;

                      if (Hs_CartDrawer.discount_order_x_item) {
                        amount = (myAumount * item.original_line_price) / 100;
                        item.original_line_price = amount;
                      };
                      item.discounted_price = item.original_line_price;
                      total_discount = 0;
                      break;
                  };
                }
              }
            }
          }
        }

        let price = item.final_line_price;
        if (Hs_CartDrawer.discount_order_x_item) {
          let priceOriginal = item.original_line_price;
          price = priceOriginal > total_discount ? priceOriginal - total_discount : item.discounted_price;
        };

        return price;
      }();

      newTotalPrice += final_price;
    });

    if (count_mmlTBYB > 0 || count_Tryon > 0) {
      result.total_price = newTotalPrice != result.total_price ? newTotalPrice : result.total_price;
    };
    /*  */

    var count_cart = '',
      cl_products_count = '',
      class_banner = '',
      cl_clear_all = '',
      text_products_count = '',
      text_clear_all = '<span style="cursor:pointer;" class="hs-clear-all-button">' + slideData.settings.language_settings.clear_all_language_settings + '</span>',
      total_price = result.total_price,
      total_weight = result.total_weight || 0,
      total_discount = result.total_discount,//CAMBIO
      status_text_cart = '',
      status_text_checkout = '',
      total = '';
    var price_rewards = HsApp1.rewardsExcludeProd(window.HSSLIDECART.CART);
    /* COMPARE PRICE LOCALSTORAGE */
    var new_result = result;
    try {
      new_result = window.Hs_modify_result(result, slideData); /* ADD COMPARE PRICE FROM LOCAL STORAGE, VARIANT TITLE */
      new_result = !new_result ? result : new_result;
    } catch (error) {
      console.log(error)
    };
    let comparePriceTotal = HsApp1.sumSubTotal(new_result) || result.original_total_price;

    //CAMBIO
    if (Hs_CartDrawer.show_base_price_discount) {
      total_discount = result.original_total_price - total_price
    } else {
      total_discount = comparePriceTotal - total_price
    };


    try {
      let saving_price = window.Hs_saving_price(result.total_price, comparePriceTotal);
      if (saving_price > 0) {
        saving_price = hsonslidecart.Currency.formatMoney(saving_price, slideData.settings.devices.money_format);
      } else {
        saving_price = '';
      };
    } catch (error) {
      console.log(error)
    };

    if (comparePriceTotal > result.total_price) {
      window.HSSLIDECART.COMPARE_AT_PRICE = !!comparePriceTotal ? comparePriceTotal : 0;
      comparePriceTotal = hsonslidecart.Currency.formatMoney(comparePriceTotal, slideData.settings.devices.money_format)
    } else {
      comparePriceTotal = '';
    };

    let hs_subtotal_compare_at_price = document.querySelector('.hs_subtotal_compare_at_price') || '';

    if (hs_subtotal_compare_at_price) {
      hs_subtotal_compare_at_price.innerHTML = comparePriceTotal;
    };

    let hs_content_original_price = document.querySelector('.hs_content_original_price') || '';

    let hs_content_total_save = document.querySelector('.hs-content-total-save') || '';

    if (hs_content_original_price) {
      comparePriceTotal !== '' ? hs_content_original_price.classList.remove('hs-hidden-div') : hs_content_original_price.classList.add('hs-hidden-div');
      let hs_original_price = hs_content_original_price.querySelector('.hs_original_price') || '';
      hs_original_price && (hs_original_price.innerHTML = comparePriceTotal);
    };


    if (hs_content_total_save) {
      saving_price !== '' ? hs_content_total_save.classList.remove('hs-hidden-div') : hs_content_total_save.classList.add('hs-hidden-div');
      let hs_total_save = hs_content_total_save.querySelector('.hs_total_save') || '';
      hs_total_save && (hs_total_save.innerHTML = saving_price);
    };

    /* */

    //HsApp1.rewardsBar(price_rewards);
    if (!HsApp1.readCookie('hscodediscount') && !HsApp1.readCookie('hs-giftWrap-variantPrice')) {
      HsApp1.rewardsBar(price_rewards);
    } else if (!HsApp1.readCookie('hscodediscount') && HsApp1.readCookie('hs-giftWrap-variantPrice')) {
      HsApp1.rewardsBar(price_rewards + parseInt(HsApp1.readCookie('hs-giftWrap-variantPrice')));
    };
    count_cart = result.item_count + ' ' + result.item_count == 1 ? slideData.settings.language_settings.product_language_settings : slideData.settings.language_settings.products_language_settings;

    text_products_count = '';
    if (!slideData.settings.additional_settings.show_clear_all) {
      text_clear_all = '';
      cl_clear_all = ' hs-clear-all-hidden';
    };

    if (!slideData.settings.additional_settings.show_products_count) {
      text_products_count = '';
      cl_products_count = ' hs-products-count-hidden';
    };

    if (!slideData.settings.announcement.enabled_announcement) {
      class_banner = ' hs-border-announcement';
    };

    if (slideData.settings.countdown.enabled_countdown) {
      class_banner = '';
    };

    count_cart = '<div class="hs-content-count' + class_banner + cl_clear_all + cl_products_count + '">' + text_products_count + text_clear_all + '</div>';

    //if (slideData.settings.additional_settings.show_products_count) {
    var hs_header_content = !!document.querySelector('.hs-header-layout .hs-header-close-empty #hs-header-content') ? document.querySelector('.hs-header-layout .hs-header-close-empty #hs-header-content') : '';
    if (!!hs_header_content) {
      const headerTitle = HsApp1.headerTitle(result.item_count);
      hs_header_content.outerHTML = headerTitle;
    }
    //};

    var hs_total_price_global = !!document.querySelector('.hs-total-price-global') ? document.querySelector('.hs-total-price-global') : '';
    if (!!hs_total_price_global) {
      hs_total_price_global.value = result.original_total_price;//CAMBIO
    };

    var hs_discount_price_global = !!document.querySelector('.hs-discount-price-global') ? document.querySelector('.hs-discount-price-global') : '';
    if (!!hs_discount_price_global) {
      hs_discount_price_global.value = result.total_price
    };//CAMBIO


    if (!!HsApp1.readCookie('hs-giftWrap-variantPrice')) {
      total_price = parseInt(HsApp1.readCookie('hs-giftWrap-variantPrice')) + parseInt(total_price);
    };
    /*AFTERPAY INTEGRATIONS */
    Hs_CartDrawer.integrationAfterpay(total_price);

    window.HSSLIDECART.SUB_TOTAL = total_price;

    total_price = hsonslidecart.Currency.formatMoney(total_price, slideData.settings.devices.money_format);


    var hs_subtotal_amount = !!document.querySelector('.hs_subtotal_amount') ? document.querySelector('.hs_subtotal_amount') : '';
    if (!!hs_subtotal_amount) {
      hs_subtotal_amount.innerHTML = total_price
    };

    var hs_content_subtotal_checkout = !!document.querySelector('.hs-content-subtotal-checkout') ? document.querySelector('.hs-content-subtotal-checkout') : '';
    if (!!hs_content_subtotal_checkout) {
      hs_content_subtotal_checkout.innerHTML = total_price
    };

    var view_total_price = document.querySelectorAll('a[href*=cart] .cartTotalSelector,a[href*=cart] #CartCost,a[href*=cart] .cart--external--total-price,a[href*=cart] .cart-item-count-header--total').length > 0 ? document.querySelectorAll('a[href*=cart] .cartTotalSelector,a[href*=cart] #CartCost,a[href*=cart] .cart--external--total-price,a[href*=cart] .cart-item-count-header--total') : [];
    if (view_total_price > 0) {
      view_total_price.forEach(function (view) {
        view.innerHTML = total_price
      });
    };

    var hs_sticky_cart_cart_drawer_content = !!document.querySelector('.hs-sticky-cart-cart-drawer-content mark') ? document.querySelector('.hs-sticky-cart-cart-drawer-content mark') : '';
    if (!!hs_sticky_cart_cart_drawer_content) {
      hs_sticky_cart_cart_drawer_content.innerHTML = result.item_count;
    };

    var hs_content_count_products_clear_all = !!document.querySelector('.hs-content-count-products-clear-all') ? document.querySelector('.hs-content-count-products-clear-all') : '';
    if (!!hs_content_count_products_clear_all) {
      hs_content_count_products_clear_all.innerHTML = count_cart;
    }
    var CartCost = document.querySelectorAll('.CartCost').length > 0 ? document.querySelectorAll('.CartCost') : [];
    if (CartCost.length > 0) {
      CartCost.forEach(function (val) {
        val.innerHTML = total_price;
      });
    };

    var shopping_cart_total = document.querySelectorAll('.shopping-cart__total').length > 0 ? document.querySelectorAll('.shopping-cart__total') : [];
    if (shopping_cart_total.length > 0) {
      shopping_cart_total.forEach(function (value) {
        value.innerHTML = total_price;
      });
    };


    if (Hs_CartDrawer.show_weight) {
      var hs_content_total_cart_weight = document.querySelector('.hs-content-total-cart-weight') || '';
      if (total_weight > 0) {
        total_weight = `<span class="hs-total-cart-weight">(Total Weight: ${Math.round(total_weight) / 1000} kg)</span>`;
      } else {
        total_weight = '';
      }
      if (hs_content_total_cart_weight) {
        hs_content_total_cart_weight.innerHTML = total_weight;
      }
    } else {
      total_weight = '';
    }

    /* if (Hs_CartDrawer.checkout_button_show_subtotal_text) {
      let hs_sub_total_cart_padding = document.querySelector('.hs-sub-total-cart-padding') || '';
      if (hs_sub_total_cart_padding) {
        let this_padding = '';
        this_padding = total_weight !== '' ? '10px' : '0px';
        hs_sub_total_cart_padding.style.paddingBottom = this_padding;
      };
    }; */

    let hs_content_discount = document.querySelector('.hs-content-discount') || '';
    if (hs_content_discount) {
      var tagDiscounts = ''
      Hs_CartDrawer.Nn(result).forEach(apply_discount => {
        var tag = hsonslidecart.Discount.tagDiscount(apply_discount);
        tagDiscounts = tagDiscounts + tag;
      });

      //CAMBIO
      let hs_discount = hs_content_discount.querySelector('.hs_discount') || '';
      let hs_text_discount_tags = hs_content_discount.querySelector('.hs-text-discount-tags') || '';
      let hs_discount_input = hs_content_discount.querySelector('input.hs-discount-global') || '';
      if (hs_discount_input) {
        hs_discount_input.value = total_discount;
      };
      //CAMBIO
      if (hs_text_discount_tags) {
        hs_text_discount_tags.innerHTML = tagDiscounts;
      };
      if (!parseInt(slideData.settings.additional_settings.show_compare_price)) {
        //CAMBIO
        if (total_discount > 0) {
          total_discount = `- ${hsonslidecart.Currency.formatMoney(total_discount, slideData.settings.devices.money_format)}`;
          hs_content_discount.classList.remove('hs-hidden-div');
        } else {
          hs_content_discount.classList.add('hs-hidden-div');
        };

        if (!!total_discount) {
          if (hs_discount) {
            hs_discount.innerHTML = total_discount;
          }
        }
      }
    };


    /* if (Hs_CartDrawer.checkout_button_show_subtotal_text) {
      let hs_content_original_price = document.querySelector('.hs-content-original-price') || '';
      if (hs_content_original_price) {
        let hs_original_price = hs_content_original_price.querySelector('.hs_original_price') || '';
        let hs_original_price_input = hs_content_original_price.querySelector('input.hs-total-original-price-global') || '';
        if (hs_original_price_input) {
          hs_original_price_input.value = result.original_total_price;
        };
        if (hs_original_price) {
          hs_original_price.innerHTML =
            hsonslidecart.Currency.formatMoney(result.original_total_price, slideData.settings.devices.money_format)
        };
    
        if (result.total_discount > 0) {
          hs_content_original_price.classList.remove('hs-hidden-div');
        } else {
          hs_content_original_price.classList.add('hs-hidden-div')
        }
      };
    }; */
    Hs_CartDrawer.integrationKlarna();
  },
  updateDynamicPrice: function () {
    var dynamic_total_save_calculation = HsApp1.dynamic_total_save_calculation();
    var percentage_total_save_calculation = HsApp1.percentage_total_save_calculation();
    var elementTotalSave = document.querySelectorAll('.hs-dynamic-calculation-total-save-price').length > 0 ? document.querySelectorAll('.hs-dynamic-calculation-total-save-price') : 0;
    var elementTotalSavePercentage = document.querySelectorAll('.hs-dynamic-calculation-total-save-percentage').length > 0 ? document.querySelectorAll('.hs-dynamic-calculation-total-save-percentage') : 0;
    // if (!!elementTotalSave) {
    //   elementTotalSave.innerHTML = dynamic_total_save_calculation;
    // }
    // if (!!elementTotalSavePercentage) {
    //   elementTotalSavePercentage.innerHTML = percentage_total_save_calculation;
    // }
    if (elementTotalSave.length > 0) {
      elementTotalSave.forEach(function (el) {
        el.innerHTML = dynamic_total_save_calculation;
      });
    };

    if (elementTotalSavePercentage.length > 0) {
      elementTotalSavePercentage.forEach(function (el) {
        el.innerHTML = percentage_total_save_calculation;
      });
    };
  },
  plusMin: function () {
    /*----- cart-plus-minus-button -----*/
    var hs_cart_plus_minus = document.querySelectorAll('.hs-cart-plus-minus').length > 0 ? document.querySelectorAll('.hs-cart-plus-minus') : [];
    if (hs_cart_plus_minus.length > 0) {
      hs_cart_plus_minus.forEach(function (val) {
        let status_qty = '', line = '';
        if (val.dataset.free === 'free_gift') {
          status_qty = ' disabled'
        };
        val.innerHTML = `
                    <button class="hs-dec hs-qtybutton" data-line="${val?.dataset?.line}" data-name="minus">
                    <span class="hs-internal-visually-hidden">Decrease quantity ${status_qty}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469">
                        <path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0">
                        </path>
                      </svg>
                    </button>
                    <input type="text" maxlength="4" autocomplete="off" aria-label="Product quantity ${status_qty}" value="${val.dataset.quantity}" id="${val.dataset.key}" data-id="${val.dataset.id}" data-key="${val.dataset.key}" data-line="${val?.dataset?.line}" data-value="${val.dataset.quantity}">
                    <button class="hs-inc hs-qtybutton" data-line="${val?.dataset?.line}" data-name="plus">
                    <span class="hs-internal-visually-hidden">Increase quantity ${status_qty}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g>
                        <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z">
                        </path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                      </svg>
                    </button>`;
      });
    };

    var hs_qtybutton = document.querySelectorAll('.hs-qtybutton').length > 0 ? document.querySelectorAll('.hs-qtybutton') : [];
    if (hs_qtybutton.length > 0) {
      hs_qtybutton.forEach(function (qty) {

        var parent = !!qty.closest('.hs-item-cart-qty') ? qty.closest('.hs-item-cart-qty') : '',
          free = !!parent ? parent.querySelector('.hs-cart-plus-minus').dataset.free : '';
        if (typeof free !== 'undefined') {
          if (free === 'free_gift') {
            return false;
          }
        };
        if (!qty.classList.contains('hs-event-static')) {
          qty.classList.add('hs-event-static');
          qty.addEventListener('click', function (e) {
            e.preventDefault();
            var arr_variants = {},
              newVal = 0,
              oldValue = !!parent ? parent.querySelector('input').value : '',
              id = !!parent ? parent.querySelector('input').dataset.id : '',
              line = !!parent ? parent.querySelector('input').dataset.line : '',
              key = !!parent ? parent.querySelector('input').dataset.key : '',
              messageLive = '';
            var hs_item_cart_content = !!qty.closest('.hs-item-cart-content') ? qty.closest('.hs-item-cart-content') : '';
            if (!!hs_item_cart_content) {
              hs_item_cart_content.classList.add('hs-is-loading');
            };
            if (qty.classList.contains('hs-inc')) {
              newVal = parseFloat(oldValue) + 1;
              messageLive = ` quantity has been increased to ${newVal}`;
            } else {
              // Don't allow decrementing below zero
              if (oldValue > 0) {
                newVal = parseFloat(oldValue) - 1;
              } else {
                newVal = 0;
              }
              messageLive = ` quantity has been decreased to ${newVal}`;
            };

            qty.parentElement.querySelector("input").value = newVal;

            line ? arr_variants.line = line : arr_variants.id = key;
            arr_variants.quantity = newVal;
            arr_variants = JSON.stringify(arr_variants);
            //arr_variants = JSON.stringify({ id: key, quantity: newVal });

            HsApp1.onloadCart(qty, arr_variants, newVal > 0 ? undefined : 0, '', null,
              function (data = null) {
                // Obtener el primer item de items_added o items_removed
                const firstItem = data?.items_added?.[0] || data?.items_removed?.[0];
                const title = firstItem?.title;
                if (!title) return false;
                if (typeof window.Hs_updateLiveRegion === 'function') {
                  window.Hs_updateLiveRegion(`${title} ${messageLive}`);
                }
              }, function (error) {
              }
            );
          });
        }
      });
    }
  },
  removeItemCart: function () {
    var arr = [];
    var hs_remove_item = document.querySelectorAll('.hs-remove-item').length > 0 ? document.querySelectorAll('.hs-remove-item') : [];
    if (hs_remove_item.length > 0) {
      function cartItemRemove(e, val) {
        var arr_variants = {}, classNames = ['hs-item-cart-content', 'hs-product-'],
          $button = val,
          line = $button.dataset.line || '',
          qty = 0,
          id = '',
          update = null;

        var content = !!$button.closest('.hs-item-cart-content') ? $button.closest('.hs-item-cart-content') : '';
        if (!!content) {
          if (content.classList.contains('hs-gwp')) {
            Hs_CartDrawer.removeGWSpecific();
          };
          id = $button.closest('.hs-item-cart-content').className;
          classNames.forEach(function (name) {
            id = id.replace(name, '')
          });
          id = parseInt(id.trim());
          $button.closest('.hs-item-cart-content').classList.add('hs-is-loading');




          const itemKey = $button?.dataset?.key;

          // IMPORTANTE: necesitas tener el cart disponible
          const cartItems = window?.HSSLIDECART?.CART?.items || [];

          const currentItem = cartItems.find(i => i.key === itemKey);

          const isParent = currentItem?.properties?._gpo_product_group;

          // =========================
          // NUEVA LÓGICA DE Gpo
          // =========================
          if (isParent) {
            const groupId = currentItem?.properties?._gpo_product_group;

            const updates = {};

            cartItems?.forEach(item => {
              const matchParent = item?.key === currentItem?.key;
              const matchChild = item?.properties?._gpo_parent_product_group == groupId;

              if (matchParent || matchChild) {
                updates[item.key] = 0;
              }
            });
            arr_variants = JSON.stringify({ updates });
            update = true;
          } else {
            line ? arr_variants.line = line : arr_variants.id = $button.dataset.key;
            arr_variants.quantity = qty;
            arr_variants = JSON.stringify(arr_variants);
          }

          HsApp1.onloadCart($button, arr_variants, 0, id, update,
            function (data = null) {
              // Obtener el primer item de items_removed
              const firstItem = data?.items_removed?.[0];
              const title = firstItem?.title;
              if (!title) return false;
              if (typeof window.Hs_updateLiveRegion === 'function') {
                window.Hs_updateLiveRegion(`${title} has been removed from your cart`);
              }
            }, function (error) {
            }
          );
        };
      };
      hs_remove_item.forEach(function (val) {
        if (!val.classList.contains('hs-event-static')) {
          val.classList.add('hs-event-static');
          val.addEventListener('click', function (e) {
            e.preventDefault();
            cartItemRemove(e, val);
          });

          val.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              cartItemRemove(e, val);
            }
          });
        };
      });
    }
  },
  clearALL: function () {
    var hs_clear_all_button = !!document.querySelector('.hs-clear-all-button') ? document.querySelector('.hs-clear-all-button') : '';
    if (!!hs_clear_all_button) {
      if (!hs_clear_all_button.classList.contains('hs-event-static')) {
        hs_clear_all_button.classList.add('hs-event-static');
        hs_clear_all_button.addEventListener('click', function (e) {
          e.preventDefault();
          HsApp1.fetchClearAll()
        });
      }
    };
  },
  fetchClearAll: function () {
    var myJSON = {};
    var this_clear = Hs_CartDrawer.routeLocale('cart/clear.js');
    fetch(`${this_clear}`, {
      method: 'POST'
    })
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then((json) => {
        window.HSSLIDECART.CART = json;
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          json = window.BOLD.common.cartDoctor.fix(json);
        }
        myJSON = json;
        if (json) {
          HsApp1.cartPrice = json.total_price;
          HsApp1.deleteCookie('hscodediscount');
          HsApp1.deleteCookie('hs-giftWrap-check');
          HsApp1.deleteCookie('hs-giftWrap-variantId');
          HsApp1.deleteCookie('hs-giftWrap-variantPrice');
          HsApp1.deleteCookie('hs-giftWrap-variantCompareAtPrice');
          HsApp1.deleteCookie('hs-shipping-protection');
          HsApp1.deleteCookie('hs-shipping-protection-auto-add');

          var hs_empty = !!HsApp1.cartEmpty(0, 1) ? HsApp1.cartEmpty(0, 1) : `
                      <div class="hs-content-empty-cart">
                        ${slideData.settings.language_settings.cart_empty_text_language_settings}
                      </div>
                  `;
          var hs_popup_cart = !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load') : '';
          if (!!hs_popup_cart) {
            var hs_site_cart_popup = !!hs_popup_cart.querySelector('.hs-site-cart-popup-layout') ? hs_popup_cart.querySelector('.hs-site-cart-popup-layout') : '';
            if (!!hs_site_cart_popup) {
              hs_site_cart_popup.classList.add('hs-popup-cart-empty');
              var body_layout = !!document.querySelector('.hs-body-layout') ? document.querySelector('.hs-body-layout') : '';
              if (!!body_layout) {
                body_layout.innerHTML = hs_empty;
              };
              var footer_layout = !!document.querySelector('.hs-footer-layout') ? document.querySelector('.hs-footer-layout') : '';
              if (!!footer_layout) {
                footer_layout.classList.add('empty');
                footer_layout.setAttribute('aria-hidden', 'true');
              };
              HsApp1.cartEmptyUpsell();
              Hs_CartDrawer.removeShippingGral();
            };
          };

          if (Hs_CartDrawer.positionDiscountCoupon) {
            let hs_finalize_purchase = document.querySelector('.hs-finalize-purchase') || ''
            if (hs_finalize_purchase) {
              var discount_element = hs_finalize_purchase.querySelector('.hs-add-discount') || '';
              if (discount_element) {
                discount_element.remove();
              }
            };
          };

          let hs_sticky_cart_countdown = document.querySelector('.hs-sticky-cart-countdown') || '';
          if (hs_sticky_cart_countdown) {
            hs_sticky_cart_countdown.style.display = 'none';
          };

          HsApp1.closeCart();
          HsApp1.priceCart(json);
          HsApp3.countCart(json);

          HsApp1.checkoutPage = '';
          if (typeof window.HS_SLIDE_CART_UPDATED !== 'undefined') {
            try {
              window.HS_SLIDE_CART_UPDATED(json);
            } catch (err) {
              console.log(err)
            };
          };
        }
      }).catch(err => {
        console.log(err)
      }).then(function () {
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.eventEmitter !== 'undefined'
          && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', myJSON);
        }
        HsApp1.plusMin();
        HsApp1.hideCartPopup();
        Hs_CartDrawer.removeGWSpecific();
      });
  },
  setInputFilter: function (textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
      if (!textbox.classList.contains('hs-event-static')) {
        textbox.classList.add('hs-event-static')
        textbox.addEventListener(event, function (e) {
          if (inputFilter(this.value)) {
            this.value = this.value === '' ? 0 : this.value; //CAMBIO
            this.value = Math.min(this.value, 9999);
            if (typeof textbox.dataset.prod !== 'undefined') {
              if (textbox.dataset.prod === 'free_gift') {
                this.value = 1;
              };
            }
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          } else {
            this.value = "";
          }
        });
        textbox.onkeypress = function (e) {
          if (isNaN(this.value + String.fromCharCode(e.charCode)))
            return false;
        };
        textbox.onkeydown = function (e) {
          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            e.preventDefault(); // evitar comportamiento por defecto
            let current = parseInt(this.value) || 0;
            current = e.key === "ArrowUp" ? current + 1 : Math.max(current - 1, 0);
            this.value = current;
            // poner el cursor al final sin parpadeo
            this.selectionStart = this.selectionEnd = this.value.length;
          }
        };
        textbox.onpaste = function (e) {
          e.preventDefault();
        }
      }
    });
  },
  UpdateNote: function (note) {
    var myJSON = {};
    var cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
    var mwgrouped = Hs_CartDrawer.mwgrouped();
    fetch(`${cart}${mwgrouped}`, {
      body: note,
      method: 'POST',
      headers: {
        'Accept': "application/json, text/javascript",
        'Content-Type': "application/json, text/javascript",
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        // NOTE: "cart" should be the variable containing the cart json data
        json = window.BOLD.common.cartDoctor.fix(json);
      }
      myJSON = json;
      if (typeof window.HS_SLIDE_CART_UPDATED !== 'undefined') {
        try {
          window.HS_SLIDE_CART_UPDATED(json)
        } catch (err) {
          console.log(err)
        };
      };
      if (!!json.status) {
        error = true;
        try {
          Hs_modal_notification(json?.message, json?.description, slideData, json?.status)
        } catch (error) {
          alert(`Error ${json.status}: ${json.description}`)
        }
      }
    }).catch(function (err) {
      console.log(err);
    }).then(function (e) {
      if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.eventEmitter !== 'undefined'
        && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', myJSON);
      }
      HsApp1.plusMin();
      HsApp1.removeItemCart();
      HsApp1.rechargeCartElement();
      HsApp1.hideCartPopup();
      HsApp1.changeQuantityCart();
      HsApp1.clearALL();
      HsApp1.startDiscount();

    });
  },
  changeQuantityCart: function () {
    var hs_item_cart_qty = document.querySelectorAll('.hs-item-cart-qty').length > 0 ? document.querySelectorAll('.hs-item-cart-qty') : [];
    if (hs_item_cart_qty.length > 0) {
      hs_item_cart_qty.forEach(function (hs_item_cart) {
        var hs_cart_plus_minus = !!hs_item_cart.querySelector('.hs-cart-plus-minus') ? hs_item_cart.querySelector('.hs-cart-plus-minus') : '';
        if (!!hs_cart_plus_minus) {
          if (typeof hs_cart_plus_minus.dataset.free !== 'undefined' || !!hs_cart_plus_minus.dataset.free) {
            return false;
          };
          var input_quantity = !!hs_cart_plus_minus.querySelector('input') ? hs_cart_plus_minus.querySelector('input') : '';
          if (!!input_quantity) {
            HsApp1.setInputFilter(input_quantity, function (value) {
              return /^-?\d*$/.test(value);
            });

            const debouncedCartUpdate = Hs_debounce((input_quantity) => {
              if (parseInt(input_quantity.dataset.value) == parseInt(input_quantity.value)) {
                return false;
              }
              input_quantity.value = input_quantity.value.replace(/[^0-9\.]/g, '');
              if (!input_quantity.value || input_quantity.value == 0) {
                input_quantity.value = 1;
              }
              var where = input_quantity, value = input_quantity.value;
              var arr_variants = [],
                id = where.dataset.id,
                key = where.dataset.key,
                line = where.dataset.line,
                qty = value === '' ? 1 : parseInt(value),
                parent = where.closest('.hs-item-' + id),
                free = !!parent ? parent.querySelector('.hs-cart-plus-minus').dataset.free : '',
                messageLive = '';

              if (typeof free !== 'undefined') {
                if (free === 'free_gift') {
                  qty = 1;
                }
              };

              if (parseInt(input_quantity.dataset.value) < parseInt(input_quantity.value)) {
                messageLive = ` quantity has been increased to ${input_quantity.value}`;
              } else {
                messageLive = ` quantity has been decreased to ${input_quantity.value}`;
              };
              arr_variants = JSON.stringify({ /* id: key */line: line, quantity: qty });
              parent.closest('.hs-item-cart-content').classList.add('hs-is-loading');

              HsApp1.onloadCart(input_quantity, arr_variants, qty > 0 ? undefined : 0, '', null,
                function (data = null) {
                  // Obtener el primer item de items_added o items_removed
                  const firstItem = data?.items_added?.[0] || data?.items_removed?.[0];
                  const title = firstItem?.title;
                  if (!title) return false;
                  if (typeof window.Hs_updateLiveRegion === 'function') {
                    window.Hs_updateLiveRegion(`${title} ${messageLive}`);
                  }
                }, function (error) {
                }
              );
            }, 300);

            input_quantity.addEventListener('focusout', function (e) {
              const input = this;
              debouncedCartUpdate(input);
            });
          }
        }

      })
    }

    var textarea_note = !!document.querySelector('textarea.hs-cart-ins') ? document.querySelector('textarea.hs-cart-ins') : '';
    if (!!textarea_note) {
      textarea_note.addEventListener('keyup', function (e) {
        e.preventDefault();
        value = JSON.stringify({ note: this.value });
        HsDelay(function () {
          HsApp1.UpdateNote(value);
        }, 400);
      });
    };
  },
  hsconversionBundlesBear: function () {
    if (typeof window.conversionBundlesBear !== 'undefined') {
      var a = !!document.querySelector('.hs-sub-total-cart') ? document.querySelector('.hs-sub-total-cart') : '';
      if (!!a) {
        conversionBundlesBear.updateSubtotal(true);
      }
    };
  },
  disableCheckout: function (status = 0) {//CAMBIO
    try {
      var buttons_checkout = document.querySelectorAll('.gokwik-checkout .btn-theme, .hs-content-checkout-button .hs-checkout-purchase') || [];
      // var hs_front_check_agreed = document.querySelector('.hs_front_check_agreed') || '';
      if (buttons_checkout.length > 0) {
        //button_checkout.setAttribute('style', 'opacity:0.4;pointer-events:none !important;');
        buttons_checkout.forEach(function (button) {
          if (status) {
            button.setAttribute('disabled', '');
          } else {
            button.style = '';
            button.removeAttribute("disabled");
          };
        });
      }
    } catch (error) {
      console.warn(error)
    }
  },
  updateInfoCart: function (cart = {}) {//CAMBIO
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;
    const giftWrapItem = cart?.items?.filter(item =>
      item.properties?._giftWrap === "true"
    );
    if (giftWrapItem.length > 0) {
      const item = giftWrapItem[0] || {};
      if (Object.keys(item).length > 0) {
        const key = item?.key || '';
        if (key) {
          const cookieGiftWrap = HsApp1.readCookie('hs-giftWrap-key') || '';
          if (cookieGiftWrap) {
            HsApp1.createCpokie('hs-giftWrap-key', key, 360);
          };
        };
      };
    };

    const shippingProtectionItem = cart?.items?.filter(item =>
      item.properties?._shippingProtection === "true"
    );
    if (shippingProtectionItem.length > 0) {
      const item = shippingProtectionItem[0] || {};
      if (Object.keys(item).length > 0) {
        const key = item?.key || '';
        if (key) {
          const shippingContent = document.querySelector('.hs-shipping-protection-gnrl') || '';
          if (shippingContent) {
            const shippingInput = document.querySelector('#hs-shipping-chk-id[data-key]:not([data-key=""])') || '';
            if (shippingInput) {
              shippingInput.dataset.key = key;
            };
            const shippingSlider = document.querySelector('.hs-shipping-slider[data-key]:not([data-key=""])') || '';
            if (shippingSlider) {
              shippingSlider.dataset.key = key;
            };
            const cookieShipping = HsApp1.readCookie('hs-shipping-protection') || '';
            if (cookieShipping) {
              HsApp1.createCpokie('hs-shipping-protection', key, 360);
            };
          };
        };
      };
    };
  },
  onloadCart: function (triggerElement, arr_variants, update_upsell, idProdDelete = '', update, onSuccess, onError) {

    const focusSnapshot = typeof window.Hs_getFocusSnapshot === 'function' ? window.Hs_getFocusSnapshot() : null;


    HsApp1.disableCheckout(1);//CAMBIO
    update_upsell = typeof update_upsell === 'undefined' ? 1 : 0;
    var ini = 0,
      mwgrouped = Hs_CartDrawer.mwgrouped(),
      elementsProperties = ['_giftWrap', '_shippingProtection'],
      cart = Hs_CartDrawer.routeLocale(`cart/change.js`),
      myJSON = {},
      iniJSON = {},
      updateCart = true;//true

    if (typeof update !== 'undefined' || update !== null) {
      if (!!update) {
        cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
      };
    };

    const thisHeaders = {
      Accept: "application/json, text/javascript",
      'X-Requested-With': 'XMLHttpRequest',
      ...(!(arr_variants instanceof FormData) && {
        'Content-Type': "application/json, text/javascript"
      })
    };

    fetch(`${cart}${mwgrouped}`, {
      body: arr_variants,
      method: 'POST',
      headers: thisHeaders,
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (!!json.status) {
        try {
          Hs_modal_notification(json?.message, json?.description, slideData, json?.status)
        } catch (error) {
          alert(`Error ${json.status}: ${json.message}`);
        }
        HsApp1.getMyCart(1, '', '');
        return false;
      };
      if (json.items && json.items.length > 0) {
        const items = json.items;
        const discounts = items.filter((item) => {
          return item.discounts && item.discounts.length > 0
        });
        if (discounts.length > 0) {
          updateCart = false;
        };
      };

      if (idProdDelete) {
        updateCart = false;
      };

      iniJSON = JSON.parse(JSON.stringify(json));
      HsApp1.updateInfoCart(iniJSON);//CAMBIO
      if (json.items.length > 0) {
        if (elementsProperties.length > 0) {
          elementsProperties.forEach(function (element) {
            ini++
            json = HsApp1.thisProperties(json, element)
          })
        };
        var changeToUpdate = false;
        if (ini == elementsProperties.length) {
          var giftWrap = HsApp1.readCookie('hs-giftWrap-key');
          var shippingProtection = HsApp1.readCookie('hs-shipping-protection');
          if (!!giftWrap || !!shippingProtection) {
            var variantId = '', arr_variants = '';
            if (json.item_count == 0) {
              if (!!giftWrap && !shippingProtection) {
                variantId = giftWrap;
                arr_variants = JSON.stringify({ id: variantId, quantity: 0 });
              }
              if (!!shippingProtection && !giftWrap) {
                variantId = shippingProtection;
                arr_variants = JSON.stringify({ id: variantId, quantity: 0 });
              }
              if (!!giftWrap && !!shippingProtection) {
                changeToUpdate = true;
                var arr = `{"updates":{"${giftWrap}":0,"${shippingProtection}": 0}}`
                arr = JSON.parse(arr)
                arr_variants = JSON.stringify(arr);
              };
              HsApp1.onloadCart('', arr_variants, 0, '', changeToUpdate);
              Hs_CartDrawer.removeGWSpecific();
              Hs_CartDrawer.removeShippingGral();
              return false;
            }
          };
        };
      };
      if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        // NOTE: "cart" should be the variable containing the cart json data
        json = window.BOLD.common.cartDoctor.fix(json);
      };
      myJSON = JSON.parse(JSON.stringify(json));
      window.HSSLIDECART.CART = iniJSON;

      if (!!window.codeblackbelt) {
        if (!!window.codeblackbelt["shipping-rates-calculator-plusLoaded"]) {
          var hs_layout_content = !!document.querySelector('.hs-layout-content') ? document.querySelector('.hs-layout-content') : '';
          if (!!hs_layout_content) {
            var hs_form_shipping = !!hs_layout_content.querySelector('.hs_form_shipping') ? hs_layout_content.querySelector('.hs_form_shipping') : '';
            if (!!hs_form_shipping) {
              hs_form_shipping.innerHTML = '';
              hs_form_shipping.innerHTML = '<form class="hs_shipping_rates_calculator_plus" action="/cart" method="post" novalidate="" data-cbb-target-form="processed"></form>';
            };
          };
        };
      };

      if (json.item_count == 0) {
        HsApp1.checkoutPage = '';
        HsApp1.deleteCookie('hscodediscount');
      };

      HsApp1.cartPrice = json.total_price;
      if (typeof onSuccess === 'function') onSuccess(json);


      if (updateCart) {

        HsApp1.updateCart(json, iniJSON, update_upsell, triggerElement);
        HsApp1.priceCart(iniJSON);//CAMBIO
        HsApp3.countCart(json);
        HsApp1.currencyConverter();
        HsApp1.hideCartPopup();
        HsApp1.hsconversionBundlesBear();
      } else {
        HsApp1.getMyCart(0, '', '', update_upsell, triggerElement);
      };

      if (!!triggerElement) {
        !!triggerElement.closest('.hs-item-cart-content') ? triggerElement.closest('.hs-item-cart-content').classList.remove('hs-is-loading') : '';
        !!triggerElement.classList.contains('hs-loading-giftwrap') ? triggerElement.classList.remove('hs-loading-giftwrap') : '';
      };
    }).catch(function (err) {
      console.log(err);
      if (typeof onError === 'function') onError(err);
      if (!!triggerElement) {
        !!triggerElement.closest('.hs-item-cart-content') ? triggerElement.closest('.hs-item-cart-content').classList.remove('hs-is-loading') : '';
        !!triggerElement.classList.contains('hs-loading-giftwrap') ? triggerElement.classList.remove('hs-loading-giftwrap') : '';
      }
    }).then(function () {
      typeof iniJSON.items !== 'undefined' ? iniJSON.items.length > 0 ? HsApp1.startDiscount() : HsApp1.deleteCookie('hscodediscount') : HsApp1.deleteCookie('hscodediscount');
      typeof iniJSON.items !== 'undefined' ? iniJSON.items.length > 0 ? '' : HsApp1.checkoutPage = '' : HsApp1.checkoutPage = '';
      if (updateCart) {
        HsApp1.plusMin();
        HsApp1.clearALL();
        HsApp1.removeItemCart();
        HsApp1.rechargeCartElement();
        HsApp1.changeQuantityCart();
        HsApp1.hsconversionBundlesBear();
        HsApp1.updateQuantityFocus(focusSnapshot)
      };

      if (typeof window.HS_SLIDE_CART_REMOVED_FROM_CART !== 'undefined') {
        if (idProdDelete !== '') {
          try {
            window.HS_SLIDE_CART_REMOVED_FROM_CART({ id: idProdDelete });
          } catch (err) {
            console.log(err)
          };
        };
      };
      if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.eventEmitter !== 'undefined'
        && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', myJSON);
      }
    });
  },
  viewNote: function () {
    if (!!slideData.settings.cart_note.enabled_cart_note) {
      var hs_note_heading = !!document.querySelector('.hs-note-heading') ? document.querySelector('.hs-note-heading') : '';
      if (!!hs_note_heading) {
        var hs_cart_note = !!document.querySelector('.hs-cart-note') ? document.querySelector('.hs-cart-note') : '';
        if (!!hs_cart_note) {
          if (!hs_cart_note.classList.contains('hs-event-static')) {
            function headingShowNote() {
              if (!!hs_cart_note.classList.contains('hs-show-note')) {
                hs_cart_note.classList.remove('hs-show-note');
                hs_note_heading.innerHTML = `${HsApp1.svgAddNote}
                          <span class="hs-note-title">${slideData.settings.cart_note.cart_note_heading}</span>
                        `;
              }
              else {
                hs_cart_note.classList.add('hs-show-note');
                hs_note_heading.innerHTML = `
                          ${HsApp1.svgCloseNote}
                          <span class="hs-note-title">${typeof slideData.settings.cart_note.cart_note_heading_close !== 'undefined' ? slideData.settings.cart_note.cart_note_heading_close : 'Close optional note'}</span>
                          `;
              }
            };
            hs_cart_note.classList.add('hs-event-static');
            hs_note_heading.addEventListener('click', function (e) {
              e.preventDefault();
              headingShowNote();
            });
            hs_note_heading.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                headingShowNote();
              }
            });
          }
        }
      }
    }
  },
  thisProperties(json, propertie) {
    /* SHIPPING PROTECTION */
    if (slideData.settings.shipping_protection) {
      if (slideData.settings.shipping_protection.enabled_shipping_protection) {
        if (slideData.settings.shipping_protection.sp_featured_product_shopify_id_variant) {
          if (json.items && json.items.length > 0) {
            var item_cart = json.items.find((item) => {
              return item.id == +slideData.settings.shipping_protection.sp_featured_product_shopify_id_variant
            });
            if (item_cart && item_cart.properties) {
              if (item_cart.properties._shippingProtection) {
                if (!!HsApp1.readCookie('hs-shipping-protection')) {
                  var cookie_key_shipping = HsApp1.readCookie('hs-shipping-protection');
                  var key_shipping = item_cart.key
                  if (cookie_key_shipping !== key_shipping) {
                    document.querySelector('input#hs-shipping-chk-id') ? document.querySelector('input#hs-shipping-chk-id').dataset.key = key_shipping : ''
                    document.querySelector('.hs-shipping-slider') ? document.querySelector('.hs-shipping-slider').dataset.key = key_shipping : '';
                    HsApp1.createCpokie('hs-shipping-protection', key_shipping, 360);
                  };
                };
              };
            };
          };
        };
      };
    };
    if (json.items.length > 0) {
      json.items.forEach((item, i) => {
        !item.hs_line ? item.hs_line = i + 1 : '';
      });
    };
    var myjson = JSON.parse(JSON.stringify(json));
    var ini = 0, count = 0;
    if (json.items.length > 0) {
      json.items.forEach(function (item, d) {
        ini++;
        var props = item.properties_all || item.properties;
        if (props != null) {
          if (Object.keys(props).length > 0) {
            Object.keys(props).forEach(function (c, o) {
              if (c === propertie) {
                count++
                myjson.items.splice(d, 1);
              }
            })
          }

        }
      });
    };
    if (ini == json.items.length) {
      myjson.item_count = myjson.item_count - count;
      return myjson;
    }
  },
  getMyCart: function (w, functions, cartManually, update_upsell = 0, triggerElement) {
    var ini = 0;
    var elementsProperties = ['_giftWrap', '_shippingProtection'];

    const focusSnapshot = typeof window.Hs_getFocusSnapshot === 'function' ? window.Hs_getFocusSnapshot() : null;

    if (!!functions) {
      if (functions.length > 0) {
        functions = functions[0]
        var functionName = functions.name;
        switch (functionName) {
          case 'addToCartUpsell':
            if (typeof window.HS_SLIDE_CART_UPSELL_ADD !== 'undefined') {
              try {
                window.window.HS_SLIDE_CART_UPSELL_ADD(parseInt(functions.attr.id));
              } catch (err) {
                console.log(err)
              };
            };
            break;
          case 'addToCart':
            if (typeof window.HS_SLIDE_CART_ADD_TO_CART !== 'undefined') {
              try {
                let params = { id: functions.attr.id, quantity: functions.attr.quantity };
                if (typeof functions.attr.properties !== 'undefined') {
                  params.properties = functions.attr.properties;
                };

                window.HS_SLIDE_CART_ADD_TO_CART(params)
              } catch (err) {
                console.log(err)
              };
            };
            break;
        }
      }
    };
    var resultValidateDevice = this.validateDevice();
    switch (parseInt(resultValidateDevice)) {
      case 0:
        HsApp1.slideCartDisabled();
        return false;
        break;
      case 2:
        HsApp1.slideCartDisabled();
        return false;
        break;
    };
    Hs_CartDrawer.validateCheckGift();
    function getFinally(json) {
      var note = '';
      note = json.note;

      var noteUpdate = HsApp1.updateAdditionalNote(json.note);
      var noteContent = !!document.querySelector('.hs-cart-ins') ? document.querySelector('.hs-cart-ins') : '';
      if (!!noteContent && !!noteUpdate.update_note) {
        noteContent.value = noteUpdate.note;
        var cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
        var mwgrouped = Hs_CartDrawer.mwgrouped();
        fetch(`${cart}${mwgrouped}`, {
          body: JSON.stringify({ note: noteUpdate.note }),
          method: 'POST',
          headers: {
            'Accept': "application/json, text/javascript",
            'Content-Type': "application/json, text/javascript",
            'X-Requested-With': 'XMLHttpRequest'
          },
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
        }).catch(function (err) {
          console.log(err);
          noteContent.value = note;
        }).then(function (e) {
        });
      };

      var noteIni = typeof slideData.settings.cart_note.cart_note_show_ini !== 'undefined' ? slideData.settings.cart_note.cart_note_show_ini : 0;
      var ind = 0;
      if (!!noteIni) {
        ind = 1;
      };
      if (note !== null) {
        if (note !== '') {
          ind = 1;
        };
      };
      if (ind > 0) {
        var elementNote = !!document.querySelector('.hs-cart-note') ? document.querySelector('.hs-cart-note') : '';
        if (!!elementNote) {
          elementNote.classList.add('hs-show-note')
        };
        var noteHeading = !!document.querySelector('.hs-note-heading') ? document.querySelector('.hs-note-heading') : '';
        if (!!noteHeading) {
          noteHeading.innerHTML = `
                    ${HsApp1.svgCloseNote}
                    <span class="hs-note-title">${typeof slideData.settings.cart_note.cart_note_heading_close !== 'undefined' ? slideData.settings.cart_note.cart_note_heading_close : 'Close optional note'}</span>
                    `;
        }
      };
      if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.eventEmitter !== 'undefined'
        && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', json);
      };

      Hs_CartDrawer.update_set_cart = 0;
      HsApp1.removeItemCart();
      HsApp1.plusMin();
      HsApp1.hideCartPopup();
      HsApp1.changeQuantityCart();
      HsApp1.clearALL();
      HsApp1.viewNote();
      HsApp1.startDiscount();
      HsApp1.rechargeCartElement();
      HsApp1.storageCart();
      var hs_sticky_cart = !!document.querySelector('.hs-sticky-cart') ? document.querySelector('.hs-sticky-cart') : '';
      if (!!hs_sticky_cart) {
        HsApp1.updateQuantityFocus(focusSnapshot)
      };

    };
    function getCart(json, iniJSON) {
      var hs_sticky_cart = !!document.querySelector('.hs-sticky-cart') ? document.querySelector('.hs-sticky-cart') : '';
      var hs_header_layout = !!document.querySelector('.hs-header-layout') ? document.querySelector('.hs-header-layout') : '';
      var note = '';
      note = json.note;
      //Change money format if exist cookie
      if (!!window.codeblackbelt) {
        if (!!window.codeblackbelt["shipping-rates-calculator-plusLoaded"]) {
          var hs_layout_content = !!document.querySelector('.hs-layout-content') ? document.querySelector('.hs-layout-content') : '';
          if (!!hs_layout_content) {
            var hs_form_shipping = !!hs_layout_content.querySelector('.hs_form_shipping') ? hs_layout_content.querySelector('.hs_form_shipping') : '';
            if (!!hs_form_shipping) {
              hs_form_shipping.innerHTML = '';
              hs_form_shipping.innerHTML = '<form class="hs_shipping_rates_calculator_plus" action="/cart" method="post" novalidate="" data-cbb-target-form="processed"></form>';
            };
          };
        };
      };
      HsApp1.cartPrice = json.total_price;
      HsApp1.currencyConverter();
      if (!!document.querySelector('.hs-result-loading.hs-body-gnral')) {
        document.querySelector('.hs-result-loading.hs-body-gnral').classList.remove('hs-show-loading');
      };

      let shipping_protection = document.querySelector('.hs-shipping-protection-gnrl.hs-loading-protection') || '';
      if (!!shipping_protection) {
        if (!!shipping_protection.querySelector('.hs-result-loading.hs-body-gnral')) {
          shipping_protection.querySelector('.hs-result-loading.hs-body-gnral').classList.remove('hs-show-loading');
        };
      };

      if (w != 1) {
        if (!hs_header_layout) {
          Hs_CartDrawer.update_set_cart = 1;
          if (typeof window.HS_SLIDE_CART_LOADED !== 'undefined') {
            try {
              window.HS_SLIDE_CART_LOADED(json);
            } catch (err) {
              console.log(err)
            };
            //return false
          };
        }
      } else {
        Hs_CartDrawer.update_set_cart = 0;
      };

      if (!!hs_sticky_cart) {
        HsApp1.updateCart(json, iniJSON, update_upsell);
      } else {
        HsApp1.cart(json, iniJSON);
        HsApp1.iniTimer(json.item_count);
        HsApp5.cartAnimator();
      }
      HsApp1.announcementContent();
      HsApp1.priceCart(iniJSON);//CAMBIO

      if (!slideData.sticky_cart.enabled_sticky_cart) {
        HsApp3.countCart(json)
      };

      if (!!parseInt(slideData.settings.additional_settings.open_cart)) {
        if (w == 1) {
          if (json.items.length > 0) {
            var bodyOpenCart = !!document.querySelector('body') ? document.querySelector('body') : '';
            if (!!bodyOpenCart) {
              if (!bodyOpenCart.classList.contains('hs-open-cart')) {
                HsApp1.openCart();
              };
            };
          };
        };

      };
    };
    if (!!cartManually) {
      if (Hs_CartDrawer.update_set_cart = 1) {
        getCart(cartManually, cartManually);
        getFinally(cartManually);
        return false;
      };
    };
    var cart = Hs_CartDrawer.routeLocale(`cart.js`), myjson = '';
    fetch(`${cart}`,
      {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      }).then((json) => {
        HsApp1.updateInfoCart(json);//CAMBIO
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          json = window.BOLD.common.cartDoctor.fix(json);
        }
        var iniJSON = JSON.parse(JSON.stringify(json));

        if (elementsProperties.length > 0) {
          elementsProperties.forEach(function (element) {
            ini++
            json = HsApp1.thisProperties(json, element)
          })
        };

        /* END SHIPPING PROTECTION */
        if (ini == elementsProperties.length) {
          if (!!slideData.sticky_cart.enabled_sticky_cart) {
            !!document.getElementById("hsitemCount") ? document.getElementById("hsitemCount").innerHTML = json.item_count : '';
            HsApp3.countCart(json);
          };

          var shipping = false, gift = false, arr_variants = '';
          if (json.item_count == 0) {
            HsApp1.checkoutPage = '';
            var giftWrap = HsApp1.readCookie('hs-giftWrap-key');
            var shippingProtection = HsApp1.readCookie('hs-shipping-protection');

            if (!!giftWrap || !!shippingProtection) {
              if (json.item_count == 0 && iniJSON.item_count > 0) {
                if (!!giftWrap && !shippingProtection) {
                  gift = true;
                  var arr = `{"updates":{"${giftWrap}":0}}`
                  arr = JSON.parse(arr)
                  arr_variants = JSON.stringify(arr);
                }
                if (!!shippingProtection && !giftWrap) {
                  shipping = true;
                  var arr = `{"updates":{"${shippingProtection}":0}}`
                  arr = JSON.parse(arr)
                  arr_variants = JSON.stringify(arr);
                }
                if (!!giftWrap && !!shippingProtection) {
                  gift = true;
                  shipping = true;
                  var arr = `{"updates":{"${giftWrap}":0,"${shippingProtection}": 0}}`
                  arr = JSON.parse(arr)
                  arr_variants = JSON.stringify(arr);
                };
              };
            };
          };

          const freeGiftItemIds = json.items
            .filter(item => item.product_type && item.product_type.includes("free_gift") && item.quantity > 1)
            .map(item => item.key);//CAMBIO
          if (arr_variants !== '') {
            if (freeGiftItemIds.length > 0) {
              arr_variants = JSON.parse(arr_variants);
              freeGiftItemIds.forEach(valor => {
                arr_variants.updates[valor] = 1;
              });
              arr_variants = JSON.stringify(arr_variants);
            };
          } else {
            if (freeGiftItemIds.length > 0) {
              arr_variants = {
                updates: {
                }
              };
              freeGiftItemIds.forEach(valor => {
                arr_variants.updates[valor] = 1;
              });
              arr_variants = JSON.stringify(arr_variants);
            };
          };

          if (arr_variants !== '') {
            var cart = Hs_CartDrawer.routeLocale(`cart/update.js`);
            var mwgrouped = Hs_CartDrawer.mwgrouped();
            fetch(`${cart}${mwgrouped}`, {
              body: arr_variants,
              method: 'POST',
              headers: {
                'Accept': "application/json, text/javascript",
                'Content-Type': "application/json, text/javascript",
                'X-Requested-With': 'XMLHttpRequest'
              },
            }).then(function (response) {
              return response.json();
            }).then(function (json) {
              if (shipping) {
                Hs_CartDrawer.removeShippingGral();
                HsApp1.deleteCookie('hs-shipping-protection');
                HsApp1.deleteCookie('hs-shipping-protection-auto-add');
              };

              if (gift) {
                Hs_CartDrawer.removeGWSpecific();
                var hs_gift_wrap = !!document.querySelector('.hs-gift-wrap') ? document.querySelector('.hs-gift-wrap') : '';
                if (!!hs_gift_wrap) {
                  var hs_gift_wrap_content_check = !!hs_gift_wrap.querySelector('.hs-gift-wrap-content-check') ? hs_gift_wrap.querySelector('.hs-gift-wrap-content-check') : '';
                  if (!!hs_gift_wrap_content_check) {
                    var gift_wrap_check = !!hs_gift_wrap_content_check.querySelector('input[type="checkbox"]') ? hs_gift_wrap_content_check.querySelector('input[type="checkbox"]') : '';
                    if (!!gift_wrap_check) {
                      gift_wrap_check.checked = false;
                    };
                  };
                };
              };
              HsApp1.getMyCart(1, '', '');
            }).catch(function (err) {
            }).then(function () {
            });
            return false;
          };
          /* SHIPPING PROTECTION */
          if (typeof slideData.settings.shipping_protection !== 'undefined') {
            Hs_CartDrawer.validateShippingGral(iniJSON);
          };
          if (typeof slideData.settings.gift_wrap !== 'undefined') {
            Hs_CartDrawer.validateGiftWrap(iniJSON);
          };
          myjson = json;
          window.HSSLIDECART.CART = iniJSON;
          getCart(json, iniJSON);
          HsApp1.hsconversionBundlesBear();
        };
      }).catch(err => {
        console.log(err);
      }).then(function () {
        getFinally(myjson);
      });
  },
  cssVariables: function () {
    var image_container = typeof slideData.settings.additional_settings.image_container !== 'undefined' ? parseInt(slideData.settings.additional_settings.image_container, 10) : 70;
    var image_container_cal = image_container + 15;
    var svgNote = typeof slideData.settings.cart_note.cart_note_show_icon !== 'undefined' ? slideData.settings.cart_note.cart_note_show_icon : 1;

    var z_index_content = '888888888888889';
    var z_index_content_bg = '2147483637';

    if (!!document.querySelector('bundle-builder-item-modal')) {
      z_index_content = '2147483637';
      z_index_content_bg = '2147483636'
    };
    if (window.OCUIncart || window.minMaxify) {
      z_index_content = '2147483637';
      z_index_content_bg = '2147483636'
    };
    if (window.codeblackbelt) {
      if (window.codeblackbelt['currency-converter-plusLoaded']) {
        z_index_content = '2147483637';
        z_index_content_bg = '2147483636'
      }
    };

    if (typeof window.gokwikSdk !== 'undefined') {//
      if (typeof onCheckoutClick === 'function') {
        z_index_content = '2147483637';
        z_index_content_bg = '2147483636'
      };
    };

    var sizeSlide = `${HsApp1.sizeSlide()}px`;

    function getScrollbarWidth() {
      if (!Hs_CartDrawer.slidePositon) {
        return 0;
      }
      return (window?.innerWidth - document?.documentElement?.clientWidth) || 0;
    }
    const scrollbarWidth = getScrollbarWidth() + 'px';
    const slide_margin = typeof slideData.customize !== 'undefined' ? !slideData.customize.customize_slidecart_design ? 0 : 20 : 0;
    const slide_size = HsApp1.sizeSlide() || 440;
    const slide_total_size = (slide_size + slide_margin) + 'px';

    return `:root{--hscart-transition-time: ${Hs_CartDrawer.transition_time || 0.249}s;--hs-border-input-qty: ${!!Hs_CartDrawer.designQty ? `0px solid rgba(0, 0, 0, 0.1)` : '1px solid rgba(0, 0, 0, 0.1)'};
  --hs-media-600-max-width: ${sizeSlide === '615px' ? typeof slideData.customize !== 'undefined' ? !!slideData.customize.customize_slidecart_margin_left ? 'calc(100% - 40px)' : 'inherit' : 'inherit' : 'inherit'};
  --hs-media-600-width: ${sizeSlide === '615px' ? '100%' : sizeSlide};
  --hs-media-375-prod-title-font-size: ${typeof slideData.customize !== 'undefined' ? parseInt(slideData.customize.customize_body_prod_title_font_size.replace('px', '')) >= 15 ? '13px' : slideData.customize.customize_body_prod_title_font_size : '13px'};
  --hs-show-svg-note: ${!!svgNote ? 'block' : 'none'};
  --hs-hidden-variant-title: ${Hs_CartDrawer.hiddenVarianTitleCart ? `none` : 'initial'};
  --hs-image-container: ${image_container + 'px'};
  --hs-slide-position-left: ${!Hs_CartDrawer.slidePositon ? '0' : 'auto'};
  --hs-slide-position-right: ${!Hs_CartDrawer.slidePositon ? 'auto' : '0'};
  --hs-slide-position-transition: ${!Hs_CartDrawer.slidePositon ? 'left' : 'right'} 0s 0.4s, opacity 0.4s;
  --hs-slide-position--overlay-transition: ${!Hs_CartDrawer.slidePositon ? 'left' : 'right'} 0s, opacity 0.4s;
  --hs-image-container-grid: ${image_container + 'px calc(100% - ' + image_container_cal + 'px)'};
  --hs-content-z-index: ${z_index_content};
  --hs-content-bg-z-index: ${z_index_content_bg};
  --hs-slidecart-size: ${sizeSlide};
  --hs-slidecart-total-size: ${slide_total_size};
  --hs-body-border-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_border_color_hex : '#e5e5e5'};
  --hs-loading-background: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_loading_background_rgb !== 'undefined' ? slideData.customize.customize_loading_background_rgb : 'rgba(255,255,255,.2)' : 'rgba(255,255,255,.2)'};
  --hs-loading-icon-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_loading_icon_hex !== 'undefined' ? slideData.customize.customize_loading_icon_hex : '#626262' : '#626262'};
  --hs-checkout-btn-text-color: ${slideData.settings.checkout_button.checkout_button_text_color_hex};
  --hs-checkout-btn-background: ${slideData.settings.checkout_button.checkout_button_background_color_hex};
  --hs-checkout-btn-border-radius: ${slideData.settings.checkout_button.checkout_button_border};
  --hs-checkout-btn-height: ${typeof slideData.settings.checkout_button.checkout_button_height !== 'undefined' ? slideData.settings.checkout_button.checkout_button_height : '52px'};
  --hs-checkout-btn-text-font-size: ${slideData.settings.checkout_button.checkout_button_text_font_size};
  --hs-checkout-btn-text-weight: ${slideData.settings.checkout_button.checkout_button_text_weight};
  --hs-checkout-btn-text-transform: ${slideData.settings.checkout_button.checkout_button_text_transform};
  --hs-checkout-btn-text-color-hov: ${slideData.settings.checkout_button.checkout_button_text_colorHover_hex};
  --hs-checkout-btn-background-hov: ${slideData.settings.checkout_button.checkout_button_background_colorHover_hex};
  --hs-slidecart-design-border: ${typeof slideData.customize !== 'undefined' ? !slideData.customize.customize_slidecart_design ? '0px' : '15px' : '0px'};
  --hs-slidecart-design-margin: ${typeof slideData.customize !== 'undefined' ? !slideData.customize.customize_slidecart_design ? '0px' : '10px' : '0px'};
  --hs-slidecart-position_left: ${!Hs_CartDrawer.slidePositon ? '-200%' : 'auto'};
  --hs-slidecart-position_right: ${!Hs_CartDrawer.slidePositon ? 'auto' : '-200%'};
  --hs-slidecart-max-width: ${typeof slideData.customize !== 'undefined' ? !!slideData.customize.customize_slidecart_margin_left ? '40px' : '0px' : '0px'};
  --hs-slidecart-transition: ${typeof slideData.customize !== 'undefined' ? !Hs_CartDrawer.slidePositon ? 'left' : 'right' : 'right'};
  --hs-slidecart-header-flex-direction: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_header_icon_position !== 'undefined' ? slideData.customize.customize_header_icon_position ? "row" : "row-reverse" : "row" : "row"};
  --hs-slidecart-header-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_header_background_color_hex : '#ffffff'};
  --hs-slidecart-header-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_header_text_font_size : '14px'};
  --hs-slidecart-header-text-font-weight: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_header_text_font_weight !== 'undefined' ? slideData.customize.customize_header_text_font_weight : '500' : '500'};
  --hs-slidecart-header-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_header_text_transform : 'uppercase'};
  --hs-slidecart-header-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_header_text_color_hex : '#000000'};
  --hs-slidecart-header-icon-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_header_icon_size !== 'undefined' ? slideData.customize.customize_header_icon_size + 'px' : '16px' : '16px'};
  --hs-slidecart-header-close-button-icon-size: 30px;
  --hs-slidecart-header-close-button-border-width: ${slideData?.customize?.customize_header_icon_border !== undefined ? slideData.customize.customize_header_icon_border + 'px' : 0};
  --hs-slidecart-header-close-button-border-color: ${slideData?.customize?.customize_header_icon_border_color_hex !== undefined ? slideData.customize.customize_header_icon_border_color_hex : '#ff000000'};
  --hs-slidecart-header-close-button-border-color-hov: ${slideData?.customize?.customize_header_icon_border_hov_color_hex !== undefined ? slideData.customize.customize_header_icon_border_hov_color_hex : '#ff000000'};
  --hs-slidecart-header-text-offset-direction: ${slideData?.customize?.customize_header_icon_position !== undefined ? (slideData.customize.customize_header_icon_position ? 1 : -1) : 1};
  --hs-slidecart-header-logo-max-height: ${slideData?.customize?.customize_header_logo_size !== undefined ? slideData.customize.customize_header_logo_size + 'px' : '30px'};

  --hs-slidecart-header-border-bottom: ${slideData?.customize?.customize_header_bottom_border !== undefined ? (slideData.customize.customize_header_bottom_border ? '1px solid var(--hs-body-border-color, #e5e5e5)' : 'none') : '1px solid var(--hs-body-border-color, #e5e5e5)'};
  --hs-slidecart-header-padding-block: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_header_height !== 'undefined' ? slideData.customize.customize_header_height ? '20px' : '10px' : '10px' : '10px'};
  --hs-slidecart-header-icon-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_header_icon_color_hex : '#7d7d7d'};
  --hs-slidecart-header-icon-color-hov: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_header_icon_color_hov_hex !== 'undefined' ? slideData.customize.customize_header_icon_color_hov_hex : '#7d7d7d' : '#7d7d7d'};
  --hs-slidecart-header-icon-background: ${slideData?.customize?.customize_header_icon_background_color_hex !== undefined ? slideData.customize.customize_header_icon_background_color_hex : '#ff000000'};
  --hs-slidecart-header-icon-background-hov: ${slideData?.customize?.customize_header_icon_background_hov_color_hex !== undefined ? slideData.customize.customize_header_icon_background_hov_color_hex : '#ff000000'};
  --hs-slidecart-body-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_background_color_hex : '#ffffff'};
  --hs-slidecart-body-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_text_color_hex : '#000000'};
  --hs-slidecart-body-var-title-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_font_size : '14px'};
  --hs-slidecart-body-var-title-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_color_text_hex : '#000000'};
  --hs-slidecart-body-var-title-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_font_weigth : 'normal'};
  --hs-slidecart-body-var-title-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_text_transform : 'none'};
  --hs-slidecart-body-prod-title-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_color_text_hex : '#000000'};
  --hs-slidecart-body-prod-title-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_font_weigth : '600'};
  --hs-slidecart-body-prod-title-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_font_size : '14px'};
  --hs-slidecart-body-prod-title-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_text_transform : 'none'};
  --hs-slidecart-body-qty-height: ${!!Hs_CartDrawer.designQty ? '40px' : '30px'};
  --hs-slidecart-body-compare-price-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_compare_price_color_text_hex : '#737373'};
  --hs-slidecart-body-compare-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_compare_price_font_size : '14px'};
  --hs-slidecart-body-compare-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_compare_price_font_weigth : 'normal'};
  --hs-slidecart-body-price-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_price_color_text_hex : '#737373'};
  --hs-slidecart-body-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_price_font_size : '14px'};
  --hs-slidecart-body-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_price_font_weigth : 'normal'};
  --hs-slidecart-body-sale-price-text-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_sale_price_color_text_hex !== 'undefined' ? slideData.customize.customize_body_sale_price_color_text_hex : '#000000' : '#000000'};
  --hs-slidecart-body-sale-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_sale_price_font_size !== 'undefined' ? slideData.customize.customize_body_sale_price_font_size : '14px' : '14px'};
  --hs-slidecart-body-sale-price-text-weight: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_sale_price_font_weigth !== 'undefined' ? slideData.customize.customize_body_sale_price_font_weigth : 'normal' : 'normal'};
  --hs-slidecart-body-sale-saving-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_saving_color_text_hex || '#000000' : '#000000'};
  --hs-slidecart-body-sale-saving-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_saving_font_size || '14px' : '14px'};
  --hs-slidecart-body-sale-saving-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_saving_font_weigth || '800' : '800'};
  --hs-slidecart-body-discount-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_discount_color_text_hex : '#737373'};
  --hs-slidecart-body-discount-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_discount_font_size : '14px'};
  --hs-slidecart-body-discount-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_discount_font_weigth : 'normal'};
  --hs-slidecart-body-upgrade-button-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upgrade_button_background_color_hex || slideData.customize.customize_body_upsell_button_background_color_hex : '#000000'};
  --hs-slidecart-body-upgrade-button-border-radius: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upgrade_button_border_radius || slideData.customize.customize_body_upsell_button_border_radius : '3px'};
  --hs-slidecart-body-upgrade-button-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upgrade_button_text_font_size || slideData.customize.customize_body_upsell_button_text_font_size : '14px'};
  --hs-slidecart-body-upgrade-button-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upgrade_button_text_color_hex || slideData.customize.customize_body_upsell_button_text_color_hex : '#ffffff'};
  --hs-slidecart-body-upgrade-button-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upgrade_button_text_font_weigth || slideData.customize.customize_body_upsell_button_text_font_weigth : '700'};
  --hs-slidecart-body-upgrade-button-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upgrade_button_text_transform || slideData.customize.customize_body_upsell_button_text_transform : 'uppercase'};
  --hs-slidecart-body-icon-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_icon_color_hex !== 'undefined' ? slideData.customize.customize_body_icon_color_hex : typeof slideData.customize.customize_body_prod_icon_remove_color_hex !== 'undefined' ? slideData.customize.customize_body_prod_icon_remove_color_hex : '#7d7d7d' : '#7d7d7d'};
  --hs-slidecart-body-icon-remove-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_prod_icon_remove_color_hex !== 'undefined' ? slideData.customize.customize_body_prod_icon_remove_color_hex : '#7d7d7d' : '#7d7d7d'};
  --hs-slidecart-body-icon-remove-color-hov: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_prod_icon_remove_color_hov_hex !== 'undefined' ? slideData.customize.customize_body_prod_icon_remove_color_hov_hex : '#7d7d7d' : '#7d7d7d'};
  --hs-slidecart-body-icon-remove-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_prod_icon_remove_size !== 'undefined' ? slideData.customize.customize_body_prod_icon_remove_size + 'px' : '14px' : '14px'};
  --hs-slidecart-body-upsell-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_background_color_hex : '#f7f8f9'};
  --hs-slidecart-body-upsell-var-options-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_options_color_text_hex : '#000000'};
  --hs-slidecart-body-upsell-var-options-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_options_font_weigth : '600'};
  --hs-slidecart-body-upsell-var-options-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_options_font_size : '14px'};
  --hs-slidecart-body-upsell-var-title-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_title_text_color_hex : '#000000'};
  --hs-slidecart-body-upsell-var-title-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_title_font_size : '14px'};
  --hs-slidecart-body-upsell-var-title-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_title_font_weigth : 'normal'};
  --hs-slidecart-body-upsell-var-title-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_title_text_transform : 'none'};
  --hs-slidecart-body-upsell-var-options-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_var_options_text_transform : 'none'};
  --hs-slidecart-body-upsell-prod-title-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_prod_title_color_text_hex : '#000000'};
  --hs-slidecart-body-upsell-prod-title-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_prod_title_font_weigth : '600'};
  --hs-slidecart-body-upsell-prod-title-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_prod_title_font_size : '14px'};
  --hs-slidecart-body-upsell-prod-title-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_prod_title_text_transform : 'none'};
  --hs-slidecart-body-upsell-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_price_color_text_hex : '#000000'};
  --hs-slidecart-body-upsell-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_price_font_size : '14px'};
  --hs-slidecart-body-upsell-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_price_font_weigth : 'normal'};
  --hs-slidecart-body-upsell-sale-price-text-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_upsell_sale_price_color_text_hex !== 'undefined' ? slideData.customize.customize_body_upsell_sale_price_color_text_hex : '#000000' : '#000000'};
  --hs-slidecart-body-upsell-sale-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_upsell_sale_price_font_size !== 'undefined' ? slideData.customize.customize_body_upsell_sale_price_font_size : '14px' : '14px'};
  --hs-slidecart-body-upsell-sale-price-text-weight: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_body_upsell_sale_price_font_weigth !== 'undefined' ? slideData.customize.customize_body_upsell_sale_price_font_weigth : 'normal' : 'normal'};
  --hs-slidecart-body-upsell-button-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_background_color_hex : '#000000'};
  --hs-slidecart-body-upsell-button-hov-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_hov_background_color_hex : '#000000'};
  --hs-slidecart-body-upsell-button-border-radius: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_border_radius : '0px'};
  --hs-slidecart-body-upsell-button-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_color_hex : '#ffffff'};
  --hs-slidecart-body-upsell-button-hov-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_hov_text_color_hex : '#ffffff'};
  --hs-slidecart-body-upsell-button-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_font_weigth : '600'};
  --hs-slidecart-body-upsell-button-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_font_size : '14px'};
  --hs-slidecart-body-upsell-button-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_transform : 'uppercase'};
  --hs-slidecart-body-upsell-arrows-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_arrows_color_hex : '#000000'};
  --hs-slidecart-body-upsell-compare-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_compare_price_color_text_hex : '#737373'};
  --hs-slidecart-body-upsell-compare-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_compare_price_font_size : '14px'};
  --hs-slidecart-body-upsell-compare-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_compare_price_font_weigth : 'normal'};
  --hs-slidecart-footer: ${Hs_CartDrawer.footer_fixed ? `auto` : 'hidden'};
  --hs-slidecart-footer-shipping-label-text-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_footer_shipping_label_text_color_hex !== 'undefined' ? slideData.customize.customize_footer_shipping_label_text_color_hex : '#000000' : '#000000'};
  --hs-slidecart-footer-shipping-label-text-font-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_footer_shipping_label_text_font_size !== 'undefined' ? slideData.customize.customize_footer_shipping_label_text_font_size : '14px' : '14px'};
  --hs-slidecart-footer-shipping-label-text-weight: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_footer_shipping_label_text_font_weight !== 'undefined' ? slideData.customize.customize_footer_shipping_label_text_font_weight : 'normal' : 'normal'};
  --hs-slidecart-footer-shipping-label-price-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_footer_shipping_label_price_color_hex !== 'undefined' ? slideData.customize.customize_footer_shipping_label_price_color_hex : '#000000' : '#000000'};
  --hs-slidecart-footer-shipping-label-price-font-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_footer_shipping_label_price_font_size !== 'undefined' ? slideData.customize.customize_footer_shipping_label_price_font_size : '14px' : '14px'};
  --hs-slidecart-footer-shipping-label-price-weight: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_footer_shipping_label_price_font_weight !== 'undefined' ? slideData.customize.customize_footer_shipping_label_price_font_weight : 'normal' : 'normal'};
  --hs-slidecart-footer-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_text_color_hex : '#000000'};
  --hs-slidecart-footer-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_background_color_hex : '#ffffff'};
  --hs-slidecart-footer-org-price-text-font-size: ${typeof slideData.settings.settings_footer !== 'undefined' ? slideData.settings.settings_footer.original_price_text_font_size : '12px'};
  --hs-slidecart-footer-total-save-text-font-size: ${typeof slideData.settings.settings_footer !== 'undefined' ? slideData.settings.settings_footer.total_save_text_font_size : '12px'};
  --hs-slidecart-footer-discount-text-font-size: ${typeof slideData.settings.settings_footer !== 'undefined' ? slideData.settings.settings_footer.discount_text_font_size : '12px'};
  --hs-slidecart-footer-shipping-text-font-size: ${typeof slideData.settings.settings_footer !== 'undefined' ? typeof slideData.settings.settings_footer.free_shipping_text1_font_size !== 'undefined' ? slideData.settings.settings_footer.free_shipping_text1_font_size : '12px' : '12px'};
  --hs-slidecart-footer-org-total-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_orig_total_price_text_font_size || '16px' : '16px'};
  --hs-slidecart-footer-org-total-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_orig_total_price_text_color_hex || '#000000' : '#000000'};
  --hs-slidecart-footer-org-total-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_orig_total_price_text_font_weight || 'normal' : 'normal'};
  --hs-slidecart-footer-org-total-price-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_orig_total_price_font_size || '16px' : '16px'};
  --hs-slidecart-footer-org-total-price-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_orig_total_price_color_hex || '#000000' : '#000000'};
  --hs-slidecart-footer-org-total-price-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_orig_total_price_font_weight || 'normal' : 'normal'};
  --hs-slidecart-footer-total-discount-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_discount_text_font_size || '16px' : '12px'};
  --hs-slidecart-footer-total-discount-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_discount_text_color_hex || '#000000' : '#000000'};
  --hs-slidecart-footer-total-discount-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_discount_text_font_weight || 'normal' : 'normal'};
  --hs-slidecart-footer-total-discount-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_discount_font_size || '16px' : '12px'};
  --hs-slidecart-footer-total-discount-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_discount_color_hex || '#000000' : '#000000'} !important;
  --hs-slidecart-footer-total-discount-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_discount_font_weight || 'normal' : 'normal'};
  --hs-slidecart-footer-total-price-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_price_font_size : '16px'};
  --hs-slidecart-footer-compare-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_compare_price_text_color_hex : '#737373'};
  --hs-slidecart-footer-total-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_price_text_color_hex : '#000000'};
  --hs-slidecart-footer-total-price-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_total_price_font_weigth : 'normal'};
  --hs-slidecart-footer-compare-price-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_compare_price_font_size : '16px'};
  --hs-slidecart-footer-compare-price-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_compare_price_font_weigth : 'normal'};
  --hs-slidecart-footer-discount-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_discount_text_color_hex : '#737373'};
  --hs-slidecart-footer-discount-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_discount_font_size : '16px'};
  --hs-slidecart-footer-discount-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_footer_discount_font_weigth : 'normal'};
  --hs-slidecart-countdown-background: ${slideData.settings.countdown.countdown_background_color_hex};
  --hs-slidecart-countdown-border-color: ${slideData.settings.countdown.countdown_border_color_hex};
  --hs-slidecart-countdown-text-color: ${slideData.settings.countdown.countdown_font_color_hex};
  --hs-slidecart-countdown-text-weight: ${slideData.settings.countdown.countdown_font_weight};
  --hs-slidecart-countdown-text-transform: ${slideData.settings.countdown.countdown_text_transform};
  --hs-slidecart-countdown-text-font-size: ${typeof slideData.settings.countdown.countdown_font_size !== 'undefined' ? slideData.settings.countdown.countdown_font_size : '14px'};
  --hs-slidecart-countdown-text-alignment: ${typeof slideData.settings.countdown.countdown_text_alignment !== 'undefined' ? slideData.settings.countdown.countdown_text_alignment : 'center'};
  --hs-slidecart-countdown-timer-background: ${typeof slideData.settings.countdown.countdown_timer_background_color_hex !== 'undefined' ? slideData.settings.countdown.countdown_timer_background_color_hex : slideData.settings.countdown.countdown_background_color_hex};
  --hs-slidecart-countdown-timer-background-border-radius: ${typeof slideData.settings.countdown.countdown_timer_background_border_radius !== 'undefined' ? slideData.settings.countdown.countdown_timer_background_border_radius : '1px'};
  --hs-slidecart-countdown-timer-color: ${typeof slideData.settings.countdown.countdown_timer_text_color_hex !== 'undefined' ? slideData.settings.countdown.countdown_timer_text_color_hex : slideData.settings.countdown.countdown_font_color_hex};
  --hs-slidecart-announcement-background: ${slideData.settings.announcement.announcement_background_color_hex};
  --hs-slidecart-announcement-border-color: ${slideData.settings.announcement.announcement_border_color_hex};
  --hs-slidecart-announcement-text-alignment: ${slideData.settings.announcement.announcement_text_alignment};
  --hs-slidecart-announcement-text-color: ${slideData.settings.announcement.announcement_font_color_hex};
  --hs-slidecart-announcement-text-weight: ${slideData.settings.announcement.announcement_font_weight};
  --hs-slidecart-announcement-text-font-size: ${typeof slideData.settings.announcement.announcement_font_size !== 'undefined' ? slideData.settings.announcement.announcement_font_size : '14px'};
  --hs-slidecart-announcement-text-transform: ${slideData.settings.announcement.announcement_text_transform};
  --hs-slidecart-rewards-background: ${typeof slideData.settings.rewards.rewards_background_content_color_hex !== 'undefined' ? slideData.settings.rewards.rewards_background_content_color_hex : typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_background_color_hex : '#ffffff'};
  --hs-slidecart-rewards-text-color: ${slideData.settings.rewards.rewards_font_color_hex};
  --hs-slidecart-rewards-text-weight: ${slideData.settings.rewards.rewards_font_weight};
  --hs-slidecart-rewards-text-font-size: ${typeof slideData.settings.rewards.rewards_font_size !== 'undefined' ? slideData.settings.rewards.rewards_font_size : '14px'};
  --hs-slidecart-rewards-text-transform: ${slideData.settings.rewards.rewards_text_transform};
  --hs-slidecart-rewards-text-font-size: ${typeof slideData.settings.rewards.rewards_font_size !== 'undefined' ? slideData.settings.rewards.rewards_font_size : '14px'};
  --hs-slidecart-rewards-border-radius: ${slideData.settings.rewards.rewards_border_radius};
  --hs-slidecart-rewards-background-secondary: ${slideData.settings.rewards.rewards_background_secondary_color_hex};
  --hs-slidecart-rewards-background-primary: ${slideData.settings.rewards.rewards_background_primary_color_hex};
  --hs-slidecart-cart-coupon-background: ${slideData.settings.cart_coupon.button_background_color_hex};
  --hs-slidecart-cart-coupon-background-hover: ${typeof slideData.settings.cart_coupon.button_background_colorHover_hex !== 'undefined' ? slideData.settings.cart_coupon.button_background_colorHover_hex : slideData.settings.cart_coupon.button_background_color_hex};
  --hs-slidecart-cart-coupon-border-radius: ${slideData.settings.cart_coupon.button_border_radius};
  --hs-slidecart-cart-coupon-text-font-size: ${typeof slideData.settings.cart_coupon.button_font_size !== 'undefined' ? slideData.settings.cart_coupon.button_font_size : '14px'};
  --hs-slidecart-cart-coupon-text-color: ${slideData.settings.cart_coupon.button_font_color_hex};
  --hs-slidecart-cart-coupon-text-color-hover: ${typeof slideData.settings.cart_coupon.button_font_colorHover_hex !== 'undefined' ? slideData.settings.cart_coupon.button_font_colorHover_hex : slideData.settings.cart_coupon.button_font_color_hex};
  --hs-slidecart-cart-coupon-text-transform: ${slideData.settings.cart_coupon.button_text_transform};
  --hs-slidecart-cart-coupon-text-weight: ${slideData.settings.cart_coupon.button_font_weight};
  --hs-slidecart-cart-note-head-color: ${slideData.settings.cart_note.cart_note_heading_color_hex};
  --hs-slidecart-cart-note-text-weight: ${slideData.settings.cart_note.cart_note_font_weight};
  --hs-slidecart-cart-note-text-font-size: ${typeof slideData.settings.cart_note.cart_note_font_size !== 'undefined' ? slideData.settings.cart_note.cart_note_font_size : '14px'};
  --hs-slidecart-cart-note-text-transform: ${slideData.settings.cart_note.cart_note_text_transform};
  --hs-slidecart-tiered-head-background: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_heading_background_color_hex : '#000000'};
  --hs-slidecart-tiered-head-text-color: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_heading_text_color_hex : '#ffffff'};
  --hs-slidecart-tiered-head-text-font-size: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_heading_font_size : '16px'};
  --hs-slidecart-tiered-head-text-bold: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? !!slideData.settings.tiered_free_items.tfi_heading_bold_font ? 'bold' : 'unset ' : 'bold'};
  --hs-slidecart-tiered-unlock-text-font-size: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_text_font_size : '14px'};
  --hs-slidecart-tiered-unlock-text-weight: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_text_font_weight : '700'};
  --hs-slidecart-tiered-unlock-text-transform: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_text_transform : 'none'};
  --hs-slidecart-tiered-unlock-text-color: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_text_color_hex : '#000000'};
  --hs-slidecart-tiered-unlock-bar-secondary-color: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_bar_color_secondary_hex : '#cccccc'};
  --hs-slidecart-tiered-unlock-bar-primary-color: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_bar_color_primary_hex : '#000000'};
  --hs-slidecart-tiered-unlock-bar-border-radius: ${typeof slideData.settings.tiered_free_items !== 'undefined' ? slideData.settings.tiered_free_items.tfi_unlock_bar_border_radius : '10px'};
  --hs-slidecart-recommendations-head-background: ${slideData.settings.product_recommendations_settings.heading_background_color_hex};
  --hs-slidecart-recommendations-head-text-color: ${slideData.settings.product_recommendations_settings.heading_text_color_hex};
  --hs-slidecart-recommendations-head-text-bold: ${!!slideData.settings.product_recommendations_settings.heading_bold_font ? 'bold' : 'unset '};
  --hs-slidecart-recommendations-text-font-size: ${typeof slideData.settings.product_recommendations_settings.font_size_upsell_automatic !== 'undefined' ? slideData.settings.product_recommendations_settings.font_size_upsell_automatic : '16px'};
  --hs-slidecart-manually-head-background: ${slideData.settings.manually_products_upsells.heading_background_color_hex_manually};
  --hs-slidecart-manually-head-text-color: ${slideData.settings.manually_products_upsells.heading_text_color_hex_manually};
  --hs-slidecart-manually-head-text-bold: ${!!slideData.settings.manually_products_upsells.heading_bold_font_manually ? 'bold' : 'unset'};
  --hs-slidecart-manually-text-font-size: ${typeof slideData.settings.manually_products_upsells.upsell_product_font_size_manually !== 'undefined' ? slideData.settings.manually_products_upsells.upsell_product_font_size_manually : '16px'};
  --hs-slidecart-static-head-background: ${typeof slideData.settings.static_products_upsells !== 'undefined' ? slideData.settings.static_products_upsells.heading_background_color_hex_static : '#f7f8f9'};
  --hs-slidecart-static-head-text-color: ${typeof slideData.settings.static_products_upsells !== 'undefined' ? slideData.settings.static_products_upsells.heading_text_color_hex_static : '#ffffff'};
  --hs-slidecart-static-head-text-bold: ${typeof slideData.settings.static_products_upsells !== 'undefined' ? !!slideData.settings.static_products_upsells.heading_bold_font_static ? 'bold' : 'unset' : 'unset'};
  --hs-slidecart-static-text-font-size: ${typeof slideData.settings.static_products_upsells !== 'undefined' ? slideData.settings.static_products_upsells.font_size_upsell_static : '14px'};
  --hs-slidecart-cart-empty-title-text-color: ${slideData.settings.cart_empty.cart_empty_title_color_hex};
  --hs-slidecart-cart-empty-title-text-transform: ${slideData.settings.cart_empty.cart_empty_title_text_transform};
  --hs-slidecart-cart-empty-title-text-weight: ${slideData.settings.cart_empty.cart_empty_title_font_weight};
  --hs-slidecart-cart-empty-title-text-font-size: ${typeof slideData.settings.cart_empty.cart_empty_title_font_size !== 'undefined' ? slideData.settings.cart_empty.cart_empty_title_font_size : '15px'};
  --hs-slidecart-cart-empty-subtitle-text-color: ${slideData.settings.cart_empty.cart_empty_subtitle_color_hex};
  --hs-slidecart-cart-empty-subtitle-text-transform: ${slideData.settings.cart_empty.cart_empty_subtitle_text_transform};
  --hs-slidecart-cart-empty-subtitle-text-weight: ${slideData.settings.cart_empty.cart_empty_subtitle_font_weight};
  --hs-slidecart-cart-empty-subtitle-text-font-size: ${typeof slideData.settings.cart_empty.cart_empty_subtitle_font_size !== 'undefined' ? slideData.settings.cart_empty.cart_empty_subtitle_font_size : '16px'};
  --hs-slidecart-cart-empty-button-text-weight: ${slideData.settings.cart_empty.cart_empty_button_font_weight};
  --hs-slidecart-cart-empty-button-text-transform: ${slideData.settings.cart_empty.cart_empty_button_text_transform};
  --hs-slidecart-cart-empty-button-text-color: ${slideData.settings.cart_empty.cart_empty_button_font_color_hex};
  --hs-slidecart-cart-empty-button-text-font-size: ${typeof slideData.settings.cart_empty.cart_empty_button_font_size !== 'undefined' ? slideData.settings.cart_empty.cart_empty_button_font_size : '16px'};
  --hs-slidecart-cart-empty-button-background: ${slideData.settings.cart_empty.cart_empty_button_background_color_hex};
  --hs-slidecart-cart-empty-button-border-radius: ${slideData.settings.cart_empty.cart_empty_button_border_radius};
  --hs-slidecart-cart-empty-upsell-head-background: ${slideData.settings.cart_empty.cart_empty_upsell_heading_background_color_hex};
  --hs-slidecart-cart-empty-upsell-text-color: ${slideData.settings.cart_empty.cart_empty_upsell_text_color_hex};
  --hs-slidecart-cart-empty-upsell-text-font-size: ${typeof slideData.settings.cart_empty.cart_empty_upsell_font_size !== 'undefined' ? slideData.settings.cart_empty.cart_empty_upsell_font_size : '16px'};
  --hs-slidecart-cart-empty-upsell-text-bold: ${!!slideData.settings.cart_empty.cart_empty_upsell_heading_bold_font ? 'bold' : 'normal'};
  --hs-slidecart-terms-text-font-size: ${typeof slideData.settings.terms_conditions.font_size_terms !== 'undefined' ? slideData.settings.terms_conditions.font_size_terms : '12px'};
  --hs-slidecart-note-additional-text-color: ${typeof slideData.settings.cart_note.cart_note_additional_color_hex !== 'undefined' ? slideData.settings.cart_note.cart_note_additional_color_hex : '#000000'};
  --hs-slidecart-note-additional-text-font-size: ${typeof slideData.settings.cart_note.cart_note_additional_font_size !== 'undefined' ? slideData.settings.cart_note.cart_note_additional_font_size : '12px'};
  --hs-slidecart-min-order-text-color: ${slideData.settings.minimum_order.minimum_color_hex};
  --hs-slidecart-min-order-text-font-size: ${typeof slideData.settings.minimum_order.minimum_font_size !== 'undefined' ? slideData.settings.minimum_order.minimum_font_size : '16px'};
  --hs-slidecart-cart-btn-text-color: ${slideData.settings.cart_button.cart_button_text_color_hex};
  --hs-slidecart-cart-btn-background: ${slideData.settings.cart_button.cart_button_background_color_hex};
  --hs-slidecart-cart-btn-border-radius: ${slideData.settings.cart_button.cart_button_border};
  --hs-slidecart-cart-btn-height: ${typeof slideData.settings.cart_button.cart_button_height !== 'undefined' ? slideData.settings.cart_button.cart_button_height : '38px'};
  --hs-slidecart-cart-btn-text-font-size: ${slideData.settings.cart_button.cart_button_text_font_size};
  --hs-slidecart-cart-btn-text-weight: ${slideData.settings.cart_button.cart_button_text_weight};
  --hs-slidecart-cart-btn-text-transform: ${slideData.settings.cart_button.cart_button_text_transform};
  --hs-slidecart-cart-btn-background-hov: ${slideData.settings.cart_button.cart_button_background_colorHover_hex};
  --hs-slidecart-cart-btn-text-color-hov: ${slideData.settings.cart_button.cart_button_text_colorHover_hex};
  --hs-slidecart-shipping-margin: ${typeof slideData.settings.shipping_protection !== 'undefined' ? !!slideData.settings.shipping_protection.sp_show_image ? '10px' : '' : ''};
  --hs-slidecart-shipping-title-text-weight: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_title_font_weight : 'normal'};
  --hs-slidecart-shipping-title-text-font-size: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_title_font_size : '14px'};
  --hs-slidecart-shipping-title-text-color: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_title_color_hex : '#000000'};
  --hs-slidecart-shipping-title-text-transform: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_title_transform : 'none'};
  --hs-slidecart-shipping-desc-text-weight: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_description_font_weight : 'normal'};
  --hs-slidecart-shipping-desc-text-font-size: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_description_font_size : '12px'};
  --hs-slidecart-shipping-desc-text-color: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_description_color_hex : '#737373	'};
  --hs-slidecart-shipping-desc-text-transform: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_description_transform : 'none'};
  --hs-slidecart-shipping-price-weight: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_price_font_weight : 'normal'};
  --hs-slidecart-shipping-price-font-size: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_price_font_size : '14px'};
  --hs-slidecart-shipping-price-color: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_price_color_hex : '#000000'};
  --hs-slidecart-shipping-compare-price-weight: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_compare_price_font_weight : 'normal'};
  --hs-slidecart-shipping-compare-price-font-size: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_compare_price_font_size : '14px'};
  --hs-slidecart-shipping-compare-price-color: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_compare_price_color_hex : '#737373	'};
  --hs-slidecart-shipping-compare-price-color: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_compare_price_color_hex : '#737373	'};
  --hs-slidecart-shipping-toggle-color: ${typeof slideData.settings.shipping_protection !== 'undefined' ? slideData.settings.shipping_protection.sp_toggle_color_hex : '#008060'};
  --hs-slidecart-gift-wrap-font-size: ${typeof slideData?.settings?.gift_wrap?.offer_font_size !== 'undefined' ? slideData.settings.gift_wrap.offer_font_size : '13px'};
  --hs-slidecart-gift-wrap-icon-color: ${slideData?.settings?.gift_wrap?.gift_wrap_icon_color_hex};
  --hs-slidecart-gift-wrap-offer-color: ${typeof slideData.settings.gift_wrap !== 'undefined' ? slideData.settings.gift_wrap.offer_name_color_hex : '#000000'};
  --hs-slidecart-gift-wrap-compare-price-color: ${slideData?.settings?.gift_wrap?.offer_compare_price_color_hex};
  --hs-slidecart-gift-wrap-price-color: ${slideData?.settings?.gift_wrap?.offer_price_color_hex};
  --hs-slidecart-gift-wrap-prod-title-bold: ${typeof slideData?.settings?.gift_wrap?.featured_product_title_bold !== 'undefined' ? !!slideData.settings.gift_wrap.featured_product_title_bold ? 'bold' : 'normal' : 'normal'};
  --hs-slidecart-gift-wrap-direction: ${Hs_CartDrawer.prices_reverse_order ? 'row-reverse' : 'row'};
  --hs-slidecart-gift-wrap-display-compare-price-color: ${slideData?.settings?.gift_wrap?.display_compare_price_color_hex};
  --hs-slidecart-gift-wrap-display-selling-color: ${slideData?.settings?.gift_wrap?.display_selling_color_hex};
  --hs-slidecart-continue-shop-text-color: ${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text_color_hex : '#737373'};
  --hs-slidecart-continue-shop-text-font-size: ${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text_font_size : '16px'};
  --hs-slidecart-continue-shop-text-weight: ${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text_weight : 'normal'};
  --hs-slidecart-continue-shop-text-decoration: ${typeof slideData.settings.continue_shopping !== 'undefined' ? typeof slideData.settings.continue_shopping.continue_shopping_text_decoration !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text_decoration : 'underline' : 'underline'};
  --hs-slidecart-continue-shop-text-transform: ${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text_transform : 'uppercase'};
  --hs-slidecart-continue-shop-text-color-hov: ${typeof slideData.settings.continue_shopping !== 'undefined' ? slideData.settings.continue_shopping.continue_shopping_text_colorHover_hex : '#000000'};
  --hs-slidecart-popup-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_background_color_hex : '#ffffff'};
  --hs-slidecart-popup-border-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_border_color_hex : '#e5e5e5'};
  --hs-slidecart-popup-title-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_title_text_color_hex : '#000000'};
  --hs-slidecart-popup-title-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_title_font_size : '14px'};
  --hs-slidecart-popup-title-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_title_font_weigth : '600'};
  --hs-slidecart-popup-title-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_title_text_transform : 'none'};
  --hs-slidecart-popup-button-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_text_font_size : '14px'};
  --hs-slidecart-popup-button-border-radius: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_border_radius : '0px'};
  --hs-slidecart-popup-button-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_text_color_hex : '#ffffff'};
  --hs-slidecart-popup-button-background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_background_color_hex : '#000000'};
  --hs-slidecart-popup-button-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_text_font_weigth : '600'};
  --hs-slidecart-popup-button-text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_text_transform : 'uppercase'};
  --hs-slidecart-popup-button-text-color-hov: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_hov_text_color_hex : '#ffffff'};
  --hs-slidecart-popup-button-background-hov: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_button_hov_background_color_hex : '#000000'};
  --hs-slidecart-popup-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_price_text_color_hex : '#000000'};
  --hs-slidecart-popup-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_price_font_size : '14px'};
  --hs-slidecart-popup-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_price_font_weigth : '600'};
  --hs-slidecart-popup-compare-price-text-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_compare_price_text_color_hex : '#737373'};
  --hs-slidecart-popup-compare-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_compare_price_font_size : '14px'};
  --hs-slidecart-popup-compare-price-text-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_popup_compare_price_font_weigth : '600'};
  --hs-slidecart-popup-sale-price-text-color: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_popup_sale_price_text_color_hex !== 'undefined' ? slideData.customize.customize_popup_sale_price_text_color_hex : '#000000' : '#000000'};
  --hs-slidecart-popup-sale-price-text-font-size: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_popup_sale_price_font_size !== 'undefined' ? slideData.customize.customize_popup_sale_price_font_size : '14px' : '14px'};
  --hs-slidecart-popup-sale-price-text-weight: ${typeof slideData.customize !== 'undefined' ? typeof slideData.customize.customize_popup_sale_price_font_weigth !== 'undefined' ? slideData.customize.customize_popup_sale_price_font_weigth : '600' : '600'};
  --hs-slidecart-mobile-max-width: ${typeof slideData.customize !== 'undefined' ? !!slideData.customize.customize_slidecart_design && !slideData.customize.customize_slidecart_margin_left ? '20px' : typeof slideData.customize !== 'undefined' ? !!slideData.customize.customize_slidecart_margin_left ? '40px' : '0px' : '0px' : '0px'};
  --hs-order-body-countdown: ${Hs_CartDrawer.getDataPosition('hs-countdown')?.order || 1};
  --hs-order-body-announcement: ${Hs_CartDrawer.getDataPosition('hs-announcement')?.order || 2};
  --hs-order-body-rewards: ${Hs_CartDrawer.getDataPosition('hs-rewards')?.order || 3};
  --hs-order-body-clear: ${Hs_CartDrawer.getDataPosition('hs-clearAll')?.order || 4};
  --hs-order-body-products: ${Hs_CartDrawer.getDataPosition('hs-products')?.order || 5};
  --hs-order-body-discount: ${Hs_CartDrawer.getDataPosition('hs-discountCode')?.order || 6};
  --hs-order-body-note: ${Hs_CartDrawer.getDataPosition('hs-note')?.order || 7};
  --hs-order-body-tiered: ${Hs_CartDrawer.getDataPosition('hs-tiered')?.order || 8};
  --hs-order-body-upsell-automatic: ${Hs_CartDrawer.getDataPosition('hs-upsellAutomatic')?.order || 8};
  --hs-order-body-upsell-manually: ${Hs_CartDrawer.getDataPosition('hs-upsellManually')?.order || 10};
  --hs-order-body-upsell-static: ${Hs_CartDrawer.getDataPosition('hs-upsellStatic')?.order || 11};
  --hs-order-empty-rewards: ${Hs_CartDrawer.getDataPosition('hs-rewards', 'empty_cart')?.order || 1};
  --hs-order-empty-cart: ${Hs_CartDrawer.getDataPosition('hs-emptyCart', 'empty_cart')?.order || 2};
  --hs-order-empty-upsell: ${Hs_CartDrawer.getDataPosition('hs-upsell', 'empty_cart')?.order || 3};
  --hs-scroll-width: ${scrollbarWidth};
  }
        `;
  },
  cssSlideCart: function () {
    var grid_column = '';
    if (typeof slideData.customize !== 'undefined') {
      if (typeof slideData.customize.customize_slidecart_size !== 'undefined') {
        if (slideData.customize.customize_slidecart_size == 365) {
          grid_column = `grid-column: 1/3;`;
        };
      };
    };


    var cssSlider = `
  .hs-cart-content-price .hs-cart-item-prices-row{\
    display: flex;\
    column-gap: 10px;
    justify-content: center;\
    flex-wrap: wrap;\
    align-items: center;\
    ${Hs_CartDrawer.prices_reverse_order ? `flex-direction: row-reverse;` : ''}
  }\
  /**********************************/              
  .hs-nopopup .hs-options-swiper {\
    ${grid_column}\
  }\
  .hs-nopopup:not(.hs-not-qty) .hs-upsell-add{\
    ${grid_column}\
  }\

  .hs-nopopup .hs-qty-upsell {\
    ${grid_column}\
  }\
  /**********************************/
  .hs-mount-sub-total,
  .hs-amount-original-price-content .hs_original_price,
  .hs-amount-save-content .hs_total_save{\
    display: flex;\
    -webkit-box-align: center;\
    align-items: center;\
    -webkit-box-pack: justify;\
    justify-content: space-between;\
    width: auto;\
    text-align: right;\
    column-gap: 10px;\
    flex-wrap: wrap;\
    justify-content: right;\
    ${Hs_CartDrawer.prices_reverse_order ? `flex-direction: row-reverse;` : ''}
  }\

  .hs-content-buttons{\
    display: flex;\
    flex-direction: column;\
    gap:10px;\
    justify-content: space-between;\
  }\
  ${Hs_CartDrawer.integrationData(11) ?
        '.hs-popup-cart-sp-load .hs-site-cart-popup-layout .hs-footer-layout .hs-finalize-purchase .hs-checkout-purchase[name="checkout"][data-route-ref]{\
        display: none !important;\
    }' : ''
      }

  ${!Hs_CartDrawer.integrationData(14) ? `.hs-popup-cart-sp-load .hs-site-cart-popup-layout .hs-footer-layout .hs-finalize-purchase #_rsi-buy-now-button{
    display:none;
  }`: ''}
                
  .hs-shipping-price-sw{\
    display: flex;\
    gap: 10px;\
    ${Hs_CartDrawer.prices_reverse_order ? `flex-direction: row-reverse;
    justify-content: flex-end;` : ''}
  }\

  .hs-popUp-product .hs-product-popup-text .hs-content-price-swiper .hs-options-prices{
    display:flex;\
    column-gap: 10px;\
    flex-wrap: wrap;\
    ${Hs_CartDrawer.prices_reverse_order ? 'flex-direction:row-reverse;' : 'justify-content: flex-end;'}
  }                        
  `;
    document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">' + cssSlider + '</style>');
  },
  slideCartDisabled: function () {
    var hs_sticky_cart_cart_drawer = !!document.querySelector('.hs-sticky-cart-cart-drawer') ? document.querySelector('.hs-sticky-cart-cart-drawer') : '';
    if (!!hs_sticky_cart_cart_drawer) {
      if (!hs_sticky_cart_cart_drawer.classList.contains('hs-event-static')) {
        hs_sticky_cart_cart_drawer.classList.add('hs-event-static');
        hs_sticky_cart_cart_drawer.addEventListener("click", function (e) {
          HsApp1.redirectCart();
        });
      }
    }
  },
  viewPage: function () {
    var url = window.location.href;
    if (url.indexOf('viewcart=true') > -1) {
      Hs_CartDrawer.getSlideCart();
    }
  },
  alwaysViewPage: function () {
    var url = window.location.href;
    if (url.indexOf('hsviewcart=true') > -1) {
      HsApp1.openCart();
    }
  },
  viewChatShopify: function () {
    var shopify_chat = !!document.querySelector('#shopify-chat') ? document.querySelector('#shopify-chat') : '';
    var shopify_chat_dummy = !!document.querySelector('#shopify-chat-dummy') ? document.querySelector('#shopify-chat-dummy') : '';
    var shopify_chat_iframe = !!document.querySelector('#dummy-chat-button-iframe') ? document.querySelector('#dummy-chat-button-iframe') : '';
    var fb_root = !!document.querySelector('#fb-root') ? document.querySelector('#fb-root') : '';
    var ba_loy_namespace = !!document.querySelector('.ba-loy-namespace') ? document.querySelector('.ba-loy-namespace') : '';
    var trustbadge = !!document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810') ? document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810') : '';
    var trustbadge_ovnvik = !!document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810 ._ovnvik') ? document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810 ._ovnvik') : '';
    var hubspot_messages = !!document.querySelector('#hubspot-messages-iframe-container') ? document.querySelector('#hubspot-messages-iframe-container') : '';
    var hubspot_messages_iframe = !!document.querySelector('#hubspot-messages-iframe-container iframe') ? document.querySelector('#hubspot-messages-iframe-container iframe') : '';
    if (!!shopify_chat) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        shopify_chat.style.display = 'none';
      }
      else {
        shopify_chat.style.display = 'block';
      }
    };

    if (!!shopify_chat_dummy) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        shopify_chat_dummy.style.display = 'none';
      }
      else {
        shopify_chat_dummy.style.display = 'block';
      }
    };

    if (!!shopify_chat_iframe) {
      if (!!document.querySelector('body').classList.contains('hs-open-cart')) {
        shopify_chat_iframe.style.display = 'none';
      }
      else {
        shopify_chat_iframe.style.display = 'block';
      }
    };

    if (!!fb_root) {
      var fb_iframe_widget = !!fb_root.querySelector('.fb_iframe_widget') ? fb_root.querySelector('.fb_iframe_widget') : '';
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        if (!!fb_iframe_widget) {
          fb_iframe_widget.style.display = 'none';
        }
        fb_root.style.display = 'none';
      }
      else {
        if (!!fb_iframe_widget) {
          fb_iframe_widget.style.display = 'block';
        }
        fb_root.style.display = 'block';
      }
    };

    if (!!ba_loy_namespace) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        ba_loy_namespace.style.display = 'none';
      }
      else {
        ba_loy_namespace.style.display = 'block';
      }
    };

    if (!!trustbadge) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        trustbadge.style.display = 'none';
        if (!!trustbadge_ovnvik) {
          trustbadge_ovnvik.setAttribute('style', 'display: none !important;');
        }
      }
      else {
        trustbadge.style.display = 'block';
        if (!!trustbadge_ovnvik) {
          trustbadge_ovnvik.setAttribute('style', 'display: block !important;');
        }
      }
    };

    if (!!hubspot_messages) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        hubspot_messages.setAttribute('style', 'display: none !important;');
      }
      else {
        hubspot_messages.setAttribute('style', 'display: initial !important;');
      }
    };

    if (!!hubspot_messages_iframe) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        hubspot_messages_iframe.setAttribute('style', 'display: none !important;');
      }
      else {
        hubspot_messages_iframe.setAttribute('style', 'display: initial !important;');
      }
    };
  },
  viewSmileUiWidget: function () {
    var smailUi = !!document.querySelector('#smile-ui-container') ? document.querySelector('#smile-ui-container') : '';
    if (!!smailUi) {
      if (document.querySelector('body').classList.contains('hs-open-cart')) {
        smailUi.style.display = 'none';
      }
      else {
        smailUi.style.display = 'block';
      }
    }
  },
  reloadedAddToCart: function () {
    var btnProductQuickview = document.querySelectorAll('.btn.btnProduct.btnProductQuickview, .quickview.quick_amount_one, .card__buttons a.button--addToCart,.quick-view-part,a[href="#"].compare,button.VariantSelector__Button,.VariantSelector__Item.is-selected, .quick-add modal-opener	 button.quick-add__submit,button.product-upsell__btn[type="button"][data-quick-add-btn],quick-add-product .quick-add__button:not([name="add"]),product-block a.quickbuy-toggle').length > 0 ? document.querySelectorAll('.btn.btnProduct.btnProductQuickview, .quickview.quick_amount_one, .card__buttons a.button--addToCart,.quick-view-part,a[href="#"].compare,button.VariantSelector__Button,.VariantSelector__Item.is-selected, .quick-add modal-opener	 button.quick-add__submit,button.product-upsell__btn[type="button"][data-quick-add-btn],quick-add-product .quick-add__button:not([name="add"]),product-block a.quickbuy-toggle') : [];
    if (btnProductQuickview.length > 0) {
      btnProductQuickview.forEach(function (buttonView) {
        if (!buttonView.classList.contains('hs-event-static')) {
          buttonView.classList.add('hs-event-static')
          buttonView.addEventListener('click', function (e) {
            setTimeout(function () {
              var elementAdd = Hs_CartDrawer.elementAdd;
              var a = document.querySelectorAll(elementAdd).length > 0 ? document.querySelectorAll(elementAdd) : [];
              if (a.length > 0) {
                var x = [];
                a.forEach(function (val) {
                  val.classList.remove('hs-event-static');
                  val.outerHTML = val.outerHTML;
                  x.push([val]);
                });
                if (x.length == a.length) {
                  setTimeout(function () {
                    pageflyANDgempages.addToCart();
                  }, 700);
                };
              };
            }, 700);
          });
        }
      });
    };

    /*  var btnProductQuickview2 = document.querySelectorAll('select.kaching-bundles__bar-variant-select') || [];
    if (btnProductQuickview2.length > 0) {
      btnProductQuickview2.forEach(function (buttonView) {
        if (!buttonView.classList.contains('hs-event-static')) {
          buttonView.classList.add('hs-event-static')
          buttonView.addEventListener('change', function (e) {
            setTimeout(function () {
              var elementAdd = Hs_CartDrawer.elementAdd;
              var a = document.querySelectorAll(elementAdd).length > 0 ? document.querySelectorAll(elementAdd) : [];
              if (a.length > 0) {
                if (document.querySelector('[action$="/cart/add"] gp-product-button button[type="button"]:not(.gp-button-sold-out)')) {
                  a = new Set([
                    ...a,
                    ...document.querySelectorAll('[action$="/cart/add"] gp-product-button button[type="button"]:not(.gp-button-sold-out)')
                  ]);
                };
                var x = [];
                a.forEach(function (val) {
                  val.classList.remove('hs-event-static');
                  //val.outerHTML = val.outerHTML;
                  x.push([val]);
                });
                if (x.length == a.length) {
                  setTimeout(function () {
                    pageflyANDgempages.addToCart();
                  }, 600);
                };
              };
            }, 600);
          });
        }
      });
    }; */
    var gp_product_button = document.querySelector('[action$="/cart/add"] gp-product-button button[type="button"]:not(.gp-button-sold-out)');
    if (gp_product_button) {
      if (gp_product_button.closest('[action$="/cart/add"]')) {
        var form = gp_product_button.closest('[action$="/cart/add"]');
        if (form.querySelector('kaching-bundles-block')) {
          gp_product_button.classList.remove('hs-event-static');
          gp_product_button.outerHTML = gp_product_button.outerHTML;
          setTimeout(function () {
            pageflyANDgempages.addToCart();
          }, 600);
        };
      };
    }
  },
  addShipping: async function (variantId, elements, check) {
    if (variantId !== '') {
      /* if (elements.length > 0) {
        elements.forEach(function (element) {
          element.classList.add('hs-active');
          element.classList.remove('hs-toogle-load');
        })
      }; */
      Hs_CartDrawer.iniAddShipping = true;
      var myJSON = {};
      var params = new FormData();
      params.append("id", variantId);
      params.append('properties[_shippingProtection]', true)
      params.append("quantity", 1);
      var add = Hs_CartDrawer.routeLocale('cart/add.js');
      await fetch(`${add}`, {
        body: params,
        method: 'POST',
        headers: {
          'Accept': "application/json, text/javascript",
          'X-Requested-With': 'XMLHttpRequest'
        },
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        myJSON = { ...json };
        if (elements.length > 0) {
          HsApp1.createCpokie('hs-shipping-protection', json.key, 360);
          elements.forEach(function (element) {
            element.dataset.key = json.key;
            element.classList.add('hs-active');
            element.classList.remove('hs-toogle-load');
          });
          check.disabled = false;
        };
        if (!!Hs_CartDrawer.auto_add_shipping_protection) {
          HsApp1.deleteCookie('hs-shipping-protection-auto-add');
        };
        try {
          Hs_modal_notification(json?.message, json?.description, slideData)
        } catch (error) {
          alert(`Error ${json.status}: ${json.description}`)
        }
      }).catch(function (err) {
        if (elements.length > 0) {
          elements.forEach(function (element) {
            element.classList.remove('hs-active');
            element.classList.add('hs-toogle-load');
          });
          check.disabled = false;
        };
        if (!!Hs_CartDrawer.auto_add_shipping_protection) {
          HsApp1.deleteCookie('hs-shipping-protection-auto-add');
        };
        Hs_CartDrawer.iniAddShipping = false;
        console.log(err)
      }).then(function (e) {
        check.focus();
        Hs_CartDrawer.iniAddShipping = false;
        var paramsFunction = [
          {
            "name": 'addToCart',
            "attr": {
              "id": parseInt(variantId),
              "quantity": 1
            }
          }];
        HsApp1.getMyCart(0, paramsFunction);
      });
    };
  },
  removeShipping: function (variantId, elements, button, check) {
    var params = '', myJSON = {}, toggleKey = !!button ? typeof button.dataset.key !== 'undefined' ? button.dataset.key : '' : '';
    var elementsProperties = ['_giftWrap', '_shippingProtection'];
    var ini = 0;
    if (toggleKey !== '') {
      var cart = Hs_CartDrawer.routeLocale(`cart/change.js`);
      var mwgrouped = Hs_CartDrawer.mwgrouped();
      params = JSON.stringify({ id: toggleKey, quantity: 0 });
      fetch(`${cart}${mwgrouped}`, {
        body: params,
        method: 'POST',
        headers: {
          'Accept': "application/json, text/javascript",
          'Content-Type': "application/json, text/javascript",
          'X-Requested-With': 'XMLHttpRequest'
        },
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          json = window.BOLD.common.cartDoctor.fix(json);
        }
        myJSON = { ...json };
        if (elements.length > 0) {
          HsApp1.deleteCookie('hs-shipping-protection');
          elements.forEach(function (element) {
            element.classList.remove('hs-active');
            element.classList.remove('hs-toogle-load');
          })
          check.disabled = false;
          if (elementsProperties.length > 0) {
            elementsProperties.forEach(function (element) {
              ini++
              json = HsApp1.thisProperties(json, element)
            })
          };
          if (ini == elementsProperties.length) {
            window.HSSLIDECART.CART = myJSON;
            HsApp1.cartPrice = json.total_price;
            const items = json.items;
            const discounts = items.filter((item) => {
              return item.discounts && item.discounts.length > 0
            });
            if (discounts.length > 0) {
              HsApp1.getMyCart(0, '', '', 1);
            } else {
              HsApp1.updateCart(json, myJSON, 0);
              HsApp1.priceCart(myJSON);//CAMBIO
              HsApp3.countCart(json);
              HsApp1.plusMin();
              HsApp1.changeQuantityCart();
              HsApp1.clearALL();
              HsApp1.removeItemCart();
              HsApp1.hideCartPopup();
              HsApp1.hsconversionBundlesBear();
              HsApp1.currencyConverter();
              HsApp1.rechargeCartElement();
              HsApp1.startDiscount();
            }
          };
        };
        if (!!Hs_CartDrawer.auto_add_shipping_protection) {
          HsApp1.createCpokie('hs-shipping-protection-auto-add', true, 360);
        };
      }).catch(function (err) {
        HsApp1.createCpokie('hs-shipping-protection', myJSON.key, 360);
        elements.forEach(function (element) {
          element.classList.add('hs-active');
          element.classList.remove('hs-toogle-load');
        })
        check.disabled = false;
        console.log(err)
      }).then(function (e) {
        check.focus();
        if (ini == elementsProperties.length) {
          if (typeof window.HS_SLIDE_CART_REMOVED_FROM_CART !== 'undefined') {
            if (variantId !== '') {
              try {
                window.HS_SLIDE_CART_REMOVED_FROM_CART({ id: variantId });
              } catch (err) {
                console.log(err)
              };
            };
          };
        };
        //HsApp1.getMyCart(1, '');
      });
    };
  },
  iniShippingProtection: async function (result, iniJSON) {
    async function autoAddShipping(variantId = '', iniJSON = {}) {//CAMBIO
      if (variantId) {
        if (!!Hs_CartDrawer.auto_add_shipping_protection) {
          if (!!HsApp1.readCookie('hs-shipping-protection-auto-add')) {
            return false;
          }

          if (typeof iniJSON === 'object' && Object.keys(iniJSON).length > 0) {
            const cart = iniJSON;
            let propShip = false;
            if (Array.isArray(cart.items) && cart.items.length > 0) {
              propShip = cart.items.some(item =>
                item.properties &&
                typeof item.properties === 'object' &&
                Object.entries(item.properties).some(
                  ([key, value]) => key === '_shippingProtection' && value === 'true'
                )
              );
              if (!propShip) {
                var hs_shipping_protection_gnrl = !!document.querySelector('.hs-shipping-protection-gnrl') ? document.querySelector('.hs-shipping-protection-gnrl') : '';
                if (!!hs_shipping_protection_gnrl) {
                  var hs_shipping_slider = !!hs_shipping_protection_gnrl.querySelector('.hs-switch .hs-shipping-slider') ? hs_shipping_protection_gnrl.querySelector('.hs-switch .hs-shipping-slider') : '';
                  if (!!hs_shipping_slider) {
                    if (!hs_shipping_slider.classList.contains('hs-active')) {
                      var toggle = !!hs_shipping_protection_gnrl.querySelector('.hs-switch input[type="checkbox"]') ? hs_shipping_protection_gnrl.querySelector('.hs-switch input[type="checkbox"]') : '';
                      if (!!toggle) {
                        let this_input = document.querySelector('.hs-shipping-protection-gnrl .hs-switch input[type="checkbox"]');
                        if (this_input.disabled) {
                          return false;
                        };
                        this_input.disabled = true;
                        var x = document.querySelector('.hs-shipping-protection-gnrl .hs-switch .hs-shipping-slider');
                        x.classList.add('hs-toogle-load');
                        var elements = [this_input, x]
                        HsApp1.addShipping(variantId, elements, this_input)
                      };
                    };
                  };
                };
              };
            };
          };
        } else {
          HsApp1.deleteCookie('hs-shipping-protection-auto-add')
        };
      };
    };
    //await autoAddShipping();//CAMBIO

    if (!!document.querySelector('.hs-shipping-content')) {
      return false;
    };

    var error = false, dataShipping = slideData.settings.shipping_protection, variantId = dataShipping.sp_featured_product_shopify_id_variant;
    var product = Hs_CartDrawer.routeLocale(`products/${dataShipping.sp_featured_product_shopify_handle}.js`);
    var priceVariant = 1;//CAMBIO
    await fetch(`${product}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then((product) => {
        if (typeof product.handle !== 'undefined') {
          var image = '';
          var title = product?.title || '', description = product?.description || ''; price = product.variants[0].price, priceVariant = product.variants[0].price, compare_at_price = product.variants[0].compare_at_price != null ? product.variants[0].compare_at_price : 0, thisActive = !!HsApp1.readCookie('hs-shipping-protection') ? 'hs-active' : '', dataKey = !!HsApp1.readCookie('hs-shipping-protection') ? `data-key ='${HsApp1.readCookie('hs-shipping-protection')}'` : '';//CAMBIO
          variantId = product.variants[0].id;
          if (typeof slideData.settings.shipping_protection !== 'undefined') {
            if (!!slideData.settings.shipping_protection.sp_show_image) {
              image = 'https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
              if (product.featured_image != null) {
                image = product.featured_image;
              } else {
                if (product.variants[0].featured_image != null) {
                  image = product.variants[0].featured_image.src;
                };
              };
              image = HsApp1.resizeSrc(image, slideData.settings.additional_settings.image_quality);
              image = `<div class='hs-shipping-image'><img width="100" height="90" src="${image}" alt='${title}'/></div>`
            };
          };
          var content_gnrl = !!document.querySelector('.hs-shipping-protection-gnrl') ? document.querySelector('.hs-shipping-protection-gnrl') : '';
          if (!!content_gnrl) {
            !!content_gnrl.querySelector('.hs-result-loading') ? content_gnrl.querySelector('.hs-result-loading').remove() : '';
            content_gnrl.classList.remove('hs-loading-protection');
            content_gnrl.insertAdjacentHTML('afterbegin', `
                          <div class="hs-shipping-content" style="display:flex;">
                              <div class="hs-shipping-item">
                                  <div class="hs-item-toggle-img">
                                    <div class="hs-item-content">
                                      <div class="hs-switch" id="hs-switch-container">
                                        <input id= "hs-shipping-chk-id" class="hs-shipping-chk ${thisActive}" type="checkbox" ${dataKey}>
                                        <span class="hs-shipping-slider hs-shipping-round ${thisActive}" ${dataKey}> </span>
                                        <span class="hs-hidden-compare">Toogle</span>
                                      </div>
                                      ${image}
                                    </div>
                                  </div>
                              </div>
                              <div class="hs-shipping-item-data">
                                <div class="hs-shipping-tittle">
                                  <label for="hs-shipping-chk-id" style="cursor: pointer;"><span class="hs-shipping-tittle">${title}</span></label>
                                  <div class="hs-shipping-price-sw">
                                  ${parseInt(compare_at_price) > parseInt(price) ?
                '<div class="hs-shipping-compare-price">' + hsonslidecart.Currency.formatMoney(compare_at_price, slideData.settings.devices.money_format) + '</div>' : ``
              }
                                  <div class="hs-shipping-price">${price <= 0 ? Hs_CartDrawer.languageFreeGnral !== '' ? '<span>' + Hs_CartDrawer.languageFreeGnral + '</span>' : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) : hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format)}</div>
                                  </div>
                                </div>
                                <input class="hs-shipping-compare-price-hidden" type="hidden" value="${compare_at_price}">
                                <input class="hs-shipping-price-hidden" type="hidden" value="${price}">
                                <p class="hs-shipping-desc" style="display: block">${description.replace(/(<([^>]+)>)/gi, "")}</p>
                              </div>
                          </div>`
            )
          };
        };
      })
      .catch(err => {
        error = true;
        var hs_layout_content = !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout') : '';
        if (!!hs_layout_content) {
          var hs_shipping_protection = !!hs_layout_content.querySelector('.hs-shipping-protection-gnrl') ? hs_layout_content.querySelector('.hs-shipping-protection-gnrl') : '';
          if (!!hs_shipping_protection) {
            hs_shipping_protection.remove();
          }
        };
        if (!!HsApp1.readCookie('hs-shipping-protection')) {
          HsApp1.deleteCookie('hs-shipping-protection');
          HsApp1.deleteCookie('hs-shipping-protection-auto-add');
          Hs_CartDrawer.validateShippingGral(iniJSON);
        }
        console.error(err)
      })
      .then(e => {
        if (!error) {
          var hs_layout_content = !!document.querySelector('.hs-site-cart-popup-layout') ? document.querySelector('.hs-site-cart-popup-layout') : '';
          if (!!hs_layout_content) {
            var hs_shipping_protection = !!hs_layout_content.querySelector('.hs-shipping-protection-gnrl') ? hs_layout_content.querySelector('.hs-shipping-protection-gnrl') : '';
            if (!!hs_shipping_protection) {
              var toggles = document.querySelectorAll('.hs-shipping-protection-gnrl .hs-switch#hs-switch-container,.hs-shipping-protection-gnrl .hs-shipping-image img') || [];
              if (toggles.length > 0) {
                toggles.forEach(function (toggle) {
                  !toggle.classList.contains('hs-event-static') ?
                    toggle.classList.add('hs-event-static') &
                    toggle.addEventListener('click', function (e) {
                      let this_input = document.querySelector('.hs-shipping-protection-gnrl .hs-switch input[type="checkbox"]');
                      if (this_input.disabled) {
                        return false;
                      };
                      this_input.disabled = true;
                      var x = document.querySelector('.hs-shipping-protection-gnrl .hs-switch .hs-shipping-slider');
                      x.classList.add('hs-toogle-load');
                      var elements = [this_input, x]
                      !x.classList.contains('hs-active') ?
                        HsApp1.addShipping(variantId, elements, this_input)/* && x.classList.add('hs-active') */ :
                        HsApp1.removeShipping(variantId, elements, x, this_input); /* && x.classList.remove('hs-active') */
                    }) : '';

                });
                priceVariant == 0 || (typeof window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] !== 'undefined' && window['55a055409207a12d5937b243fd508bde_AUTO_ADD'] == 1) ? autoAddShipping(variantId, iniJSON) : '';//CAMBIO
              };
            }
          };
        };
      });
  },
  elementsOpenSlideCart: function () {
    var elements = document.querySelectorAll(HsApp1.openSlideCart).length > 0 ? document.querySelectorAll(HsApp1.openSlideCart) : [];
    if (elements.length > 0) {
      elements.forEach(function (val) {
        if (!val.classList.contains('hs-event-static')) {
          var classContains = val.classList.contains('tt-dropdown-obj') || val.classList.contains('tt-desctop-parent-cart') || '';
          if (!classContains) {
            val.outerHTML = val.outerHTML;
          };
        };
      });
      elements = document.querySelectorAll(HsApp1.openSlideCart).length > 0 ? document.querySelectorAll(HsApp1.openSlideCart) : [];
      if (elements.length > 0) {
        elements.forEach(function (val) {
          if (!!val.querySelector('button[data-tooltip="Cart"]')) {
            if (!!val.querySelector('button[data-tooltip="Cart"]').attributes.onclick) {
              if (!!val.querySelector('button[data-tooltip="Cart"]').attributes.onclick.nodeValue) {
                if (val.querySelector('button[data-tooltip="Cart"]').attributes.onclick.nodeValue === 'window.SLIDECART_OPEN()') {
                  val.querySelector('button[data-tooltip="Cart"]').attributes.onclick.nodeValue = '';
                };
              };
            };
          };
          if (!!val.attributes.onclick) {
            val.attributes.onclick.nodeValue = '';
          };
          if (!!val.attributes['on:click']) {
            val.attributes['on:click'].nodeValue = '';
          };
          if (!val.classList.contains('hs-event-static')) {
            //val.outerHTML = val.outerHTML;
            /*var this_capture = false;
            if (val.getAttribute('is')) {
              if (val.getAttribute('is') === 'toggle-link') {
                if (val.getAttribute('aria-expanded')) {
                  if (val.getAttribute('aria-expanded') !== '') {
                    this_capture = true;
                  };
                };
              };
            }; */
            function openSlideCartHandler(e) {
              var x = 0;
              if (!!e) {
                if (typeof e.path !== 'undefined') {
                  if (e.path.length > 0) {
                    e.path.forEach(function (val) {
                      if (typeof val.classList !== 'undefined') {
                        if (typeof val.localname !== 'undefined') {
                          if (!!val.localname) {
                            var link_type = !!val.getAttribute('data-zp-link-type') ? val.getAttribute('data-zp-link-type') : '';
                            if (!!link_type) {
                              if (link_type === 'external' || link_type === 'checkout') {
                                x = 1;
                              };
                            };
                          };
                        };
                      };
                    })
                  }
                }
              };
              if (x == 0) {
                HsApp1.openCartDrawerClick(val);
              }
            };
            val.classList.add('hs-event-static');
            val.addEventListener("click", function (e) {
              e.stopImmediatePropagation();
              e.stopPropagation();
              e.preventDefault();
              openSlideCartHandler(e);
            }, true);

            val.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openSlideCartHandler(event);
              }
            });
          }
        });
      };
    };
  },
  slideCart: function () {
    HsApp1.cssSlideCart();
    var elementSlideCart = !!document.querySelector('.hs-popup-cart-sp-load') ? document.querySelector('.hs-popup-cart-sp-load') : '',
      animatedHover,
      hs_hidden_count_cart,
      footer_fixed = '',
      url = window.location.href,
      iniCart = 1;
    if (!!elementSlideCart) {
      return false;
    };

    if (url.indexOf('/cart') > -1) {
      if (!!slideData.settings.additional_settings.hide_slide_cart) {
        iniCart = 0;
      };
    };

    if (url.indexOf('/products/cart') > -1) {
      iniCart = 1;
    }
    if (url.indexOf('/collections/cart') > -1) {
      iniCart = 1;
    }
    if (url.indexOf('/pages/cart') > -1) {
      iniCart = 1;
    }
    if (url.indexOf('/blogs/cart') > -1) {
      iniCart = 1;
    }
    if (iniCart > 0) {
      var result_loading = '';
      if (typeof slideData?.customize?.customize_enabled_loading !== 'undefined') {
        if (slideData.customize.customize_enabled_loading == 1) {
          result_loading = `<div class="hs-result-loading hs-body-gnral" style="display:none"><div class="hs-spinner"></div></div>`;
        };
      };
      if (!Hs_CartDrawer.footer_fixed) {
        footer_fixed = ' hs-footer-not-fixed';
      }
      const cssVariables = HsApp1.cssVariables();

      const styleId = 'hs-sl-styles-cart';

      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = cssVariables;
        document.head.appendChild(style);
      }
      let class_position = '';
      let slideAnimationMobile = '';

      switch (Hs_CartDrawer.slidePositon) {
        case 0:
          class_position = '  hs-cart-left';
          slideAnimationMobile = !!Hs_CartDrawer.animationSlideMobile ? 'hs-animation-mobile' : '';
          break;
        case 1:
          class_position = '  hs-cart-right'
          slideAnimationMobile = !!Hs_CartDrawer.animationSlideMobile ? 'hs-animation-mobile' : '';
          break;
        case 2:
          class_position = '  hs-cart-center'
          break;

        default:
          class_position = '  hs-cart-right'
          break;
      }
      document.querySelector('body').insertAdjacentHTML('beforeend',
        `<div role="dialog" aria-modal="true" aria-labelledby="hs-header-content" aria-hidden="true" class="hs-popup-cart-sp-load hs-cart-drawer-${slideData.settings.devices.cart_type + footer_fixed + class_position}"><div class="hs-site-cart-popup-layout ${Hs_CartDrawer.rtl} ${slideAnimationMobile}"></div><div class="hs-bg-slide-cart"></div><div id="hs-cart-live-region" aria-live="polite" aria-atomic="true" class="hs-internal-visually-hidden"></div>${result_loading}</div>`);
      HsApp1.elementsOpenSlideCart();
      this.apr_show_quantity_box = slideData.settings.additional_settings.show_quantity_box_upsells;
      this.apr_mode = slideData.settings.product_recommendations_settings.mode_upsell_automatic;
      this.upsell_cross_sell_show_quantity_box = slideData.settings.additional_settings.show_quantity_box_upsells;
      this.upsell_cross_sell_mode = slideData.settings.manually_products_upsells.mode_upsell_manually;
      this.upsell_static_mode = typeof slideData.settings.static_products_upsells !== 'undefined' ? slideData.settings.static_products_upsells.mode_upsell_static : 0;
      this.text_add = slideData.settings.language_settings.add_in_upsell_language_settings;
      this.upsell_product_url_automatic = slideData.settings.product_recommendations_settings.upsell_product_url_automatic;
      this.upsell_product_url_manually = slideData.settings.manually_products_upsells.upsell_product_url_manually;
      this.note_placeholder = slideData.settings.cart_note.cart_note_heading_placeholder;
      this.bodyEmpty = `
                  <!-- HS BODY LAYOUT -->
                    <div class='hs-body-layout'>
                      <div class="hs-content-empty-cart">
                        ${slideData.settings.language_settings.cart_empty_text_language_settings}
                      </div>
                    </div>
                  `;
      window.hs_content = document.querySelector('.hs-site-cart-popup-layout') || '';
      /* window.hs_content
        ? window.hs_content.addEventListener('keyup', (evt) => {
          if (
            evt.code === 'Escape' &&
            !document.querySelector('.hs-product-option .hs-popUp-product.hs-popUp-active')
          ) {
            evt.preventDefault();
            //evt.stopPropagation();
            Hs_CartDrawer.closeCart();
          }
        })
        : ''; */

      if (window.hs_content) {
        document.addEventListener('keydown', function (evt) {
          try {
            if (evt.code === 'Escape') {
              evt.preventDefault();
              //evt.stopPropagation();
              const hsModalNotify = document.querySelector('#hs-notify-modal .hs-notify-modal') || '';
              if (hsModalNotify) {
                const closeButtonModalNotify = hsModalNotify.querySelector('.hs-notify-action .hs-notify-button') || '';
                if (closeButtonModalNotify) {
                  closeButtonModalNotify.click();
                  return false;
                }
              };
              const hsModalRewards = document.querySelector('.hs-content-modal-rewards-products:not(.hs-modal-rewards-closed)') || '';
              if (hsModalRewards) {
                const closeButtonModal = hsModalRewards.querySelector('.hs-modal-rewards-close') || '';
                if (closeButtonModal) {
                  closeButtonModal.click();
                  return false;
                }
              };
              const hsPopupProduct = document.querySelector('.hs-product-option .hs-popUp-product.hs-popUp-active') || '';
              if (hsPopupProduct) {
                if (typeof window.hsClosePopUp === 'function') {
                  window.hsClosePopUp();
                  return false
                };
              };
              Hs_CartDrawer.closeCart();
            }
          } catch (error) {
            console.log(error)
          };
        });
      };
    };
  },
  init: function () {
    var resultValidateDevice = this.validateDevice();
    switch (parseInt(resultValidateDevice)) {
      case 0:
        HsApp1.slideCartDisabled();
        return false;
        break;
      case 2:
        HsApp1.slideCartDisabled();
        return false;
        break;
    };
    Hs_CartDrawer.integrationAfterpay(0);
    Hs_CartDrawer.integrationKlarna();
    this.slideCart();
    this.ipinfo();
    this.resizeSlideCart();
    this.viewPage();
    this.alwaysViewPage();
    this.reloadedAddToCart();
  }
};

/* ================ CART BAR ================ */
var HsApp2 = {
  cartBarDevice: function () {
    var sticky_cart_bar_mobile_show_devices = parseInt(slideData.cart_bar.cart_bar_show_mobile),
      sticky_cart_bar_mobile_show_scroll = parseInt(slideData.cart_bar.cart_bar_mobile_hide_atc),
      sticky_cart_bar_mobile_hide_add_to_cart = parseInt(slideData.cart_bar.cart_bar_mobile_hide_stickybarButton),
      sticky_cart_bar_mobile_show_full_width = parseInt(slideData.cart_bar.cart_bar_mobile_show_full_stickybarButton),
      sticky_cart_bar_mobile_show_product_image = parseInt(slideData.cart_bar.cart_bar_mobile_show_productImage),
      sticky_cart_bar_mobile_show_product_title = parseInt(slideData.cart_bar.cart_bar_mobile_show_productTitle),
      sticky_cart_bar_mobile_show_review_stars = parseInt(slideData.cart_bar.cart_bar_mobile_show_reviewStarts),
      sticky_cart_bar_mobile_show_variant_select = parseInt(slideData.cart_bar.cart_bar_mobile_show_variantSelect),
      sticky_cart_bar_mobile_show_quantity_select = parseInt(slideData.cart_bar.cart_bar_mobile_show_quantitySelect),
      sticky_cart_bar_mobile_show_price = parseInt(slideData.cart_bar.cart_bar_mobile_show_price),
      sticky_cart_bar_mobile_show_compare_price = parseInt(slideData.cart_bar.cart_bar_mobile_show_comparePrice),
      sticky_cart_bar_desktop_show_devices = parseInt(slideData.cart_bar.cart_bar_show_desktop),
      sticky_cart_bar_desktop_show_scroll = parseInt(slideData.cart_bar.cart_bar_desktop_hide_atc),/////////////////////
      sticky_cart_bar_desktop_hide_add_to_cart = parseInt(slideData.cart_bar.cart_bar_desktop_hide_stickybarButton),
      sticky_cart_bar_desktop_show_product_image = parseInt(slideData.cart_bar.cart_bar_desktop_show_productImage),
      sticky_cart_bar_desktop_show_product_title = parseInt(slideData.cart_bar.cart_bar_desktop_show_productTitle),
      sticky_cart_bar_desktop_show_review_stars = parseInt(slideData.cart_bar.cart_bar_desktop_show_reviewStars),
      sticky_cart_bar_desktop_show_variant_select = parseInt(slideData.cart_bar.cart_bar_desktop_show_variantSelect),
      sticky_cart_bar_desktop_show_quantity_select = parseInt(slideData.cart_bar.cart_bar_desktop_show_quantitySelect),
      sticky_cart_bar_desktop_show_price = parseInt(slideData.cart_bar.cart_bar_desktop_show_price),
      sticky_cart_bar_desktop_show_compare_price = parseInt(slideData.cart_bar.cart_bar_desktop_show_comparePrice);



    var hs_content_checkout_bar = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
    if (!!hs_content_checkout_bar) {
      if (window.innerWidth < 769) {
        hs_content_checkout_bar.classList.remove('hs-hidden-header');

        if (!!sticky_cart_bar_desktop_show_quantity_select && !sticky_cart_bar_mobile_show_quantity_select) {
          var inputs = document.querySelectorAll('.hs-content-checkout-bar .hs---quantity.hs---buttons_added input').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs---quantity.hs---buttons_added input') : '';
          if (inputs.length > 0) {
            inputs.forEach(function (elem) {
              elem.value = 1;
            });
          };
        };

        if (!sticky_cart_bar_mobile_show_variant_select) {
          hs_content_checkout_bar.classList.add('hs-hidden-header');
          var hs_content_variants = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
          if (!!hs_content_variants) {
            hs_content_variants.style.display = "none";
          }
        }
        var hs_checkout_bar = !!document.querySelector('.hs-sticky-checkout-bar') ? document.querySelector('.hs-sticky-checkout-bar') : '';
        if (!!hs_checkout_bar) {
          var sticky_cart_bar_desktop_position = 'hs-desktop-top';
          if (slideData.cart_bar.cart_bar_desktop_position == 1) {
            sticky_cart_bar_desktop_position = 'hs-desktop-bottom';
          };

          var sticky_cart_bar_mobile_position = 'hs-mobile-top';
          if (slideData.cart_bar.cart_bar_mobile_position == 1) {
            sticky_cart_bar_mobile_position = 'hs-mobile-bottom';
          }
          hs_checkout_bar.classList.add(sticky_cart_bar_mobile_position);
          hs_checkout_bar.classList.remove(sticky_cart_bar_desktop_position);
        }

        var hs_content = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
        if (!!hs_content) {
          if (!sticky_cart_bar_mobile_show_devices) {
            hs_content.style.display = 'none';
          }
          else {
            hs_content.style.display = 'block';
          }

        };

        var hs_product_price_container = !!document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') ? document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') : '';
        if (!!hs_product_price_container) {
          if (!!sticky_cart_bar_mobile_show_compare_price || !!sticky_cart_bar_mobile_show_price) {
            hs_product_price_container.style.display = "flex";
          };
          var mobile_compare_price = document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-compare-at-price') : [];
          if (mobile_compare_price.length > 0) {
            if (!sticky_cart_bar_mobile_show_compare_price) {
              mobile_compare_price.forEach(function (val) {
                val.style.display = "none";
              });
            } else {
              mobile_compare_price.forEach(function (val) {
                val.style.display = "block";
              });
            }
          };

          var mobile_price = document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-price') : [];
          if (mobile_price.length > 0) {
            if (!sticky_cart_bar_mobile_show_price) {
              mobile_price.forEach(function (val) {
                val.style.display = "none";
              });
            } else {
              mobile_price.forEach(function (val) {
                val.style.display = "block";
              });
            }
          };
        }
        var mobile_variant = document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
        if (!!mobile_variant) {
          var box_load = mobile_variant.querySelectorAll('.hs-select-box-load').length > 0 ? mobile_variant.querySelectorAll('.hs-select-box-load') : [];
          if (!sticky_cart_bar_mobile_show_variant_select) {
            mobile_variant.classList.add('hs-hidden-select');
            if (box_load.length > 0) {
              box_load.forEach(function (val) {
                val.style.display = "none";
              });
            }
          } else {
            mobile_variant.classList.remove('hs-hidden-select');
            if (box_load.length > 0) {
              box_load.forEach(function (val) {
                val.style.display = "block";
              });
            }
          };

          mobile_variant.classList.remove('hs-hidden-select');
          var hs_select_box_bar = !!document.querySelector('.hs-load-select-box-bar-1') ? document.querySelector('.hs-load-select-box-bar-1') : '';
          var hs_option_checkout_bar = !!hs_select_box_bar ? hs_select_box_bar.querySelector('.hs-select-option-checkout-bar') : '';
          var hs_select = !!hs_option_checkout_bar ? hs_option_checkout_bar.querySelector('[value="Default Title"]') : '';
          if (!!hs_select) {
            mobile_variant.classList.add('hs-hidden-select');
          }
        };

        var mobile_review_stars = !!document.querySelector('.hs-content-checkout-bar .hs-product-review') ? document.querySelector('.hs-content-checkout-bar .hs-product-review') : '';
        if (!!mobile_review_stars) {
          if (!sticky_cart_bar_mobile_show_review_stars) {
            mobile_review_stars.style.display = "none";
          } else {
            mobile_review_stars.style.display = "block";
          }
        };

        var mobile_title = !!document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') ? document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') : '';
        var hs_variant = !!hs_content_checkout_bar ? hs_content_checkout_bar.querySelector('.hs-content-variant-select-option') : '';
        var btn_checkout_bar = !!hs_variant ? hs_variant.querySelector('.hs-btn-checkout-bar') : '';


        if (!!mobile_title) {
          if (!sticky_cart_bar_mobile_show_product_title) {
            mobile_title.style.display = "none";
            if (!!btn_checkout_bar) {
              btn_checkout_bar.style.display = "block";
            }

          } else {
            mobile_title.style.display = "block";
            if (!!btn_checkout_bar) {
              btn_checkout_bar.style.display = "none";
            }
          }
        };

        var mobile_featured_image = !!document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') ? document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') : '';
        if (!!mobile_featured_image) {
          if (!sticky_cart_bar_mobile_show_product_image) {
            mobile_featured_image.style.display = "none";
          } else {
            mobile_featured_image.style.display = "block";
          }
        };

        var mobile_addtocart = !!document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') : '';
        if (!!mobile_addtocart) {
          if (!!sticky_cart_bar_mobile_hide_add_to_cart) {
            mobile_addtocart.style.display = "none";
          } else {
            mobile_addtocart.style.display = "block";
          }
        }

        var content_img = !!document.querySelector('.hs-content-image-and-title') ? document.querySelector('.hs-content-image-and-title') : '';
        if (!!content_img) {
          if (!!sticky_cart_bar_mobile_show_product_image || !!sticky_cart_bar_mobile_show_product_title || !!sticky_cart_bar_mobile_show_review_stars || !!sticky_cart_bar_mobile_show_price || !!sticky_cart_bar_mobile_show_compare_price) {
            content_img.style.display = "flex";
          }
          else {
            content_img.style.display = "none";
          }
        };

        if (!sticky_cart_bar_mobile_hide_add_to_cart && !sticky_cart_bar_mobile_show_product_image && !sticky_cart_bar_mobile_show_product_title && !sticky_cart_bar_mobile_show_review_stars && !sticky_cart_bar_mobile_show_variant_select && !sticky_cart_bar_mobile_show_price && !sticky_cart_bar_mobile_show_compare_price) {
          var a = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
          if (!!a) {
            a.classList.add('quantityButton')
          }
        };

      } else {
        var hs_checkout_bar = !!document.querySelector('.hs-sticky-checkout-bar') ? document.querySelector('.hs-sticky-checkout-bar') : '';
        if (!!hs_checkout_bar) {
          var sticky_cart_bar_mobile_position = 'hs-mobile-top';
          if (slideData.cart_bar.cart_bar_mobile_position == 1) {
            sticky_cart_bar_mobile_position = 'hs-mobile-bottom';
          }
          var sticky_cart_bar_desktop_position = 'hs-desktop-top';
          if (slideData.cart_bar.cart_bar_desktop_position == 1) {
            sticky_cart_bar_desktop_position = 'hs-desktop-bottom';
          };
          hs_checkout_bar.classList.add(sticky_cart_bar_desktop_position);
          hs_checkout_bar.classList.remove(sticky_cart_bar_mobile_position);
        }

        var checkout_bar = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
        if (!!checkout_bar) {
          checkout_bar.classList.remove('hs-hidden-header');
        }

        if (!sticky_cart_bar_desktop_show_quantity_select && !!sticky_cart_bar_mobile_show_quantity_select) {
          var inputs = document.querySelectorAll('.hs-content-checkout-bar .hs---quantity.hs---buttons_added input').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs---quantity.hs---buttons_added input') : '';
          if (inputs.length > 0) {
            inputs.forEach(function (elem) {
              elem.value = 1;
            });
          };
        };

        var hs_content = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
        if (!!hs_content) {
          if (!!sticky_cart_bar_desktop_show_devices) {
            hs_content.style.display = 'flex';
          }
          else {
            hs_content.style.display = 'none';
          }
        };

        if (!!checkout_bar) {
          checkout_bar.classList.remove('hs-hidden-select');
          var hs_select_box_bar = !!document.querySelector('.hs-load-select-box-bar-1') ? document.querySelector('.hs-load-select-box-bar-1') : '';
          var hs_option_checkout_bar = !!hs_select_box_bar ? hs_select_box_bar.querySelector('.hs-select-option-checkout-bar') : '';
          var hs_select = !!hs_option_checkout_bar ? hs_option_checkout_bar.querySelector('[value="Default Title"]') : '';
          if (!!hs_select) {
            checkout_bar.classList.add('hs-hidden-select');
          }
        };

        var content_img = !!document.querySelector('.hs-content-image-and-title') ? document.querySelector('.hs-content-image-and-title') : '';
        if (!!content_img) {
          if (!!sticky_cart_bar_desktop_show_product_image || !!sticky_cart_bar_desktop_show_product_title || !!sticky_cart_bar_desktop_show_review_stars) {
            content_img.style.display = "flex";
          };
        };

        var desktop_featured_image = !!document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') ? document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') : ''
        if (!!desktop_featured_image) {
          if (!sticky_cart_bar_desktop_show_product_image) {
            desktop_featured_image.style.display = "none";
          } else {
            desktop_featured_image.style.display = "block";
          }
        };

        var desktop_title = !!document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') ? document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') : ''
        if (!!desktop_title) {
          if (!sticky_cart_bar_desktop_show_product_title) {
            desktop_title.style.display = "none";
          } else {
            desktop_title.style.display = "block";
          }
        };

        var desktop_review_stars = !!document.querySelector('.hs-content-checkout-bar .hs-product-review') ? document.querySelector('.hs-content-checkout-bar .hs-product-review') : ''
        if (!!desktop_review_stars) {
          if (!sticky_cart_bar_desktop_show_review_stars) {
            desktop_review_stars.style.display = "none";
          } else {
            desktop_review_stars.style.display = "block";
          }
        };


        var desktop_variant = document.querySelectorAll('.hs-content-checkout-bar .hs-select-box-load').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-select-box-load') : [];
        if (desktop_variant.length > 0) {
          if (!sticky_cart_bar_desktop_show_variant_select) {
            desktop_variant.forEach(function (val) {
              val.style.display = "none";
            });
          } else {
            desktop_variant.forEach(function (val) {
              val.style.display = "block";
            });
          }
        };

        var desktop_compare_price = document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price') : [];
        if (desktop_compare_price.length > 0) {
          if (!sticky_cart_bar_desktop_show_compare_price) {
            desktop_compare_price.forEach(function (val) {
              val.style.display = "none";
            });
          } else {
            desktop_compare_price.forEach(function (val) {
              val.style.display = "block";
            });
          }
        };

        var desktop_price = document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-price') : [];
        if (desktop_price.length > 0) {
          if (!sticky_cart_bar_desktop_show_price) {
            desktop_price.forEach(function (val) {
              val.style.display = "none";
            });
          } else {
            desktop_price.forEach(function (val) {
              val.style.display = "block";
            });
          }
        };

        var desktop_quantity = document.querySelectorAll('.hs-content-checkout-bar .hs-change-select-option .hs-content-quantity').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-change-select-option .hs-content-quantity') : [];
        if (desktop_quantity.length > 0) {
          if (!sticky_cart_bar_desktop_show_quantity_select) {
            desktop_quantity.forEach(function (val) {
              val.style.display = "none";
            });
          } else {
            desktop_quantity.forEach(function (val) {
              val.style.display = "block";
            });
          }
        };

        if (!!sticky_cart_bar_desktop_show_variant_select || !!sticky_cart_bar_desktop_show_quantity_select || !!sticky_cart_bar_desktop_show_price || !!sticky_cart_bar_desktop_show_compare_price) {
          var hs_content_selection = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
          if (!!hs_content_selection) {
            hs_content_selection.style.display = 'flex';
          }
        };

        var hs_product_price_container = !!document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') ? document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') : '';
        if (!!hs_product_price_container) {
          hs_product_price_container.style.display = "none";
        };

        var desktop_addtocart = !!document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') : ''
        if (!!desktop_addtocart) {
          if (!!sticky_cart_bar_desktop_hide_add_to_cart) {
            desktop_addtocart.style.display = "none";
          } else {
            desktop_addtocart.style.display = "block";
          }
        };

      }

    }
  },
  resizeDesktopAndMobile: function () {
    HsApp2.cartBarDevice();
  },
  validateCartBarDevice: function () {
    var show_desktop = slideData.cart_bar.cart_bar_show_desktop;
    var show_mobile = slideData.cart_bar.cart_bar_show_mobile;
    var device = HsApp1.loadDevice();
    var result;
    if (device == "desktop") {
      switch (parseInt(show_desktop)) {
        case 0:
          result = 0;
          break;
        case 1:
          result = 1
          break;
      };
    }
    else if (device == "mobile" || "tablet") {
      switch (parseInt(show_mobile)) {
        case 0:
          result = 2;
          break;
        case 1:
          result = 3;
          break;
      };
    };
    return result;
  },
  imageResize: function (t, r) {
    try {
      if ("original" == r) return t;
      var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return e[1] + "_" + r + "." + e[2]
    } catch (r) {
      return t
    }
  },
  removeParam: function (key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  },
  URL_add_parameter: function (url, param, value) {
    var hash = {};
    var parser = document.createElement('a');

    parser.href = url;

    var parameters = parser.search.split(/\?|&/);

    for (var i = 0; i < parameters.length; i++) {
      if (!parameters[i])
        continue;

      var ary = parameters[i].split('=');
      hash[ary[0]] = ary[1];
    }

    hash[param] = value;

    var list = [];


    Object.keys(hash).forEach(function (key) {
      list.push(key + '=' + hash[key]);
    });

    parser.search = '?' + list.join('&');
    return parser.href;
  },
  captureVariants: function (variantTitle) {
    var arr = [];
    if (variantTitle !== '') {
      if (HsApp1.arr_variants.length > 0) {
        //var countOption = variantTitle.split('/');
        HsApp1.arr_variants.forEach(function (variant) {
          if (variantTitle.indexOf('/') == -1)//only send 1 option with 2 options in product
          {
            if (variantTitle === variant.option1) {
              arr.push(variant);
            }
          }
          else {
            if (variantTitle === variant.title) {
              arr.push(variant);
            };
          };
        });
        if (arr.length > 0) {
          arr = arr[0];
        }
      }
    };

    return arr;
  },
  callBackVariant: function (variant) {
    if (variant.length == 0) {
      var compare_price = document.querySelectorAll('.hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-checkout-bar-compare-at-price') : [];
      if (compare_price.length > 0) {
        compare_price.forEach(function (val) {
          val.innerHTML = '';
        });
      };
      var hs_bar_price = document.querySelectorAll('.hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-checkout-bar-price') : [];
      if (hs_bar_price.length > 0) {
        hs_bar_price.forEach(function (hsVal) {
          hsVal.innerHTML = '';
        });
      };
      var hs_checkout_bar_add = !!document.querySelector('.hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-checkout-bar-add-to-cart') : '';
      if (!!hs_checkout_bar_add) {
        hs_checkout_bar_add.innerHTML = slideData.settings.language_settings.unavailable_language_settings;
        hs_checkout_bar_add.setAttribute('disabled', 'disabled');
      };
      return false;
    }
    if (typeof variant !== 'undefined') {
      var addToCartForms = document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length > 0 ? document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]') : [],
        url = window.location.href,
        featured_image = '',
        variantid = variant.id,
        available = variant.available,
        price = variant.price,
        compareatprice = variant.compare_at_price,
        compare_price_active = '';
      document.querySelector('select.hs-select-variants-bar').value = variantid;
      //$('select.hs-select-variants-bar').val(variantid).change();

      var compare_price = document.querySelectorAll('.hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-checkout-bar-compare-at-price') : [];
      if (compare_price.length > 0) {
        compare_price.forEach(function (val) {
          val.innerHTML = '';
        });
      };
      //$('.hs-checkout-bar-compare-at-price').html('');


      var hs_bar_price = document.querySelectorAll('.hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-checkout-bar-price') : [];
      if (hs_bar_price.length > 0) {
        hs_bar_price.forEach(function (hsVal) {
          hsVal.innerHtml = '';
        });
      };
      //$('.hs-checkout-bar-price').html('');


      if (variant.featured_image != null) {
        featured_image = HsApp2.imageResize(variant.featured_image.src, 'x100');
        var hs_featured_image = document.querySelector('.hs-bar-featured-image') ? document.querySelector('.hs-bar-featured-image') : '';
        if (!!hs_featured_image) {
          hs_featured_image.setAttribute('src', featured_image)
        }
      };
      if (compareatprice) {
        if (compareatprice > price) {
          compare_price_active = ' hs-compare-price-active';
          var compare_price = document.querySelectorAll('.hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-checkout-bar-compare-at-price') : [];
          if (!!Hs_CartDrawer.cartBar_typePrice) {
            var hs_content_checkout_bar = document.querySelector('.hs-content-checkout-bar'), qty = 1;
            if (!!hs_content_checkout_bar) {
              var hs_quick_button_quantity = hs_content_checkout_bar.querySelector('.hs-quick-button-quantity2');
              if (!!hs_quick_button_quantity) {
                qty = hs_quick_button_quantity.value;
              };
            };
            compareatprice = compareatprice * qty;
          };
          if (compare_price.length > 0) {
            compare_price.forEach(function (val) {
              val.innerHTML = '<s class="hs-money-compare-price">' + hsonslidecart.Currency.formatMoney(compareatprice, slideData.settings.devices.money_format) + '</s>';
            });
          };
        }
      };
      if (price) {
        var hs_bar_price = document.querySelectorAll('.hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-checkout-bar-price') : [];
        if (hs_bar_price.length > 0) {
          if (!!Hs_CartDrawer.cartBar_typePrice) {
            var hs_content_checkout_bar = document.querySelector('.hs-content-checkout-bar'), qty = 1;
            if (!!hs_content_checkout_bar) {
              var hs_quick_button_quantity = hs_content_checkout_bar.querySelector('.hs-quick-button-quantity2');
              if (!!hs_quick_button_quantity) {
                qty = hs_quick_button_quantity.value;
              };
            };
            price = price * qty;
          };
          hs_bar_price.forEach(function (hsVal) {
            hsVal.innerHTML = '<span class="hs-money-price' + compare_price_active + '">' + hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) + '</span>';
          });
        }
      };
      if (available) {
        if (addToCartForms.length > 0) {
          addToCartForms.forEach(function (forms) {
            setTimeout(function () {
              var preorder = !!forms.querySelector('#preorder-note') ? forms.querySelector('#preorder-note') : '';
              if (!!preorder) {
                var buttons = forms.querySelectorAll(Hs_CartDrawer.elementAddATC).length > 0 ? forms.querySelectorAll(Hs_CartDrawer.elementAddATC) : [];
                if (buttons.length > 0) {
                  buttons.forEach(function (element) {
                    if (!!element.value) {
                      document.querySelector('.hs-checkout-bar-add-to-cart').innerHTML = '';
                      document.querySelector('.hs-checkout-bar-add-to-cart').innerHTML = '<span class="hs-add--to--cart">' + element.value + '</span><span class="hs--loading">' + HsApp4.loadSvg() + '</span>';
                    }
                  });
                }
              };
            }, 800)
          });
        };
        url = HsApp2.removeParam('variant', url);
        url = HsApp2.URL_add_parameter(url, 'variant', variantid);
        window.history.pushState({}, "keywords", url);
        document.querySelector('.hs-checkout-bar-add-to-cart').removeAttribute('disabled');
        document.querySelector('.hs-checkout-bar-add-to-cart').innerHTML = '<span class="hs-add--to--cart">' + slideData.cart_bar.cart_bar_button_text + '</span><span class="hs--loading">' + HsApp4.loadSvg() + '</span>';
      } else {
        document.querySelector('.hs-checkout-bar-add-to-cart').setAttribute('disabled', 'disabled');
        document.querySelector('.hs-checkout-bar-add-to-cart').innerHTML = slideData.settings.language_settings.sold_out_language_settings;
        url = HsApp2.removeParam('variant', url);
        url = HsApp2.URL_add_parameter(url, 'variant', variantid);
        window.history.pushState({}, "keywords", url);
      }
    };
  },
  addToCart: function (where) {
    var elementForm = !!document.querySelector('input[name="form_type"][value="product"]') ? document.querySelector('input[name="form_type"][value="product"]').closest('form[action="/cart/add"]') : '',
      element_variant_id = !!document.querySelector('form[action="/cart/add"] input[name="id"]') ? document.querySelector('form[action="/cart/add"] input[name="id"]') : '',
      variantid = !!document.querySelector('form[action="/cart/add"] select[name="id"]') ? document.querySelector('form[action="/cart/add"] select[name="id"]').value : '',
      element = document.querySelectorAll('.hs-change-select-option .hs-content-quantity input.hs-quick-button-quantity2').length > 0 ? document.querySelectorAll('.hs-change-select-option .hs-content-quantity input.hs-quick-button-quantity2') : [],
      variantIdElement = !!document.querySelector('form[action="/cart/add"] select[name="id"]') ? document.querySelector('form[action="/cart/add"] select[name="id"]') : '',
      quantity = 1;
    if (element.length > 0) {
      element.forEach(function (val) {
        quantity = val.value;
      });
    }
    if (element_variant_id.length > 0) {
      variantid = element_variant_id.value;
    }
    if (elementForm === null || elementForm === '') {
      if (!!element_variant_id) {
        elementForm = element_variant_id.closest('form[action="/cart/add"]');
      }
      if (!!variantIdElement) {
        elementForm = variantIdElement.closest('form[action="/cart/add"]');
      }
    };
    where.classList.add('hs-loading-btn');
    var params = new FormData(), validate = 0;
    params.set('quantity', quantity);
    if (!!elementForm) {
      if (!params.get('id') || params.get('id') === 'null' || params.get('id') === '') {
        validate = 1;
      };
    }
    else {
      validate = 1;

    };
    if (!!validate) {
      variantid = where.closest('.hs-content-checkout-bar').querySelector('.hs-content-variant-select-option').querySelector('select.hs-select-variants-bar').value;
      quantity = parseInt(quantity);
      params.append('id', variantid);
      params.append('quantity', quantity)
    };


    HsApp3.postMyCart(params, where);
  },
  isScrolledIntoView: function (elem) {
    elem = !!document.querySelector(elem) ? document.querySelector(elem) : '';
    if (!!elem) {
      var elementOffsetHeight = elem.offsetHeight;
      let offsetTop = 0;
      while (elem) {
        offsetTop += elem.offsetTop;
        elem = elem.offsetParent;
      }
      var docViewTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var docViewBottom = docViewTop + window.innerHeight;
      var elemTop = offsetTop
      var elemBottom = elemTop + elementOffsetHeight;
      if (window.innerWidth < 770) {
        let hiddenTopMobile = 1;
        if (hiddenTopMobile && elemTop >= docViewTop && elemBottom >= docViewBottom) {
          return true;
        };
      };
      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    } else {
      return false;
    }
  },
  homepageDetect: function () {
    var check = false;
    var shopify_root = "/";
    if (!!window.Shopify) {
      if (!!window.Shopify.routes) {
        if (!!window.Shopify.routes.root) {
          if (window.Shopify.routes.root !== '/') {
            shopify_root = window.Shopify.routes.root;
          }
        }
      }
    }
    if (document.location.pathname === "/" || document.location.pathname === shopify_root || document.location.pathname === shopify_root.slice(0, -1)) {
      check = true;
    }
    return check;
  },
  scrollAndresize: function (sticky_cart_bar_mobile_show_scroll, aTop, atc_visibility, hs_checkout_bar) {
    var windowScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (!!hs_checkout_bar) {
      if (slideData.cart_bar.cart_bar_mobile_position === '1' || slideData.cart_bar.cart_bar_desktop_position === '1') {
        aTop = 0;
      };
      if (window.innerWidth < 770) {//MOBILE
        if (!HsApp2.homepageDetect()) {
          if (parseInt(slideData.cart_bar.cart_bar_mobile_hide_atc)) {
            aTop = 80;
            var atc_visibility = HsApp2.isScrolledIntoView(Hs_CartDrawer.elementAddATC);
            if (!!atc_visibility) {
              hs_checkout_bar.classList.add('hs-hide-element');
              hs_checkout_bar.classList.remove('hs-show-element');
            } else {
              if (windowScroll >= aTop) {
                hs_checkout_bar.classList.remove('hs-hide-element');
                hs_checkout_bar.classList.add('hs-show-element');
              }
            }
          } else {
            hs_checkout_bar.classList.add('hs-hide-element');
            hs_checkout_bar.classList.remove('hs-show-element');
            if (windowScroll >= aTop) {
              hs_checkout_bar.classList.remove('hs-hide-element');
              hs_checkout_bar.classList.add('hs-show-element');
            }
          }
        } else {
          hs_checkout_bar.classList.add('hs-hide-element');
          hs_checkout_bar.classList.remove('hs-show-element');
          if (windowScroll >= aTop) {
            hs_checkout_bar.classList.remove('hs-hide-element');
            hs_checkout_bar.classList.add('hs-show-element');
          }
        }
      }
      else {//DESKTOP
        if (!HsApp2.homepageDetect()) {
          if (parseInt(slideData.cart_bar.cart_bar_desktop_hide_atc)) {
            aTop = 80;
            var atc_visibility = HsApp2.isScrolledIntoView(Hs_CartDrawer.elementAddATC);
            if (!!atc_visibility) {
              hs_checkout_bar.classList.add('hs-hide-element');
              hs_checkout_bar.classList.remove('hs-show-element');
            } else {
              if (windowScroll >= aTop) {
                hs_checkout_bar.classList.remove('hs-hide-element');
                hs_checkout_bar.classList.add('hs-show-element');
              }
            }
          } else {
            hs_checkout_bar.classList.add('hs-hide-element');
            hs_checkout_bar.classList.remove('hs-show-element');
            if (windowScroll >= aTop) {
              hs_checkout_bar.classList.remove('hs-hide-element');
              hs_checkout_bar.classList.add('hs-show-element');
            }
          }
        } else {
          hs_checkout_bar.classList.add('hs-hide-element');
          hs_checkout_bar.classList.remove('hs-show-element');
          if (windowScroll >= aTop) {
            hs_checkout_bar.classList.remove('hs-hide-element');
            hs_checkout_bar.classList.add('hs-show-element');
          }
        }
      }
    };
  },
  changePrices: function (val) {
    if (!!Hs_CartDrawer.cartBar_typePrice) {
      var hs_content_checkout_bar = document.querySelector('.hs-content-checkout-bar');
      if (!!hs_content_checkout_bar) {
        var price = '', comparePrice = '';
        var hs_select_variants_bar = hs_content_checkout_bar.querySelector('.hs-select-variants-bar');
        if (!!hs_select_variants_bar) {
          var variant_price = hs_select_variants_bar.options[hs_select_variants_bar.selectedIndex].dataset.price;
          var variant_comaprePrice = hs_select_variants_bar.options[hs_select_variants_bar.selectedIndex].dataset.compareatprice;
          if (!!variant_price) {
            price = variant_price * val;
          };
          if (!!variant_comaprePrice) {
            comparePrice = variant_comaprePrice * val;
          };
        };
        if (price !== '') {
          var hs_checkout_bar_price = hs_content_checkout_bar.querySelectorAll('.hs-checkout-bar-price');
          if (hs_checkout_bar_price.length > 0) {
            hs_checkout_bar_price.forEach(function (bar_price) {
              var thisElement = bar_price.querySelector('.hs-money-price');
              if (!!thisElement) {
                thisElement.innerHTML = hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format);
              };
            });
          };
        };
        if (comparePrice !== '') {
          var hs_checkout_bar_compare_at_price = hs_content_checkout_bar.querySelectorAll('.hs-checkout-bar-compare-at-price');
          if (hs_checkout_bar_compare_at_price.length > 0) {
            hs_checkout_bar_compare_at_price.forEach(function (bar_comparePrice) {
              var thisElement = bar_comparePrice.querySelector('.hs-money-compare-price');
              if (!!thisElement) {
                thisElement.innerHTML = hsonslidecart.Currency.formatMoney(comparePrice, slideData.settings.devices.money_format);
              };
            });
          };
        };
      };
    };
  },
  changeVariantsCheckoutBar: function () {
    function changeATC(value_variant, titleVariant) {
      var variant = '';
      if (value_variant.length > 0) {
        value_variant.forEach(function (varVal, varIndex, array) {
          //document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = escape(varVal);
          var hs_content_variant_select_option = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
          if (!!hs_content_variant_select_option) {
            var hs_change_select_option = !!hs_content_variant_select_option.querySelector('.hs-change-select-option') ? hs_content_variant_select_option.querySelector('.hs-change-select-option') : '';
            if (!!hs_change_select_option) {
              var hs_select_box_load = hs_change_select_option.querySelectorAll('.hs-select-box-load').length > 0 ? hs_change_select_option.querySelectorAll('.hs-select-box-load')[varIndex] : '';
              if (!!hs_select_box_load) {
                var hs_select_option_checkout_bar = !!hs_select_box_load.querySelector('select.hs-select-option-checkout-bar') ? hs_select_box_load.querySelector('select.hs-select-option-checkout-bar') : '';
                if (!!hs_select_option_checkout_bar) {
                  hs_select_option_checkout_bar.value = Hs_CartDrawer.escape(varVal);
                }
              }
            }
          }
        });
        if (!!titleVariant) {
          variant = HsApp2.captureVariants(titleVariant);
          if (Object.keys(variant).length > 0) {
            HsApp2.callBackVariant(variant);
          }
        };
        HsApp1.currencyConverter();
      };
    };
    /*CART BAR ---> Change cart bar selects of shop*/
    //var variant = '';
    let addToCartForms = document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length > 0 ? document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]') : [];
    if (addToCartForms.length > 0) {
      addToCartForms.forEach(function (addToCartForm) {
        var select = addToCartForm.querySelectorAll('select:not(.cbb-recommendations-variant-select):not(.sls-select)')
        select.forEach(function (val, i) {
          var select_index = val.getAttribute('name');
          if (select_index !== "id") {
            /* if(!val.classList.contains('hs-event-static'))
          {
            val.classList.add('hs-event-static'); */
            val.addEventListener('change', function (e) {
              setTimeout(function () {
                var value = val.options.selectedIndex >= 0 ? val.options[val.selectedIndex].value : '', titleVariant = '', value_variant = [];
                if (!!value) {
                  select.forEach(function (xxx) {
                    var select_index_child = xxx.getAttribute('name');
                    let parent = xxx.parentElement;
                    if (parent) {
                      if (parent.classList.contains('paywhirl-plan-selector-plan')) {
                        select_index_child = 'id';
                      };
                    };
                    if (select_index_child !== "id") {
                      var where = xxx, value_select = where.options[where.options.selectedIndex] || '', select_data_option = where.getAttribute('data-option');
                      if (value_select) {
                        value_select = value_select.value;
                        if (select_index_child !== "quantity") {
                          if (select_index_child !== "none") {
                            if (xxx.ariaLabel !== 'Quantity') {
                              if (value_select != null) {
                                value_variant.push(value_select);
                                titleVariant = titleVariant.concat(value_select + ' / ');
                              }
                            };
                          }
                        }
                      };
                    }
                  });
                };
                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                  changeATC(value_variant, titleVariant)
                }
              }, 250);
            });

            val.addEventListener('click', function (e) {
              setTimeout(function () {
                var value = val.options.selectedIndex >= 0 ? val.options[val.selectedIndex].value : '', titleVariant = '', value_variant = [];
                if (!!value) {
                  select.forEach(function (xxx) {
                    var select_index_child = xxx.getAttribute('name');
                    if (select_index_child !== "id") {
                      var where = xxx, value_select = where.options[where.options.selectedIndex] || '', select_data_option = where.getAttribute('data-option');
                      if (value_select) {
                        value_select = value_select.value;
                        if (select_index_child !== "quantity") {
                          if (select_index_child !== "none") {
                            if (xxx.ariaLabel !== 'Quantity') {
                              if (value_select != null) {
                                value_variant.push(value_select);
                                titleVariant = titleVariant.concat(value_select + ' / ');
                              }
                            };
                          }
                        }
                      };
                    }
                  });
                };
                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                  changeATC(value_variant, titleVariant)
                }
              }, 250);
            });
          }
        });
      })
    };

    /* -----------------------------------------------------------  */
    /* CASE PAGEFLY1 */
    if (addToCartForms.length > 0) {
      addToCartForms.forEach(function (forms) {
        var pf_option_swatches = forms.querySelectorAll('[data-pf-type="ProductVariantSwatches"]').length > 0 ? forms.querySelectorAll('[data-pf-type="ProductVariantSwatches"]') : [];
        if (pf_option_swatches.length > 0) {
          pf_option_swatches.forEach(function (pf_swatch) {
            var contents = pf_swatch.querySelectorAll('.pf-th').length > 0 ? pf_swatch.querySelectorAll('.pf-th') : [];
            if (contents.length > 0) {
              contents.forEach(function (content) {
                var contentOption = !!content.querySelector('.pf-option-swatches') ? content.querySelector('.pf-option-swatches') : '';
                if (!!contentOption) {
                  var ipts = contentOption.querySelectorAll('input[type="radio"]').length > 0 ? contentOption.querySelectorAll('input[type="radio"]') : [];
                  if (ipts.length > 0) {
                    ipts.forEach(function (ipt) {
                      ipt.addEventListener('change', function (e) {
                        var titleVariant = '', value_variant = [];
                        ipts.forEach(function (xxx) {
                          if (!!xxx.checked) {
                            var value_select = xxx.value;
                            if (value_select != null) {
                              value_variant.push(value_select);
                              titleVariant = titleVariant.concat(value_select + ' / ');
                            };
                          };
                        });
                        if (titleVariant) {
                          titleVariant = titleVariant.slice(0, -3);
                          changeATC(value_variant, titleVariant);
                        };
                      });
                    });
                  };
                };
              });
            };
          });
        };
      });
    };

    /*-- CASE SELECTOR WRAPPER -- */
    var selector_wrapper = document.querySelectorAll('.selector-wrapper').length > 0 ? document.querySelectorAll('.selector-wrapper') : [];
    if (selector_wrapper.length > 0) {
      selector_wrapper.forEach(function (wrapper) {
        var selectWrapper = !!wrapper.querySelector('ul') ? wrapper.querySelector('ul') : '';
        if (!!selectWrapper) {
          var thisOptions = selectWrapper.querySelectorAll('li').length > 0 ? selectWrapper.querySelectorAll('li') : '';
          if (thisOptions.length > 0) {
            thisOptions.forEach(function (thisOption) {
              thisOption.addEventListener('click', function (e) {
                setTimeout(function () {
                  var value_variant = [], titleVariant = '';
                  selector_wrapper.forEach(function (wrapper) {
                    var selectValue = !!wrapper.querySelector('select') ? wrapper.querySelector('select').value : '';
                    if (!!selectValue) {
                      value_variant.push(selectValue);
                      titleVariant = titleVariant.concat(selectValue + ' / ');
                    };
                  })

                  if (titleVariant) {
                    titleVariant = titleVariant.slice(0, -3);
                    changeATC(value_variant, titleVariant);
                  }
                }, 250);
              })
            })
          }
        }
      })
    };

    /* --CASE SizeSwatchList ------------------------------------- ok  */
    var SizeSwatchList = document.querySelectorAll('.ProductForm__Variants').length > 0 ? document.querySelectorAll('.ProductForm__Variants') : [];
    if (SizeSwatchList.length > 0) {
      SizeSwatchList.forEach(function (val) {
        var inputs = val.querySelectorAll('input').length > 0 ? val.querySelectorAll('input') : [];
        if (inputs.length > 0) {
          inputs.forEach(function (input) {
            input.addEventListener('change', function (e) {
              var titleVariant = '', value_variant = [];
              if (!!input.value) {
                inputs.forEach(function (val) {
                  if (!!val.checked) {
                    var where = val, value_select = val.value;
                    value_variant.push(value_select);
                    titleVariant = titleVariant.concat(value_select + ' / ');
                  };
                });
                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                  if (value_variant.length > 0) {
                    value_variant.forEach(function (varVal, varIndex, array) {
                      var contentGeneralSelects = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
                      if (!!contentGeneralSelects) {
                        var change_select = !!contentGeneralSelects.querySelector('.hs-change-select-option') ? contentGeneralSelects.querySelector('.hs-change-select-option') : '';
                        if (!!change_select) {
                          var thisContentSelects = change_select.querySelectorAll('.hs-select-box-load').length > 0 ? change_select.querySelectorAll('.hs-select-box-load') : [];
                          if (thisContentSelects.length > 0) {
                            thisContentSelects.forEach(function (thisSelect) {
                              var thisSelect = thisSelect.querySelectorAll('select.hs-select-option-checkout-bar').length > 0 ? thisSelect.querySelectorAll('select.hs-select-option-checkout-bar') : [];
                              if (thisSelect.length > 0) {
                                thisSelect.forEach(function (opt) {
                                  if (opt.value === Hs_CartDrawer.escape(varVal)) {
                                    thisSelect.value = Hs_CartDrawer.escape(varVal);
                                  };
                                })
                              };
                            });
                          };
                        };
                      };

                    });
                    variant = HsApp2.captureVariants(titleVariant);
                    HsApp2.callBackVariant(variant);
                    HsApp1.currencyConverter();
                  }
                }
              };
            });
          });
        }
      });
    };

    var vario_variants = !!document.querySelector('ul.vario-variants') ? document.querySelector('ul.vario-variants') : '';
    if (!!vario_variants) {
      var vario_variant = document.querySelectorAll('li.vario-variant').length > 0 ? document.querySelectorAll('li.vario-variant') : '';
      if (vario_variant.length > 0) {
        vario_variant.forEach(function (val) {
          val.addEventListener('click', function (e) {
            var titleVariant = '', value_variant = [];
            vario_variant.forEach(function (xxx) {
              if (xxx.classList.contains('sv_active')) {
                if (!!xxx.getAttribute('data-value')) {
                  var where = xxx, value_select = xxx.dataset.value;
                  value_variant.push(value_select);
                  titleVariant = titleVariant.concat(value_select + ' / ');
                }
              }
            });
            if (titleVariant) {
              titleVariant = titleVariant.slice(0, -3);
              if (value_variant.length > 0) {
                value_variant.forEach(function (varVal, varIndex, array) {
                  document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = Hs_CartDrawer.escape(varVal);
                });
                variant = HsApp2.captureVariants(titleVariant);
                HsApp2.callBackVariant(variant);
                HsApp1.currencyConverter();
              }
            }
          });
        });
      };
    };

    /* ----------------------------------------------------------- OK */
    //SWATCH
    var swatchs = 'variant-radios.no-js-hidden,.variant-wrapper--button'
    var variant_swatchs = document.querySelectorAll(swatchs).length > 0 ? document.querySelectorAll(swatchs) : [];
    if (variant_swatchs.length > 0) {
      variant_swatchs.forEach(function (variant_radios) {
        if (!!variant_radios) {
          var fieldset = variant_radios.querySelectorAll('fieldset').length > 0 ? variant_radios.querySelectorAll('fieldset') : [];
          if (fieldset.length > 0) {
            variant_swatchs.forEach(function (field) {
              field.addEventListener('change', function (e) {
                var titleVariant = '', value_variant = [];
                fieldset.forEach(function (xxx) {
                  var where = xxx, value_select = xxx.querySelector('input:checked') || '';
                  if (value_select) {
                    value_select = value_select.value || '';
                    value_variant.push(value_select);
                    titleVariant = titleVariant.concat(value_select + ' / ');
                  };
                });
                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                  if (value_variant.length > 0) {
                    value_variant.forEach(function (varVal, varIndex, array) {
                      document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = Hs_CartDrawer.escape(varVal);
                    });
                    variant = HsApp2.captureVariants(titleVariant);
                    HsApp2.callBackVariant(variant);
                    HsApp1.currencyConverter();
                  }
                }
              });
            })
          };
        };
      });
    };

    var product_block = document.querySelectorAll('.product-block[data-dynamic-variants-enabled] .variant-wrapper.js fieldset .variant-input');
    if (product_block.length > 0) {
      product_block.forEach(function (variant_input) {
        let input = variant_input.querySelector('input') || '';
        if (input) {
          input.addEventListener('change', function (e) {
            var titleVariant = '', value_variant = [];
            product_block.forEach(function (variant_input) {
              let input_check = variant_input.querySelector('input:checked') || '';
              if (input_check) {
                input_check = input_check.value || '';
                value_variant.push(input_check);
                titleVariant = titleVariant.concat(input_check + ' / ');
              };
            });

            if (titleVariant) {
              titleVariant = titleVariant.slice(0, -3);
              if (value_variant.length > 0) {
                value_variant.forEach(function (varVal, varIndex, array) {
                  document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = Hs_CartDrawer.escape(varVal);
                });
                variant = HsApp2.captureVariants(titleVariant);
                HsApp2.callBackVariant(variant);
                HsApp1.currencyConverter();
              };
            };
          });
        };
      });
    };
    /* -----------------------------------------------------------  */
    //NEW FORM
    var new_form = document.querySelectorAll('[id="new-form"]').length > 0 ? document.querySelectorAll('[id="new-form"]') : [];
    if (new_form.length > 0) {
      new_form.forEach(function (newForm) {
        var new_form_option = newForm.querySelectorAll('.new-form-option').length > 0 ? newForm.querySelectorAll('.new-form-option') : [];
        if (new_form_option.length > 0) {
          new_form_option.forEach(function (formOption) {
            formOption.addEventListener('click', function (e) {
              e.preventDefault();
              var variant_swatchs = document.querySelectorAll(swatchs).length > 0 ? document.querySelectorAll(swatchs) : [];
              if (variant_swatchs.length > 0) {
                variant_swatchs.forEach(function (variant_radios) {
                  if (!!variant_radios) {
                    var fieldset = variant_radios.querySelectorAll('fieldset').length > 0 ? variant_radios.querySelectorAll('fieldset') : [];
                    if (fieldset.length > 0) {
                      fieldset.forEach(function (field) {
                        var ev = new Event("change", { "bubbles": true, "cancelable": false });
                        field.dispatchEvent(ev);
                      })
                    }
                  }
                })
              }
              else {
                var titleVariant = '';
                var title = !!this.querySelector('.title-variant') ? this.querySelector('.title-variant') : '';
                if (!!title) {
                  titleVariant = title;
                };
                var titleVariant = '', value_variant = [];
                new_form_option.forEach(function (xxx) {
                  if (xxx.classList.contains('selectedWB')) {
                    var title = !!xxx.querySelector('.title-variant') ? xxx.querySelector('.title-variant') : '';
                    if (!!title) {
                      var where = xxx, value_select = title.textContent;
                      value_variant.push(value_select);
                      titleVariant = titleVariant.concat(value_select + ' / ');
                    }
                  }
                });

                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                  if (value_variant.length > 0) {
                    value_variant.forEach(function (varVal, varIndex, array) {
                      document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = Hs_CartDrawer.escape(varVal);
                    });
                    variant = HsApp2.captureVariants(titleVariant);
                    HsApp2.callBackVariant(variant);
                    HsApp1.currencyConverter();
                  }
                }
              };
            });
          })
        }
      });
    };
    /* ----------------------------------------------------------- OK  */
    function changeVariantSelect() {
      var variant_selects = !!document.querySelector('variant-selects') ? document.querySelector('variant-selects') : '';
      if (!!variant_selects) {
        var selects = variant_selects.querySelectorAll('select').length > 0 ? variant_selects.querySelectorAll('select') : [];
        if (selects.length > 0) {
          selects.forEach(function (select) {
            if (!select.classList.contains('hs-event-changed-static')) {
              select.classList.add('hs-event-changed-static');
              select.addEventListener('change', function (e) {
                var value = select.options[select.options.selectedIndex].value, titleVariant = '', value_variant = [];
                selects.forEach(function (xxx) {
                  var where = xxx, value_select = xxx.options[xxx.options.selectedIndex].value;
                  value_variant.push(value_select);
                  titleVariant = titleVariant.concat(value_select + ' / ');
                });

                if (titleVariant) {
                  titleVariant = titleVariant.slice(0, -3);
                  if (value_variant.length > 0) {
                    value_variant.forEach(function (varVal, varIndex, array) {
                      document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = Hs_CartDrawer.escape(varVal);
                    });
                    variant = HsApp2.captureVariants(titleVariant);
                    HsApp2.callBackVariant(variant);
                    HsApp1.currencyConverter();
                  }
                };
                setTimeout(function () {
                  changeVariantSelect();
                }, 1000);


              });
            };
          });
        }
      };
    };
    changeVariantSelect();

    /* -----------------------------------------------------------OK  */
    /*CART BAR ---> Change cart bar selects beginning */
    function changed_select() {
      var cart_bar_forms = document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length > 0 ? document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]') : [];
      if (cart_bar_forms.length > 0) {
        cart_bar_forms.forEach(function (cart_bar_form) {
          var cart_bar_select = cart_bar_form.querySelectorAll('select').length > 0 ? cart_bar_form.querySelectorAll('select') : [];
          if (cart_bar_select.length > 0) {
            cart_bar_select.forEach(function (vals) {
              if (typeof vals.options !== 'undefined') {
                if (vals.options.length > 0) {
                  var ev = new Event("change", { "bubbles": true, "cancelable": false });
                  vals.dispatchEvent(ev);
                };
              };
            });
          };
        });
      };
    };
    changed_select();

    if (addToCartForms.length > 0) {
      addToCartForms.forEach(function (addToCartForm) {
        var swatch_options = !!addToCartForm.querySelector('.swatch_options') ? addToCartForm.querySelector('.swatch_options') : '';
        if (!!swatch_options) {
          swatch_options.addEventListener('change', function (e) {
            changed_select();
          });

          let swatch_option_inner = swatch_options.querySelectorAll('.swatch_option_inner') || [];
          if (swatch_option_inner.length > 0) {
            swatch_option_inner.forEach(function (inner) {
              let inputs = inner.querySelectorAll('input[type="radio"]') || [];
              if (inputs.length > 0) {
                inputs.forEach(function (option) {
                  option.addEventListener('click', function (e) {
                    changed_select();
                  });
                });
              }
            });
          };
        };
      })
    };

    // Función para agregar el evento 'change' a todos los inputs
    function addChangeEventToSelects(selector_variants = '') {
      if (selector_variants) {
        let variant_selects = !!document.querySelector(selector_variants) ? document.querySelector(selector_variants) : '';
        if (variant_selects) {
          var selects = variant_selects.querySelectorAll('fieldset input') || [];
          if (selects.length > 0) {
            selects.forEach(function (select) {
              if (!select.classList.contains('hs-event-changed-static')) {
                select.classList.add('hs-event-changed-static');
                select.addEventListener('change', function (e) {
                  var titleVariant = '', value_variant = [];
                  selects.forEach(function (ea) {
                    if (ea.checked) {
                      var where = ea, value_select = ea.value;
                      value_variant.push(value_select);
                      titleVariant = titleVariant.concat(value_select + ' / ');
                    }
                  });
                  if (titleVariant) {
                    titleVariant = titleVariant.slice(0, -3);
                    if (value_variant.length > 0) {
                      value_variant.forEach(function (varVal, varIndex, array) {
                        document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load')[varIndex].querySelector('select.hs-select-option-checkout-bar').value = Hs_CartDrawer.escape(varVal);
                      });
                      variant = HsApp2.captureVariants(titleVariant);
                      HsApp2.callBackVariant(variant);
                      HsApp1.currencyConverter();
                    };
                  };
                });
              };
            });
          };
        };
      };
    };
    // Seleccionamos el contenedor de los selects
    var variant_selects = !!document.querySelector('variant-selects') ? document.querySelector('variant-selects') : '';
    // Si existe 'variant_selects', buscamos los 'inputs' dentro de 'fieldset'
    if (variant_selects) {
      var selects = variant_selects.querySelectorAll('fieldset input') || [];
      if (selects.length > 0) {
        let parent = variant_selects?.parentNode
        let parentNode = parent?.nodeName
        if (parent) {
          if (parentNode === 'SECTION') {

            // Agregamos el evento 'change' a los selects iniciales
            addChangeEventToSelects('variant-selects');

            // Creamos el observer para observar cambios en el DOM de 'variant_selects'
            var observer = new MutationObserver(function (mutationsList) {
              // Cada vez que se detecte un cambio, volvemos a asignar los eventos
              mutationsList.forEach(function (mutation) {
                if (mutation.type === 'childList' || mutation.type === 'subtree') {
                  // Actualizamos la variable 'selects' con los nuevos elementos
                  var variant_selects = !!document.querySelector('variant-selects') ? document.querySelector('variant-selects') : '';
                  selects = variant_selects.querySelectorAll('fieldset input');
                  addChangeEventToSelects('variant-selects'); // Reasignamos el evento
                }
              });
            });

            // Opciones del observer
            var config = {
              childList: true,  // Observar cambios en los elementos hijos
              subtree: true     // Observar cambios en los elementos descendientes
            };

            // Iniciamos el observer
            observer.observe(parent, config);
          };
        };
      };
    };

    addChangeEventToSelects('variant-picker');

    function dispatchChangeEventToSelects(selector_variants = '') {
      if (selector_variants) {
        var variant_selects = !!document.querySelector(selector_variants) ? document.querySelector(selector_variants) : '';
        if (!!variant_selects) {
          var selects = variant_selects.querySelectorAll('fieldset input:checked').length > 0 ? variant_selects.querySelectorAll('fieldset input:checked') : [];
          if (selects.length > 0) {
            let parent = variant_selects?.parentNode
            let parentNode = parent?.nodeName
            if (parent) {
              selects.forEach(function (select) {
                if (select.checked) {
                  var ev = new Event("change", { "bubbles": true, "cancelable": false });
                  select.dispatchEvent(ev);
                };
              });
            };
          }
        };
      };
    };

    dispatchChangeEventToSelects('variant-selects');
    dispatchChangeEventToSelects('variant-picker');
    /*CASE PAGEFLY1 INI */
    if (addToCartForms.length > 0) {
      addToCartForms.forEach(function (forms) {
        var pf_option_swatches = forms.querySelectorAll('[data-pf-type="ProductVariantSwatches"]').length > 0 ? forms.querySelectorAll('[data-pf-type="ProductVariantSwatches"]') : [];
        if (pf_option_swatches.length > 0) {
          pf_option_swatches.forEach(function (pf_swatch) {
            var contents = pf_swatch.querySelectorAll('.pf-th').length > 0 ? pf_swatch.querySelectorAll('.pf-th') : [];
            if (contents.length > 0) {
              contents.forEach(function (content) {
                var contentOption = !!content.querySelector('.pf-option-swatches') ? content.querySelector('.pf-option-swatches') : '';
                if (!!contentOption) {
                  var ipts = contentOption.querySelectorAll('input[type="radio"]').length > 0 ? contentOption.querySelectorAll('input[type="radio"]') : [];
                  if (ipts.length > 0) {
                    ipts.forEach(function (xxx) {
                      if (!!xxx.checked) {
                        var ev = new Event("change", { "bubbles": true, "cancelable": false });
                        xxx.dispatchEvent(ev);
                      };
                    });
                  };
                };
              });
            };
          });
        };
      });
    };

    /*-- CASE SELECTOR WRAPPER -- */
    var selector_wrapper = document.querySelectorAll('.selector-wrapper').length > 0 ? document.querySelectorAll('.selector-wrapper') : [];
    if (selector_wrapper.length > 0) {
      selector_wrapper.forEach(function (wrapper) {
        var selectWrapper = !!wrapper.querySelector('ul') ? wrapper.querySelector('ul') : '';
        if (!!selectWrapper) {
          var thisOptions = selectWrapper.querySelectorAll('li').length > 0 ? selectWrapper.querySelectorAll('li') : '';
          if (thisOptions.length > 0) {
            thisOptions.forEach(function (thisOption) {
              var liActive = !!thisOption.querySelector('a') ? thisOption.querySelector('a') : '';
              if (!!liActive) {
                if (!!liActive.classList.contains('active')) {
                  var ev = new Event("click", { "bubbles": true, "cancelable": false });
                  thisOption.dispatchEvent(ev);
                };
              };
            });
          }
        }
      })
    };

    /* --CASE SizeSwatchList ------------------------------------- ok  */
    var SizeSwatchList = !!document.querySelectorAll('.ProductForm__Variants').length > 0 ? document.querySelectorAll('.ProductForm__Variants') : [];
    if (SizeSwatchList.length > 0) {
      SizeSwatchList.forEach(function (val) {
        var inputs = val.querySelectorAll('input').length > 0 ? val.querySelectorAll('input') : [];
        if (inputs.length > 0) {
          inputs.forEach(function (input) {
            if (!!input.checked) {
              var ev = new Event("change", { "bubbles": true, "cancelable": false });
              input.dispatchEvent(ev);
            };
          });
        }
      });
    };
    /* ----------------------------------------------------------- ok  */
    //CASE SWATCHES
    var swatchs = 'variant-radios.no-js-hidden,.variant-wrapper--button'
    //var swatchs ='variant-radios.no-js-hidden,.variant-wrapper--button';
    var variant_swatchs = document.querySelectorAll(swatchs).length > 0 ? document.querySelectorAll(swatchs) : [];
    if (variant_swatchs.length > 0) {
      variant_swatchs.forEach(function (variant_radios) {
        if (!!variant_radios) {
          var fieldset = variant_radios.querySelectorAll('fieldset').length > 0 ? variant_radios.querySelectorAll('fieldset') : [];
          if (fieldset.length > 0) {
            fieldset.forEach(function (field) {
              var inputs = field.querySelectorAll('input').length > 0 ? field.querySelectorAll('input') : [];
              if (inputs.length > 0) {
                var ev = new Event("change", { "bubbles": true, "cancelable": false });
                field.dispatchEvent(ev);
              }
            });
          }
        };
      });
    };
    /* ----------------- */

    var product_block = document.querySelectorAll('.product-block[data-dynamic-variants-enabled] .variant-wrapper.js fieldset .variant-input');
    if (product_block.length > 0) {
      product_block.forEach(function (variant_input) {
        let input = variant_input.querySelector('input:checked') || '';
        if (input) {
          var ev = new Event("change", { "bubbles": true, "cancelable": false });
          input.dispatchEvent(ev);
        };
      });
    };

    /* ----------------------------------------------------------- ok  */
    //NEW FORM ID
    var new_forms = document.querySelectorAll('[id="new-form"]').length > 0 ? document.querySelectorAll('[id="new-form"]') : [];
    if (new_forms.length > 0) {
      new_forms.forEach(function (new_form) {
        var swatches = document.querySelectorAll(swatchs);
        if (swatches.length < 1) {
          var new_form_option = new_form.querySelectorAll('.new-form-option').length > 0 ? new_form.querySelectorAll('.new-form-option') : [];
          if (new_form_option.length > 0) {
            new_form_option.forEach(function (val) {
              if (val.classList.contains('selectedWB')) {
                var ev = new Event("click", { "bubbles": true, "cancelable": false });
                val.dispatchEvent(ev);
              }
            });
          }
        }
      });
    }

    /* -----------------------------------------------------------ok  */
    //CASE SELECTS
    var variant_selects = !!document.querySelector('variant-selects') ? document.querySelector('variant-selects') : '';
    if (!!variant_selects) {
      var selects = variant_selects.querySelectorAll('select').length > 0 ? variant_selects.querySelectorAll('select') : [];
      if (selects.length > 0) {
        selects.forEach(function (select) {
          var ev = new Event("change", { "bubbles": true, "cancelable": false });
          select.dispatchEvent(ev);
        });
      }
    };
    /* -----------------------------------------------------------ok  */
    //CASE VARIO-VARIANTS
    var vario_variants = !!document.querySelector('ul.vario-variants') ? document.querySelector('ul.vario-variants') : '';
    if (!!vario_variants) {
      var vario_variant = document.querySelectorAll('li.vario-variant').length > 0 ? document.querySelectorAll('li.vario-variant') : '';
      if (vario_variant.length > 0) {
        vario_variant.forEach(function (val) {
          if (val.classList.contains('sv_active')) {
            var ev = new Event("click", { "bubbles": true, "cancelable": false });
            val.dispatchEvent(ev);
          }
        });
      }
    };

    /* ----------------------------------------------------------- */
    var shop_form = !!document.querySelector('form[action="/cart/add"]') ? document.querySelector('form[action="/cart/add"]') : '';
    if (!!shop_form) {
      var shop_select = shop_form.querySelectorAll('select[name="id"]').length > 0 ? shop_form.querySelectorAll('select[name="id"]') : [];
      if (shop_select.length > 0) {
        shop_select.forEach(function (vals) {
          var ev = new Event("change", { "bubbles": true, "cancelable": false });
          vals.dispatchEvent(ev);
        });
      }
    };

    /* ----------------------------------------------------------- ok  */
    /*CART BAR ---> Click title scroll to top */
    var cart_bar_product_title = !!document.querySelector('.hs-sticky-bar-product-title') ? document.querySelector('.hs-sticky-bar-product-title') : '';
    if (!!cart_bar_product_title) {
      cart_bar_product_title.addEventListener("click", function (e) {
        e.preventDefault();
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });

      });
    };
    /* ----------------------------------------------------------- OK */
    /*CART BAR ---> Input validate value price */
    var inputAdded = document.querySelectorAll('.hs---buttons_added input').length > 0 ? document.querySelectorAll('.hs---buttons_added input') : [];
    if (inputAdded.length > 0) {
      inputAdded.forEach(function (inputAdd) {
        inputAdd.onkeyup = function (e) {
          e.preventDefault();
          inputAdd.value = inputAdd.value.replace(/[^0-9\.]/g, '');
          /*  if (!inputAdd.value) {
            inputAdd.value = 0;
          }
          if (inputAdd.value == 0) {
            inputAdd.value = 1;
          } */
          inputAdd.value = inputAdd.value
        }
        inputAdd.onblur = function (e) {//CAMBIO
          e.preventDefault();
          inputAdd.value = inputAdd.value.replace(/[^0-9\.]/g, '');
          if (!inputAdd.value || inputAdd.value == 0) {
            inputAdd.value = 1;
          };
          inputAdd.value = inputAdd.value
        }
      });
    };
    /* ----------------------------------------------------------- OK */
    /*CART BAR ---> Input change value price */

    var qty = document.querySelectorAll('.hs---qty').length > 0 ? document.querySelectorAll('.hs---qty') : [];
    var inputQty = document.querySelectorAll('input.hs-quick-button-quantity2').length > 0 ? document.querySelectorAll('input.hs-quick-button-quantity2') : [];
    if (qty.length > 0) {
      qty.forEach(function (val) {
        val.addEventListener("click", function (e) {
          var arr_variants = [],
            newVal = 0,
            oldValue = val.closest('.hs---buttons_added').querySelector('input').value;
          if (val.classList.contains('hs---plus')) {
            newVal = parseFloat(oldValue) + 1;
          } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
              newVal = parseFloat(oldValue) - 1;
            } else {
              newVal = 1;
            }
          }
          if (inputQty.length > 0) {
            inputQty.forEach(function (now) {
              now.value = newVal;
            })
          };
          HsApp2.changePrices(newVal);
        });
      });
    };
    /* ----------------------------------------------------------- OK */
    /*CART BAR ---> Change cart bar selects of cart bar*/
    function dispatchSelectCombo(variant_select = '', value = '') {
      if (variant_select) {
        var variant_selects = !!document.querySelector(variant_select) ? document.querySelector(variant_select) : '';
        if (!!variant_selects) {
          var selects = variant_selects.querySelectorAll('fieldset input').length > 0 ? variant_selects.querySelectorAll('fieldset input') : [];
          if (selects.length > 0) {
            selects.forEach(function (select) {
              if (select.value === value) {
                select.checked = true;
                var ev = new Event("change", { "bubbles": true, "cancelable": false });
                select.dispatchEvent(ev);
              };
            });
          }
        };
      };
    };

    var selectOpt = document.querySelectorAll('.hs-select-option-checkout-bar').length > 0 ? document.querySelectorAll('.hs-select-option-checkout-bar') : [];
    if (selectOpt.length > 0) {
      selectOpt.forEach(function (valOpt) {
        if (!valOpt.classList.contains('hs-event-static')) {
          valOpt.classList.add('hs-event-static');
          valOpt.addEventListener('change', function (e) {
            e.preventDefault();
            var id = valOpt.querySelector('option:checked').dataset.id, value = Hs_CartDrawer.unEscape(valOpt.value), variant_option = '', titleVariant = '', arr = [], variant = [];
            var select_box_load = document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load').length > 0 ? document.querySelector('.hs-content-variant-select-option').querySelector('.hs-change-select-option').querySelectorAll('.hs-select-box-load') : [];
            if (select_box_load.length > 0) {
              select_box_load.forEach(function (valSelect) {
                var val_select = Hs_CartDrawer.unEscape(valSelect.querySelector('select').value);
                titleVariant = titleVariant.concat(val_select + ' / ');
                arr.push(val_select);
              });
            }
            if (titleVariant) {
              titleVariant = titleVariant.slice(0, -3);
            }

            dispatchSelectCombo('variant-selects', value);
            dispatchSelectCombo('variant-picker', value);

            //CASE COMBOBOX
            var forms = document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length > 0 ? document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]') : [];
            if (forms.length > 0) {
              forms.forEach(function (form) {
                var formSelect = form.querySelectorAll('select:not(.cbb-recommendations-variant-select):not(.sls-select)').length > 0 ? form.querySelectorAll('select:not(.cbb-recommendations-variant-select):not(.sls-select)') : '';
                if (formSelect.length > 0) {
                  var count = -1;
                  formSelect.forEach(function (valSelect, index) {
                    if (!!valSelect.options) {
                      if (valSelect.ariaLabel !== 'Quantity') {
                        let parent = valSelect.parentElement;
                        var select_index = valSelect.getAttribute('name');
                        if (parent) {
                          if (parent.classList.contains('paywhirl-plan-selector-plan')) {
                            select_index = 'id';
                          };
                        };
                        if (select_index !== "id") {
                          count++
                          if (value === Hs_CartDrawer.unEscape(arr[count])) {
                            var id = valSelect.getAttribute('id');
                            if (id !== null) {
                              var element = document.getElementById(id);
                              valSelect.value = arr[count];
                              var ev = new Event("change", { "bubbles": true, "cancelable": false });
                              element.dispatchEvent(ev);
                            };
                          }
                        }
                      };
                    }
                  });
                };
              })
            };
            /*-- CASE PAGEFLY1 --*/
            var pf_option_swatches = document.querySelectorAll('[data-pf-type="ProductVariantSwatches"]').length > 0 ? document.querySelectorAll('[data-pf-type="ProductVariantSwatches"]') : [];
            if (pf_option_swatches.length > 0) {
              pf_option_swatches.forEach(function (pf_swatch) {
                var contents = pf_swatch.querySelectorAll('.pf-th').length > 0 ? pf_swatch.querySelectorAll('.pf-th') : [];
                if (contents.length > 0) {
                  contents.forEach(function (content) {
                    var contentOption = !!content.querySelector('.pf-option-swatches') ? content.querySelector('.pf-option-swatches') : '';
                    if (!!contentOption) {
                      var ipts = contentOption.querySelectorAll('input[type="radio"]').length > 0 ? contentOption.querySelectorAll('input[type="radio"]') : [];
                      if (ipts.length > 0) {
                        ipts.forEach(function (xxx) {
                          if (xxx.value === value) {
                            xxx.checked = true;
                            var parentElemt = !!xxx.closest('div[data-pf-type="ProductVariantSwatches"]') ? xxx.closest('div[data-pf-type="ProductVariantSwatches"]') : '';
                            if (!!parentElemt) {
                              var ev = new Event("change", { "bubbles": true, "cancelable": false });
                              parentElemt.dispatchEvent(ev);
                            };
                          };
                        });
                      };
                    };
                  });
                };
              });
            };
            /*-- CASE SELECTOR WRAPPER -- */
            var selector_wrapper = document.querySelectorAll('.selector-wrapper').length > 0 ? document.querySelectorAll('.selector-wrapper') : [];
            if (selector_wrapper.length > 0) {
              selector_wrapper.forEach(function (wrapper) {
                var selectWrapper = !!wrapper.querySelector('ul') ? wrapper.querySelector('ul') : '';
                if (!!selectWrapper) {
                  var thisOptions = selectWrapper.querySelectorAll('li').length > 0 ? selectWrapper.querySelectorAll('li') : '';
                  if (thisOptions.length > 0) {
                    thisOptions.forEach(function (thisOption) {
                      var liActive = !!thisOption.querySelector('a') ? thisOption.querySelector('a') : '';
                      if (liActive.dataset.value === value) {
                        var ev = new Event("click", { "bubbles": true, "cancelable": false });
                        liActive.dispatchEvent(ev);
                      }
                    })
                  }
                }
              })
            };

            /* --CASE SizeSwatchList ------------------------------------- ok  */
            var SizeSwatchList = !!document.querySelectorAll('.ProductForm__Variants').length > 0 ? document.querySelectorAll('.ProductForm__Variants') : [];
            if (SizeSwatchList.length > 0) {
              SizeSwatchList.forEach(function (val) {
                var inputs = val.querySelectorAll('input').length > 0 ? val.querySelectorAll('input') : [];
                if (inputs.length > 0) {
                  inputs.forEach(function (input) {
                    if (input.value === value) {
                      input.checked = true;
                      var ev = new Event("change", { "bubbles": true, "cancelable": false });
                      input.dispatchEvent(ev);
                    };
                  });
                }
              });
            };

            //CASE SWATCHES
            var variant_radios = !!document.querySelector('variant-radios.no-js-hidden') ? document.querySelector('variant-radios.no-js-hidden') : '';
            //var variant_radios = !!document.querySelector('variant-radios.no-js-hidden') ? document.querySelector('variant-radios.no-js-hidden') : '';
            if (!!variant_radios) {
              var fieldset = variant_radios.querySelectorAll('fieldset').length > 0 ? variant_radios.querySelectorAll('fieldset') : [];
              if (fieldset.length > 0) {
                fieldset.forEach(function (field) {
                  var inputs = field.querySelectorAll('input').length > 0 ? field.querySelectorAll('input') : [];
                  if (inputs.length > 0) {
                    inputs.forEach(function (input) {

                      if (input.value === value) {
                        input.checked = true;
                        if (variant_radios.matches(".variant-wrapper.js")) {
                          var ev = new Event("change", { "bubbles": true, "cancelable": false });
                          input.dispatchEvent(ev);
                        }
                      }
                    });
                  }
                });
              }
              var ev = new Event("change", { "bubbles": true, "cancelable": false });
              variant_radios.dispatchEvent(ev);
            };

            /* ----------------- */

            var product_block = document.querySelectorAll('.product-block[data-dynamic-variants-enabled] .variant-wrapper.js fieldset .variant-input');
            if (product_block.length > 0) {
              product_block.forEach(function (variant_input) {
                let input = variant_input.querySelector('input') || '';
                if (input.value === value) {
                  input.checked = true;
                  var ev = new Event("change", { "bubbles": true, "cancelable": false });
                  input.dispatchEvent(ev);
                }
              });
            };
            //CASE NEW FORM
            var new_form = document.querySelectorAll('[id="new-form"]').length > 0 ? document.querySelectorAll('[id="new-form"]') : [];
            if (new_form.length > 0) {
              new_form.forEach(function (newForm) {
                var new_form_option = newForm.querySelectorAll('.new-form-option').length > 0 ? newForm.querySelectorAll('.new-form-option') : [];
                if (new_form_option.length > 0) {
                  new_form_option.forEach(function (formOption) {
                    var titleOption = !!formOption.querySelector('.title-variant') ? formOption.querySelector('.title-variant') : '';
                    if (!!titleOption) {
                      if (value === titleOption.innerText) {
                        var opt = titleOption.closest('.new-form-option');
                        var ev = new Event("click", { "bubbles": true, "cancelable": false });
                        opt.dispatchEvent(ev);
                      }
                    }
                  });
                }
              });
            };

            //CASE SELECTS
            var variant_selects = !!document.querySelector('variant-selects') ? document.querySelector('variant-selects') : '';
            if (!!variant_selects) {
              var selects = variant_selects.querySelectorAll('select').length > 0 ? variant_selects.querySelectorAll('select') : [];
              if (selects.length > 0) {
                selects.forEach(function (valSelect, index) {
                  if (value === Hs_CartDrawer.unEscape(arr[index])) {
                    valSelect.value = arr[index];
                    var ev = new Event("change", { "bubbles": true, "cancelable": true });
                    valSelect.dispatchEvent(ev);
                  }
                });
              }
              if (variant_selects.classList.contains('no-js-hidden')) {
                var ev = new Event("change", { "bubbles": false, "cancelable": true });
                variant_selects.dispatchEvent(ev);
              };

            };

            //CASE vario-variants
            var vario_variants = !!document.querySelector('ul.vario-variants') ? document.querySelector('ul.vario-variants') : '';
            if (!!vario_variants) {
              var vario_variant = document.querySelectorAll('li.vario-variant').length > 0 ? document.querySelectorAll('li.vario-variant') : '';
              if (vario_variant.length > 0) {
                vario_variant.forEach(function (val) {
                  if (!!val.getAttribute('data-value')) {
                    if (val.dataset.value === value) {
                      var ev = new Event("click", { "bubbles": true, "cancelable": false });
                      val.dispatchEvent(ev);
                    }
                  }
                })
              }
            };


            variant = HsApp2.captureVariants(titleVariant);
            HsApp2.callBackVariant(variant);
            HsApp1.currencyConverter();
          });
        }
      });
    };



    /*CART BAR ---> Change cart bar Add To Cart Button*/
    var add_to_cart = !!document.querySelector('.hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-checkout-bar-add-to-cart') : '';
    if (!!add_to_cart) {
      if (!add_to_cart.classList.contains('hs-event-static')) {
        //CANDYRACK
        if (window.CANDYRACK_DOCUMENT_LISTENER) {
          if (window.CANDYRACK_CUSTOM_BUTTON_SELECTORS) {
            var type = typeof window.CANDYRACK_CUSTOM_BUTTON_SELECTORS || '';
            if (type === 'object') {
              window.CANDYRACK_CUSTOM_BUTTON_SELECTORS.push('.hs-checkout-bar-add-to-cart')
            }
          } else {
            window.CANDYRACK_CUSTOM_BUTTON_SELECTORS = ['.hs-checkout-bar-add-to-cart']
          };
        };
        add_to_cart.classList.add('hs-event-static');
        add_to_cart.addEventListener('click', function (e) {
          e.preventDefault();
          HsApp2.addToCart(this);
        });
      }
    };


    if ('ontouchstart' in window) {
      add_to_cart.outerHTML = add_to_cart.outerHTML;
      add_to_cart = !!document.querySelector('.hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-checkout-bar-add-to-cart') : '';
      if (!!add_to_cart) {
        if (!add_to_cart.classList.contains('hs-event-static-touch')) {
          add_to_cart.classList.add('hs-event-static-touch')
          add_to_cart.addEventListener("touchstart", function (e) {
            //e.preventDefault();
            HsApp2.addToCart(this);
          }, { passive: true });
        }
      }
    };
    var sticky_cart_bar_mobile_show_scroll = parseInt(slideData.cart_bar.cart_bar_mobile_hide_atc);
    var aTop = 80;
    var atc_visibility = HsApp2.isScrolledIntoView(Hs_CartDrawer.elementAddATC);
    var hs_checkout_bar = !!document.querySelector('.hs-sticky-checkout-bar') ? document.querySelector('.hs-sticky-checkout-bar') : '';
    var windowScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    HsApp2.scrollAndresize(sticky_cart_bar_mobile_show_scroll, aTop, atc_visibility, hs_checkout_bar);
    window.addEventListener('scroll', function (e) {
      HsApp2.scrollAndresize(sticky_cart_bar_mobile_show_scroll, aTop, atc_visibility, hs_checkout_bar);
      HsApp2.cartBarDevice();
    }, { passive: true });
    window.addEventListener('resize', function (e) {
      HsApp2.scrollAndresize(sticky_cart_bar_mobile_show_scroll, aTop, atc_visibility, hs_checkout_bar);
      HsApp2.cartBarDevice();
    }, { passive: true });
  },
  stickyCheckoutBar: function (product) {
    var count_options = 1,
      review = '',
      hs_price = '',
      compare_price_active = '',
      sticky_cart_bar_desktop_position = ' hs-desktop-top',
      sticky_cart_bar_mobile_position = ' hs-mobile-top',
      title = '',
      content = '',
      price = '',
      count_variants = 0,
      hidden_variant = '',
      compare_at_price = 0,
      content_compare_at_price = '<div class="hs-checkout-bar-compare-at-price"></div>',
      checkoutBar = '',
      featured_image = '',
      quantity = '',
      button = '',
      flag = '',
      filterText1 = '',
      filterText2 = '',
      filterText3 = '',
      options = [],
      variants = [],
      filteredArr1 = [],
      filteredArr2 = [],
      filteredArr3 = [],
      opt1 = [],
      opt2 = [],
      opt3 = [],
      option1 = '',
      option2 = '',
      option3 = '',
      selectParent = '',
      selectVariant = '';
    if (parseInt(slideData.cart_bar.cart_bar_desktop_position, 10) == 1) {
      sticky_cart_bar_desktop_position = ' hs-desktop-bottom';
    }
    if (parseInt(slideData.cart_bar.cart_bar_mobile_position, 10) == 1) {
      sticky_cart_bar_mobile_position = ' hs-mobile-bottom';
    }
    product.forEach(function (val) {
      var cartbar = `<div class="hs-sticky-checkout-bar hs-sticky-checkout-bar-${val.id} ${sticky_cart_bar_desktop_position} ${sticky_cart_bar_mobile_position} hs-sticky-bar" style="visibility: hidden;opacity: 0;"></div>`;
      document.querySelector('body').insertAdjacentHTML('beforeend', cartbar);
      checkoutBar = document.querySelector(`.hs-sticky-checkout-bar-${val.id}`);
      title = val.title;
      price = val.price;
      compare_at_price = val.compare_at_price;
      featured_image = HsApp2.imageResize(val.featured_image, 'x100');
      options = val.options;
      variants = val.variants;
      selectParent = '';
      selectVariant = '';
      compare_price_active = '';
      opt1 = [];
      opt2 = [];
      opt3 = [];
      count_options = 1;
      count_variants = variants.length;
      variants.forEach(function (n, x) {
        option1 = '';
        option2 = '';
        option3 = '';
        count_options = n.options.length;
        n.options.forEach(function (w, u) {
          if (u == 0) {
            option1 = w;
          }
          if (u == 1) {
            option2 = w;
          }
          if (u == 2) {
            option3 = w;
          }
        });
        if (option1.length > 0) {
          opt1.push(option1);
        }
        if (option2.length > 0) {
          opt2.push(option2);
        }
        if (option3.length > 0) {
          opt3.push(option3);
        }
        //selectParent = selectParent.concat('<option value="' + n.id + '" data-id="' + val.id + '" title="' + n.title + '" data-price="' + n.price + '" data-sku="' + n.sku + '" data-available="' + n.available + '" data-barcode="' + n.barcode + '" data-featuredimage="' + val.featured_image + '" data-inventorymanagement="' + n.inventory_management + '" data-compareatprice="' + n.compare_at_price + '">' + n.title + '</option>');
        selectParent = selectParent.concat(`<option value='${n.id}' data-id='${val.id}' data-price='${n.price}' data-sku='${n.sku}' data-available='${n.available}' data-barcode='${n.barcode}' data-featuredimage='${val.featured_image}' data-inventorymanagement='${n.inventory_management}' data-compareatprice='${n.compare_at_price}'>${n.title}</option>`);
        selectVariant = selectVariant.concat('<li data-id="' + val.id + '" data-vid="' + n.id + '"><span>' + n.title + '</li></span>');
      });
      filterText1 = '';
      filterText2 = '';
      filterText3 = '';
      selectParent = '<select aria-label="hs-select-variants-bar" class="hs-select-variants-bar" style="display:none;">' + selectParent + '</select>';
      selectVariant = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-' + val.id + '">' + selectVariant + '</ul>';
      quantity = '<div class="hs---quantity hs---buttons_added"><div role="button" aria-label="Decrease quantity" tabindex="0" class="hs---minus hs---qty"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input aria-label="Product quantity" type="text" maxlength="4" step="1" name="hs-quick-button-quantity2" value="1" class="hs-quick-button-quantity2" size="4" pattern="" inputmode=""><div role="button" aria-label="Increase  quantity" tabindex="0" class="hs---plus hs---qty"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>';
      button = '<button type="button" class="hs-add-to-cart hs-button-cart-' + val.id + ' ' + slideData.quick_buy.quick_buy_button_position + ' hs-animated HsbounceIn" data-id="' + val.id + '"><span>' + slideData.quick_buy.icon + '</span></button>';
      flag = '<div class="hs-flag-content hs-flag-' + val.id + '" style="display:none;"></div>';
      filteredArr1 = opt1.filter(function (item, index) {
        if (opt1.indexOf(item) == index)
          return item;
      });
      filteredArr2 = opt2.filter(function (item, index) {
        if (opt2.indexOf(item) == index)
          return item;
      });
      filteredArr3 = opt3.filter(function (item, index) {
        if (opt3.indexOf(item) == index)
          return item;
      });
      if (filteredArr1.length > 0) {
        hidden_variant = '';
        filteredArr1.forEach(function (v, i) {
          if (count_variants == 1) {
            if (v == 'Default Title') {
              hidden_variant = ' hs-hidden-select---variants';
            }
          }
          /*var selected = '';
          selected = i == 0 ? "selected" : ""*/
          filterText1 = filterText1.concat('<option  value="' + Hs_CartDrawer.escape(v) + '" data-id="' + val.id + '">' + v + '</option>');
        })
        filterText1 = '<div class="hs-select-box-load' + hidden_variant + ' hs-load-select-box-bar-' + count_options + '"><span class="hs-select-text">' + val.options[0].name + '</span><select aria-label="hs-option-' + val.id + '-0" class="hs-option-' + val.id + '-0 hs-select-option-checkout-bar" name="none"><option value="' + Hs_CartDrawer.escape(val.options[0].name) + '" disabled>' + val.options[0].name + '</option>' + filterText1 + '</select></div>';
      };

      if (filteredArr2.length > 0) {
        filteredArr2.forEach(function (v, i) {
          filterText2 = filterText2.concat('<option value="' + Hs_CartDrawer.escape(v) + '" data-id="' + val.id + '">' + v + '</option>');
        });
        filterText2 = '<div class="hs-select-box-load hs-load-select-box-bar-' + count_options + '"><span class="hs-select-text">' + val.options[1].name + '</span><select aria-label="hs-option-' + val.id + '-1" class="hs-option-' + val.id + '-1 hs-select-option-checkout-bar" name="none"><option value="' + Hs_CartDrawer.escape(val.options[1].name) + '" disabled>' + val.options[1].name + '</option>' + filterText2 + '</select></div>';
      };

      if (filteredArr3.length > 0) {
        filteredArr3.forEach(function (v, i) {
          filterText3 = filterText3.concat('<option value="' + Hs_CartDrawer.escape(v) + '" data-id="' + val.id + '">' + v + '</option>');
        });
        filterText3 = '<div class="hs-select-box-load hs-load-select-box-bar-' + count_options + '"><span class="hs-select-text">' + val.options[2].name + '</span><select aria-label="hs-option-' + val.id + '-2" class="hs-option-' + val.id + '-2 hs-select-option-checkout-bar" name="none"><option value="' + Hs_CartDrawer.escape(val.options[2].name) + '" disabled>' + val.options[2].name + '</option>' + filterText3 + '</select></div>';
      };

      if (compare_at_price > price) {
        compare_price_active = ' hs-compare-price-active';
        content_compare_at_price = '<div class="hs-checkout-bar-compare-at-price"><s class="hs-money-compare-price">' + hsonslidecart.Currency.formatMoney(compare_at_price, slideData.settings.devices.money_format) + '</s></div>';
      };

      hs_price = '<div class="hs-checkout-bar-price"><span class="hs-money-price' + compare_price_active + '">' + hsonslidecart.Currency.formatMoney(price, slideData.settings.devices.money_format) + '</span></div>';

      if (featured_image === null) {
        featured_image = 'https://cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/hs-no-image_thumb.gif';
      };

      var textButton = !product[0].available ? slideData.settings.language_settings.sold_out_language_settings : slideData.cart_bar.cart_bar_button_text;
      var disabledButton = !product[0].available ? 'disabled="disabled' : '';
      review = '<span class="shopify-product-reviews-badge" data-id="' + val.id + '"></span>';
      content = '<div class="hs-content-image-and-title">\
              <div class="hs-image-thumb">\
                  <div class="hs-thumb-and-title">\
                  <div class="hs-bar-content-image">\
                  <img class="hs-bar-featured-image" src="'+ featured_image + '" alt="' + val.title + '" />\
                  </div>\
                  <div class="hs-bar-content-title">\
                  <span class="hs-sticky-bar-add-to-cart-product-title">\
                  <div class="hs-sticky-bar-product-title">'+ title + '</div>\
                  <div class="hs-product-review">'+ review + '</div>\
                  <div class="hs-product-price-container" style="display: none;">\
                  '+ content_compare_at_price + hs_price + '\
                  </div>\
                  </span>\
                  </div>\
                  </div>\
                  </div>\
              <div class="hs-content-quantity-resize" style="display:none;">'+ quantity + '</div>\
                  <div class="hs-bar-content-price"><div class="hs-hidden-quantity-mobile"><div class="hs-content-quantity">'+ quantity + '</div></div>' + content_compare_at_price + hs_price + '</div>\
                  </div>\
                  <div class="hs-content-variant-select-option">\
                  <div class="hs-change-select-option">\
                  '+ filterText1 + filterText2 + filterText3 + '\
                  <div class="hs-content-quantity">'+ quantity + '</div>\
                  </div>\
                  <div class="hs-checkout-bar-prices-sw">'+ content_compare_at_price + hs_price + '</div>' + selectParent + '\
                  </div>\
                  <div class="hs-full-bar-button">\
                  <div class="hs-content-quantity">'+ quantity + '</div>\
                  <button type="button" class="hs-checkout-bar-add-to-cart btn" ' + disabledButton + '">\
                  <span class="hs-add--to--cart">'+ textButton + '</span>\
                  <span class="hs--loading">'+ HsApp4.loadSvg() + '</span>\
                  </button>\
                  </div>';
      checkoutBar.innerHTML = '<div class="hs-content-checkout-bar' + hidden_variant + '">' + content + '</div>';
    });
    HsApp2.changeVariantsCheckoutBar();
  },
  printCheckoutBar: function (handle) {
    if (handle) {
      var currency_update = '';
      if (window.Shopify) {
        if (window.Shopify.currency) {
          if (window.Shopify.currency.active && window.Shopify.country) {
            currency_update = `&currency=${window.Shopify.currency.active}&country=${window.Shopify.country}`;
          };
        };
      };

      fetch(`${handle}.js?v='${(new Date).getTime()}${currency_update}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => {
          return response.ok ? response.json() : Promise.reject(response);
        })
        .then((json) => {
          if (json) {
            /* var currencyMoney = ''
            if (!!window.Shopify) {
              if (!!window.Shopify.currency) {
                if (!!window.Shopify.currency.active) {
                  currencyMoney = window.Shopify.currency.active;
                }
              }
            };
            if (currencyMoney) {
              slideData.settings.devices.money_format = HsCurrency.moneyFormats[currencyMoney].money_format || slideData.settings.devices.money_format;
            };
 
            if (HsApp1.readCookie('cart_currency') !== '') {
              if (HsApp1.readCookie('cart_currency') !== currencyMoney) {
                currencyMoney = HsApp1.readCookie('cart_currency');
              };
              slideData.settings.devices.money_format = HsCurrency.moneyFormats[currencyMoney].money_format || slideData.settings.devices.money_format;
            };
 
            if (currencyMoney === 'EUR') {
              if (!!Hs_CartDrawer.afterSymbol) {
                slideData.settings.devices.money_format = HsCurrency.moneyFormats[currencyMoney].money_format_reverse || slideData.settings.devices.money_format;
              };
            }; */

            HsApp1.arr_variants = json.variants;
            var tags = json.tags, product = [];
            if (!tags.includes('HS_CART_BAR_HIDDEN_PRODUCT')) {
              product.push(json)
              HsApp2.stickyCheckoutBar(product);
              HsApp2.cartBarDevice();
            }
            if (!!slideData.cart_animator.enabled_cart_animator) {
              if (slideData.cart_animator.cart_animator_sticky_bar_button !== 'none') {
                HsApp5.animatedStickyBarButton();
              }
            };
          }
        })
        .catch(err => {
          console.log(err)
        });
    }
  },
  cssCartBar: function () {
    var contentCssCartBar = `
                .hs-sticky-checkout-bar.hs-mobile-bottom {\
                    box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-sticky-checkout-bar.hs-mobile-top {\
                  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-sticky-checkout-bar.hs-desktop-top {\
                  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-sticky-checkout-bar.hs-desktop-top{\
                  top:${slideData.cart_bar.cart_bar_desktop_positionOffset}px;\
                  bottom: inherit;\
                }\
                .hs-sticky-checkout-bar.hs-show-element{\
                  visibility: hidden !important;\
                  transition: all .7s;\
                }\
                .hs-sticky-checkout-bar.hs-hide-element{\
                  visibility: visible !important;\
                  z-index : 0;\
                  transition: all .7s;\
                }\
                .hs-sticky-checkout-bar.hs-sticky-bar.hs-hide-element {\
                  z-index: -1 !important;\
                }\
                body.pplr_fixed .hs-sticky-checkout-bar.hs-sticky-bar{
                  display: none;\
                }\
                .hs-sticky-checkout-bar {\
                  position: fixed;\
                  top: 0;\
                  left: 0;\
                  z-index: 2147483635;\
                  width: 100%;\
                }\
                .hs-content-checkout-bar {\
                  box-sizing: border-box;\
                  margin: 0 auto;\
                  width: 100%;\
                  font-size: 18px;\
                  line-height: 18px;\
                  background: ${slideData.cart_bar.cart_bar_background_color_hex};\
                  padding-right: 10px;\
                  padding-left: 10px;\
                  display: flex;\
                  display: -webkit-flex;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  -webkit-box-pack: justify;\
                  gap:10px;\
                }\
                .hs-sticky-checkout-bar.hs-show-element{\
                  visibility: visible !important;\
                  opacity: 1 !important;\
                }\
                .hs-content-checkout-bar .hs-select-box-load .hs-select-text {\
                  display: none;\
                }\
                .hs-content-checkout-bar .hs-content-image-and-title {\
                  vertical-align: middle;\
                  height: 57px;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  -webkit-box-pack: justify;\
                  justify-content: space-between;\
                  display: flex;\
                  display: -webkit-flex;\
                  flex-direction: row;\
                  flex-wrap: nowrap;\
                  width: auto;\
                  flex: 1 1 auto;\
                  overflow: hidden;\
                  position: relative;\
                  height: auto;\
                  margin-top: 5px;\
                }\
                .hs-content-checkout-bar.hs-hidden-header .hs-content-image-and-title {\
                  display: none;\
                }\
                .hs-content-checkout-bar .hs-image-thumb {\
                  display: flex;\
                  display: -webkit-flex;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  max-width: 100%;\
                  flex: 1 1 auto;\
                  overflow: hidden;\
                }\
                .hs-desktop-top .hs-content-checkout-bar .hs-thumb-and-title, .hs-desktop-bottom .hs-content-checkout-bar .hs-thumb-and-title {\
                  margin-bottom: 5px;\
                }\
                .hs-content-checkout-bar .hs-thumb-and-title {\
                  -webkit-box-pack: justify;\
                  display: flex;\
                  display: -webkit-flex;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  /* margin-right: 10px;\ */
                  width: auto;\
                  flex: 1 1 auto;\
                  overflow: hidden;\
                  gap:10px;\
                }\
                .hs-content-checkout-bar .hs-bar-content-image {\
                  line-height: 0;\
                }\
                .hs-content-checkout-bar .hs-bar-content-title {\
                  display: flex;\
                  display: -webkit-flex;\
                  width: calc(100% - 60px);\
                  flex-direction: column;\
                  line-height: 1.4;\
                }\
                .hs-content-checkout-bar .hs-bar-content-title a {\
                  text-decoration:none;\
                }\
                .hs-sticky-bar-add-to-cart-product-title .hs-sticky-bar-product-title{\
                  color: ${slideData.cart_bar.cart_bar_productTitle_color_hex};\
                  cursor: pointer;\
                  white-space: nowrap;\
                  text-overflow: ellipsis;\
                  overflow: hidden;\
                }\
                .hs-content-checkout-bar .hs-product-review {\
                  color: ${slideData.cart_bar.cart_bar_productTitle_color_hex};\
                  font-size: 14px;\
                  white-space: nowrap;\
                  text-overflow: ellipsis;\
                  overflow: hidden;\
                }\
                .hs-content-checkout-bar .hs-select-option-checkout-bar {\
                  -webkit-appearance: none !important;\
                  -moz-appearance: none !important;\
                  appearance: none !important;\
                  background-position: right center !important;\
                  background-image: url("//cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/ico-select.svg") !important;\
                  background-repeat: no-repeat !important;\
                  background-position: right 10px center !important;\
                  padding-right: 28px !important;\
                  text-indent: 0.01px !important;\
                  text-overflow: "" !important;\
                  cursor: pointer !important;\
                  padding-top: 0px !important;\
                  padding-left: 18px !important;\
                  padding-bottom: 0px !important;\
                  height: 41px !important;\
                  min-height: 41px !important;\
                  margin: 0;\
                  appearance: none;\
                  width: 100%;\
                  text-overflow: ellipsis;\
                  box-shadow: none !important;\
                  outline: none !important;\
                  outline-offset: inherit !important;\
                }\
                .hs-content-checkout-bar .hs-bar-content-price {\
                  display: none;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  -webkit-box-pack: justify;\
                  justify-content: space-between;\
                }\
                .hs-content-checkout-bar.hs-hidden-select .hs-select-box-load,.hs-content-checkout-bar .hs-hidden-quantity-mobile {\
                  display: none !important;\
                }\
                .hs---quantity.hs---buttons_added {\
                  text-align: left;\
                  position: relative;\
                  white-space: nowrap;\
                  vertical-align: top;\
                  display:flex;\
                }\
                .hs---quantity.hs---buttons_added .hs---minus {\
                  border-right: 0;\
                }\
                .hs---quantity.hs---buttons_added .hs---minus,.hs---quantity.hs---buttons_added .hs---plus {\
                  display: inline-flex;\
                  align-items: center;\
                  justify-content: center;\
                  padding: 0px 8px !important;\
                  background-color: #ffffff;\
                  border-radius: 0px !important;\
                  border: 1px solid #949494;\
                  height: 41px !important;\
                  line-height: 41px !important;\
                  min-height: auto;\
                  cursor: pointer;\
                  font-size: inherit !important;\
                  box-sizing: border-box !important;\
                  box-shadow: none !important;\
                  outline: none !important;\
                  letter-spacing: 0;\
              width:27px;\
                }\
                .hs---quantity.hs---buttons_added input {\
                  display: inline-block;\
                  margin: 0;\
                  vertical-align: top;\
                  box-shadow: none;\
                }\
                .hs---quantity .hs-quick-button-quantity2 {\
                  color: #000;\
                  width: 40px !important;\
                  height: 41px !important;\
                  padding: 0px !important;\
                  text-align: center !important;\
                  background-color: #fff !important;\
                  border: 0px !important;\
                  border-top: 1px solid #949494 !important;\
                  border-bottom: 1px solid #949494 !important;\
                  border-radius: 0 !important;\
                  outline: none;\
                  min-height: auto !important;\
                }\
                .hs---quantity.hs---buttons_added .hs---minus,.hs---quantity.hs---buttons_added .hs---plus {\
                  display: inline-flex;\
                  align-items: center;\
                  justify-content: center;\
                  padding: 0px 8px !important;\
                  background-color: #ffffff;\
                  border-radius: 0px !important;\
                  border: 1px solid #949494;\
                  height: 41px !important;\
                  line-height: 41px !important;\
                  min-height: auto;\
                  cursor: pointer;\
                  font-size: inherit !important;\
                  box-sizing: border-box !important;\
                  box-shadow: none !important;\
                  outline: none !important;\
                  letter-spacing: 0;\
                }\
                .hs---quantity.hs---buttons_added .hs---minus {\
                  border-right: 0;\
                }\
                .hs---quantity.hs---buttons_added .hs---plus {\
                  border-left: 0;\
                }\
                .hs---quantity.hs---buttons_added svg {\
                  width: auto !important;\
                  height: auto !important;\
                  vertical-align: unset;\
                }\
                .hs---minus svg,.hs---plus svg {\
                  fill: #7d7d7d;\
                }\
                .hs-checkout-bar-prices-sw{\
                  display: flex;\
                  gap:10px;
                  ${Hs_CartDrawer.prices_reverse_order ? 'flex-direction: row-reverse;' : ''}
                }\
                .hs-checkout-bar-price,.hs-checkout-bar-compare-at-price{\
                  vertical-align: middle;\
                  display: flex;\
                  display: -webkit-flex;\
                  flex-direction: row;\
                  white-space: nowrap;\
                }\
                .hs-checkout-bar-price .hs-money-price{\
                  color:${slideData.cart_bar.cart_bar_price_color_hex};\
                }\
                .hs-checkout-bar-compare-at-price {\
                  text-decoration: line-through !important;\
                  color:${slideData.cart_bar.cart_bar_comparePrice_color_hex} !important;\
                }\
                /* .hs-content-variant-select-option .hs-checkout-bar-compare-at-price .hs-money-compare-price {\
                  margin-left: 10px;\
                }\ */
                .hs-content-checkout-bar .hs-content-variant-select-option {\
                  margin-bottom: 0rem;\
                  display: flex;\
                  display: -webkit-flex;\
                  flex-direction: row;\
                  margin-left: 0px;\
                  width: auto;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  -webkit-box-pack: justify;\
                  gap:10px;\
                }\
                .hs-content-checkout-bar .hs-change-select-option {\
                  position: relative;\
                  margin-bottom: 0rem;\
                  display: flex;\
                  display: -webkit-flex;\
                  flex-direction: row;\
                  margin-left: 0px;\
                  width: auto;\
                  gap:10px;\
                }\
                .hs-content-checkout-bar .hs-select-box-load {\
                  position: relative;\
                  display: flex;\
                  display: -webkit-flex;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  max-width: 140px;\
                  min-width: 110px;\
                  /* padding-right: 5px;\ */
                  flex: 1 1 auto;\
                }\
                /* .hs-content-checkout-bar .hs-full-bar-button {\
                  margin-left: 10px;\
                }\ */
                .hs-content-checkout-bar .hs-full-bar-button .hs-checkout-bar-add-to-cart {\
                  box-sizing: border-box !important;\
                  margin: 0;\
                  width: 100% !important;\
                  max-width: 100% !important;\
                  height: 40px;\
                  box-shadow:none;\
                }\
                .hs-content-checkout-bar .hs-full-bar-button .hs-checkout-bar-add-to-cart.hs-loading-btn .hs-spinner{\
                  border-top-color:${slideData.cart_bar.cart_bar_button_text_color_hex} !important;\
                }\
                .hs-content-checkout-bar .hs-checkout-bar-add-to-cart[disabled="disabled"] {\
                  cursor:default !important;\
                }\
                .hs-content-checkout-bar .hs-checkout-bar-add-to-cart, .hs-content-checkout-bar .hs-checkout-bar-add-to-cart:focus, .hs-content-checkout-bar .hs-checkout-bar-add-to-cart:active, .hs-content-checkout-bar .hs-checkout-bar-add-to-cart:hover {\
                  position:relative !important;\
                  -moz-user-select: none;\
                  -ms-user-select: none;\
                  -webkit-user-select: none;\
                  user-select: none;\
                  -webkit-appearance: none;\
                  -moz-appearance: none;\
                  appearance: none;\
                  display: inline-block;\
                  width: auto;\
                  text-decoration: none !important;\
                  text-align: center !important;\
                  vertical-align: middle !important;\
                  cursor: pointer;\
                  border: 1px solid transparent !important;\
                  border-radius: 2px !important;\
                  padding: 8px 20px !important;\
                  background-color: ${slideData.cart_bar.cart_bar_button_background_color_hex} !important;\
                  color: ${slideData.cart_bar.cart_bar_button_text_color_hex} !important;\
                  font-style: normal !important;\
                  white-space: normal !important;\
                  font-size: 14px !important;\
                  line-height: 14px !important;\
                  /*margin-left: 10px !important;\*/
                  -webkit-box-pack: center !important;\
                  justify-content: center !important;\
                  white-space: nowrap !important;\
                  user-select: none !important;\
                  overflow: hidden !important ;\
                  min-width:150px !important;\
                }\
                .hs-content-checkout-bar .hs-checkout-bar-add-to-cart span,.hs-content-checkout-bar .hs-checkout-bar-add-to-cart:focus > span,.hs-content-checkout-bar .hs-checkout-bar-add-to-cart:active > span,.hs-content-checkout-bar .hs-checkout-bar-add-to-cart:hover > span{\
                  color: ${slideData.cart_bar.cart_bar_button_text_color_hex} !important;\
                  font-style: normal;\
                  font-size: 14px;\
                  white-space: nowrap !important;\
                }\
                
                .hs--loading {\
                  display: none;\
                }\
                .hs-content-checkout-bar .hs-image-thumb {\
                  display: flex;\
                  display: -webkit-flex;\
                  -webkit-box-align: center;\
                  align-items: center;\
                  max-width: 100%;\
                  flex: 1 1 auto;\
                  overflow: hidden;\
                }\
                .hs-sticky-checkout-bar.hs-desktop-bottom {\
                  bottom:${slideData.cart_bar.cart_bar_desktop_positionOffset}px;\
                  top: auto;\
                }\
                .hs-sticky-checkout-bar.hs-desktop-top {\
                  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-sticky-checkout-bar.hs-desktop-bottom {\
                  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-sticky-checkout-bar.hs-mobile-bottom {\
                  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-sticky-checkout-bar.hs-sticky-checkout-bar-6919672365231.hs-mobile-top.hs-sticky-bar.hs-show-element {\
                  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
                }\
                .hs-content-checkout-bar .hs-content-image-and-title .hs-image-thumb img {\
                  /* margin-right: 10px;\ */
                  max-height: 48px;\
                  max-width: 48px;\
                  height: auto !important;\
                  width: auto !important;\
                }\
                .hs-loading-btn{\
                  position:relative;\
                }\
                .hs-loading-btn .hs-add--to--cart {\
                  visibility: hidden;\
                  opacity: 0;\
                }\
                .hs-loading-btn .hs--loading {\
                  display: flex !important;\
                  display: -webkit-flex;\
                  align-items: center;\
                  justify-content: center;\
                  position: absolute;\
                  top: 50%;\
                  left: 50%;\
                  transform: translate(-50%, -50%);\
                  width: 100%;\
                }\
                .hs--loading svg{\
                  width: 50px;\
                  height: 50px;\
                }\

                .hs-select-box-load.hs-hidden-select---variants {\
                  display: none !important;\
                }\

                .hs-sticky-checkout-bar .hs-full-bar-button .hs-content-quantity\
                {\
                  display:none;\
                }\

                .hs-product-price-container{\
                  display:none;\
                  gap:10px;\
                  align-items: center;\
                  flex-direction: ${Hs_CartDrawer.prices_reverse_order ? 'row-reverse' : 'row'};
                  ${Hs_CartDrawer.prices_reverse_order ? 'justify-content: flex-end;' : ''};
                }\

                @media (max-width: 769px){
                  .hs-sticky-checkout-bar .hs-change-select-option .hs-content-quantity\
                  {\
                    display:none !important;\
                  }\
                  .hs-sticky-checkout-bar .hs-full-bar-button .hs-content-quantity\
                  {\
                    display:${!!parseInt(slideData.cart_bar.cart_bar_mobile_show_quantitySelect) ? 'block' : 'none'};\
                    margin: 5px 5px 5px 5px;\
                  }\
                  .hs-sticky-checkout-bar .hs-full-bar-button button\
                  {\
                    display: block;\
                    justify-content: center;\
                    margin: 0px 12px 0px;\
                    border-radius: 0px;\
                    color: white;\
                    background-color: black;\
                    border: 1px solid black;\
                    height: 41px !important;\
                    line-height: 20px;\
                    width: 100%;\
                    position: relative;\
                    font-size: inherit;\
                    font-weight: bold;\
                    box-shadow: none;\
                    white-space: nowrap;\
                    margin: 5px 5px 5px 5px !important;\
                  }\
                  .hs-content-checkout-bar .hs-select-option-checkout-bar\
                  {\
                    height: 40px;\
                    flex: 1 1 150px;\
                  }\

                  .hs-content-checkout-bar{\
                    font-size: 16px;\
                    line-height: 16px;\
                    -webkit-box-align: center;\
                    align-items: center;\
                    -webkit-box-pack: justify;\
                    justify-content: space-between;\
                    display: flex;\
                    display: -webkit-flex;\
                    flex-direction: row;\
                    padding: 0px;\
                    flex-wrap: wrap;\
                    width: 100%;\
                    flex: 1 1 auto;\
                    overflow: hidden;\
                  }\
                  .hs-sticky-checkout-bar.hs-mobile-bottom{\
                    bottom:${slideData.cart_bar.cart_bar_mobile_positionOffset}px;\
                    top: auto;\
                  }\
                  .hs-content-checkout-bar .hs-content-image-and-title {\
                    width: 100%;\
                    padding: 0px 5px;\
                  }\
                  .hs-content-checkout-bar .hs-bar-content-price {\
                    display: none;\
                    display: none;\
                  }\
                  .hs-content-checkout-bar .hs-content-variant-select-option {\
                    -webkit-box-align: center;\
                    align-items: center;\
                    -webkit-box-pack: justify;\
                    justify-content: space-between;\
                    display: flex;\
                      display: -webkit-flex;\
                    flex-direction: row;\
                    flex-wrap: wrap;\
                    width: 100%;\
                    flex: 1 1 auto;\
                    overflow: hidden;\
                  }\
                  .hs-content-checkout-bar .hs-change-select-option {\
                    padding: 3px 3px 0px 3px;\
                    width: calc(100% + 1.1rem);\
                    display: flex;\
                    margin: 5px 2px 0px;\
                    flex: 1 1 100%;\
                    flex-wrap: wrap;\
                  }\

                  .hs-content-checkout-bar.quantityButton{\
                    display:flex !important;\
                  }\
                  .hs-content-checkout-bar.quantityButton .hs-change-select-option {\
                    margin-left: 5px !important;
                    padding:0px;
                    width: auto !important;\
                  }\
                  .hs-content-checkout-bar.quantityButton .hs-content-variant-select-option{\
                    width: auto !important;\
                  }\
                  .hs-content-checkout-bar.quantityButton .hs-full-bar-button{\
                    width: auto !important;\
                    margin-rigth: 5px !important;\
                  }\

                  .hs-change-select-option {\
                    padding-right: 0px;\
                  }\
                  .hs-content-variant-select-option .hs-checkout-bar-compare-at-price, .hs-content-variant-select-option .hs-checkout-bar-price {\
                    display: none !important;\
                  }\
                  .hs-content-checkout-bar .hs-select-box-load {\
                    position: relative;\
                    display: flex;\
                    display: -webkit-flex;\
                    -webkit-box-align: center;\
                    align-items: center;\
                    max-width: initial;\
                    min-width: 70px;\
                    padding-right: 0px;\
                    flex: 1 1 auto;\
                  }\
                  .hs-content-checkout-bar .hs-select-box-load {\
                    margin-bottom: 5px;\
                  }\
                  .hs-content-checkout-bar .hs-full-bar-button {\
                    margin-left: 0px;\
                      -webkit-box-align: center;\
                      align-items: center;\
                      -webkit-box-pack: justify;\
                      justify-content: space-between;\
                      display: flex;\
                      display: -webkit-flex;\
                      flex-direction: row;\
                      width: 100%;\
                      flex: 1 1 auto;\
                      overflow: hidden;\
                  }\
                  .hs-full-bar-button .hs-content-quantity-resize {\
                    padding-right: 10px;\
                  }\
                  .hs-full-bar-button {\
                    align-items: center;\
                    flex-direction: row;\
                    width: 100%;\
                    margin-left:0px;\
                  }\
                  .hs-content-checkout-bar .hs-checkout-bar-add-to-cart{\
                    font-size: 16px;\
                    height:52px !important;\
                  }\
                  .hs-full-bar-button button.hs-checkout-bar-add-to-cart {\
                    border-radius: 0 !important;\
                  }\
                  .hs-content-checkout-bar .hs-checkout-bar-add-to-cart{\
                    font-size: 16px;\
                    height:52px !important;\
                  }\
                  .hs-sticky-checkout-bar.hs-mobile-top{\
                    top:${slideData.cart_bar.cart_bar_mobile_positionOffset}px;\
                    bottom: auto;\
                  }\
                }
          `;
    document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">' + contentCssCartBar + '</style>');
  },
  cartBar: function () {
    if (!parseInt(slideData.cart_bar.enabled_cart_bar)) {
      return false;
    };
    var resultValidateDevice = HsApp2.validateCartBarDevice();
    switch (parseInt(resultValidateDevice)) {
      case 0:
        return false;
        break;
      case 2:
        return false;
        break;
    };
    HsApp2.cssCartBar();
    var url = window.location.href, handle = '';
    if (typeof url !== "undefined") {
      if (url.indexOf('/products/') > -1) {
        handle = url.split('/products/');
        handle = handle[1];
        if (handle.indexOf('?') > -1) {
          handle = handle.split('?');
          handle = handle[0];
        }
        if (handle.indexOf('#') > -1) {
          handle = handle.split('#');
          handle = handle[0];
        }
        handle = decodeURIComponent(handle);
        handle = decodeURIComponent(handle);
        handle = decodeURIComponent(handle);
      }
    };
    if (HsApp2.homepageDetect()) {
      if (slideData.cart_bar.enabled_cart_bar_home_page) {
        handle = '/products/' + slideData.cart_bar.cart_bar_product_shopify_handle;
        if (!!window.Shopify) {
          if (!!window.Shopify.routes) {
            if (!!window.Shopify.routes.root) {
              if (window.Shopify.routes.root !== '/') {
                handle = window.Shopify.routes.root.concat('products/' + slideData.cart_bar.cart_bar_product_shopify_handle);
              }
            }
          }
        }
      }
    }
    HsApp2.printCheckoutBar(handle);
  },
  init: function () {
    this.cartBar();
  }

}
/* =============== STICKY CART ============== */
var HsApp3 = {
  validateStickyCartDevice: function () {
    var show_desktop = slideData.sticky_cart.sticky_cart_show_desktop;
    var show_mobile = slideData.sticky_cart.sticky_cart_show_mobile;
    var device = HsApp1.loadDevice();
    var result;
    if (device == "desktop") {
      switch (parseInt(show_desktop)) {
        case 0:
          result = 0;
          break;
        case 1:
          result = 1
          break;
      };
    }
    else if (device == "mobile" || "tablet") {
      switch (parseInt(show_mobile)) {
        case 0:
          result = 2;
          break;
        case 1:
          result = 3;
          break;
      };
    };
    return result;
  },
  positionStickyCart: function () {
    var handle = slideData.sticky_cart.sticky_cart_position, distance = parseInt(slideData.sticky_cart.sticky_cart_distance), x = '', y = '', result;
    switch (handle) {
      case 'hs-top-right':
        x = 'right';
        y = 'top';
        break;
      case 'hs-bottom-right':
        x = 'right';
        y = 'bottom';
        break;
      case 'hs-top-left':
        x = 'left';
        y = 'top';
        break;
      case 'hs-bottom-left':
        x = 'left';
        y = 'bottom';
        break;
    };
    result = { x, y, distance };
    return result;

  },
  addslashes: function (string) {
    return string.replace(/\\/g, '\\\\').
      replace(/\u0008/g, '\\b').
      replace(/\t/g, '\\t').
      replace(/\n/g, '\\n').
      replace(/\f/g, '\\f').
      replace(/\r/g, '\\r').
      replace(/'/g, '\\\'').
      replace("\r\n", "\\n").
      replace(/"/g, '\\"');
  },
  objectifyForm: function (formArray) {
    //serialize data function
    var returnArray = {};
    for (var i = 0; i < formArray.length; i++) {
      returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnArray;
  },
  allElements: function (myCase, array, attr, money, text) {
    var size = array.length > 0 ? array.length : [];
    if (size > 0) {
      switch (myCase) {
        case 0:
          /* 22abaf.myshopify.com */
          array.forEach(function (value, index, array) {
            var count = text;
            if (!!value.classList.contains('sf-cart-count')) {
              var section_header = !!document.querySelector('section.sf-header') ? document.querySelector('section.sf-header') : '';
              if (!!section_header) {
                if (text > 0) {
                  section_header.classList.add('cart-has-items')
                } else {
                  section_header.classList.remove('cart-has-items')
                }
              };
            };
            if (value.hasAttribute('data-header-cart-count') == false) {
              var changeValue = 1;
              if (value.hasAttribute('x-text') == true || value.classList.contains('header--cart--count')) {
                if (text > 0) {
                  value.style.display = 'flex';
                }
                else {
                  value.style.display = 'none';
                }
              };
              if (value.classList.contains('js-cart-count') && (!value.classList.contains('text-indicator') && !value.classList.contains('quick-cart__indicator'))) {
                if (text <= 0) {
                  value.style.display = 'none';
                } else {
                  value.style.display = '';
                }
              };
              if (value.classList.contains('gt_cart--noti')) {
                if (text > 0) {
                  value.style.display = "block";
                } else {
                  value.style.display = "none";
                };
                return false;
              };
              if (value.classList.contains('cart-link__icon')) {
                var link_count = !!value.querySelector('.cart-link__count') ? value.querySelector('.cart-link__count') : '';
                if (!link_count) {
                  var a = !!value.querySelector('svg') ? value.querySelector('svg') : '';
                  if (!!a) {
                    a.insertAdjacentHTML('afterend', `<span class="cart-link__count">${text}</span>`);
                  }
                }
              }
              else {
                var parentElement = value.parentElement || '';
                if (!!parentElement) {
                  if (parentElement.classList.contains('number-wrapper')) {
                    var thisDisplay = window.getComputedStyle(parentElement).getPropertyValue('display');
                    if (text > 0) {
                      if (thisDisplay === 'none') {
                        parentElement.style.setProperty('display', 'inline', 'important');
                      }
                    } else {
                      parentElement.style.setProperty('display', 'none', 'important');
                    }
                  };
                };


                if (typeof value.parentNode !== 'undefined') {
                  var parent1 = value.parentNode || '';
                  if (!!parent1) {
                    if (!!parent1.classList.contains('cart-link__bubble')) {
                      if (typeof parent1.parentNode !== 'undefined') {
                        var parent2 = parent1.parentNode;
                        if (parent2.classList.contains('cart-link')) {
                          var parent3 = parent2.parentNode;
                          if (typeof parent3.parentNode !== 'undefined') {
                            if (parent3.getAttribute("aria-controls") != null) {
                              if (parent3.getAttribute("aria-controls") === 'CartDrawer') {
                                if (text > 0) { document.querySelector('body').classList.add('cart-has-items') } else { document.querySelector('body').classList.remove('cart-has-items') }
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
                if (typeof value.parentElement !== 'undefined') {
                  var parent2 = value.parentElement || '';
                  if (!!parent2) {
                    if (parent2.classList.contains('cart--external--icon')) {
                      if (parent2.getAttribute('data-item-count') != null) {
                        parent2.setAttribute('data-item-count', text)
                      };
                    };
                    if (parent2.classList.contains('header--cart-toggle')) {
                      var parent3 = parent2.parentElement || '';
                      if (!!parent3) {
                        if (parent3.classList.contains('cart--external--icon') && parent3.getAttribute('data-item-count') != null) {
                          parent3.setAttribute('data-item-count', text)
                        };
                      };
                    };
                  };
                };
                if (value.classList.contains('num') && value.localName === 'span') {
                  if (text > 0) {
                    //value.style.display = "inline-block";
                    value.style.display = null;
                  } else {
                    value.style.display = "none";
                  };
                };
                if (!!value.querySelector('cart-counter')) {
                  changeValue = 0;
                };

                if (!!value.classList.contains('cart-link__bubble')) {
                  if (value.innerText === '') {
                    changeValue = 0;
                  };
                }
                if (!!value.tagName && value.tagName === 'CART-COUNT') {
                  if (count > 0) {
                    count = `<div class="cart-count ">
                        <span aria-hidden="true">${text}</span>
                      </div>`
                  } else {
                    count = '';
                  };
                };

                if (typeof value.dataset.cartCount !== 'undefined') {
                  if (value.dataset.cartCount !== '') {
                    if (!!value.classList.contains('header--cart-toggle') && typeof value.dataset.drawerOpen !== 'undefined' && !!value.querySelector('svg.icon--root')) {
                      changeValue = 0;
                      value.dataset.cartCount = count;
                    };
                  }
                };

                if (value.hasAttribute('data-cart-count') && (!!value.querySelector('svg.icon--cart') || !!value.querySelector('svg.icon--bag'))) {
                  changeValue = 0;
                  value.dataset.cartCount = count;
                };


                if (!!changeValue) {
                  if (!!value.querySelector('span.cart-count-number')) {
                    value = value.querySelector('span.cart-count-number');
                  };
                  if (!!value.querySelector('span.cart-link__count')) {
                    value = value.querySelector('span.cart-link__count');
                  };
                  if (!!value.classList.contains('cart-link__bubble')) {
                    if (!!value.querySelector('span.cart-link__bubble-num')) {
                      value = value.querySelector('span.cart-link__bubble-num');
                    };
                  };
                  if (value.nodeName) {
                    if (value.nodeName === 'EM') {
                      if (value.parentElement) {
                        if (value.parentElement.querySelector('.header-cart-count[data-header-cart-count]')) {
                          value = value.parentElement.querySelector('.header-cart-count[data-header-cart-count]')
                        };
                      };
                    };
                  };

                  if (value.id === 'cartCount') {
                    if (count > 0) {
                      value.classList.remove('hidden-count');
                    } else {
                      value.classList.add('hidden-count');
                    };
                  };

                  if (value.classList.contains('header--cart')) {
                    if (!!value.querySelector('.icon--bag')) {
                      return false;
                    };
                  };

                  if (value.classList.contains('cart-count')) {
                    if (!!value.querySelector('.beside-svg[data-cart-count]')) {
                      return false;
                    };
                  };

                  value.innerHTML = count;
                };
              }
              var result = text;
              var parent3 = value.parentNode || '';
              if (!!parent3) {
                if (value.parentNode.classList.contains('header__cart-count')) {
                  if (result > 0) {
                    value.parentNode.classList.add('visible');
                  } else {
                    value.parentNode.classList.remove('visible');
                  };
                };
              }
              if (value.classList.contains('header-bar__cart-count') || (value.classList.contains('header-cart__bubble') && value.classList.contains('cartCount'))) {
                if (result > 0) {
                  value.classList.remove('hidden-count');
                }
                else {
                  value.classList.add('hidden-count');
                };
              };
              if (value.classList.contains('cart-item-count-header--quantity')) {
                if (result > 0) {
                  value.classList.remove('hide');
                }
                else {
                  value.classList.add('hide');
                };
              };
              if (value.classList.contains('cartCount')) {
                if (value.getAttribute('cart-count') !== null) {
                  if (result > 0) {
                    value.classList.add('shown')
                  }
                  else {
                    value.classList.remove('shown')
                  };
                };
              };

              var parent4 = value.parentNode || '';
              if (!!parent4) {
                if (value.parentNode.classList.contains('opacity-100') || value.parentNode.classList.contains('opacity-0')) {
                  if (result > 0) {
                    value.parentNode.classList.remove('opacity-0');
                    value.parentNode.classList.add('opacity-100');
                  } else {
                    value.parentNode.classList.remove('opacity-100');
                    value.parentNode.classList.add('opacity-0');
                  };
                };
              };
              if (!!value.querySelector('cart-counter')) {
                var thisElement = value.querySelector('cart-counter');
                if (!!thisElement.classList.contains('#cart-counter')) {
                  thisElement.innerHTML = result;
                  if (result > 0) {
                    thisElement.classList.add('!animate');
                    thisElement.removeAttribute("hidden", "");
                    setTimeout(function () {
                      thisElement.classList.remove('!animate');
                    }, 2000);
                  } else {
                    thisElement.setAttribute("hidden", "");
                  };
                };
                if (!!value.querySelector('cart-total')) {
                  if (typeof money !== 'undefined' || money != null) {
                    var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
                    span_money = span_money.replace('<span class=money>', '').replace('</span>', '');
                    if (!!value.querySelector('cart-total').querySelector('span')) {
                      value.querySelector('cart-total').querySelector('span').innerHTML = span_money;
                    };
                  };
                };
              };
            } else {
              var condition = false;
              if (value.classList.contains('header-cart-count')) {
                condition = true;
              };
              if (value.classList.contains('icon-button__label')) {
                condition = true;
              };
              var after = window.getComputedStyle(value, ':after');
              if (typeof after !== 'undefined' || after != null) {
                if (!after.content) {
                  condition = true;
                };
              };

              if (!!condition) {
                text > 0 ? text = text : text = '';
                value.innerHTML = text;
              };
            };
          });
          break;
        case 1:
          if (!!attr) {
            array.forEach(function (value, index, array) {
              if (text > 0) {
                value.classList.add('visible');
              }
              else {
                value.classList.remove('visible');
              }
              value.setAttribute(attr, text);
            });
          }
          break;
        case 2:
          array.forEach(function (value, index, array) {
            var result = text;
            value.innerHTML = ''
            if (result <= 0) {
              value.classList.add('hide');
            }
            else {
              value.classList.remove('hide')
            }
          });
          break;
        case 100:
          array.forEach(function (value, index, array) {
            var child = value.querySelector('span[data-cart-count]') || !!value.querySelector('.cart-products-count') || !!value.querySelector('#CartCount');
            if (!!child) {
              text = text.replace('(', '').replace(')', '');
              if (text > 0) {
                value.classList.remove('hide-count');
              } else {
                value.classList.add('hide-count');
              }
              child.innerHTML = text;
            } else {
              if (!value.hasAttribute('data-cart-count') && value.id !== 'CartCount') {
                value.innerHTML = text;
              }
              if (!value.hasAttribute('data-cart-count-bubble') && value.id !== 'CartCount') {
                value.innerHTML = text;
              }
              if (!!value.hasAttribute('data-header-cart-count')) {
                text = text.replace(' ', '');
                text = text.replace(' ', '');
                value.innerHTML = text;
              }
            };
          });

          break;
        case 101:
          array.forEach(function (value, index, array) {
            value.querySelectorAll('.site-header__cart-count').forEach(function (value, index, array) {
              !!value.querySelectorAll('span')[0] ? value.querySelectorAll('span')[0].innerHTML = text : '';
            });
            const classNames = ['bounce', 'animated', 'infinite']
            if ((!!value.classList.contains('bounce') && !!value.classList.contains('animated') && !!value.classList.contains('infinite')) || !!value.classList.contains('no_anim')) {
              if (text > 0) {
                value.classList.remove('no_anim');
                value.classList.add("bounce", "animated", "infinite");
              }
              else {
                value.classList.add('no_anim');
                value.classList.remove("bounce", "animated", "infinite");
              }
            };
            if (!!value.querySelector('.icon__fallback-text') && !value.querySelector('.site-header__cart-indicator')) {
              if (text > 0) {
                if (!value.querySelector('#CartCount')) {
                  value.insertAdjacentHTML('beforeend', `<div id="CartCount" class="site-header__cart-count">
                            <span>${text}</span>
                            <span class="icon__fallback-text medium-up--hide">item</span>
                            </div>`)
                };
              }
              else {
                if (!!value.querySelector('#CartCount')) {
                  value.querySelector('#CartCount').remove();
                }
              };
            };
            if (!!value.querySelector('#CartCost')) {
              if (typeof money !== 'undefined' || money != null) {
                var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
                span_money = span_money.replace('<span class=money>', '').replace('</span>', '');
                value.querySelector('#CartCost').innerHTML = span_money;
              };
            };
          });
          break;
        case 102:
          array.forEach(function (value, index, array) {
            var result = text;
            if (result <= 0) {
              value.classList.remove('cart-bubble--visible')
            }
            else {
              value.classList.add('cart-bubble--visible')
            }
          });
          break;
        case 103:
          array.forEach(function (value, index, array) {
            var result = text;
            if (result <= 0) {
              value.closest('#CartCount').classList.add('hide')
              value.innerHTML = '';
            }
            else {
              value.closest('#CartCount').classList.remove('hide')
              value.innerHTML = result;
            }

          });
          break;
        case 104:
          /* store-vena.myshopify.com */
          array.forEach(function (value, index, array) {
            var result = text;
            if (typeof value.getAttribute("id") !== 'undefined') {
              if (value.getAttribute("id") === 'numberItemsInCart') {
                value.innerHTML = result;
              };
            };
            if (result <= 0) {
              value.classList.remove('cart-link__bubble--visible')
            }
            else {
              value.classList.add('cart-link__bubble--visible')
            }

          });
          break;
        case 105:
          array.forEach(function (value, index, array) {
            var result = text;
            var span_selector = value.querySelectorAll('span').length > 0 ? value.querySelectorAll('span') : [];
            if (span_selector.length = 2) {
              span_selector.forEach(function (val) {
                if (!!val.getAttribute('data-js-cart-count-desktop')) {
                  val.setAttribute('data-js-cart-count-desktop', result);
                  var text_count = val.textContent;
                  var init = text_count.indexOf('(');
                  var fin = text_count.indexOf(')') + 1;
                  text_count = text_count.substring(init, fin);
                  text_count = val.textContent.replace(text_count, '(' + result + ')');
                  val.innerHTML = text_count;
                };
                if (!!val.getAttribute('data-js-cart-count-mobile')) {
                  val.setAttribute('data-js-cart-count-mobile', result);
                  val.innerHTML = result
                };
              });
            };
          });
          break;
        case 106:
          array.forEach(function (value, index, array) {
            var result = text;
            var child_element = value.querySelector('#CartCount') || '';
            if (!!child_element) {
              child_element.innerHTML = result;
            };
            if (value.textContent !== '' && !child_element) {
              value.innerHTML = result;
            };
            if (result <= 0) {
              value.classList.remove('is-visible')
            }
            else {
              value.classList.add('is-visible')
            }
          });
          break;
        case 107:
          array.forEach(function (value, index, array) {
            var result = text;
            if (result <= 0) {
              value.classList.remove('site-header__cart-bubble--visible')
            }
            else {
              value.classList.add('site-header__cart-bubble--visible')
            }
          });
          break;
        case 108:
          array.forEach(function (value, index, array) {
            var result = text;
            if (result <= 0) {
              value.classList.remove('has-cart-count')
            }
            else {
              value.classList.add('has-cart-count')
            }
          });
          break;
        case 109:
          array.forEach(function (value, index, array) {
            var result = text;
            value.innerHTML = result;
            if (result <= 0) {
              value.classList.add('hide')
            }
            else {
              value.classList.remove('hide')
            }
          });
          break;
        case 110:
          array.forEach(function (value, index, array) {
            var result = text;
            result > 0 && result < 10 ? result = '0' + result : result
            value.innerHTML = `<span id="CartCount">${result}</span>`;
          });
          break;
        case 111:
          /* 22abaf.myshopify.com */
          var result = text;
          array.forEach(function (value, index, array) {
            if (!!value.querySelector('.hd-Navigation_Item-icon')) {
              return false;
            };
            if (!!value.querySelector('.cart-count-bubble.with__count')) {
              return false;
            };
            if (!!value.querySelector('.cart-count-bubble')) {
              return false;
            };
            if (!!value.querySelector('span.cart-icontxt-btn') || !!value.querySelector('span.icon.icon-cart')) {
              var result2 = result;
              if (!!value.querySelector('span.icon.icon-cart')) {
                result2 = `(${result})`;
              };
              var cart_count_bubble = value.querySelector('.cart-count-bubble') || '';
              if (cart_count_bubble) {
                if (result > 0) {
                  cart_count_bubble.querySelector('span').innerHTML = result2;
                } else {
                  cart_count_bubble.remove();
                };
              } else {
                if (result > 0) {
                  value.insertAdjacentHTML('beforeend', `
                    <div class="cart-count-bubble"><span aria-hidden="true">${result2}</span><span class="visually-hidden">${result} item</span>
                    </div>`
                  );
                };
              };
              return false;
            };

            var svg = !!value.querySelector('svg') && value.querySelector('svg');
            var img = !!value.querySelector('img') ? value.querySelector('img') : '';
            var icon = !!value.querySelector('svg#Layer_1') ? value.querySelector('svg#Layer_1') : '';
            var visually_hidden = !!value.querySelector('span.visually-hidden') ? value.querySelector('span.visually-hidden') : '';
            if (!!svg) {
              svg = svg.outerHTML
            };
            var cart_count_bubble = !!value.querySelector('.cart-count-bubble') ? value.querySelector('.cart-count-bubble') : '';
            if (result > 0) {
              if (!!icon || (!!img && !!visually_hidden)) {
                !!cart_count_bubble ? cart_count_bubble.remove() : '';
                value.insertAdjacentHTML('beforeend', `<div class="cart-count-bubble"><span aria-hidden="true">${result}</span><span class="visually-hidden">${result} item</span></div>`);
                return false;
              };
              if (!svg) {
                svg = `<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                            <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
                            </svg>`
              };
              value.innerHTML =
                `${svg}
                          <span class="visually-hidden">Cart</span>
                          <div class="cart-count-bubble">
                            <span aria-hidden="true">${result}</span>
                            <span class="visually-hidden">${result} item</span>
                          </div>`;
            } else {
              if (!!icon || (!!img && !!visually_hidden)) {
                !!cart_count_bubble ? cart_count_bubble.remove() : '';
                return false;
              };
              if (!svg) {
                svg = `<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                            <path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"></path>
                            </svg>`
              };
              value.innerHTML =
                `${svg}
                          <span class="visually-hidden">Cart</span></a>`
            }
          });
          break;
        case 112:
          array.forEach(function (value, index, array) {
            var result = text;
            var span_ = !!value.querySelector('[data-header-cart-count]') ? value.querySelector('[data-header-cart-count]') : '';
            var span__ = !!value.querySelector('[data-header-cart-full]') ? value.querySelector('[data-header-cart-full]') : '';

            var span___ = !!value.querySelector('.header__cart__status[data-cart-count]') ? value.querySelector('.header__cart__status[data-cart-count]') : '';
            if (!!span_) {
              span_.setAttribute('data-header-cart-count', result);
              span_.innerHTML = `(${result})`
            };
            if (!!span___) {
              span___.dataset.cartCount = result
              span___.innerHTML = `${result}`
            };
            if (!!span__) {
              if (result > 0) {
                span__.setAttribute('data-header-cart-full', 'true');
              }
              else {
                span__.setAttribute('data-header-cart-full', 'false')
              }
            };
            let header_parent = value.closest('header.theme__header[data-header-height]') || '';
            if (!!header_parent) {
              let div_header_inner = header_parent.querySelector('.header__inner') || '';
              if (!!div_header_inner) {
                if (typeof div_header_inner.dataset.headerCartFull !== 'undefined') {
                  if (result > 0) {
                    div_header_inner.setAttribute('data-header-cart-full', 'true');
                  }
                  else {
                    div_header_inner.setAttribute('data-header-cart-full', 'false')
                  };
                };
              };
            };
          });
          break;
        case 113:
          array.forEach(function (value, index, array) {
            var result = text;
            if (result < 1) {
              value.classList.add('cartToggle--empty')
            }
            else {
              value.classList.remove('cartToggle--empty')
            }

          });
          break;
        case 114:
          array.forEach(function (value, index, array) {
            var result = text;
            if (!!value.classList.contains('money')) {
              if (result > 0) {
                value.innerHTML = result / 100;
              } else {
                value.innerHTML = '0.00'
              }
              return false;
            };
            value.innerHTML = hsonslidecart.Currency.formatMoney(result, slideData.settings.devices.money_format)
          });
          break;
        case 115:
          array.forEach(function (value, index, array) {
            var result = text;
            value.insertAdjacentHTML("beforeend", `<span class="cart__count">(${result})</span>`);
          });
          break;
        case 116:
          array.forEach(function (value, index, array) {
            var result = text;
            var external_icon = !!value.querySelector('span.cart--external--icon') ? value.querySelector('span.cart--external--icon') : ''
            if (!!external_icon) {
              if (!!external_icon.dataset.itemCount) {
                external_icon.dataset.itemCount = result;
                if (!!external_icon.querySelector('span.cart--external--total-items')) {
                  external_icon.querySelector('span.cart--external--total-items').innerHTML = result;
                }
              }
            }
            else {
              value.innerHTML = result
            }
          });
          break;
        case 117:
          array.forEach(function (value, index, array) {
            var result = text;
            if (!!value.querySelector('.header--cart-number')) {
              var element = value.querySelector('.header--cart-number');
              if (!!element.dataset.itemCount) {
                element.dataset.itemCount = result;
                if (!!element.querySelector('span.cart--external--total-items')) {
                  element.innerHTML = `(<span class="cart--external--total-items">${result}</span>)`;
                }
              };
            }
          });
          break;
        case 118:
          array.forEach(function (value) {
            var result = text;
            if (result > 0) {
              value.innerHTML = result;
              value.classList.remove('hidden');
            }
            else {
              value.classList.add('hidden');
            }
          });
          break;
        case 119:
          array.forEach(function (value, index, array) {
            var result = text;
            if (result > 0) {
              value.classList.add('items-in-cart');

            }
            else {
              value.classList.remove('items-in-cart');
            }
          });
          break;
        case 120:
          array.forEach(function (value, index, array) {
            if (window.location.pathname === '/cart') {
              return false;
            };
            var result = text;
            var stickyCartcontent = !!document.querySelector('#StickyCart.sticky-cart') ? document.querySelector('#StickyCart.sticky-cart') : '';
            var nav_menu = !!document.querySelector('.site-nav__thumb-menu') ? document.querySelector('.site-nav__thumb-menu') : '';
            var thisBody = !!document.querySelector('body') ? document.querySelector('body') : '';
            if (!!stickyCartcontent && !!nav_menu) {
              if (result > 0) {
                let stickyItem = !!value.querySelector('a[href*=cart]#StickyItems') ? value.querySelector('a[href*=cart]#StickyItems') : '';
                let stickySubtotal = !!value.querySelector('#StickySubtotal') ? value.querySelector('#StickySubtotal') : '';
                if (!!stickyItem) {
                  let textItem = stickyItem.innerHTML;
                  let numItem = parseInt(textItem);
                  textItem = isNaN(numItem) ? textItem : textItem.replace(numItem, result);
                  stickyItem.innerHTML = textItem;
                };
                if (!!stickySubtotal) {
                  if (typeof money !== 'undefined' || money != null) {
                    var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
                    stickySubtotal.innerHTML = span_money;
                  };
                };
                if (!!thisBody) {
                  thisBody.classList.add('body--sticky-cart-open');
                };
                stickyCartcontent.classList.add('sticky-cart--open');
                nav_menu.classList.add('site-nav__thumb-menu--inactive');
              } else {
                if (!!thisBody) {
                  thisBody.classList.remove('body--sticky-cart-open');
                };
                stickyCartcontent.classList.remove('sticky-cart--open');
                nav_menu.classList.remove('site-nav__thumb-menu--inactive');
              };
            };
          });
          break;
        case 121:
          var result = text;
          array.forEach(function (value) {
            var cart_count = !!value.querySelector('.cart-count') ? value.querySelector('.cart-count') : '';
            if (!cart_count) {
              if (result > 0) {
                value.insertAdjacentHTML('afterbegin', `<div class="cart-count">
                          <span>${result}</span>
                        </div>`);
              };
            } else {
              if (result > 0) {
                if (!!cart_count.querySelector('span')) {
                  cart_count.querySelector('span').innerHTML = result
                };
              } else {
                cart_count.remove();
              }
            };
          });
          break;
        case 122:
          var result = text;
          array.forEach(function (value) {
            if (!!value.classList.contains('cart-button__count')) {
              value.innerHTML = result;
            };
            if (!!value.classList.contains('cart-button__total') && !!value.classList.contains('money')) {
              if (result > 0) {
                value.innerHTML = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
              } else {
                value.innerHTML = '';
              };
            };
          });
          break;
        case 123:
          array.forEach(function (value) {
            if (!!value.classList.contains('cart__toggle')) {
              if (text > 0) {
                value.classList.add('cart__toggle--has-items');
              } else {
                value.classList.remove('cart__toggle--has-items');
              }
            };
          });
          break;
        case 124:
          var result = text;
          array.forEach(function (value) {
            if (result > 0) {
              value.classList.remove('opacity-0');
            } else {
              value.classList.add('opacity-0');
            };
            value.innerHTML = result;
          });
          break;
        case 125:
          var result = text;
          array.forEach(function (value) {
            if (typeof value.innerHTML.toLowerCase() !== 'undefined') {
              if (value.innerHTML.toLowerCase().indexOf('cart') == -1) {
                if (result > 0) {
                  if (!value.previousSibling.getAttribute('x-show')) {
                    value.insertAdjacentHTML('beforebegin', `<span x-show="$store.cart_count.count > 0" class="tracking-normal absolute -bottom-1.5 -right-1.5 w-5 h-5 bg-scheme-text text-scheme-background rounded-full text-[0.625rem] flex items-center justify-center" x-text="$store.cart_count.count" style="display:none;">${result}</span>`);
                    setTimeout(function () {
                      if (value.previousSibling.style.display === 'none') {
                        value.previousSibling.style.display = 'flex'
                        value.previousSibling.innerHTML = result
                      }
                    }, 1000);
                  } else {
                    value.previousSibling.innerHTML = result
                  };
                } else {
                  if (!!value.previousSibling.getAttribute('x-show')) {
                    value.previousSibling.remove();
                  };
                };
                value.innerHTML = result;
              };
            };
          });
          break;
        case 126:
          var result = text;
          array.forEach(function (value) {
            value.innerHTML = result;
            if (result > 0) {
              value.style.display = '';
            } else {
              value.style.display = 'none';
            };
          });
          break;
        case 127:
          var result = text;
          array.forEach(function (value) {
            var thisMoney = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
            if (value.classList.contains('cartCost')) {
              if (result > 0) {
                value.classList.remove('hidden-count');
              } else {
                value.classList.add('hidden-count');
              };
              thisMoney = `(${thisMoney})`;
            };
            value.innerHTML = thisMoney;
          });
          break;
        case 128:
          var result = text;
          array.forEach(function (value) {
            if (result > 0) {
              value.style = "";
            } else {
              value.style.display = "none";
            };
          });
          break;
        case 129:
          var result = text;
          array.forEach(function (value) {
            if (result > 0) {
              !!value.querySelector('.cart-count-bubble') ? value.querySelector('.cart-count-bubble').remove() : '';
              value.insertAdjacentHTML('beforeend', `<span class="cart-count-bubble hs-cart-count"><span aria-hidden="true">${result}</span><span class="visually-hidden">${result}</span></span>`);
            } else {
              if (!!value.querySelector('.cart-count-bubble')) {
                value.querySelector('.cart-count-bubble').remove();
              }
            };
          });
          break;
        case 130:
          const result_ = text;
          var html_ = document.querySelector('html') || '';
          array.forEach(function (value, index, array) {
            value.innerHTML = result_;
            if (result_ > 0) {
              value.removeAttribute('hidden');
            }
            else {
              value.setAttribute('hidden', '');
            };

            if (value.classList.contains('cart-count')) {
              result_ > 99 ? (value.innerHTML = '<span class="text-sm">99+</span>',
                value.classList.add('cart-count--small-medium')) : (value.classList.remove('cart-count--small-medium'));
              if (result_ > 0) {
                html_.classList.add('cart-has-items');
              }
              else {
                html_.classList.remove('cart-has-items');
              };
            };
          });
          break;
        case 131:
          array.forEach(function (value, index, array) {
            value.innerHTML = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format)
          });
          break;
        case 132:
          var result = text;
          array.forEach(function (value, index, array) {
            var img = value.querySelector('img') || '';
            if (img) {
              value.innerHTML = '';
              value.appendChild(img);
              value.insertAdjacentHTML('beforeend', result);
            };
          });
          break;
        case 133:
          var result = text;
          array.forEach(function (value, index, array) {
            var span_count = value.querySelector('span.cart-blip') || '';
            span_count ? span_count.innerHTML = result : '';
            if (result > 0) {
              value.classList.add('has-blip-visible');
              span_count ? span_count.removeAttribute('hidden') : '';
            } else {
              value.classList.remove('has-blip-visible');
              span_count ? span_count.setAttribute('hidden', 'true') : '';
            };
          });
          break;
        case 134:
          var result = text;
          array.forEach(function (value, index, array) {
            var counter = value.querySelector('.mini-cart-icon sup .bigcounter');
            var total_cart = value.querySelector('.shopping-cart__total');
            if (counter) {
              counter.innerHTML = result;
            };
            if (total_cart) {
              if (typeof money !== 'undefined' || money != null) {
                var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
                total_cart.innerHTML = span_money;
              };

            };
          });
          break;
        case 135:
          var result = text;
          array.forEach(function (value, index, array) {
            value.innerHTML = result;
            if (result > 0) {
              value.classList.remove("m:hidden");
            } else {
              value.classList.add("m:hidden");
            };
          });
          break;
        case 136:
          var result = text;
          array.forEach(function (value, index, array) {
            if (typeof money !== 'undefined' || money != null) {
              var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
              value.innerHTML = span_money;
            };
          });
          break;
        case 137:
          array.forEach(function (value, index, array) {
            value.innerHTML = text;
          });
          break;
        case 138:
          var result = text;
          array.forEach(function (value, index, array) {
            if (value.querySelector('span.display--hidden')) {
              let cart_count = value.querySelector('.site-header__cart-count') || '';
              let count_item_text = `<div class="site-header__cart-count color--bg-primary" bis_skin_checked="1"><span aria-hidden="true">${result}</span><span class="display--hidden">${result} items </span></div>`;

              switch (result) {
                case 0:
                  if (cart_count) {
                    cart_count.remove();
                  };
                  break;
                default:
                  if (cart_count) {
                    cart_count.remove();
                  };
                  value.insertAdjacentHTML("beforeend", count_item_text);
                  break;
              }
            };
          });
          break;
        case 139:
          var result = text;
          array.forEach(function (value, index, array) {
            if (value.querySelector('img[alt="Cart"]') || value.querySelector('img[alt="Account"]')) {
              let cart_count = value.querySelector('.badge') || '';
              let count_item_text = `<p class="badge"><span class="badge-counter">${result}</span></p>`;
              if (cart_count) {
                cart_count.remove();
              };
              if (result > 0) {
                value.insertAdjacentHTML("beforeend", count_item_text);
              };
            };
          });
          break;
        case 140:
          array.forEach(function (value, index, array) {
            if (typeof money !== 'undefined' || money != null) {
              value.innerHTML = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format)
            };
          });
          break;
        case 141:
          var result = text;
          array.forEach(function (value, index, array) {
            let current_cart = value.querySelector('.current-cart-icon.current-cart-icon--cart span.current-cart-count') || '';
            let current_cart_count = value.querySelector('.current-cart-icon.current-cart-icon--cart span.current-cart-count .inner-count') || '';
            if (result > 0) {
              if (current_cart) {
                if (current_cart_count) {
                  current_cart_count.innerHTML = result;
                }
              } else {
                value.insertAdjacentHTML("beforeend", `<span class="current-cart-count">
                    <span class="inner-count">
                      ${result}
                    </span>
                  </span>`);
              };
            } else {
              if (current_cart) {
                current_cart.remove();
              };
            };
          });
          break;
        case 142:
          var result = text;
          array.forEach(function (value, index, array) {
            let count = value.querySelector('span.mt-\\[1px\\]') || '';
            if (count) {
              count.innerHTML = result;
            }
            if (result > 0) {
              value.classList.remove('hidden');
            } else {
              value.classList.add('hidden')
            }
          });
          break;
        case 143:
          if (typeof money !== 'undefined' || money != null) {
            var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
            var result = text;
            array.forEach(function (value, index, array) {

              const element = value.querySelector('span.shopify-Price-amount');
              const newClass = [...element.classList];

              span_money = span_money.replace(/<span([^>]*)>/, (match, attributes) => {
                let newAttr = attributes;
                const matchClass = attributes.match(/class="([^"]*)"/);
                if (matchClass) {
                  const classAct = matchClass[1].split(' ');
                  const allClass = [...new Set([...classAct, ...newClass])];
                  newAttr = newAttr.replace(/class="[^"]*"/, `class="${allClass.join(' ')}"`);
                } else {
                  newAttr += ` class="${newClass.join(' ')}"`;
                }

                return `<span${newAttr}>`;
              });

              value.innerHTML = span_money;
            });
          };
          break;
        case 144://CAMBIO
          if (typeof money !== 'undefined' || money != null) {
            var span_money = hsonslidecart.Currency.formatMoney(money, slideData.settings.devices.money_format);
            var result = text;
            array.forEach(function (value, index, array) {

              const element = value.querySelector('span.t4s-h-cart__total');
              const newClass = [...element.classList];

              span_money = span_money.replace(/<span([^>]*)>/, (match, attributes) => {
                let newAttr = attributes;
                const matchClass = attributes.match(/class="([^"]*)"/);
                if (matchClass) {
                  const classAct = matchClass[1].split(' ');
                  const allClass = [...new Set([...classAct, ...newClass])];
                  newAttr = newAttr.replace(/class="[^"]*"/, `class="${allClass.join(' ')}"`);
                } else {
                  newAttr += ` class="${newClass.join(' ')}"`;
                }
                return `<span${newAttr}>`;
              });

              value.innerHTML = span_money;
            });
          };
          break;
        case 145:
          var result = text;
          array.forEach(function (value, index, array) {
            let innerText = '';
            if (result > 0) {
              innerText = `<span class="header__cart__icon-count">${result}</span>
                            <span class="visually-hidden" aria-hidden="true">${result} item in cart</span>`;
            };
            value.innerHTML = innerText;
          });
          break;
        case 146:
          var result = text;
          array.forEach(function (value, index, array) {
            let cart_bubble = value.querySelector('.cart-bubble[ref="cartBubble"]') || '';
            let text_count = value.querySelector('.cart-bubble__text-count[ref="cartBubbleCount"]') || '';
            if (cart_bubble && text_count) {
              text_count.innerHTML = result > 99 ? '' : result;
              if (result > 0) {
                value.classList.add('header-actions__cart-icon--has-cart');
                cart_bubble.classList.remove('visually-hidden');
                text_count.classList.remove('hidden');
              } else {
                value.classList.remove('header-actions__cart-icon--has-cart');
                cart_bubble.classList.add('visually-hidden');
                text_count.classList.add('hidden');
              }
            };
          });
          break;
      }
    }
  },
  countCart: function (json) {
    var result = json.item_count;
    // Custom Cart Drawer - Product count
    try {
      const language_settings = slideData.settings.language_settings ?? {};

      const productText =
        language_settings.product_language_settings ?? 'Product';

      const productsText =
        language_settings.products_language_settings ?? 'Products';

      const productCountText =
        `${result} ${result === 1 ? productText : productsText}`;

      document
        .querySelectorAll('.hs-sl-text-count-products')
        .forEach(function (element) {
          element.textContent = productCountText;
        });

    } catch (error) {
      console.log('HS product count error:', error);
    }
    var count1 = document.querySelectorAll(`#cartCount,
        .cart-link__bubble-num,
        .header__cart__count,
        .count-style.bigcounter,
        .Header__CartCount,
        .gt_cart-count,
        a[href*=cart] .cart_qty_cls,
        a .cartCount,
        a[href*=cart] .cart-link__count,
        #pageheader a[href*=cart] .cart-link__icon,
        a.icon-cart.cart-button span,
        a[href*=cart] .jsccount,
        a[href*=cart] .cart-count-bubble:not(.bubble-style--frame) span[aria-hidden="true"],
        .cart[aria-label="Cart"] div,
        [href="/cart"] [data-cart-item-count],
        span#CartCount,
        .CartCount,
        [data-cart-count],
        .tt-badge-cart,
        a[href*=cart] .count-holder .count,
        a[href*=cart] span.cart-count,
        a[href*=cart] .cart-btn__count,
        a[href*=cart] .Header__CartCount,
        a[href*=cart] .cart--external--total-items,
        a[href*=cart] .total_number_cart,
        a[href*=cart] .cart_count,
        a[href*=cart] span.item-num,
        header a[href*=cart] #cartItemCount,
        .counter-number,
        a[href*=cart] em,
        .header-cart__icon .header-cart__count,
        a[href*=cart] .cartCountSelector,
        .cart-item-count-header,
        .js-cart-count,
        .cart-target .n-item,
        .header__action-item-content .header__cart-count,
        header .pt-cart .pt-dropdown-toggle .pt-badge-cart,
        a[href*=cart] .site-header-cart--count,
        #gocart p a,
        #cart .checkout em,
        .item-count,
        #CartCount span,
        a[href*=cart] .site-header__cart-indicator,
        .hs-count-cart,
        #cart-count a,
        .cart_container a .cart_count,
        a[href*=cart] #CartToggleItemCount,
        a[href*=cart] .full-cart span,
        a[href*=cart] sub.cart_counter,
        a[href*=cart] p.amount.ammount-cart-number,
        header .cart_qty_cls,
        header a[href*=cart] .header__cart-count span,
        a[href*=cart] cart-count.header__cart-count,
        header .header-cart a[href*=cart] .header-cart__count,
        .docked-navigation-container .header-cart a[href*=cart] .header-cart__count,
        a[data-node-type="commerce-cart-open-link"] div,
        header #headerBorderWrap #headerContainer button#CartButton span[x-text="$store.cart_count.count"],
        header .single-icon.cart a span.count,
        header-root a.header--cart-link .cart--external--icon .cart--external--total-items,
        header #site-menu .container .hdrOptions .cart .num,
        header .header a[href*="/cart"].icon-cart .icon-cart__total,
        header-component a[href*=cart] cart-count,
        header .minicart__button span.item__count,
        div[class="#header-main"] cart-drawer-trigger,
        div[data-section-type="header"] .links a.cart[href*="cart"] div,
        header li.header-cart .header-cart-count,
        header .gt_show-cart span.gt_cart--noti,
        .header__icons .header__icon--cart .cart-count-bubble span[aria-hidden="true"],
        header#header a[href*="cart"] span.header--cart--count,
        header .header_cart  .header_cart_items,
        header a[href*=cart] span[data-js-cart-count],
        header a[href*=cart] span.sf-cart-count,
        .footer-mobile__common a[href*=cart] span.sf-cart-count,
        header .headerCart .cartCount,
        header a[href*=cart] .number.js-cart-item-count,
        header a[href*=cart] span.cart-link .cart-link__bubble,
        header.site-header a[href*=cart] ~ span.header-cart__bubble.cartCount,
        header x-header.header a[href*=cart] cart-count,
        header#header a[href*=cart]#cart-drawer-toggle .thb-item-count,
        a[href*=cart].oob-cart-link .cart-count-bubble,
        header-section a[href*=cart]#cart-icon-button [data-cart-button-count],
        header .header_cart a[href*=cart] #cart_items,
        header .maxus-bags__quantity.enj-cartcount,
        header a#cart-icon-bubble[href*=cart] .cart-count.h-count,
        header .go-cart__trigger .js-go-cart-counter,
        header.header #cart-icon-bubble .headcart span#Cartcount,
        header.header button[name="cart-open"]#cart-open .cart-count,
        header a[href$="/cart"].header__cart-link.header__cart-link span.cart-number.cart-number--header,
        a[href$="#"].bt-sidebar-btn.cart-sidebar-trigger[data-target="#bt-sidebar-cart"] span.cart-number,
        a[href$="#"].por.header__cart-trigger-mobile[data-target="#bt-sidebar-cart"] span.cart-number.abs-number,
        a[href$="/cart"].bt-sidebar-btn[data-target="#bt-sidebar-cart"] span.cart-number.abs-number.bmt__abs-number,
        .header__cart a[href*=cart].cart__link .cart__count,
        header [data-new-layout-header] button.new-layout-header__actions-cart span[data-cart-render="item_count"],
        header-root .header--cart .cart--external--icon .cart--external--total-items,
        theme-header a[href*=cart]#cart-drawer-toggle span.float_count,
        header hdt-sticky-header a[href*=cart].hdt-has-count-box hdt-cart-count.hdt-count-box,
        header .goodveda_h_header-account-cart a[href$="/cart"] .goodveda_h_header__quantity,
        .header-sticky-wrapper #HeaderWrapper header#SiteHeader a .cart-link .cart-link__bubble,
        header .header-container .header-content a[href] .number.js-cart-items-count,
        main-header .\\#main-header-inner .\\#main-header-toolbar a[href$="/cart"] .\\#main-header-toolbar-link-icon,
        #shopify-section-header s-header.site-header ul li ul li button[js-open-cart] span#cart-count[aria-label="Cart Quantity"],
        .toolbar-cart.header_cart a.cart.dropdown-link .number.num-set span
      `); //CAMBIO

    var count2 = document.querySelectorAll('.site-header__upper.page-width a[href*=cart] .site-header__cart-indicator, #StickyBar a[href*=cart] .site-header__cart-indicator');
    var count3 = document.querySelectorAll('.site-header__cart-count,.header-controls__cart-count,header .header-items a[href*=cart] .cart__count');
    var count4 = document.querySelectorAll('.site-header__cart, header.util .wrapper .right-wrapper a[href*=cart]#CartButton');
    var count5 = document.querySelectorAll('.cart-summary .cart-count');
    var count6 = document.querySelectorAll('.cart-count.cart-summary');
    var count7 = document.querySelectorAll('a[href*=cart] .site-header-cart--count');
    var count8 = document.querySelectorAll('.num-items-in-cart .block-cart');
    var count9 = document.querySelectorAll('.header-content-right .cart-count');
    var count10 = document.querySelectorAll('header a[href$="/cart"].site-header__cart.cart-link');
    var count11 = document.querySelectorAll('.site-header__icon.site-header__cart #CartCount span[data-cart-count]');
    var count12 = document.querySelectorAll('a[href*=cart] .cart-link__bubble,header .site-nav__link.cart-link .icon_cart_header .cart-link__bubble,header a.snl.sni_icon.cart-link .cart-link__bubble,header .site-nav__link.cart-link[aria-controls="CartDrawer"] .cart-link__bubble, .header-sticky-wrapper #HeaderWrapper header#SiteHeader a .cart-link .cart-link__bubble');//CAMBIO
    var count13 = document.querySelectorAll('header .header__line-top a[href*=cart]');
    var count14 = document.querySelectorAll('header .Header__Wrapper a[href*=cart] .Header__CartDot,header x-header.header a[href*=cart] cart-dot.header__cart-dot');
    var count15 = document.querySelectorAll('header .site-header-sections .site-header__section a[href*=cart] span.site-header__cart-bubble');
    var count16 = document.querySelectorAll('.header-cart.action-area__link');
    var count17 = document.querySelectorAll('.tt-cart button.tt-dropdown-toggle span.tt-badge-cart');
    var count18 = document.querySelectorAll('.site-header__cart.style_2 .site-header__cart-count');
    var count19 = document.querySelectorAll('a#cart-icon-bubble.header__icon.header__icon--cart.link.link--text.focus-inset,header a#cart-icon-bubble.header__icon.header__icon--cart:not(.site-header__cart--withcount), header a#cart-icon-bubble.mml_nav_cart_icon--link');
    var count20 = document.querySelectorAll(`a.navlink.navlink--cart,header a[href*=cart] span.header__cart__status`);
    var count21 = document.querySelectorAll('header .header__icons #cartTotal');
    var count22 = document.querySelectorAll('header .header-items span[data-cart-price], header a[href$="/cart"] #CartCost span.money');
    var count23 = document.querySelectorAll('header .header-items a[href*=cart]');
    var count24 = document.querySelectorAll('header-root .header--container a.header--cart-count span,header-root .header--container .cart-link a');
    var count25 = document.querySelectorAll('header .header--mobile--cart a.header--cart-link,header .header--cart a.header--cart-link');
    var count26 = document.querySelectorAll('header .main-items__cart .products-in-cart, header#header nav-header ul.header-nav-item-menu li.nav-cart-button drawer-button cart-count');
    var count27 = document.querySelectorAll('.links.site-control__inner a.cart .cart-icon--indicator');
    var count28 = document.querySelectorAll('#StickyCart form[action*=cart].sticky-cart__inner');
    var count29 = document.querySelectorAll(('header .m-header a.cart[href*="cart"]'));
    var count30 = document.querySelectorAll(('header a[href*="cart"] .cart-button__count,header a[href*="cart"] .cart-button__total.money'));
    var count31 = document.querySelectorAll('header a[href*=cart].cart__toggle');
    var count32 = document.querySelectorAll('header .header__cart-count cart-count');
    var count33 = document.querySelectorAll('body header #headerBorderWrap #headerContainer a[href*=cart] .visually-hidden, body header #headerBorderWrap #headerContainer button#CartButton .visually-hidden, .shopify-section #headerBorderWrap #headerContainer button.js-enabled#CartButton span.visually-hidden, data-island #headerContainer a[href*=cart] span.visually-hidden');
    var count34 = document.querySelectorAll('body header .shopping-cart button.header__cartButton .header__bubble');
    var count35 = document.querySelectorAll('header a[href*=cart] .js-cart-item-total, header a[href*=cart] .cartCost ');
    var count36 = document.querySelectorAll('header a[href*=cart] [data-color-scheme="header"]');
    var count37 = document.querySelectorAll('header cart-drawer details summary .header__icon,mobile-dock.mobile-dock .dock__item[data-action="cart"] p span#mobile-cart-icon-bubble');
    var count38 = document.querySelectorAll('nav ul li.nav-item a.cart-icon .cart-count-badge,nav .container a.cart-icon .cart-count-badge, header a[href*="cart"] cart-count.cart-count');
    var count39 = document.querySelectorAll('header .icon_cart  .js_cat_ttprice.ch_tt_price, header .header-container .header-content .js-money.js-cart-icon-total-money');//MONEY
    var count40 = document.querySelectorAll('header a[href*=cart] .hidden-phone,header a[href*=cart] .hidden-tablet-and-up');
    var count41 = document.querySelectorAll('header .header-content a.header-item__link[href="#drawer-cart"][role="button"]');
    var count42 = document.querySelectorAll('.mini-cart-icon a[href$="#ltn__utilize-cart-menu"].ltn__utilize-toggle');
    var count43 = document.querySelectorAll('header a[href*=cart].m-cart-icon-bubble .m-cart-count-bubble');
    var count44 = document.querySelectorAll('header.header #cart-icon-bubble .hcart .cart-tot');
    var count45 = document.querySelectorAll(`main-header .header-container a.area--cart.icon-button span[data-header-cart-count]`);
    var count46 = document.querySelectorAll('header #cart-icon-bubble drawer-opener button.button--icon .site-header__cart-indicator');
    var count47 = document.querySelectorAll('header .mobile-site-header .mobile-site-cart a[href*=cart],header .new-header-inner .head-social-box a[href*=cart]');
    var count48 = document.querySelectorAll('a[href*=cart] .cart-count-bubble.bubble-style--frame [aria-hidden="true"]');
    var count49 = document.querySelectorAll('a[href*=cart].current-cart.toggle-cart-summary span.current-cart-icon.current-cart-icon--cart');
    var count50 = document.querySelectorAll('header .pb-header .header-icon-cart a[href*=cart]#cart-icon .bg-\\[rgba\\(var\\(--colors-cart\\)\\)\\]');
    var count51 = document.querySelectorAll('header a[href*=cart] .basel-cart-totals .basel-cart-subtotal');
    var count52 = document.querySelectorAll('.t4s-container .t4s-site-nav__cart a[href*=cart] .t4s-h-cart-totals.t4s-dn');//CAMBIO
    var count53 = document.querySelectorAll('header height-calc header-component nav ul li button.js-element[drawer-to-open="cart-drawer"] div[header-cart-bubble]');
    var count54 = document.querySelectorAll('header header-actions cart-drawer-component.cart-drawer button cart-icon.header-actions__cart-icon, header header-actions a[href*=cart] cart-icon.header-actions__cart-icon');//ev1etc-31.myshopify.com, miracle-fort.myshopify.com


    if (count1.length > 0) {
      HsApp3.allElements(0, count1, null, json.total_price, result);
    }
    if (count2.length > 0) {
      HsApp3.allElements(2, count2, null, null, result);
    }
    if (count3.length > 0) {
      HsApp3.allElements(100, count3, null, null, result < 1 ? '' : '( ' + result + ' )');
    }
    if (count4.length > 0) {
      HsApp3.allElements(101, count4, null, json.total_price, result);
    }
    if (count5.length > 0) {
      HsApp3.allElements(0, count5, null, null, `
                <span class="cart-count__text">
                  Cart (${result})
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag">
                        <title>Cart</title>
                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <path d="M16 10a4 4 0 0 1-8 0"></path>
                </svg>`);
    }
    if (count6.length > 0) {
      HsApp3.allElements(0, count6, null, null, `
                <span class="cart-count__text">(${result})</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag">
                  <title>Cart</title>
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <path d="M16 10a4 4 0 0 1-8 0"></path>
                </svg>`);
    };
    if (count7.length > 0) {
      HsApp3.allElements(1, count7, "data-header-cart-count", null, result)
    };
    if (count8.length > 0) {
      HsApp3.allElements(0, count8, null, null, 'Cart (' + result + ')');
    };
    if (count9.length > 0) {
      HsApp3.allElements(0, count9, null, null, `<span class="cart-count-text">cart</span>
                (<span class="cart-count-number">${result}</span>)`);
    };
    if (count10.length > 0) {
      HsApp3.allElements(102, count10, null, null, result);
    };
    if (count11.length > 0) {
      HsApp3.allElements(103, count11, null, null, result);
    };
    if (count12.length > 0) {
      HsApp3.allElements(104, count12, null, null, result);
    };
    if (count13.length > 0) {
      HsApp3.allElements(105, count13, null, null, result);
    };
    if (count14.length > 0) {
      HsApp3.allElements(106, count14, null, null, result);
    };
    if (count15.length > 0) {
      HsApp3.allElements(107, count15, null, null, result);
    };
    if (count16.length > 0) {
      HsApp3.allElements(108, count16, null, null, result);
    };
    if (count17.length > 0) {
      HsApp3.allElements(109, count17, null, null, result);
    };
    if (count18.length > 0) {
      HsApp3.allElements(110, count18, null, null, result);
    };
    if (count19.length > 0) {
      HsApp3.allElements(111, count19, null, null, result);
    };
    if (count20.length > 0) {
      HsApp3.allElements(112, count20, null, null, result);
    };
    if (count21.length > 0) {
      HsApp3.allElements(113, count21, null, null, result);
    };
    if (count22.length > 0) {
      if (count23.length > 0 && count3.length == 0) {
        HsApp3.allElements(115, count23, null, null, result);
      };
      HsApp3.allElements(114, count22, null, null, json.total_price);
    };

    if (count24.length > 0) {
      HsApp3.allElements(116, count24, null, null, result);
    };

    if (count25.length > 0) {
      HsApp3.allElements(117, count25, null, null, result);
    };

    if (count26.length > 0) {
      HsApp3.allElements(118, count26, null, null, result);
    };

    if (count27.length > 0) {
      HsApp3.allElements(119, count27, null, null, result);
    };

    if (count28.length > 0) {
      HsApp3.allElements(120, count28, null, json.total_price, result);
    };

    if (count29.length > 0) {
      HsApp3.allElements(121, count29, null, null, result);
    };
    if (count30.length == 2 || count30.length == 4) {
      HsApp3.allElements(122, count30, null, json.total_price, result);
    };
    if (count31.length > 0) {
      HsApp3.allElements(123, count31, null, null, result);
    };
    if (count32.length > 0) {
      HsApp3.allElements(124, count32, null, null, result);
    };
    if (count33.length > 0) {
      HsApp3.allElements(125, count33, null, json.total_price, result);
    };
    if (count34.length > 0) {
      HsApp3.allElements(126, count34, null, json.total_price, result);
    };
    if (count35.length > 0) {
      HsApp3.allElements(127, count35, null, json.total_price, result);
    };
    if (count36.length > 0) {
      HsApp3.allElements(128, count36, null, json.total_price, result);
    };
    if (count37.length > 0) {
      HsApp3.allElements(129, count37, null, json.total_price, result);
    };
    if (count38.length > 0) {
      HsApp3.allElements(130, count38, null, json.total_price, result);
    };
    if (count39.length > 0) {
      HsApp3.allElements(131, count39, null, json.total_price, result);
    };
    if (count40.length > 0) {
      HsApp3.allElements(132, count40, null, json.total_price, result);
    };
    if (count41.length > 0) {
      HsApp3.allElements(133, count41, null, json.total_price, result);
    };
    if (count42.length > 0) {
      HsApp3.allElements(134, count42, null, json.total_price, result);
    };
    if (count43.length > 0) {
      HsApp3.allElements(135, count43, null, json.total_price, result);
    };
    if (count44.length > 0) {
      HsApp3.allElements(136, count44, null, json.total_price, result);
    };
    if (count45.length > 0) {
      HsApp3.allElements(137, count45, null, json.total_price, result);
    };
    if (count46.length > 0) {
      HsApp3.allElements(138, count46, null, json.total_price, result);
    };
    if (count47.length > 0) {
      HsApp3.allElements(139, count47, null, json.total_price, result);
    };
    if (count48.length > 0) {
      HsApp3.allElements(140, count48, null, json.total_price, result);
    };
    if (count49.length > 0) {
      HsApp3.allElements(141, count49, null, json.total_price, result);
    };
    if (count50.length > 0) {
      HsApp3.allElements(142, count50, null, json.total_price, result);
    };
    if (count51.length > 0) {
      HsApp3.allElements(143, count51, null, json.total_price, result);
    };
    if (count52.length > 0) {
      HsApp3.allElements(144, count52, null, json.total_price, result);//CAMBIO
    };
    if (count53.length > 0) {
      HsApp3.allElements(145, count53, null, json.total_price, result);//CAMBIO
    };
    if (count54.length > 0) {
      HsApp3.allElements(146, count54, null, json.total_price, result);//CAMBIO
    };
    //***********************************************************************************//
    var c = document.querySelector(".hs-sticky-cart-cart-drawer") ? document.querySelector(".hs-sticky-cart-cart-drawer") : "";
    if (!!c) {
      if (result > 0) {
        c.classList.remove("hs-hidden-count-cart");
      } else {
        if (parseInt(slideData.sticky_cart.sticky_cart_hide_empty)) {
          c.classList.add("hs-hidden-count-cart");
        } else {
          c.classList.remove("hs-hidden-count-cart");
        }
      }
    }

  },
  getMyCart: function (w) {
    if (!slideData.sticky_cart.enabled_sticky_cart) {
      return false;
    };
    var resultValidateDevice = HsApp1.validateDevice();
    switch (parseInt(resultValidateDevice)) {
      case 1:
        return false;
        break;
      case 3:
        return false;
        break;
    };
    fetch(`/cart.js?v=${(new Date).getTime()}`)
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then((json) => {
        if (typeof window.BOLD !== 'undefined'
          && typeof window.BOLD.common !== 'undefined'
          && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          json = window.BOLD.common.cartDoctor.fix(json);
        };

        if (json) {
          var ini = 0;
          var elementsProperties = ['_giftWrap', '_shippingProtection']
          if (elementsProperties.length > 0) {
            elementsProperties.forEach(function (element) {
              ini++;
              json = HsApp1.thisProperties(json, element)
            })
          };
          if (ini == elementsProperties.length) {
            !!document.getElementById("hsitemCount") ? document.getElementById("hsitemCount").innerHTML = json.item_count : '';
            HsApp3.countCart(json);
            if (typeof window.BOLD !== 'undefined'
              && typeof window.BOLD.common !== 'undefined'
              && typeof window.BOLD.common.eventEmitter !== 'undefined'
              && typeof window.BOLD.common.eventEmitter.emit !== 'undefined') {
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', json);
            }
          }
        };
      })
      .catch(err => {
        console.log(err)
      }).then(function () {
      });
  },
  closeModalQuickView: function () {
    function thisDispatch(element, event) {
      if (!!element) {
        var ev = new Event(event, { "bubbles": true, "cancelable": false });
        element.dispatchEvent(ev);
      };
    };
    try {
      var modal = !!document.querySelector('.modal--is-active') ? document.querySelector('.modal--is-active') : '';
      if (!!modal) {
        var button = !!modal.querySelector('.modal__close') ? modal.querySelector('.modal__close') : '';
        if (!!button) {
          thisDispatch(button, "click");
        };
      };
      modal = !!document.querySelector('body .fancybox-slide #quickshop') ? document.querySelector('body .fancybox-slide #quickshop') : '';
      if (!!modal) {
        var button = !!modal.querySelector('button[type="button"][data-fancybox-close]') ? modal.querySelector('button[type="button"][data-fancybox-close]') : '';
        thisDispatch(button, "click");
      };

      modal = !!document.querySelector('.quick-product--wrap.modal.is-visible') ? document.querySelector('.quick-product--wrap.modal.is-visible') : '';
      if (!!modal) {
        var button = !!modal.querySelector('button[type="button"][data-modal-close].modal__close-icon') ? modal.querySelector('button[type="button"][data-modal-close].modal__close-icon') : '';
        thisDispatch(button, "click");
      };
      modal = !!document.querySelector('quick-add-modal[open]') ? document.querySelector('quick-add-modal[open]') : '';
      if (!!modal) {
        var button = !!modal.querySelector('button[type="button"].quick-add-modal__toggle') ? modal.querySelector('button[type="button"].quick-add-modal__toggle') : '';
        thisDispatch(button, "click");
      };
      modal = !!document.querySelector('#colorbox') ? document.querySelector('#colorbox') : '';
      if (!!modal) {
        var button = !!modal.querySelector('a.close-box[aria-label="Close"]') ? modal.querySelector('a.close-box[aria-label="Close"]') : '';
        thisDispatch(button, "click");
      };

      modal = !!document.querySelector('.modal[data-modal-container]') ? document.querySelector('.modal[data-modal-container]') : '';
      if (!!modal) {
        var button = !!modal.querySelector('button.modal-close') ? modal.querySelector('button.modal-close') : '';
        thisDispatch(button, "click");
      };


      modal = !!document.querySelector('dialog.product-quick-add[data-quick-add-modal][data-scroll-lock-required][open="true"]') ? document.querySelector('dialog.product-quick-add[data-quick-add-modal][data-scroll-lock-required][open="true"]') : '';
      if (!!modal) {
        var button = !!modal.querySelector('.product-quick-add__close-outer .product-quick-add__close.drawer__close[data-quick-add-modal-close]') ? modal.querySelector('.product-quick-add__close-outer .product-quick-add__close.drawer__close[data-quick-add-modal-close]') : '';
        thisDispatch(button, "click");
      };

      modal = !!document.querySelector('.popup-quick-view__item .popup-quick-view__body .popup-quick-view__content') ? document.querySelector('.popup-quick-view__item .popup-quick-view__body .popup-quick-view__content') : '';
      if (!!modal) {
        var button = !!modal.querySelector('.popup-quick-view__content a.popup-quick-view__close[data-popup-close]') ? modal.querySelector('.popup-quick-view__content a.popup-quick-view__close[data-popup-close]') : '';
        thisDispatch(button, "click");
      };

      modal = !!document.querySelector('.layout--viewport[data-drawer-status="opened"]') ? document.querySelector('.layout--viewport[data-drawer-status="opened"]') : '';
      if (!!modal) {
        var button = !!modal.querySelector('.layout--close') ? modal.querySelector('.layout--close') : '';
        thisDispatch(button, "click");
      };

      modal = !!document.querySelector('.drawer.cart-flyout.is-visible.is-active.has-quick-shop-product') ? document.querySelector('.drawer.cart-flyout.is-visible.is-active.has-quick-shop-product') : '';
      if (!!modal) {
        var button = !!modal.querySelector('.quick-cart__close.js-close') ? modal.querySelector('.quick-cart__close.js-close') : '';
        thisDispatch(button, "click");
      };
      modal = !!document.querySelector('.modal__container[data-wau-modal="quickview"]#modal-quickview-cart') ? document.querySelector('.modal__container[data-wau-modal="quickview"]#modal-quickview-cart') : '';
      if (!!modal) {
        var button = !!modal.querySelector('button.slideout__trigger-quickview.js-modal-close') ? modal.querySelector('button.slideout__trigger-quickview.js-modal-close') : '';
        thisDispatch(button, "click");
      };
      modal = !!document.querySelector('product-side-drawer#Product-QuickView-Drawer .drawer-header') ? document.querySelector('product-side-drawer#Product-QuickView-Drawer .drawer-header') : '';
      if (!!modal) {
        var button = !!modal.querySelector('button.drawer-close[type="button"]') ? modal.querySelector('button.drawer-close[type="button"]') : '';
        thisDispatch(button, "click");
      };
      modal = !!document.querySelector('quick-shop-modal.modal.modal-quick-shop.is-open') ? document.querySelector('quick-shop-modal.modal.modal-quick-shop.is-open') : '';
      if (!!modal) {
        var button = !!modal.querySelector('.modal_box .js-modal-close.js-modal-close-qv.modal_close') ? modal.querySelector('.modal_box .js-modal-close.js-modal-close-qv.modal_close') : '';
        thisDispatch(button, "click");
      };
      modal = !!document.querySelector('#colorbox[role="dialog"] #cboxContent') ? document.querySelector('#colorbox[role="dialog"] #cboxContent') : '';
      if (!!modal) {
        var button = !!modal.querySelector('#colorbox[role="dialog"] #cboxContent #cboxLoadedContent .quickbuy .quickbuy__toolbar .quickbuy__close a.js-close-quickbuy') ? modal.querySelector('#colorbox[role="dialog"] #cboxContent #cboxLoadedContent .quickbuy .quickbuy__toolbar .quickbuy__close a.js-close-quickbuy') : '';
        thisDispatch(button, "click");
      };
    } catch (error) {
      console.log(error)
    };
  },
  klaviyoTrackAddToCart(id) {
    var variant = '', _learnq = window._learnq || [];
    if (id) {
      if (window.HSSLIDECART.PRODUCT && window.HSSLIDECART.SHOP) {
        variant = window.HSSLIDECART.PRODUCT.variants.find(variant => variant.id == id) || '';
      };
    };
    if (variant !== '') {
      var secure_url = window.HSSLIDECART.SHOP.secure_url || window.location.origin;
      var product = window.HSSLIDECART.PRODUCT;
      var item = {
        Name: product.title,
        ProductID: product.id,
        Categories: product.collections || [],
        ImageURL: product.featured_image_grande || '',
        URL: secure_url + window.HSSLIDECART.PRODUCT.url,
        Brand: product.vendor,
        Price: product.price_money,
        CompareAtPrice: product.compare_at_price_max_money
      };
      /* _learnq.push(['track', 'Viewed Product', item]);
      _learnq.push(['trackViewedItem', {
        Title: item.Name,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Brand: item.Brand,
          Price: item.Price,
          CompareAtPrice: item.CompareAtPrice
        }
      }]); */
      _learnq.push(['track', 'Added to Cart', item]);
    } else {
      _learnq.push(['track', 'Added to Cart']);
    };
  },
  postMyCart: function (params, z, show_loading = 1) {
    /* tbyb */
    try {
      if (z && params) {
        let parent_atc = z.closest('.hs-sticky-checkout-bar') || '';
        if (parent_atc) {
          let atc_properties = parent_atc.querySelector('.mml-tbyb-bar-properties') || '';
          if (atc_properties) {
            const inputs_properties = atc_properties.querySelectorAll('input[type="hidden"]') || [];
            if (inputs_properties.length > 0) {
              inputs_properties.forEach(input => {
                params.append(input.name, input.value);
              });
            };
          };
          let atc_discount_properties = parent_atc.querySelector('.mml-tbyb-bar-discounts-properties') || '';
          if (atc_discount_properties) {
            const inputs_discount_properties = atc_discount_properties.querySelectorAll('input[type="hidden"]') || [];
            if (inputs_discount_properties.length > 0) {
              inputs_discount_properties.forEach(input => {
                params.append(input.name, input.value);
              });
            };
          };
        };
      };
    } catch (error) {
      console.log(error);
    };

    let add_json_result = {};
    function bodyLoading() {
      var body = document.querySelector('.loading') || '';
      if (body) {
        var modalOverly = document.querySelector('.modalOverly') || '';
        var loadingBox = document.querySelector('.loadingBox') || '';
        if (modalOverly && loadingBox) {
          body.classList.remove('loading');
        };
      };
    };

    var result_loading = !!show_loading ? document.querySelector('.hs-result-loading.hs-body-gnral') || '' : '';
    if (!!result_loading) {
      result_loading.classList.add('hs-show-loading');
    } else {
      if (typeof slideData?.customize?.customize_enabled_loading !== 'undefined') {
        if (slideData.customize.customize_enabled_loading == 2) {
          if (!!parseInt(slideData.settings.additional_settings.open_cart)) {
            result_loading = '';
            var bodyOpenCart = !!document.querySelector('body') ? document.querySelector('body') : '';
            if (!!bodyOpenCart) {
              if (!bodyOpenCart.classList.contains('hs-open-cart')) {
                HsApp1.openCart();
              }
            }
          };
        };
      };
    };

    var element_error = '', elementActive = document.activeElement;
    if (!!z) {
      element_error = z.querySelector('[data-qty-error-message]') || '';
      if (element_error) {
        element_error.classList.add('hidden')
      };
      // if (z?.classList?.contains('hs-add-to-cart')) {
      //   elementActive = z;
      // };
      //Hs_CartDrawer.setActiveElement(elementActive);
    };
    try {
      Hs_loading_page_button(z, 'remove') //FUNCTION unlock loading in button
    } catch (error) {
      console.log(error)
    };



    var error = false, identify = 0;
    var add = Hs_CartDrawer.routeLocale('cart/add.js');
    let headers = {
      'Accept': "application/json, text/javascript",
      'X-Requested-With': 'XMLHttpRequest',
    };
    typeof params === 'string' ? headers['Content-Type'] = "application/json, text/javascript" : '';
    fetch(`${add}`, {
      body: params,
      method: 'POST',
      headers: headers,
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (!!json.status) {
        error = true;
        if (!!result_loading) {
          result_loading.classList.remove('hs-show-loading');
        };
        if (json.status == 422) {
          if (element_error) {
            element_error.classList.remove('hidden')
            return false;
          };
        };
        try {
          Hs_modal_notification(json?.message, json?.description, slideData)
        } catch (error) {
          alert(`Error ${json.status}: ${json.description}`)
        }
      };
      add_json_result = json;
      if (!!json.properties) {
        if (Object.keys(json.properties).length > 0) {
          Object.keys(json.properties).forEach(function (c, o) {
            if (c === '_giftWrap') {
              HsApp1.createCpokie('hs-giftWrap-key', json.key, 360);
            }
          })
        }
      };

    }).catch(function (err) {
      console.log(err)
      try {
        if (result_loading) {
          result_loading.classList.remove('hs-show-loading');
        };
        Hs_loading_page_button(z, 'add');//FUNCTION lock loading in button
      } catch (error) {
        console.log(error)
      }
      error = true;
    }).then(function (e) {
      var paramsFunction = [];
      bodyLoading();

      if (!!z) {
        if (z.classList.contains('hs-add-to-cart')) {
          z.innerHTML = '<span>' + slideData.quick_buy.icon + '</span>';
          if (!!z.closest('.hs-content-cart-drawer-loop').querySelector('ul.active')) {
            z.closest('.hs-content-cart-drawer-loop').querySelector('ul').classList.remove('active');
          }
          if (!error) {
            switch (slideData.quick_buy.quick_buy_button_redirect) {
              case 'cart':
                window.location.href = '/cart';
                break;
              case 'checkout':
                window.location.href = '/checkout';
                break;
            };
            if (slideData.quick_buy.quick_buy_button_redirect !== 'no-redirect') {
              return false;
            };
          };
        };
        if (z.classList.contains('hs-checkout-bar-add-to-cart')) {
          z.classList.remove('hs-loading-btn');
          if (!error) {
            switch (slideData.cart_bar.cart_bar_button_redirect) {
              case 'cart':
                window.location.href = '/cart';
                break;
              case 'checkout':
                window.location.href = '/checkout';
                break;
            };
            if (slideData.cart_bar.cart_bar_button_redirect !== 'no-redirect') {
              return false;
            };
          };
        };
        if (z.classList.contains('hs-loading-giftwrap')) {
          z.classList.remove('hs-loading-giftwrap')
        };
      };


      if (!error) {
        if (!!slideData.settings.devices.enabled_desktop || !!slideData.settings.devices.enabled_mobile) {
          HsApp3.closeModalQuickView();
        };
        params = HsApp3.serialize(params);
        paramsFunction = [
          {
            "name": 'addToCart',
            "attr": {
              "id": parseInt(params.id),
              "quantity": params.quantity,
              "properties": add_json_result.properties || {},
            }
          }];

      };
      /* if (!!submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        if (submitButton.querySelector('.loading-overlay__spinner')) {
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
        if (submitButton.querySelector('.loading__spinner')) {
          submitButton.querySelector('.loading__spinner').classList.add('hidden');
        }
      } */
      try {
        Hs_loading_page_button(z, 'add');//FUNCTION lock loading in button
      } catch (error) {
        console.log(error)
      };

      if (!error) {
        HsApp1.getMyCart(1, paramsFunction);
        HsApp3.getMyCart(result_loading ? 1 : 0);
        if (typeof window.Hs_updateLiveRegion === 'function') {
          if (Object.keys(params).length > 0 && Object.keys(add_json_result).length > 0) {
            const qty = parseInt(params?.quantity) || '';
            if (qty) {
              const title = Hs_CartDrawer.escape(`${add_json_result.title.replace(/<.*?>/g, '')}`)
              const liveRegionMessage = `${title} (quantity: ${params.quantity}) has been added to your cart`;
              window.Hs_updateLiveRegion(liveRegionMessage);
            }
          };
        };
      }
    });
  },
  serialize: function (data) {
    let obj = {};
    for (let [key, value] of data) {
      if (obj[key] !== undefined) {
        if (key !== 'quantity') {
          if (!Array.isArray(obj[key])) {
            obj[key] = [obj[key]];
          }
          obj[key].push(value);
        }
      } else {
        obj[key] = value;
      }
    }
    return obj;
  },
  serializeArray: function (form) {
    var x = [];
    if (!form || form.nodeName !== "FORM") {
      return;
    }
    var i, j, q = [];
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
      if (form.elements[i].name === "") {
        continue;
      }
      switch (form.elements[i].nodeName) {
        case 'INPUT':
          switch (form.elements[i].type) {
            case 'text':
            case 'tel':
            case 'email':
            case 'hidden':
            case 'password':
            case 'button':
            case 'reset':
            case 'submit':
              q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
              break;
            case 'checkbox':
            case 'radio':
              if (form.elements[i].checked) {
                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
              }
              break;
          }
          break;
        case 'file':
          break;
        case 'TEXTAREA':
          q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
          break;
        case 'SELECT':
          switch (form.elements[i].type) {
            case 'select-one':
              q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
              break;
            case 'select-multiple':
              for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                if (form.elements[i].options[j].selected) {
                  q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value));
                }
              }
              break;
          }
          break;
        case 'BUTTON':
          switch (form.elements[i].type) {
            case 'reset':
            case 'submit':
            case 'button':
              q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
              break;
          }
          break;
      }
    }
    q = q.join("&");
    q = Object.fromEntries(new URLSearchParams(q));
    for (const value in q) {
      x.push({ 'name': value, 'value': q[value] })
    };
    return x;
  },
  addslashes: function (string) {
    return string.replace(/\\/g, '\\\\').
      replace(/\u0008/g, '\\b').
      replace(/\t/g, '\\t').
      replace(/\n/g, '\\n').
      replace(/\f/g, '\\f').
      replace(/\r/g, '\\r').
      replace(/'/g, '\\\'').
      replace("\r\n", "\\n").
      replace(/"/g, '\\"');
  },
  addForm: function ($this, button) {
    var arrProperties = [],
      params = {},
      formElement = {},
      concatProperties = '',
      tryon_selling_plan_id = 0;
    parentForm = !!button.closest('form') ? button.closest('form') : '',
      elementForm = !!button.closest('form') ? button.closest('form') : '',
      elementVariant = !!elementForm ? elementForm.querySelector('[name="id"]') : '',
      variantid = !!elementVariant ? elementVariant.value : '',
      qty = !!elementForm ? elementForm.querySelector('[name="quantity"]') : '',
      quantity = 1;
    //personalize = false;
    var qtybox = false;



    if (!!qty) {
      if (qty.getAttribute('type') === 'hidden') {
        var qtybox = !!elementForm.querySelector('.qtybox') ? elementForm.querySelector('.qtybox') : '';
        if (!!qtybox) {
          var input_qty = !!qtybox.querySelector('.quantity-input') ? qtybox.querySelector('.quantity-input') : '';
          if (input_qty) {
            qtybox = true;
            quantity = input_qty.value;
          }
        };
      };
    };
    if (!!button) {
      if (!!button.classList.contains('quick-add-btn') || button.classList.contains('cust_btn')) {
        if (!!button.dataset.id && button.dataset.id !== '') {
          //params = JSON.stringify({'id':button.dataset.id,'quantity':quantity,});
          elementForm = elementForm === '' ? new FormData() : new FormData(elementForm);
          elementForm.append("id", button.dataset.id);
          elementForm.append("quantity", quantity);
          HsApp3.postMyCart(elementForm, parentForm);
          return false;
        }
      };
      if (!!button.classList.contains('productitem--action-trigger') && !!button.classList.contains('productitem--action-atc')) {
        if (typeof button.dataset.quickBuy !== 'undefined') {
          if (!!button.dataset.variantId && button.dataset.variantId !== '') {
            //params = JSON.stringify({'id':button.dataset.id,'quantity':quantity,});
            elementForm = elementForm === '' ? new FormData() : new FormData(elementForm);
            elementForm.append("id", button.dataset.variantId);
            elementForm.append("quantity", quantity);
            HsApp3.postMyCart(elementForm, parentForm);
            return false;
          };
        };
      };
    };

    if (elementForm === '') {
      if (typeof button.href !== 'undefined') {
        const this_href = button.href.split('?')[1];
        const urlParams = new URLSearchParams(this_href);
        const id = !!urlParams.get('id') ? urlParams.get('id') : '';
        const quantity = !!urlParams.get('quantity') ? urlParams.get('quantity') : 1;
        const selling_plan = !!urlParams.get('selling_plan') ? urlParams.get('selling_plan') : '';
        if (!!id) {
          elementForm = new FormData();
          elementForm.append("id", id);
          elementForm.append("quantity", quantity);
          !!selling_plan ? elementForm.append("selling_plan", selling_plan) : '';
          HsApp3.postMyCart(elementForm, '');
          return false;
        };
      };
    };

    if (elementForm === '') {
      if ((!!button.classList.contains('prodMain__button') && !!button.classList.contains('buyButton')) || (!!button.classList.contains('stickyBuy__button') && !!button.classList.contains('buyButton'))) {
        var thisThing = $(this);
        index = index * 1;
        var qty = $('#quantity').val();
        var index = !!document.querySelector('#variantDrop') ? document.querySelector('#variantDrop').value : '';
        var newObj = index !== '' ? typeof variants !== 'undefined' ? variants[index] : '' : '';
        variantid = !!newObj ? newObj.id : '';
        quantity = !!document.querySelector('#quantity') ? document.querySelector('#quantity').value : quantity;
        if (index !== '' && !!newObj && !!variantid) {
          elementForm = new FormData();
          elementForm.append("id", variantid);
          elementForm.append("quantity", quantity);
          HsApp3.postMyCart(elementForm, '');
          return false;
        };
      };
    };


    /* if (elementForm === '') {
      if (!!button.classList.contains('productitem--action-trigger') && !!button.classList.contains('productitem--action-atc')) {
        const variantID = button.getAttribute('data-variant-id') || '';
        if (variantID) {
          elementForm = new FormData();
          elementForm.append("id", variantID);
          elementForm.append("quantity", quantity);
          HsApp3.postMyCart(elementForm, '');
          return false;
        };
      };
    }; */
    if (elementForm === '') {
      if (!!button.classList.contains('js-grid-cart') && !!button.dataset.id) {
        variantid = button.dataset.id || '';
        if (variantid) {
          elementForm = new FormData();
          elementForm.append("id", variantid);
          elementForm.append("quantity", quantity);
          HsApp3.postMyCart(elementForm, '');
          return false;
        };
      };
    };

    if (elementForm === '') {
      if (!!button.classList.contains('js-grid-cart') && !!button.dataset.id) {
        variantid = button.dataset.id || '';
        if (variantid) {
          elementForm = new FormData();
          elementForm.append("id", variantid);
          elementForm.append("quantity", quantity);
          HsApp3.postMyCart(elementForm, '');
          return false;
        };
      };
    };
    if (elementForm === '') {
      if (!!button.classList.contains('add-to-cart') && (!!button.getAttribute('id') && button.getAttribute('id') !== null)) {
        variantid = button.getAttribute('id') || '';
        if (variantid) {
          elementForm = new FormData();
          elementForm.append("id", variantid);
          elementForm.append("quantity", quantity);
          HsApp3.postMyCart(elementForm, '');
          return false;
        };
      };
    };

    if (elementForm === '') {//https://genderrevealcelebrations.com/
      if (button.type === 'button' && button.classList.contains('product--quick-add--button') && (button.closest('product-quick-add'))) {
        var quick_add = button.closest('product-quick-add') || '';
        if (quick_add) {
          variantid = quick_add.dataset.id || '';
          if (variantid) {
            elementForm = new FormData();
            elementForm.append("id", variantid);
            elementForm.append("quantity", quantity);
            HsApp3.postMyCart(elementForm, button);
            return false;
          };
        };
      };
    };

    if (elementForm === '') {
      return false;
    }


    if (elementForm.length > 0) {
      /* var personaliseValidate = true;
      var personalize_box = parentForm.querySelectorAll("#personalize-box") || [];
      if (personalize_box.length > 0) {
        if (personalize_box[0].checked == false) {
          personaliseValidate = false;
          personalize = true;
        };
      }; */

      //if (!!personaliseValidate) {
      if (!elementForm.checkValidity()) {
        elementForm.reportValidity()
        return false;
      }
      //};
    };

    var spb_fileupload = !!document.querySelector('.spb-fileupload') ? document.querySelector('.spb-fileupload') : '';
    if (!!spb_fileupload) {
      var input_file = !!spb_fileupload.querySelector('input[name="file"]') ? spb_fileupload.querySelector('input[name="file"]') : '';
      if (!!input_file) {
        return false;
      }
    };
    var error_text = '';
    var time = 0;
    if (!!window.TPOConfigs) {
      var tpo_option = !!elementForm ? elementForm.querySelector('.tpo_option-set-wrapper') || '' : '';
      if (!!tpo_option) {
        var tpo_container = tpo_option.querySelector('.tpo_option-set-container') || '';
        if (!!tpo_container) {
          var element_error = tpo_container.querySelectorAll('.tpo_error-message') || [];
          element_error.forEach((error) => {
            if (error.innerHTML !== '') {
              error_text = error.innerHTML;
              return false;
            };
          });
          if (error_text !== '') {
            time = 0;
          } else {
            time = 800;
            setTimeout(function () {
              element_error = tpo_container.querySelectorAll('.tpo_error-message') || [];
              element_error.forEach((error) => {
                if (error.innerHTML !== '') {
                  error_text = error.innerHTML;
                  return false;
                };
              });
            }, time);
          }
        }
      };
    };


    var find_my_shade_modal = !!document.querySelector('.find-my-shade-modal') ? document.querySelector('.find-my-shade-modal') : '';
    if (!!find_my_shade_modal) {
      var find_my_shade_modal = !!document.querySelector('find_my_shade_modal') ? document.querySelector('find_my_shade_modal') : '';
      if (!!find_my_shade_modal) {
        var formElement = !!find_my_shade_modal.querySelector('form[action*="/cart/add"]') ? find_my_shade_modal.querySelector('form[action*="/cart/add"]') : '';
        if (!!formElement) {
          //formElement = JSON.stringify(HsApp3.serialize(formElement));
          elementForm = formElement;
        }
      }
    };

    if (!variantid) {
      if (!!button.getAttribute('variant-id')) {
        variantid = button.getAttribute('variant-id');
      }
    };

    if (!variantid) {
      if (!!button.dataset.var_id) {
        variantid = button.dataset.var_id;
      }
    };

    let theme_shrine = '';
    if (elementForm && elementForm.closest('product-form') && elementForm.closest('product-info')) {
      let data = [];

      const productForm = elementForm.closest('product-form');
      const templateForm = productForm?.dataset?.section || '';

      // Busca el elemento <product-info> que es el ancestro del formulario
      let productInfo = elementForm.closest('product-info');

      // Verifica si <product-info> contiene un <quantity-breaks>
      let quantityBreaks = productInfo.querySelector('quantity-breaks');

      let productInfoUpsell = productInfo.querySelector('.product-info-upsells-container');

      if (quantityBreaks) {
        let quantityBreaksContainer = quantityBreaks.querySelector('.quantity-breaks-container');

        if (quantityBreaksContainer) {
          const selectedInput = quantityBreaksContainer.querySelector('input[type="radio"]:checked');

          // Verificar si se encontró un input seleccionado
          if (selectedInput) {
            // Obtener el id del input seleccionado
            const inputId = selectedInput.id;
            if (inputId) {
              // Obtener el label asociado al input mediante el atributo 'for'
              const associatedLabel = quantityBreaksContainer.querySelector(`label[for="${inputId}"]`);
              if (associatedLabel) {

                let variants_ids = [];

                const quantityGift = productInfo.querySelector('quantity-gifts') || '';
                if (quantityGift) {
                  // Obtener todos los elementos con data-unlocked="true"
                  const unlockedGifts = quantityGift.querySelectorAll('.quantity-gift[data-unlocked="true"]') || [];

                  // Recorrer los elementos y obtener el data-product si existe
                  unlockedGifts.forEach(gift => {
                    // Verificar si el atributo data-product existe
                    if (gift.hasAttribute('data-product')) {
                      const product = gift.getAttribute('data-product');
                      variants_ids.push(product);
                    }
                  });
                }

                // Obtener los elementos 'quantity-break__selector-item' dentro de ese label
                const selectorItems = associatedLabel.querySelectorAll('.quantity-break__selector-item[data-selected-id]');
                if (selectorItems.length > 0) {
                  const selectedIds = Array.from(selectorItems).map(item => item.getAttribute('data-selected-id')) || [];
                  variants_ids = [...variants_ids, ...selectedIds];
                } else {
                  if (variantid) {
                    if (quantityBreaksContainer.querySelector('input:checked')) {
                      let value = quantityBreaksContainer.querySelector('input:checked').value
                      for (let i = 0; i < +value; i++) {
                        variants_ids.push(variantid)
                      };
                    }
                  };

                };
                // Obtener los 'data-selected-id' de esos elementos
                for (let i = 0; i < variants_ids.length; i++) {
                  const itemId = variants_ids[i];
                  const existingItemIndex = data.findIndex(item => item.id === itemId);

                  if (existingItemIndex < 0) {
                    // Si no se encuentra el item, agregarlo
                    data.push({
                      id: itemId,
                      quantity: 1
                    });
                  } else {
                    // Si se encuentra, incrementar la cantidad
                    data[existingItemIndex].quantity += 1;
                  };
                };
              };
            };
          };
        };
      };

      if (productInfoUpsell) {
        if (templateForm) {
          const productUpsell = productInfoUpsell.querySelectorAll(`product-info-upsell.product-info-upsell-${templateForm}[data-selected="true"]`);
          if (productUpsell) {
            // Obtener los 'data-selected-id' de esos elementos
            for (let i = 0; i < productUpsell.length; i++) {
              const itemId = productUpsell[i]?.dataset?.id || '';
              if (itemId) {
                const existingItemIndex = data.findIndex(item => item.id === itemId);
                if (existingItemIndex < 0) {
                  // Si no se encuentra el item, agregarlo
                  data.push({
                    id: itemId,
                    quantity: 1
                  });
                } else {
                  // Si se encuentra, incrementar la cantidad
                  data[existingItemIndex].quantity += 1;
                };
              };
            };
          };
        };
      };

      let someVariable = '';
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        someVariable += `<input type="hidden" name="items[${i}][quantity]" value="${item.quantity}">
                    <input type="hidden" name="items[${i}][id]" value="${item.id}">`;
      };

      let form__variants = elementForm.querySelector('.product-form__variants.hidden') || '';
      if (form__variants) {
        form__variants.innerHTML = someVariable;
        if (someVariable) {
          theme_shrine = productForm
        };
      };
    };

    //CAMBIO
    function serializeToFormData(form) {
      const fd = new FormData();

      Array.from(form.elements).forEach(function (o) {
        if (!o.name || o.disabled) return;

        if (["file", "reset", "submit", "button"].includes(o.type)) return;

        if (o.type === "select-multiple") {
          Array.from(o.options).forEach(function (opt) {
            if (opt.selected) {
              fd.append(o.name, opt.value);
            }
          });
        }

        else if (["checkbox", "radio"].includes(o.type)) {
          if (o.checked) {
            fd.append(o.name, o.value);
          }
        }
        else {
          if (o.name === "id" || o.name.startsWith("id[")) {
            var e = new RegExp("gid://shopify/ProductVariant/([0-9]+)$");
            o.value = e.test(o.value) ? parseInt(o.value.match(e)[1]) : o.value;
          };
          fd.append(o.name, o.value);
        }
      });
      return fd;
    };
    try {
      params = serializeToFormData(elementForm)
    } catch (error) {
      params = new FormData(elementForm);
    }


    if (typeof button.tagName !== 'undefined') {
      if (button.tagName === 'TRYON-BUTTON') {
        if (!!button.getAttribute('data-selling_plan_id')) {
          tryon_selling_plan_id = button.getAttribute('data-selling_plan_id');
          if (!!tryon_selling_plan_id) {
            params.append('selling_plan', tryon_selling_plan_id);
          }
        }
      }
    };

    if (theme_shrine) {
      const optionsList = theme_shrine.dataset.options ? theme_shrine.dataset.options.split(',') : [];

      const fieldList = ['id', 'quantity', ...optionsList];

      for (let i = 0; i < fieldList.length; i++) {
        params.delete(fieldList[i]);
      };

      HsApp3.postMyCart(params, parentForm)
      return false
    };

    // if (!!qtybox) {
    //   if (params.get('quantity') === null) {
    //     params.append('quantity', quantity)
    //   }
    //   else {
    //     params.set('quantity', quantity)
    //   }
    // };
    // if (params.get('id') === null) {
    //   if (!!variantid) {
    //     params.append('id', variantid)
    //   }
    // };

    const itemIdKeys = [...params.keys()].filter(k => /^items\[\d*\]\[id\]$/.test(k));
    const hasItems = itemIdKeys.length > 0;

    if (hasItems) {
      // MULTI-ITEM → borra id/quantity sueltos y normaliza
      params.delete('id');
      params.delete('quantity');

      // si mandaron solo id sin quantity, pon 1
      itemIdKeys.forEach(k => {
        const idx = k.match(/^items\[(\d*)\]/)[1]; // funciona con [0] o []
        const qtyKey = `items[${idx}][quantity]`;
        if (!params.has(qtyKey)) params.append(qtyKey, '1');
      });

    } else {
      // SINGLE → lógica original
      if (qtybox) {
        params.set('quantity', quantity);
      } else if (!params.get('quantity')) {
        params.set('quantity', quantity);
      }
      if (!params.get('id') && variantid) {
        params.set('id', variantid);
      }
    }


    /* if (!params.get('id') || params.get('id') === 'null' || params.get('id') === '') {
      return false;
    }; */

    //CAMBIO
    // if (
    //   (!params.has('id') || params.get('id') === 'null' || params.get('id') === '') &&
    //   !Array.from(params.keys()).some(key => key.startsWith('id['))
    // ) {
    //   return false;
    // }

    if (!params.get('id') && !params.has('items[0][id]') && !params.has('items[][id]')) {
      return false;
    }

    if (!!elementForm.classList.contains('kaching-bundles-form--different-variants-selected')) {
      if (params.has("items[0][id]")) {
        params.delete("id");
        params.delete("quantity");
      }
    };

    if (window.Shopify.optionScriptInitialized && !!document.getElementById('product-options-ho4ed2r6cwo')) {
      params.append('hs_EasyFlow', true)
    };

    let all_Products_Arr = [];
    params.forEach(function (value, key) {
      if (key == 'first_addon_product_id' || key == 'second_addon_product_id') {
        if (value != '') {
          let item = {
            id: parseInt(value),
            quantity: 1
          };
          all_Products_Arr.push(item);
        }
      }
    });
    all_Products_Arr = all_Products_Arr.reverse();

    let mml_multiple_variants_ids = document.querySelector('.mml-multiple-variants-ids') || '';
    if (mml_multiple_variants_ids) {
      const mmlIds = mml_multiple_variants_ids.querySelectorAll('input[name="mml_ids"]') || [];
      if (mmlIds.length > 0) {
        const objects = Array.from(mmlIds).map(input => (
          all_Products_Arr.push({
            id: input.value,
            quantity: 1
          })
        ));
      };
    };

    if (all_Products_Arr.length > 0) {
      let hs_EasyFlow = false;
      if (params.get('id') !== null && params.get('quantity') !== null) {
        const data = Object.fromEntries(params.entries());

        // Inicializamos un objeto vacío para almacenar los resultados
        let result = {};
        // Iteramos sobre el params
        params.forEach((value, key) => {
          // Si la clave contiene 'properties[' y ']', la tratamos como una propiedad anidada
          if (key.startsWith('properties[') && key.endsWith(']')) {
            // Extraemos el nombre de la propiedad, eliminando 'properties[' y ']'
            let propertyName = key.substring(11, key.length - 1);
            // Creamos la estructura de propiedades si aún no existe
            if (!result.properties) {
              result.properties = {};
            };

            // Asignamos el valor a la propiedad extraída
            result.properties[propertyName] = value;
          } else {
            // Si la clave no es de 'properties', simplemente la asignamos directamente
            result[key] = value;
          }
        });
        if (typeof result.properties !== 'undefined') {
          data.properties = result.properties;
        };
        all_Products_Arr.push(data)

      };

      params.get('hs_EasyFlow') ? hs_EasyFlow = true : '';
      params = {
        items: all_Products_Arr
      };
      hs_EasyFlow ? params['hs_EasyFlow'] = hs_EasyFlow : '';
      params = JSON.stringify(params, '')
    };



    setTimeout(function () {
      if (error_text !== '') {
        return false;
      };
      HsApp3.postMyCart(params, parentForm)
    }, time > 0 ? time + 100 : time);


  },
  addCart: function () {
    pageflyANDgempages.addToCart();
  },
  cssStickyCart: function () {
    const positionStickyCart = this.positionStickyCart();
    var contentCss = `
                  .hs-sticky-cart-cart-drawer {\
                      cursor:pointer;\
                      position: fixed;\
                      ${positionStickyCart.y}: ${positionStickyCart.distance}%;\
                      ${positionStickyCart.x}: 15px;\
                      z-index: ${!!document.querySelector('bundle-builder-item-modal') ? '2147483637' : '2147483635'};\
                  }\
                  .hs-hidden-count-cart{
                      display:none !important;
                  }
                  .hs-sticky-cart-cart-drawer-content {\
                      background: ${slideData.sticky_cart.sticky_cart_background_color_hex} !important;\
                      font-size:20px;\
                      display: flex;\
                      align-items: center;\
                      justify-content: center;\
                      -webkit-border-radius: 30px !important;\
                      -moz-border-radius: 30px !important;\
                      border-radius: 30px !important;\
                      -webkit-box-shadow: 1px 1px 5px grey !important;\
                      -moz-box-shadow: 1px 1px 5px grey !important;\
                      box-shadow: 1px 1px 5px grey !important;\
                      padding: 10px;\
                      width: 30px;\
                      height: 30px;\
                      margin: 0 auto;\
                      line-height: 30px !important;\
                      text-align: center;\
                      position: relative;\
                      box-sizing: content-box !important;\
                      z-index: 1;\
                  }\
                  .hs-sticky-cart-cart-drawer-content mark {\
                      background-color: ${slideData.sticky_cart.sticky_cart_total_background_color_hex} !important;\
                      color: ${slideData.sticky_cart.sticky_cart_total_color_hex} !important;\
                      -webkit-border-radius: 20px;\
                      -moz-border-radius: 20px;\
                      border-radius: 20px;\
                      border: 2px solid transparent;\
                      width: 20px;\
                      height: 20px;\
                      position: absolute;\
                      top: -5px;\
                      left: -10px;\
                      font-size: 10px !important;\
                      line-height: 20px;\
                      font-weight: 700;\
                      box-sizing: content-box !important;\
                      box-shadow: -1px 0px 3px #707080;\
                      padding: 0 !important;\
                  }\
                  .hs-sticky-cart-cart-drawer-content svg{
                      color:${slideData.sticky_cart.sticky_cart_icon_color_hex} !important;\
                      width:20px !important;\
                      height:20px !important;\
                      fill:${slideData.sticky_cart.sticky_cart_icon_color_hex} !important;\
                  }\
                  .hs-sticky-cart-cart-drawer-content svg path{\
                      fill:${slideData.sticky_cart.sticky_cart_icon_color_hex} !important;\
                  }\
                  .hs-sticky-cart-cart-drawer .hs-sticky-cart-countdown{\
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    transform: translate(-50%,50%);
                    width: fit-content;
                    padding: 0 !important;\
                    background-color: ${typeof slideData.sticky_cart.sticky_cart_countdown_background_color_hex !== 'undefined' ? slideData.sticky_cart.sticky_cart_countdown_background_color_hex : slideData.sticky_cart.sticky_cart_total_background_color_hex} !important;\
                    color: ${typeof slideData.sticky_cart.sticky_cart_countdown_color_hex !== 'undefined' ? slideData.sticky_cart.sticky_cart_countdown_color_hex : slideData.sticky_cart.sticky_cart_total_color_hex} !important;\
                    border-radius: 4px;
                    border: 2px solid transparent;\
                    font-size: 12px !important;\
                    line-height: 20px;\
                    font-weight: 700;\
                    word-break: normal;\
                    box-sizing: content-box !important;\
                    overflow-wrap: initial;\
                  }\
                  .hs-sticky-cart-cart-drawer.hs-hidden-desktop-count-cart{\
                      display:none;\
                  }\
                  .hs-sticky-cart-cart-drawer.hs-hidden-devices-count-cart{\
                      display:block;\
                  }\
                  .hs-sticky-cart-cart-drawer.hs-hidden-desktop-count-cart.hs-hidden-devices-count-cart{\
                      display:none;\
                  }\
                  .hs-sticky-cart-cart-drawer.hs-hidden-desktop-count-cart{\
                      display:block;\
                  }\
                  .hs-sticky-cart-cart-drawer.hs-hidden-devices-count-cart{\
                      display:none;\
                  }`;
    document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">' + contentCss + '</style>');
  },
  stickyCart: function () {
    if (!parseInt(slideData.sticky_cart.enabled_sticky_cart)) {
      return false;
    };
    if (window.location.href.indexOf('/cart') > 1 && parseInt(slideData.sticky_cart.sticky_cart_hide_page)) {
      return false;
    };
    var resultValidateDevice = this.validateStickyCartDevice();
    switch (parseInt(resultValidateDevice)) {
      case 0:
        return false;
        break;
      case 2:
        return false;
        break;
    };
    this.cssStickyCart();
    var sticky_cart_countdown = Hs_CartDrawer.sticky_cart_countdown ? `
              <span class="hs-sticky-cart-countdown" style="display:none;">
                <div class="hs-sticky-cart-countdown-box">
                  <span class="hs-sticky-cart-countdown-countdown-timer"></span>
                </div>
              </span>` : '';
    var contentStickyCart = `<div class="hs-sticky-cart-cart-drawer hs-hidden-count-cart" role="button" tabindex="0">
              <span class="hs-sticky-cart-cart-drawer-content">
                <mark id='hsitemCount'>0</mark>
                ${slideData.sticky_cart.icon}
                ${sticky_cart_countdown}
              </span>
            </div>`;//STICKY CART COUNTDOWN
    document.querySelector('body').insertAdjacentHTML('beforeend', contentStickyCart);
    this.addCart();
    this.getMyCart();
  },
  init: function () {
    this.stickyCart();
  }
};
/* =============== QUICK BUY =============== */
var HsApp4 = {
  cssQuickBuyButton: function () {
    var quick_buy_size = typeof slideData.quick_buy.quick_buy_button_size !== 'undefined' ? parseInt(slideData.quick_buy.quick_buy_button_size, 10) : 35;
    var content = `
                .ShopTheLook__ProductItem .hs-quantity-content-arrows.hs-top-right {\
                  right: 16px;\
                }\
                .jdgm-carousel-item .hs-add-to-cart {\
                  display: none !important;\
                }\
                .hs-content-cart-drawer-loop {\
                  height: auto;\
                  right: 0px;\
                  top: 0;\
                  z-index: 2;\
                  width: 100%;\
                }\
                .hs-content-cart-drawer-loop *:focus-visible{\
                  outline: .2rem solid rgba(18, 18, 18, .5) !important;\
                  outline-offset: .3rem !important;\
                  box-shadow: 0 0 0 .3rem rgb(255, 255, 255), 0 0 .5rem .4rem rgba(18, 18, 18, .3) !important;\

                }\
                .hs-add-to-cart span {\
                  padding: 0px !important;
                  margin: 0px !important;
                  background: ${slideData.quick_buy.quick_buy_button_background_color_hex} !important;\
                  color: ${slideData.quick_buy.quick_buy_button_icon_color_hex} !important;\
                  width: ${quick_buy_size}px !important;\
                  border-radius: 50% !important;\
                  opacity: .9 !important;\
                  display: flex !important;\
                  -webkit-box-align: center !important;\
                  align-items: center !important;\
                  -webkit-box-pack: justify !important;\
                  justify-content: center !important;\
                  height: ${quick_buy_size}px !important;\
                }\
                .hs-quantity-content-arrows.hs-top-right {\
                  position: absolute;\
                  top: 4px;\
                  right: 4px;\
                }\
                .hs-quantity-content-arrows.hs-top-left {\
                  left: 4px !important;\
                  position: absolute;\
                  top: 4px;\
                }\
                .hs-top-right .hs-add-to-cart {\
                  cursor: pointer;\
                  border: 0px;\
                  height: auto !important;\
                  position: absolute;\
                  top: 0px;\
                  right: 0px;\
                  z-index: 4;\
                  line-height: 0px;\
                  padding: 0px;\
                  margin: 0px;\
                  outline: none;\
                  background: transparent;\
                  border-radius: 50%;\
                  display: inline-block;\
                  width: auto;\
                  min-height: auto !important;\

                  min-width:auto;\
                  box-shadow:none;\
                }\
                .hs-top-left .hs-add-to-cart {\
                  cursor: pointer;\
                  border: 0px;\
                  position: absolute;\
                  top: 0px;\
                  left: 0px;\
                  z-index: 4;\
                  line-height: 0px;\
                  padding: 0px;\
                  margin: 0px;\
                  outline: none;\
                  background: transparent;\
                  border-radius: 50%;\
                  display: inline-block;\
                  width: auto;\
                  min-height: auto !important;\

                  min-width:auto;\
                  box-shadow:none;\
                }\
                .hs-combobox-option-variant li::before {\
                  content: none !important;\
                }\
                .hs-combobox-option-variant{\
                  -webkit-overflow-scrolling: auto;\
                }\
                .hs-combobox-option-variant::-webkit-scrollbar-track\
                {\
                  -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,0.1);\
                  background-color: #f5f6f7;\
                }\
                .hs-combobox-option-variant::-webkit-scrollbar\
                {\
                  width: 8px;\
                  background-color: #c1c1c1;\
                }\
                .hs-combobox-option-variant::-webkit-scrollbar-thumb\
                {\
                  background-color: #c1c1c1;\
                }\
                ul.hs-combobox-option-variant.hs-top-left {\
                  left: 0;\
                }\
                ul.hs-combobox-option-variant.hs-top-right {\
                  right: 0;\
                }\
                .farm-quantity-button {\
                  line-height: 0;\
                }\
                .fa.fa-angle-up:not(.mldarrow):before,.fa.fa-angle-down:not(.mldarrow):before {\
                  content:none !important;\
                }\
                
                input.hs-quick-button-quantity[type=number]::-webkit-inner-spin-button,input.hs-quick-button-quantity[type=number]::-webkit-outer-spin-button {\
                  opacity: 1;\
                }\
                .hs-combobox-option-variant {\
                  display:none !important;\
                  position: absolute !important;\
                  top:${quick_buy_size + 10}px;\
                  z-index: 100 !important;\
                  width: 80% !important;\
                  font-size: ${slideData.quick_buy.quick_buy_button_variants_font_size || '13px'} !important;\
                  font-weight: ${slideData.quick_buy.quick_buy_button_variants_font_weight || 'normal'} !important;\
                  overflow: hidden !important;\
                  overflow-y: auto !important;\
                  list-style: none !important;\
                  text-align: center !important;\
                  ${typeof slideData.quick_buy.quick_buy_button_variants_background_color_rgb === 'undefined' ? `opacity:.9 !important;` : ''}
                  margin:0px !important;\
                  max-height: 192px !important;\
                  padding: 0 !important;\
                }\
                .hs-combobox-option-variant:hover {\
                  opacity:1;\
                }\
                .hs-combobox-option-variant.active {\
                  display:block !important;\
                }\
                .hs-frequently-bought span {\
              border:none !important;\
                  line-height: initial !important;\
                }\
                .hs-combobox-option-variant li {\
                  display: block;\
                  background: ${slideData.quick_buy.quick_buy_button_variants_background_color_rgb || '#eee'};\
                  color: #000;\
                  padding: 5px;\
                  margin: 0;\
                  border-bottom: 1px solid  ${slideData.quick_buy.quick_buy_button_variants_line_color_hex || '#ddd'};\
                  line-height: 1;\
                  cursor: pointer;\
                }\
                .hs-combobox-option-variant li:hover {\
                  opacity:.9;\
                }\
                .header-item .hs-content-cart-drawer-loop {\
                  display: none !important;\
                }\
                .hs-content-cart-drawer-loop .hs-select-box-load select {\
                  width: 100%;\
                  padding-top: 10px;\
                  padding-left: 18px;\
                  padding-bottom: 10px;\
                  -webkit-appearance: none;\
                  -moz-appearance: none;\
                  appearance: none;\
                  background-position: right center;\
                  background-image: url(//cdn.shopify.com/s/files/1/3067/1988/t/10/assets/ico-select.svg?44545);\
                  background-repeat: no-repeat;\
                  background-position: right 10px center;\
                  line-height: 1.2;\
                  padding-right: 28px;\
                  text-indent: 0.01px;\
                  text-overflow: "";\
                  cursor: pointer;\
                  padding-top: 8px;\
                  padding-left: 15px;\
                  padding-bottom: 8px;\
                }\
                .product-info .product-link .hs-content-cart-drawer-loop {\
                  display: none !important;\
                }\
                .btn .hs-content-cart-drawer-loop {\
                  display: none !important;\
                }\
                .hs-content-cart-drawer-loop select:last-child {\
                  margin-bottom: 0px\
                  margin-top: 0px\
                }\
                .hs-content-cart-drawer-loop .hs-top-right .hs-quick-button-quantity {\
                  background: #fff;\
                  box-sizing: border-box !important;\
                  box-shadow:none !important;\
                  width: ${quick_buy_size + 60}px;\
                  height: ${quick_buy_size}px;\
                  min-height: ${quick_buy_size}px;\
                  display: block;\
                  z-index: 3;\
                  border-radius: ${quick_buy_size / 2}px;\
                  padding: 7px ${quick_buy_size + 5}px 7px 5px;\
                  margin: 0;\
                  text-align: left;\
                  color: #222222;\
                  outline: none;\
                  font-size: ${(quick_buy_size / 2) - 5}px !important;\
                }\
                .hs-content-cart-drawer-loop .hs-top-left .hs-quick-button-quantity {\
                  background: #fff;\
                  width: ${quick_buy_size + 60}px;\
                  height: ${quick_buy_size}px;\
                  min-height: ${quick_buy_size}px;\
                  display: block;\
                  z-index: 3;\
                  border-radius: ${quick_buy_size / 2}px;\
                  padding: 7px 5px 7px ${quick_buy_size + 5}px;\
                  margin: 0;\
                  text-align: right;\
                  color: #a0a0a0;\
                  font-size: ${(quick_buy_size / 2) - 5}px !important;\
                }\
                .gm-target .hs-content-cart-drawer-loop {\
                display: none !important;\
                }\
                .hs-content-cart-drawer-loop.hs-hidden-quick-buy-button {\
                  display: none !important;\
                }\
                .grid-product__meta .hs-content-cart-drawer-loop {
                  display: none;
                }\
                .hs-content-cart-drawer-loop .hs-quick-button-quantity{\
                  border: 1px solid ${slideData.quick_buy.quick_buy_button_background_color_hex};\
                }\
                .hs-product-content-image-swipper .hs-content-cart-drawer-loop {\
                  display: none !important;\
                }\
                .hs-content-cart-drawer-loop .hs-top-left .hs-quick-button-quantity{\
                  border: 1px solid ${slideData.quick_buy.quick_buy_button_background_color_hex};\
                }\
                .hs-item-content-variants .hs-content-cart-drawer-loop {\
                  display: none !important;\
                }\
                .grid-product__meta .hs-content-cart-drawer-loop{\
                  display: none !important;\
                }\
                .hs-content-cart-drawer-loop i {\
                  margin: 0;\
                }\
                .hs-content-product-slide-cart .hs-content-cart-drawer-loop {\
                  display: none;\
                }\
                .hs-content-cart-drawer-loop .hs-add-to-cart svg {\
                  color: ${slideData.quick_buy.quick_buy_button_icon_color_hex};\
                  width: ${quick_buy_size - 15}px;\
                  height:${quick_buy_size - 15}px;\
                  fill: ${slideData.quick_buy.quick_buy_button_icon_color_hex};\
                  position:relative !important;\
                }
                /*.hs-content-cart-drawer-loop .hs-add-to-cart svg.hs-icon-loading {\
                  width: ${quick_buy_size}px;\
                  height:${quick_buy_size}px;\
                }\
                .hs-content-cart-drawer-loop .hs-add-to-cart svg path{\
                  fill: ${slideData.quick_buy.quick_buy_button_icon_color_hex};\
                }*/
                
                
              .hs-content-cart-drawer-loop .hs-add-to-cart .hs-spinner{\
                  border-top-color: ${slideData.quick_buy.quick_buy_button_icon_color_hex} !important;\
                  display: inline-block;\
                  width: ${quick_buy_size - 15}px !important;\
                  height:${quick_buy_size - 15}px !important;\
                  margin: 0 auto;\
                  border: 2px solid transparent;\
                  border-radius: 50%;\
                  content: "";\
                  z-index: 2;\
                  border-image: none;\
                  -webkit-animation: hs-spin .75s infinite linear;\
                  animation: hs-spin .75s infinite linear;\
                }\
                .hs-add-to-cart .hs-spinner:before{\
                  box-sizing: inherit;\
                  position: absolute;\
                  top: -2px;\
                  right: 0;\
                  left: -2px;\
                  width: inherit;\
                  height: inherit;\
                  border: inherit;\
                  border-radius: inherit;\
                  border-top-color: inherit;\
                  content: "";\
                  -webkit-animation: hs-spin 1.5s infinite ease;\
                  animation: hs-spin 1.5s infinite ease;\
                }
                @keyframes hs-spin {\
                  0% {\
                      transform: rotate(0deg);\
                  }\
                  100% {\
                      transform: rotate(360deg);\
                  }\
                }\
            `
    var personalize = '';
    var element = document.querySelectorAll('.flits-wishlist-colection.flits-wishlist-colection-style.flits-wishlist-button-style').length > 0 ? document.querySelectorAll('.flits-wishlist-colection.flits-wishlist-colection-style.flits-wishlist-button-style') : [];

    if (element.length > 0) {
      personalize = `
            .flits-wishlist-colection{
              z-index: 1 !important;\
            }`
    }
    document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">' + content + personalize + '</style>');
  },
  validateQuickBuyDevice: function () {
    var show_desktop = slideData.quick_buy.quick_buy_button_show_desktop;
    var show_mobile = slideData.quick_buy.quick_buy_button_show_mobile;
    var device = HsApp1.loadDevice();
    var result;
    if (device == "desktop") {
      switch (parseInt(show_desktop)) {
        case 0:
          result = 0;
          break;
        case 1:
          result = 1
          break;
      };
    }
    else if (device == "mobile" || "tablet") {
      switch (parseInt(show_mobile)) {
        case 0:
          result = 2;
          break;
        case 1:
          result = 3;
          break;
      };
    };
    return result;
  },
  isJson: function (item) {
    item = typeof item !== "string"
      ? JSON.stringify(item)
      : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item !== null) {
      return true;
    }

    return false;
  },
  loadSvg: function () {
    return `<div class="hs-spinner"></div>`;
  },
  changeVariants: function (json) {
    var selectBody = document.querySelector('body');
    selectBody.addEventListener("click", function (e) {
      var ul = document.querySelectorAll('.hs-combobox-option-variant.active').length > 0 ? document.querySelectorAll('.hs-combobox-option-variant.active') : [];
      if (ul.length > 0) {
        ul.forEach(function (val) {
          val.classList.remove('active');
        });
      }
    });

    var buttonQuantity = document.querySelectorAll('.hs-quick-button-quantity').length > 0 ? document.querySelectorAll('.hs-quick-button-quantity') : [];
    if (buttonQuantity.length > 0) {
      buttonQuantity.forEach(function (button) {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      });
    };

    let select = document.querySelectorAll('.hs-add-to-cart').length > 0 ? document.querySelectorAll('.hs-add-to-cart') : [];

    if (select.length > 0) {
      select.forEach(function (z, x, c) {
        if (!z.classList.contains('hs-event-static')) {
          z.classList.add('hs-event-static');
          z.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var id = z.dataset.id,
              h = 160,
              text = '',
              elementP = z.closest('.hs-product-cart-drawer-' + id),
              elementProduct = elementP.parentNode.nodeName,
              element = elementP.querySelector('.hs-option-parent-' + id),
              elementVid = document.querySelectorAll('.hs-combobox-option-variant'),
              elementVariant = elementP.querySelector('.hs-combobox-option-variant-' + id),
              variantid = '',
              left = 0,
              e = elementP.querySelectorAll('.hs-combobox-option-variant-' + id + '.active').length,
              quantity = 1;
            if (e > 0) {
              elementVariant.classList.remove('active');
              return false;
            }
            if (elementProduct === 'DIV') {
              h = elementProduct.clientHeight - 45;
            }
            if (!!elementP.querySelector('.hs-quick-button-quantity')) {
              quantity = elementP.querySelector('.hs-quick-button-quantity').value;
            }
            quantity = parseInt(quantity);
            elementVariant.style.height = h + 'px';
            if (elementVid.length > 0) {
              elementVid.forEach(function (value, index) {
                value.classList.remove('active');
              });
            }
            z.classList.add('hs-loading-cart');
            z.innerHTML = '<span>' + HsApp4.loadSvg() + '</span>';
            left = z.closest('.hs-content-cart-drawer-loop').querySelector('.hs-select-option-add-to-cart').querySelectorAll('option').length;
            if (left == 1) {
              variantid = element.querySelector('option:checked').dataset.variantid;
              //var params = JSON.stringify({id:variantid,quantity:quantity});
              var params = new FormData();
              params.append('id', variantid)
              params.append('quantity', quantity)
              HsApp3.postMyCart(params, z);
            } else {
              setTimeout(function () {
                z.innerHTML = '<span>' + slideData.quick_buy.icon + '</span>';
                elementVariant.classList.add('active');
              }, 200);
            }
          });
        }
      });
    };

    var optVariant = document.querySelectorAll('.hs-combobox-option-variant li').length > 0 ? document.querySelectorAll('.hs-combobox-option-variant li') : [];
    if (optVariant.length > 0) {
      optVariant.forEach(function (val) {
        if (!val.classList.contains('hs-event-static')) {
          val.classList.add('hs-event-static');

          function quickBuyButtonAdd() {
            var id = val.dataset.id,
              variantid = val.dataset.vid,
              elementGlobal = val.closest('.hs-product-cart-drawer-' + id),
              elementButton = elementGlobal.querySelector('.hs-button-cart-' + id),
              quantity = 1;
            val.classList.remove('active');
            elementButton.classList.add('hs-loading-cart');
            elementButton.innerHTML = '<span>' + HsApp4.loadSvg() + '</span>';
            if (!!elementGlobal.querySelector('.hs-quick-button-quantity')) {
              quantity = elementGlobal.querySelector('.hs-quick-button-quantity').value;
            }
            quantity = parseInt(quantity);
            var params = new FormData();
            params.append('id', variantid)
            params.append('quantity', quantity)
            HsApp3.postMyCart(params, elementButton);
          };

          val.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            quickBuyButtonAdd();
          });
          val.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              event.stopPropagation();
              quickBuyButtonAdd();
            }
          });

        }
      });
    };
  },
  fromCreateVariants: function (element, value) {
    var count_options = 1, content = '', cartButton = '', position_element = '', quantity = '', button = '', flag = '', filterText1 = '', filterText2 = '', filterText3 = '', options = [], variants = [], filteredArr1 = [], filteredArr2 = [], filteredArr3 = [], opt1 = [], opt2 = [], opt3 = [], option1 = '', option2 = '', option3 = '', selectParent = '', selectVariant = '';
    if (value.tags.includes('HS_QUICK_BUY_HIDDEN_PRODUCT')) {
      return false;
    }
    options = value.options;
    variants = value.variants;
    selectParent = '';
    selectVariant = '';
    position_element = ' ' + slideData.quick_buy.quick_buy_button_position;
    opt1 = [];
    opt2 = [];
    opt3 = [];
    count_options = 1;
    variants.forEach(function (n, x) {
      option1 = '';
      option2 = '';
      option3 = '';
      count_options = n.options.length;
      value.options.forEach(function (w, u) {
        if (u == 0) {
          option1 = w;
        }
        if (u == 1) {
          option2 = w;
        }
        if (u == 2) {
          option3 = w;
        }
      });
      if (option1.length > 0) {
        opt1.push(option1);
      }
      if (option2.length > 0) {
        opt2.push(option2);
      }
      if (option3.length > 0) {
        opt3.push(option3);
      }

      //selectParent = selectParent.concat('<option value="' + n.title + '" title="' + n.title + '" data-id="' + value.id + '" data-price="' + n.price + '" data-sku="' + n.sku + '" data-available="' + n.available + '" data-barcode="' + n.barcode + '" data-featuredimage="' + value.featured_image + '" data-inventorymanagement="' + n.inventory_management + '" data-compareatprice="' + n.compare_at_price + '" data-variantid="' + n.id + '">' + n.title + '</option>');
      selectParent = selectParent.concat(`<option value='${n.title.replace(/<.*?>/g, '')}' data-id='${value.id}' data-price='${n.price}' data-sku='${n.sku}' data-available='${n.available}' data-barcode='${n.barcode}' data-featuredimage='${value.featured_image}' data-inventorymanagement='${n.inventory_management}' data-compareatprice='${n.compare_at_price}' data-variantid='${n.id}'>${n.title.replace(/<.*?>/g, '')}</option>`);

      selectVariant = selectVariant.concat(
        '<li role="button" tabindex="0" aria-label="' + n.title + '" ' +
        'data-id="' + value.id + '" data-vid="' + n.id + '" data-available="' + n.available + '">' +
        '<span>' + n.title + '</span>' +
        '</li>'
      );

    });
    filterText1 = '';
    filterText2 = '';
    filterText3 = '';
    selectVariant = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-' + value.id + position_element + '">' + selectVariant + '</ul>';
    quantity = '<input type="number" class="hs-quick-button-quantity" name="hs-quick-button-quantity" aria-label="hs-quick-buy" value="1" min="1"><div class="farm-quantity-nav"> <div class="farm-quantity-button farm-quantity-up"><i class="fa fa-angle-up" aria-hidden="true"></i></div> <div class="farm-quantity-button farm-quantity-down"><i class="fa fa-angle-down" aria-hidden="true"></i></div> </div>';
    button = '<button type="button" aria-label="hsquickBuyButton" class="hs-add-to-cart hs-button-cart-' + value.id + '" data-id="' + value.id + '"><span>' + slideData.quick_buy.icon + '</span></button>';
    flag = '<div class="hs-flag-content hs-flag-' + value.id + '" style="display:none;"></div>';
    selectParent = '<select aria-label="hs-option-' + value.id + '" class="hs-option-parent-' + value.id + ' hs-select-option-add-to-cart" name="none" data-id="' + value.id + '" style="display:none;">' + selectParent + '</select>';

    filteredArr1 = opt1.filter(function (item, index) {
      if (opt1.indexOf(item) == index)
        return item;
    });
    filteredArr2 = opt2.filter(function (item, index) {
      if (opt2.indexOf(item) == index)
        return item;
    });
    filteredArr3 = opt3.filter(function (item, index) {
      if (opt3.indexOf(item) == index)
        return item;
    });
    if (filteredArr1.length > 0) {
      filteredArr1.forEach(function (v, i) {
        filterText1 = filterText1.concat('<option value="' + v + '" data-id="' + value.id + '">' + v + '</option>');
      });
      filterText1 = '<div class="hs-select-box-load hs-load-select-box-bar-' + count_options + '"><span class="hs-select-text">' + value.options[0] + '</span><select class="hs-option-' + value.id + '-0 hs-select-option" name="none">' + filterText1 + '</select></div>';
    }
    if (filteredArr2.length > 0) {
      filteredArr2.forEach(function (v, i) {
        filterText2 = filterText2.concat('<option value="' + v + '" data-id="' + value.id + '">' + v + '</option>');
      });
      filterText2 = '<div class="hs-select-box-load hs-load-select-box-bar-' + count_options + '"><span class="hs-select-text">' + value.options[1] + '</span><select class="hs-option-' + value.id + '-1 hs-select-option" name="none">' + filterText2 + '</select></div>';
    }
    if (filteredArr3.length > 0) {
      filteredArr3.forEach(function (v, i) {
        filterText3 = filterText3.concat('<option value="' + v + '" data-id="' + value.id + '">' + v + '</option>');
      });
      filterText3 = '<div class="hs-select-box-load hs-load-select-box-bar-' + count_options + '"><span class="hs-select-text">' + value.options[2] + '</span><select class="hs-option-' + value.id + '-2 hs-select-option" name="none">' + filterText3 + '</select></div>';
    }
    if (slideData.quick_buy.quick_buy_button_show_quantity_selector == 0) {
      quantity = '';
    }

    content = '<div class="hs-change-select-option" style="display:none;">' + filterText1 + filterText2 + filterText3 + '</div>' + selectParent;
    if (!!element) {
      //if(!!element.parentElement.querySelector('img') || !!element.parentElement.querySelector('svg')) -- > duplicate quickbuy
      if (!!element.parentElement.querySelector('img')) {
        if (!element.classList.contains('Button')) {
          var a = element.querySelectorAll('.hs-content-cart-drawer-loop');
          if (a.length < 1) {
            if (element.getAttribute('data-product-type') === 'title' || !!element.parentElement.classList.contains('FeaturedProduct')) {
              return false;
            }
            if (!!element.classList.contains('grid-product__link')) {
              var grid_product__image_mask = !!element.querySelector('.grid-product__image-mask') ? element.querySelector('.grid-product__image-mask') : '';
              if (!!grid_product__image_mask) {
                var image_wrap = !!grid_product__image_mask.querySelector('.image-wrap') ? grid_product__image_mask.querySelector('.image-wrap') : '';
                if (!!image_wrap) {
                  element = grid_product__image_mask;
                };
              };
            };
            element.insertAdjacentHTML('afterbegin', `
                            <div class="hs-product-cart-drawer-${value.id} hs-content-cart-drawer-loop" style="position:absolute;display:none">${content}
                            <div class="hs-quantity-content-arrows ${position_element}">${quantity}${button}${flag}</div>${selectVariant}</div>`
            );
            Hs_CartDrawer.arrQuickBuyButton.push(value);
          }
        }
      } else if (!!element.parentElement.querySelector('.grid-view-item__image.primary.lazyload')) {
        var a = element.querySelectorAll('.hs-content-cart-drawer-loop');
        if (a.length < 1) {
          element.insertAdjacentHTML('afterbegin', `
                          <div class="hs-product-cart-drawer-${value.id} hs-content-cart-drawer-loop" style="position:absolute;display:none">${content}
                          <div class="hs-quantity-content-arrows ${position_element}">${quantity}${button}${flag}</div>${selectVariant}</div>`
          );
          Hs_CartDrawer.arrQuickBuyButton.push(value);
        }
      } else if (!!element.closest('li.grid__item')) {
        var grid_item = element.closest('li.grid__item');
        var car_content = grid_item.querySelectorAll('.card.card--standard.card--media,.card.card--standard.card--text,.card.card--card.card--media').length > 0 ? grid_item.querySelectorAll('.card.card--standard.card--media,.card.card--standard.card--text,.card.card--card.card--media') : '';
        if (car_content.length > 0) {
          car_content.forEach(function (val) {
            if (val.querySelectorAll('.hs-content-cart-drawer-loop').length < 1) {
              val.insertAdjacentHTML('afterbegin', `
                            <div class="hs-product-cart-drawer-${value.id} hs-content-cart-drawer-loop" style="position:absolute;display:none">${content}
                            <div class="hs-quantity-content-arrows ${position_element}">${quantity}${button}${flag}</div>${selectVariant}</div>`
              );
              Hs_CartDrawer.arrQuickBuyButton.push(value);
            }
          })
        }
      } else if (!!element.parentElement.classList.contains('grid-product__content')) {
        var a = element.querySelectorAll('.hs-content-cart-drawer-loop');
        if (a.length < 1) {
          if (element.getAttribute('data-product-type') === 'title' || !!element.parentElement.classList.contains('FeaturedProduct')) {
            return false;
          };
          if (!!element.querySelector('.grid__image-ratio')) {
            element.insertAdjacentHTML('afterbegin', `
                      <div class="hs-product-cart-drawer-${value.id} hs-content-cart-drawer-loop" style="position:absolute;display:none">${content}
                      <div class="hs-quantity-content-arrows ${position_element}">${quantity}${button}${flag}</div>${selectVariant}</div>`
            );
            Hs_CartDrawer.arrQuickBuyButton.push(value);
          };
        };
      }
      const classNames = ['card-information__text', 'h5']
      if (classNames.some(className => element.parentElement.classList.contains(className))) {
        var card_information_wrapper = element.parentElement.parentElement.classList.contains('card-information__wrapper') ? element.parentElement.parentElement : '';
        if (!!card_information_wrapper) {
          var card_information = card_information_wrapper.parentElement.classList.contains('card-information') ? card_information_wrapper.parentElement : '';
          if (!!card_information) {
            var card_wrapper = card_information.parentElement.classList.contains('card-wrapper') ? card_information.parentElement : '';
            if (!!card_wrapper) {
              var element2 = !!card_wrapper.querySelector('.card.card--product.card--outline') ? card_wrapper.querySelector('.card.card--product.card--outline') : '';
              if (!!element2) {
                var img_element = !!element2.querySelector('img') ? element2.querySelector('img') : '';
                if (!!img_element) {
                  element2.insertAdjacentHTML('beforebegin', `
                                  <div class="hs-product-cart-drawer-${value.id} hs-content-cart-drawer-loop" style="position:absolute;display:none">${content}
                                  <div class="hs-quantity-content-arrows ${position_element}">${quantity}${button}${flag}</div>${selectVariant}</div>`
                  );
                };
              };
            };
          };
        };
      };
    };
  },
  removeDuplicates: function (originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for (i in lookupObject) {
      if (!!lookupObject[i].handle) {
        newArray.push(lookupObject[i]);
      }
    }
    return newArray;
  },
  addBuyButton: function (arr, id) {
    if (arr) {
      var handle = '', x = 0, url = '', where = '', itemsProcessed = 0;
      arr = HsApp4.removeDuplicates(arr, 'handle');
      arr.forEach(function (val) {
        if (typeof val.handle !== 'undefined') {
          var text_variant = val.handle.indexOf('?variant');
          if (text_variant > -1) {
            val.handle = val.handle.substring(text_variant, 0)
          };
          var text_param = val.handle.indexOf('?v=');
          if (text_param > -1) {
            val.handle = val.handle.substring(text_param, 0)
          };
          var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
          var str = val.handle.match(regex);
          if (str !== null) {
            var textArray = val.handle.split("/");
            if (textArray.length > 0) {
              textArray.forEach(function (val, index) {
                textArray[index] = encodeURIComponent(val);
              });
            }
            val.handle = textArray.join("/");
          }
          var element = document.querySelectorAll(`[href="${CSS.escape(val.handle.replace(".js", ""))}"]`).length > 0 ? document.querySelectorAll(`[href="${CSS.escape(val.handle.replace(".js", ""))}"]`) : [],
            element2 = document.querySelectorAll(`[data-href="${CSS.escape(val.handle.replace('.js', ''))}"]`).length > 0 ? document.querySelectorAll(`[data-href="${CSS.escape(val.handle.replace('.js', ''))}"]`) : []
          x = 0;

          if (element2.length > 0 && element.length < 1) {
            element = element2;
          }
          if (element2.length > 0 && element.length > 0) {
            element = [...element, ...element2];
          }
          if (element.length > 0) {
            element.forEach(function (value) {
              if (!!value.querySelector('.hs-content-cart-drawer-loop')) {
                x++;
              }
            });
          }
          if (x > 0) {
            return false;
          }
          fetch(`${val.handle}?v=${(new Date).getTime()}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then((response) => {
              return response.ok ? response.json() : Promise.reject(response);
            })
            .then((json) => {
              itemsProcessed++;
              if (element.length > 1) {
                element.forEach(function (value) {
                  HsApp4.fromCreateVariants(value, json);
                });
              }
              else {
                var elements = document.querySelectorAll(`[href*="${CSS.escape(val.handle.replace(".js", ""))}"]`);
                if (elements.length > 0) {
                  elements.forEach(function (element) {
                    var thisElement = element.getAttribute('href');
                    thisElement = thisElement !== null ? thisElement.split('/') : '';
                    if (thisElement !== '') {
                      if (thisElement.length > 0) {
                        var thisHandle = thisElement[thisElement.length - 1];
                        thisHandle = thisHandle.split('?')
                        if (thisHandle[0] === json.handle) {
                          HsApp4.fromCreateVariants(element, json);
                        };
                      };
                    };
                  });
                };
              }
            })
            .catch(err => {
              itemsProcessed++;
              console.log(err)
            }).then(function () {
              if (itemsProcessed == arr.length) {
                HsApp4.changeVariants();
                var content = document.querySelectorAll('.hs-content-cart-drawer-loop').length > 0 ? document.querySelectorAll('.hs-content-cart-drawer-loop') : [];
                if (content.length > 0) {
                  content.forEach(function (cart) {
                    cart.style.display = 'block';
                  });
                }
                if (!!slideData.cart_animator.enabled_cart_animator) {
                  if (slideData.cart_animator.cart_animator_quick_buy_button !== 'none') {
                    HsApp5.animatedQuickBuyButton();
                  }
                };
              };
            });
        }
      });
    }
  },
  quickBuy: function (id = 0) {
    if (!parseInt(slideData.quick_buy.enabled_quick_buy)) {
      return false;
    }
    if (window.location.pathname.indexOf('/collections/') > -1) {
      if (window.theme) {
        if (window.theme.collectionView) {
          document.addEventListener("scroll", (event) => {

          });
        };
      };
    };

    HsApp4.cssQuickBuyButton();

    var resultValidateDevice = HsApp4.validateQuickBuyDevice();
    switch (parseInt(resultValidateDevice)) {
      case 0:
        return false;
        break;
      case 2:
        return false;
        break;
    };

    var url = window.location.href;
    if (url.indexOf('/products/cart-kokoko') < 0 || url.indexOf('/collections/cart') < 0 || url.indexOf('/pages/cart') < 0 || url.indexOf('/blogs/cart') < 0) {
      if (url.indexOf('/cart') > -1) {
        return false;
      }
    }
    var arr = [], products = [], products2 = [];
    products = document.querySelectorAll('a[href*="products"]').length > 0 ? document.querySelectorAll('a[href*="products"]') : [];
    products2 = document.querySelectorAll('[data-href*="products"]').length > 0 ? document.querySelectorAll('[data-href*="products"]') : [];
    if (products.length > 0 && products2.length > 0) {
      products = [...products, ...products2];

    }
    if (products2.length > 0 && products.length < 1) {
      products = products2;
    }
    if (products.length > 0) {
      products.forEach(function (value, index, array) {
        var collections = '', handle = '', url = '', url2 = '', params = '', urlHref = '', hadleLower = '';
        if (value.closest('.hs-site-cart-popup-layout') !== null) {
          return false;
        }
        if (!!value.getAttribute('href')) {
          url = value.getAttribute('href');
          if (!!value.querySelectorAll('.hs-content-cart-drawer-loop')[0]) {
            return false;
          }
          if (typeof url !== "undefined") {
            if (url.indexOf('/products/') > -1) {
              handle = url.split('/products/');
              collections = handle[0] + '/products/';
              handle = handle[1];

              if (handle.indexOf('?') > -1) {

                handle = handle.split('?');
                params = '?' + handle[1];
                handle = handle[0];

              }
              if (handle.indexOf('#') > -1) {
                handle = handle.split('#');
                params = '#' + handle[1];
                handle = handle[0];
              }
              handle = decodeURIComponent(handle);
              handle = decodeURIComponent(handle);
              handle = decodeURIComponent(handle);
              urlHref = collections + handle + '.js' + params;
              hadleLower = urlHref.toLowerCase();
              if (hadleLower.indexOf('.jpg') > 1 || hadleLower.indexOf('.png') > 1 || hadleLower.indexOf('.jpeg') > 1 || hadleLower.indexOf('.gif') > 1 || hadleLower.indexOf('.com') > 1 /* || hadleLower.indexOf('?variant=') > 1 */) {
                return false;
              }
              arr.push({ handle: urlHref });
            }
          }
        };

        if (!!value.getAttribute('data-href')) {

          url2 = value.getAttribute('data-href');
          if (!!value.querySelectorAll('.hs-content-cart-drawer-loop')[0]) {
            return false;
          }
          if (!!value.getAttribute('data-product-type')) {
            return false;
          }
          if (typeof url2 !== "undefined") {
            if (url2.indexOf('/products/') > -1) {
              handle = url2.split('/products/');
              collections = handle[0] + '/products/';
              handle = handle[1];

              if (handle.indexOf('?') > -1) {

                handle = handle.split('?');
                params = '?' + handle[1];
                handle = handle[0];

              }
              if (handle.indexOf('#') > -1) {
                handle = handle.split('#');
                params = '#' + handle[1];
                handle = handle[0];
              }
              handle = decodeURIComponent(handle);
              handle = decodeURIComponent(handle);
              handle = decodeURIComponent(handle);
              urlHref = collections + handle + '.js' + params;
              hadleLower = urlHref.toLowerCase();
              if (hadleLower.indexOf('.jpg') > 1 || hadleLower.indexOf('.png') > 1 || hadleLower.indexOf('.jpeg') > 1 || hadleLower.indexOf('.gif') > 1 || hadleLower.indexOf('.com') > 1 /* || hadleLower.indexOf('?variant=') > 1 */) {
                return false;
              }
              arr.push({ handle: urlHref });

            }
          }
        };
      });
    };
    if (!!arr) {
      HsApp4.addBuyButton(arr, id);
    }
  },
  init: function () {
    this.quickBuy();
  }
};
/* ============= CART ANIMATOR ============ */
var HsApp5 = {
  animatedHover: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      var hs_sticky = !!document.querySelector('.hs-sticky-cart-cart-drawer') ? document.querySelector('.hs-sticky-cart-cart-drawer') : '';
      if (!!hs_sticky) {
        hs_sticky.addEventListener("mouseover", function (event) {
          var mark = !!hs_sticky.querySelector('mark') ? hs_sticky.querySelector('mark') : '';
          if (!!mark) {
            if (!mark.classList.contains('hs-animated')) {
              mark.classList.add('Hsswing');
              mark.classList.add('hs-animated');
            };
          };
          setTimeout(function () {
            mark.classList.remove('Hsswing');
            mark.classList.remove('hs-animated');
          }, 1000);
        }, false);
      };
    }
  },
  animateStickyCart: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      var stickyCart = !!document.querySelector('.hs-sticky-cart-cart-drawer') ? document.querySelector('.hs-sticky-cart-cart-drawer') : '';
      if (!!stickyCart) {
        setTimeout(function () {
          stickyCart.classList.add('hs-animated');
          stickyCart.classList.add('Hs' + slideData.cart_animator.cart_animator_sticky_cart_button);
        }, 600)
        setTimeout(function () {
          stickyCart.classList.remove('hs-animated');
          stickyCart.classList.remove('Hs' + slideData.cart_animator.cart_animator_sticky_cart_button);
          setTimeout(function () { HsApp5.animateStickyCart(); }, 1000)
        }, slideData.cart_animator.cart_animator_sticky_cart_button_time * 1000);
      };
    }
  },
  animatedAddToCart: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      var addTocart = document.querySelectorAll('button[type="submit"][name="add"]').length > 0 ? document.querySelectorAll('button[type="submit"][name="add"]') : [];
      if (addTocart.length > 0) {
        addTocart.forEach(function (addVal) {
          addVal.classList.add('hs-animated');
          addVal.classList.add('Hs' + slideData.cart_animator.cart_animator_add_cart_button);
        });
        setTimeout(function () {
          addTocart.forEach(function (addVal) {
            addVal.classList.remove('hs-animated');
            addVal.classList.remove('Hs' + slideData.cart_animator.cart_animator_add_cart_button);
          });
          setTimeout(function () { HsApp5.animatedAddToCart(); }, 1000);
        }, slideData.cart_animator.cart_animator_add_cart_button_time * 1000);
      };
    }
  },
  animatedStickyBarButton: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      var stickyBarButton = !!document.querySelector('.hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-checkout-bar-add-to-cart') : '';
      if (!!stickyBarButton) {
        stickyBarButton.classList.add('hs-animated');
        stickyBarButton.classList.add('Hs' + slideData.cart_animator.cart_animator_sticky_bar_button);
        setTimeout(function () {
          stickyBarButton.classList.remove('hs-animated');
          stickyBarButton.classList.remove('Hs' + slideData.cart_animator.cart_animator_sticky_bar_button);
          setTimeout(function () { HsApp5.animatedStickyBarButton(); }, 1000);
        }, slideData.cart_animator.cart_animator_sticky_bar_button_time * 1000);
      };
    }
  },
  animatedQuickBuyButton: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      var quickBuyButton = document.querySelectorAll('.hs-add-to-cart') ? document.querySelectorAll('.hs-add-to-cart') : [];
      if (quickBuyButton.length > 0) {
        quickBuyButton.forEach(function (quickVal) {
          quickVal.classList.add('hs-animated');
          quickVal.classList.add('Hs' + slideData.cart_animator.cart_animator_quick_buy_button);
        });
        setTimeout(function () {
          quickBuyButton.forEach(function (quickVal) {
            quickVal.classList.remove('hs-animated');
            quickVal.classList.remove('Hs' + slideData.cart_animator.cart_animator_quick_buy_button);
          });
          setTimeout(function () { HsApp5.animatedQuickBuyButton(); }, 1000);
        }, slideData.cart_animator.cart_animator_quick_buy_button_time * 1000);
      };
    }
  },
  animatedCheckoutButton: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      var checkoutButton = document.querySelectorAll('.hs-checkout-purchase,button[type="submit"][name="checkout"],input[type="submit"][name="checkout"]').length > 0 ? document.querySelectorAll('.hs-checkout-purchase,button[type="submit"][name="checkout"],input[type="submit"][name="checkout"]') : [];
      if (checkoutButton.length > 0) {
        checkoutButton.forEach(function (checkVal) {
          checkVal.classList.add('hs-animated');
          checkVal.classList.add('Hs' + slideData.cart_animator.cart_animator_checkout_button);
        });
        setTimeout(function () {
          checkoutButton.forEach(function (checkVal) {
            checkVal.classList.remove('hs-animated');
            checkVal.classList.remove('Hs' + slideData.cart_animator.cart_animator_checkout_button);
          });
          setTimeout(function () { HsApp5.animatedCheckoutButton(); }, 1000);
        }, slideData.cart_animator.cart_animator_checkout_button_time * 1000);
      };
    };
  },
  cssCartAnimator: function () {
    var cssCartAnimator = `
              .hs-ini .hs-animated{-webkit-animation-duration:1s !important;animation-duration:1s !important;-webkit-animation-fill-mode:both;animation-fill-mode:both}.hs-animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.hs-animated.Hshinge{-webkit-animation-duration:2s;animation-duration:2s}.hs-animated.HsbounceIn,.hs-animated.HsbounceOut,.hs-animated.HsflipOutX,.hs-animated.HsflipOutY{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes Hsbounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}40%,43%,70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes Hsbounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}40%,43%,70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.Hsbounce{-webkit-animation-name:Hsbounce;animation-name:Hsbounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes Hsflash{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes Hsflash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.Hsflash{-webkit-animation-name:Hsflash;animation-name:Hsflash}@-webkit-keyframes Hspulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes Hspulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.Hspulse{-webkit-animation-name:Hspulse;animation-name:Hspulse}@-webkit-keyframes HsrubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes HsrubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.HsrubberBand{-webkit-animation-name:HsrubberBand;animation-name:HsrubberBand}@-webkit-keyframes Hsshake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes Hsshake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.Hsshake{-webkit-animation-name:Hsshake;animation-name:Hsshake}@-webkit-keyframes HsheadShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes HsheadShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.HsheadShake{-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:HsheadShake;animation-name:HsheadShake}@-webkit-keyframes Hsswing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0);transform:rotate(0)}}@keyframes Hsswing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0);transform:rotate(0)}}.Hsswing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:Hsswing;animation-name:Hsswing}@-webkit-keyframes Hstada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes Hstada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.Hstada{-webkit-animation-name:Hstada;animation-name:Hstada}@-webkit-keyframes Hswobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}@keyframes Hswobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}.Hswobble{-webkit-animation-name:Hswobble;animation-name:Hswobble}@-webkit-keyframes Hsjello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes Hsjello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.Hsjello{-webkit-animation-name:Hsjello;animation-name:Hsjello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes HsbounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes HsbounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}.HsbounceIn{-webkit-animation-name:HsbounceIn;animation-name:HsbounceIn}@-webkit-keyframes HsbounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}@keyframes HsbounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}.HsbounceInDown{-webkit-animation-name:HsbounceInDown;animation-name:HsbounceInDown}@-webkit-keyframes HsbounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes HsbounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}.HsbounceInLeft{-webkit-animation-name:HsbounceInLeft;animation-name:HsbounceInLeft}@-webkit-keyframes HsbounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes HsbounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}.HsbounceInRight{-webkit-animation-name:HsbounceInRight;animation-name:HsbounceInRight}@-webkit-keyframes HsbounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes HsbounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.HsbounceInUp{-webkit-animation-name:HsbounceInUp;animation-name:HsbounceInUp}@-webkit-keyframes HsbounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes HsbounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}.HsbounceOut{-webkit-animation-name:HsbounceOut;animation-name:HsbounceOut}@-webkit-keyframes HsbounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes HsbounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.HsbounceOutDown{-webkit-animation-name:HsbounceOutDown;animation-name:HsbounceOutDown}@-webkit-keyframes HsbounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes HsbounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.HsbounceOutLeft{-webkit-animation-name:HsbounceOutLeft;animation-name:HsbounceOutLeft}@-webkit-keyframes HsbounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes HsbounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.HsbounceOutRight{-webkit-animation-name:HsbounceOutRight;animation-name:HsbounceOutRight}@-webkit-keyframes HsbounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes HsbounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.HsbounceOutUp{-webkit-animation-name:HsbounceOutUp;animation-name:HsbounceOutUp}@-webkit-keyframes HsfadeIn{0%{opacity:0}to{opacity:1}}@keyframes HsfadeIn{0%{opacity:0}to{opacity:1}}.HsfadeIn{-webkit-animation-name:HsfadeIn;animation-name:HsfadeIn}@-webkit-keyframes HsfadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInDown{-webkit-animation-name:HsfadeInDown;animation-name:HsfadeInDown}@-webkit-keyframes HsfadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInDownBig{-webkit-animation-name:HsfadeInDownBig;animation-name:HsfadeInDownBig}@-webkit-keyframes HsfadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInLeft{-webkit-animation-name:HsfadeInLeft;animation-name:HsfadeInLeft}@-webkit-keyframes HsfadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInLeftBig{-webkit-animation-name:HsfadeInLeftBig;animation-name:HsfadeInLeftBig}@-webkit-keyframes HsfadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInRight{-webkit-animation-name:HsfadeInRight;animation-name:HsfadeInRight}@-webkit-keyframes HsfadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInRightBig{-webkit-animation-name:HsfadeInRightBig;animation-name:HsfadeInRightBig}@-webkit-keyframes HsfadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInUp{-webkit-animation-name:HsfadeInUp;animation-name:HsfadeInUp}@-webkit-keyframes HsfadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsfadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.HsfadeInUpBig{-webkit-animation-name:HsfadeInUpBig;animation-name:HsfadeInUpBig}@-webkit-keyframes HsfadeOut{0%{opacity:1}to{opacity:0}}@keyframes HsfadeOut{0%{opacity:1}to{opacity:0}}.HsfadeOut{-webkit-animation-name:HsfadeOut;animation-name:HsfadeOut}@-webkit-keyframes HsfadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes HsfadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.HsfadeOutDown{-webkit-animation-name:HsfadeOutDown;animation-name:HsfadeOutDown}@-webkit-keyframes HsfadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes HsfadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.HsfadeOutDownBig{-webkit-animation-name:HsfadeOutDownBig;animation-name:HsfadeOutDownBig}@-webkit-keyframes HsfadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes HsfadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.HsfadeOutLeft{-webkit-animation-name:HsfadeOutLeft;animation-name:HsfadeOutLeft}@-webkit-keyframes HsfadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes HsfadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.HsfadeOutLeftBig{-webkit-animation-name:HsfadeOutLeftBig;animation-name:HsfadeOutLeftBig}@-webkit-keyframes HsfadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes HsfadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.HsfadeOutRight{-webkit-animation-name:HsfadeOutRight;animation-name:HsfadeOutRight}@-webkit-keyframes HsfadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes HsfadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.HsfadeOutRightBig{-webkit-animation-name:HsfadeOutRightBig;animation-name:HsfadeOutRightBig}@-webkit-keyframes HsfadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes HsfadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.HsfadeOutUp{-webkit-animation-name:HsfadeOutUp;animation-name:HsfadeOutUp}@-webkit-keyframes HsfadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes HsfadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.HsfadeOutUpBig{-webkit-animation-name:HsfadeOutUpBig;animation-name:HsfadeOutUpBig}@-webkit-keyframes Hsflip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn)}0%,40%{-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95)}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes Hsflip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn)}0%,40%{-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95)}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.hs-animated.Hsflip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:Hsflip;animation-name:Hsflip}@-webkit-keyframes HsflipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes HsflipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.HsflipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:HsflipInX;animation-name:HsflipInX}@-webkit-keyframes HsflipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes HsflipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.HsflipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:HsflipInY;animation-name:HsflipInY}@-webkit-keyframes HsflipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@keyframes HsflipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}.HsflipOutX{-webkit-animation-name:HsflipOutX;animation-name:HsflipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@-webkit-keyframes HsflipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@keyframes HsflipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}.HsflipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:HsflipOutY;animation-name:HsflipOutY}@-webkit-keyframes HslightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg)}60%,80%{opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:none;transform:none;opacity:1}}@keyframes HslightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg)}60%,80%{opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:none;transform:none;opacity:1}}.HslightSpeedIn{-webkit-animation-name:HslightSpeedIn;animation-name:HslightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes HslightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}@keyframes HslightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.HslightSpeedOut{-webkit-animation-name:HslightSpeedOut;animation-name:HslightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes HsrotateIn{0%{transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}@keyframes HsrotateIn{0%{transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}.HsrotateIn{-webkit-animation-name:HsrotateIn;animation-name:HsrotateIn}@-webkit-keyframes HsrotateInDownLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes HsrotateInDownLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.HsrotateInDownLeft{-webkit-animation-name:HsrotateInDownLeft;animation-name:HsrotateInDownLeft}@-webkit-keyframes HsrotateInDownRight{0%{transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes HsrotateInDownRight{0%{transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.HsrotateInDownRight{-webkit-animation-name:HsrotateInDownRight;animation-name:HsrotateInDownRight}@-webkit-keyframes HsrotateInUpLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes HsrotateInUpLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.HsrotateInUpLeft{-webkit-animation-name:HsrotateInUpLeft;animation-name:HsrotateInUpLeft}@-webkit-keyframes HsrotateInUpRight{0%{transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes HsrotateInUpRight{0%{transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.HsrotateInUpRight{-webkit-animation-name:HsrotateInUpRight;animation-name:HsrotateInUpRight}@-webkit-keyframes HsrotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}@keyframes HsrotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}.HsrotateOut{-webkit-animation-name:HsrotateOut;animation-name:HsrotateOut}@-webkit-keyframes HsrotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}@keyframes HsrotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}.HsrotateOutDownLeft{-webkit-animation-name:HsrotateOutDownLeft;animation-name:HsrotateOutDownLeft}@-webkit-keyframes HsrotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes HsrotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.HsrotateOutDownRight{-webkit-animation-name:HsrotateOutDownRight;animation-name:HsrotateOutDownRight}@-webkit-keyframes HsrotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes HsrotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.HsrotateOutUpLeft{-webkit-animation-name:HsrotateOutUpLeft;animation-name:HsrotateOutUpLeft}@-webkit-keyframes HsrotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}@keyframes HsrotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}.HsrotateOutUpRight{-webkit-animation-name:HsrotateOutUpRight;animation-name:HsrotateOutUpRight}@-webkit-keyframes Hshinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}@keyframes Hshinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}.Hshinge{-webkit-animation-name:Hshinge;animation-name:Hshinge}@-webkit-keyframes HsrollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes HsrollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}.HsrollIn{-webkit-animation-name:HsrollIn;animation-name:HsrollIn}@-webkit-keyframes HsrollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}@keyframes HsrollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}.HsrollOut{-webkit-animation-name:HsrollOut;animation-name:HsrollOut}@-webkit-keyframes HszoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes HszoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.HszoomIn{-webkit-animation-name:HszoomIn;animation-name:HszoomIn}@-webkit-keyframes HszoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes HszoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.HszoomInDown{-webkit-animation-name:HszoomInDown;animation-name:HszoomInDown}@-webkit-keyframes HszoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes HszoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.HszoomInLeft{-webkit-animation-name:HszoomInLeft;animation-name:HszoomInLeft}@-webkit-keyframes HszoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes HszoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.HszoomInRight{-webkit-animation-name:HszoomInRight;animation-name:HszoomInRight}@-webkit-keyframes HszoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes HszoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.HszoomInUp{-webkit-animation-name:HszoomInUp;animation-name:HszoomInUp}@-webkit-keyframes HszoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}@keyframes HszoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}.HszoomOut{-webkit-animation-name:HszoomOut;animation-name:HszoomOut}@-webkit-keyframes HszoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes HszoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.HszoomOutDown{-webkit-animation-name:HszoomOutDown;animation-name:HszoomOutDown}@-webkit-keyframes HszoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}@keyframes HszoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}.HszoomOutLeft{-webkit-animation-name:HszoomOutLeft;animation-name:HszoomOutLeft}@-webkit-keyframes HszoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}@keyframes HszoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}.HszoomOutRight{-webkit-animation-name:HszoomOutRight;animation-name:HszoomOutRight}@-webkit-keyframes HszoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes HszoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.HszoomOutUp{-webkit-animation-name:HszoomOutUp;animation-name:HszoomOutUp}@-webkit-keyframes HsslideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes HsslideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.HsslideInDown{-webkit-animation-name:HsslideInDown;animation-name:HsslideInDown}@-webkit-keyframes HsslideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes HsslideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.HsslideInLeft{-webkit-animation-name:HsslideInLeft;animation-name:HsslideInLeft}@-webkit-keyframes HsslideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes HsslideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.HsslideInRight{-webkit-animation-name:HsslideInRight;animation-name:HsslideInRight}@-webkit-keyframes HsslideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes HsslideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.HsslideInUp{-webkit-animation-name:HsslideInUp;animation-name:HsslideInUp}@-webkit-keyframes HsslideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes HsslideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.HsslideOutDown{-webkit-animation-name:HsslideOutDown;animation-name:HsslideOutDown}@-webkit-keyframes HsslideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes HsslideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.HsslideOutLeft{-webkit-animation-name:HsslideOutLeft;animation-name:HsslideOutLeft}@-webkit-keyframes HsslideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes HsslideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.HsslideOutRight{-webkit-animation-name:HsslideOutRight;animation-name:HsslideOutRight}@-webkit-keyframes HsslideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes HsslideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.HsslideOutUp{-webkit-animation-name:HsslideOutUp;animation-name:HsslideOutUp}
              `;
    document.querySelector('html').classList.add('hs-ini');
    document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">' + cssCartAnimator + '</style>');
  },
  cartAnimator: function () {
    if (!!slideData.cart_animator.enabled_cart_animator) {
      HsApp5.cssCartAnimator();
      HsApp5.animatedHover();
      if (slideData.cart_animator.cart_animator_sticky_cart_button !== 'none') {
        HsApp5.animateStickyCart();
      }
      if (slideData.cart_animator.cart_animator_add_cart_button !== 'none') {
        HsApp5.animatedAddToCart();
      }
      if (slideData.cart_animator.cart_animator_sticky_bar_button !== 'none') {
        HsApp5.animatedStickyBarButton();
      }
      if (slideData.cart_animator.cart_animator_quick_buy_button !== 'none') {
        HsApp5.animatedQuickBuyButton();
      }
      if (slideData.cart_animator.cart_animator_checkout_button !== 'none') {
        HsApp5.animatedCheckoutButton();
      }
    }
    else {
      return false;
    }
  },

  init: function () {
    HsApp5.cartAnimator();
  }
};
/* ============== COUPON BAR ============== */
var HsApp6 = {
  cssCouponBar: function () {
    /* var this_top = 0, size_screen = window.innerWidth || 1024;
    //if (parseInt(slideData.coupon_bar.coupon_bar_position)) {
      if(Hs_CartDrawer.coupon_bar_desktop_positionOffset == 0){
        if(size_screen > 769){
          countdown_h = document.querySelector('.hs-coupon-bar-countdown-offer').offsetHeight;
          countdown_h = countdown_h + 20;
          countdown_h = countdown_h + 'px';
          this_top = countdown_h;
        };
      };
      if(Hs_CartDrawer.coupon_bar_mobile_positionOffset == 0){
        if(size_screen <= 769){
          countdown_h = document.querySelector('.hs-coupon-bar-countdown-offer').offsetHeight;
          countdown_h = countdown_h + 20;
          countdown_h = countdown_h + 'px';
          this_top = countdown_h;
        };
      };
    //}; */


    var content = `
              .modal-open .hs-coupon-bar-countdown-offer {\
                z-index: 0 !important;\
              }\
              .hs-coupon-bar-countdown-offer{\
                top: ${Hs_CartDrawer.coupon_bar_desktop_positionOffset}px;\
              }\
              .hs-coupon-bar-countdown-offer-content{\
                background: ${slideData.coupon_bar.coupon_bar_background_color_hex};\
                color: ${slideData.coupon_bar.coupon_bar_font_color_hex};\
                text-align: ${slideData.coupon_bar.coupon_bar_text_alignment};\
                font-weight: ${slideData.coupon_bar.coupon_bar_font_weight};\
                text-transform: ${slideData.coupon_bar.coupon_bar_text_transform};\
                font-size: ${slideData.coupon_bar.coupon_bar_font_size};\
                top: ${Hs_CartDrawer.coupon_bar_desktop_positionOffset}px;\
              }\
              .hs-coupon-bar-countdown-slide-cart{\
                  color: #504f4f;\
                  font-weight: 400;\
                  background: #fff;\
                  padding: 5px 10px;\
                  display: inline-block;\
                  margin: 5px 6px;\
              }\
              @media (max-width: 1024px) {\
                .hs-coupon-bar-countdown-offer-content {\
                    font-size: 16px;\
                }\
            }\
            @media (max-width: 769px) {\
                .hs-coupon-bar-countdown-offer-content {\
                  top: ${Hs_CartDrawer.coupon_bar_mobile_positionOffset}px;
                }\
            }\
            @media (max-width: 600px) {\
                .hs-coupon-bar-countdown-offer-content {\
                    font-size: 14px;\
                }\
                .hs-coupon-bar-countdown-offer-mobile {\
                  display: block;\
                  margin: 0 auto;\
                }\
            }`;
    document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">' + content + '</style>');
  },
  timerOfferCouponBar: function () {
    var minutesCouponBar = parseInt(slideData.coupon_bar.coupon_bar_timer), secondsCouponBar = 60 * minutesCouponBar;
    this.countdownCouponBar(minutesCouponBar, secondsCouponBar);
  },
  countdownCouponBar: function (minutesCouponBar, secondsCouponBar) {
    if (!HsApp1.readCookie('hs-coupon-bar')) {
      HsApp1.createCpokie('hs-coupon-bar', minutesCouponBar, 360);
    }
    else {
      if (HsApp1.readCookie('hs-coupon-bar') != minutesCouponBar) {
        HsApp1.deleteCookie('hs-coupon-bar');
        HsApp1.createCpokie('hs-coupon-bar', minutesCouponBar, 360);
        sessionStorage.setItem("seconds", secondsCouponBar)
      }
    }

    secondsCouponBar = parseInt(sessionStorage.getItem("seconds")) || secondsCouponBar;
    function tick() {

      secondsCouponBar--
      sessionStorage.setItem("seconds", secondsCouponBar)
      var currentDate = new Date();
      var desktop_seconds = currentDate.getSeconds();
      var desktop_minutes = currentDate.getMinutes();
      var desktop_minutes = desktop_minutes * 60;
      var desktop_minutes = desktop_minutes + desktop_seconds;
      /* if (minutesCouponBar > 60) {
        secondsCouponBar = secondsCouponBar - 1;
        secondsCouponBar = secondsCouponBar - desktop_minutes;
      } */
      var current_hours = Math.floor(secondsCouponBar / 3600);
      var current_minutes = parseInt(secondsCouponBar / 60) % 60;
      var current_seconds = secondsCouponBar % 60;

      var text_hours = ' ' + slideData.coupon_bar.coupon_bar_hours;
      var text_minutes = ' ' + slideData.coupon_bar.coupon_bar_minutes;
      var text_seconds = ' ' + slideData.coupon_bar.coupon_bar_seconds;

      if (current_hours < 10) {
        current_hours = '0' + current_hours;
      };
      if (current_minutes < 10) {
        current_minutes = '0' + current_minutes;
      };
      if (current_seconds < 10) {
        current_seconds = '0' + current_seconds;
      };
      /* return false; */
      !!document.getElementById('hs-coupon-bar-countdown') ? document.getElementById('hs-coupon-bar-countdown').innerHTML = `
              <span class='hs-coupon-bar-countdown-slide-cart'>${current_hours} ${text_hours}</span>
              <span class='hs-coupon-bar-countdown-slide-cart'>${current_minutes} ${text_minutes}</span>
              <span class='hs-coupon-bar-countdown-slide-cart'>${current_seconds} ${text_seconds}</span>` : '';
      if (secondsCouponBar > 0) {
        setTimeout(tick, 1000);
      } else {
        HsApp1.deleteCookie('hs-coupon-bar');
        sessionStorage.removeItem("seconds");
        if (parseInt(slideData.coupon_bar.coupon_bar_clear_offer)) {
          document.querySelector('.hs-coupon-bar-countdown-offer').innerHTML = slideData.coupon_bar.coupon_bar_text_expire;
          setTimeout(function () { document.querySelector('.hs-coupon-bar-countdown-offer').remove(); }, 3000);
        }
        else {
          HsApp6.timerOfferCouponBar();
        }
      }
    };
    tick();
  },
  couponBar: function () {
    if (!parseInt(slideData.coupon_bar.enabled_coupon_bar)) {
      HsApp1.deleteCookie('hs-coupon-bar');
      sessionStorage.removeItem("seconds");
      return false;
    }
    if (!!document.querySelector('.hs-coupon-bar-countdown-offer')) {
      return false;
    };
    this.cssCouponBar();
    var countdown_offer = '', text_countdown_offer = '', text_styles = '', countdown_h = 0;
    text_countdown_offer = slideData.coupon_bar.coupon_bar_text;
    text_countdown_offer = text_countdown_offer.replace("{{ COUNTDOWN }}", "<span class='hs-coupon-bar-countdown-offer-mobile'><span id='hs-coupon-bar-countdown'></span></span>");
    text_styles = 'padding:5px 10px;width:100%;position:absolute;left:0px;z-index:2147483635;';
    //text_styles = 'padding:5px 10px;width:100%;position:absolute;left:0px;z-index:2147483635;';
    if (parseInt(slideData.coupon_bar.coupon_bar_position)) {
      //text_styles = 'padding:5px 10px;width:100%;position:fixed;left:0px;z-index:2147483635;';
      text_styles = 'padding:5px 10px;width:100%;position:fixed;left:0px;z-index:2147483635;';
    }
    countdown_offer = '<div class="hs-coupon-bar-countdown-offer"><div class="hs-coupon-bar-countdown-offer-content" role="region" tabindex="0" style="' + text_styles + '">' + text_countdown_offer + '</div></div>';
    document.querySelector('body').insertAdjacentHTML('afterbegin', countdown_offer);
    /* if (parseInt(slideData.coupon_bar.coupon_bar_position)) {
      if(Hs_CartDrawer.coupon_bar_desktop_positionOffset == 0 || Hs_CartDrawer.coupon_bar_mobile_positionOffset){
        countdown_h = document.querySelector('.hs-coupon-bar-countdown-offer').offsetHeight;
        countdown_h = countdown_h + 20;
        countdown_h = countdown_h + 'px';
        document.querySelector('body').style.paddingTop = countdown_h;
      };
    } */
    setTimeout(function () {
      var this_top = 0, countdown_h = document.querySelector('.hs-coupon-bar-countdown-offer-content').offsetHeight || 0, size_screen = window.innerWidth || 1024;
      //if (parseInt(slideData.coupon_bar.coupon_bar_position)) {
      //this_top =  countdown_h + 'px';
      if (Hs_CartDrawer.coupon_bar_desktop_positionOffset == 0) {
        if (size_screen > 769) {
          //if (slideData.coupon_bar.coupon_bar_position == 0) {
          //countdown_h = countdown_h + 20;
          this_top = countdown_h + 'px';
          //};
        };
      };
      if (Hs_CartDrawer.coupon_bar_mobile_positionOffset == 0) {
        if (size_screen <= 769) {
          //if (slideData.coupon_bar.coupon_bar_position == 0) {
          //countdown_h = countdown_h + 20;
          this_top = countdown_h + 'px';
          //};
        };
      };
      //};
      //document.querySelector('body').style.paddingTop = this_top;
      document.querySelector('.hs-coupon-bar-countdown-offer').style.height = this_top;
      try {
        if (Hs_CartDrawer.coupon_bar_desktop_positionOffset > 0) {
          if (size_screen > 769) {
            countdown_h = 0;
          };
        };
        if (Hs_CartDrawer.coupon_bar_mobile_positionOffset > 0) {
          if (size_screen <= 769) {
            countdown_h = 0;
          };
        };
        window.Hs_couponBar_navs(slideData, countdown_h)
      } catch (error) {
        console.log(error)
      }
    }, 200);

    HsApp6.timerOfferCouponBar();
  },
  init: function () {
    this.couponBar();
  }
};
/* ================= CART REDIRECT LOGIC ================= */
var _HsCartRedirect = function () {
  try {
    if (typeof window.HSSLIDECART === 'undefined' || !window.HSSLIDECART.setSettings) return;

    var slideData = window.HSSLIDECART.setSettings;
    var redirectEnabled = slideData?.settings?.additional_settings?.cart_redirect_enabled;
    var redirectUrl = slideData?.settings?.additional_settings?.cart_redirect_url;

    // Salir si la opción no está activada
    if (!redirectEnabled) return;

    // Obtener root de Shopify (prefijo de país/lenguaje) si existe
    var shopRoot = window.Shopify?.routes?.root || '/';
    shopRoot = shopRoot.endsWith('/') ? shopRoot.slice(0, -1) : shopRoot; // quitar "/" final

    // Detectar si estamos en la página cart real
    var currentPath = window.location.pathname.replace(/\/$/, '');
    if (currentPath === shopRoot + '/cart') {

      // Valor por defecto
      if (!redirectUrl || redirectUrl.trim() === '') {
        redirectUrl = '/';
      }

      // Asegurar slash inicial
      if (!redirectUrl.startsWith('/')) {
        redirectUrl = '/' + redirectUrl;
      }

      var fullPath;

      // Evitar duplicar prefijo (ej: /es-ca/es-ca/cart)
      if (!redirectUrl.startsWith(shopRoot)) {
        fullPath = shopRoot + redirectUrl;
      } else {
        fullPath = redirectUrl;
      }

      // Limpiar dobles slashes
      fullPath = fullPath.replace(/\/{2,}/g, '/');

      // Construir URL completa
      var finalUrl = new URL(fullPath, window.location.origin);

      // Agregar parámetro
      finalUrl.searchParams.set('hsviewcart', 'true');

      // Redirigir
      window.location.replace(finalUrl.toString());
    }

  } catch (e) {
    console.error('Error _HsCartRedirect:', e);
  }
};
/* ================ ADD SCRIPT HEADER AND CALLBACK ================ */
var _HsLoadScript = function (url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.setAttribute('defer', 'defer');
  // If the browser is Internet Explorer.
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
    // For any other browser.
  } else {
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};
var _HsLoadScriptModule = function (url, nomodule, type = '', callback) {
  var script = document.createElement("script");
  !!nomodule ? script.setAttribute('nomodule', '') : '';
  type !== '' ? script.type = type : "";
  script.setAttribute('defer', 'defer');
  // If the browser is Internet Explorer.
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
    // For any other browser.
  } else {
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};
var _HsApplyLocalesPatch = function (obj, key, patch) {
  if (!obj || typeof obj !== 'object' || !patch) return false;

  var ID_FIELDS = {
    announcement_tiers: 'announcement_id',
    rewards_specific_countries_tiers: 'reward_id',
    rewards_all_countries_tiers: 'reward_id',
    special_offer_notification_tier: 'id',
    tiered_free_items_tiers: null // sin id, se hace por orden
  };

  try {
    var names = [key, key + 's', key.replace(/_tier$/, '_tiers')];

    for (var k in obj) {
      if (names.indexOf(k) === -1) continue;

      var target = obj[k];

      // caso ARRAY (locale viene como { "3813": {...} })
      if (Array.isArray(target) && typeof patch === 'object' && !Array.isArray(patch)) {
        var sample = target[0] || {};
        var idField = ID_FIELDS[k] || Object.keys(sample).find(function (f) {
          return f.endsWith('_id');
        });

        if (idField) {
          for (var id in patch) {
            if (!patch.hasOwnProperty(id)) continue;
            var item = target.find(function (it) {
              return String(it[idField]) === String(id);
            });
            // solo sobreescribe si existe el item Y el patch
            if (item && patch[id]) Object.assign(item, patch[id]);
          }
        } else {
          // sin ID -> por orden, mantiene original si no hay patch
          var i = 0;
          for (var pid in patch) {
            if (!patch.hasOwnProperty(pid)) continue;
            if (target[i] && patch[pid]) Object.assign(target[i], patch[pid]);
            i++;
          }
        }
      }
      // caso OBJETO simple
      else if (target && typeof target === 'object' && typeof patch === 'object') {
        Object.assign(target, patch);
      }
      return true;
    }

    // busca recursivo (settings.cart_empty, top-level cart_bar, etc.)
    for (var kk in obj) {
      if (obj[kk] && typeof obj[kk] === 'object') {
        if (_HsApplyLocalesPatch(obj[kk], key, patch)) {
          return true;
        }
      }
    }
  } catch (e) {
    console.warn('Locale patch error in', key, e);
    // no rompe nada, deja el valor original
  }
  return false;
};
/* ================ MY APP JAVASCRIPT ================ */
var _HsMyAppJavaScript = function () {
  if (typeof _HsHandlebars === 'undefined') {
    setTimeout(function () {
      _HsMyAppJavaScript();
    }, 500);
    return false;
  };

  if (window.HSSLIDECART.length == 0) {
    console.log(
      `%c${'Slide Cart Upsell Not Charge'}`, // todo lo que aparece despues de %c tiene estilo
      `background: #4871ff; color: #fff; font-size: 13px; font-weight:bold; padding: 5px 10px; border-radius: 3px`
    );
    return false;
  }
  slideData = window.HSSLIDECART.setSettings;

  var lang = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en');
  var loc = slideData.locale && slideData.locale[lang];

  if (loc) {
    for (var k in loc) {
      if (loc.hasOwnProperty(k)) {
        _HsApplyLocalesPatch(slideData, k, loc[k]); // si falla, no toca slideData
      }
    }
  }

  if (typeof slideData == 'undefined') {
    return false;
  }
  // Llamar redirect al inicio de la app
  _HsCartRedirect();

  /* ================ RESET REWARDS ADD ================ */
  HsApp1.autoRewardsOff();
  HsApp1.resetRewards();

  var size = Object.keys(slideData).length;

  if (size < 1) {
    return false;
  };
  if (!slideData?.settings?.additional_check?.enabled_additional_checkout_buttons) {
    const hs_dynamic_checkout_buttons = document.getElementById('hs--dynamic-checkout-buttons') || '';
    if (hs_dynamic_checkout_buttons) {
      hs_dynamic_checkout_buttons.remove();
    }
  };

  if (parseInt(slideData.dashboard.dashboard_general_app) < 1) {
    return false;
  };
  console.log(
    `%c${'Slide Cart Upsell is Loaded ... 🚀'}`, // todo lo que aparece despues de %c tiene estilo
    `background: #4871ff; color: #fff; font-size: 13px; font-weight:bold; padding: 5px 10px; border-radius: 3px`
  );

  window.HSSLIDECART.money_format = window?.HSSLIDECART?.money_format || '';
  window.HSSLIDECART.money_currency_format = window?.HSSLIDECART?.money_currency_format || '';

  let money_store = window.HSSLIDECART.money_html || '';
  if (!money_store) {
    money_store = slideData.settings.devices.money_format;
  };

  var documentFragment = Hs_CartDrawer.parseHTML(money_store);
  if (typeof documentFragment.children === 'object' && documentFragment.children.length > 0) {
    documentFragment = documentFragment.children[0];
    if (documentFragment.className) {
      window.hs_class_money = documentFragment.className;
    };
  };

  /* Rewards Products */
  window.HSSLIDECART.setSettings.rewardsProducts = [];

  /* SLIDE AUTO PLAY ANNOUNCEMENT */
  if (typeof slideData.settings.announcement.announcement_autoplay_time !== 'undefined') {
    Hs_CartDrawer.announcement_autoplay_time = parseInt(slideData.settings.announcement.announcement_autoplay_time) * 1000;
  };

  //COUPON BAR
  if (typeof slideData.coupon_bar.coupon_bar_desktop_positionOffset !== 'undefined') {
    Hs_CartDrawer.coupon_bar_desktop_positionOffset = parseInt(slideData.coupon_bar.coupon_bar_desktop_positionOffset);
  };
  if (typeof slideData.coupon_bar.coupon_bar_mobile_positionOffset !== 'undefined') {
    Hs_CartDrawer.coupon_bar_mobile_positionOffset = parseInt(slideData.coupon_bar.coupon_bar_mobile_positionOffset);
  };

  /* CUSTOMIZE */
  if (typeof slideData.customize !== 'undefined') {
    if (typeof slideData.customize.customize_slidecart_time_transition !== 'undefined') {
      Hs_CartDrawer.transition_time = slideData.customize.customize_slidecart_time_transition;
    };

    if (typeof slideData.customize.customize_body_design_qty !== 'undefined') {
      Hs_CartDrawer.designQty = slideData.customize.customize_body_design_qty;
    };
    if (typeof slideData.customize.customize_slidecart_position !== 'undefined') {
      Hs_CartDrawer.slidePositon = slideData.customize.customize_slidecart_position;
    };
    if (typeof slideData.customize.customize_slidecart_rtl !== 'undefined') {
      if (!!slideData.customize.customize_slidecart_rtl) {
        Hs_CartDrawer.rtl = 'hs-layout-rtl';
      }
    };
    if (typeof slideData.customize.customize_slidecart_animation_mobile !== 'undefined') {
      Hs_CartDrawer.animationSlideMobile = slideData.customize.customize_slidecart_animation_mobile;
    };
    if (typeof slideData.customize.customize_slidecart_footer_fixed !== 'undefined') {
      Hs_CartDrawer.footer_fixed = slideData.customize.customize_slidecart_footer_fixed;
    };
    if (typeof slideData.customize.customize_body_upsell_enabled_sale_price !== 'undefined') {
      Hs_CartDrawer.customize_upsell_sale_price = slideData.customize.customize_body_upsell_enabled_sale_price;
    };
    if (typeof slideData.customize.customize_popup_enabled_sale_price !== 'undefined') {
      Hs_CartDrawer.customize_popUp_sale_price = slideData.customize.customize_popup_enabled_sale_price;
    };
    if (typeof slideData.customize.customize_body_enabled_sale_price !== 'undefined') {
      Hs_CartDrawer.customize_body_sale_price = slideData.customize.customize_body_enabled_sale_price;
    };

    if (typeof slideData.customize.customize_popup_var_options_design !== 'undefined') {
      Hs_CartDrawer.upsell_popUp_design = slideData.customize.customize_popup_var_options_design;
    };
  };
  /* LANGUAGE */
  if (typeof slideData.settings.language_settings.free_language_settings !== 'undefined') {
    Hs_CartDrawer.languageFree = slideData.settings.language_settings.free_language_settings;
  };
  if (typeof slideData.settings.language_settings.free_gnral_language_settings !== 'undefined') {
    Hs_CartDrawer.languageFreeGnral = slideData.settings.language_settings.free_gnral_language_settings;
  };
  if (typeof slideData.settings.language_settings.rc_withOutSub_in_upsell_language_settings !== 'undefined') {
    Hs_CartDrawer.withOutSub = slideData.settings.language_settings.rc_withOutSub_in_upsell_language_settings;
  };
  if (typeof slideData.settings.language_settings.rc_withSub_in_upsell_language_settings !== 'undefined') {
    Hs_CartDrawer.withSubAndDscto = Hs_CartDrawer.unEscape(slideData.settings.language_settings.rc_withSub_in_upsell_language_settings);
  };
  if (typeof slideData.settings.language_settings.rc_withSubOnly_in_upsell_language_settings !== 'undefined') {
    Hs_CartDrawer.withSubOnly = slideData.settings.language_settings.rc_withSubOnly_in_upsell_language_settings || Hs_CartDrawer.withSubAndDscto;
  } else {
    Hs_CartDrawer.withSubOnly = Hs_CartDrawer.withSubAndDscto;
  };

  if (typeof slideData.settings.language_settings.rc_upgrade_language_settings !== 'undefined') {
    Hs_CartDrawer.upgrade_text = slideData.settings.language_settings.rc_upgrade_language_settings;
  };

  if (typeof slideData.settings.language_settings.rc_downgrade_language_settings !== 'undefined') {
    Hs_CartDrawer.downgrade_text = slideData.settings.language_settings.rc_downgrade_language_settings;
  };


  /* ADDITIONAL SETTINGS */
  if (typeof slideData.settings.additional_settings.show_prices_x_qty !== 'undefined') {
    Hs_CartDrawer.typePrice = slideData.settings.additional_settings.show_prices_x_qty;
  };
  if (typeof slideData.settings.additional_settings.hide_decimal !== 'undefined') {
    Hs_CartDrawer.hiddenDecNum = slideData.settings.additional_settings.hide_decimal;
  };
  if (typeof slideData.settings.additional_settings.show_unit_price !== 'undefined') {
    Hs_CartDrawer.display_unit_price = slideData.settings.additional_settings.show_unit_price;
  };
  if (typeof slideData.settings.additional_settings.reverse_currency_symbol !== 'undefined') {
    Hs_CartDrawer.afterSymbol = parseInt(slideData.settings.additional_settings.reverse_currency_symbol);
  };
  if (typeof slideData.settings.additional_settings.selected_subscribe_upsell !== 'undefined') {
    Hs_CartDrawer.subscribe = slideData.settings.additional_settings.selected_subscribe_upsell;
  };
  if (typeof slideData.settings.additional_settings.hide_discount_money_cart !== 'undefined') {
    Hs_CartDrawer.hidenDiscount = slideData.settings.additional_settings.hide_discount_money_cart;
  };
  if (typeof slideData.settings.additional_settings.show_weight !== 'undefined') {
    Hs_CartDrawer.show_weight = slideData.settings.additional_settings.show_weight;
  };
  if (typeof slideData.settings.additional_settings.show_subscription_option !== 'undefined') {
    Hs_CartDrawer.upgrade_charge = slideData.settings.additional_settings.show_subscription_option;
  };
  if (typeof slideData.settings.additional_settings.show_subscription_option_upsell !== 'undefined') {
    Hs_CartDrawer.subscribe_option_upsell = slideData.settings.additional_settings.show_subscription_option_upsell;
  };
  if (typeof slideData.settings.additional_settings.hidden_variant_title_cart !== 'undefined') {
    Hs_CartDrawer.hiddenVarianTitleCart = slideData.settings.additional_settings.hidden_variant_title_cart;
  };
  if (typeof slideData.settings.additional_settings.base_price_for_discount !== 'undefined') {
    Hs_CartDrawer.show_base_price_discount = slideData.settings.additional_settings.base_price_for_discount;
  };

  if (typeof slideData.settings.additional_settings.show_save_item !== 'undefined') {
    Hs_CartDrawer.showSaveItem = slideData.settings.additional_settings.show_save_item;
  };
  if (typeof slideData.settings.additional_settings.show_discount_order_x_item !== 'undefined') {
    Hs_CartDrawer.discount_order_x_item = slideData.settings.additional_settings.show_discount_order_x_item;
  };
  if (typeof slideData.settings.additional_settings.prices_reverse_order !== 'undefined') {
    Hs_CartDrawer.prices_reverse_order = slideData.settings.additional_settings.prices_reverse_order;
  };

  if (typeof slideData.settings.additional_settings.add_url_item_cart !== 'undefined') {
    Hs_CartDrawer.add_url_item_cart = slideData.settings.additional_settings.add_url_item_cart;
  };

  if (typeof slideData.settings.additional_settings.hide_discount_list_footer !== 'undefined') {
    Hs_CartDrawer.hide_discount_list_footer = slideData.settings.additional_settings.hide_discount_list_footer;
  };


  /* REWARDS */
  if (typeof slideData.settings.rewards.rewards_show_goals !== 'undefined') {
    Hs_CartDrawer.rewardShowGoal = slideData.settings.rewards.rewards_show_goals;
  };

  if (typeof slideData.cart_bar.cart_bar_show_prices_x_qty !== 'undefined') {
    Hs_CartDrawer.cartBar_typePrice = slideData.cart_bar.cart_bar_show_prices_x_qty;
  };

  if (typeof slideData.settings.devices.cart_type === 'undefined') {
    slideData.settings.devices.cart_type = 0;
    if (typeof slideData.customize !== 'undefined') {
      if (typeof slideData.customize.customize_slidecart_position !== 'undefined') {
        if (slideData.customize.customize_slidecart_position == 2) {
          slideData.settings.devices.cart_type = 1;
        };
      };
    };
  };

  /* SLIDE PERV VIEW CART EMPTY UPSELL */
  if (typeof slideData.settings.cart_empty.cart_empty_upsell_qty !== 'undefined') {
    Hs_CartDrawer.cart_empty_upsell_qty = parseInt(slideData.settings.cart_empty.cart_empty_upsell_qty);
  };
  if (typeof slideData.settings.cart_empty.cart_empty_upsell_autoplay_time !== 'undefined') {
    Hs_CartDrawer.cart_empty_upsell_autoplay_time = parseInt(slideData.settings.cart_empty.cart_empty_upsell_autoplay_time) * 1000;
  };
  /* SLIDE PERV VIEW AUTOMATIC PRODUCTS UPSELL */
  if (typeof slideData.settings.product_recommendations_settings.slides_per_view_automatic !== 'undefined') {
    Hs_CartDrawer.apu_qty_per_view = parseInt(slideData.settings.product_recommendations_settings.slides_per_view_automatic);
  };
  if (typeof slideData.settings.product_recommendations_settings.slides_autoplay_time_automatic !== 'undefined') {
    Hs_CartDrawer.apu_autoplay_time = parseInt(slideData.settings.product_recommendations_settings.slides_autoplay_time_automatic) * 1000;
  };
  /* SLIDE PERV VIEW MANUALLY PRODUCTS UPSELL */
  if (typeof slideData.settings.manually_products_upsells.slides_per_view_manually !== 'undefined') {
    Hs_CartDrawer.mpu_qty_per_view = parseInt(slideData.settings.manually_products_upsells.slides_per_view_manually);
  };
  if (typeof slideData.settings.manually_products_upsells.slides_autoplay_time_manually !== 'undefined') {
    Hs_CartDrawer.mpu_autoplay_time = parseInt(slideData.settings.manually_products_upsells.slides_autoplay_time_manually) * 1000;
  };
  /* SLIDE PERV VIEW STATIC PRODUCTS UPSELL */
  if (typeof slideData.settings.static_products_upsells !== 'undefined') {
    if (typeof slideData.settings.static_products_upsells.slides_per_view_static !== 'undefined') {
      Hs_CartDrawer.spu_qty_per_view = parseInt(slideData.settings.static_products_upsells.slides_per_view_static);
    };
    if (typeof slideData.settings.static_products_upsells.slides_autoplay_time_static !== 'undefined') {
      Hs_CartDrawer.spu_autoplay_time = parseInt(slideData.settings.static_products_upsells.slides_autoplay_time_static) * 1000;
    };
  };

  if (typeof slideData.settings.tiered_free_items !== 'undefined') {
    /* SLIDE PERV VIEW TIERED PRODUCTS UPSELL */
    if (typeof slideData.settings.tiered_free_items.tfi_slides_per_view !== 'undefined') {
      Hs_CartDrawer.tiered_qty_per_view = parseInt(slideData.settings.tiered_free_items.tfi_slides_per_view);
    };
    if (typeof slideData.settings.tiered_free_items.tfi_slides_autoplay_time !== 'undefined') {
      Hs_CartDrawer.tiered_autoplay_time = parseInt(slideData.settings.tiered_free_items.tfi_slides_autoplay_time) * 1000;
    };
    /* TIERED LOCK METHOD */
    if (typeof slideData.settings.tiered_free_items.tfi_lock_method !== 'undefined') {
      Hs_CartDrawer.tfi_lock_method = parseInt(slideData.settings.tiered_free_items.tfi_lock_method);
    };
  };

  /* SETTINGS FOOTER */
  if (typeof slideData.settings.settings_footer !== 'undefined') {
    Hs_CartDrawer.shipping = parseInt(slideData.settings.settings_footer.enabled_free_shipping);
    Hs_CartDrawer.total_save = parseInt(slideData.settings.settings_footer.enabled_total_save);
  };

  /* SETTINGS SHIPPING PROTECTION */
  if (typeof slideData.settings.shipping_protection !== 'undefined') {
    if (typeof slideData.settings.shipping_protection.sp_auto_add !== 'undefined') {
      Hs_CartDrawer.auto_add_shipping_protection = parseInt(slideData.settings.shipping_protection.sp_auto_add);
    };
  };

  /* SETTINGS ADDITIONAL CART NOTE */
  if (typeof slideData.settings.cart_note.cart_note_additional !== 'undefined') {
    Hs_CartDrawer.cart_note_additional = parseInt(slideData.settings.cart_note.cart_note_additional);
  };

  /* SETTINGS MINIMUM ORDER */
  if (typeof slideData.settings.minimum_order.minimum_order_option !== 'undefined') {
    Hs_CartDrawer.minimum_order_option = parseInt(slideData.settings.minimum_order.minimum_order_option);
  };


  /* STICKY CART */
  if (typeof slideData.sticky_cart.sticky_cart_show_countdown !== 'undefined') {
    Hs_CartDrawer.sticky_cart_countdown = parseInt(slideData.sticky_cart.sticky_cart_show_countdown);
  };

  /* DISCOUNT COUPON */
  if (typeof slideData.settings.cart_coupon.position_cart_coupon_button !== 'undefined') {
    Hs_CartDrawer.positionDiscountCoupon = parseInt(slideData.settings.cart_coupon.position_cart_coupon_button);
  };

  if (typeof slideData.settings.checkout_button.checkout_button_show_subtotal_text !== 'undefined') {
    Hs_CartDrawer.checkout_button_show_subtotal_text = parseInt(slideData.settings.checkout_button.checkout_button_show_subtotal_text);
  };


  if (!!window.Shopify) {
    if (!!window.Shopify.currency) {
      if (!!window.Shopify.currency.rate) {
        if (+window.Shopify.currency.rate < 1 || +window.Shopify.currency.rate > 1) {
          slideData.settings.gift_wrap.offer_price = (Math.ceil((parseFloat(slideData.settings.gift_wrap.offer_price * 100) * parseFloat(Shopify.currency.rate).toFixed(2)) / 100)).toFixed(2);
          slideData.settings.gift_wrap.offer_compare_price = (Math.ceil((parseFloat(slideData.settings.gift_wrap.offer_compare_price * 100) * parseFloat(Shopify.currency.rate).toFixed(2)) / 100)).toFixed(2);
        };
      };
    };
  };

  let currency_format = window.HSSLIDECART.money_format;
  if (typeof slideData.settings.additional_settings.currency_format_type !== 'undefined') {
    const currency = +slideData.settings.additional_settings.currency_format_type;
    if (currency) {
      currency_format = window.HSSLIDECART.money_currency_format;
    };
  };

  if (currency_format !== '') {
    /* const parser = new DOMParser();
  const doc = parser.parseFromString(currency_format, 'text/html');
  const textDeco = doc?.documentElement?.textContent || '';
  let inner = textDeco.match(/<span[^>]*>(.*?)<\/span>/)?.[1] || textDeco;
  inner = !!Hs_CartDrawer.afterSymbol ? inner.replace(/€\s*({{\s*[^}]+\s*}})/, '$1 €') : inner;
  slideData.settings.devices.money_format = inner; */

    // Paso 1: Decodificar HTML escapado
    function decodeHTMLEntities(str) {
      const txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    }

    // Decodificamos
    const decoded = decodeHTMLEntities(currency_format);  // <span id='rupee_symbol'>₹</span> {{ amount_no_decimals }}

    // Paso 2: Insertamos en un div y extraemos texto plano
    const container = document.createElement('div');
    container.innerHTML = decoded;

    let inner = container.textContent.trim();

    // Paso 3: Ajustamos símbolo si es necesario
    inner = !!Hs_CartDrawer.afterSymbol ? inner.replace(/€\s*({{\s*[^}]+\s*}})/, '$1 €') : inner;

    slideData.settings.devices.money_format = inner;

  } else {
    slideData.settings.devices.money_format = slideData.settings.devices.money_format.replace(/<.*?>/g, '');
  };

  /* SETTINGS CHECKOUT BUTTON */

  slideData.settings.settings_footer = {};
  slideData.settings.settings_footer.original_price_text_font_size = '14px'

  slideData.settings.settings_footer.total_save_text = 'Total Save'
  slideData.settings.settings_footer.total_save_text_font_size = '14px'

  slideData.settings.settings_footer.discount_text_font_size = '14px'
  /*   slideData.settings.settings_footer.free_shipping_text1 = 'Shipping'
    slideData.settings.settings_footer.free_shipping_text2 = 'Free'
    slideData.settings.settings_footer.free_shipping_text1_font_size = '12px' */
  pageflyANDgempages.init();
  HsApp3.init();
  HsApp2.init();
  HsApp1.init();
  HsApp4.init();
  HsApp5.init();
  HsApp6.init();
  customCssAndJs.init();
  HsApp1.setGeoCountryfunction();

  /* ************ */
  function detectAddUrl(url) {
    let match = false;
    // Expresión regular para detectar '/cart/add.js', '/cart/change.js' o '/cart/update.js' al final de la URL
    const regex = /\/cart\/(add)(\.js|\.json)?(\?.*)?$/i;

    // Comprobamos si la URL coincide con el patrón y no contiene el parámetro 'hsfastcart'
    if (regex.test(url) && !url.includes('hsfastcart')) {
      match = true;
    };
    return match;
  }
  function detectUrl(url) {
    let match = false;
    // Expresión regular para detectar '/cart/add.js', '/cart/change.js' o '/cart/update.js' al final de la URL
    const regex = /\/cart\/(clear|change|update)(\.js|\.json)?(\?.*)?$/i;

    // Comprobamos si la URL coincide con el patrón y no contiene el parámetro 'hsfastcart'
    if (regex.test(url) && !url.includes('hsfastcart')) {
      match = true;
    };
    return match;
  }
  function beforeRequest() {
    try {
      var slideOpen = !!document.querySelector('body') ? document.querySelector('body') : '';
      if (!!slideOpen) {
        if (!slideOpen.classList.contains('hs-open-cart')) {
          var result_loading = document.querySelector('.hs-result-loading.hs-body-gnral') || '';
          if (!!result_loading) {
            result_loading.classList.add('hs-show-loading');
          } else {
            if (typeof slideData.customize.customize_enabled_loading !== 'undefined') {
              if (slideData.customize.customize_enabled_loading == 2) {
                if (!!parseInt(slideData.settings.additional_settings.open_cart)) {
                  var bodyOpenCart = !!document.querySelector('body') ? document.querySelector('body') : '';
                  if (!!bodyOpenCart) {
                    if (!bodyOpenCart.classList.contains('hs-open-cart')) {
                      if (pageflyANDgempages.withOutOpenCart == 1) {
                        return false;
                      }
                      HsApp1.openCart();
                    }
                  }
                };
              };
            };
          };
        };
      };
    } catch (error) {
      console.log(error)
    }
  }
  function afterRequest(status = true) {
    try {
      if (!status) {
        var slideOpen = !!document.querySelector('body') ? document.querySelector('body') : '';
        if (!!slideOpen) {
          if (!slideOpen.classList.contains('hs-open-cart')) {
            var result_loading = document.querySelector('.hs-result-loading.hs-body-gnral') || '';
            if (!!result_loading) {
              result_loading.classList.remove('hs-show-loading');
            };
          };
        };
      };
    } catch (error) {
      console.log(error)
    }
  }
  (function () {
    var proxied = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      if (slideData.dashboard && parseInt(slideData.dashboard.dashboard_general_app) > 0) {
        var resultValidateDevice = HsApp1.validateDevice();
        if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
          if (arguments[0] === 'GET' && arguments[1].indexOf('/products') > -1) {
            setTimeout(function () {
              pageflyANDgempages.addToCart();
            }, 1500);
          };
        };
      };
      return proxied.apply(this, [].slice.call(arguments));
    };
  })();
  (function () {
    var proxied = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function () {
      var thisArguments = arguments;
      var pointer = this;
      var url = '';
      if (!!pointer._requestUrl) {
        url = pointer._requestUrl;
      };
      if (!!pointer._url) {
        url = pointer._url;
      };

      if (detectAddUrl(url)) {
        var resultValidateDevice = HsApp1.validateDevice();
        if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
          if (typeof beforeRequest === "function") {
            beforeRequest(pointer);
          };
        };
      };

      var intervalId = window.setInterval(function (data) {
        if (typeof data === 'undefined') {
          if (thisArguments.length > 0) {
            data = thisArguments[0];
          } else {
            data = thisArguments;
          };
        };
        if (pointer.readyState != 4) {
          return;
        }


        if (slideData.dashboard && parseInt(slideData.dashboard.dashboard_general_app) > 0) {
          if (url !== "") {
            if (pointer.status == 200) {
              var resultValidateDevice = HsApp1.validateDevice();
              /* if (url === "/cart/add" || url === "/cart/add.js" || url === window.location.origin + "/cart/add.js" || url.indexOf("/cart/add.json") > -1 || url.indexOf(window.location.origin + "/cart/add.json") > -1 ||
                url === "/cart/add.js?mr=1&mrs=1" || url === "/cart/add.js?mr=1" || url.indexOf(window.location.origin + "/cart/add.js?bundler-cart-call") > -1) { */
              if (detectAddUrl(url)) {
                if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
                  var id = '', quantity = 0, count = 0;
                  var a = decodeURI(data);
                  a = a.split('&');
                  var b = '';
                  a.forEach(function (val) {
                    count++
                    if (val.indexOf('id') > -1) {
                      id = val.replace('id=', '');
                    };
                    if (val.indexOf('quantity') > -1) {
                      quantity = val.replace('quantity=', '');
                    };
                    if (count == a.length) {
                      if (quantity == 0) {
                        quantity = 1;
                      }
                      try {
                        if (id !== '') {
                          if (typeof window.HS_SLIDE_CART_ADD_TO_CART !== 'undefined') {
                            b = JSON.parse(b.concat(`{"id":${id},"quantity":${quantity}}`));
                            window.HS_SLIDE_CART_ADD_TO_CART(b)
                          };
                        }
                      } catch (err) {
                        console.log(err)
                      };
                    };
                  });
                  var slideOpen = !!document.querySelector('body') ? document.querySelector('body') : '';
                  if (!!slideOpen) {
                    if (!slideOpen.classList.contains('hs-open-cart')) {
                      if (pageflyANDgempages.withOutOpenCart == 1) {
                        return false;
                      }
                      /* if (!!document.querySelector('.hs-result-loading')) {
                        document.querySelector('.hs-result-loading').classList.add('hs-show-loading');
                      }; */
                      Hs_CartDrawer.getSlideCart();
                    } else {
                      Hs_CartDrawer.updateSlideCart();
                    }
                  };
                };
              };

              /* if (url === "/cart/clear" || url === (window.location.origin + "/cart/clear") || url === (window.location.origin + "/cart/change") || url.indexOf('/cart/change.js') > -1 || url.indexOf(window.location.origin + "/cart/change.js") > -1 || url === window.location.origin + "/cart/update.js" || url === "/cart/update.js") { */
              if (detectUrl(url)) {
                Hs_CartDrawer.updateSlideCart();
              };

              if (detectUrl(url) || detectAddUrl(url)) {
                let hs_sticky_cart = document.querySelector('html.hs-open-drawer .hs-popup-cart-sp-load .hs-sticky-cart') || '';
                if (hs_sticky_cart) {
                  hs_sticky_cart.classList.add('hs-adding-prod');
                };
                HsApp3.getMyCart();
              };
              /*  */
              const contentType = pointer._method || '';
              if (contentType === 'GET') {
                if (pointer.response) {
                  try {
                    var parser = new DOMParser();
                    var stringParse = parser.parseFromString(pointer.response, 'text/html') || '';
                    if (stringParse) {
                      var section = '';
                      section = stringParse.querySelector('.productList .grid-products') || '';
                      if (section) {
                        if (url.indexOf(`collections`) > -1 && url.indexOf(`filter`) > -1) {
                          if (window.theme) {
                            if (window.theme.collectionView) {
                              setTimeout(function () {
                                Hs_CartDrawer.getQuickBuyButton(1);
                              }, 500);
                            };
                          };
                        };
                      };

                      if (url.indexOf('stratusoutdoors.com') > -1 && (url.indexOf('/collections/shop?page=') > -1 || url.indexOf('/collections/shop') > -1)) {
                        setTimeout(function () {
                          Hs_CartDrawer.getQuickBuyButton(1);
                        }, 500);
                      };
                    };
                  } catch (error) {
                    console.log(error)
                  }
                };
                if (url.indexOf('svc-3-usf.hotyon.com') > -1 && url.indexOf('search') > -1) {
                  if (data) {
                    if (data.apiKey) {
                      setTimeout(function () {
                        Hs_CartDrawer.getQuickBuyButton(1);
                        pageflyANDgempages.addToCart();
                      }, 1000);
                    };
                  };
                };
              };
            } else {
              var resultValidateDevice = HsApp1.validateDevice();
              /* if (url === "/cart/add" || url === "/cart/add.js" || url === window.location.origin + "/cart/add.js" || url.indexOf("/cart/add.json") > -1 || url.indexOf(window.location.origin + "/cart/add.json") > -1 ||
                url === "/cart/add.js?mr=1&mrs=1" || url === "/cart/add.js?mr=1" || url.indexOf(window.location.origin + "/cart/add.js?bundler-cart-call") > -1) { */
              if (detectAddUrl(url)) {
                if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
                  afterRequest(false)
                  try {
                    /* let jsonResponse = JSON.parse(pointer?.responseText);
                    if (jsonResponse.errors) {
                      jsonResponse = jsonResponse?.errors;
                    }; */
                    let jsonResponse = JSON.parse(pointer?.responseText);
                    if (jsonResponse.errors) {
                      jsonResponse = jsonResponse?.errors;
                      Hs_modal_notification(jsonResponse, jsonResponse, slideData)
                    };
                    if (jsonResponse?.description && jsonResponse?.message && jsonResponse?.status) {
                      Hs_modal_notification(jsonResponse?.message, jsonResponse?.description, slideData, jsonResponse?.status)
                    };

                  } catch (error) {
                    console.error(`Error: HTTP response was not 200. Status code: ${pointer.status}`);
                    console.error("Answer:", pointer.responseText);
                  }
                };
              };
            }
          };
        };
        clearInterval(intervalId);
      }, 1);

      return proxied.apply(this, [].slice.call(arguments));
    };
  })();
  (function () {
    const constantMock = window.fetch;
    window.fetch = function () {
      const args = arguments;
      return new Promise((resolve, reject) => {
        constantMock.apply(this, arguments)
          .then((response) => {
            var resultValidateDevice = HsApp1.validateDevice();
            if (response.status == 200) {
              if (slideData.dashboard && parseInt(slideData.dashboard.dashboard_general_app) > 0) {
                if (!!arguments) {
                  if (arguments.length > 0) {
                    if (typeof arguments[0].hostname === 'undefined') {
                      if (typeof arguments[0] === 'string') {
                        if (detectAddUrl(arguments[0])) {
                          let notSlideCart = true;
                          if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
                            if (typeof beforeRequest === "function") {
                              beforeRequest();
                            };

                            if (arguments[1].body instanceof FormData) {
                              const obj = Object.fromEntries(arguments[1].body);
                              if (obj.hs_EasyFlow) {
                                arguments[1].body.delete('hs_EasyFlow');
                                notSlideCart = false;
                              };
                            };

                            if (notSlideCart == true) {
                              var json = {}, data = {};
                              if (typeof arguments[1].body.get === "function") {
                                if (!!arguments[1].body.get('id') || arguments[1].body.get('id') !== 'null' || arguments[1].body.get('id') !== '') {
                                  data = JSON.parse(`{"id":${arguments[1].body.get('id')},"quantity":${arguments[1].body.get('quantity')}}`);
                                };
                              };

                              if (typeof data.id === 'undefined') {
                                if (arguments[1].body.indexOf('id') > -1 && arguments[1].body.indexOf('quantity') > -1) {
                                  try {
                                    json = JSON.parse(arguments[1].body);
                                    if (!!json.id && !!json.quantity) {
                                      data = JSON.parse(`{"id":${parseInt(json.id)},"quantity":${parseInt(json.quantity)}}`);
                                    };
                                  } catch (error) {
                                    var id = '', quantity = 1, count = 0;
                                    var a = decodeURI(data);
                                    a = a.split('&');
                                    var b = '';
                                    a.forEach(function (val) {
                                      count++
                                      if (val.indexOf('id') > -1) {
                                        id = val.replace('id=', '');
                                      };
                                      if (val.indexOf('quantity') > -1) {
                                        quantity = val.replace('quantity=', '');
                                      };
                                      if (count == a.length) {
                                        if (id !== '') {
                                          data = JSON.parse(b.concat(`{"id":${id},"quantity":${quantity}}`));
                                        };
                                      };
                                    });
                                  }
                                };
                              };

                              try {
                                if (typeof window.HS_SLIDE_CART_ADD_TO_CART !== 'undefined') {
                                  if (typeof data.id !== 'undefined') {
                                    window.HS_SLIDE_CART_ADD_TO_CART(data);
                                  };
                                };
                              } catch (err) {
                                console.log(err)
                              };
                            };

                            var slideOpen = !!document.querySelector('body') ? document.querySelector('body') : '';
                            if (!!slideOpen) {
                              if (!slideOpen.classList.contains('hs-open-cart')) {
                                if (!!document.querySelector('.hs-result-loading.hs-body-gnral')) {
                                  document.querySelector('.hs-result-loading.hs-body-gnral').classList.add('hs-show-loading');
                                };
                                Hs_CartDrawer.getSlideCart();
                              } else {
                                Hs_CartDrawer.updateSlideCart();
                              }
                            }

                          };
                        };
                        /* if (arguments[0] === "/cart/clear" || arguments[0] === (window.location.origin + "/cart/clear") || arguments[0] === (window.location.origin + "/cart/change") || arguments[0].indexOf('/cart/change.js') > -1 || arguments[0].indexOf(window.location.origin + "/cart/change.js") > -1 || arguments[0].indexOf('/cart/change') > -1 || arguments[0].indexOf(window.location.origin + "/cart/change") > -1 ||
                        arguments[0] === "/cart/update.js" || arguments[0] === window.location.origin + "/cart/update.js") { */
                        if (detectUrl(arguments[0])) {
                          Hs_CartDrawer.updateSlideCart();
                        };
                        if (detectUrl(arguments[0]) || detectAddUrl(arguments[0])) {
                          let hs_sticky_cart = document.querySelector('html.hs-open-drawer .hs-popup-cart-sp-load .hs-sticky-cart') || '';
                          if (hs_sticky_cart) {
                            hs_sticky_cart.classList.add('hs-adding-prod');
                          };
                          HsApp3.getMyCart();
                          //};
                        };
                      };


                      /* FILTER PRODUCT DETECT ADD TO CART => https://www.nisarabeauty.com/collections/for-her?filter.v.price.lte=849.00&filter.v.price.gte=800.00&filter.p.m.custom.fragrance=Citrus
                                          https://www.scandiscents.com/collections/christmas-sale?filter.v.price.gte=&filter.v.price.lte=&sort_by=title-ascending*/

                      if (typeof arguments[0] === 'string') {
                        if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
                          const contentType = response.headers.get("content-type") || '';
                          if (contentType.indexOf('text/html') > -1) {
                            const responseClone = response.clone();
                            if (responseClone) {
                              responseClone.text().then((text) => {
                                try {
                                  var reloadAddToCart = false;
                                  if (text) {
                                    if (text.indexOf('data-section-type="collection-grid"') > -1) {
                                      var parser = new DOMParser();
                                      var stringParse = parser.parseFromString(text, 'text/html') || '';
                                      if (stringParse) {
                                        var section = '', sectionId = '';
                                        section = stringParse.querySelector('[data-section-type="collection-grid"]') || '';
                                        if (section) {
                                          sectionId = section.dataset.sectionId || '';
                                          if (arguments[0].indexOf(`collections`) > -1 && arguments[0].indexOf(`section_id=${sectionId}`) > -1 && arguments[0].indexOf(`filter`) > -1) {
                                            reloadAddToCart = true;
                                          };
                                        };
                                      }
                                    };
                                    if (text.indexOf('shopify-section-template') > -1) {
                                      var parser = new DOMParser();
                                      var stringParse = parser.parseFromString(text, 'text/html') || '';
                                      if (stringParse) {
                                        var section = '', sectionId = '';
                                        section = stringParse.querySelector('.shopify-section') || '';
                                        if (section) {
                                          sectionId = section.id || '';
                                          sectionId = sectionId.replace('shopify-section-', '');
                                          if (sectionId) {
                                            if (arguments[0].indexOf(`collections`) > -1 && arguments[0].indexOf(`section_id=${sectionId}`) > -1 && arguments[0].indexOf(`filter`) > -1) {
                                              reloadAddToCart = true;
                                            };
                                          };
                                        };
                                      };
                                    };

                                    if (text.indexOf('data-section-type="collection-grid"') > -1) {
                                      var parser = new DOMParser();
                                      var stringParse = parser.parseFromString(text, 'text/html') || '';
                                      if (stringParse) {
                                        var section = '', sectionId = '';
                                        section = stringParse.querySelector('[data-section-type="collection-grid"]') || '';
                                        if (section) {
                                          sectionId = section.dataset.sectionId || '';
                                          if (arguments[0].indexOf(`collections`) > -1 && arguments[0].indexOf(`section_id=${sectionId}`) > -1 && arguments[0].indexOf(`filter`) > -1) {
                                            reloadAddToCart = true;
                                          };
                                        };
                                      }
                                    };


                                    if (reloadAddToCart) {
                                      setTimeout(function () {
                                        pageflyANDgempages.addToCart();
                                      }, 500);
                                    };


                                    if (text.indexOf('shopify-section--main-collection') > -1) {
                                      var parser = new DOMParser();
                                      var stringParse = parser.parseFromString(text, 'text/html') || '';
                                      if (stringParse) {
                                        var section = '', sectionId = '';
                                        section = stringParse.querySelector('section.shopify-section') || '';
                                        if (section) {
                                          sectionId = section.id || '';
                                          sectionId = sectionId.replace('shopify-section-', '');
                                          if (sectionId) {
                                            if (arguments[0].indexOf(`collections`) > -1 && arguments[0].indexOf(`section_id=${sectionId}`) > -1 && arguments[0].indexOf(`filter`) > -1) {
                                              if (reloadAddToCart) {
                                                setTimeout(function () {
                                                  HsApp1.reloadedAddToCart();
                                                  Hs_CartDrawer.getQuickBuyButton(1);
                                                }, 600);
                                              };
                                            };
                                          };
                                        };
                                      };
                                    };


                                    /* https://aldeadesign.co.uk/collections/sideboards-and-dressers */
                                    if (text.indexOf('data-section-type="collection"') > -1) {

                                      if (document.getElementById('filters')) {
                                        const formData = new FormData(document.getElementById('filters'));
                                        const searchParams = new URLSearchParams(formData);

                                        const paramString = searchParams.toString();

                                        var parser = new DOMParser();
                                        var stringParse = parser.parseFromString(text, 'text/html') || '';
                                        if (stringParse) {
                                          var section = '', sectionId = '';
                                          section = stringParse.querySelector('[data-section-type="collection"]') || '';
                                          if (section) {

                                            if (arguments[0].indexOf(`collections`) > -1 && arguments[0].indexOf(paramString) > -1) {
                                              Hs_CartDrawer.arrQuickBuyButton = [];
                                              if (!!slideData.quick_buy.enabled_quick_buy && Hs_CartDrawer.arrQuickBuyButton.length <= 0) {
                                                setTimeout(function () {
                                                  Hs_CartDrawer.getQuickBuyButton(1);
                                                }, 900);
                                              };
                                            };
                                          };
                                        }

                                      };
                                    };

                                    //https://nusielle.com/
                                    if (text) {
                                      if (text.indexOf('<cart-drawer-component') > -1) {
                                        var parser = new DOMParser();
                                        var stringParse = parser.parseFromString(text, 'text/html') || '';
                                        if (stringParse) {
                                          var section = '';
                                          section = stringParse.querySelector('cart-drawer-component button.button.header-actions__action') || '';
                                          if (section) {
                                            if (!section.classList.contains('hs-event-static')) {
                                              setTimeout(function () {
                                                HsApp1.elementsOpenSlideCart();
                                              }, 500);
                                            }
                                          };
                                        };
                                      };
                                    };

                                  };
                                } catch (error) {
                                  console.log(error)
                                }
                              });
                            };
                          };
                        }
                      };
                      /*  */
                    };
                  };
                };
                if (response.url.indexOf('__product-grid') > -1 && response.url.indexOf('sort_by') > -1) {
                  Hs_CartDrawer.arrQuickBuyButton = [];
                  if (!!slideData.quick_buy.enabled_quick_buy && Hs_CartDrawer.arrQuickBuyButton.length <= 0) {
                    setTimeout(function () {
                      Hs_CartDrawer.getQuickBuyButton(1);
                    }, 500);
                  };
                };

                var prod_recom = !!document.querySelector('product-recommendations') ? document.querySelector('product-recommendations') : '';
                if (!!prod_recom) {
                  var url_fetch = !!prod_recom.getAttribute('data-url') ? prod_recom.getAttribute('data-url') : '';
                  if (!!url_fetch) {
                    if (response.status == 200) {
                      if (response.url.indexOf(url_fetch) > -1) {
                        var limit_text = url_fetch.indexOf('limit=');
                        var text_new = url_fetch.substring(limit_text, url_fetch.length);
                        var limit = text_new.substring(text_new.indexOf('=') + 1, text_new.length);
                        if (text_new.indexOf('&') > -1) {
                          limit = text_new.substring(text_new.indexOf('=') + 1, text_new.indexOf('&'));
                        }
                        if (!!slideData.quick_buy.enabled_quick_buy && Hs_CartDrawer.arrQuickBuyButton.length <= 0) {
                          setTimeout(function () {
                            Hs_CartDrawer.getQuickBuyButton(1);
                          }, limit * 100);
                        };
                      }
                    };
                  };
                }
                prod_recom = !!document.querySelector(`[data-section-type="product-recommendations"]`) ? document.querySelector(`[data-section-type="product-recommendations"]`) : '';
                if (!!prod_recom) {
                  var url_fetch = !!prod_recom.getAttribute('data-url') ? prod_recom.getAttribute('data-url') : '';
                  if (!!url_fetch) {
                    if (response.status == 200) {
                      if (response.url.indexOf(url_fetch) > -1) {
                        setTimeout(function () {
                          pageflyANDgempages.addToCart();
                        }, 800);
                      }
                    }
                  }
                };
              };
            };
            if (response.status == 200 || response.status == 304) {
              if (typeof arguments[0] === 'string') {
                if (parseInt(resultValidateDevice) == 1 || parseInt(resultValidateDevice) == 3) {
                  const contentType = response.headers.get("content-type") || '';
                  if (contentType.indexOf('text/html') > -1) {
                    const responseClone = response.clone();
                    if (responseClone) {
                      responseClone.text().then((text) => {
                        try {
                          var reloadAddToCart = false;
                          var parser = new DOMParser();
                          var stringParse = parser.parseFromString(text, 'text/html') || '';
                          if (stringParse) {
                            if (stringParse.querySelector('product-recommendations')) {
                              if (arguments[0].indexOf(`/recommendations`) > -1 && arguments[0].indexOf(`section_id`) > -1 && arguments[0].indexOf(`product_id`) > -1) {
                                reloadAddToCart = true;
                                setTimeout(function () {
                                  Hs_CartDrawer.getQuickBuyButton(1);
                                }, 500);
                              };
                            };
                          };
                          if (reloadAddToCart) {
                            setTimeout(function () {
                              pageflyANDgempages.addToCart();
                            }, 500);
                          };
                        } catch (error) {
                          console.log(error)
                        }
                      });
                    };
                  };
                }
              };
            };
            if (!response.ok) {
              if (slideData.dashboard && parseInt(slideData.dashboard.dashboard_general_app) > 0) {
                if (!!arguments) {
                  if (arguments.length > 0) {
                    if (typeof arguments[0].hostname === 'undefined') {
                      if (typeof arguments[0] === 'string') {
                        /* if (arguments[0] === '/cart/add.js' || arguments[0] === '/cart/add' || arguments[0] === window.location.origin + "/cart/add.js" || arguments[0] === window.location.origin + "/cart/add" || arguments[0] === new_route_api || arguments[0].indexOf(new_route_api + '?kp-0') > -1 || arguments[0].indexOf(new_route_api + '?kp-1') > -1 || arguments[0].indexOf(new_route_api + '?kp-2') > -1 || arguments[0].indexOf(new_route_api + '?kp-3') > -1 || arguments[0].indexOf(new_route_api + '?kp-4') > -1 || arguments[0].indexOf(new_route_api + '?kaching_bundles=true') > -1) { */
                        if (detectAddUrl(arguments[0])) {
                          afterRequest(response.ok);
                          response.json()
                            .then((errorJson) => {
                              if (errorJson.errors) {
                                Hs_modal_notification(errorJson?.errors, errorJson?.errors, slideData)
                              };
                              if (errorJson?.description && errorJson?.message && errorJson?.status) {
                                Hs_modal_notification(errorJson?.message, errorJson?.description, slideData, errorJson?.status)
                              };
                            })
                            .catch((jsonError) => {
                              // Si no se puede convertir a JSON, manejarlo como un error simple
                              response.text()
                                .then((errorText) => {
                                  console.log("Response without JSON, text:", errorText);
                                })
                                .catch((textError) => {
                                  console.log("Error reading error text:", textError);
                                });
                            });
                        };
                      };
                    };
                  };
                };
              };
            };
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          })
      });
    }
  })();
};
/* ================ LOAD CLIENT JS AND MY APP AND JQUERY ================ */

const HS_SCRIPTS = {
  global: 'hs-config-global',
  store: 'hs-config-store'
};

Object.values(HS_SCRIPTS).forEach(id => {
  const script = document.getElementById(id);

  if (!script) return;

  // solo intervenir si fue mutado a "load"
  if (script.type === 'load') {

    // evita ejecutar dos veces
    if (script?.dataset?.hsExecuted === "1") return;

    const content = script.innerText?.trim();
    if (!content) return;

    try {
      new Function(content)();

      // marca como ejecutado
      script.dataset.hsExecuted = "1";

    } catch (e) {
      console.warn("HS load script failed:", id, e);
    }
  }
});



if (window.HSSLIDECART.setSettings !== undefined && window.HSSLIDECART.setSettings !== null && typeof window.HSSLIDECART.setSettings === 'object' && !Array.isArray(window.HSSLIDECART.setSettings) && Object.keys(window.HSSLIDECART.setSettings).length > 0) {
  _HsMyAppJavaScript();
  if (typeof slideData !== 'undefined') {
    //observerElements();
  }
} else if (Array.isArray(window.HSSLIDECART.setSettings) && window.HSSLIDECART.setSettings.length == 0) {
  console.log(
    `%c${'Slide Cart Upsell Not Charge'}`, // everything after the %c is styled
    `background: #4871ff; color: #fff; font-size: 13px; font-weight:bold; padding: 5px 10px; border-radius: 3px`
  );
} else {
  _HsLoadScript(`${window.HSHOST}/clients/` + window.HSSLIDECART.auth + '.js?v=' + (new Date).getTime(), function (e) {
    _HsMyAppJavaScript();
    if (typeof slideData !== 'undefined') {
      //observerElements();
    }
  });
}

// function resolveAppState() {
//   const global = window.HSSLIDECART;

//   if (typeof global === 'undefined') {
//     return 'waiting';
//   }

//   if (Array.isArray(global) && global.length === 0) {
//     return 'not_charge';
//   }

//   const settings = global?.setSettings;

//   if (Array.isArray(settings) && settings.length === 0) {
//     return 'not_charge';
//   }

//   if (
//     typeof settings === 'object' &&
//     settings &&
//     !Array.isArray(settings) &&
//     Object.keys(settings).length > 0
//   ) {
//     return 'ready';
//   }

//   return 'waiting';
// }

// function waitForAppReady(timeout = 4000) {
//   const start = Date.now();

//   return new Promise((resolve) => {

//     function check() {
//       const state = resolveAppState();

//       if (state !== 'waiting') {
//         resolve(state);
//         return;
//       }

//       if (Date.now() - start >= timeout) {
//         resolve('timeout');
//         return;
//       }

//       setTimeout(check, 50);
//     }

//     check();
//   });
// }

// (async function boot() {

//   const state = await waitForAppReady();

//   if (state === 'not_charge') {
//     console.log(
//       `%cSlide Cart Upsell Not Charge`,
//       `background: #4871ff; color: #fff; font-size: 13px; font-weight:bold; padding: 5px 10px; border-radius: 3px`
//     );
//     return;
//   }

//   if (state === 'ready') {
//     _HsMyAppJavaScript();
//     return;
//   }

//   // timeout o estado raro
//   const auth = window.HSSLIDECART?.auth;

//   if (auth) {
//     _HsLoadScript(
//       `${window.HSHOST}/clients/${auth}.js?v=${Date.now()}`,
//       function () {
//         _HsMyAppJavaScript();
//       }
//     );
//   }
// })();

function observerElements() {
  if (
    typeof slideData === 'undefined' ||
    typeof slideData.dashboard?.dashboard_general_app === 'undefined' ||
    parseInt(slideData.dashboard.dashboard_general_app) < 1
  ) {
    return false;
  };
  const observer = new MutationObserver((mutationList) => {
    mutationList.forEach((mutation) => {
      var elementAdd = Hs_CartDrawer.elementAdd;
      var a = mutation.target.querySelectorAll(elementAdd).length > 0 ? mutation.target.querySelectorAll(elementAdd) : [];
      if (a.length > 0) {
        pageflyANDgempages.addToCart();
      }
    })
  });
  const selectors = '#hs-additional-buttons,section.Section .ProductRecommendations,.CollectionInner__Products,.grid__item--content,.grid-overflow-wrapper .grid--uniform,.shopify-section.index-section,#ProductModals,#QuickAddModal,[action$="/cart/add"], [action$="/cart/add.js"], quick-add-modal.quick-add-modal, .modal[data-modal-container] .modal-content, .halo-block-content,.pswp.pswp--custom-loader, quick-buy-drawer[open-from="bottom"], main .shopify-section #ProductGridContainer, quick-buy-modal.quick-buy-modal.modal[handle]:not([handle=""]),.modal__container[data-wau-modal="quickview"]#modal-quickview-cart, filter-container product-block .quickbuy-container .inner, product-side-drawer#Product-QuickView-Drawer #Product-QuickView-Details, .quick__view#quickViewWrapper[role="dialog"],quick-shop-modal.modal.modal-quick-shop,.card-wrapper quick-view-drawer, #colorbox[role="dialog"] #cboxContent';

  const grid_items = document.querySelectorAll(selectors.trim()) || [];

  if (grid_items.length > 0) {
    const observerOptions = {
      attributes: false,
      childList: true,
      subtree: true,
      characterData: false,
      attributeOldValue: false,
      characterDataOldValue: false
    };
    grid_items.forEach(function (grid_item) {
      observer.observe(grid_item, observerOptions);
    })
  };

  const observerIconHeader = new MutationObserver((mutationList) => {
    mutationList.forEach((mutation) => {
      var new_element = !!mutation.target.querySelector('[data-picky-cart-button-area]') ? mutation.target.querySelector('[data-picky-cart-button-area]') : '';
      /* new_element.outerHTML = new_element.outerHTML; //LOOP INFINITE */
      new_element = !!mutation.target.querySelector('[data-picky-cart-button-area]') ? mutation.target.querySelector('[data-picky-cart-button-area]') : '';
      if (!!new_element) {
        if (!!new_element.attributes) {
          if (!!new_element.attributes.onclick) {
            new_element.attributes.onclick.nodeValue = '';
          };
        };
        if (!new_element.classList.contains('hs-event-static')) {
          new_element.classList.add('hs-event-static');
          new_element.addEventListener("click", function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            var x = 0;
            if (!!e) {
              if (typeof e.path !== 'undefined') {
                if (e.path.length > 0) {
                  e.path.forEach(function (val) {
                    if (typeof val.classList !== 'undefined') {
                      if (typeof val.localname !== 'undefined') {
                        if (!!val.localname) {
                          var link_type = !!val.getAttribute('data-zp-link-type') ? val.getAttribute('data-zp-link-type') : '';
                          if (!!link_type) {
                            if (link_type === 'external' || link_type === 'checkout') {
                              x = 1;
                            };
                          };
                        };
                      };
                    };
                  })
                }
              }
            };
            if (x == 0) {
              HsApp1.openCartDrawerClick(new_element);
            }
          });
        }
      };
    })
  });
  var shopifyRoot = '/';
  if (!!window.Shopify) {
    if (!!window.Shopify.routes) {
      if (!!window.Shopify.routes) {
        if (!!window.Shopify.routes.root) {
          if (window.Shopify.routes.root !== '/') {
            shopifyRoot = window.Shopify.routes.root;
          }
        }
      }
    }
  }
  const itemsIcons = document.querySelectorAll(`a[href="${shopifyRoot}cart"]`).length > 0 ? document.querySelectorAll(`a[href="${shopifyRoot}cart"]`) : [];
  if (itemsIcons.length > 0) {
    const observerOptions = {
      attributes: false,
      childList: true,
      subtree: true,
      characterData: false,
      attributeOldValue: false,
      characterDataOldValue: false
    };
    itemsIcons.forEach(function (items) {
      observerIconHeader.observe(items, observerOptions);
    })
  };

  const observerHeaderCount = new MutationObserver((mutationList) => {
    mutationList.forEach((mutation) => {
      try {
        var openSlideCart = mutation.target.querySelectorAll(HsApp1.openSlideCart) || [];
        if (openSlideCart.length > 0) {
          HsApp1.elementsOpenSlideCart();
        };
      } catch (error) {
        console.log(error)
      }
    })
  });


  const headerCount = document.querySelectorAll(`header .tt-header-row .tt-stuck-parent-cart.tt-parent-box, modal-dialog.quick-add-modal,.header-container[data-section-type="header"] .header-content`).length > 0 ? document.querySelectorAll(`header .tt-header-row .tt-stuck-parent-cart.tt-parent-box,modal-dialog.quick-add-modal,.header-container[data-section-type="header"] .header-content`) : [];
  if (headerCount.length > 0) {
    const observerOptions = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: false,
      attributeOldValue: false,
      characterDataOldValue: false
    };
    headerCount.forEach(function (items) {
      observerHeaderCount.observe(items, observerOptions);
    })
  };

};

var hs_isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
function Hswork() {/*  */
  if (typeof window.SHGJQ !== 'undefined') {
    window.SHGJQ(document).ajaxSuccess(function (a, b, c) {
      if (c.url.indexOf('/cart/add.js') > -1) {
        if (b.status == 200) {
          Hs_CartDrawer.getSlideCart();
        }
      }
    });
  };
}

if (document.readyState == 'loading') {
  if (hs_isSafari) {
    function HsAjx(f) { /in/.test(document.readyState) ? setTimeout('HsAjx(' + f + ')', 9) : f() }
    HsAjx(function () {
      Hswork();
      observerElements();
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      Hswork();
      observerElements();
    });
  }
} else {
  function HsAjx(f) { /in/.test(document.readyState) ? setTimeout('HsAjx(' + f + ')', 9) : f() }
  HsAjx(function () {
    Hswork();
    observerElements();
  });
}